module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/lib.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=00356e69!./src/components/switch/switch.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=00356e69!./src/components/switch/switch.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0133e889!./src/components/responsive-table/responsive-table.scss":
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0133e889!./src/components/responsive-table/responsive-table.scss ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=01901aee!./src/components/empty-area/empty-area.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=01901aee!./src/components/empty-area/empty-area.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0381e6e3!./src/components/responsive-table/table-group/table-group.scss":
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0381e6e3!./src/components/responsive-table/table-group/table-group.scss ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c2f61!./src/components/expandable-layout/expandable-layout.scss":
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c2f61!./src/components/expandable-layout/expandable-layout.scss ***!
  \************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c5519!./src/components/message/message.scss":
/*!****************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c5519!./src/components/message/message.scss ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=058310c7!./src/components/overlay/overlay.scss":
/*!****************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=058310c7!./src/components/overlay/overlay.scss ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0733b00c!./src/components/transitions/slide-transition/slide-transition.scss":
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0733b00c!./src/components/transitions/slide-transition/slide-transition.scss ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=087b1865!./src/components/option/option-title/option-title.scss":
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=087b1865!./src/components/option/option-title/option-title.scss ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=08b4e269!./src/components/dropdown/dropdown-item/dropdown-item.scss":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=08b4e269!./src/components/dropdown/dropdown-item/dropdown-item.scss ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0bd3a7ee!./src/components/icon/icon.scss":
/*!**********************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0bd3a7ee!./src/components/icon/icon.scss ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0d06b22b!./src/components/rich-text/rich-text.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0d06b22b!./src/components/rich-text/rich-text.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=10a01209!./src/components/decimalfield/decimalfield.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=10a01209!./src/components/decimalfield/decimalfield.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=124023ee!./src/components/avatar/avatar.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=124023ee!./src/components/avatar/avatar.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=163b32ee!./src/components/message-page/message-page.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=163b32ee!./src/components/message-page/message-page.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=19060d2e!./src/components/radio-style/radio-style.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=19060d2e!./src/components/radio-style/radio-style.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=1f986c2e!./src/components/datepicker/datepicker.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=1f986c2e!./src/components/datepicker/datepicker.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=24cb94e9!./src/components/auto-horizontal-scroll/auto-horizontal-scroll.scss":
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=24cb94e9!./src/components/auto-horizontal-scroll/auto-horizontal-scroll.scss ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=250a5c50!./src/components/carousel/carousel-item/carousel-item.scss":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=250a5c50!./src/components/carousel/carousel-item/carousel-item.scss ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=265e9e39!./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.scss":
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=265e9e39!./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.scss ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=28c4efa6!./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.scss":
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=28c4efa6!./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.scss ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2a89eca9!./src/components/moneyfield/moneyfield.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2a89eca9!./src/components/moneyfield/moneyfield.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2bf5f173!./src/components/accordion-group/accordion-group.scss":
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2bf5f173!./src/components/accordion-group/accordion-group.scss ***!
  \********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2cc87029!./src/components/carousel/carousel.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2cc87029!./src/components/carousel/carousel.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2ff620ee!./src/components/scroll-top/scroll-top.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2ff620ee!./src/components/scroll-top/scroll-top.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=357ca42e!./src/components/navbar/navbar.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=357ca42e!./src/components/navbar/navbar.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=367dd5c9!./src/components/limit-text/limit-text.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=367dd5c9!./src/components/limit-text/limit-text.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=37de12a9!./src/components/multi-select/multi-select.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=37de12a9!./src/components/multi-select/multi-select.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=38d3076e!./src/components/validation-message/validation-message.scss":
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=38d3076e!./src/components/validation-message/validation-message.scss ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3a102eb1!./src/components/radio/radio.scss":
/*!************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3a102eb1!./src/components/radio/radio.scss ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3af5f797!./src/components/accordion/accordion.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3af5f797!./src/components/accordion/accordion.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3b9a4e69!./src/components/calendar/calendar.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3b9a4e69!./src/components/calendar/calendar.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3f3dc9e9!./src/components/steppers/steppers.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3f3dc9e9!./src/components/steppers/steppers.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=448dcde9!./src/components/toggle-buttons/toggle-buttons.scss":
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=448dcde9!./src/components/toggle-buttons/toggle-buttons.scss ***!
  \******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=47b4f576!./src/components/option/option-separator/option-separator.scss":
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=47b4f576!./src/components/option/option-separator/option-separator.scss ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4823b029!./src/components/button/button.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4823b029!./src/components/button/button.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4b19ed3a!./src/components/transitions/opacity-transition/opacity-transition.scss":
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4b19ed3a!./src/components/transitions/opacity-transition/opacity-transition.scss ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4bf3aaee!./src/components/inplace-edit/inplace-edit.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4bf3aaee!./src/components/inplace-edit/inplace-edit.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4ec0ce10!./src/components/tree/tree-node/tree-node.scss":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4ec0ce10!./src/components/tree/tree-node/tree-node.scss ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5116ddaf!./src/components/sidebar/sidebar.scss":
/*!****************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5116ddaf!./src/components/sidebar/sidebar.scss ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=519225ae!./src/components/table-header/table-header.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=519225ae!./src/components/table-header/table-header.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5814d975!./src/components/spinner/spinner.scss":
/*!****************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5814d975!./src/components/spinner/spinner.scss ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=58475183!./src/components/file-upload/file-upload.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=58475183!./src/components/file-upload/file-upload.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=59e37688!./src/components/navbar/navbar-item/navbar-item.scss":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=59e37688!./src/components/navbar/navbar-item/navbar-item.scss ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e62b15b!./src/components/icon-button/icon-button.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e62b15b!./src/components/icon-button/icon-button.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e83b90b!./src/components/table/table.scss":
/*!************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e83b90b!./src/components/table/table.scss ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5ff5c2e9!./src/components/textarea/textarea.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5ff5c2e9!./src/components/textarea/textarea.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=61559ce9!./src/components/dialog/dialog.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=61559ce9!./src/components/dialog/dialog.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=62718769!./src/components/link/link.scss":
/*!**********************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=62718769!./src/components/link/link.scss ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=67884c58!./src/components/chip/chip-delete/chip-delete.scss":
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=67884c58!./src/components/chip/chip-delete/chip-delete.scss ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=69da5218!./src/components/select/select-item/select-item.scss":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=69da5218!./src/components/select/select-item/select-item.scss ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6a2c3951!./src/components/character-count/character-count.scss":
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6a2c3951!./src/components/character-count/character-count.scss ***!
  \********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6b5f25ee!./src/components/dropdown/dropdown.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6b5f25ee!./src/components/dropdown/dropdown.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6d5502cd!./src/components/textfield/textfield.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6d5502cd!./src/components/textfield/textfield.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6dce6849!./src/components/periodpicker/periodpicker.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6dce6849!./src/components/periodpicker/periodpicker.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6f985e5d!./src/components/show-more/show-more.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6f985e5d!./src/components/show-more/show-more.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=710d8e4d!./src/components/radio-group/radio-group.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=710d8e4d!./src/components/radio-group/radio-group.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=71302225!./src/components/responsive-table/table-group-header/table-group-header.scss":
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=71302225!./src/components/responsive-table/table-group-header/table-group-header.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=72503f49!./src/components/timepicker/timepicker.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=72503f49!./src/components/timepicker/timepicker.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7311a776!./src/components/responsive-table/table-head/table-head.scss":
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7311a776!./src/components/responsive-table/table-head/table-head.scss ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=74129ec2!./src/components/panel/panel.scss":
/*!************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=74129ec2!./src/components/panel/panel.scss ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7418f0e9!./src/components/tree/tree.scss":
/*!**********************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7418f0e9!./src/components/tree/tree.scss ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=78dffdae!./src/components/form/form.scss":
/*!**********************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=78dffdae!./src/components/form/form.scss ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7b2de66e!./src/components/checkbox/checkbox.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7b2de66e!./src/components/checkbox/checkbox.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=827d400c!./src/components/steppers/steppers-item/steppers-item.scss":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=827d400c!./src/components/steppers/steppers-item/steppers-item.scss ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=893ed962!./src/components/popup/popup.scss":
/*!************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=893ed962!./src/components/popup/popup.scss ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8a22ccee!./src/components/maskedfield/maskedfield.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8a22ccee!./src/components/maskedfield/maskedfield.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8ba3d5e6!./src/components/option/option-item/option-item.scss":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8ba3d5e6!./src/components/option/option-item/option-item.scss ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=9ecc5126!./src/components/responsive-table/table-empty-row/table-empty-row.scss":
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=9ecc5126!./src/components/responsive-table/table-empty-row/table-empty-row.scss ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=a89018ae!./src/components/autocomplete/autocomplete.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=a89018ae!./src/components/autocomplete/autocomplete.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b18183ae!./src/components/organize-table-columns-modal/organize-table-columns-modal.scss":
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b18183ae!./src/components/organize-table-columns-modal/organize-table-columns-modal.scss ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b759f322!./src/components/input-group/input-group.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b759f322!./src/components/input-group/input-group.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bc006eae!./src/components/pagination/pagination.scss":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bc006eae!./src/components/pagination/pagination.scss ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bcbac466!./src/components/file-select/file-select.scss":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bcbac466!./src/components/file-select/file-select.scss ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c1365b4e!./src/components/toast/toast.scss":
/*!************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c1365b4e!./src/components/toast/toast.scss ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c9caf92e!./src/components/plus/plus.scss":
/*!**********************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c9caf92e!./src/components/plus/plus.scss ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d7835cec!./src/components/tree/tree-icon/tree-icon.scss":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d7835cec!./src/components/tree/tree-icon/tree-icon.scss ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d802e53a!./src/components/list-item/list-item.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d802e53a!./src/components/list-item/list-item.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e450952e!./src/components/popper/popper.scss":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e450952e!./src/components/popper/popper.scss ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e93c04ee!./src/components/progress/progress.scss":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e93c04ee!./src/components/progress/progress.scss ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=eebd53ce!./src/components/typeahead/typeahead.scss":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=eebd53ce!./src/components/typeahead/typeahead.scss ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f68819ae!./src/components/integerfield/integerfield.scss":
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f68819ae!./src/components/integerfield/integerfield.scss ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f77ae324!./src/components/chip/chip-add/chip-add.scss":
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** /var/lib/jenkins-slave/workspace/campus/modul - releases/modul-publish-release/node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f77ae324!./src/components/chip/chip-add/chip-add.scss ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/assets/icons/svg/profile.svg":
/*!******************************************!*\
  !*** ./src/assets/icons/svg/profile.svg ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__profile\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1 -1 26 26\"><g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M23.5,12c0,3.4-1.4,6.3-3.7,8.4 c-2,1.9-4.8,3.1-7.8,3.1s-5.7-1.1-7.9-3.1c-2.2-2-3.7-5.1-3.7-8.4c0-6.3,5.1-11.6,11.6-11.6C18.3,0.6,23.5,5.7,23.5,12z\"></path><path d=\"M19.8,20.4c-2,1.9-4.8,3.1-7.8,3.1 s-5.7-1.1-7.9-3.1c0.5-1.2,1.4-1.5,1.4-1.5L9.8,17v-2.7c-1-0.8-1.7-2.2-1.7-3.9l0,0c-0.3,0-0.5-0.2-0.5-0.5V8.6 c0-0.3,0.2-0.5,0.5-0.5l0,0l0,0C7.8,7.6,7.7,7.2,7.7,6.7c0-1.7,1.5-3.1,3.5-3.1c0.8,0,1.5,0.2,2,0.6c0.1,0,0.3-0.1,0.4-0.1 C15,4.1,16,5.5,16,7.2c0,0.3,0,0.5-0.1,0.8v0.1l0,0c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5l0,0c0,1.6-0.7,3.1-1.7,3.9 v2.7l4.2,1.8C18.4,18.9,19.3,19.2,19.8,20.4z\"></path></g></svg>"

/***/ }),

/***/ "./src/components/accordion-group/accordion-group.html?style=./accordion-group.scss":
/*!******************************************************************************************!*\
  !*** ./src/components/accordion-group/accordion-group.html?style=./accordion-group.scss ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2bf5f173!./accordion-group.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2bf5f173!./src/components/accordion-group/accordion-group.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "m-accordion-group" }, [
    _vm.hasTitleSlot() || !_vm.concurrent
      ? _c(
          "header",
          {
            staticClass: "m-accordion-group__header",
            class: {
              "m--no-title": !_vm.hasTitleSlot(),
              "m--has-secondary-content": _vm.hasSecondaryContentSlot(),
              "m--is-toggle-link-left": _vm.toggleLinkLeft
            }
          },
          [
            _vm.hasTitleSlot()
              ? _c(
                  "div",
                  { staticClass: "m-accordion-group__header-title" },
                  [_vm._t("title")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-accordion-group__secondary-content" },
              [
                _vm._t("secondary-content"),
                _vm._v(" "),
                !_vm.concurrent && !_vm.disabled
                  ? _c(
                      "div",
                      { staticClass: "m-accordion-group__toggle-link" },
                      [
                        !_vm.isAllOpen
                          ? _c(
                              "m-link",
                              {
                                ref: "openAllButton",
                                attrs: { mode: _vm.linkModeButton },
                                on: {
                                  click: function($event) {
                                    return _vm.openAllAccordions()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$i18n.translate(
                                        "m-accordion-group:open-all"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isAllOpen && !_vm.isAllClosed
                          ? [_vm._v("  |  ")]
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isAllClosed
                          ? _c(
                              "m-link",
                              {
                                ref: "closeAllButton",
                                attrs: { mode: _vm.linkModeButton },
                                on: { click: _vm.closeAllAccordions }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$i18n.translate(
                                        "m-accordion-group:close-all"
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-accordion-group__body" },
      [_vm._t("default", null, { groupRef: _vm.$vnode.componentInstance })],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-2bf5f173'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/accordion-group/accordion-group.ts":
/*!***********************************************************!*\
  !*** ./src/components/accordion-group/accordion-group.ts ***!
  \***********************************************************/
/*! exports provided: MAccordionGroup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordionGroup", function() { return MAccordionGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _accordion_accordion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../accordion/accordion */ "./src/components/accordion/accordion.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _accordion_group_html_style_accordion_group_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./accordion-group.html?style=./accordion-group.scss */ "./src/components/accordion-group/accordion-group.html?style=./accordion-group.scss");
/* harmony import */ var _accordion_group_html_style_accordion_group_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_accordion_group_html_style_accordion_group_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MAccordionGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAccordionGroup, _super);
    function MAccordionGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isAllOpen = false;
        _this.isAllClosed = false;
        _this.linkModeButton = _link_link__WEBPACK_IMPORTED_MODULE_8__["MLinkMode"].Button;
        _this.accordions = {};
        return _this;
    }
    MAccordionGroup.prototype.emitUpdateOpenedIds = function (openedIds) { };
    MAccordionGroup.prototype.onOpenedIdsChange = function (openedIds) {
        var _loop_1 = function (id) {
            this_1.accordions[id].propOpen =
                openedIds.find(function (openedId) { return openedId === id; }) !== undefined;
        };
        var this_1 = this;
        for (var id in this.accordions) {
            _loop_1(id);
        }
    };
    Object.defineProperty(MAccordionGroup.prototype, "propSkin", {
        get: function () {
            return this.skin || _accordion_accordion__WEBPACK_IMPORTED_MODULE_5__["MAccordionSkin"].Default;
        },
        enumerable: true,
        configurable: true
    });
    MAccordionGroup.prototype.addAccordion = function (accordion) {
        accordion.$on('update:open', this.onAccordionOpenChange);
        this.$set(this.accordions, accordion.propId, accordion);
        if (this.openAll || (this.openedIds && this.openedIds.find(function (v) { return v === accordion.propId; }))) {
            accordion.propOpen = true;
        }
    };
    MAccordionGroup.prototype.removeAccordion = function (id) {
        this.accordions[id].$off('update:open', this.onAccordionOpenChange);
        this.$delete(this.accordions, id);
    };
    MAccordionGroup.prototype.closeAllAccordions = function () {
        for (var id in this.accordions) {
            if (!this.accordions[id].propDisabled) {
                this.accordions[id].propOpen = false;
            }
        }
    };
    MAccordionGroup.prototype.hasTitleSlot = function () {
        return !!this.$slots['title'] || !!this.$scopedSlots['title'];
    };
    MAccordionGroup.prototype.hasSecondaryContentSlot = function () {
        return Boolean(this.$slots['secondary-content']) || Boolean(this.$scopedSlots['secondary-content']);
    };
    MAccordionGroup.prototype.openAllAccordions = function () {
        for (var id in this.accordions) {
            if (!this.accordions[id].propDisabled) {
                this.accordions[id].propOpen = true;
            }
        }
    };
    MAccordionGroup.prototype.onAccordionOpenChange = function () {
        var _this = this;
        this.updateToggleLinks();
        var openedIds = Object.keys(this.accordions).filter(function (id) { return _this.accordions[id].propOpen; });
        this.emitUpdateOpenedIds(openedIds);
    };
    MAccordionGroup.prototype.updateToggleLinks = function () {
        this.updateIsAllOpen();
        this.updateIsAllClosed();
    };
    MAccordionGroup.prototype.mounted = function () {
        this.updateToggleLinks();
    };
    MAccordionGroup.prototype.updated = function () {
        this.updateToggleLinks();
    };
    MAccordionGroup.prototype.updateIsAllOpen = function () {
        // A computed wouldn't work here since we want to recompute the value each time the DOM changes (when a child is removed, added, updated, etc)
        var allOpened = true;
        for (var id in this.accordions) {
            allOpened = this.accordions[id].propOpen || !this.accordionHasContent(id);
            if (!allOpened && !this.accordions[id].propDisabled) {
                break;
            }
        }
        this.isAllOpen = allOpened;
    };
    MAccordionGroup.prototype.updateIsAllClosed = function () {
        // A computed wouldn't work here since we want to recompute the value each time the DOM changes (when a child is removed, added, updated, etc)
        var allClosed = true;
        for (var id in this.accordions) {
            allClosed = !this.accordions[id].propOpen || !this.accordionHasContent(id);
            if (!allClosed && !this.accordions[id].propDisabled) {
                break;
            }
        }
        this.isAllClosed = allClosed;
    };
    MAccordionGroup.prototype.accordionHasContent = function (id) {
        return !!this.accordions[id].$slots.default ||
            (!!this.accordions[id].$scopedSlots.default && !!this.accordions[id].$scopedSlots.default(undefined));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: _accordion_accordion__WEBPACK_IMPORTED_MODULE_5__["MAccordionSkin"].Default,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__["Enums"].toValueArray(_accordion_accordion__WEBPACK_IMPORTED_MODULE_5__["MAccordionSkin"]).includes(value); }
        })
    ], MAccordionGroup.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: false
        })
    ], MAccordionGroup.prototype, "concurrent", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: false
        })
    ], MAccordionGroup.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MAccordionGroup.prototype, "openedIds", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: false
        })
    ], MAccordionGroup.prototype, "toggleLinkLeft", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: false
        })
    ], MAccordionGroup.prototype, "openAll", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('update:openedIds')
    ], MAccordionGroup.prototype, "emitUpdateOpenedIds", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('openedIds')
    ], MAccordionGroup.prototype, "onOpenedIdsChange", null);
    MAccordionGroup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _accordion_group_html_style_accordion_group_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_8__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["MI18n"],
                _a)
        })
    ], MAccordionGroup);
    return MAccordionGroup;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var AccordionGroupPlugin = {
    install: function (v) {
        v.use(_accordion_accordion__WEBPACK_IMPORTED_MODULE_5__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["ACCORDION_GROUP_NAME"], MAccordionGroup);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AccordionGroupPlugin);


/***/ }),

/***/ "./src/components/accordion/accordion.html?style=./accordion.scss":
/*!************************************************************************!*\
  !*** ./src/components/accordion/accordion.html?style=./accordion.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3af5f797!./accordion.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3af5f797!./src/components/accordion/accordion.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-accordion",
      class: [
        "m--is-" + _vm.propSkin,
        {
          "m--is-closed": !_vm.propOpen,
          "m--is-open": _vm.propOpen,
          "m--is-disabled": _vm.propDisabled,
          "m--has-icon-left": _vm.isIconPositionLeft,
          "m--has-icon-large": _vm.isIconSizeLarge,
          "m--is-empty-content": !_vm.hasContent()
        }
      ]
    },
    [
      _c(
        "div",
        {
          ref: "accordionHeader",
          staticClass: "m-accordion__header",
          class: {
            "m--has-padding": _vm.paddingHeader && _vm.padding
          },
          attrs: {
            id: _vm.propId,
            "aria-expanded": _vm.propOpen,
            "aria-controls": _vm.idBodyWrap,
            tabindex: _vm.headerTabindex,
            "aria-label": _vm.headerAriaLabel,
            "aria-disabled": _vm.propDisabled,
            role: "button"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.toggleAccordion($event)
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.toggleAccordion($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "m-accordion__header-content" },
            [_vm._t("header")],
            2
          ),
          _vm._v(" "),
          _vm.hasContent()
            ? _c("m-plus", {
                staticClass: "m-accordion__header-icon",
                class: {
                  "m--is-left": _vm.isIconPositionLeft
                },
                attrs: {
                  border: _vm.hasIconBorder,
                  large: _vm.isIconSizeLarge,
                  open: _vm.propOpen,
                  skin: _vm.plusSkin,
                  "aria-hidden": "true"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasContent()
        ? _c(
            "m-accordion-transition",
            { attrs: { "height-delta": _vm.deltaHeight } },
            [
              !_vm.keepContentAlive
                ? [
                    _vm.propOpen
                      ? _c(
                          "div",
                          {
                            staticClass: "m-accordion__body-wrap",
                            attrs: {
                              id: _vm.idBodyWrap,
                              "aria-labelledby": _vm.propId
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "m-accordion__body",
                                class: _vm.classBody
                              },
                              [_vm._t("default")],
                              2
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                : [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propOpen,
                            expression: "propOpen"
                          }
                        ],
                        staticClass: "m-accordion__body-wrap",
                        attrs: {
                          id: _vm.idBodyWrap,
                          "aria-labelledby": _vm.propId
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-accordion__body",
                            class: _vm.classBody
                          },
                          [_vm._t("default")],
                          2
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-3af5f797'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/accordion/accordion.ts":
/*!***********************************************!*\
  !*** ./src/components/accordion/accordion.ts ***!
  \***********************************************/
/*! exports provided: MAccordionSkin, MAccordionIconPosition, MAccordionIconSize, ACCORDION_CLOSEST_ELEMENTS, MAccordion, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordionSkin", function() { return MAccordionSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordionIconPosition", function() { return MAccordionIconPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordionIconSize", function() { return MAccordionIconSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCORDION_CLOSEST_ELEMENTS", function() { return ACCORDION_CLOSEST_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordion", function() { return MAccordion; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _plus_plus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../plus/plus */ "./src/components/plus/plus.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _accordion_html_style_accordion_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./accordion.html?style=./accordion.scss */ "./src/components/accordion/accordion.html?style=./accordion.scss");
/* harmony import */ var _accordion_html_style_accordion_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_accordion_html_style_accordion_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var MAccordionSkin;
(function (MAccordionSkin) {
    MAccordionSkin["Default"] = "default";
    MAccordionSkin["Dark"] = "dark";
    MAccordionSkin["DarkB"] = "dark-b";
    MAccordionSkin["Light"] = "light";
    MAccordionSkin["Plain"] = "plain";
})(MAccordionSkin || (MAccordionSkin = {}));
var MAccordionIconPosition;
(function (MAccordionIconPosition) {
    MAccordionIconPosition["Left"] = "left";
    MAccordionIconPosition["Right"] = "right";
})(MAccordionIconPosition || (MAccordionIconPosition = {}));
var MAccordionIconSize;
(function (MAccordionIconSize) {
    MAccordionIconSize["Small"] = "small";
    MAccordionIconSize["Large"] = "large";
})(MAccordionIconSize || (MAccordionIconSize = {}));
var ACCORDION_CLOSEST_ELEMENTS = "[href], [onclick], [for], a, button, input, textarea, radio, ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["BUTTON_GROUP_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["INPUT_STYLE_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["CHECKBOX_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["RADIO_GROUP_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["RADIO_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["LINK_NAME"] + ", ." + _component_names__WEBPACK_IMPORTED_MODULE_6__["INPLACE_EDIT_NAME"];
var MAccordion = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAccordion, _super);
    function MAccordion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uuid = _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        _this.internalOpen = false;
        return _this;
    }
    MAccordion.prototype.emitClick = function (event) { };
    MAccordion.prototype.emitUpdateOpen = function (open) { };
    MAccordion.prototype.onOpenChange = function (open) {
        this.internalOpen = open;
    };
    Object.defineProperty(MAccordion.prototype, "propDisabled", {
        get: function () {
            if (!this.internalGroupRef) {
                return false;
            }
            return this.internalGroupRef.disabled || this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "propId", {
        get: function () {
            return this.id || this.uuid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "idBodyWrap", {
        get: function () {
            return this.propId + "-body-wrap";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "classBody", {
        get: function () {
            return {
                'm--has-padding': this.paddingBody && this.padding
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "propOpen", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            if (open !== this.internalOpen) {
                this.internalOpen = open;
                this.emitUpdateOpen(open);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "headerTabindex", {
        get: function () {
            return this.propDisabled || !this.hasContent() ? undefined : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "headerAriaLabel", {
        get: function () {
            return !this.propDisabled && this.hasContent() ?
                this.$i18n.translate("m-accordion:" + (this.propOpen ? 'close' : 'open'))
                : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "isIconPositionLeft", {
        get: function () {
            return this.iconPosition === MAccordionIconPosition.Left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "isIconSizeLarge", {
        get: function () {
            return this.iconSize === MAccordionIconSize.Large;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "deltaHeight", {
        get: function () {
            switch (this.propSkin) {
                case MAccordionSkin.Default:
                case MAccordionSkin.Dark:
                case MAccordionSkin.DarkB:
                    return 32;
                default:
                    return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "propSkin", {
        get: function () {
            return this.internalGroupRef ? this.internalGroupRef.skin : this.skin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "plusSkin", {
        get: function () {
            if (this.skin === MAccordionSkin.DarkB) {
                if (this.propOpen) {
                    return _plus_plus__WEBPACK_IMPORTED_MODULE_8__["MPlusSkin"].CurrentColor;
                }
                else {
                    return _plus_plus__WEBPACK_IMPORTED_MODULE_8__["MPlusSkin"].Light;
                }
            }
            else {
                return _plus_plus__WEBPACK_IMPORTED_MODULE_8__["MPlusSkin"].Default;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAccordion.prototype, "hasIconBorder", {
        get: function () {
            if (this.iconBorder) {
                return this.iconBorder;
            }
            return this.propSkin === MAccordionSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    MAccordion.prototype.hasContent = function () {
        return Boolean(this.$slots.default);
    };
    MAccordion.prototype.toggleAccordion = function (event) {
        if (!this.hasContent()) {
            return;
        }
        var target = event.target.closest(ACCORDION_CLOSEST_ELEMENTS);
        if (!this.propDisabled && !target) {
            var initialState = this.internalOpen;
            if (!this.internalOpen &&
                this.internalGroupRef &&
                this.internalGroupRef.concurrent) {
                this.internalGroupRef.closeAllAccordions();
            }
            this.refAccordionHeader.blur();
            this.propOpen = !initialState;
            this.emitClick(event);
        }
    };
    MAccordion.prototype.mounted = function () {
        if (this.internalGroupRef) {
            this.internalGroupRef.addAccordion(this);
        }
    };
    MAccordion.prototype.beforeDestroy = function () {
        if (!this.internalGroupRef) {
            return;
        }
        this.internalGroupRef.removeAccordion(this.propId);
    };
    Object.defineProperty(MAccordion.prototype, "internalGroupRef", {
        get: function () {
            if (this.isParentAccordionGroup()) {
                return this.$parent;
            }
            else if (this.groupRef) {
                return this.groupRef;
            }
        },
        enumerable: true,
        configurable: true
    });
    MAccordion.prototype.isParentAccordionGroup = function () {
        return 'addAccordion' in this.$parent;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAccordion.prototype, "groupRef", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAccordion.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MAccordion.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MAccordion.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MAccordionSkin.Default,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MAccordionSkin).includes(value); }
        })
    ], MAccordion.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MAccordionIconPosition.Left,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MAccordionIconPosition).includes(value); }
        })
    ], MAccordion.prototype, "iconPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAccordion.prototype, "iconBorder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MAccordionIconSize.Large,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MAccordionIconSize).includes(value); }
        })
    ], MAccordion.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MAccordion.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MAccordion.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MAccordion.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MAccordion.prototype, "keepContentAlive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Ref"])('accordionHeader')
    ], MAccordion.prototype, "refAccordionHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MAccordion.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:open')
    ], MAccordion.prototype, "emitUpdateOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open', { immediate: true })
    ], MAccordion.prototype, "onOpenChange", null);
    MAccordion = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _accordion_html_style_accordion_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_9__["MAccordionTransition"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["PLUS_NAME"]] = _plus_plus__WEBPACK_IMPORTED_MODULE_8__["MPlus"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["MI18n"],
                _a)
        })
    ], MAccordion);
    return MAccordion;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var AccordionPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["ACCORDION_NAME"], MAccordion);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AccordionPlugin);


/***/ }),

/***/ "./src/components/add/add.html":
/*!*************************************!*\
  !*** ./src/components/add/add.html ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-link",
    {
      staticClass: "m-add",
      attrs: {
        disabled: _vm.disabled,
        "icon-position": _vm.iconPosition,
        "icon-size": _vm.iconSize,
        skin: _vm.skin,
        underline: _vm.underline,
        "icon-name": "m-svg__add-circle-filled",
        mode: "button"
      },
      on: { click: _vm.onClick }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-59f1d465'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/add/add.scss":
/*!*************************************!*\
  !*** ./src/components/add/add.scss ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/add/add.ts":
/*!***********************************!*\
  !*** ./src/components/add/add.ts ***!
  \***********************************/
/*! exports provided: MAdd, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAdd", function() { return MAdd; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _add_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./add.html */ "./src/components/add/add.html");
/* harmony import */ var _add_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_add_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _add_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./add.scss */ "./src/components/add/add.scss");
/* harmony import */ var _add_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_add_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MAdd = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAdd, _super);
    function MAdd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MAdd.prototype.emitClick = function () { };
    MAdd.prototype.onClick = function () {
        if (this.disabled) {
            return;
        }
        this.emitClick();
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAdd.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MAdd.prototype, "underline", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkSkin"].Default,
            validator: function (value) {
                return value === _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkSkin"].Default ||
                    value === _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkSkin"].Light ||
                    value === _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkSkin"].Text;
            }
        })
    ], MAdd.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkIconPosition"].Left,
            validator: function (value) {
                return value === _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkIconPosition"].Left || value === _link_link__WEBPACK_IMPORTED_MODULE_5__["MLinkIconPosition"].Right;
            }
        })
    ], MAdd.prototype, "iconPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '24px' })
    ], MAdd.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MAdd.prototype, "emitClick", null);
    MAdd = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _add_html__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_5__["MLink"],
                _a)
        })
    ], MAdd);
    return MAdd;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var AddPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["ADD_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["ADD_NAME"], MAdd);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AddPlugin);


/***/ }),

/***/ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll-unscoped.scss":
/*!************************************************************************************!*\
  !*** ./src/components/auto-horizontal-scroll/auto-horizontal-scroll-unscoped.scss ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.html?style=./auto-horizontal-scroll.scss":
/*!***************************************************************************************************************!*\
  !*** ./src/components/auto-horizontal-scroll/auto-horizontal-scroll.html?style=./auto-horizontal-scroll.scss ***!
  \***************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=24cb94e9!./auto-horizontal-scroll.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=24cb94e9!./src/components/auto-horizontal-scroll/auto-horizontal-scroll.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-auto-horizontal-scroll",
      class: [
        {
          "m--has-horizontal-scrollbar": _vm.hasHorizontalScroll,
          "m--has-left-gradient": _vm.hasLeftGradient,
          "m--has-right-gradient": _vm.hasRightGradient,
          "m--has-previous-button": _vm.hasPreviousButton,
          "m--has-next-button": _vm.hasNextButton,
          "m--is-drag-active": _vm.dragActive && _vm.hasHorizontalScroll,
          "m--is-dragging": _vm.isDragging && _vm.hasHorizontalScroll
        },
        "m--is-gradient-style-" + _vm.gradientStyle
      ],
      style: _vm.componentHeightStyle
    },
    [
      _c("transition", { attrs: { name: "m--is" } }, [
        _vm.hasPreviousButton || _vm.hasLeftGradient
          ? _c(
              "div",
              {
                staticClass: "m-auto-horizontal-scroll__button-area m--is-left",
                style: _vm.buttonAreaHeightStyle
              },
              [
                _vm.hasPreviousButton
                  ? _c("m-icon-button", {
                      ref: "leftButton",
                      attrs: {
                        skin: _vm.iconButtonSkin,
                        ripple: false,
                        title: _vm.previousButtonText,
                        "icon-name": "m-svg__chevron--left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.emitPreviousButtonClick($event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "m--is" } }, [
        _vm.hasNextButton || _vm.hasRightGradient
          ? _c(
              "div",
              {
                staticClass:
                  "m-auto-horizontal-scroll__button-area m--is-right",
                style: _vm.buttonAreaHeightStyle
              },
              [
                _vm.hasNextButton
                  ? _c("m-icon-button", {
                      ref: "rightButton",
                      attrs: {
                        skin: _vm.iconButtonSkin,
                        ripple: false,
                        title: _vm.nextButtonText,
                        "icon-name": "m-svg__chevron--right"
                      },
                      on: {
                        click: function($event) {
                          return _vm.emitNextButtonClick($event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "body",
          staticClass: "m-auto-horizontal-scroll__body",
          on: {
            scroll: function($event) {
              return _vm.onScroll()
            },
            mousedown: function($event) {
              return _vm.onMousedown($event)
            },
            mouseleave: function($event) {
              return _vm.onMouseleave()
            },
            mouseup: function($event) {
              return _vm.onMouseup()
            },
            mousemove: function($event) {
              return _vm.onMousemove($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              ref: "bodyContent",
              staticClass: "m-auto-horizontal-scroll__body-content",
              style: { minWidth: _vm.minWidth }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-24cb94e9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.en.json":
/*!***********************************************************************************!*\
  !*** ./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.en.json ***!
  \***********************************************************************************/
/*! exports provided: m-auto-horizontal-scroll, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-auto-horizontal-scroll\":{\"previous-button-text\":\"Previous\",\"next-button-text\":\"Next\"}}");

/***/ }),

/***/ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.fr.json":
/*!***********************************************************************************!*\
  !*** ./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.fr.json ***!
  \***********************************************************************************/
/*! exports provided: m-auto-horizontal-scroll, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-auto-horizontal-scroll\":{\"previous-button-text\":\"Précédent\",\"next-button-text\":\"Suivant\"}}");

/***/ }),

/***/ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.ts":
/*!*************************************************************************!*\
  !*** ./src/components/auto-horizontal-scroll/auto-horizontal-scroll.ts ***!
  \*************************************************************************/
/*! exports provided: MAutoHorizontalScrollGradientStyle, MAutoHorizontalScroll, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAutoHorizontalScrollGradientStyle", function() { return MAutoHorizontalScrollGradientStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAutoHorizontalScroll", function() { return MAutoHorizontalScroll; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/element-queries/element-queries */ "./src/mixins/element-queries/element-queries.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _auto_horizontal_scroll_unscoped_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./auto-horizontal-scroll-unscoped.scss */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll-unscoped.scss");
/* harmony import */ var _auto_horizontal_scroll_unscoped_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_auto_horizontal_scroll_unscoped_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _auto_horizontal_scroll_html_style_auto_horizontal_scroll_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./auto-horizontal-scroll.html?style=./auto-horizontal-scroll.scss */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.html?style=./auto-horizontal-scroll.scss");
/* harmony import */ var _auto_horizontal_scroll_html_style_auto_horizontal_scroll_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_auto_horizontal_scroll_html_style_auto_horizontal_scroll_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MAutoHorizontalScrollGradientStyle;
(function (MAutoHorizontalScrollGradientStyle) {
    MAutoHorizontalScrollGradientStyle["Any"] = "Any";
    MAutoHorizontalScrollGradientStyle["White"] = "white";
    MAutoHorizontalScrollGradientStyle["Light"] = "light";
    MAutoHorizontalScrollGradientStyle["Dark"] = "dark";
    MAutoHorizontalScrollGradientStyle["GreyBlack"] = "grey-black";
    MAutoHorizontalScrollGradientStyle["Interactive"] = "interactive";
    MAutoHorizontalScrollGradientStyle["InteractiveDark"] = "interactive-dark";
    MAutoHorizontalScrollGradientStyle["InteractiveDarker"] = "interactive-darker";
    MAutoHorizontalScrollGradientStyle["CurrentColor"] = "current-color";
})(MAutoHorizontalScrollGradientStyle || (MAutoHorizontalScrollGradientStyle = {}));
var MAutoHorizontalScroll = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAutoHorizontalScroll, _super);
    function MAutoHorizontalScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasHorizontalScroll = false;
        _this.couldHaveLeftContent = false;
        _this.couldHaveRightContent = false;
        _this.componentWidth = '';
        _this.componentHeight = '';
        _this.scrollLeftCounter = -1;
        _this.scrollAnimationActive = false;
        _this.isDragging = false;
        _this.startXDragging = 0;
        _this.scrollLeftDragging = 0;
        _this.observer = new MutationObserver(function () {
            _this.resizeComponent();
        });
        return _this;
    }
    MAutoHorizontalScroll.prototype.emitResize = function (resizeProperties) { };
    MAutoHorizontalScroll.prototype.emitUpdateHorizontalScrollOffset = function (horizontalScrollOffset) { };
    MAutoHorizontalScroll.prototype.emitPreviousButtonClick = function (event) { };
    MAutoHorizontalScroll.prototype.emitNextButtonClick = function (event) { };
    MAutoHorizontalScroll.prototype.onLeftGradientActiveChange = function () {
        this.checkGradientPresence();
    };
    MAutoHorizontalScroll.prototype.onDisplayHorizontalScrollbarChange = function () {
        this.resizeComponent();
    };
    MAutoHorizontalScroll.prototype.onHorizontalScrollOffsetChange = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.scrollLeftCounter++;
                        if (this.scrollAnimationActive) {
                            this.stopScrollAnimation();
                            return [2 /*return*/];
                        }
                        if (this.refBody &&
                            this.horizontalScrollOffset !== this.refBody.scrollLeft) {
                            if (this.scrollLeftCounter <= 0) {
                                this.refBody.scrollLeft = this.horizontalScrollOffset;
                            }
                            else {
                                this.startScrollAnimation();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MAutoHorizontalScroll.prototype.onRightGradientActiveChange = function () {
        this.checkGradientPresence();
    };
    Object.defineProperty(MAutoHorizontalScroll.prototype, "componentHeightStyle", {
        get: function () {
            return {
                height: !this.displayHorizontalScrollbar ? this.componentHeight : undefined
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "buttonAreaHeightStyle", {
        get: function () {
            return {
                height: this.componentHeight
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "hasLeftGradient", {
        get: function () {
            return this.leftGradientActive && this.couldHaveLeftContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "hasRightGradient", {
        get: function () {
            return this.rightGradientActive && this.couldHaveRightContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "hasPreviousButton", {
        get: function () {
            return this.previousButtonActive && this.couldHaveLeftContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "hasNextButton", {
        get: function () {
            return this.nextButtonActive && this.couldHaveRightContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "isGradientStyleDark", {
        get: function () {
            return (this.gradientStyle ===
                MAutoHorizontalScrollGradientStyle.Dark);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "isGradientStyleInteractive", {
        get: function () {
            return (this.gradientStyle ===
                MAutoHorizontalScrollGradientStyle.Interactive);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "isGradientStyleGreyBlack", {
        get: function () {
            return (this.gradientStyle ===
                MAutoHorizontalScrollGradientStyle.GreyBlack);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "isGradientStyleInteractiveDark", {
        get: function () {
            return (this.gradientStyle ===
                MAutoHorizontalScrollGradientStyle.InteractiveDark);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "isGradientStyleInteractiveDarker", {
        get: function () {
            return (this.gradientStyle ===
                MAutoHorizontalScrollGradientStyle.InteractiveDarker);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutoHorizontalScroll.prototype, "iconButtonSkin", {
        get: function () {
            return this.isGradientStyleDark ||
                this.isGradientStyleGreyBlack ||
                this.isGradientStyleInteractive ||
                this.isGradientStyleInteractiveDark ||
                this.isGradientStyleInteractiveDarker
                ? _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButtonSkin"].Dark
                : _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButtonSkin"].Light;
        },
        enumerable: true,
        configurable: true
    });
    MAutoHorizontalScroll.prototype.startScrollAnimation = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var initialScrollLeft, difference, intervalDelay_1, increment_1, isPositiveIncrement_1, counter_1, scrollAnimationInterval_1;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.scrollAnimationActive = true;
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (this.refBody) {
                            initialScrollLeft = this.refBody.scrollLeft;
                            difference = this.horizontalScrollOffset - initialScrollLeft <=
                                this.refBody.scrollWidth
                                ? this.horizontalScrollOffset - initialScrollLeft
                                : this.refBody.scrollWidth;
                            intervalDelay_1 = difference > 500 ? 7 : 10;
                            increment_1 = difference / intervalDelay_1;
                            isPositiveIncrement_1 = increment_1 > 0;
                            counter_1 = 0;
                            scrollAnimationInterval_1 = window.setInterval(function () {
                                counter_1 += intervalDelay_1;
                                if (!_this.scrollAnimationActive ||
                                    !_this.refBody ||
                                    _this.refBody.scrollLeft === undefined ||
                                    ((isPositiveIncrement_1 &&
                                        _this.refBody.scrollLeft >= _this.horizontalScrollOffset) ||
                                        (!isPositiveIncrement_1 &&
                                            _this.refBody.scrollLeft <= _this.horizontalScrollOffset) ||
                                        counter_1 >= 5000)) {
                                    _this.stopScrollAnimation();
                                    window.clearInterval(scrollAnimationInterval_1);
                                }
                                else {
                                    _this.setScrollLeftOffset(_this.refBody.scrollLeft += increment_1);
                                }
                            }, intervalDelay_1);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MAutoHorizontalScroll.prototype.stopScrollAnimation = function () {
        this.scrollAnimationActive = false;
        this.onScroll();
    };
    MAutoHorizontalScroll.prototype.onScroll = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.refBody && !this.scrollAnimationActive) {
                            this.emitUpdateHorizontalScrollOffset(this.refBody.scrollLeft);
                        }
                        return [4 /*yield*/, this.checkGradientPresence()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MAutoHorizontalScroll.prototype.onMousedown = function (e) {
        this.isDragging = this.dragActive;
        this.startXDragging = e.pageX - this.refBody.offsetLeft;
        this.scrollLeftDragging = this.refBody.scrollLeft;
    };
    MAutoHorizontalScroll.prototype.onMouseleave = function () {
        this.isDragging = false;
    };
    MAutoHorizontalScroll.prototype.onMouseup = function () {
        this.isDragging = false;
    };
    MAutoHorizontalScroll.prototype.onMousemove = function (e) {
        if (!this.isDragging) {
            return;
        }
        e.preventDefault();
        var x = e.pageX - this.refBody.offsetLeft;
        var walk = (x - this.startXDragging) * 2;
        this.refBody.scrollLeft = this.scrollLeftDragging - walk;
    };
    MAutoHorizontalScroll.prototype.mounted = function () {
        this.resizeComponent();
        this.$on('resizeDone', this.resizeComponent);
        if (this.refBodyContent) {
            this.observer.observe(this.refBodyContent, {
                subtree: true,
                childList: true
            });
        }
    };
    MAutoHorizontalScroll.prototype.beforeDestroy = function () {
        this.$off('resizeDone', this.resizeComponent);
        if (this.observer) {
            this.observer.disconnect();
        }
        this.stopScrollAnimation();
    };
    MAutoHorizontalScroll.prototype.resizeComponent = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.componentWidth = this.$el.clientWidth
                            ? this.$el.clientWidth + "px"
                            : '100%';
                        this.hasHorizontalScroll =
                            this.$el.clientWidth < parseInt(this.minWidth, 10);
                        this.componentHeight = Boolean(this.refBodyContent)
                            ? this.refBodyContent.clientHeight - 1 + "px"
                            : '';
                        this.emitResize({
                            element: this.$el,
                            hasHorizontalScroll: this.hasHorizontalScroll,
                            componentWidth: this.componentWidth,
                            horizontalScollbarWidth: this.refBodyContent.scrollWidth
                                ? this.refBodyContent.scrollWidth
                                : 0
                        });
                        this.checkGradientPresence();
                        return [2 /*return*/];
                }
            });
        });
    };
    MAutoHorizontalScroll.prototype.setScrollLeftOffset = function (scrollLeftOffset) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var maxScrollLeft;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (!this.refBody) {
                            return [2 /*return*/];
                        }
                        maxScrollLeft = this.refBodyContent.scrollWidth - this.refBody.clientWidth;
                        if (scrollLeftOffset < 0) {
                            this.refBody.scrollLeft = 0;
                            this.scrollAnimationActive = false;
                        }
                        else if (scrollLeftOffset >= maxScrollLeft) {
                            this.refBody.scrollLeft = maxScrollLeft - 0.5;
                            this.scrollAnimationActive = false;
                        }
                        else {
                            this.refBody.scrollLeft = scrollLeftOffset;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MAutoHorizontalScroll.prototype.checkGradientPresence = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.couldHaveLeftContent =
                            this.hasHorizontalScroll &&
                                Boolean(this.refBody) &&
                                this.refBody.scrollLeft > 2;
                        this.couldHaveRightContent =
                            this.hasHorizontalScroll &&
                                Boolean(this.refBody) &&
                                this.refBody.scrollLeft <=
                                    Math.round(this.refBody.scrollWidth -
                                        this.refBody.clientWidth -
                                        2);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: '100%',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_4__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MAutoHorizontalScroll.prototype, "minWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: true
        })
    ], MAutoHorizontalScroll.prototype, "horizontalScrollOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: true
        })
    ], MAutoHorizontalScroll.prototype, "dragActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MAutoHorizontalScrollGradientStyle.White,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MAutoHorizontalScrollGradientStyle).includes(value);
            }
        })
    ], MAutoHorizontalScroll.prototype, "gradientStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: true
        })
    ], MAutoHorizontalScroll.prototype, "leftGradientActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: true
        })
    ], MAutoHorizontalScroll.prototype, "rightGradientActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: false
        })
    ], MAutoHorizontalScroll.prototype, "previousButtonActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: false
        })
    ], MAutoHorizontalScroll.prototype, "nextButtonActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: function () { return _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"].prototype.$i18n.translate('m-auto-horizontal-scroll:previous-button-text'); }
        })
    ], MAutoHorizontalScroll.prototype, "previousButtonText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: function () { return _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"].prototype.$i18n.translate('m-auto-horizontal-scroll:next-button-text'); }
        })
    ], MAutoHorizontalScroll.prototype, "nextButtonText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: false
        })
    ], MAutoHorizontalScroll.prototype, "displayHorizontalScrollbar", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Ref"])('body')
    ], MAutoHorizontalScroll.prototype, "refBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Ref"])('bodyContent')
    ], MAutoHorizontalScroll.prototype, "refBodyContent", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('resize')
    ], MAutoHorizontalScroll.prototype, "emitResize", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('update:horizontalScrollOffset')
    ], MAutoHorizontalScroll.prototype, "emitUpdateHorizontalScrollOffset", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('previous-button-click')
    ], MAutoHorizontalScroll.prototype, "emitPreviousButtonClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('next-button-click')
    ], MAutoHorizontalScroll.prototype, "emitNextButtonClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('leftGradientActive')
    ], MAutoHorizontalScroll.prototype, "onLeftGradientActiveChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('displayHorizontalScrollbar')
    ], MAutoHorizontalScroll.prototype, "onDisplayHorizontalScrollbarChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('horizontalScrollOffset', { immediate: true })
    ], MAutoHorizontalScroll.prototype, "onHorizontalScrollOffsetChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('rightGradientActive')
    ], MAutoHorizontalScroll.prototype, "onRightGradientActiveChange", null);
    MAutoHorizontalScroll = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _auto_horizontal_scroll_html_style_auto_horizontal_scroll_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            modul: {
                i18n: {
                    'fr': __webpack_require__(/*! ./auto-horizontal-scroll.lang.fr.json */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.fr.json"),
                    'en': __webpack_require__(/*! ./auto-horizontal-scroll.lang.en.json */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.lang.en.json")
                }
            },
            components: (_a = {}, _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButton"], _a),
            mixins: [_mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_2__["ElementQueries"]]
        })
    ], MAutoHorizontalScroll);
    return MAutoHorizontalScroll;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var AutoHorizontalScrollPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["AUTO_HORIZONTAL_SCROLL"], MAutoHorizontalScroll);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AutoHorizontalScrollPlugin);


/***/ }),

/***/ "./src/components/autocomplete/autocomplete.html?style=./autocomplete.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/autocomplete/autocomplete.html?style=./autocomplete.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=a89018ae!./autocomplete.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=a89018ae!./src/components/autocomplete/autocomplete.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-dropdown",
    {
      attrs: {
        filterable: true,
        "clear-invalid-selection-on-close": _vm.clearInvalidSelectionOnClose,
        "show-arrow-icon": false,
        "enable-animation": false,
        "include-filterable-status-items": false,
        "clear-model-on-selected-text": false,
        placeholder: _vm.placeholder,
        focus: _vm.focus,
        "force-open": _vm.open,
        "label-up": _vm.labelUp,
        disabled: _vm.disabled,
        "error-message": _vm.errorMessage,
        "valid-message": _vm.validMessage,
        "helper-message": _vm.helperMessage,
        width: _vm.width,
        "max-width": _vm.maxWidth,
        label: _vm.label,
        "required-marker": _vm.requiredMarker,
        "tag-style": _vm.tagStyle,
        "max-length": _vm.maxLength,
        autocomplete: _vm.autocomplete
      },
      on: { input: _vm.onInputChangeThrottled },
      model: {
        value: _vm.selection,
        callback: function($$v) {
          _vm.selection = $$v
        },
        expression: "selection"
      }
    },
    [
      _vm._l(_vm.items, function(i, index) {
        return _c(
          "m-dropdown-item",
          {
            key: index,
            attrs: { value: i.value, label: i.label, "non-filterable": true }
          },
          [_vm._t("default", [_vm._v(_vm._s(i.label))], { item: i })],
          2
        )
      }),
      _vm._v(" "),
      _vm.showNoResult
        ? _c(
            "m-dropdown-item",
            { attrs: { readonly: true, "non-filterable": true } },
            [_vm._v(_vm._s(_vm.propTextNoMatch))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-a89018ae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/autocomplete/autocomplete.ts":
/*!*****************************************************!*\
  !*** ./src/components/autocomplete/autocomplete.ts ***!
  \*****************************************************/
/*! exports provided: MAutocomplete, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAutocomplete", function() { return MAutocomplete; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _dropdown_dropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../dropdown/dropdown */ "./src/components/dropdown/dropdown.ts");
/* harmony import */ var _dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../dropdown/dropdown-item/dropdown-item */ "./src/components/dropdown/dropdown-item/dropdown-item.ts");
/* harmony import */ var _autocomplete_html_style_autocomplete_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./autocomplete.html?style=./autocomplete.scss */ "./src/components/autocomplete/autocomplete.html?style=./autocomplete.scss");
/* harmony import */ var _autocomplete_html_style_autocomplete_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_autocomplete_html_style_autocomplete_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var MAutocomplete = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAutocomplete, _super);
    function MAutocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selection = '';
        _this.inputText = '';
        _this.items = [];
        _this.loading = false;
        _this.autocomplete = 'new-password';
        return _this;
    }
    MAutocomplete.prototype.created = function () {
        this.refreshItemsOnSelectionChange(this.model);
        this.selection = this.model;
    };
    MAutocomplete.prototype.onModelChange = function () {
        this.refreshItemsOnSelectionChange(this.model);
        this.selection = this.model;
    };
    MAutocomplete.prototype.onSelection = function () {
        this.refreshItemsOnSelectionChange(this.selection);
        if (this.selection === '') {
            this.inputText = this.selection;
        }
        return this.selection;
    };
    MAutocomplete.prototype.onResults = function () {
        this.items = this.results;
        this.loading = false;
    };
    MAutocomplete.prototype.onInputChangeThrottled = function (value) {
        var _this = this;
        clearTimeout(this.throttleTimeout);
        this.throttleTimeout = setTimeout(function () {
            _this.throttleTimeout = undefined;
            _this.onInputChange(value);
        }, this.throttle);
    };
    Object.defineProperty(MAutocomplete.prototype, "showNoResult", {
        get: function () {
            return !this.loading &&
                this.items.length === 0 &&
                this.inputText.length >= this.minimumChars;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAutocomplete.prototype, "propTextNoMatch", {
        get: function () {
            return (this.textNoMatch ? this.textNoMatch : this.$i18n.translate('m-dropdown:no-result'));
        },
        enumerable: true,
        configurable: true
    });
    MAutocomplete.prototype.refreshItemsOnSelectionChange = function (value) {
        var label = '';
        var result = this.results.find(function (r) { return r.value === value; });
        if (result) {
            label = result.label;
        }
        this.items = value !== '' ? [Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ label: label, value: value }, result)] : [];
    };
    MAutocomplete.prototype.onInputChange = function (value) {
        this.inputText = value;
        if (value === '') {
            this.items = [];
        }
        else if (value.length >= this.minimumChars) {
            this.emitComplete(value);
            this.loading = true;
        }
    };
    MAutocomplete.prototype.emitComplete = function (value) {
        return value;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change')
    ], MAutocomplete.prototype, "model", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MAutocomplete.prototype, "results", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 250 })
    ], MAutocomplete.prototype, "throttle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 1 })
    ], MAutocomplete.prototype, "minimumChars", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "textNoMatch", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "placeholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MAutocomplete.prototype, "clearInvalidSelectionOnClose", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "labelUp", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "errorMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "validMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "helperMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '100%' })
    ], MAutocomplete.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__["InputMaxWidth"].Regular })
    ], MAutocomplete.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAutocomplete.prototype, "requiredMarker", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputStateTagStyle"].Default,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__["Enums"].toValueArray(_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputStateTagStyle"]).indexOf(value) !== -1; }
        })
    ], MAutocomplete.prototype, "tagStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('model')
    ], MAutocomplete.prototype, "onModelChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('selection')
    ], MAutocomplete.prototype, "onSelection", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('results')
    ], MAutocomplete.prototype, "onResults", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('complete')
    ], MAutocomplete.prototype, "emitComplete", null);
    MAutocomplete = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _autocomplete_html_style_autocomplete_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["DROPDOWN_NAME"]] = _dropdown_dropdown__WEBPACK_IMPORTED_MODULE_8__["MDropdown"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["DROPDOWN_ITEM_NAME"]] = _dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_9__["MDropdownItem"],
                _a)
        })
    ], MAutocomplete);
    return MAutocomplete;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var AutoCompletePlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_7__["AUTOCOMPLETE_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["AUTOCOMPLETE_NAME"], MAutocomplete);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AutoCompletePlugin);


/***/ }),

/***/ "./src/components/avatar/avatar.html?style=./avatar.scss":
/*!***************************************************************!*\
  !*** ./src/components/avatar/avatar.html?style=./avatar.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=124023ee!./avatar.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=124023ee!./src/components/avatar/avatar.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "avatar",
      staticClass: "m-avatar",
      class: _vm.interactionClass,
      style: _vm.sizeStyle,
      attrs: { tabindex: _vm.tabindex },
      on: {
        click: _vm.onClick,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onClick($event)
        },
        touchend: function($event) {
          $event.preventDefault()
          return _vm.onTouchend($event)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
          ) {
            return null
          }
          return _vm.focusDisplay(true)
        },
        mouseover: function($event) {
          _vm.hover = true
        },
        mouseleave: function($event) {
          _vm.hover = false
        },
        focus: function($event) {
          _vm.hover = true
        },
        blur: function($event) {
          _vm.hover = false
        }
      }
    },
    [
      _vm._t("default", [
        _c("m-icon", {
          staticClass: "m-avatar__default-image",
          class: { "m--is-avatar-large": !_vm.isSmall },
          attrs: { name: _vm.defaultAvatar, size: _vm.size }
        })
      ]),
      _vm._v(" "),
      _vm._t("content", null, { contentVisible: _vm.showContent })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-124023ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/avatar/avatar.ts":
/*!*****************************************!*\
  !*** ./src/components/avatar/avatar.ts ***!
  \*****************************************/
/*! exports provided: MAvatarSize, MAvatar, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAvatarSize", function() { return MAvatarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAvatar", function() { return MAvatar; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _avatar_html_style_avatar_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./avatar.html?style=./avatar.scss */ "./src/components/avatar/avatar.html?style=./avatar.scss");
/* harmony import */ var _avatar_html_style_avatar_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_avatar_html_style_avatar_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MAvatarSize;
(function (MAvatarSize) {
    MAvatarSize[MAvatarSize["SMALL"] = 32] = "SMALL";
    MAvatarSize[MAvatarSize["MEDIUM"] = 64] = "MEDIUM";
    MAvatarSize[MAvatarSize["LARGE"] = 192] = "LARGE";
})(MAvatarSize || (MAvatarSize = {}));
var MAvatar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAvatar, _super);
    function MAvatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFocusVisible = false;
        _this.isHovered = false;
        _this.isTouched = false;
        _this.timeoutContentVisible = 0;
        return _this;
    }
    MAvatar.prototype.destroy = function () {
        this.resetTouch();
    };
    Object.defineProperty(MAvatar.prototype, "sizeStyle", {
        get: function () {
            return {
                width: this.size + 'px',
                height: this.size + 'px'
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "defaultAvatar", {
        get: function () {
            return this.isSmall ? 'm-svg__profile' : 'm-svg__avatar';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "isSmall", {
        get: function () {
            return this.size === MAvatarSize.SMALL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "tabindex", {
        get: function () {
            return this.clickable ? 0 : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "interactionClass", {
        get: function () {
            return {
                'm--is-clickable': this.clickable,
                'm--is-focus-visible': this.isFocusVisible
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "showContent", {
        get: function () {
            return this.hover || this.isTouched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "isEmptyContentSlot", {
        get: function () {
            return !this.$scopedSlots.content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MAvatar.prototype, "hover", {
        get: function () {
            return this.isHovered;
        },
        set: function (hover) {
            this.isHovered = hover;
        },
        enumerable: true,
        configurable: true
    });
    MAvatar.prototype.focusDisplay = function (focusVisible) {
        this.isFocusVisible = focusVisible;
    };
    MAvatar.prototype.onClick = function () {
        if (this.clickable) {
            this.emitClick();
        }
    };
    MAvatar.prototype.onTouchend = function () {
        var _this = this;
        if (this.clickable) {
            if (this.isTouched || this.isEmptyContentSlot) {
                this.resetTouch();
                this.emitTouch();
            }
            else {
                this.$modul.event.$on('click', this.resetTouch);
                this.isTouched = true;
                this.timeoutContentVisible = window.setTimeout(function () {
                    _this.isTouched = false;
                }, 5000);
            }
        }
    };
    MAvatar.prototype.resetTouch = function () {
        this.$modul.event.$off('click', this.resetTouch);
        clearTimeout(this.timeoutContentVisible);
        this.isTouched = false;
    };
    MAvatar.prototype.emitTouch = function () { };
    MAvatar.prototype.emitClick = function () { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MAvatarSize.SMALL,
            validator: function (value) {
                return value === MAvatarSize.SMALL ||
                    value === MAvatarSize.MEDIUM ||
                    value === MAvatarSize.LARGE;
            }
        })
    ], MAvatar.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MAvatar.prototype, "clickable", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('touch')
    ], MAvatar.prototype, "emitTouch", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MAvatar.prototype, "emitClick", null);
    MAvatar = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _avatar_html_style_avatar_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_5__["MIcon"],
                _a)
        })
    ], MAvatar);
    return MAvatar;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var AvatarPlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["AVATAR_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["AVATAR_NAME"], MAvatar);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AvatarPlugin);


/***/ }),

/***/ "./src/components/button/button.html?style=./button.scss":
/*!***************************************************************!*\
  !*** ./src/components/button/button.html?style=./button.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4823b029!./button.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4823b029!./src/components/button/button.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "m-button",
      class: {
        "m--is-skin-primary": _vm.isSkinPrimary,
        "m--is-skin-secondary": _vm.isSkinSecondary,
        "m--is-waiting": _vm.isWaiting,
        "m--is-disabled": _vm.disabled,
        "m--is-full-size": _vm.fullSize
      },
      attrs: { disabled: _vm.disabled || _vm.isWaiting, type: _vm.type },
      on: {
        click: _vm.onClick,
        mousedown: _vm.onMousedown,
        focus: _vm.onFocus,
        blur: _vm.onBlur,
        touchstart: _vm.onTouchstart,
        touchend: _vm.onTouchend
      }
    },
    [
      _vm.hasIconLeft
        ? _c("m-icon", {
            staticClass: "m-button__icon m--is-left",
            attrs: {
              "aria-hidden": "true",
              name: _vm.iconName,
              size: _vm.iconSize
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasWaitingIconLeft
        ? _c("m-spinner", {
            staticClass: "m-button__icon m--is-left",
            attrs: { "aria-hidden": "true", skin: "lighter", size: "small" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "m-button__text" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.hasPrecision
            ? _c(
                "span",
                { staticClass: "m-button__precision" },
                [
                  _vm._t("precision"),
                  _vm.precision ? void 0 : _vm._e(),
                  _vm._v(_vm._s(_vm.precision) + "\n        ")
                ],
                2
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasWaitingIconRight
        ? _c("m-spinner", {
            staticClass: "m-button__icon m--is-right",
            attrs: { "aria-hidden": "true", skin: "lighter", size: "small" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasIconRight
        ? _c("m-icon", {
            staticClass: "m-button__icon m--is-right",
            attrs: {
              "aria-hidden": "true",
              name: _vm.iconName,
              size: _vm.iconSize
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4823b029'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/button/button.ts":
/*!*****************************************!*\
  !*** ./src/components/button/button.ts ***!
  \*****************************************/
/*! exports provided: MButtonType, MButtonSkin, MButtonIconPosition, MButton, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MButtonType", function() { return MButtonType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MButtonSkin", function() { return MButtonSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MButtonIconPosition", function() { return MButtonIconPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MButton", function() { return MButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _spinner_spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../spinner/spinner */ "./src/components/spinner/spinner.ts");
/* harmony import */ var _button_html_style_button_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./button.html?style=./button.scss */ "./src/components/button/button.html?style=./button.scss");
/* harmony import */ var _button_html_style_button_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_button_html_style_button_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MButtonType;
(function (MButtonType) {
    MButtonType["Button"] = "button";
    MButtonType["Submit"] = "submit";
    MButtonType["Reset"] = "reset";
})(MButtonType || (MButtonType = {}));
var MButtonSkin;
(function (MButtonSkin) {
    MButtonSkin["Primary"] = "primary";
    MButtonSkin["Secondary"] = "secondary";
})(MButtonSkin || (MButtonSkin = {}));
var MButtonIconPosition;
(function (MButtonIconPosition) {
    MButtonIconPosition["Left"] = "left";
    MButtonIconPosition["Right"] = "right";
})(MButtonIconPosition || (MButtonIconPosition = {}));
var MButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MButton, _super);
    function MButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MButton.prototype.onClick = function (event) {
        this.$el.blur();
    };
    MButton.prototype.onMousedown = function (event) { };
    MButton.prototype.onTouchstart = function (event) { };
    MButton.prototype.onTouchend = function (event) { };
    MButton.prototype.onFocus = function (event) { };
    MButton.prototype.onBlur = function (event) { };
    Object.defineProperty(MButton.prototype, "isSkinPrimary", {
        get: function () {
            return this.skin === MButtonSkin.Primary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "isSkinSecondary", {
        get: function () {
            return this.skin === MButtonSkin.Secondary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "isWaiting", {
        get: function () {
            return !this.disabled ? this.waiting : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasIcone", {
        get: function () {
            return !!this.iconName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasIconLeft", {
        get: function () {
            return this.iconPosition === MButtonIconPosition.Left && this.hasIcone && !this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasIconRight", {
        get: function () {
            return this.iconPosition === MButtonIconPosition.Right && this.hasIcone && !this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasWaitingIconLeft", {
        get: function () {
            return this.iconPosition === MButtonIconPosition.Left && this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasWaitingIconRight", {
        get: function () {
            return this.iconPosition === MButtonIconPosition.Right && this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MButton.prototype, "hasPrecision", {
        get: function () {
            return !!this.precision || !!this.$slots.precision;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MButtonType.Button,
            validator: function (value) {
                return value === MButtonType.Button ||
                    value === MButtonType.Submit ||
                    value === MButtonType.Reset;
            }
        })
    ], MButton.prototype, "type", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MButtonSkin.Primary,
            validator: function (value) {
                return value === MButtonSkin.Primary ||
                    value === MButtonSkin.Secondary;
            }
        })
    ], MButton.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MButton.prototype, "precision", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MButton.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MButton.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MButton.prototype, "fullSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MButton.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MButtonIconPosition.Left,
            validator: function (value) {
                return value === MButtonIconPosition.Left ||
                    value === MButtonIconPosition.Right;
            }
        })
    ], MButton.prototype, "iconPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '12px' })
    ], MButton.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MButton.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('mousedown')
    ], MButton.prototype, "onMousedown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('touchstart')
    ], MButton.prototype, "onTouchstart", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('touchend')
    ], MButton.prototype, "onTouchend", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('focus')
    ], MButton.prototype, "onFocus", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('blur')
    ], MButton.prototype, "onBlur", null);
    MButton = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _button_html_style_button_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["SPINNER_NAME"]] = _spinner_spinner__WEBPACK_IMPORTED_MODULE_6__["MSpinner"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_5__["MIcon"],
                _a)
        })
    ], MButton);
    return MButton;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var ButtonPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["BUTTON_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["BUTTON_NAME"], MButton);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ButtonPlugin);


/***/ }),

/***/ "./src/components/calendar/calendar-button/calendar-button.scss":
/*!**********************************************************************!*\
  !*** ./src/components/calendar/calendar-button/calendar-button.scss ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/calendar/calendar-button/calendar-button.ts":
/*!********************************************************************!*\
  !*** ./src/components/calendar/calendar-button/calendar-button.ts ***!
  \********************************************************************/
/*! exports provided: MCalendarButton */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCalendarButton", function() { return MCalendarButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _calendar_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./calendar-button.scss */ "./src/components/calendar/calendar-button/calendar-button.scss");
/* harmony import */ var _calendar_button_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_calendar_button_scss__WEBPACK_IMPORTED_MODULE_2__);



var MCalendarButton = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
    name: 'calendar-button',
    functional: true,
    render: function (createElement, context) {
        var data = {
            class: {
                'm-calendar-button': true,
                'm--is-disabled': context.props['disabled'],
                'm--is-selected': context.props['selected'],
                'm--is-today': context.props['today']
            },
            props: {
                disabled: { type: Boolean, required: false },
                selected: { type: Boolean, required: false },
                today: { type: Boolean, required: false }
            },
            on: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, context.data.on), { click: function ($event) {
                    $event.stopPropagation();
                    var emit = context.data.on.click;
                    emit && emit($event);
                },
                keyup: function ($event) {
                    var emit = context.data.on.keyup;
                    emit && emit($event);
                },
                mouseenter: function ($event) {
                    var emit = context.data.on.mouseenter;
                    emit && emit($event);
                },
                mouseleave: function ($event) {
                    var emit = context.data.on.mouseleave;
                    emit && emit($event);
                } }),
            attrs: {
                'aria-selected': context.data.attrs.selected
            },
            ref: context.data.ref
        };
        return createElement('button', data, context.children);
    }
});


/***/ }),

/***/ "./src/components/calendar/calendar-renderer/abstract-calendar-renderer.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/calendar/calendar-renderer/abstract-calendar-renderer.ts ***!
  \*********************************************************************************/
/*! exports provided: MAbstractCalendarRenderer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAbstractCalendarRenderer", function() { return MAbstractCalendarRenderer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../calendar-state/state/calendar-state */ "./src/components/calendar/calendar-state/state/calendar-state.ts");




var MAbstractCalendarRenderer = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAbstractCalendarRenderer, _super);
    function MAbstractCalendarRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MAbstractCalendarRenderer.prototype.onDaySelect = function (day) {
    };
    MAbstractCalendarRenderer.prototype.onDayMouseEnter = function (day) {
    };
    MAbstractCalendarRenderer.prototype.onDayMouseLeave = function (day) {
    };
    MAbstractCalendarRenderer.prototype.onDayKeyboardTab = function (day) {
    };
    MAbstractCalendarRenderer.prototype.onMonthSelect = function (month) {
    };
    MAbstractCalendarRenderer.prototype.onMonthNext = function (event) {
    };
    MAbstractCalendarRenderer.prototype.onMonthPrevious = function (event) {
    };
    MAbstractCalendarRenderer.prototype.onYearSelect = function (year) {
    };
    MAbstractCalendarRenderer.prototype.onYearMonthSelect = function (year, month) {
    };
    MAbstractCalendarRenderer.prototype.onYearNext = function (event) {
    };
    MAbstractCalendarRenderer.prototype.onYearPrevious = function (event) {
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ required: true })
    ], MAbstractCalendarRenderer.prototype, "calendar", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_SELECT)
    ], MAbstractCalendarRenderer.prototype, "onDaySelect", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_MOUSE_ENTER)
    ], MAbstractCalendarRenderer.prototype, "onDayMouseEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_MOUSE_LEAVE)
    ], MAbstractCalendarRenderer.prototype, "onDayMouseLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_KEYBOARD_TAB)
    ], MAbstractCalendarRenderer.prototype, "onDayKeyboardTab", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].MONTH_SELECT)
    ], MAbstractCalendarRenderer.prototype, "onMonthSelect", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].MONTH_NEXT)
    ], MAbstractCalendarRenderer.prototype, "onMonthNext", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].MONTH_PREVIOUS)
    ], MAbstractCalendarRenderer.prototype, "onMonthPrevious", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].YEAR_SELECT)
    ], MAbstractCalendarRenderer.prototype, "onYearSelect", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].YEAR_MONTH_SELECT)
    ], MAbstractCalendarRenderer.prototype, "onYearMonthSelect", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].YEAR_NEXT)
    ], MAbstractCalendarRenderer.prototype, "onYearNext", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])(_calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].YEAR_PREVIOUS)
    ], MAbstractCalendarRenderer.prototype, "onYearPrevious", null);
    return MAbstractCalendarRenderer;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__["ModulVue"]));



/***/ }),

/***/ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.html":
/*!************************************************************************************!*\
  !*** ./src/components/calendar/calendar-renderer/base-calendar/base-calendar.html ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-base-calendar",
      class: {
        "m--is-years-months-view": _vm.isYearsMonthsView,
        "m--is-max-row": _vm.isMaxRow
      },
      attrs: { id: _vm.id }
    },
    [
      _c(
        "nav",
        {
          staticClass: "m-base-calendar__header",
          class: { "m--is-select-mode": !_vm.isDaysView }
        },
        [
          _vm.isButtonToogleViewDisabled
            ? _c("strong", [
                _vm._v(
                  _vm._s(_vm.currentMonthName) + " " + _vm._s(_vm.currentYear)
                )
              ])
            : _c(
                "m-link",
                {
                  ref: "currentDate",
                  staticClass: "m-base-calendar__current-month-and-year",
                  attrs: {
                    mode: _vm.modeLinkCurrentMonthAndYear,
                    "aria-live": "polite"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onToogleView($event)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.currentMonthName) + " " + _vm._s(_vm.currentYear)
                  )
                ]
              ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "m--is" } }, [
            _vm.isDaysView
              ? _c(
                  "div",
                  { staticClass: "m-base-calendar__nav-buttons" },
                  [
                    _c(
                      "m-icon-button",
                      {
                        ref: "previousMonth",
                        staticClass: "m-base-calendar__previous",
                        attrs: {
                          disabled: _vm.isMinMonth,
                          "icon-name": "m-svg__chevron--left",
                          "icon-size": "16px",
                          skin: "link"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onMonthPrevious()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.previousMonthLabel))]
                    ),
                    _vm._v(" "),
                    _c(
                      "m-icon-button",
                      {
                        ref: "nextMonth",
                        staticClass: "m-base-calendar__next",
                        attrs: {
                          disabled: _vm.isMaxMonth,
                          "icon-name": "m-svg__chevron--right",
                          "icon-size": "16px",
                          skin: "link"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onMonthNext()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.nextMonthLabel))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "body",
          staticClass: "m-base-calendar__body",
          attrs: { "aria-live": "polite" }
        },
        [
          _c("transition", { attrs: { name: "m--is" } }, [
            _vm.isDaysView
              ? _c("div", { staticClass: "m-base-calendar__days-view" }, [
                  _c(
                    "div",
                    { staticClass: "m-base-calendar__week" },
                    _vm._l(_vm.weekdaysLabels, function(w, weekdayIndex) {
                      return _c(
                        "span",
                        {
                          key: weekdayIndex,
                          staticClass: "m-base-calendar__weekday"
                        },
                        [_vm._v(_vm._s(w))]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-base-calendar__days-grid" },
                    _vm._l(_vm.days, function(d, dayIndex) {
                      return _c(
                        "m-calendar-button",
                        {
                          key: dayIndex,
                          ref: _vm.buildRef(
                            _vm.mBaseCalendarView.DAYS,
                            _vm.currentYear,
                            _vm.currentMonth + 1,
                            d.day
                          ),
                          refInFor: true,
                          staticClass: "m-base-calendar__day",
                          class: {
                            "m--is-highlighted": d.isHighlighted,
                            "m--is-in-future": _vm.isDateInFuture(d),
                            "m--is-inside-range": _vm.isInsideRange(d),
                            "m--is-other-month":
                              d.isInPreviousMonth || d.isInNextMonth,
                            "m--is-selection-start": _vm.isSelectionStart(d),
                            "m--is-selection-end": _vm.isSelectionEnd(d)
                          },
                          attrs: {
                            disabled: d.isDisabled || _vm.hideDay(d),
                            selected: d.isSelected,
                            today: d.isToday
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDaySelect(d)
                            },
                            keyup: function($event) {
                              return _vm.onKeyUp($event, d)
                            },
                            mouseenter: function($event) {
                              return _vm.onDayMouseEnter(d)
                            },
                            mouseleave: function($event) {
                              return _vm.onDayMouseLeave(d)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "m-base-calendar__day-content",
                              class: { "m--is-hidden": _vm.hideDay(d) }
                            },
                            [_vm._v(_vm._s(d.day))]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "m--is" },
              on: { enter: _vm.scrollToCurrentYear }
            },
            [
              _vm.isYearsMonthsView
                ? _c(
                    "div",
                    {
                      ref: "yearsMonthsView",
                      staticClass: "m-base-calendar__years-months-view"
                    },
                    [
                      _vm._l(_vm.yearsMonths, function(yM, yearsMonthsIndex) {
                        return [
                          _c(
                            "h2",
                            {
                              staticClass: "m-base-calendar__year-title",
                              class: { "m--is-current": yM.year.isCurrent },
                              attrs: { "data-current-year": yM.year.isCurrent }
                            },
                            [_vm._v(_vm._s(yM.year.year))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "m-base-calendar__month-list" },
                            _vm._l(yM.months, function(m, monthIndex) {
                              return _c(
                                "m-calendar-button",
                                {
                                  key: monthIndex,
                                  ref: _vm.buildRef(
                                    _vm.mBaseCalendarView.YEARS_MONTHS,
                                    yM.year.year,
                                    m.month + 1
                                  ),
                                  refInFor: true,
                                  attrs: {
                                    disabled: m.isDisabled,
                                    selected: m.isCurrent
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onYearMonthSelect(yM.year, m)
                                    },
                                    keyup: function($event) {
                                      return _vm.onYearMonthSelectKeyup(
                                        $event,
                                        yM.year.year,
                                        m
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.monthIndexToShortName(m.month))
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-600b5e83'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.scss":
/*!************************************************************************************!*\
  !*** ./src/components/calendar/calendar-renderer/base-calendar/base-calendar.scss ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.ts":
/*!**********************************************************************************!*\
  !*** ./src/components/calendar/calendar-renderer/base-calendar/base-calendar.ts ***!
  \**********************************************************************************/
/*! exports provided: MBaseCalendarView, MBaseCalendarType, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MBaseCalendarView", function() { return MBaseCalendarView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MBaseCalendarType", function() { return MBaseCalendarType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../utils/keycode/keycode */ "./src/utils/keycode/keycode.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _calendar_button_calendar_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../calendar-button/calendar-button */ "./src/components/calendar/calendar-button/calendar-button.ts");
/* harmony import */ var _calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../calendar-state/state/calendar-state */ "./src/components/calendar/calendar-state/state/calendar-state.ts");
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./../../../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _abstract_calendar_renderer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../abstract-calendar-renderer */ "./src/components/calendar/calendar-renderer/abstract-calendar-renderer.ts");
/* harmony import */ var _base_calendar_html__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./base-calendar.html */ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.html");
/* harmony import */ var _base_calendar_html__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_base_calendar_html__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _base_calendar_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./base-calendar.scss */ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.scss");
/* harmony import */ var _base_calendar_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_base_calendar_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a;














var TRANSLATION_ROOT = 'm-calendar' + ':';
var TRANSLATION_MONTHS = TRANSLATION_ROOT + 'month';
var TRANSLATION_WEEKDAYS = TRANSLATION_ROOT + 'weekday';
var TRANSLATION_SUFFIXE = '.short';
var MonthsNames;
(function (MonthsNames) {
    MonthsNames["JANUARY"] = "january";
    MonthsNames["FEBRUARY"] = "february";
    MonthsNames["MARCH"] = "march";
    MonthsNames["APRIL"] = "april";
    MonthsNames["MAY"] = "may";
    MonthsNames["JUNE"] = "june";
    MonthsNames["JULY"] = "july";
    MonthsNames["AUGUST"] = "august";
    MonthsNames["SEPTEMBER"] = "september";
    MonthsNames["OCTOBER"] = "october";
    MonthsNames["NOVEMBER"] = "november";
    MonthsNames["DECEMBER"] = "december";
})(MonthsNames || (MonthsNames = {}));
var WeekdayNames;
(function (WeekdayNames) {
    WeekdayNames["SUNDAY"] = "sunday";
    WeekdayNames["MONDAY"] = "monday";
    WeekdayNames["TUESDAY"] = "tuesday";
    WeekdayNames["WEDNESDAY"] = "wednesday";
    WeekdayNames["THURSDAY"] = "thursday";
    WeekdayNames["FRIDAY"] = "friday";
    WeekdayNames["SATURDAY"] = "saturday";
})(WeekdayNames || (WeekdayNames = {}));
var MBaseCalendarView;
(function (MBaseCalendarView) {
    MBaseCalendarView["DAYS"] = "days";
    MBaseCalendarView["YEARS_MONTHS"] = "years-months";
})(MBaseCalendarView || (MBaseCalendarView = {}));
var MBaseCalendarType;
(function (MBaseCalendarType) {
    MBaseCalendarType["FULL_DATE"] = "full-date";
    MBaseCalendarType["YEARS_MONTHS"] = "years-months";
})(MBaseCalendarType || (MBaseCalendarType = {}));
var MBaseCalendar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MBaseCalendar, _super);
    function MBaseCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mBaseCalendarView = MBaseCalendarView;
        _this.previousMonthLabel = _this.$i18n.translate('m-calendar:previous.month');
        _this.nextMonthLabel = _this.$i18n.translate('m-calendar:next.month');
        _this.previousYearLabel = _this.$i18n.translate('m-calendar:previous.year');
        _this.nextYearLabel = _this.$i18n.translate('m-calendar:next.year');
        _this.id = "m-simple-calendar-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        _this.modeLinkCurrentMonthAndYear = _link_link__WEBPACK_IMPORTED_MODULE_7__["MLinkMode"].Button;
        _this.animReady = false;
        _this.internalCurrentView = MBaseCalendarView.DAYS;
        return _this;
    }
    MBaseCalendar.prototype.visibleChanged = function (visible) {
        var isInYearView = this.isTypeYearsMonths || this.initialView === MBaseCalendarView.YEARS_MONTHS;
        if (visible && isInYearView) {
            this.scrollToCurrentYear();
        }
    };
    MBaseCalendar.prototype.created = function () {
        this.currentView = this.initialView; // Set currentView value in created() to hide animation when the component is diplayed for the firt time
    };
    MBaseCalendar.prototype.onToogleView = function () {
        this.currentView === MBaseCalendarView.DAYS ? this.currentView = MBaseCalendarView.YEARS_MONTHS : this.currentView = MBaseCalendarView.DAYS;
    };
    MBaseCalendar.prototype.onYearMonthSelect = function (year, month) {
        var _this = this;
        if (!month.isDisabled) {
            month.isCurrent = true;
            if (this.isTypeYearsMonths) {
                _super.prototype.onYearMonthSelect.call(this, year, month);
            }
            else {
                _super.prototype.onYearSelect.call(this, year);
                _super.prototype.onMonthSelect.call(this, month);
                // Delay to show the user selection
                setTimeout(function () {
                    _this.currentView = MBaseCalendarView.DAYS;
                }, 300);
            }
        }
    };
    MBaseCalendar.prototype.onYearMonthSelectKeyup = function ($event, year, month) {
        // tslint:disable-next-line: deprecation
        if ($event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_ENTER || $event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_RETURN) {
            this.onYearMonthSelect(year, month);
        }
    };
    MBaseCalendar.prototype.onYearNext = function (event) {
        _super.prototype.onYearNext.call(this, event);
    };
    MBaseCalendar.prototype.onYearPrevious = function (event) {
        _super.prototype.onYearPrevious.call(this, event);
    };
    MBaseCalendar.prototype.onMonthNext = function (event) {
        _super.prototype.onMonthNext.call(this, event);
    };
    MBaseCalendar.prototype.onMonthPrevious = function (event) {
        _super.prototype.onMonthPrevious.call(this, event);
    };
    MBaseCalendar.prototype.onDaySelect = function (day) {
        _super.prototype.onDaySelect.call(this, day);
    };
    MBaseCalendar.prototype.onDayMouseEnter = function (day) {
        _super.prototype.onDayMouseEnter.call(this, day);
    };
    MBaseCalendar.prototype.onKeyUp = function ($event, day) {
        // tslint:disable-next-line: deprecation
        if ($event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_ENTER || $event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_RETURN) {
            _super.prototype.onDaySelect.call(this, day);
        }
        // tslint:disable-next-line: deprecation
        if ($event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_TAB) {
            _super.prototype.onDayKeyboardTab.call(this, day);
        }
    };
    MBaseCalendar.prototype.onDayMouseLeave = function (day) {
        _super.prototype.onDayMouseLeave.call(this, day);
    };
    MBaseCalendar.prototype.isDateInFuture = function (day) {
        return !!this.calendar.type && this.calendar.type === _calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_9__["CalendarType"].DATE_RANGE
            && !!this.calendar.value && !!this.calendar.value.begin
            && day.date.isAfter(new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](this.calendar.value.begin));
    };
    MBaseCalendar.prototype.isInsideRange = function (day) {
        return !!this.calendar.type && this.calendar.type === _calendar_state_state_calendar_state__WEBPACK_IMPORTED_MODULE_9__["CalendarType"].DATE_RANGE
            && !!this.calendar.value && !!this.calendar.value.begin
            && !!this.calendar.value && !!this.calendar.value.end
            && day.isHighlighted;
    };
    MBaseCalendar.prototype.isSelectionStart = function (day) {
        return day.isSelectionStart && !this.hideDay(day);
    };
    MBaseCalendar.prototype.isSelectionEnd = function (day) {
        return day.isSelectionEnd && !this.hideDay(day);
    };
    MBaseCalendar.prototype.hideDay = function (day) {
        return (day.isInNextMonth || day.isInPreviousMonth) && !this.showMonthBeforeAfter;
    };
    MBaseCalendar.prototype.buildRef = function (refPrefix, year, month, day) {
        var refName = refPrefix + "-" + this.padString(year, 4) + "-" + this.padString(month, 2);
        if (refPrefix === MBaseCalendarView.DAYS) {
            return refName + "-" + this.padString(day, 2);
        }
        return refName;
    };
    MBaseCalendar.prototype.monthIndexToShortName = function (index) {
        return this.monthsNames[index];
    };
    MBaseCalendar.prototype.scrollToCurrentYear = function () {
        var _this = this;
        this.$nextTick(function () {
            var yearsMonthsViewEl = _this.$refs.yearsMonthsView;
            var spacingBeforeCurrentYear = 16;
            if (yearsMonthsViewEl) {
                yearsMonthsViewEl.scrollTop = yearsMonthsViewEl.querySelector('[data-current-year="true"]').offsetTop - spacingBeforeCurrentYear || 0;
            }
        });
    };
    Object.defineProperty(MBaseCalendar.prototype, "currentView", {
        get: function () {
            return this.internalCurrentView;
        },
        set: function (view) {
            if (this.isTypeYearsMonths) {
                this.internalCurrentView = MBaseCalendarView.YEARS_MONTHS;
            }
            else {
                this.internalCurrentView = view;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isTypeYearsMonths", {
        get: function () {
            return this.type === MBaseCalendarType.YEARS_MONTHS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "currentYear", {
        get: function () {
            return this.calendar.dates.current.fullYear();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "currentMonth", {
        get: function () {
            return this.calendar.dates.current.month();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "currentMonthName", {
        get: function () {
            return this.monthsNamesLong[this.currentMonth];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "weekdaysLabels", {
        get: function () {
            return this.daysNames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "years", {
        get: function () {
            return this.calendar.years;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "yearsMonths", {
        get: function () {
            return this.calendar.yearsMonths;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "months", {
        get: function () {
            return this.calendar.months;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "days", {
        get: function () {
            return this.calendar.days;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isYearsMonthsView", {
        get: function () {
            return this.currentView === MBaseCalendarView.YEARS_MONTHS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isDaysView", {
        get: function () {
            return this.currentView === MBaseCalendarView.DAYS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isMinYear", {
        get: function () {
            return this.currentYear === Math.min.apply(Math, this.calendar.years.map(function (year) { return year.year; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isMaxYear", {
        get: function () {
            return this.currentYear === Math.max.apply(Math, this.calendar.years.map(function (year) { return year.year; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isMinMonth", {
        get: function () {
            return this.calendar.dates.current.isSameOrBefore(this.calendar.dates.min, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["DatePrecision"].MONTH);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isMaxMonth", {
        get: function () {
            return this.calendar.dates.current.isSameOrAfter(this.calendar.dates.max, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["DatePrecision"].MONTH);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isMaxRow", {
        get: function () {
            if (this.isTypeYearsMonths) {
                return false;
            }
            var numberOfDays = this.calendar.days.length;
            return numberOfDays / 7 > 5 ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseCalendar.prototype, "isButtonToogleViewDisabled", {
        get: function () {
            return this.isMinMonth && this.isMaxYear || this.isTypeYearsMonths;
        },
        enumerable: true,
        configurable: true
    });
    MBaseCalendar.prototype.padString = function (value, length) {
        if (length === void 0) { length = 2; }
        return ('000' + value).slice(-1 * length);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MBaseCalendarView.DAYS,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(MBaseCalendarView).includes(value); }
        })
    ], MBaseCalendar.prototype, "initialView", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MBaseCalendar.prototype, "showMonthBeforeAfter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: function () {
                return Object.keys(MonthsNames).map(function (key) {
                    return vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Vue"].prototype.$i18n.translate(TRANSLATION_MONTHS + "." + MonthsNames[key] + TRANSLATION_SUFFIXE);
                });
            }
        })
    ], MBaseCalendar.prototype, "monthsNames", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: function () {
                return Object.keys(MonthsNames).map(function (key) {
                    return vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Vue"].prototype.$i18n.translate(TRANSLATION_MONTHS + "." + MonthsNames[key]);
                });
            }
        })
    ], MBaseCalendar.prototype, "monthsNamesLong", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: function () {
                return Object.keys(WeekdayNames).map(function (key) {
                    return vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Vue"].prototype.$i18n.translate(TRANSLATION_WEEKDAYS + "." + WeekdayNames[key] + TRANSLATION_SUFFIXE);
                });
            }
        })
    ], MBaseCalendar.prototype, "daysNames", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MBaseCalendarType.FULL_DATE,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(MBaseCalendarType).includes(value); }
        })
    ], MBaseCalendar.prototype, "type", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MBaseCalendar.prototype, "visible", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('visible', { immediate: true })
    ], MBaseCalendar.prototype, "visibleChanged", null);
    MBaseCalendar = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _base_calendar_html__WEBPACK_IMPORTED_MODULE_12___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_7__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["CALENDAR_BUTTON_NAME"]] = _calendar_button_calendar_button__WEBPACK_IMPORTED_MODULE_8__["MCalendarButton"],
                _a)
        })
    ], MBaseCalendar);
    return MBaseCalendar;
}(_abstract_calendar_renderer__WEBPACK_IMPORTED_MODULE_11__["MAbstractCalendarRenderer"]));
/* harmony default export */ __webpack_exports__["default"] = (MBaseCalendar);


/***/ }),

/***/ "./src/components/calendar/calendar-state/calendar-state-machine.ts":
/*!**************************************************************************!*\
  !*** ./src/components/calendar/calendar-state/calendar-state-machine.ts ***!
  \**************************************************************************/
/*! exports provided: CalendarMode, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarMode", function() { return CalendarMode; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _state_calendar_range_date_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./state/calendar-range-date-state */ "./src/components/calendar/calendar-state/state/calendar-range-date-state.ts");
/* harmony import */ var _state_calendar_single_date_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./state/calendar-single-date-state */ "./src/components/calendar/calendar-state/state/calendar-single-date-state.ts");






var CalendarMode;
(function (CalendarMode) {
    CalendarMode["SINGLE_DATE"] = "single-date";
    CalendarMode["DATE_RANGE"] = "date-range";
})(CalendarMode || (CalendarMode = {}));
var MCalendarStateMachine = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCalendarStateMachine, _super);
    function MCalendarStateMachine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendarState = {};
        return _this;
    }
    MCalendarStateMachine.prototype.refreshValue = function () {
        this.calendarState.updateState(this.value, this.minDate, this.maxDate);
    };
    MCalendarStateMachine.prototype.created = function () {
        switch (this.mode) {
            case CalendarMode.SINGLE_DATE:
                this.calendarState = new _state_calendar_single_date_state__WEBPACK_IMPORTED_MODULE_5__["default"](this.value, this.minDate, this.maxDate);
                break;
            case CalendarMode.DATE_RANGE:
                this.calendarState = new _state_calendar_range_date_state__WEBPACK_IMPORTED_MODULE_4__["default"](this.value, this.minDate, this.maxDate);
        }
        this.calendarState.onDateSelect(this.dateSelectCallBack);
    };
    MCalendarStateMachine.prototype.render = function () {
        if (this.$scopedSlots) {
            return this.$scopedSlots.default(this.calendarState.buildCurrentCalendar());
        }
    };
    MCalendarStateMachine.prototype.onInput = function (value) {
        this.calendarState.updateState(value, this.minDate, this.maxDate);
    };
    MCalendarStateMachine.prototype.dateSelectCallBack = function (date) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '' })
    ], MCalendarStateMachine.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: CalendarMode.SINGLE_DATE })
    ], MCalendarStateMachine.prototype, "mode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MCalendarStateMachine.prototype, "minDate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MCalendarStateMachine.prototype, "maxDate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('minDate'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('maxDate')
    ], MCalendarStateMachine.prototype, "refreshValue", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], MCalendarStateMachine.prototype, "dateSelectCallBack", null);
    MCalendarStateMachine = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MCalendarStateMachine);
    return MCalendarStateMachine;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));
/* harmony default export */ __webpack_exports__["default"] = (MCalendarStateMachine);


/***/ }),

/***/ "./src/components/calendar/calendar-state/state/abstract-calendar-state.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/calendar/calendar-state/state/abstract-calendar-state.ts ***!
  \*********************************************************************************/
/*! exports provided: MAX_DATE_OFFSET, MIN_DATE_OFFSET, FIRST_MONTH_INDEX, LAST_MONTH_INDEX, LAST_DAY_OF_WEEK_INDEX, FIRST_DAY_OF_MONTH_INDEX, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_DATE_OFFSET", function() { return MAX_DATE_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIN_DATE_OFFSET", function() { return MIN_DATE_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_MONTH_INDEX", function() { return FIRST_MONTH_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_MONTH_INDEX", function() { return LAST_MONTH_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_DAY_OF_WEEK_INDEX", function() { return LAST_DAY_OF_WEEK_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_DAY_OF_MONTH_INDEX", function() { return FIRST_DAY_OF_MONTH_INDEX; });
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../../../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _calendar_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./calendar-state */ "./src/components/calendar/calendar-state/state/calendar-state.ts");


var MAX_DATE_OFFSET = 10;
var MIN_DATE_OFFSET = 10;
var FIRST_MONTH_INDEX = 0;
var LAST_MONTH_INDEX = 11;
var LAST_DAY_OF_WEEK_INDEX = 6;
var FIRST_DAY_OF_MONTH_INDEX = 1;
var AbstractCalendarState = /** @class */ (function () {
    function AbstractCalendarState(value, minDate, maxDate) {
        this.now = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"]();
        this.currentlyDisplayedDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"]();
        this.calendar = {
            dates: { min: new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](), current: new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](), max: new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"]() },
            years: [],
            months: [],
            yearsMonths: [],
            days: []
        };
        this.initDates(value, minDate, maxDate);
    }
    AbstractCalendarState.prototype.buildCurrentCalendar = function () {
        return {
            calendar: this.assembleCalendar(),
            calendarEvents: this.assembleCalendarEvents()
        };
    };
    AbstractCalendarState.prototype.onDateSelect = function (callback) {
        this.daySelectCallback = callback;
    };
    AbstractCalendarState.prototype.emitUpdate = function (data) {
        if (this.daySelectCallback) {
            this.daySelectCallback(data);
        }
    };
    /**
     * Updates the date used to display the calendar. If it's lower than the minimum date authorized, it's set to the minimum.
     * If it's higher than the maximum date authorized, it's set to the maximum
     *
     * @param year new value
     * @param month new value
     * @param day new value
     */
    AbstractCalendarState.prototype.updateCurrentlyDisplayedDate = function (year, month, day) {
        this.currentlyDisplayedDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](year, month, day);
        if (this.currentlyDisplayedDate.isAfter(this.currentMaxDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].DAY)) {
            this.currentlyDisplayedDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](this.currentMaxDate);
        }
        if (this.currentlyDisplayedDate.isBefore(this.currentMinDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].DAY)) {
            this.currentlyDisplayedDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](this.currentMinDate);
        }
    };
    AbstractCalendarState.prototype.selectDay = function (selectedDay) {
        this.lastSelectedDate = this.selectedDayToDate(selectedDay);
    };
    AbstractCalendarState.prototype.nextMonth = function () {
        this.updateCurrentlyDisplayedDate(this.currentlyDisplayedYear(), this.currentlyDisplayedMonth() + 1, FIRST_DAY_OF_MONTH_INDEX);
    };
    AbstractCalendarState.prototype.previousMonth = function () {
        this.updateCurrentlyDisplayedDate(this.currentlyDisplayedYear(), this.currentlyDisplayedMonth() - 1, FIRST_DAY_OF_MONTH_INDEX);
    };
    AbstractCalendarState.prototype.nextYear = function () {
        this.updateCurrentlyDisplayedDate(this.currentlyDisplayedYear() + 1, this.currentlyDisplayedMonth(), this.currentlyDisplayedDay());
    };
    AbstractCalendarState.prototype.previousYear = function () {
        this.updateCurrentlyDisplayedDate(this.currentlyDisplayedYear() - 1, this.currentlyDisplayedMonth(), this.currentlyDisplayedDay());
    };
    AbstractCalendarState.prototype.selectYear = function (year) {
        this.updateCurrentlyDisplayedDate(year.year, this.currentlyDisplayedMonth(), this.currentlyDisplayedDay());
    };
    AbstractCalendarState.prototype.selectYearMonth = function (year, month) {
        this.updateCurrentlyDisplayedDate(year.year, month.month, this.currentlyDisplayedDay());
    };
    AbstractCalendarState.prototype.selectMonth = function (month) {
        this.updateCurrentlyDisplayedDate(this.currentlyDisplayedYear(), month.month, FIRST_DAY_OF_MONTH_INDEX);
    };
    AbstractCalendarState.prototype.initDates = function (value, minDate, maxDate) {
        this.initCurrentValue(value);
        this.initMinDate(minDate);
        this.initMaxDate(maxDate);
        this.initCurrentlyDisplayedDate();
    };
    AbstractCalendarState.prototype.assembleCalendar = function () {
        this.calendar.value = this.assembleValue();
        this.calendar.dates = {
            min: this.currentMinDate,
            current: this.currentlyDisplayedDate,
            max: this.currentMaxDate
        };
        this.calendar.years = this.years();
        this.calendar.months = this.months();
        this.calendar.days = this.daysOfMonth();
        this.calendar.type = this.calendarType();
        this.calendar.yearsMonths = this.yearsMonths();
        return this.calendar;
    };
    AbstractCalendarState.prototype.assembleCalendarEvents = function () {
        var _a;
        if (!this.events) {
            this.events = (_a = {},
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].DAY_SELECT] = this.selectDay.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].DAY_MOUSE_ENTER] = function () { },
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].DAY_MOUSE_LEAVE] = function () { },
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].DAY_KEYBOARD_TAB] = function () { },
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].MONTH_SELECT] = this.selectMonth.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].MONTH_PREVIOUS] = this.previousMonth.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].MONTH_NEXT] = this.nextMonth.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].YEAR_SELECT] = this.selectYear.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].YEAR_MONTH_SELECT] = this.selectYearMonth.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].YEAR_PREVIOUS] = this.previousYear.bind(this),
                _a[_calendar_state__WEBPACK_IMPORTED_MODULE_1__["CalendarEvent"].YEAR_NEXT] = this.nextYear.bind(this),
                _a);
            this.events = this.overrideCalendarEvents(this.events);
        }
        return this.events;
    };
    AbstractCalendarState.prototype.overrideCalendarEvents = function (events) {
        return events;
    };
    AbstractCalendarState.prototype.selectedDayToDate = function (selectedDay) {
        return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](selectedDay.year, selectedDay.month, selectedDay.day);
    };
    AbstractCalendarState.prototype.isDayDisabled = function (date) {
        return !date.isBetween(this.currentMinDate, this.currentMaxDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].DAY);
    };
    AbstractCalendarState.prototype.isDayToday = function (date) {
        return date.isSame(this.now, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].DAY);
    };
    AbstractCalendarState.prototype.isInPreviousMonth = function (date) {
        return date.isBefore(this.currentlyDisplayedDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].MONTH);
    };
    AbstractCalendarState.prototype.isInNextMonth = function (date) {
        return date.isAfter(this.currentlyDisplayedDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].MONTH);
    };
    AbstractCalendarState.prototype.isDaySelected = function (_date) {
        return false;
    };
    AbstractCalendarState.prototype.isHighlighted = function (_date) {
        return false;
    };
    AbstractCalendarState.prototype.isSelectionStart = function (_date) {
        return false;
    };
    AbstractCalendarState.prototype.isSelectionEnd = function (_date) {
        return false;
    };
    AbstractCalendarState.prototype.hasFocus = function (date) {
        return !!this.lastSelectedDate && date.isSame(this.lastSelectedDate);
    };
    AbstractCalendarState.prototype.currentlyDisplayedYear = function () {
        return this.currentlyDisplayedDate.fullYear();
    };
    AbstractCalendarState.prototype.currentlyDisplayedMonth = function () {
        return this.currentlyDisplayedDate.month();
    };
    AbstractCalendarState.prototype.currentlyDisplayedDay = function () {
        return this.currentlyDisplayedDate.day();
    };
    AbstractCalendarState.prototype.years = function () {
        var years = [];
        for (var year = this.currentMinDate.fullYear(); year <= this.currentMaxDate.fullYear(); year++) {
            years.push({ year: year, isCurrent: this.currentlyDisplayedYear() === year });
        }
        return years;
    };
    AbstractCalendarState.prototype.months = function () {
        var months = [];
        var date;
        for (var index = FIRST_MONTH_INDEX; index <= LAST_MONTH_INDEX; index++) {
            date = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](this.currentlyDisplayedDate.fullYear(), index, 1);
            months.push({
                month: index,
                isCurrent: this.currentlyDisplayedMonth() === index,
                isDisabled: !date.isBetween(this.currentMinDate, this.currentMaxDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].MONTH)
            });
        }
        return months;
    };
    AbstractCalendarState.prototype.yearsMonths = function () {
        var yearsMonths = [];
        for (var year = this.currentMinDate.fullYear(); year <= this.currentMaxDate.fullYear(); year++) {
            var months = [];
            var date = void 0;
            var isYearsCurrent = this.currentlyDisplayedDate.fullYear() === year;
            var isYearMinOrMax = (year === this.currentMinDate.fullYear()) || (year === this.currentMaxDate.fullYear());
            for (var monthIndex = FIRST_MONTH_INDEX; monthIndex <= LAST_MONTH_INDEX; monthIndex++) {
                date = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](year, monthIndex, 1);
                months.push({
                    month: monthIndex,
                    isCurrent: isYearsCurrent && (this.currentlyDisplayedMonth() === monthIndex),
                    isDisabled: isYearMinOrMax && !date.isBetween(this.currentMinDate, this.currentMaxDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["DatePrecision"].MONTH)
                });
            }
            yearsMonths.push({
                year: { year: year, isCurrent: this.currentlyDisplayedYear() === year },
                months: months
            });
        }
        return yearsMonths;
    };
    AbstractCalendarState.prototype.daysOfMonth = function () {
        return this.buildDaysList();
    };
    AbstractCalendarState.prototype.initMaxDate = function (maxDate) {
        if (this.currentMaxDate && this.currentMaxDate.isSame(new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](maxDate))) {
            return;
        }
        if (maxDate) {
            this.currentMaxDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](maxDate);
        }
        else {
            this.currentMaxDate = this.calculateYearOffset(this.now, MAX_DATE_OFFSET);
        }
    };
    AbstractCalendarState.prototype.initMinDate = function (minDate) {
        if (this.currentMinDate && this.currentMinDate.isSame(new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](minDate))) {
            return;
        }
        if (minDate) {
            this.currentMinDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](minDate);
        }
        else {
            this.currentMinDate = this.calculateYearOffset(this.now, MIN_DATE_OFFSET * -1);
        }
    };
    AbstractCalendarState.prototype.buildDaysList = function () {
        var startDate = this.calculateStartDate(this.currentlyDisplayedDate);
        var endDate = this.calculateEndDate(this.currentlyDisplayedDate);
        var numberOfDays = startDate.deltaInDays(endDate);
        var days = [];
        var date;
        for (var index = 0; index <= numberOfDays; index++) {
            date = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](startDate.fullYear(), startDate.month(), startDate.day() + index);
            days.push({
                date: date,
                day: date.day(),
                month: date.month(),
                year: date.fullYear(),
                isDisabled: this.isDayDisabled(date),
                isToday: this.isDayToday(date),
                isSelected: this.isDaySelected(date),
                isSelectionStart: this.isSelectionStart(date),
                isSelectionEnd: this.isSelectionEnd(date),
                isInPreviousMonth: this.isInPreviousMonth(date),
                isInNextMonth: this.isInNextMonth(date),
                isHighlighted: this.isHighlighted(date),
                hasFocus: this.hasFocus(date)
            });
        }
        return days;
    };
    AbstractCalendarState.prototype.calculateStartDate = function (date) {
        var startOffset = this.weekdayIndexOfFirstDayOfMonth(date);
        return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](date.fullYear(), date.month(), 1 - startOffset);
    };
    AbstractCalendarState.prototype.calculateEndDate = function (date) {
        var endOffset = LAST_DAY_OF_WEEK_INDEX - this.weekdayIndexOfLastDayOfMonth(date);
        return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](date.fullYear(), date.month(), this.daysInMonth(date) + endOffset);
    };
    AbstractCalendarState.prototype.weekdayIndexOfFirstDayOfMonth = function (date) {
        var dateFirstOfMonth = new Date(date.fullYear(), date.month(), 1);
        return dateFirstOfMonth.getDay();
    };
    AbstractCalendarState.prototype.weekdayIndexOfLastDayOfMonth = function (date) {
        var dateLastOfMonth = new Date(date.fullYear(), date.month() + 1, 0);
        return dateLastOfMonth.getDay();
    };
    AbstractCalendarState.prototype.daysInMonth = function (date) {
        var dateLastOfMonth = new Date(date.fullYear(), date.month() + 1, 0);
        return dateLastOfMonth.getDate();
    };
    AbstractCalendarState.prototype.calculateYearOffset = function (date, offset) {
        return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_0__["default"](date.fullYear() + (offset), date.month(), date.day());
    };
    return AbstractCalendarState;
}());
/* harmony default export */ __webpack_exports__["default"] = (AbstractCalendarState);


/***/ }),

/***/ "./src/components/calendar/calendar-state/state/calendar-range-date-state.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/calendar/calendar-state/state/calendar-range-date-state.ts ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _abstract_calendar_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./abstract-calendar-state */ "./src/components/calendar/calendar-state/state/abstract-calendar-state.ts");
/* harmony import */ var _calendar_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./calendar-state */ "./src/components/calendar/calendar-state/state/calendar-state.ts");




var DateRangePosition;
(function (DateRangePosition) {
    DateRangePosition["BEGIN"] = "begin";
    DateRangePosition["END"] = "end";
})(DateRangePosition || (DateRangePosition = {}));
var CalendarRangeDateState = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CalendarRangeDateState, _super);
    function CalendarRangeDateState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentDateHiglighted = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"]();
        return _this;
    }
    CalendarRangeDateState.prototype.updateState = function (value, minDate, maxDate) {
        this.initDates(value, minDate, maxDate);
    };
    CalendarRangeDateState.prototype.assembleValue = function () {
        return {
            begin: this.currentRange.begin ? this.currentRange.begin.toString() : '',
            end: this.currentRange.end ? this.currentRange.end.toString() : ''
        };
    };
    CalendarRangeDateState.prototype.selectDay = function (selectedDay) {
        _super.prototype.selectDay.call(this, selectedDay);
        if (!selectedDay.isDisabled) {
            var newDate = this.selectedDayToDate(selectedDay);
            this.currentRange = this.updateRangeModel(this.currentRange, newDate);
            this.currentRange = this.reOrderRangeDates(this.currentRange);
            this.updateCurrentlyDisplayedDate(newDate.fullYear(), newDate.month(), newDate.day());
            this.emitUpdate(this.assembleValue());
        }
    };
    CalendarRangeDateState.prototype.highlightDate = function (selectedDay) {
        this.currentDateHiglighted = this.selectedDayToDate(selectedDay);
    };
    CalendarRangeDateState.prototype.overrideCalendarEvents = function (events) {
        events[_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_MOUSE_ENTER] = this.highlightDate.bind(this);
        events[_calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarEvent"].DAY_KEYBOARD_TAB] = this.highlightDate.bind(this);
        return events;
    };
    CalendarRangeDateState.prototype.initCurrentValue = function (value) {
        var rangeCache = Object.assign({}, this.currentRange);
        if (value) {
            this.currentRange = {
                begin: this.initDateRange(value, DateRangePosition.BEGIN),
                end: this.initDateRange(value, DateRangePosition.END)
            };
            if (this.currentRange.begin) {
                this.currentDateHiglighted = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"](this.currentRange.begin);
            }
            else if (this.currentRange.end) {
                this.currentDateHiglighted = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"](this.currentRange.end);
            }
        }
        else {
            this.currentRange = { begin: undefined, end: undefined };
        }
    };
    CalendarRangeDateState.prototype.initCurrentlyDisplayedDate = function () {
        if (this.currentRange.begin) {
            this.updateCurrentlyDisplayedDate(this.currentRange.begin.fullYear(), this.currentRange.begin.month(), this.currentRange.begin.day());
        }
        else if (this.currentRange.end) {
            this.updateCurrentlyDisplayedDate(this.currentRange.end.fullYear(), this.currentRange.end.month(), this.currentRange.end.day());
        }
        else {
            this.updateCurrentlyDisplayedDate(this.now.fullYear(), this.now.month(), this.now.day());
        }
    };
    CalendarRangeDateState.prototype.isDaySelected = function (date) {
        return (!!this.currentRange.begin && date.isSame(this.currentRange.begin, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY))
            || (!!this.currentRange.end && date.isSame(this.currentRange.end, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY));
    };
    CalendarRangeDateState.prototype.isHighlighted = function (date) {
        return ((!!this.currentRange.begin && !this.currentRange.end) && this.betweenBeginAndHightlight(date))
            || ((!!this.currentRange.begin && !!this.currentRange.end) && date.isBetween(this.currentRange.begin, this.currentRange.end, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY));
    };
    CalendarRangeDateState.prototype.isSelectionStart = function (date) {
        return (!!this.currentRange.begin && date.isSame(this.currentRange.begin, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY));
    };
    CalendarRangeDateState.prototype.isSelectionEnd = function (date) {
        return (!!this.currentRange.end && date.isSame(this.currentRange.end, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY));
    };
    CalendarRangeDateState.prototype.calendarType = function () {
        return _calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarType"].DATE_RANGE;
    };
    CalendarRangeDateState.prototype.betweenBeginAndHightlight = function (date) {
        if (this.currentRange.begin) {
            if (this.currentDateHiglighted.isBefore(this.currentRange.begin)) {
                return date.isBetween(this.currentDateHiglighted, this.currentRange.begin, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY);
            }
            else {
                return date.isBetween(this.currentRange.begin, this.currentDateHiglighted, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY);
            }
        }
        return false;
    };
    CalendarRangeDateState.prototype.initDateRange = function (dates, position) {
        return (dates[position]) ? new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"](dates[position]) : undefined;
    };
    CalendarRangeDateState.prototype.updateRangeModel = function (range, date) {
        if (range.end) {
            range.end = undefined;
            range.begin = date;
        }
        else if (range.begin) {
            range.end = date;
        }
        else {
            range.begin = date;
        }
        return range;
    };
    CalendarRangeDateState.prototype.reOrderRangeDates = function (range) {
        if (range.begin
            && range.end
            && range.end.isBefore(range.begin, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY)) {
            range.end = [range.begin, range.begin = range.end][0];
        }
        return range;
    };
    return CalendarRangeDateState;
}(_abstract_calendar_state__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CalendarRangeDateState);


/***/ }),

/***/ "./src/components/calendar/calendar-state/state/calendar-single-date-state.ts":
/*!************************************************************************************!*\
  !*** ./src/components/calendar/calendar-state/state/calendar-single-date-state.ts ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _abstract_calendar_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./abstract-calendar-state */ "./src/components/calendar/calendar-state/state/abstract-calendar-state.ts");
/* harmony import */ var _calendar_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./calendar-state */ "./src/components/calendar/calendar-state/state/calendar-state.ts");




var CalendarSingleDateState = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CalendarSingleDateState, _super);
    function CalendarSingleDateState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarSingleDateState.prototype.updateState = function (value, minDate, maxDate) {
        this.initDates(value, minDate, maxDate);
    };
    CalendarSingleDateState.prototype.assembleValue = function () {
        return this.currentDate ? this.currentDate.toString() : '';
    };
    CalendarSingleDateState.prototype.selectYearMonth = function (year, month) {
        this.currentDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"](year.year, month.month, 1);
        this.emitUpdate(this.assembleValue());
        _super.prototype.selectYearMonth.call(this, year, month);
    };
    CalendarSingleDateState.prototype.selectDay = function (selectedDay) {
        _super.prototype.selectDay.call(this, selectedDay);
        if (!selectedDay.isDisabled) {
            var newDate = this.selectedDayToDate(selectedDay);
            this.currentDate = newDate;
            this.updateCurrentlyDisplayedDate(newDate.fullYear(), newDate.month(), newDate.day());
            this.emitUpdate(this.assembleValue());
        }
    };
    CalendarSingleDateState.prototype.initCurrentValue = function (value) {
        if (value) {
            this.currentDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["default"](value);
        }
        else {
            this.currentDate = undefined;
        }
    };
    CalendarSingleDateState.prototype.initCurrentlyDisplayedDate = function () {
        if (this.currentDate) {
            this.updateCurrentlyDisplayedDate(this.currentDate.fullYear(), this.currentDate.month(), this.currentDate.day());
        }
        else {
            this.updateCurrentlyDisplayedDate(this.now.fullYear(), this.now.month(), this.now.day());
        }
    };
    CalendarSingleDateState.prototype.isDaySelected = function (date) {
        return !!this.currentDate && date.isSame(this.currentDate, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_1__["DatePrecision"].DAY);
    };
    CalendarSingleDateState.prototype.isSelectionStart = function (date) {
        return this.isDaySelected(date);
    };
    CalendarSingleDateState.prototype.isSelectionEnd = function (date) {
        return this.isDaySelected(date);
    };
    CalendarSingleDateState.prototype.calendarType = function () {
        return _calendar_state__WEBPACK_IMPORTED_MODULE_3__["CalendarType"].SINGLE_DATE;
    };
    return CalendarSingleDateState;
}(_abstract_calendar_state__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CalendarSingleDateState);


/***/ }),

/***/ "./src/components/calendar/calendar-state/state/calendar-state.ts":
/*!************************************************************************!*\
  !*** ./src/components/calendar/calendar-state/state/calendar-state.ts ***!
  \************************************************************************/
/*! exports provided: CalendarEvent, CalendarType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarEvent", function() { return CalendarEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarType", function() { return CalendarType; });
var CalendarEvent;
(function (CalendarEvent) {
    CalendarEvent["DAY_SELECT"] = "day-select";
    CalendarEvent["DAY_MOUSE_ENTER"] = "day-mouse-enter";
    CalendarEvent["DAY_MOUSE_LEAVE"] = "day-mouse-leave";
    CalendarEvent["DAY_KEYBOARD_TAB"] = "day-keyboard-tab";
    CalendarEvent["MONTH_SELECT"] = "month-select";
    CalendarEvent["MONTH_NEXT"] = "month-next";
    CalendarEvent["MONTH_PREVIOUS"] = "month-previous";
    CalendarEvent["YEAR_SELECT"] = "year-select";
    CalendarEvent["YEAR_NEXT"] = "year-next";
    CalendarEvent["YEAR_PREVIOUS"] = "year-previous";
    CalendarEvent["YEAR_MONTH_SELECT"] = "year-month-select";
})(CalendarEvent || (CalendarEvent = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["SINGLE_DATE"] = "single-date";
    CalendarType["DATE_RANGE"] = "date-range";
})(CalendarType || (CalendarType = {}));


/***/ }),

/***/ "./src/components/calendar/calendar.html?style=./calendar.scss":
/*!*********************************************************************!*\
  !*** ./src/components/calendar/calendar.html?style=./calendar.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3b9a4e69!./calendar.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3b9a4e69!./src/components/calendar/calendar.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-calendar",
      class: {
        "m-calendar-single-date": _vm.isSingleDate,
        "m-calendar-date-range": _vm.isDateRange
      },
      attrs: { id: _vm.id }
    },
    [
      _c("m-calendar-state-machine", {
        ref: "calendarState",
        attrs: {
          mode: _vm.mode,
          "min-date": _vm.minDate,
          "max-date": _vm.maxDate
        },
        on: { input: _vm.onInput },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var calendar = ref.calendar
              var calendarEvents = ref.calendarEvents
              return _c(
                "m-base-calendar",
                _vm._g(
                  {
                    ref: "calendarRenderer",
                    staticClass: "m-calendar__renderer",
                    attrs: {
                      calendar: calendar,
                      type: _vm.type,
                      visible: _vm.visible,
                      "initial-view": _vm.initialView,
                      "show-month-before-after": _vm.showMonthBeforeAfter
                    }
                  },
                  calendarEvents
                )
              )
            }
          }
        ]),
        model: {
          value: _vm.innerValue,
          callback: function($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-3b9a4e69'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/calendar/calendar.ts":
/*!*********************************************!*\
  !*** ./src/components/calendar/calendar.ts ***!
  \*********************************************/
/*! exports provided: CalendarMode, MCalendarType, MCalendar, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarMode", function() { return CalendarMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCalendarType", function() { return MCalendarType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCalendar", function() { return MCalendar; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./calendar-renderer/base-calendar/base-calendar */ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.ts");
/* harmony import */ var _calendar_state_calendar_state_machine__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./calendar-state/calendar-state-machine */ "./src/components/calendar/calendar-state/calendar-state-machine.ts");
/* harmony import */ var _calendar_html_style_calendar_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./calendar.html?style=./calendar.scss */ "./src/components/calendar/calendar.html?style=./calendar.scss");
/* harmony import */ var _calendar_html_style_calendar_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_calendar_html_style_calendar_scss__WEBPACK_IMPORTED_MODULE_8__);









var CalendarMode;
(function (CalendarMode) {
    CalendarMode["SINGLE_DATE"] = "single-date";
    CalendarMode["DATE_RANGE"] = "date-range";
})(CalendarMode || (CalendarMode = {}));
var MCalendarType;
(function (MCalendarType) {
    MCalendarType["FullDate"] = "full-date";
    MCalendarType["YearsMonths"] = "years-months";
})(MCalendarType || (MCalendarType = {}));
var MCalendar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCalendar, _super);
    function MCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerValue = _this.value;
        _this.id = "m-calendar-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate();
        return _this;
    }
    MCalendar.prototype.refreshValue = function () {
        this.validateInputModel();
        this.innerValue = this.value;
    };
    MCalendar.prototype.created = function () {
        this.validateInputModel();
    };
    MCalendar.prototype.onInput = function () {
        return this.innerValue;
    };
    Object.defineProperty(MCalendar.prototype, "isSingleDate", {
        get: function () {
            return this.mode === CalendarMode.SINGLE_DATE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MCalendar.prototype, "isDateRange", {
        get: function () {
            return this.mode === CalendarMode.DATE_RANGE;
        },
        enumerable: true,
        configurable: true
    });
    MCalendar.prototype.validateInputModel = function () {
        switch (this.mode) {
            case CalendarMode.SINGLE_DATE:
                if (typeof this.value !== 'string') {
                    throw new Error("In '" + CalendarMode.SINGLE_DATE + "' mode, the model type should be a 'string'");
                }
                break;
            case CalendarMode.DATE_RANGE:
                if (typeof this.value !== 'object') {
                    throw new Error("In '" + CalendarMode.DATE_RANGE + "' mode, the model type should be an 'object'");
                }
                break;
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: '' })
    ], MCalendar.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: CalendarMode.SINGLE_DATE })
    ], MCalendar.prototype, "mode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: _calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__["MBaseCalendarType"].FULL_DATE,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__["MBaseCalendarType"]).includes(value); }
        })
    ], MCalendar.prototype, "type", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MCalendar.prototype, "minDate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MCalendar.prototype, "maxDate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MCalendar.prototype, "showMonthBeforeAfter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MCalendar.prototype, "visible", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: _calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__["MBaseCalendarView"].DAYS,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__["MBaseCalendarView"]).includes(value); }
        })
    ], MCalendar.prototype, "initialView", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('value')
    ], MCalendar.prototype, "refreshValue", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('input')
    ], MCalendar.prototype, "onInput", null);
    MCalendar = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _calendar_html_style_calendar_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: {
                MCalendarStateMachine: _calendar_state_calendar_state_machine__WEBPACK_IMPORTED_MODULE_7__["default"],
                MBaseCalendar: _calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_6__["default"]
            }
        })
    ], MCalendar);
    return MCalendar;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var CalendarPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["CALENDAR_NAME"], MCalendar);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CalendarPlugin);


/***/ }),

/***/ "./src/components/carousel/carousel-item/carousel-item.html?style=./carousel-item.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/carousel/carousel-item/carousel-item.html?style=./carousel-item.scss ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=250a5c50!./carousel-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=250a5c50!./src/components/carousel/carousel-item/carousel-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-carousel-item",
      class: { "m--no-animation": _vm.animNotReady },
      style: {
        transform: _vm.translate,
        left: _vm.margin + "px",
        right: _vm.margin + "px"
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-250a5c50'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/carousel/carousel-item/carousel-item.ts":
/*!****************************************************************!*\
  !*** ./src/components/carousel/carousel-item/carousel-item.ts ***!
  \****************************************************************/
/*! exports provided: MCarouselItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCarouselItem", function() { return MCarouselItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _carousel_item_html_style_carousel_item_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./carousel-item.html?style=./carousel-item.scss */ "./src/components/carousel/carousel-item/carousel-item.html?style=./carousel-item.scss");
/* harmony import */ var _carousel_item_html_style_carousel_item_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_carousel_item_html_style_carousel_item_scss__WEBPACK_IMPORTED_MODULE_3__);




var MCarouselItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCarouselItem, _super);
    function MCarouselItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isVisible = false;
        _this.position = 0;
        _this.margin = 0;
        _this.animNotReady = true;
        return _this;
    }
    MCarouselItem.prototype.beforeEnter = function () {
        this.$emit('animationStart');
    };
    MCarouselItem.prototype.afterLeave = function () {
        this.$emit('animationDone');
    };
    Object.defineProperty(MCarouselItem.prototype, "translate", {
        get: function () {
            if (this.position === 0) {
                return 'translate(0)';
            }
            else {
                return "translate(calc(" + 100 * this.position + "% + " + (this.margin / 2) * this.position + "px))";
            }
        },
        enumerable: true,
        configurable: true
    });
    MCarouselItem.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.animNotReady = false;
        });
    };
    MCarouselItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _carousel_item_html_style_carousel_item_scss__WEBPACK_IMPORTED_MODULE_3___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MCarouselItem);
    return MCarouselItem;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));



/***/ }),

/***/ "./src/components/carousel/carousel.html?style=./carousel.scss":
/*!*********************************************************************!*\
  !*** ./src/components/carousel/carousel.html?style=./carousel.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2cc87029!./carousel.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2cc87029!./src/components/carousel/carousel.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-touch",
    {
      staticClass: "m-carousel",
      attrs: { "swipe-options": { direction: "horizontal" }, tag: "ul" },
      on: {
        tap: _vm.onTap,
        click: _vm.onClick,
        swipeleft: _vm.showNextItem,
        swiperight: _vm.showPrevItem
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-2cc87029'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/carousel/carousel.ts":
/*!*********************************************!*\
  !*** ./src/components/carousel/carousel.ts ***!
  \*********************************************/
/*! exports provided: MCarousel, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCarousel", function() { return MCarousel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _touch_touch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../touch/touch */ "./src/components/touch/touch.ts");
/* harmony import */ var _carousel_item_carousel_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./carousel-item/carousel-item */ "./src/components/carousel/carousel-item/carousel-item.ts");
/* harmony import */ var _carousel_html_style_carousel_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./carousel.html?style=./carousel.scss */ "./src/components/carousel/carousel.html?style=./carousel.scss");
/* harmony import */ var _carousel_html_style_carousel_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_carousel_html_style_carousel_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MCarousel = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCarousel, _super);
    function MCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.items = [];
        _this.internalIndex = 0;
        return _this;
    }
    MCarousel.prototype.onTap = function (event) {
        this.$emit('tap', event);
    };
    MCarousel.prototype.onClick = function (event) {
        this.$emit('click', event);
    };
    MCarousel.prototype.mounted = function () {
        var _this = this;
        this.toggleKeyboardNavigation(this.keyboardNavigable);
        if (this.interval) {
            this.updateInterval = setInterval(function () {
                _this.showNextItem();
            }, this.interval);
        }
        this.initialize();
    };
    MCarousel.prototype.updated = function () {
        this.initialize();
    };
    MCarousel.prototype.beforeDestroy = function () {
        this.toggleKeyboardNavigation(false);
        clearInterval(this.updateInterval);
    };
    MCarousel.prototype.initialize = function () {
        var _this = this;
        if (this.isIndexValid(this.propIndex) || this.propIndex === 0 && this.items.length === 0) {
            this.internalIndex = this.propIndex;
            var items_1 = [];
            if (this.$slots.default) {
                var index_1 = 0;
                this.$slots.default.forEach(function (item) {
                    if (item.componentInstance instanceof _carousel_item_carousel_item__WEBPACK_IMPORTED_MODULE_6__["MCarouselItem"]) {
                        item.componentInstance.position = index_1 - _this.internalIndex;
                        item.componentInstance.margin = _this.margin;
                        item.componentInstance.$slots.default.forEach(function (content) {
                            var el = content.componentInstance && content.componentInstance.$el || content.elm;
                            if (el instanceof HTMLElement && (el.tagName === 'IMG' || el.tagName === 'PICTURE')) {
                                el.style.maxWidth = '100%';
                                el.style.maxHeight = '100%';
                            }
                        });
                        items_1.push(item.componentInstance);
                        index_1++;
                    }
                });
                this.items = items_1.length > 0 ? items_1 : this.items;
            }
        }
    };
    MCarousel.prototype.toggleKeyboardNavigation = function (value) {
        document.removeEventListener('keyup', this.changeItem);
        if (value) {
            document.addEventListener('keyup', this.changeItem);
        }
    };
    MCarousel.prototype.changeItem = function (e) {
        if (e.keyCode === 37) {
            this.showPrevItem();
        }
        else if (e.keyCode === 39) {
            this.showNextItem();
        }
    };
    Object.defineProperty(MCarousel.prototype, "propIndex", {
        get: function () {
            if (this.index !== undefined) {
                return this.index;
            }
            return this.internalIndex;
        },
        set: function (value) {
            if (value !== this.propIndex && this.isIndexValid(value)) {
                this.items.forEach(function (item, index) {
                    item.position = index - value;
                });
                this.internalIndex = value;
                this.$emit('update:index', value);
            }
        },
        enumerable: true,
        configurable: true
    });
    MCarousel.prototype.isIndexValid = function (value) {
        return value >= 0 && value < this.numberOfCarouselItems();
    };
    MCarousel.prototype.numberOfCarouselItems = function () {
        var count = 0;
        if (this.$slots.default) {
            this.$slots.default.forEach(function (item) {
                if (item.componentInstance instanceof _carousel_item_carousel_item__WEBPACK_IMPORTED_MODULE_6__["MCarouselItem"]) {
                    count++;
                }
            });
        }
        return count;
    };
    MCarousel.prototype.showPrevItem = function (resetInterval) {
        if (resetInterval === void 0) { resetInterval = false; }
        if (!this.swipeDisabled && this.isIndexValid(this.propIndex - 1)) {
            this.showItem(this.propIndex - 1, resetInterval);
        }
    };
    MCarousel.prototype.showNextItem = function (resetInterval) {
        if (resetInterval === void 0) { resetInterval = false; }
        if (!this.swipeDisabled && this.isIndexValid(this.propIndex + 1)) {
            this.showItem(this.propIndex + 1, resetInterval);
        }
    };
    MCarousel.prototype.showItem = function (index, resetInterval) {
        this.propIndex = index;
        if (resetInterval) {
            this.resetInterval();
        }
    };
    MCarousel.prototype.resetInterval = function () {
        var _this = this;
        if (this.interval) {
            clearInterval(this.updateInterval);
            this.updateInterval = setInterval(function () {
                _this.showNextItem(true);
            }, this.interval);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MCarousel.prototype, "index", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 0 })
    ], MCarousel.prototype, "interval", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MCarousel.prototype, "keyboardNavigable", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 0 })
    ], MCarousel.prototype, "margin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MCarousel.prototype, "swipeDisabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('keyboardNavigable')
    ], MCarousel.prototype, "toggleKeyboardNavigation", null);
    MCarousel = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _carousel_html_style_carousel_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["TOUCH_NAME"]] = _touch_touch__WEBPACK_IMPORTED_MODULE_5__["MTouch"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["CAROUSEL_ITEM_NAME"]] = _carousel_item_carousel_item__WEBPACK_IMPORTED_MODULE_6__["MCarouselItem"],
                _a)
        })
    ], MCarousel);
    return MCarousel;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var CarouselPlugin = {
    install: function (v) {
        v.use(_touch_touch__WEBPACK_IMPORTED_MODULE_5__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["CAROUSEL_ITEM_NAME"], _carousel_item_carousel_item__WEBPACK_IMPORTED_MODULE_6__["MCarouselItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["CAROUSEL_NAME"], MCarousel);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CarouselPlugin);


/***/ }),

/***/ "./src/components/character-count/character-count.html?style=./character-count.scss":
/*!******************************************************************************************!*\
  !*** ./src/components/character-count/character-count.html?style=./character-count.scss ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6a2c3951!./character-count.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6a2c3951!./src/components/character-count/character-count.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-character-count" },
    [
      _c("m-accordion-transition", { attrs: { disabled: !_vm.transition } }, [
        _vm.hasCounter
          ? _c(
              "div",
              {
                staticClass: "m-character-count__wrap",
                attrs: { "aria-hidden": "true" }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.valueLength))]),
                _vm._v("/" + _vm._s(_vm.maxLength))
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-6a2c3951'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/character-count/character-count.ts":
/*!***********************************************************!*\
  !*** ./src/components/character-count/character-count.ts ***!
  \***********************************************************/
/*! exports provided: MCharacterCount, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCharacterCount", function() { return MCharacterCount; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _character_count_html_style_character_count_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./character-count.html?style=./character-count.scss */ "./src/components/character-count/character-count.html?style=./character-count.scss");
/* harmony import */ var _character_count_html_style_character_count_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_character_count_html_style_character_count_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MCharacterCount = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCharacterCount, _super);
    function MCharacterCount() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MCharacterCount.prototype, "hasCounter", {
        get: function () {
            return this.maxLength > 0 && this.valueLength >= Math.max(0, Math.min(this.threshold, this.maxLength));
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MCharacterCount.prototype, "valueLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            required: true, validator: function (value) {
                if (value === undefined) {
                    console.error('character-count component expects prop maxLength to be defined.');
                }
                return value !== undefined;
            }
        })
    ], MCharacterCount.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 0 })
    ], MCharacterCount.prototype, "threshold", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MCharacterCount.prototype, "transition", void 0);
    MCharacterCount = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _character_count_html_style_character_count_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_5__["MAccordionTransition"],
                _a)
        })
    ], MCharacterCount);
    return MCharacterCount;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var CharacterCountPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["CHARACTER_COUNT_NAME"], MCharacterCount);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CharacterCountPlugin);


/***/ }),

/***/ "./src/components/checkbox/checkbox.html?style=./checkbox.scss":
/*!*********************************************************************!*\
  !*** ./src/components/checkbox/checkbox.html?style=./checkbox.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7b2de66e!./checkbox.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7b2de66e!./src/components/checkbox/checkbox.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-checkbox",
      class: {
        "m--is-checkbox-left": _vm.hasCheckboxLeft,
        "m--is-checkbox-right": !_vm.hasCheckboxLeft,
        "m--is-checkbox-top": _vm.isAlignTop,
        "m--is-checked": _vm.propValue,
        "m--is-disabled": _vm.isDisabled,
        "m--is-indeterminate": _vm.propIndeterminate,
        "m--is-readonly": _vm.readonly,
        "m--is-focus": _vm.isFocus,
        "m--has-error": _vm.hasError,
        "m--is-valid": _vm.isValid,
        "m--has-validation-message": _vm.hasValidationMessage
      }
    },
    [
      !_vm.readonly
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.propValue,
                expression: "propValue"
              }
            ],
            ref: "checkbox",
            staticClass: "m-checkbox__hidden",
            attrs: { id: _vm.id, disabled: _vm.isDisabled, type: "checkbox" },
            domProps: {
              indeterminate: _vm.propIndeterminate,
              checked: Array.isArray(_vm.propValue)
                ? _vm._i(_vm.propValue, null) > -1
                : _vm.propValue
            },
            on: {
              click: _vm.onClick,
              focus: function($event) {
                return _vm.setFocus(true)
              },
              blur: function($event) {
                return _vm.setFocus(false)
              },
              change: function($event) {
                var $$a = _vm.propValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.propValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.propValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.propValue = $$c
                }
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.readonly
        ? _c("input", {
            attrs: { id: _vm.id, type: "hidden" },
            domProps: { value: _vm.propValue }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "m-checkbox__wrap",
          attrs: { for: _vm.id, "aria-label": _vm.ariaLabel }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.$slots.default
            ? _c(
                "div",
                { staticClass: "m-checkbox__label" },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("m-validation-message", {
        ref: "validation",
        staticClass: "m-checkbox__message",
        attrs: {
          disabled: _vm.isDisabled,
          error: _vm.hasError,
          "error-message": _vm.errorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "m-checkbox__input", attrs: { "aria-hidden": "true" } },
      [_c("span", { staticClass: "m-checkbox__input__icon" })]
    )
  }
]
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-7b2de66e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/checkbox/checkbox.ts":
/*!*********************************************!*\
  !*** ./src/components/checkbox/checkbox.ts ***!
  \*********************************************/
/*! exports provided: MCheckboxPosition, MCheckboxVerticalAlignement, MCheckbox, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCheckboxPosition", function() { return MCheckboxPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCheckboxVerticalAlignement", function() { return MCheckboxVerticalAlignement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCheckbox", function() { return MCheckbox; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _checkbox_html_style_checkbox_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./checkbox.html?style=./checkbox.scss */ "./src/components/checkbox/checkbox.html?style=./checkbox.scss");
/* harmony import */ var _checkbox_html_style_checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_checkbox_html_style_checkbox_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MCheckboxPosition;
(function (MCheckboxPosition) {
    MCheckboxPosition["Left"] = "left";
    MCheckboxPosition["Right"] = "right";
})(MCheckboxPosition || (MCheckboxPosition = {}));
var MCheckboxVerticalAlignement;
(function (MCheckboxVerticalAlignement) {
    MCheckboxVerticalAlignement["Center"] = "center";
    MCheckboxVerticalAlignement["Top"] = "top";
})(MCheckboxVerticalAlignement || (MCheckboxVerticalAlignement = {}));
var MCheckbox = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MCheckbox, _super);
    function MCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFocus = false;
        _this.internalValue = false;
        return _this;
    }
    MCheckbox.prototype.onChange = function (value) { };
    MCheckbox.prototype.onClick = function (event) {
        // NOTE: this.$refs.checkbox is undefined when using Edge
        if (this.$refs.checkbox) {
            this.$refs.checkbox.blur();
        }
        // NOTE: Edge does not change the checkbox value when indeterminate="true"
        if (this.propIndeterminate) {
            this.propValue = true;
            event.preventDefault();
        }
    };
    MCheckbox.prototype.onValueChange = function (value) {
        this.internalValue = value;
    };
    Object.defineProperty(MCheckbox.prototype, "propValue", {
        get: function () {
            return this.value !== undefined ? this.value : this.internalValue;
        },
        set: function (value) {
            this.onChange(value);
            this.internalValue = value;
        },
        enumerable: true,
        configurable: true
    });
    MCheckbox.prototype.setFocus = function (value) {
        this.isFocus = value;
    };
    Object.defineProperty(MCheckbox.prototype, "propIndeterminate", {
        get: function () {
            return this.indeterminate && !this.propValue;
        },
        set: function (newValue) {
            this.indeterminate = newValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MCheckbox.prototype, "hasCheckboxLeft", {
        get: function () {
            return this.position === MCheckboxPosition.Left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MCheckbox.prototype, "isAlignTop", {
        get: function () {
            return this.verticalAlign === MCheckboxVerticalAlignement.Top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MCheckbox.prototype, "forId", {
        get: function () {
            if (this.as().readonly) {
                return undefined;
            }
            else {
                return this.id;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MCheckbox.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: function () { return "mCheckbox-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate(); }
        })
    ], MCheckbox.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MCheckbox.prototype, "indeterminate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MCheckboxPosition.Left,
            validator: function (value) {
                return value === MCheckboxPosition.Left ||
                    value === MCheckboxPosition.Right;
            }
        })
    ], MCheckbox.prototype, "position", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MCheckboxVerticalAlignement.Center,
            validator: function (value) {
                return value === MCheckboxVerticalAlignement.Center ||
                    value === MCheckboxVerticalAlignement.Top;
            }
        })
    ], MCheckbox.prototype, "verticalAlign", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MCheckbox.prototype, "ariaLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change')
    ], MCheckbox.prototype, "onChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MCheckbox.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value')
    ], MCheckbox.prototype, "onValueChange", null);
    MCheckbox = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _checkbox_html_style_checkbox_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_7__["MValidationMessage"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MCheckbox);
    return MCheckbox;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var CheckboxPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_6__["CHECKBOX_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["CHECKBOX_NAME"], MCheckbox);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (CheckboxPlugin);


/***/ }),

/***/ "./src/components/chip/chip-add/chip-add.html?style=./chip-add.scss":
/*!**************************************************************************!*\
  !*** ./src/components/chip/chip-add/chip-add.html?style=./chip-add.scss ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f77ae324!./chip-add.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f77ae324!./src/components/chip/chip-add/chip-add.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "m-chip-add",
      class: {
        "m--is-disabled": _vm.disabled,
        "m--is-small": _vm.size === "small"
      },
      attrs: { disabled: _vm.disabled, type: "button" },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "div",
        { staticClass: "m-chip-add__body" },
        [
          _c("span", { staticClass: "m-chip-add__hidden-text" }, [
            _vm._v(_vm._s(_vm._f("f-m-i18n")("chip:add")) + " : ")
          ]),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.icon
            ? _c("m-icon", {
                staticClass: "m-chip-add__icon",
                attrs: { size: _vm.iconSize, name: "m-svg__add-circle" }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-f77ae324'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/chip/chip-add/chip-add.ts":
/*!**************************************************!*\
  !*** ./src/components/chip/chip-add/chip-add.ts ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _chip_add_html_style_chip_add_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./chip-add.html?style=./chip-add.scss */ "./src/components/chip/chip-add/chip-add.html?style=./chip-add.scss");
/* harmony import */ var _chip_add_html_style_chip_add_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_chip_add_html_style_chip_add_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a, _b;









var MChipSize;
(function (MChipSize) {
    MChipSize["Small"] = "small";
    MChipSize["Large"] = "large";
})(MChipSize || (MChipSize = {}));
var MChipAdd = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MChipAdd, _super);
    function MChipAdd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MChipAdd.prototype.emitClick = function () { };
    MChipAdd.prototype.emitAdd = function () { };
    Object.defineProperty(MChipAdd.prototype, "iconSize", {
        get: function () {
            return this.size === MChipSize.Small ? '13px' : '20px';
        },
        enumerable: true,
        configurable: true
    });
    MChipAdd.prototype.onClick = function (event) {
        if (this.disabled) {
            return;
        }
        this.emitClick();
        this.emitAdd();
        this.$el.blur();
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MChipAdd.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MChipAdd.prototype, "icon", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MChipSize.Large,
            validator: function (value) {
                return value === MChipSize.Large ||
                    value === MChipSize.Small;
            }
        })
    ], MChipAdd.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MChipAdd.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('add')
    ], MChipAdd.prototype, "emitAdd", null);
    MChipAdd = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _chip_add_html_style_chip_add_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_7__["MIcon"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["i18nFilter"],
                _b)
        })
    ], MChipAdd);
    return MChipAdd;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));
/* harmony default export */ __webpack_exports__["default"] = (MChipAdd);


/***/ }),

/***/ "./src/components/chip/chip-delete/chip-delete.html?style=./chip-delete.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/chip/chip-delete/chip-delete.html?style=./chip-delete.scss ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=67884c58!./chip-delete.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=67884c58!./src/components/chip/chip-delete/chip-delete.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-chip-delete",
      class: {
        "m--is-disabled": _vm.disabled,
        "m--is-small": _vm.size === "small",
        "m--is-hover": _vm.iconHover
      }
    },
    [
      _c("div", { staticClass: "m-chip-delete__body" }, [
        _c(
          "span",
          { staticClass: "m-chip-delete__text", attrs: { id: _vm.textId } },
          [
            _c("span", { staticClass: "m-chip-delete__hidden-text" }, [
              _vm._v(_vm._s(_vm._f("f-m-i18n")("chip:delete")) + " : ")
            ]),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "m-chip-delete__button",
            attrs: {
              "aria-labelledby": _vm.textId,
              disabled: _vm.disabled,
              type: "button"
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onClick($event)
              }
            }
          },
          [
            _c("m-icon", {
              staticClass: "m-chip-delete__icon",
              attrs: { size: _vm.iconSize, name: "m-svg__close-clear" },
              on: { mouseover: _vm.onMouseOver, mouseleave: _vm.onMouseLeave }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-67884c58'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/chip/chip-delete/chip-delete.ts":
/*!********************************************************!*\
  !*** ./src/components/chip/chip-delete/chip-delete.ts ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _chip_delete_html_style_chip_delete_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./chip-delete.html?style=./chip-delete.scss */ "./src/components/chip/chip-delete/chip-delete.html?style=./chip-delete.scss");
/* harmony import */ var _chip_delete_html_style_chip_delete_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_chip_delete_html_style_chip_delete_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a, _b;










var MChipSize;
(function (MChipSize) {
    MChipSize["Small"] = "small";
    MChipSize["Large"] = "large";
})(MChipSize || (MChipSize = {}));
var MChipDelete = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MChipDelete, _super);
    function MChipDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textId = "mChipDeleteText-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__["default"].generate();
        _this.iconHover = false;
        return _this;
    }
    MChipDelete.prototype.emitClick = function () { };
    MChipDelete.prototype.emitDelete = function () { };
    Object.defineProperty(MChipDelete.prototype, "iconSize", {
        get: function () {
            return this.size === MChipSize.Small ? '8px' : '14px';
        },
        enumerable: true,
        configurable: true
    });
    MChipDelete.prototype.onClick = function (event) {
        if (this.disabled) {
            return;
        }
        this.emitClick();
        this.emitDelete();
    };
    MChipDelete.prototype.onMouseOver = function (event) {
        this.iconHover = true;
    };
    MChipDelete.prototype.onMouseLeave = function (event) {
        this.iconHover = false;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MChipDelete.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MChipSize.Large,
            validator: function (value) {
                return value === MChipSize.Large ||
                    value === MChipSize.Small;
            }
        })
    ], MChipDelete.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MChipDelete.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('delete')
    ], MChipDelete.prototype, "emitDelete", null);
    MChipDelete = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _chip_delete_html_style_chip_delete_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_8__["MIcon"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["i18nFilter"],
                _b)
        })
    ], MChipDelete);
    return MChipDelete;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));
/* harmony default export */ __webpack_exports__["default"] = (MChipDelete);


/***/ }),

/***/ "./src/components/chip/chip.html":
/*!***************************************!*\
  !*** ./src/components/chip/chip.html ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { css: false } },
    [
      _vm.isModeAdd
        ? _c(
            "m-chip-add",
            {
              attrs: { disabled: _vm.disabled, size: _vm.size },
              on: { click: _vm.emitClick, add: _vm.emitAdd }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isModeDelete
        ? _c(
            "m-chip-delete",
            {
              attrs: { disabled: _vm.disabled, size: _vm.size },
              on: { click: _vm.emitClick, delete: _vm.emitDelete }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-b23ca7ae'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/chip/chip.ts":
/*!*************************************!*\
  !*** ./src/components/chip/chip.ts ***!
  \*************************************/
/*! exports provided: MChipMode, MChipSize, MChip, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MChipMode", function() { return MChipMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MChipSize", function() { return MChipSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MChip", function() { return MChip; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _chip_add_chip_add__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./chip-add/chip-add */ "./src/components/chip/chip-add/chip-add.ts");
/* harmony import */ var _chip_delete_chip_delete__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./chip-delete/chip-delete */ "./src/components/chip/chip-delete/chip-delete.ts");
/* harmony import */ var _chip_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./chip.html */ "./src/components/chip/chip.html");
/* harmony import */ var _chip_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_chip_html__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MChipMode;
(function (MChipMode) {
    MChipMode["Add"] = "add";
    MChipMode["Delete"] = "delete";
})(MChipMode || (MChipMode = {}));
var MChipSize;
(function (MChipSize) {
    MChipSize["Small"] = "small";
    MChipSize["Large"] = "large";
})(MChipSize || (MChipSize = {}));
var MChip = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MChip, _super);
    function MChip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MChip.prototype.emitClick = function () { };
    MChip.prototype.emitAdd = function () { };
    MChip.prototype.emitDelete = function () { };
    Object.defineProperty(MChip.prototype, "isModeAdd", {
        get: function () {
            return this.mode === MChipMode.Add;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MChip.prototype, "isModeDelete", {
        get: function () {
            return this.mode === MChipMode.Delete;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MChip.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MChipMode.Add,
            validator: function (value) {
                return value === MChipMode.Add ||
                    value === MChipMode.Delete;
            }
        })
    ], MChip.prototype, "mode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MChipSize.Large,
            validator: function (value) {
                return value === MChipSize.Large ||
                    value === MChipSize.Small;
            }
        })
    ], MChip.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MChip.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('add')
    ], MChip.prototype, "emitAdd", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('delete')
    ], MChip.prototype, "emitDelete", null);
    MChip = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _chip_html__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["CHIP_ADD_NAME"]] = _chip_add_chip_add__WEBPACK_IMPORTED_MODULE_5__["default"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["CHIP_DELETE_NAME"]] = _chip_delete_chip_delete__WEBPACK_IMPORTED_MODULE_6__["default"],
                _a)
        })
    ], MChip);
    return MChip;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var MChipPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["CHIP_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["CHIP_NAME"], MChip);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MChipPlugin);


/***/ }),

/***/ "./src/components/component-names.ts":
/*!*******************************************!*\
  !*** ./src/components/component-names.ts ***!
  \*******************************************/
/*! exports provided: ACCORDION_GROUP_NAME, ACCORDION_NAME, ACCORDION_TRANSITION_NAME, ADD_NAME, ADDRESS_AUTOCOMPLETE_FIELD_NAME, ADDRESS_EDITOR_NAME, ADDRESS_LOOKUP_FIELD_NAME, ADDRESS_READER, AUTO_HORIZONTAL_SCROLL, AUTOCOMPLETE_NAME, AVATAR_NAME, BREADCRUMBS_NAME, BUTTON_NAME, BUTTON_GROUP_NAME, CALENDAR_NAME, CAROUSEL_NAME, CAROUSEL_ITEM_NAME, CHARACTER_COUNT_NAME, CHECKBOX_NAME, CHIP_NAME, CHIP_ADD_NAME, CHIP_DELETE_NAME, COPY_TO_CLIPBOARD_NAME, COPY_TO_CLIPBOARD_FEEDBACK_NAME, COUNTRY_FLAG_NAME, DATEPICKER_NAME, DATERANGEPICKER_NAME, DECIMALFIELD_NAME, DIALOG_NAME, DROPDOWN_NAME, DROPDOWN_ITEM_NAME, DYNAMIC_TEMPLATE_NAME, EMPTY_AREA_NAME, ERROR_ACCESS_DENIED_NAME, ERROR_BROWSER_NOT_SUPPORTED_NAME, ERROR_CONFIG_NOT_SUPPORTED_NAME, ERROR_CONFLICT_NAME, ERROR_COOKIES_NOT_SUPPORTED_NAME, ERROR_PAGE_NOT_FOUND_NAME, ERROR_RESOURCE_UNAVAILABLE_NAME, ERROR_TECHNICAL_DIFFICULTY_NAME, ERROR_SESSION_EXPIRED_NAME, EXPANDABLE_LAYOUT_NAME, FILE_SELECT_NAME, FILE_UPLOAD_NAME, FORM_NAME, OVERLAY_NAME, I18N_NAME, ICON_NAME, ICON_BUTTON_NAME, ICON_FILE_NAME, INPLACE_EDIT_NAME, INPUT_GROUP_NAME, INPUT_STYLE_NAME, LIMIT_ELEMENTS, LIMIT_TEXT_NAME, LINK_NAME, LIST_ITEM_NAME, MASKEDFIELD_NAME, MESSAGE_NAME, MENU_NAME, MENU_ITEM_NAME, MESSAGE_PAGE_NAME, MONEYFIELD_NAME, MODAL_NAME, MULTI_SELECT_NAME, NAVBAR_NAME, NAVBAR_ITEM_NAME, OPACITY_TRANSITION_NAME, OPTION_NAME, OPTION_ITEM_NAME, OPTION_ITEM_ADD_NAME, OPTION_ITEM_ARCHIVE_NAME, OPTION_ITEM_DELETE_NAME, OPTION_ITEM_EDIT_NAME, OPTION_TITLE, OPTION_SEPARATOR, ORGANIZE_TABLE_COLUMNS_NAME, ORGANIZE_TABLE_COLUMNS_MODAL_NAME, PANEL_NAME, PAGINATION_NAME, PERIODPICKER_NAME, PHONEFIELD_NAME, PHOTO_EDITOR_NAME, PLUS_NAME, POPPER_NAME, POPUP_NAME, POSTALCODEFIELD_NAME, POWERED_BY_GOOGLE, PROGRESS_NAME, RADIO_NAME, RADIO_GROUP_NAME, RADIO_STYLE_NAME, REPEATER_NAME, RESPONSIVE_TABLE_NAME, RICH_TEXT_NAME, RICH_TEXT_EDITOR_NAME, SCROLL_TOP_NAME, SEARCHFIELD_NAME, SHOW_MORE_NAME, SIDEBAR_NAME, SPINNER_NAME, SLIDE_TRANSITION_NAME, STEPPERS_NAME, STEPPERS_ITEM_NAME, SWITCH_NAME, TABLE_NAME, TABLE_HEAD_NAME, TABLE_GROUP_NAME, TABLE_GROUP_HEADER_NAME, TABLE_EMPTY_ROW_NAME, TABLE_HEADER_NAME, TEMPLATE_NAME, TEXTAREA_NAME, TEXTFIELD_NAME, TIMEPICKER_NAME, TOAST, TOGGLE_BUTTONS_NAME, TOOLTIP_NAME, TOUCH_NAME, TREE_NAME, TREE_ICON_NAME, TREE_NAME_NODE, TYPEAHEAD_NAME, VALIDATION_MESSAGE_NAME, INTEGERFIELD_NAME, SELECT_NAME, SELECT_VIRTUAL_SCROLL_NAME, SVG_NAME, INPUT_MASK_NAME, CALENDAR_BUTTON_NAME */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCORDION_GROUP_NAME", function() { return ACCORDION_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCORDION_NAME", function() { return ACCORDION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCORDION_TRANSITION_NAME", function() { return ACCORDION_TRANSITION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NAME", function() { return ADD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADDRESS_AUTOCOMPLETE_FIELD_NAME", function() { return ADDRESS_AUTOCOMPLETE_FIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADDRESS_EDITOR_NAME", function() { return ADDRESS_EDITOR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADDRESS_LOOKUP_FIELD_NAME", function() { return ADDRESS_LOOKUP_FIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADDRESS_READER", function() { return ADDRESS_READER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_HORIZONTAL_SCROLL", function() { return AUTO_HORIZONTAL_SCROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOCOMPLETE_NAME", function() { return AUTOCOMPLETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AVATAR_NAME", function() { return AVATAR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREADCRUMBS_NAME", function() { return BREADCRUMBS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_NAME", function() { return BUTTON_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_GROUP_NAME", function() { return BUTTON_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_NAME", function() { return CALENDAR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAROUSEL_NAME", function() { return CAROUSEL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAROUSEL_ITEM_NAME", function() { return CAROUSEL_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHARACTER_COUNT_NAME", function() { return CHARACTER_COUNT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKBOX_NAME", function() { return CHECKBOX_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP_NAME", function() { return CHIP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP_ADD_NAME", function() { return CHIP_ADD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP_DELETE_NAME", function() { return CHIP_DELETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY_TO_CLIPBOARD_NAME", function() { return COPY_TO_CLIPBOARD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY_TO_CLIPBOARD_FEEDBACK_NAME", function() { return COPY_TO_CLIPBOARD_FEEDBACK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COUNTRY_FLAG_NAME", function() { return COUNTRY_FLAG_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATEPICKER_NAME", function() { return DATEPICKER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATERANGEPICKER_NAME", function() { return DATERANGEPICKER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DECIMALFIELD_NAME", function() { return DECIMALFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIALOG_NAME", function() { return DIALOG_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROPDOWN_NAME", function() { return DROPDOWN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROPDOWN_ITEM_NAME", function() { return DROPDOWN_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DYNAMIC_TEMPLATE_NAME", function() { return DYNAMIC_TEMPLATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY_AREA_NAME", function() { return EMPTY_AREA_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_ACCESS_DENIED_NAME", function() { return ERROR_ACCESS_DENIED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_BROWSER_NOT_SUPPORTED_NAME", function() { return ERROR_BROWSER_NOT_SUPPORTED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_CONFIG_NOT_SUPPORTED_NAME", function() { return ERROR_CONFIG_NOT_SUPPORTED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_CONFLICT_NAME", function() { return ERROR_CONFLICT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_COOKIES_NOT_SUPPORTED_NAME", function() { return ERROR_COOKIES_NOT_SUPPORTED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_PAGE_NOT_FOUND_NAME", function() { return ERROR_PAGE_NOT_FOUND_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_RESOURCE_UNAVAILABLE_NAME", function() { return ERROR_RESOURCE_UNAVAILABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_TECHNICAL_DIFFICULTY_NAME", function() { return ERROR_TECHNICAL_DIFFICULTY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_SESSION_EXPIRED_NAME", function() { return ERROR_SESSION_EXPIRED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPANDABLE_LAYOUT_NAME", function() { return EXPANDABLE_LAYOUT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_SELECT_NAME", function() { return FILE_SELECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_UPLOAD_NAME", function() { return FILE_UPLOAD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORM_NAME", function() { return FORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OVERLAY_NAME", function() { return OVERLAY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18N_NAME", function() { return I18N_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_NAME", function() { return ICON_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_BUTTON_NAME", function() { return ICON_BUTTON_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_FILE_NAME", function() { return ICON_FILE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPLACE_EDIT_NAME", function() { return INPLACE_EDIT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_GROUP_NAME", function() { return INPUT_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_STYLE_NAME", function() { return INPUT_STYLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIMIT_ELEMENTS", function() { return LIMIT_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIMIT_TEXT_NAME", function() { return LIMIT_TEXT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_NAME", function() { return LINK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST_ITEM_NAME", function() { return LIST_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MASKEDFIELD_NAME", function() { return MASKEDFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MESSAGE_NAME", function() { return MESSAGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_NAME", function() { return MENU_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_ITEM_NAME", function() { return MENU_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MESSAGE_PAGE_NAME", function() { return MESSAGE_PAGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONEYFIELD_NAME", function() { return MONEYFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_NAME", function() { return MODAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MULTI_SELECT_NAME", function() { return MULTI_SELECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_NAME", function() { return NAVBAR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_ITEM_NAME", function() { return NAVBAR_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPACITY_TRANSITION_NAME", function() { return OPACITY_TRANSITION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_NAME", function() { return OPTION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_ITEM_NAME", function() { return OPTION_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_ITEM_ADD_NAME", function() { return OPTION_ITEM_ADD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_ITEM_ARCHIVE_NAME", function() { return OPTION_ITEM_ARCHIVE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_ITEM_DELETE_NAME", function() { return OPTION_ITEM_DELETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_ITEM_EDIT_NAME", function() { return OPTION_ITEM_EDIT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_TITLE", function() { return OPTION_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPTION_SEPARATOR", function() { return OPTION_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORGANIZE_TABLE_COLUMNS_NAME", function() { return ORGANIZE_TABLE_COLUMNS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORGANIZE_TABLE_COLUMNS_MODAL_NAME", function() { return ORGANIZE_TABLE_COLUMNS_MODAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PANEL_NAME", function() { return PANEL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGINATION_NAME", function() { return PAGINATION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERIODPICKER_NAME", function() { return PERIODPICKER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONEFIELD_NAME", function() { return PHONEFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHOTO_EDITOR_NAME", function() { return PHOTO_EDITOR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS_NAME", function() { return PLUS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPPER_NAME", function() { return POPPER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPUP_NAME", function() { return POPUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POSTALCODEFIELD_NAME", function() { return POSTALCODEFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POWERED_BY_GOOGLE", function() { return POWERED_BY_GOOGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROGRESS_NAME", function() { return PROGRESS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO_NAME", function() { return RADIO_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO_GROUP_NAME", function() { return RADIO_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO_STYLE_NAME", function() { return RADIO_STYLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPEATER_NAME", function() { return REPEATER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESPONSIVE_TABLE_NAME", function() { return RESPONSIVE_TABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RICH_TEXT_NAME", function() { return RICH_TEXT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RICH_TEXT_EDITOR_NAME", function() { return RICH_TEXT_EDITOR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL_TOP_NAME", function() { return SCROLL_TOP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCHFIELD_NAME", function() { return SEARCHFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOW_MORE_NAME", function() { return SHOW_MORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDEBAR_NAME", function() { return SIDEBAR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNER_NAME", function() { return SPINNER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLIDE_TRANSITION_NAME", function() { return SLIDE_TRANSITION_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEPPERS_NAME", function() { return STEPPERS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEPPERS_ITEM_NAME", function() { return STEPPERS_ITEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCH_NAME", function() { return SWITCH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_NAME", function() { return TABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_HEAD_NAME", function() { return TABLE_HEAD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_GROUP_NAME", function() { return TABLE_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_GROUP_HEADER_NAME", function() { return TABLE_GROUP_HEADER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_EMPTY_ROW_NAME", function() { return TABLE_EMPTY_ROW_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLE_HEADER_NAME", function() { return TABLE_HEADER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEMPLATE_NAME", function() { return TEMPLATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXTAREA_NAME", function() { return TEXTAREA_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXTFIELD_NAME", function() { return TEXTFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIMEPICKER_NAME", function() { return TIMEPICKER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOAST", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_BUTTONS_NAME", function() { return TOGGLE_BUTTONS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOOLTIP_NAME", function() { return TOOLTIP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH_NAME", function() { return TOUCH_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NAME", function() { return TREE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_ICON_NAME", function() { return TREE_ICON_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NAME_NODE", function() { return TREE_NAME_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TYPEAHEAD_NAME", function() { return TYPEAHEAD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VALIDATION_MESSAGE_NAME", function() { return VALIDATION_MESSAGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTEGERFIELD_NAME", function() { return INTEGERFIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_NAME", function() { return SELECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_VIRTUAL_SCROLL_NAME", function() { return SELECT_VIRTUAL_SCROLL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SVG_NAME", function() { return SVG_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_MASK_NAME", function() { return INPUT_MASK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_BUTTON_NAME", function() { return CALENDAR_BUTTON_NAME; });
var ACCORDION_GROUP_NAME = 'm-accordion-group';
var ACCORDION_NAME = 'm-accordion';
var ACCORDION_TRANSITION_NAME = 'm-accordion-transition';
var ADD_NAME = 'm-add';
var ADDRESS_AUTOCOMPLETE_FIELD_NAME = 'm-address-autocomplete-field';
var ADDRESS_EDITOR_NAME = 'm-address-editor';
var ADDRESS_LOOKUP_FIELD_NAME = 'm-address-lookup-field';
var ADDRESS_READER = 'm-address-reader';
var AUTO_HORIZONTAL_SCROLL = 'm-auto-horizontal-scroll';
var AUTOCOMPLETE_NAME = 'm-autocomplete';
var AVATAR_NAME = 'm-avatar';
var BREADCRUMBS_NAME = 'm-breadcrumbs';
var BUTTON_NAME = 'm-button';
var BUTTON_GROUP_NAME = 'm-button-group';
var CALENDAR_NAME = 'm-calendar';
var CAROUSEL_NAME = 'm-carousel';
var CAROUSEL_ITEM_NAME = 'm-carousel-item';
var CHARACTER_COUNT_NAME = 'm-character-count';
var CHECKBOX_NAME = 'm-checkbox';
var CHIP_NAME = 'm-chip';
var CHIP_ADD_NAME = 'm-chip-add';
var CHIP_DELETE_NAME = 'm-chip-delete';
var COPY_TO_CLIPBOARD_NAME = 'm-copy-to-clipboard';
var COPY_TO_CLIPBOARD_FEEDBACK_NAME = 'm-copy-to-clipboard-feedback';
var COUNTRY_FLAG_NAME = 'm-country-flag';
var DATEPICKER_NAME = 'm-datepicker';
var DATERANGEPICKER_NAME = 'm-daterangepicker';
var DECIMALFIELD_NAME = 'm-decimalfield';
var DIALOG_NAME = 'm-dialog';
var DROPDOWN_NAME = 'm-dropdown';
var DROPDOWN_ITEM_NAME = 'm-dropdown-item';
var DYNAMIC_TEMPLATE_NAME = 'm-dynamic-template';
var EMPTY_AREA_NAME = 'm-empty-area';
var ERROR_ACCESS_DENIED_NAME = 'm-error-access-denied';
var ERROR_BROWSER_NOT_SUPPORTED_NAME = 'm-error-browser-not-supported';
var ERROR_CONFIG_NOT_SUPPORTED_NAME = 'm-error-config-not-supported';
var ERROR_CONFLICT_NAME = 'm-error-conflict';
var ERROR_COOKIES_NOT_SUPPORTED_NAME = 'm-error-cookies-not-supported';
var ERROR_PAGE_NOT_FOUND_NAME = 'm-error-page-not-found';
var ERROR_RESOURCE_UNAVAILABLE_NAME = 'm-error-resource-unavailable';
var ERROR_TECHNICAL_DIFFICULTY_NAME = 'm-error-technical-difficulty';
var ERROR_SESSION_EXPIRED_NAME = 'm-error-session-expired';
var EXPANDABLE_LAYOUT_NAME = 'm-expandable-layout';
var FILE_SELECT_NAME = 'm-file-select';
var FILE_UPLOAD_NAME = 'm-file-upload';
var FORM_NAME = 'm-form';
var OVERLAY_NAME = 'm-overlay';
var I18N_NAME = 'm-i18n';
var ICON_NAME = 'm-icon';
var ICON_BUTTON_NAME = 'm-icon-button';
var ICON_FILE_NAME = 'm-icon-file';
var INPLACE_EDIT_NAME = 'm-inplace-edit';
var INPUT_GROUP_NAME = 'm-input-group';
var INPUT_STYLE_NAME = 'm-input-style';
var LIMIT_ELEMENTS = 'm-limit-elements';
var LIMIT_TEXT_NAME = 'm-limit-text';
var LINK_NAME = 'm-link';
var LIST_ITEM_NAME = 'm-list-item';
var MASKEDFIELD_NAME = 'm-maskedfield';
var MESSAGE_NAME = 'm-message';
var MENU_NAME = 'm-menu';
var MENU_ITEM_NAME = 'm-menu-item';
var MESSAGE_PAGE_NAME = 'm-message-page';
var MONEYFIELD_NAME = 'm-moneyfield';
var MODAL_NAME = 'm-modal';
var MULTI_SELECT_NAME = 'm-multi-select';
var NAVBAR_NAME = 'm-navbar';
var NAVBAR_ITEM_NAME = 'm-navbar-item';
var OPACITY_TRANSITION_NAME = 'm-opacity-transition';
var OPTION_NAME = 'm-option';
var OPTION_ITEM_NAME = 'm-option-item';
var OPTION_ITEM_ADD_NAME = 'm-option-item-add';
var OPTION_ITEM_ARCHIVE_NAME = 'm-option-item-archive';
var OPTION_ITEM_DELETE_NAME = 'm-option-item-delete';
var OPTION_ITEM_EDIT_NAME = 'm-option-item-edit';
var OPTION_TITLE = 'm-option-title';
var OPTION_SEPARATOR = 'm-option-separator';
var ORGANIZE_TABLE_COLUMNS_NAME = 'm-organize-table-columns';
var ORGANIZE_TABLE_COLUMNS_MODAL_NAME = 'm-organize-table-columns-modal';
var PANEL_NAME = 'm-panel';
var PAGINATION_NAME = 'm-pagination';
var PERIODPICKER_NAME = 'm-periodpicker';
var PHONEFIELD_NAME = 'm-phonefield';
var PHOTO_EDITOR_NAME = 'm-photo-editor';
var PLUS_NAME = 'm-plus';
var POPPER_NAME = 'm-popper';
var POPUP_NAME = 'm-popup';
var POSTALCODEFIELD_NAME = 'm-postalcodefield';
var POWERED_BY_GOOGLE = 'm-powered-by-google';
var PROGRESS_NAME = 'm-progress';
var RADIO_NAME = 'm-radio';
var RADIO_GROUP_NAME = 'm-radio-group';
var RADIO_STYLE_NAME = 'm-radio-style';
var REPEATER_NAME = 'm-repeater';
var RESPONSIVE_TABLE_NAME = 'm-responsive-table';
var RICH_TEXT_NAME = 'm-rich-text';
var RICH_TEXT_EDITOR_NAME = 'm-rich-text-editor';
var SCROLL_TOP_NAME = 'm-scroll-top';
var SEARCHFIELD_NAME = 'm-searchfield';
var SHOW_MORE_NAME = 'm-show-more';
var SIDEBAR_NAME = 'm-sidebar';
var SPINNER_NAME = 'm-spinner';
var SLIDE_TRANSITION_NAME = 'm-slide-transition';
var STEPPERS_NAME = 'm-steppers';
var STEPPERS_ITEM_NAME = 'm-steppers-item';
var SWITCH_NAME = 'm-switch';
var TABLE_NAME = 'm-table';
var TABLE_HEAD_NAME = 'm-table-head';
var TABLE_GROUP_NAME = 'm-table-group';
var TABLE_GROUP_HEADER_NAME = 'm-table-group-header';
var TABLE_EMPTY_ROW_NAME = 'm-table-empty-row';
var TABLE_HEADER_NAME = 'm-table-header';
var TEMPLATE_NAME = 'm-template';
var TEXTAREA_NAME = 'm-textarea';
var TEXTFIELD_NAME = 'm-textfield';
var TIMEPICKER_NAME = 'm-timepicker';
var TOAST = 'm-toast';
var TOGGLE_BUTTONS_NAME = 'm-toggle-buttons';
var TOOLTIP_NAME = 'm-tooltip';
var TOUCH_NAME = 'm-touch';
var TREE_NAME = 'm-tree';
var TREE_ICON_NAME = 'm-tree-icon';
var TREE_NAME_NODE = 'm-tree-node';
var TYPEAHEAD_NAME = 'm-typeahead';
var VALIDATION_MESSAGE_NAME = 'm-validation-message';
var INTEGERFIELD_NAME = 'm-integerfield';
var SELECT_NAME = 'm-select';
var SELECT_VIRTUAL_SCROLL_NAME = 'm-select-virtual-scroll';
var SVG_NAME = 'm-svg';
var INPUT_MASK_NAME = 'm-input-mask';
var CALENDAR_BUTTON_NAME = 'm-calendar-button';


/***/ }),

/***/ "./src/components/components-plugin.ts":
/*!*********************************************!*\
  !*** ./src/components/components-plugin.ts ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/logger/logger */ "./src/utils/logger/logger.ts");
/* harmony import */ var _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/scroll-to/scroll-to */ "./src/utils/scroll-to/scroll-to.ts");
/* harmony import */ var _accordion_group_accordion_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./accordion-group/accordion-group */ "./src/components/accordion-group/accordion-group.ts");
/* harmony import */ var _accordion_accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./accordion/accordion */ "./src/components/accordion/accordion.ts");
/* harmony import */ var _add_add__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./add/add */ "./src/components/add/add.ts");
/* harmony import */ var _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./auto-horizontal-scroll/auto-horizontal-scroll */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.ts");
/* harmony import */ var _autocomplete_autocomplete__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./autocomplete/autocomplete */ "./src/components/autocomplete/autocomplete.ts");
/* harmony import */ var _avatar_avatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./avatar/avatar */ "./src/components/avatar/avatar.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./button/button */ "./src/components/button/button.ts");
/* harmony import */ var _calendar_calendar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./calendar/calendar */ "./src/components/calendar/calendar.ts");
/* harmony import */ var _carousel_carousel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./carousel/carousel */ "./src/components/carousel/carousel.ts");
/* harmony import */ var _character_count_character_count__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./character-count/character-count */ "./src/components/character-count/character-count.ts");
/* harmony import */ var _checkbox_checkbox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./checkbox/checkbox */ "./src/components/checkbox/checkbox.ts");
/* harmony import */ var _chip_chip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./chip/chip */ "./src/components/chip/chip.ts");
/* harmony import */ var _datepicker_datepicker__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./datepicker/datepicker */ "./src/components/datepicker/datepicker.ts");
/* harmony import */ var _daterangepicker_daterangepicker__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./daterangepicker/daterangepicker */ "./src/components/daterangepicker/daterangepicker.ts");
/* harmony import */ var _decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./decimalfield/decimalfield */ "./src/components/decimalfield/decimalfield.ts");
/* harmony import */ var _dialog_dialog__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./dialog/dialog */ "./src/components/dialog/dialog.ts");
/* harmony import */ var _dropdown_dropdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./dropdown/dropdown */ "./src/components/dropdown/dropdown.ts");
/* harmony import */ var _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./empty-area/empty-area */ "./src/components/empty-area/empty-area.ts");
/* harmony import */ var _error_pages_error_access_denied_error_access_denied__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./error-pages/error-access-denied/error-access-denied */ "./src/components/error-pages/error-access-denied/error-access-denied.ts");
/* harmony import */ var _error_pages_error_browser_not_supported_error_browser_not_supported__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./error-pages/error-browser-not-supported/error-browser-not-supported */ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.ts");
/* harmony import */ var _error_pages_error_config_not_supported_error_config_not_supported__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./error-pages/error-config-not-supported/error-config-not-supported */ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.ts");
/* harmony import */ var _error_pages_error_conflict_error_conflict__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./error-pages/error-conflict/error-conflict */ "./src/components/error-pages/error-conflict/error-conflict.ts");
/* harmony import */ var _error_pages_error_cookies_not_supported_error_cookies_not_supported__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./error-pages/error-cookies-not-supported/error-cookies-not-supported */ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.ts");
/* harmony import */ var _error_pages_error_page_not_found_error_page_not_found__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./error-pages/error-page-not-found/error-page-not-found */ "./src/components/error-pages/error-page-not-found/error-page-not-found.ts");
/* harmony import */ var _error_pages_error_resource_unavailable_error_resource_unavailable__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./error-pages/error-resource-unavailable/error-resource-unavailable */ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.ts");
/* harmony import */ var _error_pages_error_session_expired_error_session_expired__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./error-pages/error-session-expired/error-session-expired */ "./src/components/error-pages/error-session-expired/error-session-expired.ts");
/* harmony import */ var _error_pages_error_technical_difficulty_error_technical_difficulty__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./error-pages/error-technical-difficulty/error-technical-difficulty */ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.ts");
/* harmony import */ var _expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./expandable-layout/expandable-layout */ "./src/components/expandable-layout/expandable-layout.ts");
/* harmony import */ var _file_select_file_select__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./file-select/file-select */ "./src/components/file-select/file-select.ts");
/* harmony import */ var _file_upload_file_upload__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./file-upload/file-upload */ "./src/components/file-upload/file-upload.ts");
/* harmony import */ var _form_form_plugin__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./form/form.plugin */ "./src/components/form/form.plugin.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_file_icon_file__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./icon-file/icon-file */ "./src/components/icon-file/icon-file.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _inplace_edit_inplace_edit__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./inplace-edit/inplace-edit */ "./src/components/inplace-edit/inplace-edit.ts");
/* harmony import */ var _input_group_input_group__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./input-group/input-group */ "./src/components/input-group/input-group.ts");
/* harmony import */ var _integerfield_integerfield__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./integerfield/integerfield */ "./src/components/integerfield/integerfield.ts");
/* harmony import */ var _limit_text_limit_text__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./limit-text/limit-text */ "./src/components/limit-text/limit-text.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./link/link */ "./src/components/link/link.ts");
/* harmony import */ var _list_item_list_item__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./list-item/list-item */ "./src/components/list-item/list-item.ts");
/* harmony import */ var _menu_menu__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./menu/menu */ "./src/components/menu/menu.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./message/message */ "./src/components/message/message.ts");
/* harmony import */ var _modal_modal__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./modal/modal */ "./src/components/modal/modal.ts");
/* harmony import */ var _moneyfield_moneyfield__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./moneyfield/moneyfield */ "./src/components/moneyfield/moneyfield.ts");
/* harmony import */ var _multi_select_multi_select__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./multi-select/multi-select */ "./src/components/multi-select/multi-select.ts");
/* harmony import */ var _navbar_navbar__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./navbar/navbar */ "./src/components/navbar/navbar.ts");
/* harmony import */ var _option_option__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./option/option */ "./src/components/option/option.ts");
/* harmony import */ var _organize_table_columns_modal_organize_table_columns_modal__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./organize-table-columns-modal/organize-table-columns-modal */ "./src/components/organize-table-columns-modal/organize-table-columns-modal.ts");
/* harmony import */ var _overlay_overlay__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./overlay/overlay */ "./src/components/overlay/overlay.ts");
/* harmony import */ var _pagination_pagination__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./pagination/pagination */ "./src/components/pagination/pagination.ts");
/* harmony import */ var _panel_panel__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./panel/panel */ "./src/components/panel/panel.ts");
/* harmony import */ var _periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./periodpicker/periodpicker */ "./src/components/periodpicker/periodpicker.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _postalcodefield_postalcodefield__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./postalcodefield/postalcodefield */ "./src/components/postalcodefield/postalcodefield.ts");
/* harmony import */ var _progress_progress__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./progress/progress */ "./src/components/progress/progress.ts");
/* harmony import */ var _radio_group_radio_group__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./radio-group/radio-group */ "./src/components/radio-group/radio-group.ts");
/* harmony import */ var _radio_style_radio_style__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./radio-style/radio-style */ "./src/components/radio-style/radio-style.ts");
/* harmony import */ var _radio_radio__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./radio/radio */ "./src/components/radio/radio.ts");
/* harmony import */ var _responsive_table_responsive_table__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./responsive-table/responsive-table */ "./src/components/responsive-table/responsive-table.ts");
/* harmony import */ var _scroll_top_scroll_top__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./scroll-top/scroll-top */ "./src/components/scroll-top/scroll-top.ts");
/* harmony import */ var _searchfield_searchfield__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./searchfield/searchfield */ "./src/components/searchfield/searchfield.ts");
/* harmony import */ var _show_more_show_more__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./show-more/show-more */ "./src/components/show-more/show-more.ts");
/* harmony import */ var _sidebar_sidebar__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./sidebar/sidebar */ "./src/components/sidebar/sidebar.ts");
/* harmony import */ var _spinner_spinner__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./spinner/spinner */ "./src/components/spinner/spinner.ts");
/* harmony import */ var _steppers_steppers__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./steppers/steppers */ "./src/components/steppers/steppers.ts");
/* harmony import */ var _svg_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./svg/svg */ "./src/components/svg/svg.ts");
/* harmony import */ var _switch_switch__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./switch/switch */ "./src/components/switch/switch.ts");
/* harmony import */ var _table_header_table_header__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./table-header/table-header */ "./src/components/table-header/table-header.ts");
/* harmony import */ var _table_table__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ./table/table */ "./src/components/table/table.ts");
/* harmony import */ var _textarea_textarea__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./textarea/textarea */ "./src/components/textarea/textarea.ts");
/* harmony import */ var _textfield_textfield__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./textfield/textfield */ "./src/components/textfield/textfield.ts");
/* harmony import */ var _timepicker_timepicker__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./timepicker/timepicker */ "./src/components/timepicker/timepicker.ts");
/* harmony import */ var _toast_toast__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ./toast/toast */ "./src/components/toast/toast.ts");
/* harmony import */ var _toggle_buttons_toggle_buttons__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ./toggle-buttons/toggle-buttons */ "./src/components/toggle-buttons/toggle-buttons.ts");
/* harmony import */ var _tooltip_tooltip__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ./tooltip/tooltip */ "./src/components/tooltip/tooltip.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ./transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _transitions_opacity_transition_opacity_transition__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ./transitions/opacity-transition/opacity-transition */ "./src/components/transitions/opacity-transition/opacity-transition.ts");
/* harmony import */ var _transitions_slide_transition_slide_transition__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ./transitions/slide-transition/slide-transition */ "./src/components/transitions/slide-transition/slide-transition.ts");
/* harmony import */ var _tree_tree__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ./tree/tree */ "./src/components/tree/tree.ts");
/* harmony import */ var _typeahead_typeahead__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ./typeahead/typeahead */ "./src/components/typeahead/typeahead.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ./validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");





















































































var ComponentsPlugin = {
    install: function (v, options) {
        if (options === void 0) { options = {}; }
        if (!v.prototype.$log) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__["default"]);
        }
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_accordion_group_accordion_group__WEBPACK_IMPORTED_MODULE_3__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_accordion_accordion__WEBPACK_IMPORTED_MODULE_4__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_79__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_add_add__WEBPACK_IMPORTED_MODULE_5__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_6__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_button_button__WEBPACK_IMPORTED_MODULE_9__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_calendar_calendar__WEBPACK_IMPORTED_MODULE_10__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_carousel_carousel__WEBPACK_IMPORTED_MODULE_11__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_character_count_character_count__WEBPACK_IMPORTED_MODULE_12__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_checkbox_checkbox__WEBPACK_IMPORTED_MODULE_13__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_datepicker_datepicker__WEBPACK_IMPORTED_MODULE_15__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_daterangepicker_daterangepicker__WEBPACK_IMPORTED_MODULE_16__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_modal_modal__WEBPACK_IMPORTED_MODULE_46__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_dropdown_dropdown__WEBPACK_IMPORTED_MODULE_19__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_autocomplete_autocomplete__WEBPACK_IMPORTED_MODULE_7__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_overlay_overlay__WEBPACK_IMPORTED_MODULE_52__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_file_select_file_select__WEBPACK_IMPORTED_MODULE_31__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_file_upload_file_upload__WEBPACK_IMPORTED_MODULE_32__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_form_form_plugin__WEBPACK_IMPORTED_MODULE_33__["default"], options.formPluginOptions ? options.formPluginOptions : undefined);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_i18n_i18n__WEBPACK_IMPORTED_MODULE_34__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_icon_icon__WEBPACK_IMPORTED_MODULE_37__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_35__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_icon_file_icon_file__WEBPACK_IMPORTED_MODULE_36__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_input_group_input_group__WEBPACK_IMPORTED_MODULE_39__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_limit_text_limit_text__WEBPACK_IMPORTED_MODULE_41__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_link_link__WEBPACK_IMPORTED_MODULE_42__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_list_item_list_item__WEBPACK_IMPORTED_MODULE_43__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_message_message__WEBPACK_IMPORTED_MODULE_45__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_dialog_dialog__WEBPACK_IMPORTED_MODULE_18__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_empty_area_empty_area__WEBPACK_IMPORTED_MODULE_20__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_navbar_navbar__WEBPACK_IMPORTED_MODULE_49__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_transitions_opacity_transition_opacity_transition__WEBPACK_IMPORTED_MODULE_80__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_option_option__WEBPACK_IMPORTED_MODULE_50__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_menu_menu__WEBPACK_IMPORTED_MODULE_44__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_panel_panel__WEBPACK_IMPORTED_MODULE_54__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_55__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_popup_popup__WEBPACK_IMPORTED_MODULE_56__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_progress_progress__WEBPACK_IMPORTED_MODULE_58__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_radio_radio__WEBPACK_IMPORTED_MODULE_61__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_radio_group_radio_group__WEBPACK_IMPORTED_MODULE_59__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_radio_style_radio_style__WEBPACK_IMPORTED_MODULE_60__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_scroll_top_scroll_top__WEBPACK_IMPORTED_MODULE_63__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_show_more_show_more__WEBPACK_IMPORTED_MODULE_65__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_spinner_spinner__WEBPACK_IMPORTED_MODULE_67__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_66__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_transitions_slide_transition_slide_transition__WEBPACK_IMPORTED_MODULE_81__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_steppers_steppers__WEBPACK_IMPORTED_MODULE_68__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_switch_switch__WEBPACK_IMPORTED_MODULE_70__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_table_table__WEBPACK_IMPORTED_MODULE_72__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_table_header_table_header__WEBPACK_IMPORTED_MODULE_71__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_responsive_table_responsive_table__WEBPACK_IMPORTED_MODULE_62__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_multi_select_multi_select__WEBPACK_IMPORTED_MODULE_48__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_textarea_textarea__WEBPACK_IMPORTED_MODULE_73__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_textfield_textfield__WEBPACK_IMPORTED_MODULE_74__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_searchfield_searchfield__WEBPACK_IMPORTED_MODULE_64__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_timepicker_timepicker__WEBPACK_IMPORTED_MODULE_75__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_toast_toast__WEBPACK_IMPORTED_MODULE_76__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_toggle_buttons_toggle_buttons__WEBPACK_IMPORTED_MODULE_77__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_tooltip_tooltip__WEBPACK_IMPORTED_MODULE_78__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_tree_tree__WEBPACK_IMPORTED_MODULE_82__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_typeahead_typeahead__WEBPACK_IMPORTED_MODULE_83__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_validation_message_validation_message__WEBPACK_IMPORTED_MODULE_84__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_inplace_edit_inplace_edit__WEBPACK_IMPORTED_MODULE_38__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_pagination_pagination__WEBPACK_IMPORTED_MODULE_53__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_chip_chip__WEBPACK_IMPORTED_MODULE_14__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_postalcodefield_postalcodefield__WEBPACK_IMPORTED_MODULE_57__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_moneyfield_moneyfield__WEBPACK_IMPORTED_MODULE_47__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_17__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_integerfield_integerfield__WEBPACK_IMPORTED_MODULE_40__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_access_denied_error_access_denied__WEBPACK_IMPORTED_MODULE_21__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_browser_not_supported_error_browser_not_supported__WEBPACK_IMPORTED_MODULE_22__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_config_not_supported_error_config_not_supported__WEBPACK_IMPORTED_MODULE_23__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_conflict_error_conflict__WEBPACK_IMPORTED_MODULE_24__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_cookies_not_supported_error_cookies_not_supported__WEBPACK_IMPORTED_MODULE_25__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_page_not_found_error_page_not_found__WEBPACK_IMPORTED_MODULE_26__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_resource_unavailable_error_resource_unavailable__WEBPACK_IMPORTED_MODULE_27__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_session_expired_error_session_expired__WEBPACK_IMPORTED_MODULE_28__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_error_pages_error_technical_difficulty_error_technical_difficulty__WEBPACK_IMPORTED_MODULE_29__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_organize_table_columns_modal_organize_table_columns_modal__WEBPACK_IMPORTED_MODULE_51__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_2__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_30__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_avatar_avatar__WEBPACK_IMPORTED_MODULE_8__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_svg_svg__WEBPACK_IMPORTED_MODULE_69__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ComponentsPlugin);


/***/ }),

/***/ "./src/components/datepicker/datepicker.html?style=./datepicker.scss":
/*!***************************************************************************!*\
  !*** ./src/components/datepicker/datepicker.html?style=./datepicker.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=1f986c2e!./datepicker.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=1f986c2e!./src/components/datepicker/datepicker.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-datepicker",
      class: {
        "m--is-disabled": _vm.isDisabled,
        "m--is-readonly": _vm.isReadonly,
        "m--is-waiting": _vm.isWaiting,
        "m--has-error": _vm.hasCalandarError,
        "m--is-valid": _vm.isValid,
        "m--has-validation-message": _vm.hasValidationMessage
      },
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          directives: [
            { name: "m-popup", rawName: "v-m-popup:popup", arg: "popup" }
          ],
          attrs: {
            disabled: _vm.isDisabled,
            label: _vm.label,
            "label-for": _vm.id,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            waiting: _vm.isWaiting,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            error: _vm.hasCalandarError,
            valid: _vm.isValid
          }
        },
        [
          _c("m-input-mask", {
            ref: "input",
            attrs: {
              id: _vm.id,
              "aria-haspopup": true,
              "aria-expanded": _vm.open,
              disabled: _vm.isDisabled || _vm.isWaiting,
              readonly: _vm.isReadonly || _vm.isLessThanTablet,
              options: _vm.inputOptions,
              placeholder: _vm.propPlaceholder,
              raw: false,
              value: _vm.inputModel,
              autocomplete: "off"
            },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              input: function($event) {
                return _vm.inputDate($event)
              },
              keyup: _vm.onKeyup,
              keydown: _vm.onKeydown
            }
          }),
          _vm._v(" "),
          _c(
            "m-icon-button",
            {
              staticClass: "m-datepicker__icon",
              attrs: {
                slot: "suffix",
                "aria-controls": _vm.id,
                "button-size": "22px",
                disabled: !_vm.active,
                "icon-name": "m-svg__calendar"
              },
              on: {
                click: function($event) {
                  return _vm.togglePopup($event)
                }
              },
              slot: "suffix"
            },
            [
              !_vm.open
                ? _c("m-i18n", { attrs: { k: "m-datepicker:open" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.open
                ? _c("m-i18n", { attrs: { k: "m-datepicker:close" } })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-datepicker__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-datepicker__validation__message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasCalandarError,
              "error-message": _vm.calandarErrorMessage,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "m-popup",
        {
          ref: "popup",
          attrs: {
            open: _vm.open,
            disabled: !_vm.active,
            "close-on-backdrop": true,
            "focus-management": _vm.isMqMaxS,
            "open-trigger": "manual",
            padding: false,
            placement: "bottom"
          },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            },
            open: _vm.onOpen,
            close: _vm.onClose
          }
        },
        [
          _vm.label && _vm.isMqMaxS
            ? _c(
                "h2",
                {
                  staticClass: "m-datepicker__header-label",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v(_vm._s(_vm.label))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("m-calendar", {
            attrs: {
              "min-date": _vm.minDateString,
              "max-date": _vm.maxDateString,
              type: _vm.type,
              visible: _vm.open,
              "initial-view": _vm.initialView,
              "show-month-before-after": false,
              value: _vm.formattedDate
            },
            on: { input: _vm.selectDate }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-1f986c2e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/datepicker/datepicker.ts":
/*!*************************************************!*\
  !*** ./src/components/datepicker/datepicker.ts ***!
  \*************************************************/
/*! exports provided: MDatepickerDefaultView, MDatepicker, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDatepickerDefaultView", function() { return MDatepickerDefaultView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDatepicker", function() { return MDatepicker; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/popup/popup */ "./src/directives/popup/popup.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _calendar_calendar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../calendar/calendar */ "./src/components/calendar/calendar.ts");
/* harmony import */ var _calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../calendar/calendar-renderer/base-calendar/base-calendar */ "./src/components/calendar/calendar-renderer/base-calendar/base-calendar.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../input-mask/input-mask */ "./src/components/input-mask/input-mask.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _datepicker_html_style_datepicker_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./datepicker.html?style=./datepicker.scss */ "./src/components/datepicker/datepicker.html?style=./datepicker.scss");
/* harmony import */ var _datepicker_html_style_datepicker_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_datepicker_html_style_datepicker_scss__WEBPACK_IMPORTED_MODULE_25__);
var _a, _b;


























var MDatepickerDefaultView;
(function (MDatepickerDefaultView) {
    MDatepickerDefaultView["Month"] = "month";
    MDatepickerDefaultView["Day"] = "day";
})(MDatepickerDefaultView || (MDatepickerDefaultView = {}));
var MDatepicker = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDatepicker, _super);
    function MDatepicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mDatepicker-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_11__["default"].generate();
        _this.internalOpen = false;
        _this.internalCalendarErrorMessage = '';
        _this.inputModel = '';
        _this.internalDateModel = '';
        return _this;
    }
    MDatepicker.prototype.created = function () {
        if (this.value instanceof Date) {
            this.$log.warn('Using a Date as value for datepicker is not recommended and will be deprecated in 1.0, the value should use a string with the format "YYYY-MM-DD". Using a Date object can lead to timezone issue in your projet see -> https://stackoverflow.com/questions/29174810/javascript-date-timezone-issue');
        }
    };
    Object.defineProperty(MDatepicker.prototype, "inputOptions", {
        get: function () {
            if (this.isTypeYearsMonths) {
                return {
                    numericOnly: true,
                    delimiters: ['-'],
                    blocks: [4, 2]
                };
            }
            return {
                numericOnly: true,
                delimiters: ['-', '-'],
                blocks: [4, 2, 2]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "isTypeYearsMonths", {
        get: function () {
            return this.type === _calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__["MBaseCalendarType"].YEARS_MONTHS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "propPlaceholder", {
        get: function () {
            if (this.placeholder) {
                return this.placeholder;
            }
            return this.isTypeYearsMonths ? this.$i18n.translate('m-datepicker:placeholder-aaaa-mm') : this.$i18n.translate('m-datepicker:placeholder-aaaa-mm-jj');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "formattedDate", {
        get: function () {
            return this.convertValueToModel(this.model);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "hasCalandarError", {
        get: function () {
            return this.internalCalendarErrorMessage !== '' || this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "calandarErrorMessage", {
        get: function () {
            if (this.internalCalendarErrorMessage && !this.hideInternalErrorMessage) {
                return this.internalCalendarErrorMessage;
            }
            else {
                return this.as().errorMessage !== undefined ? this.as().errorMessage : '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "open", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            if (this.as().active) {
                this.internalOpen = open;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "minDateString", {
        get: function () {
            return this.convertValueToModel(this.min);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "maxDateString", {
        get: function () {
            return this.convertValueToModel(this.max);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "minModulDate", {
        get: function () {
            return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](this.min);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "maxModulDate", {
        get: function () {
            return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](this.max);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "maxInputLenght", {
        get: function () {
            return this.isTypeYearsMonths ? 7 : 10;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "isLessThanTablet", {
        get: function () {
            return this.as().isMqMaxS;
        },
        enumerable: true,
        configurable: true
    });
    MDatepicker.prototype.onOpen = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var inputMask;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                // dont set the focus on less than tablet
                if (!this.isLessThanTablet) {
                    inputMask = this.$refs.input;
                    inputMask.focusAndSelectAll();
                }
                return [2 /*return*/];
            });
        });
    };
    MDatepicker.prototype.onClose = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                // emit blur if not focus and still open
                if (!this.as().internalIsFocus) {
                    this.emitBlur();
                }
                return [2 /*return*/];
            });
        });
    };
    MDatepicker.prototype.emitBlur = function () {
        if (!this.skipInputValidation) {
            this.showErrorMessage(this.inputModel);
        }
    };
    MDatepicker.prototype.emitClick = function (event) { };
    MDatepicker.prototype.emitKeydown = function (event) { };
    MDatepicker.prototype.onSkipInputValidationChangement = function (skipInputValidation) {
        this.inputDate(this.inputModel);
        this.showErrorMessage(this.inputModel);
    };
    MDatepicker.prototype.selectDate = function (selectedDate) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                this.internalCalendarErrorMessage = '';
                this.model = this.convertValueToModel(selectedDate);
                this.inputModel = this.internalDateModel;
                this.open = false;
                return [2 /*return*/];
            });
        });
    };
    MDatepicker.prototype.inputDate = function (inputValue) {
        this.inputModel = inputValue;
        if (!inputValue || inputValue === '') {
            this.model = '';
            this.clearErrorMessage();
        }
        else {
            if (this.open) {
                this.open = false;
            }
            if (this.skipInputValidation) {
                this.model = inputValue;
            }
            else {
                if (inputValue.length === this.maxInputLenght && this.showErrorMessage(inputValue)) {
                    this.model = this.inputModel;
                }
                else {
                    this.model = '';
                }
            }
        }
    };
    // Model management
    // override from InputManagement
    MDatepicker.prototype.onValueChange = function (value) {
        if (this.internalDateModel !== this.convertModelToString(value)) {
            this.internalDateModel = this.convertModelToString(value);
            this.inputModel = this.internalDateModel ? this.internalDateModel : '';
            this.showErrorMessage(this.inputModel);
        }
    };
    Object.defineProperty(MDatepicker.prototype, "model", {
        get: function () {
            return this.internalDateModel;
        },
        // override from InputManagement
        set: function (value) {
            if (this.internalDateModel !== value) {
                this.internalDateModel = value;
                this.emitChange();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDatepicker.prototype, "hasValue", {
        // override from InputManagement
        get: function () {
            return !!(this.inputModel || '').toString().trim();
        },
        enumerable: true,
        configurable: true
    });
    MDatepicker.prototype.togglePopup = function (event) {
        this.open = !this.open;
        // stop event propagation to parent.
        event.stopPropagation();
    };
    MDatepicker.prototype.emitChange = function () {
        this.$emit('change', this.convertStringToModel(this.internalDateModel));
    };
    MDatepicker.prototype.onKeydown = function (event) {
        if (this.as().active) {
            if (event.key === 'Tab') {
                // close popop if open and tab key is pressed (accessibility)
                if (this.open) {
                    this.open = false;
                }
            }
            this.emitKeydown(event);
        }
    };
    Object.defineProperty(MDatepicker.prototype, "hasErrorMessage", {
        get: function () {
            return (!!this.as().errorMessage || this.as().errorMessage === ' '
                || !!(this.internalCalendarErrorMessage || '').trim()) &&
                !this.as().disabled && !this.as().waiting;
        },
        enumerable: true,
        configurable: true
    });
    // Focus management.
    // override from InputManagement
    MDatepicker.prototype.onFocus = function (event) {
        if (!this.open) { // open on focus
            this.open = true;
        }
        this.as().internalIsFocus = this.as().active;
        if (this.as().internalIsFocus) {
            this.$emit('focus', event);
        }
    };
    // override from InputManagement
    MDatepicker.prototype.onClick = function (event) {
        this.as().internalIsFocus = this.as().active;
        var inputEl = this.as().getInput();
        if (this.as().internalIsFocus && inputEl) {
            inputEl.focus();
        }
        this.emitClick(event);
    };
    // override from InputManagement
    MDatepicker.prototype.onBlur = function (event) {
        this.as().internalIsFocus = false;
        if (!this.open) { // do not emit blur if still open
            this.emitBlur();
        }
    };
    Object.defineProperty(MDatepicker.prototype, "isFocus", {
        // override from Input-management
        get: function () {
            return this.as().internalIsFocus || this.open;
        },
        enumerable: true,
        configurable: true
    });
    MDatepicker.prototype.convertValueToModel = function (input) {
        if (input) {
            try {
                return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](input).toString();
            }
            catch (err) {
                return '';
            }
        }
        return '';
    };
    MDatepicker.prototype.validateDateFormat = function (dateString) {
        return Boolean(dateString) && !isNaN(Date.parse(dateString));
    };
    MDatepicker.prototype.convertStringToModel = function (newValue) {
        if (newValue && this.value instanceof Date) {
            return new Date(newValue);
        }
        else {
            return newValue;
        }
    };
    MDatepicker.prototype.convertModelToString = function (value) {
        if (value instanceof Date) {
            return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](value.toISOString()).toString();
        }
        else {
            if (value) {
                return value;
            }
            else {
                return '';
            }
        }
    };
    MDatepicker.prototype.clearErrorMessage = function () {
        this.internalCalendarErrorMessage = '';
    };
    MDatepicker.prototype.showErrorMessage = function (inputValue) {
        if (inputValue === '' || inputValue === undefined || inputValue === null || this.skipInputValidation) {
            this.internalCalendarErrorMessage = '';
            return true;
        }
        else if (inputValue.length === this.maxInputLenght && this.validateDateFormat(inputValue)) {
            var newDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"](inputValue);
            if (newDate.isBetween(this.minModulDate, this.maxModulDate)) {
                this.internalCalendarErrorMessage = '';
                return true;
            }
            else {
                this.internalCalendarErrorMessage = this.$i18n.translate('m-datepicker:out-of-range-error');
                return false;
            }
        }
        else {
            this.internalCalendarErrorMessage = this.$i18n.translate('m-datepicker:format-error');
            return false;
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDatepicker.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDatepicker.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__["MBaseCalendarView"].DAYS,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_8__["Enums"].toValueArray(_calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__["MBaseCalendarView"]).includes(value); }
        })
    ], MDatepicker.prototype, "initialView", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__["MBaseCalendarType"].FULL_DATE,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_8__["Enums"].toValueArray(_calendar_calendar_renderer_base_calendar_base_calendar__WEBPACK_IMPORTED_MODULE_15__["MBaseCalendarType"]).includes(value); }
        })
    ], MDatepicker.prototype, "type", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"]().subtract(10, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["DatePrecision"].YEAR); } })
    ], MDatepicker.prototype, "min", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["default"]().add(10, _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_10__["DatePrecision"].YEAR); } })
    ], MDatepicker.prototype, "max", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDatepicker.prototype, "placeholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputMaxWidth"].Small })
    ], MDatepicker.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MDatepicker.prototype, "hideInternalErrorMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MDatepicker.prototype, "skipInputValidation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('open')
    ], MDatepicker.prototype, "onOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close')
    ], MDatepicker.prototype, "onClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('blur')
    ], MDatepicker.prototype, "emitBlur", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MDatepicker.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('keydown')
    ], MDatepicker.prototype, "emitKeydown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('skipInputValidation')
    ], MDatepicker.prototype, "onSkipInputValidationChangement", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], MDatepicker.prototype, "onValueChange", null);
    MDatepicker = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _datepicker_html_style_datepicker_scss__WEBPACK_IMPORTED_MODULE_25___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["INPUT_MASK_NAME"]] = _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_19__["MInputMask"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_13__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_20__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_18__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_17__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_22__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_21__["MPopup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_16__["CALENDAR_NAME"]] = _calendar_calendar__WEBPACK_IMPORTED_MODULE_14__["MCalendar"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_23__["POPUP_NAME"]] = _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__["MPopupDirective"],
                _b),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_24__["InputManagement"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__["MediaQueries"]
            ]
        })
    ], MDatepicker);
    return MDatepicker;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__["ModulVue"]));

var DatepickerPlugin = {
    install: function (v) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_9__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_16__["DATEPICKER_NAME"], MDatepicker);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DatepickerPlugin);


/***/ }),

/***/ "./src/components/daterangepicker/daterangepicker.html":
/*!*************************************************************!*\
  !*** ./src/components/daterangepicker/daterangepicker.html ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-periodpicker",
    _vm._b(
      {
        ref: "periodpicker",
        attrs: {
          disabled: _vm.disabled,
          "convert-to-iso": _vm.convertToIso,
          waiting: _vm.waiting,
          error: _vm.error,
          valid: _vm.valid,
          readonly: _vm.readonly,
          "max-width": _vm.maxWidth,
          "error-message": _vm.errorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        },
        on: { input: _vm.updateValue },
        scopedSlots: _vm._u([
          {
            key: "first",
            fn: function(ref) {
              var props = ref.props
              var handlers = ref.handlers
              return _c(
                "m-datepicker",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        label: _vm.labelFrom,
                        "max-width": _vm.maxWidth,
                        "hide-internal-error-message":
                          _vm.hideInternalErrorMessage,
                        "skip-input-validation": _vm.skipInputValidation,
                        "required-marker": _vm.requiredMarker
                      }
                    },
                    "m-datepicker",
                    props,
                    false
                  ),
                  handlers
                )
              )
            }
          },
          {
            key: "second",
            fn: function(ref) {
              var props = ref.props
              var handlers = ref.handlers
              return _c(
                "m-datepicker",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        label: _vm.labelTo,
                        "max-width": _vm.maxWidth,
                        "hide-internal-error-message":
                          _vm.hideInternalErrorMessage,
                        "skip-input-validation": _vm.skipInputValidation,
                        "required-marker": _vm.requiredMarker
                      }
                    },
                    "m-datepicker",
                    props,
                    false
                  ),
                  handlers
                )
              )
            }
          }
        ])
      },
      "m-periodpicker",
      _vm.periodPickerProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-e7167126'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/daterangepicker/daterangepicker.ts":
/*!***********************************************************!*\
  !*** ./src/components/daterangepicker/daterangepicker.ts ***!
  \***********************************************************/
/*! exports provided: MDaterangepicker, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDaterangepicker", function() { return MDaterangepicker; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _datepicker_datepicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../datepicker/datepicker */ "./src/components/datepicker/datepicker.ts");
/* harmony import */ var _periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../periodpicker/periodpicker */ "./src/components/periodpicker/periodpicker.ts");
/* harmony import */ var _daterangepicker_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./daterangepicker.html */ "./src/components/daterangepicker/daterangepicker.html");
/* harmony import */ var _daterangepicker_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_daterangepicker_html__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var MDaterangepicker = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDaterangepicker, _super);
    function MDaterangepicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MDaterangepicker.prototype, "periodPickerProps", {
        get: function () {
            return { value: this.value, min: this.min, max: this.max };
        },
        enumerable: true,
        configurable: true
    });
    MDaterangepicker.prototype.updateValue = function (newValue) {
        return newValue;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDaterangepicker.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDaterangepicker.prototype, "min", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDaterangepicker.prototype, "max", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$i18n.translate('m-daterangepicker:label.from'); }
        })
    ], MDaterangepicker.prototype, "labelFrom", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$i18n.translate('m-daterangepicker:label.to'); }
        })
    ], MDaterangepicker.prototype, "labelTo", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: true
        })
    ], MDaterangepicker.prototype, "convertToIso", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputMaxWidth"].Small })
    ], MDaterangepicker.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MDaterangepicker.prototype, "hideInternalErrorMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MDaterangepicker.prototype, "skipInputValidation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('input')
    ], MDaterangepicker.prototype, "updateValue", null);
    MDaterangepicker = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _daterangepicker_html__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["DATEPICKER_NAME"]] = _datepicker_datepicker__WEBPACK_IMPORTED_MODULE_9__["MDatepicker"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["PERIODPICKER_NAME"]] = _periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_10__["MPeriodpicker"],
                _a),
            mixins: [
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__["InputLabel"],
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"]
            ]
        })
    ], MDaterangepicker);
    return MDaterangepicker;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var DaterangepickerPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["DATERANGEPICKER_NAME"], MDaterangepicker);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DaterangepickerPlugin);


/***/ }),

/***/ "./src/components/decimalfield/decimalfield.html?style=./decimalfield.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/decimalfield/decimalfield.html?style=./decimalfield.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=10a01209!./decimalfield.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=10a01209!./src/components/decimalfield/decimalfield.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-decimalfield",
      class: [
        {
          "m--is-disabled": _vm.isDisabled,
          "m--is-waiting": _vm.isWaiting,
          "m--is-readonly": _vm.isReadonly,
          "m--has-error": _vm.hasDecimalfieldError,
          "m--is-valid": _vm.isDecimalfieldValid,
          "m--has-label": _vm.hasLabel,
          "m--has-validation-message": _vm.hasValidationMessage
        }
      ],
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasDecimalfieldError,
            valid: _vm.isDecimalfieldValid,
            label: _vm.label,
            "label-for": _vm.id,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2),
          _vm._v(" "),
          _c("m-input-mask", {
            ref: "inputMask",
            staticClass: "m-decimalfield__input",
            attrs: {
              id: _vm.id,
              disabled: _vm.isDisabled || _vm.isWaiting,
              placeholder: _vm.placeholder,
              readonly: _vm.isReadonly,
              options: _vm.inputMaskOptions,
              inputmode: "decimal"
            },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              keyup: _vm.onKeyup,
              change: _vm.onChange
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _vm._v(" "),
          _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-decimalfield__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-decimalfield__validation__message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasDecimalfieldError,
              "error-message": _vm.errorMessage,
              valid: _vm.isDecimalfieldValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-10a01209'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/decimalfield/decimalfield.ts":
/*!*****************************************************!*\
  !*** ./src/components/decimalfield/decimalfield.ts ***!
  \*****************************************************/
/*! exports provided: MDecimalfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDecimalfield", function() { return MDecimalfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/l10n/l10n */ "./src/utils/l10n/l10n.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../input-mask/input-mask */ "./src/components/input-mask/input-mask.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _decimalfield_html_style_decimalfield_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./decimalfield.html?style=./decimalfield.scss */ "./src/components/decimalfield/decimalfield.html?style=./decimalfield.scss");
/* harmony import */ var _decimalfield_html_style_decimalfield_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_decimalfield_html_style_decimalfield_scss__WEBPACK_IMPORTED_MODULE_14__);
var _a;















var MDecimalfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDecimalfield, _super);
    function MDecimalfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mDecimalfield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_8__["default"].generate();
        _this.text = '';
        return _this;
    }
    Object.defineProperty(MDecimalfield.prototype, "hasDecimalfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDecimalfield.prototype, "isDecimalfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDecimalfield.prototype, "inputMaskOptions", {
        get: function () {
            var decimalFormat = this.$l10n.getDecimalFormat(this.currentLocale);
            return {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
                numeralIntegerScale: this.precision - this.rounding,
                numeralDecimalScale: this.rounding,
                numeralDecimalMark: decimalFormat.decimalMark,
                numeralPositiveOnly: true,
                stripLeadingZeroes: true,
                delimiter: decimalFormat.thousandSeparator,
                removeTrailingDecimalMark: true,
                forceDecimalScale: this.forceRoundingFormat
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDecimalfield.prototype, "currentLocale", {
        get: function () {
            return this.$i18n.currentLocale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDecimalfield.prototype, "model", {
        get: function () {
            return this.text;
        },
        set: function (value) {
            this.text = value;
            var valueAsNumber = Number.parseFloat(value);
            this.emitNewValue(valueAsNumber);
        },
        enumerable: true,
        configurable: true
    });
    MDecimalfield.prototype.onValueChange = function (newValue) {
        var currentTextAsNumber = Number.parseFloat(this.text);
        if (newValue !== currentTextAsNumber) {
            this.text = (!newValue && newValue !== 0 ? '' : newValue).toString();
        }
    };
    MDecimalfield.prototype.emitNewValue = function (_newValue) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDecimalfield.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 2
        })
    ], MDecimalfield.prototype, "rounding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 14
        })
    ], MDecimalfield.prototype, "precision", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MDecimalfield.prototype, "forceRoundingFormat", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], MDecimalfield.prototype, "onValueChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], MDecimalfield.prototype, "emitNewValue", null);
    MDecimalfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _decimalfield_html_style_decimalfield_scss__WEBPACK_IMPORTED_MODULE_14___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ],
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["INPUT_MASK_NAME"]] = _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_11__["MInputMask"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_13__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_12__["MInputStyle"],
                _a)
        })
    ], MDecimalfield);
    return MDecimalfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_9__["ModulVue"]));

var DecimalfieldPlugin = {
    install: function (v) {
        v.use(_utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_7__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_10__["DECIMALFIELD_NAME"], MDecimalfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DecimalfieldPlugin);


/***/ }),

/***/ "./src/components/dialog/dialog.html?style=./dialog.scss":
/*!***************************************************************!*\
  !*** ./src/components/dialog/dialog.html?style=./dialog.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=61559ce9!./dialog.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=61559ce9!./src/components/dialog/dialog.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "baseWindow", staticClass: "m-dialog" },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      _vm.portalCreated
        ? _c(
            "portal",
            { attrs: { "target-el": _vm.portalTargetSelector } },
            [
              _c("transition", { attrs: { name: "m--is" } }, [
                _vm.portalMounted
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propOpen,
                            expression: "propOpen"
                          }
                        ],
                        ref: "modalWrap",
                        staticClass: "m-dialog__wrap",
                        class: [
                          { "m--is-disabled": _vm.disabled },
                          _vm.className
                        ]
                      },
                      [
                        _c(
                          "article",
                          {
                            ref: "article",
                            staticClass: "m-dialog__article",
                            class: { "m--has-width-large": _vm.hasWidthLarge }
                          },
                          [
                            _vm.hasTitle
                              ? _c(
                                  "header",
                                  { staticClass: "m-dialog__header" },
                                  [_c("h2", [_vm._v(_vm._s(_vm.title))])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-dialog__body" }, [
                              _vm.state !== "default"
                                ? _c(
                                    "div",
                                    { staticClass: "m-dialog__state-icon" },
                                    [
                                      _c("m-message", {
                                        staticClass:
                                          "m-dialog__state-icon__message",
                                        attrs: {
                                          state: _vm.getState,
                                          skin: "page-light"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasDefaultSlot || _vm.hasMessage
                                ? _c(
                                    "div",
                                    { staticClass: "m-dialog__message" },
                                    [
                                      _vm.hasMessage
                                        ? _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(_vm.message)
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._t("default")
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasHint
                                ? _c("div", { staticClass: "m-dialog__hint" }, [
                                    _c(
                                      "div",
                                      { staticClass: "m-dialog__hint-body" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "m-dialog__hint-icon"
                                          },
                                          [
                                            _c("m-icon", {
                                              attrs: {
                                                name: "m-svg__hint",
                                                size: "32px"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "m-dialog__hint-text"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.hint))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "footer",
                              { staticClass: "m-dialog__footer" },
                              [
                                _vm._t("footer"),
                                _vm._v(" "),
                                !_vm.hasFooterSlot
                                  ? _c(
                                      "nav",
                                      { staticClass: "m-dialog__footer__nav" },
                                      [
                                        _c(
                                          "m-button",
                                          {
                                            style: _vm.dialogStyles,
                                            attrs: { skin: _vm.okButtonSkin },
                                            on: {
                                              click: function($event) {
                                                return _vm.onOk()
                                              }
                                            }
                                          },
                                          [
                                            _vm.hasOkLabel
                                              ? [_vm._v(_vm._s(_vm.okLabel))]
                                              : _c("m-i18n", {
                                                  attrs: { k: "m-dialog:ok" }
                                                }),
                                            _vm._v(" "),
                                            _vm.hasOkPrecision
                                              ? _c(
                                                  "template",
                                                  { slot: "precision" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.okPrecision) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.secBtn
                                          ? _c(
                                              "m-button",
                                              {
                                                style: _vm.dialogStyles,
                                                attrs: { skin: "secondary" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onSecondaryBtn()
                                                  }
                                                }
                                              },
                                              [
                                                _vm.hasSecBtnLabel
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(_vm.secBtnLabel)
                                                      )
                                                    ]
                                                  : _c("m-i18n", {
                                                      attrs: {
                                                        k: "m-dialog:cancel"
                                                      }
                                                    }),
                                                _vm._v(" "),
                                                _vm.hasSecBtnPrecision
                                                  ? _c(
                                                      "template",
                                                      { slot: "precision" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.secBtnPrecision
                                                          ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.negativeLink
                                          ? _c(
                                              "m-link",
                                              {
                                                attrs: { mode: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onCancel()
                                                  }
                                                }
                                              },
                                              [
                                                _vm.hasCancelLabel
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(_vm.cancelLabel)
                                                      )
                                                    ]
                                                  : _c("m-i18n", {
                                                      attrs: {
                                                        k: "m-dialog:cancel"
                                                      }
                                                    })
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-61559ce9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/dialog/dialog.ts":
/*!*****************************************!*\
  !*** ./src/components/dialog/dialog.ts ***!
  \*****************************************/
/*! exports provided: MDialogWidth, MDialogState, MDialog, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDialogWidth", function() { return MDialogWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDialogState", function() { return MDialogState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDialog", function() { return MDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_dialog_dialog_service_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/dialog/dialog-service.plugin */ "./src/utils/dialog/dialog-service.plugin.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _dialog_html_style_dialog_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./dialog.html?style=./dialog.scss */ "./src/components/dialog/dialog.html?style=./dialog.scss");
/* harmony import */ var _dialog_html_style_dialog_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_dialog_html_style_dialog_scss__WEBPACK_IMPORTED_MODULE_12__);
var _a;













var MDialogWidth;
(function (MDialogWidth) {
    MDialogWidth["Default"] = "default";
    MDialogWidth["Large"] = "large";
})(MDialogWidth || (MDialogWidth = {}));
var MDialogState;
(function (MDialogState) {
    MDialogState["Default"] = "default";
    MDialogState["Warning"] = "warning";
    MDialogState["Confirmation"] = "confirmation";
    MDialogState["Information"] = "information";
    MDialogState["Error"] = "error";
})(MDialogState || (MDialogState = {}));
var MDialog = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDialog, _super);
    function MDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDialog.prototype.handlesFocus = function () {
        return true;
    };
    MDialog.prototype.openDialog = function () {
        this.as().propOpen = true;
    };
    MDialog.prototype.doCustomPropOpen = function (value) {
        return false;
    };
    MDialog.prototype.getBackdropMode = function () {
        return _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["BackdropMode"].BackdropFast;
    };
    MDialog.prototype.getPortalElement = function () {
        return this.$refs.article;
    };
    MDialog.prototype.onOk = function (event) {
        this.as().propOpen = false;
    };
    MDialog.prototype.onSecondaryBtn = function (event) {
        this.as().propOpen = false;
    };
    MDialog.prototype.onCancel = function (event) {
        this.as().propOpen = false;
    };
    Object.defineProperty(MDialog.prototype, "hasDefaultSlot", {
        get: function () {
            return !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasFooterSlot", {
        get: function () {
            return !!this.$slots.footer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasHint", {
        get: function () {
            return !!this.hint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasTitle", {
        get: function () {
            return !!this.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasMessage", {
        get: function () {
            return !!this.message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasOkLabel", {
        get: function () {
            return !!this.okLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasOkPrecision", {
        get: function () {
            return !!this.okPrecision;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasSecBtnLabel", {
        get: function () {
            return !!this.secBtnLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasSecBtnPrecision", {
        get: function () {
            return !!this.secBtnPrecision;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "dialogStyles", {
        get: function () {
            return { 'width': this.btnWidth };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasCancelLabel", {
        get: function () {
            return !!this.cancelLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "hasWidthLarge", {
        get: function () {
            return this.width === MDialogWidth.Large;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDialog.prototype, "getState", {
        get: function () {
            var state = '';
            switch (this.state) {
                case MDialogState.Confirmation:
                    state = 'confirmation';
                    break;
                case MDialogState.Information:
                    state = 'information';
                    break;
                case MDialogState.Warning:
                    state = 'warning';
                    break;
                case MDialogState.Error:
                    state = 'error';
                    break;
                default:
                    break;
            }
            return state;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "message", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "okLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "okPrecision", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _button_button__WEBPACK_IMPORTED_MODULE_6__["MButtonSkin"].Primary })
    ], MDialog.prototype, "okButtonSkin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MDialog.prototype, "secBtn", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "secBtnLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "secBtnPrecision", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '100%' })
    ], MDialog.prototype, "btnWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "cancelLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MDialog.prototype, "negativeLink", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDialog.prototype, "hint", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MDialogWidth.Default,
            validator: function (value) {
                return value === MDialogWidth.Default ||
                    value === MDialogWidth.Large;
            }
        })
    ], MDialog.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MDialogState.Default,
            validator: function (value) {
                return value === MDialogState.Default ||
                    value === MDialogState.Warning ||
                    value === MDialogState.Confirmation ||
                    value === MDialogState.Information ||
                    value === MDialogState.Error;
            }
        })
    ], MDialog.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('ok')
    ], MDialog.prototype, "onOk", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('secondaryBtn')
    ], MDialog.prototype, "onSecondaryBtn", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('cancel')
    ], MDialog.prototype, "onCancel", null);
    MDialog = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _dialog_html_style_dialog_scss__WEBPACK_IMPORTED_MODULE_12___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_6__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_10__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["MESSAGE_NAME"]] = _message_message__WEBPACK_IMPORTED_MODULE_11__["MMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_9__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_8__["MI18n"],
                _a),
            mixins: [_mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["Portal"]]
        })
    ], MDialog);
    return MDialog;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var DialogPlugin = {
    install: function (v, options) {
        v.use(_utils_dialog_dialog_service_plugin__WEBPACK_IMPORTED_MODULE_4__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["DIALOG_NAME"], MDialog);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DialogPlugin);


/***/ }),

/***/ "./src/components/dropdown/dropdown-item/dropdown-item.html?style=./dropdown-item.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/dropdown/dropdown-item/dropdown-item.html?style=./dropdown-item.scss ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=08b4e269!./dropdown-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=08b4e269!./src/components/dropdown/dropdown-item/dropdown-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.filtered || _vm.inactive
    ? _c(
        "li",
        {
          staticClass: "m-dropdown-item",
          class: {
            "m--is-selected": _vm.selected,
            "m--is-disabled": _vm.disabled,
            "m--is-inactive": _vm.inactive,
            "m--is-focus": _vm.focused,
            "m--readonly": _vm.readonly
          },
          attrs: {
            role: "option",
            "aria-selected": _vm.selected,
            tabindex: _vm.tabindex
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onClick($event)
            }
          }
        },
        [
          _vm.isMqMinS || _vm.readonly
            ? _c(
                "span",
                { staticClass: "m-dropdown-item__element-text" },
                [_vm._t("default", [_vm._v(_vm._s(_vm.propLabel))])],
                2
              )
            : _c(
                "m-radio-style",
                {
                  attrs: {
                    "full-width": true,
                    "radio-position": "right",
                    focus: _vm.focused,
                    checked: _vm.selected,
                    disabled: _vm.disabled,
                    tabindex: "0"
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "m-dropdown-item__element-text" },
                    [_vm._t("default", [_vm._v(_vm._s(_vm.propLabel))])],
                    2
                  )
                ]
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-08b4e269'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/dropdown/dropdown-item/dropdown-item.ts":
/*!****************************************************************!*\
  !*** ./src/components/dropdown/dropdown-item/dropdown-item.ts ***!
  \****************************************************************/
/*! exports provided: BaseDropdown, BaseDropdownGroup, MDropdownItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseDropdown", function() { return BaseDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseDropdownGroup", function() { return BaseDropdownGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDropdownItem", function() { return MDropdownItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_str_str__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/str/str */ "./src/utils/str/str.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _radio_style_radio_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../radio-style/radio-style */ "./src/components/radio-style/radio-style.ts");
/* harmony import */ var _dropdown_item_html_style_dropdown_item_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dropdown-item.html?style=./dropdown-item.scss */ "./src/components/dropdown/dropdown-item/dropdown-item.html?style=./dropdown-item.scss");
/* harmony import */ var _dropdown_item_html_style_dropdown_item_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dropdown_item_html_style_dropdown_item_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var BaseDropdown = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseDropdown, _super);
    function BaseDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseDropdown;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var BaseDropdownGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseDropdownGroup, _super);
    function BaseDropdownGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseDropdownGroup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var MDropdownItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDropdownItem, _super);
    function MDropdownItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDropdownItem.prototype.created = function () {
        var rootNode = this.getParent(function (p) { return p instanceof BaseDropdown; });
        if (rootNode) {
            this.root = rootNode;
        }
        else {
            console.error('m-dropdown-item need to be inside m-dropdown');
        }
        this.group = this.getParent(function (p) { return p instanceof BaseDropdownGroup; });
    };
    Object.defineProperty(MDropdownItem.prototype, "filtered", {
        get: function () {
            if (this.propLabel && !this.nonFilterable) {
                return !this.root.matchFilter(Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_4__["normalizeString"])(this.propLabel));
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdownItem.prototype, "inactive", {
        get: function () {
            return this.value === undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdownItem.prototype, "propLabel", {
        // Value and label rules
        // - If Value and Label : Value = value, Label = label
        // - If only value : value = value, label = value.toString
        // - If only label : value = label, label = label
        // - If none: value = undef, label = undef and item is flag inactive
        get: function () {
            if (this.label) {
                return this.label;
            }
            else if (this.value) {
                if (typeof this.value === 'string') {
                    return this.value;
                }
                else {
                    return JSON.stringify(this.value);
                }
            }
            else {
                return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdownItem.prototype, "selected", {
        get: function () {
            return this.root.model === this.value && !this.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdownItem.prototype, "focused", {
        get: function () {
            return this.root.focused === this.value && !this.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdownItem.prototype, "tabindex", {
        get: function () {
            return this.disabled || this.readonly ? undefined : 0;
        },
        enumerable: true,
        configurable: true
    });
    MDropdownItem.prototype.onClick = function () {
        if (!this.inactive && !this.root.inactive && !this.disabled) {
            this.root.model = this.value;
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDropdownItem.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDropdownItem.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDropdownItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDropdownItem.prototype, "readonly", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MDropdownItem.prototype, "nonFilterable", void 0);
    MDropdownItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _dropdown_item_html_style_dropdown_item_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["RADIO_STYLE_NAME"]] = _radio_style_radio_style__WEBPACK_IMPORTED_MODULE_7__["MRadioStyle"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["MediaQueries"]]
        })
    ], MDropdownItem);
    return MDropdownItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));



/***/ }),

/***/ "./src/components/dropdown/dropdown.html?style=./dropdown.scss":
/*!*********************************************************************!*\
  !*** ./src/components/dropdown/dropdown.html?style=./dropdown.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6b5f25ee!./dropdown.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6b5f25ee!./src/components/dropdown/dropdown.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "mDropdown",
      staticClass: "m-dropdown",
      class: {
        "m--is-open": _vm.open,
        "m--is-disabled": _vm.isDisabled,
        "m--is-readonly": _vm.isReadonly,
        "m--is-waiting": _vm.isWaiting,
        "m--has-placeholder-icon": _vm.hasPlaceholderIcon,
        "m--has-validation-message": _vm.hasValidationMessage
      },
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
    },
    [
      _c(
        "m-input-style",
        {
          directives: [
            { name: "m-popup", rawName: "v-m-popup:popup", arg: "popup" }
          ],
          ref: "mInputStyle",
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            disabled: _vm.isDisabled,
            readonly: _vm.isReadonly,
            waiting: _vm.isWaiting,
            focus: _vm.internalIsFocus,
            "label-up": _vm.internallLabelUp,
            empty: _vm.isEmpty,
            error: _vm.hasError,
            "cursor-pointer": _vm.hasPointer,
            valid: _vm.isValid,
            "required-marker": _vm.requiredMarker,
            width: _vm.inputStyletWidth,
            "tag-style": _vm.tagStyle
          },
          on: { click: _vm.onOpen }
        },
        [
          _vm.hasPlaceholderIcon
            ? _c("m-icon", {
                staticClass: "m-dropdown__placeholder-icon",
                attrs: {
                  "aria-hidden": "true",
                  name: "m-svg__search",
                  size: "16px"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.selectedText,
                expression: "selectedText",
                modifiers: { trim: true }
              }
            ],
            ref: "input",
            staticClass: "m-dropdown__input",
            attrs: {
              type: "text",
              id: _vm.id,
              "aria-haspopup": "true",
              "aria-controls": _vm.ariaControls,
              "aria-expanded": _vm.open,
              disabled: !_vm.active,
              readonly: !_vm.filterableDesktop || _vm.isReadonly,
              placeholder: _vm.internalPlaceholder,
              maxlength: _vm.maxLength,
              autocomplete: _vm.autocomplete
            },
            domProps: { value: _vm.selectedText },
            on: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.onKeydownEnter($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k(
                      $event.keyCode,
                      "return",
                      undefined,
                      $event.key,
                      undefined
                    )
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.onKeydownEnter($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onKeydownEsc($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.onKeydownUp($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.onKeydownDown($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.onKeydownTab($event)
                },
                _vm.inputOnKeydown
              ],
              focusin: _vm.onFocusIn,
              focusout: _vm.onFocusOut,
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.selectedText = $event.target.value.trim()
                },
                _vm.onInput
              ],
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.width === "auto"
            ? _c("template", { slot: "adjust-width-auto" }, [
                _vm._v(_vm._s(_vm.selectedText))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showArrowIcon
            ? _c(
                "div",
                {
                  staticClass: "m-dropdown__arrow",
                  class: { "m--is-open": _vm.open },
                  attrs: { slot: "suffix" },
                  slot: "suffix"
                },
                [
                  _c(
                    "m-icon",
                    {
                      ref: "arrow",
                      staticClass: "m-dropdown__arrow__icon",
                      attrs: {
                        name: "m-svg__arrow-head-filled--down",
                        size: "12px",
                        disabled: !_vm.active
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.open = _vm.active
                        }
                      }
                    },
                    [
                      !_vm.open
                        ? _c("m-i18n", { attrs: { k: "m-dropdown:open" } })
                        : _c("m-i18n", { attrs: { k: "m-dropdown:close" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("m-validation-message", {
        staticClass: "m-dropdown__validation-message",
        attrs: {
          disabled: _vm.isDisabled,
          waiting: _vm.isWaiting,
          error: _vm.hasError,
          valid: _vm.isValid,
          "error-message": _vm.errorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      }),
      _vm._v(" "),
      _c(
        "m-popup",
        {
          ref: "popup",
          attrs: {
            width: "100%",
            placement: "bottom-start",
            open: _vm.open,
            disabled: !_vm.active,
            enter: _vm.transitionEnter,
            leave: _vm.transitionLeave,
            padding: false,
            "focus-management": false,
            "close-on-backdrop": true,
            preload: true,
            "open-trigger": "mousedown",
            lazy: false,
            "sidebar-full-height": _vm.filterable
          },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            },
            open: _vm.onOpen,
            close: _vm.onClose,
            "portal-mounted": _vm.portalMounted
          }
        },
        [
          _vm.isMqMaxS && (_vm.hasLabel || _vm.filterable)
            ? _c("template", { slot: "header" }, [
                _vm.hasLabel
                  ? _c("h2", { staticClass: "m-dropdown__header__label" }, [
                      _vm._v(_vm._s(_vm.label))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filterable
                  ? _c(
                      "div",
                      { staticClass: "m-dropdown__header__research" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.selectedText,
                              expression: "selectedText",
                              modifiers: { trim: true }
                            }
                          ],
                          ref: "researchInput",
                          staticClass: "m-dropdown__header__research-input",
                          attrs: {
                            type: "text",
                            placeholder: _vm._f("f-m-i18n")(
                              "m-dropdown:search"
                            ),
                            "max-length": _vm.maxLength
                          },
                          domProps: { value: _vm.selectedText },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.selectedText = $event.target.value.trim()
                              },
                              _vm.onInput
                            ],
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "m-icon-button",
                          {
                            staticClass: "m-dropdown__header__research-button",
                            attrs: { "icon-name": "m-svg__search" },
                            on: { click: _vm.focusOnResearchInput }
                          },
                          [
                            _c("m-i18n", {
                              attrs: { k: "m-dropdown:research" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            {
              ref: "items",
              staticClass: "m-dropdown__list",
              attrs: {
                id: _vm.ariaControls,
                "aria-labelledby": _vm.id,
                "aria-live": "polite"
              },
              on: { mouseup: _vm.selectText }
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              !_vm.hasItems && !_vm.dirty && _vm.includeFilterableStatusItems
                ? _c("m-dropdown-item", { attrs: { readonly: true } }, [
                    _vm._v(_vm._s(_vm.propTextNoData))
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasItems && _vm.dirty && _vm.includeFilterableStatusItems
                ? _c("m-dropdown-item", { attrs: { readonly: true } }, [
                    _vm._v(_vm._s(_vm.propTextNoMatch))
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.hasFooterSlot
            ? _c("template", { slot: "footer" }, [_vm._t("footer")], 2)
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-6b5f25ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/dropdown/dropdown.ts":
/*!*********************************************!*\
  !*** ./src/components/dropdown/dropdown.ts ***!
  \*********************************************/
/*! exports provided: MDropdown, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDropdown", function() { return MDropdown; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_popup_popup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../directives/popup/popup */ "./src/directives/popup/popup.ts");
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_popup_input_popup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixins/input-popup/input-popup */ "./src/mixins/input-popup/input-popup.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_str_str__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../utils/str/str */ "./src/utils/str/str.ts");
/* harmony import */ var _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../utils/user-agent/user-agent */ "./src/utils/user-agent/user-agent.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./dropdown-item/dropdown-item */ "./src/components/dropdown/dropdown-item/dropdown-item.ts");
/* harmony import */ var _dropdown_html_style_dropdown_scss__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./dropdown.html?style=./dropdown.scss */ "./src/components/dropdown/dropdown.html?style=./dropdown.scss");
/* harmony import */ var _dropdown_html_style_dropdown_scss__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_dropdown_html_style_dropdown_scss__WEBPACK_IMPORTED_MODULE_27__);
var _a, _b, _c;




























var DROPDOWN_STYLE_TRANSITION = 'max-height 0.3s ease';
var MDropdown = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDropdown, _super);
    function MDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalFilter = '';
        _this.internalFilterRegExp = / /;
        _this.internalItems = [];
        _this.internalSelectedText = '';
        _this.internalIsFocus = false;
        _this.focusedIndex = -1;
        _this.internalOpen = false;
        _this.dirty = false;
        _this.id = "mDropdown-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_16__["default"].generate();
        return _this;
    }
    MDropdown.prototype.onForceOpenUpdate = function () {
        if (this.forceOpen) {
            this.internalOpen = this.forceOpen;
        }
    };
    MDropdown.prototype.matchFilter = function (text) {
        var result = true;
        if (text !== undefined && this.dirty && (this.internalFilterRegExp)) {
            result = this.internalFilterRegExp.test(text);
        }
        return result;
    };
    MDropdown.prototype.onFocusIn = function () {
        if (!this.filterable) {
            this.$refs.input.setSelectionRange(0, 0);
        }
        this.internalIsFocus = true;
    };
    MDropdown.prototype.onFocusOut = function () {
        this.internalIsFocus = false;
    };
    Object.defineProperty(MDropdown.prototype, "filterableDesktop", {
        get: function () {
            return this.filterable && this.as().isMqMinS;
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.groupHasItems = function (group) {
        return this.internalItems.some(function (i) {
            return i.group === group;
        });
    };
    MDropdown.prototype.created = function () {
        this.setInternalValue(this.value);
    };
    MDropdown.prototype.mounted = function () {
        if (this.focus) {
            this.focusChanged(this.focus);
        }
    };
    MDropdown.prototype.beforeDestroy = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    Object.defineProperty(MDropdown.prototype, "open", {
        get: function () {
            return this.internalOpen;
        },
        set: function (value) {
            if (value && value !== this.internalOpen) {
                this.focusedIndex = -1;
            }
            if (this.as().active) {
                this.internalOpen = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.onOpen = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var inputEl;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        inputEl = this.$refs.input;
                        setTimeout(function () {
                            if (!(_this.filterable && _this.as().isMqMaxS)) {
                                inputEl.focus();
                            }
                        }, 200);
                        this.focusSelected();
                        this.scrollToFocused();
                        return [2 /*return*/];
                }
            });
        });
    };
    MDropdown.prototype.onClose = function () {
        var hasMatch = this.matchFilterTextToValue();
        this.internalFilter = '';
        this.dirty = false;
        this.internalFilterRegExp = / /;
        if (this.clearInvalidSelectionOnClose && !hasMatch && this.selectedText === '') {
            this.$emit('input', '');
            this.setModel('', true);
        }
    };
    MDropdown.prototype.setInternalValue = function (value) {
        this.setModel(value, false);
    };
    MDropdown.prototype.focusChanged = function (focus) {
        if (focus && !this.as().isDisabled) {
            this.selectText();
        }
        else {
            if (!this.isAndroid) {
                this.$refs.input.blur();
            }
            this.internalOpen = false;
        }
    };
    MDropdown.prototype.matchFilterTextToValue = function () {
        var _this = this;
        if (this.filterable && this.internalFilter !== '') {
            var value_1 = '';
            this.internalItems.every(function (item) {
                if (item.propLabel && Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_14__["normalizeString"])(item.propLabel) === Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_14__["normalizeString"])(_this.internalFilter)) {
                    value_1 = item.value;
                    return false;
                }
                return true;
            });
            if (value_1 !== '') {
                this.model = value_1;
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(MDropdown.prototype, "model", {
        get: function () {
            return this.value === undefined ? this.as().internalValue : this.value;
        },
        set: function (value) {
            this.setModel(value, true);
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.setModel = function (value, emit) {
        this.as().internalValue = value;
        if (emit) {
            this.$emit('change', value);
        }
        this.dirty = false;
        if (value !== '') {
            this.internalOpen = false;
        }
        this.setInputWidth();
    };
    Object.defineProperty(MDropdown.prototype, "internalPlaceholder", {
        get: function () {
            if (this.as().isReadonly) {
                return '';
            }
            else {
                return this.as().placeholder;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "internallLabelUp", {
        get: function () {
            if (this.as().isReadonly) {
                return true;
            }
            else {
                return this.as().labelUp;
            }
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.portalMounted = function () {
        var _this = this;
        this.buildItemsMap();
        this.observer = new MutationObserver(function () {
            _this.buildItemsMap();
        });
        if (this.$refs.items) {
            // todo: mobile
            this.observer.observe(this.$refs.items, { subtree: true, childList: true });
        }
    };
    MDropdown.prototype.setInputWidth = function () {
        var _this = this;
        this.$nextTick(function () {
            if (_this.$refs.mInputStyle) {
                _this.$refs.mInputStyle.setInputWidth();
            }
        });
    };
    Object.defineProperty(MDropdown.prototype, "inputStyletWidth", {
        get: function () {
            return this.as().inputWidth === 'auto' && this.as().maxWidth === 'none' ? 'auto' : '100%';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "focused", {
        get: function () {
            return this.focusedIndex > -1 ? this.internalNavigationItems[this.focusedIndex].value : this.model;
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.onIsMqMaxS = function (value, old) {
        var _this = this;
        if (value !== old) {
            this.$nextTick(function () { return _this.buildItemsMap(); });
        }
    };
    Object.defineProperty(MDropdown.prototype, "selectedText", {
        get: function () {
            var _this = this;
            var result = '';
            if (this.dirty || this.internalFilter) {
                result = this.internalFilter;
            }
            else if (this.internalItems.every(function (item) {
                if (item.value === _this.model) {
                    result = item.propLabel;
                    return false;
                }
                return true;
            })) {
                result = '';
            }
            return result;
        },
        set: function (value) {
            this.dirty = true;
            if (this.clearModelOnSelectedText) {
                this.$emit('change', '');
                this.as().internalValue = value;
            }
            this.internalFilter = value;
            var parsedQuery = Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_14__["normalizeString"])(this.internalFilter).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
            this.internalFilterRegExp = new RegExp(parsedQuery, 'i');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "isEmpty", {
        get: function () {
            return (this.filterable && this.open) || this.as().hasValue || (this.as().hasPlaceholder() && this.open) ? false : true;
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.buildItemsMap = function () {
        this.focusedIndex = -1;
        // all visible items
        var items = [];
        // items that can be reached with the keyboard (!disabled)
        var navigation = [];
        this.$refs.popup.$children[0].$children.forEach(function (item) {
            if (item instanceof _dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_26__["MDropdownItem"] && !item.inactive && !item.filtered) {
                items.push(item);
                if (!item.disabled) {
                    navigation.push(item);
                }
            }
        });
        this.internalItems = items;
        this.internalNavigationItems = navigation;
        this.focusSelected();
    };
    Object.defineProperty(MDropdown.prototype, "propTextNoData", {
        get: function () {
            return (this.textNoData ? this.textNoData : this.$i18n.translate('m-dropdown:no-data'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "propTextNoMatch", {
        get: function () {
            return (this.textNoMatch ? this.textNoMatch : this.$i18n.translate('m-dropdown:no-result'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "hasItems", {
        get: function () {
            return this.internalItems.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "ariaControls", {
        get: function () {
            return this.id + '-controls';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "inactive", {
        get: function () {
            return this.as().isDisabled || this.as().isReadonly || this.as().isWaiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "hasFooterSlot", {
        get: function () {
            return !!this.$slots.footer;
        },
        enumerable: true,
        configurable: true
    });
    MDropdown.prototype.onKeydownUp = function ($event) {
        if (!this.open) {
            this.open = true;
        }
        else {
            this.focusPreviousItem();
        }
    };
    MDropdown.prototype.onKeydownDown = function ($event) {
        if (!this.open) {
            this.open = true;
        }
        else {
            this.focusNextItem();
        }
    };
    MDropdown.prototype.onKeydownEnter = function ($event) {
        if (!this.open) {
            this.open = true;
        }
        if (this.focusedIndex > -1) {
            var item = this.internalNavigationItems[this.focusedIndex];
            this.model = item.value;
        }
        this.selectText();
    };
    MDropdown.prototype.onKeydownTab = function ($event) {
        if (this.as().isMqMinS) {
            if (this.focusedIndex > -1 && this.internalItems.length === 1) {
                var item = this.internalNavigationItems[this.focusedIndex];
                this.model = item.value;
            }
            this.open = false;
        }
    };
    MDropdown.prototype.onKeydownEsc = function () {
        this.open = false;
    };
    MDropdown.prototype.onInput = function (value) {
        this.$emit('input', value.target.value);
    };
    MDropdown.prototype.focusOnResearchInput = function () {
        this.$refs.researchInput.focus();
    };
    MDropdown.prototype.selectText = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (!this.isAndroid) {
                            this.$refs.input.focus();
                        }
                        else {
                            this.internalIsFocus = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MDropdown.prototype.focusSelected = function () {
        var _this = this;
        this.internalNavigationItems.every(function (item, i) {
            if (item.value === _this.model) {
                _this.focusedIndex = i;
                return false;
            }
            else if (_this.filterable && _this.internalFilter !== '' && _this.model === undefined) {
                _this.focusedIndex = 0;
                return false;
            }
            else {
                _this.focusedIndex = -1;
                return true;
            }
        });
        if (this.focusedIndex === -1) {
            this.focusNextItem();
        }
    };
    MDropdown.prototype.focusNextItem = function () {
        if (!this.hasItems) {
            return;
        }
        if (this.focusedIndex > -1) {
            this.focusedIndex++;
            if (this.focusedIndex >= this.internalNavigationItems.length) {
                this.focusedIndex = 0;
            }
        }
        else {
            this.focusedIndex = this.internalNavigationItems.length === 0 ? -1 : 0;
        }
        this.scrollToFocused();
    };
    MDropdown.prototype.focusPreviousItem = function () {
        if (!this.hasItems) {
            return;
        }
        if (this.focusedIndex > -1) {
            this.focusedIndex--;
            if (this.focusedIndex < 0) {
                this.focusedIndex = this.internalNavigationItems.length - 1;
            }
        }
        else {
            this.focusedIndex = this.internalNavigationItems.length - 1;
        }
        this.scrollToFocused();
    };
    MDropdown.prototype.scrollToFocused = function () {
        var _this = this;
        if (!this.hasItems) {
            return;
        }
        if (this.focusedIndex > -1 && this.as().isMqMinS) {
            this.$nextTick(function () {
                var container = _this.$refs.items;
                if (container) {
                    var focusedItem = _this.internalNavigationItems[_this.focusedIndex];
                    var top = focusedItem.$el.offsetTop;
                    var bottom = focusedItem.$el.offsetTop + focusedItem.$el.offsetHeight;
                    var viewRectTop = container.scrollTop;
                    var viewRectBottom = viewRectTop + container.clientHeight;
                    if (top < viewRectTop) {
                        container.scrollTop = top;
                    }
                    else if (bottom > viewRectBottom) {
                        container.scrollTop = bottom - container.clientHeight;
                    }
                }
            });
        }
    };
    MDropdown.prototype.transitionEnter = function (el, done) {
        var _this = this;
        this.$nextTick(function () {
            el.style.opacity = '0';
            el.style.width = _this.$el.clientWidth + 'px';
            setTimeout(function () {
                if (_this.as().isMqMinS) {
                    var height_1 = el.clientHeight;
                    // tslint:disable-next-line: deprecation
                    el.style.webkitTransition = DROPDOWN_STYLE_TRANSITION;
                    el.style.transition = DROPDOWN_STYLE_TRANSITION;
                    el.style.overflowY = 'hidden';
                    if (_this.enableAnimation) {
                        el.style.maxHeight = '0';
                    }
                    el.style.width = _this.$el.clientWidth + 'px';
                    el.style.minWidth = _this.listMinWidth;
                    el.style.removeProperty('opacity');
                    setTimeout(function () {
                        if (_this.enableAnimation) {
                            el.style.maxHeight = height_1 + 'px';
                        }
                        done();
                    }, 0);
                }
                else {
                    done();
                }
            }, 0);
        });
    };
    MDropdown.prototype.transitionLeave = function (el, done) {
        var _this = this;
        this.$nextTick(function () {
            if (_this.as().isMqMinS) {
                var height = el.clientHeight;
                el.style.width = _this.$el.clientWidth + 'px';
                el.style.minWidth = _this.listMinWidth;
                if (_this.enableAnimation) {
                    el.style.maxHeight = height + 'px';
                    el.style.maxHeight = '0';
                }
                setTimeout(function () {
                    if (_this.enableAnimation) {
                        el.style.maxHeight = 'none';
                    }
                    done();
                }, 300);
            }
            else {
                done();
            }
        });
    };
    Object.defineProperty(MDropdown.prototype, "hasPointer", {
        get: function () {
            return !this.as().isDisabled &&
                !this.as().isReadonly &&
                (!this.filterable || (this.filterable && !this.open));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "hasPlaceholderIcon", {
        get: function () {
            if (_utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isEdge() && !_utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isBlink()) {
                return this.filterable && this.selectedText === '' && !this.as().isReadonly && this.isEdgeSupport;
            }
            else if (_utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isGecko() && !_utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isBlink()) {
                return this.filterable && this.selectedText === '' && !this.as().isReadonly && this.isFirefoxSupport;
            }
            else {
                return this.filterable && this.selectedText === '' && !this.as().isReadonly;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "isEdgeSupport", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isEdge() && this.as().placeholder === '' || this.as().placeholder === undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "isFirefoxSupport", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isGecko() && this.as().placeholder === '' || this.as().placeholder === undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDropdown.prototype, "isAndroid", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_15__["default"].isAndroid();
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "filterable", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "textNoData", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "textNoMatch", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "listMinWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "forceOpen", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDropdown.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MDropdown.prototype, "showArrowIcon", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MDropdown.prototype, "enableAnimation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MDropdown.prototype, "includeFilterableStatusItems", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MDropdown.prototype, "clearInvalidSelectionOnClose", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MDropdown.prototype, "clearModelOnSelectedText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('forceOpen')
    ], MDropdown.prototype, "onForceOpenUpdate", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('open')
    ], MDropdown.prototype, "onOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('close')
    ], MDropdown.prototype, "onClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('value')
    ], MDropdown.prototype, "setInternalValue", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('focus')
    ], MDropdown.prototype, "focusChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('isMqMaxS')
    ], MDropdown.prototype, "onIsMqMaxS", null);
    MDropdown = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _dropdown_html_style_dropdown_scss__WEBPACK_IMPORTED_MODULE_27___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_17__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_22__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_21__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_20__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_19__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_24__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_23__["MPopup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_18__["DROPDOWN_ITEM_NAME"]] = _dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_26__["MDropdownItem"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_4__["POPUP_NAME"]] = _directives_popup_popup__WEBPACK_IMPORTED_MODULE_5__["MPopupDirective"],
                _b),
            filters: (_c = {},
                _c[_filters_filter_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["i18nFilter"],
                _c),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_10__["InputState"],
                _mixins_input_popup_input_popup__WEBPACK_IMPORTED_MODULE_9__["InputPopup"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_12__["MediaQueries"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_25__["InputManagement"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_11__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_8__["InputLabel"]
            ]
        })
    ], MDropdown);
    return MDropdown;
}(_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_26__["BaseDropdown"]));

var DropdownPlugin = {
    install: function (v, options) {
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_13__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_18__["DROPDOWN_ITEM_NAME"], _dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_26__["MDropdownItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_18__["DROPDOWN_NAME"], MDropdown);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DropdownPlugin);


/***/ }),

/***/ "./src/components/dynamic-template/dynamic-template.html":
/*!***************************************************************!*\
  !*** ./src/components/dynamic-template/dynamic-template.html ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.internalTemplate, { tag: "component" })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-7b1637ae'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/dynamic-template/dynamic-template.ts":
/*!*************************************************************!*\
  !*** ./src/components/dynamic-template/dynamic-template.ts ***!
  \*************************************************************/
/*! exports provided: MDynamicTemplate, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDynamicTemplate", function() { return MDynamicTemplate; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _dynamic_template_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dynamic-template.html */ "./src/components/dynamic-template/dynamic-template.html");
/* harmony import */ var _dynamic_template_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dynamic_template_html__WEBPACK_IMPORTED_MODULE_6__);







var MDynamicTemplate = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDynamicTemplate, _super);
    function MDynamicTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = 'm-dt-' + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        return _this;
    }
    MDynamicTemplate.prototype.mounted = function () {
        this.$emit('mounted', this.$children);
    };
    MDynamicTemplate.prototype.updated = function () {
        this.$emit('updated', this.$children);
    };
    Object.defineProperty(MDynamicTemplate.prototype, "internalTemplate", {
        get: function () {
            if (typeof this.template === 'string') {
                if (vue__WEBPACK_IMPORTED_MODULE_1___default.a.compile !== undefined) {
                    vue__WEBPACK_IMPORTED_MODULE_1___default.a.component(this.tag, {
                        template: "<div>" + this.template + "</div>"
                    });
                }
                else {
                    var innerHTML_1 = this.template;
                    vue__WEBPACK_IMPORTED_MODULE_1___default.a.component(this.tag, {
                        render: function (createElement) {
                            return createElement('div', { domProps: { innerHTML: innerHTML_1 } });
                        }
                    });
                }
            }
            else {
                vue__WEBPACK_IMPORTED_MODULE_1___default.a.component(this.tag, this.template);
            }
            return this.tag;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MDynamicTemplate.prototype, "template", void 0);
    MDynamicTemplate = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _dynamic_template_html__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MDynamicTemplate);
    return MDynamicTemplate;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var DynamicTemplatePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["DYNAMIC_TEMPLATE_NAME"], MDynamicTemplate);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicTemplatePlugin);


/***/ }),

/***/ "./src/components/empty-area/empty-area.html?style=./empty-area.scss":
/*!***************************************************************************!*\
  !*** ./src/components/empty-area/empty-area.html?style=./empty-area.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=01901aee!./empty-area.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=01901aee!./src/components/empty-area/empty-area.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-empty-area",
      class: [
        "m--is-background-style-" + _vm.backgroundStyle,
        "m--is-display-mode-" + _vm.displayMode,
        {
          "m--has-button": _vm.buttonText,
          "m--has-content-area": _vm.hasContentArea
        }
      ],
      style: { minHeight: _vm.minHeight }
    },
    [
      _vm.buttonText
        ? [
            _vm.isButtonTypeAdd
              ? _c(
                  "m-add",
                  {
                    staticClass: "m-empty-area__button",
                    on: {
                      click: function($event) {
                        return _vm.emitButtonClick()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.buttonText) + "\n        "
                    )
                  ]
                )
              : _c(
                  "m-button",
                  {
                    staticClass: "m-empty-area__button",
                    attrs: { skin: _vm.buttonSkin },
                    on: {
                      click: function($event) {
                        return _vm.emitButtonClick()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.buttonText) + "\n        "
                    )
                  ]
                )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasContentArea
        ? _c(
            "div",
            { staticClass: "m-empty-area__content-area" },
            [
              _vm.svgName
                ? _c("m-svg", {
                    staticClass: "m-empty-area__icon",
                    attrs: {
                      name: _vm.svgName,
                      width: _vm.svgSize,
                      height: _vm.svgSize
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.title || _vm.subtitle
                ? _c("div", { staticClass: "m-empty-area__title-area" }, [
                    _vm.title
                      ? _c("p", { staticClass: "m-empty-area__title" }, [
                          _c("strong", [_vm._v(_vm._s(_vm.title))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.subtitle
                      ? _c("p", { staticClass: "m-empty-area__subtitle" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.subtitle) +
                              "\n            "
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-01901aee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/empty-area/empty-area.ts":
/*!*************************************************!*\
  !*** ./src/components/empty-area/empty-area.ts ***!
  \*************************************************/
/*! exports provided: MEmptyAreaButtonType, MEmptyAreaBackgroundStyle, MEmptyAreaDisplayMode, MEmptyArea, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEmptyAreaButtonType", function() { return MEmptyAreaButtonType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEmptyAreaBackgroundStyle", function() { return MEmptyAreaBackgroundStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEmptyAreaDisplayMode", function() { return MEmptyAreaDisplayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEmptyArea", function() { return MEmptyArea; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _add_add__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../add/add */ "./src/components/add/add.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _svg_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../svg/svg */ "./src/components/svg/svg.ts");
/* harmony import */ var _empty_area_html_style_empty_area_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./empty-area.html?style=./empty-area.scss */ "./src/components/empty-area/empty-area.html?style=./empty-area.scss");
/* harmony import */ var _empty_area_html_style_empty_area_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_empty_area_html_style_empty_area_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MEmptyAreaButtonType;
(function (MEmptyAreaButtonType) {
    MEmptyAreaButtonType["Button"] = "button";
    MEmptyAreaButtonType["AddButton"] = "add-button";
})(MEmptyAreaButtonType || (MEmptyAreaButtonType = {}));
var MEmptyAreaBackgroundStyle;
(function (MEmptyAreaBackgroundStyle) {
    MEmptyAreaBackgroundStyle["Any"] = "any";
    MEmptyAreaBackgroundStyle["Light"] = "light";
})(MEmptyAreaBackgroundStyle || (MEmptyAreaBackgroundStyle = {}));
var MEmptyAreaDisplayMode;
(function (MEmptyAreaDisplayMode) {
    MEmptyAreaDisplayMode["Inline"] = "inline";
    MEmptyAreaDisplayMode["Block"] = "block";
})(MEmptyAreaDisplayMode || (MEmptyAreaDisplayMode = {}));
var MEmptyArea = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MEmptyArea, _super);
    function MEmptyArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonSkin = _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonSkin"].Secondary;
        return _this;
    }
    MEmptyArea.prototype.emitButtonClick = function (event) { };
    Object.defineProperty(MEmptyArea.prototype, "isButtonTypeAdd", {
        get: function () {
            return this.buttonType === MEmptyAreaButtonType.AddButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MEmptyArea.prototype, "hasContentArea", {
        get: function () {
            return Boolean(this.svgName || this.title || this.subtitle);
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MEmptyArea.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MEmptyArea.prototype, "subtitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MEmptyArea.prototype, "buttonText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MEmptyAreaButtonType.AddButton,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(MEmptyAreaButtonType).includes(value);
            }
        })
    ], MEmptyArea.prototype, "buttonType", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MEmptyArea.prototype, "svgName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MEmptyAreaBackgroundStyle.Light,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(MEmptyAreaBackgroundStyle).includes(value);
            }
        })
    ], MEmptyArea.prototype, "backgroundStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: MEmptyAreaDisplayMode.Block,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_2__["Enums"].toValueArray(MEmptyAreaDisplayMode).includes(value);
            }
        })
    ], MEmptyArea.prototype, "displayMode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: '60px',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_3__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MEmptyArea.prototype, "svgSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            default: '280px',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_3__["REGEX_CSS_NUMBER_VALUE"].test(value) || value === 'auto';
            }
        })
    ], MEmptyArea.prototype, "minHeight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('button-click')
    ], MEmptyArea.prototype, "emitButtonClick", null);
    MEmptyArea = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _empty_area_html_style_empty_area_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_7__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ADD_NAME"]] = _add_add__WEBPACK_IMPORTED_MODULE_6__["MAdd"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["SVG_NAME"]] = _svg_svg__WEBPACK_IMPORTED_MODULE_8__["MSvg"],
                _a)
        })
    ], MEmptyArea);
    return MEmptyArea;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var EmptyAreaPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["EMPTY_AREA_NAME"], MEmptyArea);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (EmptyAreaPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-access-denied/error-access-denied.html":
/*!*********************************************************************************!*\
  !*** ./src/components/error-pages/error-access-denied/error-access-denied.html ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-01a155b9'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-access-denied/error-access-denied.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/error-pages/error-access-denied/error-access-denied.ts ***!
  \*******************************************************************************/
/*! exports provided: MErrorAccessDenied, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorAccessDenied", function() { return MErrorAccessDenied; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_access_denied_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-access-denied.html */ "./src/components/error-pages/error-access-denied/error-access-denied.html");
/* harmony import */ var _error_access_denied_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_access_denied_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorAccessDenied = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorAccessDenied, _super);
    function MErrorAccessDenied() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Information;
        _this.svgName = 'message-error-access-denied';
        return _this;
    }
    MErrorAccessDenied.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-access-denied', __webpack_require__(/*! ./message-error-access-denied.svg */ "./src/components/error-pages/error-access-denied/message-error-access-denied.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-access-denied:title'); }
        })
    ], MErrorAccessDenied.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MErrorAccessDenied.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-access-denied:hint.primary')
            ]; }
        })
    ], MErrorAccessDenied.prototype, "hints", void 0);
    MErrorAccessDenied = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_access_denied_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorAccessDenied);
    return MErrorAccessDenied;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorAccessDeniedPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_ACCESS_DENIED_NAME"], MErrorAccessDenied);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorAccessDeniedPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-access-denied/message-error-access-denied.svg":
/*!****************************************************************************************!*\
  !*** ./src/components/error-pages/error-access-denied/message-error-access-denied.svg ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-access-denied\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 134\"><path fill=\"#D7D7D7\" d=\"M109.4,35.4v24.3H95.1V36.1c0-0.3,0-0.5,0-0.8C94.7,24.6,85.9,16,75.1,16s-19.6,8.6-20,19.3 c0,0.3,0,0.5,0,0.8v23.5H40.6V35.4C40.6,16.4,56,1,75,1S109.4,16.4,109.4,35.4z\"></path><path fill=\"#F4F4F4\" d=\"M76.4,5.9L76.4,5.9c0,0.9-0.7,1.7-1.6,1.8c-15,0.8-26.9,13.2-26.9,28.4c0,0.1,0,0.2,0,0.4v21.2 c0,0.1,0,0.1-0.1,0.1h-3.3c-0.1,0-0.1,0-0.1-0.1V36.1c0-17,13.3-30.9,30.1-31.9C75.5,4.1,76.4,4.9,76.4,5.9z\"></path><path fill=\"#FFFFFF\" d=\"M46.9,36.1v0.4C46.9,36.3,46.9,36.2,46.9,36.1L46.9,36.1z\"></path><path fill=\"#FFC103\" d=\"M32.7,132c-1.1,0-1.9-0.9-1.9-1.9V60.5c0-1.1,0.9-1.9,1.9-1.9h84.6c1.1,0,1.9,0.9,1.9,1.9v69.6 c0,1.1-0.9,1.9-1.9,1.9H32.7z\"></path><path d=\"M117.3,59.6c0.5,0,0.9,0.4,0.9,0.9v69.6c0,0.5-0.4,0.9-0.9,0.9H32.7c-0.5,0-0.9-0.4-0.9-0.9V60.5c0-0.5,0.4-0.9,0.9-0.9 H117.3 M117.3,57.6H32.7c-1.6,0-2.9,1.3-2.9,2.9v69.6c0,1.6,1.3,2.9,2.9,2.9h84.6c1.6,0,2.9-1.3,2.9-2.9V60.5 C120.2,58.9,118.9,57.6,117.3,57.6L117.3,57.6z\"></path><polygon opacity=\"0.25\" fill=\"#FFFFFF\" enable-background=\"new\" points=\"70.3,59.1 52.6,79.5 31,108.2 31,70 31,59 40.1,59.1 \"></polygon><polygon opacity=\"0.25\" fill=\"#FFFFFF\" enable-background=\"new\" points=\"89.7,58.8 63.3,89.3 31,132 31,75.1 31,58.8 44.6,58.8 \"></polygon><path d=\"M80.5,91.2l4.6,26.8H64.9l4.6-26.8c-2.8-1.8-4.6-4.9-4.6-8.4c0-4.7,3.3-8.7,7.7-9.8c0.8-0.2,1.5-0.3,2.3-0.3 s1.6,0.1,2.3,0.3c4.4,1.1,7.7,5,7.7,9.8C85.1,86.3,83.2,89.4,80.5,91.2z\"></path><path d=\"M117.3,59.6c0.5,0,0.9,0.4,0.9,0.9v69.6c0,0.5-0.4,0.9-0.9,0.9H32.7c-0.5,0-0.9-0.4-0.9-0.9V60.5c0-0.5,0.4-0.9,0.9-0.9 H117.3 M117.3,57.6H32.7c-1.6,0-2.9,1.3-2.9,2.9v69.6c0,1.6,1.3,2.9,2.9,2.9h84.6c1.6,0,2.9-1.3,2.9-2.9V60.5 C120.2,58.9,118.9,57.6,117.3,57.6L117.3,57.6z\"></path><path d=\"M75,3c17.8,0,32.4,14.5,32.4,32.4v22.3H97.1V36.1c0-0.3,0-0.6,0-0.9c-0.5-11.8-10.1-21.1-22-21.1s-21.6,9.3-22,21.1 c0,0.4,0,0.7,0,0.9v21.5H42.6V35.4C42.6,17.5,57.2,3,75,3 M75,1C56,1,40.6,16.4,40.6,35.4v24.3h14.3V36.1c0-0.3,0-0.5,0-0.8 c0.4-10.7,9.2-19.3,20-19.3s19.6,8.6,20,19.3c0,0.3,0,0.5,0,0.8v23.5h14.3V35.4C109.4,16.4,94,1,75,1L75,1z\"></path></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.html":
/*!*************************************************************************************************!*\
  !*** ./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.html ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.isMqMinS ? _vm.hintsDesktop : _vm.hintsMobile,
      links: _vm.isMqMinS ? _vm.linksDesktop : _vm.linksMobile
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-1c5369a3'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.ts":
/*!***********************************************************************************************!*\
  !*** ./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.ts ***!
  \***********************************************************************************************/
/*! exports provided: MErrorBrowserNotSupported, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorBrowserNotSupported", function() { return MErrorBrowserNotSupported; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_browser_not_supported_html__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./error-browser-not-supported.html */ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.html");
/* harmony import */ var _error_browser_not_supported_html__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_error_browser_not_supported_html__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MErrorBrowserNotSupported = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorBrowserNotSupported, _super);
    function MErrorBrowserNotSupported() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_8__["MMessageState"].Warning;
        _this.svgName = 'message-error-browser-not-supported';
        return _this;
    }
    MErrorBrowserNotSupported.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-browser-not-supported', __webpack_require__(/*! ./message-error-browser-not-supported.svg */ "./src/components/error-pages/error-browser-not-supported/message-error-browser-not-supported.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-browser-not-supported:title'); }
        })
    ], MErrorBrowserNotSupported.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [new _message_page_message_page__WEBPACK_IMPORTED_MODULE_7__["Link"]((vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-browser-not-supported:update-browser.desktop'), 'http://outdatedbrowser.com/fr', true)]; }
        })
    ], MErrorBrowserNotSupported.prototype, "linksDesktop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: function () { return []; } })
    ], MErrorBrowserNotSupported.prototype, "linksMobile", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [(vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-browser-not-supported:hint.primary.desktop')]; }
        })
    ], MErrorBrowserNotSupported.prototype, "hintsDesktop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [(vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-browser-not-supported:hint.primary.mobile')]; }
        })
    ], MErrorBrowserNotSupported.prototype, "hintsMobile", void 0);
    MErrorBrowserNotSupported = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_browser_not_supported_html__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_7__["MMessagePage"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__["MediaQueries"]]
        })
    ], MErrorBrowserNotSupported);
    return MErrorBrowserNotSupported;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var ErrorBrowserNotSupported = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["ERROR_BROWSER_NOT_SUPPORTED_NAME"], MErrorBrowserNotSupported);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorBrowserNotSupported);


/***/ }),

/***/ "./src/components/error-pages/error-browser-not-supported/message-error-browser-not-supported.svg":
/*!********************************************************************************************************!*\
  !*** ./src/components/error-pages/error-browser-not-supported/message-error-browser-not-supported.svg ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-browser-not-supported\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150.1 93\"><path fill=\"none\" stroke=\"#000000\" stroke-width=\"7\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\"M27.7,23.8 C6.3,31.2,13.4,45.7,15.5,51.2c1.1,2.8,2.5,5.3,3.8,9c2.4,7.1,2,18-4.7,24.3c-3.7,3.4-8.9,5.1-14.5,5\"></path><path d=\"M150.1,55.4v9c-1.2,1.3-2.2,2.6-3,3.8c-0.2,0.3-0.4,0.6-0.6,0.8c-0.7,0.9-1.3,1.9-2,2.9c-1,1.5-2.1,3.3-3.7,5.2 c-7.7,9.5-18.7,12-26.1,10.3c-0.2,0-0.4-0.1-0.6-0.1c-5.7-1.5-10.7-5.5-14-11.2l6-3.5c2.4,4.1,5.9,7,9.8,8 c7.1,1.9,15.3-2.6,19.5-7.8c1.3-1.6,2.3-3.2,3.3-4.6c0.7-1.1,1.4-2.2,2.2-3.3c0.2-0.2,0.4-0.5,0.6-0.8 C143.2,61.7,146,57.9,150.1,55.4z\"></path><g stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><polygon fill=\"#3D3D3D\" points=\" 67.8,33.5 63.7,30.7 63.6,30.6 60.7,14.7 60.8,14.4 65.6,1 79.4,16.8 74.5,30.5 \"></polygon><polygon points=\" 67.8,33.5 43,38 38.9,35.2 63.7,30.7 \"></polygon><line fill=\"none\" x1=\"60.8\" y1=\"14.4\" x2=\"60.9\" y2=\"14.4\"></line><line fill=\"none\" x1=\"35.9\" y1=\"18.9\" x2=\"36\" y2=\"18.9\"></line><line fill=\"none\" x1=\"38.8\" y1=\"35.2\" x2=\"38.9\" y2=\"35.2\"></line><line fill=\"none\" x1=\"63.7\" y1=\"30.7\" x2=\"63.8\" y2=\"30.7\"></line><polygon fill=\"#282828\" points=\" 63.7,30.7 38.9,35.2 38.8,35.1 35.9,19.1 36,18.9 60.8,14.4 60.7,14.7 63.6,30.6 \"></polygon><path fill=\"#282828\" d=\" M37.9,30.2l-10,1.8c-1.4,0.2-3.2-3.2-4-7.7s-0.3-8.3,1-8.6l13-2.3l-2,5.5l-0.1,0.2L37.9,30.2z\"></path><polygon fill=\"#FFC103\" points=\" 65.7,13.6 67.4,8.1 90,4 88.3,9.5 \"></polygon><polygon fill=\"#FFC103\" points=\" 73.5,22.5 75.2,17 97.7,12.9 96,18.4 \"></polygon><path fill=\"#BCBCBC\" d=\" M88.5,24.9l-20,3.6c-0.7,0.1-1.5-0.9-1.7-2.3s0.1-2.6,0.8-2.7l20-3.6c1.4-0.2,2.7,0.7,3,2c0.1,0.7,0,1.4-0.4,1.9 C89.7,24.4,89.1,24.8,88.5,24.9z\"></path></g><rect x=\"24\" y=\"15.8\" transform=\"matrix(0.9841 -0.1777 0.1777 0.9841 -2.6955 5.7286)\" opacity=\"0.3\" fill=\"#EAEAEA\" enable-background=\"new\" width=\"13.2\" height=\"4.2\"></rect><rect x=\"23.9\" y=\"21.2\" transform=\"matrix(0.9841 -0.1777 0.1777 0.9841 -3.3831 5.7142)\" opacity=\"0.3\" fill=\"#EAEAEA\" enable-background=\"new\" width=\"12.6\" height=\"1.1\"></rect><path opacity=\"0.7\" fill=\"#FFFFFF\" enable-background=\"new\" d=\"M68.2,25.5L68.2,25.5c-0.1-0.3,0.1-0.6,0.4-0.6l19.7-3.6 c0.3-0.1,0.6,0.1,0.6,0.4l0,0c0.1,0.3-0.1,0.6-0.4,0.6L68.8,26C68.5,26,68.2,25.8,68.2,25.5z\"></path><g stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path fill=\"none\" d=\" M37.9,30.2l-10,1.8c-1.4,0.2-3.2-3.2-4-7.7s-0.3-8.3,1-8.6l13-2.3l-2,5.5l-0.1,0.2L37.9,30.2z\"></path><polygon fill=\"#5B5B5B\" points=\" 60.8,14.4 36,18.9 38,13.4 40.8,5.5 65.6,1 \"></polygon><path fill=\"#282828\" d=\" M105,65.3l9.6,6.1c1.3,0.8,0.2,5-2.5,9.3s-6,7.1-7.3,6.3l-12.5-7.9l5.8-3.1l0.2-0.1L105,65.3z\"></path></g><rect x=\"106.6\" y=\"64.3\" transform=\"matrix(0.5325 -0.8464 0.8464 0.5325 -9.774 125.7281)\" opacity=\"0.3\" fill=\"#EAEAEA\" enable-background=\"new\" width=\"4.7\" height=\"14.8\"></rect><rect x=\"106.1\" y=\"68.4\" transform=\"matrix(0.5325 -0.8464 0.8464 0.5325 -13.9751 125.6143)\" opacity=\"0.3\" fill=\"#EAEAEA\" enable-background=\"new\" width=\"1.2\" height=\"14.2\"></rect><g stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path fill=\"none\" d=\" M105,65.3l9.6,6.1c1.3,0.8,0.2,5-2.5,9.3s-6,7.1-7.3,6.3l-12.5-7.9l5.8-3.1l0.2-0.1L105,65.3z\"></path><path fill=\"#FFC103\" d=\" M90.1,44.3c0.6,0.4,1.2,0.9,1.5,1.6c2.2,3.8,0.7,11.7-4,19.2S76.4,77.4,72,77.1c-0.8-0.1-1.5-0.3-2.1-0.7c-4.2-2.6-3.1-12,2.5-20.9 C77.9,46.8,85.9,41.7,90.1,44.3z\"></path><path fill=\"#282828\" d=\" M91.6,46l13,16.9l0.5,0.6l0,0c0.1,0.1,0.1,0.3,0.2,0.5c0.6,2.1-0.7,6.2-3.2,10.3c-2.6,4.1-5.7,7-7.9,7.4c-0.2,0-0.3,0-0.4,0.1l0,0 L93,81.6l-21-4.4c4.4,0.4,10.8-4.4,15.6-12C92.3,57.7,93.8,49.8,91.6,46z\"></path></g><rect x=\"70.1\" y=\"56.5\" transform=\"matrix(0.5452 -0.8383 0.8383 0.5452 -13.5324 90.4607)\" fill=\"#231F20\" width=\"13\" height=\"2.4\"></rect><rect x=\"81.3\" y=\"57.8\" transform=\"matrix(0.5452 -0.8383 0.8383 0.5452 -13.6587 96.9022)\" fill=\"#231F20\" width=\"2.4\" height=\"6.4\"></rect></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.html":
/*!***********************************************************************************************!*\
  !*** ./src/components/error-pages/error-config-not-supported/error-config-not-supported.html ***!
  \***********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-2e52a60e'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/error-pages/error-config-not-supported/error-config-not-supported.ts ***!
  \*********************************************************************************************/
/*! exports provided: MErrorConfigNotSupported, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorConfigNotSupported", function() { return MErrorConfigNotSupported; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_config_not_supported_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-config-not-supported.html */ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.html");
/* harmony import */ var _error_config_not_supported_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_config_not_supported_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorConfigNotSupported = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorConfigNotSupported, _super);
    function MErrorConfigNotSupported() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Warning;
        _this.svgName = 'message-error-config-not-supported';
        return _this;
    }
    MErrorConfigNotSupported.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-config-not-supported', __webpack_require__(/*! ./message-error-config-not-supported.svg */ "./src/components/error-pages/error-config-not-supported/message-error-config-not-supported.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-config-not-supported:title'); }
        })
    ], MErrorConfigNotSupported.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: function () { return []; } })
    ], MErrorConfigNotSupported.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-config-not-supported:hint.primary'),
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-config-not-supported:hint.secondary')
            ]; }
        })
    ], MErrorConfigNotSupported.prototype, "hints", void 0);
    MErrorConfigNotSupported = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_config_not_supported_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorConfigNotSupported);
    return MErrorConfigNotSupported;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorConfigNotSupportedPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_CONFIG_NOT_SUPPORTED_NAME"], MErrorConfigNotSupported);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorConfigNotSupportedPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-config-not-supported/message-error-config-not-supported.svg":
/*!******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-config-not-supported/message-error-config-not-supported.svg ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-config-not-supported\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 153 115.5\"><path fill=\"#D7D7D7\" d=\"M14.8,114c-6.2,0-11.2-5-11.2-11.2V12.2C3.6,6,8.6,1,14.8,1h123.4c6.2,0,11.2,5,11.2,11.2v90.6 c0,6.2-5,11.2-11.2,11.2C138.2,114,14.8,114,14.8,114z\"></path><path d=\"M138.2,2c5.6,0,10.2,4.6,10.2,10.2v90.6c0,5.6-4.6,10.2-10.2,10.2H14.8c-5.6,0-10.2-4.6-10.2-10.2V12.2 C4.6,6.6,9.2,2,14.8,2H138.2 M138.2,0H14.8C8,0,2.6,5.5,2.6,12.2v90.6c0,6.7,5.5,12.2,12.2,12.2h123.4c6.7,0,12.2-5.5,12.2-12.2 V12.2C150.4,5.5,145,0,138.2,0L138.2,0z\"></path><rect x=\"10.4\" y=\"7.8\" fill=\"#98D5FF\" stroke=\"#000000\" stroke-width=\"0.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" width=\"132.3\" height=\"78.2\"></rect><g fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"0.5\" stroke-miterlimit=\"10\"><line x1=\"10.9\" y1=\"47.5\" x2=\"143.2\" y2=\"47.5\"></line><line x1=\"10.4\" y1=\"66.4\" x2=\"142.6\" y2=\"66.4\"></line><line x1=\"10.4\" y1=\"27.3\" x2=\"142.6\" y2=\"27.3\"></line><line x1=\"77.1\" y1=\"7.8\" x2=\"77.1\" y2=\"86\"></line><line x1=\"43.7\" y1=\"7.8\" x2=\"43.7\" y2=\"86\"></line><line x1=\"109.3\" y1=\"7.8\" x2=\"109.3\" y2=\"86\"></line></g><polyline fill=\"none\" stroke=\"#E30513\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" points=\" 10.9,47.5 28.2,47.5 29.3,50.9 32.8,40.5 35.1,45.1 40.8,17.5 47.7,67 52.3,47.5 58.1,47.5 59.2,44 61.5,49.8 63.8,42.8 66.1,47.5 73,47.5 \"></polyline><polyline fill=\"none\" stroke=\"#E30513\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" points=\" 71.9,47.5 89.2,47.5 90.3,48.7 93.8,42.1 96.1,46.7 101.8,45.5 108.7,50.3 113.3,47.5 119.1,47.5 120.2,47.2 122.5,48.7 124.8,46 127.1,47.5 134,47.5 \"></polyline><circle fill=\"#E30513\" stroke=\"#E30513\" stroke-width=\"2\" stroke-miterlimit=\"10\" cx=\"134\" cy=\"47.5\" r=\"1.7\"></circle><polygon opacity=\"0.2\" fill=\"#FFFFFF\" enable-background=\"new\" points=\"73.9,8.1 45.2,40 10.2,84.6 10.2,25.1 10.2,8 25,8.1 \"></polygon><rect x=\"10.4\" y=\"7.8\" fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" width=\"132.3\" height=\"78.2\"></rect><g stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\"><circle fill=\"#B3040F\" cx=\"16\" cy=\"100\" r=\"6\"></circle><path fill=\"#0075C3\" d=\"M74.5,106h-24c-3.3,0-6-2.7-6-6l0,0 c0-3.3,2.7-6,6-6h24V106z\"></path><path fill=\"#0075C3\" d=\"M102.5,106h-24V94h24c3.3,0,6,2.7,6,6l0,0 C108.5,103.3,105.8,106,102.5,106z\"></path></g></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-conflict/error-conflict.html":
/*!***********************************************************************!*\
  !*** ./src/components/error-pages/error-conflict/error-conflict.html ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-62c45b99'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-conflict/error-conflict.ts":
/*!*********************************************************************!*\
  !*** ./src/components/error-pages/error-conflict/error-conflict.ts ***!
  \*********************************************************************/
/*! exports provided: MErrorOperationFailed, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorOperationFailed", function() { return MErrorOperationFailed; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_conflict_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-conflict.html */ "./src/components/error-pages/error-conflict/error-conflict.html");
/* harmony import */ var _error_conflict_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_conflict_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorOperationFailed = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorOperationFailed, _super);
    function MErrorOperationFailed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Warning;
        _this.svgName = 'message-error-conflict';
        return _this;
    }
    MErrorOperationFailed.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-conflict', __webpack_require__(/*! ./message-error-conflict.svg */ "./src/components/error-pages/error-conflict/message-error-conflict.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-conflict:title'); }
        })
    ], MErrorOperationFailed.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MErrorOperationFailed.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-conflict:hint.primary')
            ]; }
        })
    ], MErrorOperationFailed.prototype, "hints", void 0);
    MErrorOperationFailed = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_conflict_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorOperationFailed);
    return MErrorOperationFailed;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorOperationFailedPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_CONFLICT_NAME"], MErrorOperationFailed);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorOperationFailedPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-conflict/message-error-conflict.svg":
/*!******************************************************************************!*\
  !*** ./src/components/error-pages/error-conflict/message-error-conflict.svg ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-conflict\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 148.4\"><polygon fill=\"#F39612\" stroke=\"#000000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" points=\" 103.9,110.1 95.7,85.3 74.7,85.3 99,35.3 100.2,32.7 133.6,48.9 \"></polygon><polygon fill=\"#FFC103\" points=\"116.3,42 96.1,85.2 74.7,85.1 99.2,33.4 \"></polygon><g stroke=\"#000000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><polygon fill=\"#1895FD\" points=\" 100.3,32.7 104.9,23.1 138.2,39.3 133.6,48.9 \"></polygon><path fill=\"#EF7382\" d=\" M148.4,18.4l-10.2,21L105,23.2l10.2-21c0.2-0.6,0.9-0.8,1.5-0.6l31.1,15.2C148.4,17.1,148.6,17.8,148.4,18.4z\"></path><polygon fill=\"none\" points=\" 103.9,110.1 95.7,85.3 74.7,85.3 100.2,32.7 133.6,48.9 \"></polygon><polygon fill=\"#F39612\" points=\" 88,103.4 79.6,128 43.1,146.5 26.4,113.4 71.2,90.7 \"></polygon></g><polygon fill=\"#FFC103\" points=\"87.6,103.4 63.4,115.4 35.4,129.4 26.1,111.8 58.7,95.8 70,90.2 \"></polygon><g stroke=\"#000000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><polygon fill=\"#3D3D3D\" points=\" 22,146.8 1.5,146.9 13.7,130.5 \"></polygon><polygon fill=\"#FFFBD4\" points=\" 43.1,146.5 22,146.8 13.7,130.5 26.4,113.4 \"></polygon><polygon fill=\"none\" points=\" 88,103.4 79.6,128 43.1,146.5 26.4,113.4 29,112.1 60.3,96.2 71.2,90.7 \"></polygon><line fill=\"none\" x1=\"102.5\" y1=\"122.4\" x2=\"112.1\" y2=\"133.4\"></line><line fill=\"none\" x1=\"106.9\" y1=\"118.4\" x2=\"115.6\" y2=\"122.2\"></line><line fill=\"none\" x1=\"96.9\" y1=\"125.5\" x2=\"98.9\" y2=\"133.6\"></line></g></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.html":
/*!*************************************************************************************************!*\
  !*** ./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.html ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-627d46d6'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.ts":
/*!***********************************************************************************************!*\
  !*** ./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.ts ***!
  \***********************************************************************************************/
/*! exports provided: MErrorCookiesNotSupported, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorCookiesNotSupported", function() { return MErrorCookiesNotSupported; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_cookies_not_supported_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-cookies-not-supported.html */ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.html");
/* harmony import */ var _error_cookies_not_supported_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_cookies_not_supported_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorCookiesNotSupported = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorCookiesNotSupported, _super);
    function MErrorCookiesNotSupported() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Warning;
        _this.svgName = 'message-error-cookies-disabled';
        return _this;
    }
    MErrorCookiesNotSupported.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-cookies-disabled', __webpack_require__(/*! ./message-error-cookies-disabled.svg */ "./src/components/error-pages/error-cookies-not-supported/message-error-cookies-disabled.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-cookies-not-supported:title'); }
        })
    ], MErrorCookiesNotSupported.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                new _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["Link"]((vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-cookies-not-supported:home-label'), '\\')
            ]; }
        })
    ], MErrorCookiesNotSupported.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-cookies-not-supported:hint.primary')
            ]; }
        })
    ], MErrorCookiesNotSupported.prototype, "hints", void 0);
    MErrorCookiesNotSupported = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_cookies_not_supported_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorCookiesNotSupported);
    return MErrorCookiesNotSupported;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorCookiesNotSupportedPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_COOKIES_NOT_SUPPORTED_NAME"], MErrorCookiesNotSupported);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorCookiesNotSupportedPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-cookies-not-supported/message-error-cookies-disabled.svg":
/*!***************************************************************************************************!*\
  !*** ./src/components/error-pages/error-cookies-not-supported/message-error-cookies-disabled.svg ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-cookies-disabled\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 133\"><path fill=\"#DAB67B\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\" M128.6,74.4c-1.2,4.6,0,9.3,2.9,12.7c1.1,1.3,2.5,2.4,4,3.2c-9.5,24.1-33,41.2-60.5,41.2c-11.4,0-22-2.9-31.3-8 c1.9-2.3,3.3-5,4.1-8.1c0.1-0.4,0.2-0.8,0.3-1.3c2.3-11.1-4.5-22.2-15.7-25.2c-4.3-1.2-8.7-0.9-12.6,0.4c-1.7,0.6-3.3,1.4-4.8,2.3 c-3.2-7.7-5-16.2-5-25.2c0-1.9,0.1-3.8,0.3-5.7c0.4-4.3,1.1-8.5,2.3-12.5C15,40.1,19,32.5,24.2,26C36.1,11,54.5,1.5,75,1.5 c4.6,0,9.1,0.5,13.5,1.4C90,3.2,91.5,3.6,93,4c-1.6,1.8-2.9,3.9-3.6,6.3c-0.6,1.8-1,3.8-1,5.8c0,10,8.1,18.1,18.1,18.1 c1,0,1.9-0.1,2.9-0.3c-0.1,0.9-0.3,1.9-0.3,2.9c0,10,8.1,18.1,18.1,18.1c4.1,0,7.9-1.4,10.9-3.7c0.7,3.1,1.3,6.2,1.5,9.5 c0.1,1.2,0.2,2.3,0.2,3.5c-0.2,0-0.4,0.1-0.7,0.1C134.3,65.3,130,69.2,128.6,74.4z\"></path><g opacity=\"0.35\" fill=\"#B2722D\" enable-background=\"new\"><path d=\"M15.1,80.2c1.3,3.2,3,6.3,4.8,9.2c-1.7,0.6-3.3,1.4-4.8,2.3 C11.8,83.9,10,75.4,10,66.4c0-1.9,0.1-3.8,0.3-5.7C10.9,67.5,12.5,74,15.1,80.2z\"></path><path d=\"M135.5,90.2c-9.5,24.1-33,41.2-60.5,41.2 c-11.4,0-22-2.9-31.3-8c1.9-2.3,3.3-5,4.1-8.1c0.1-0.4,0.2-0.8,0.3-1.3c8.2,3.8,17.3,5.8,26.9,5.8c24.2,0,45.3-13.2,56.5-32.8 C132.6,88.3,134,89.4,135.5,90.2z\"></path><path d=\"M140,64.2c-0.2,0-0.4,0.1-0.7,0.1c0.2-1.2,0.3-2.4,0.4-3.6 C139.8,61.9,139.9,63.1,140,64.2z\"></path></g><g fill=\"#906145\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M140,66.4c0,8.4-1.6,16.5-4.5,23.8c-1.5-0.8-2.9-1.9-4-3.2c-2.9-3.4-4.1-8-2.9-12.7c1.4-5.3,5.7-9.1,10.7-10.1 c0.2-0.1,0.4-0.1,0.7-0.1C140,64.9,140,65.8,140,66.4z\"></path><circle cx=\"72.2\" cy=\"66.2\" r=\"18\"></circle><circle cx=\"94.8\" cy=\"97.7\" r=\"6.7\"></circle><circle cx=\"65.9\" cy=\"22.1\" r=\"6.3\"></circle><path d=\"M31.7,40.9c-1.8,6.8-8.7,10.8-15.5,9c-1.3-0.4-2.5-0.9-3.6-1.6C15,40.1,19,32.5,24.2,25.9C30.1,28.3,33.4,34.7,31.7,40.9z\"></path></g><path fill=\"#906145\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\" M48.1,114c-0.1,0.4-0.2,0.8-0.3,1.3c-0.8,3-2.2,5.8-4.1,8.1c-12.8-7-22.9-18.2-28.6-31.8c1.5-1,3.1-1.8,4.8-2.3 c3.9-1.4,8.3-1.6,12.6-0.4C43.6,91.8,50.4,102.9,48.1,114z\"></path></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-page-not-found/error-page-not-found.html":
/*!***********************************************************************************!*\
  !*** ./src/components/error-pages/error-page-not-found/error-page-not-found.html ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4c4ec7ce'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-page-not-found/error-page-not-found.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/error-pages/error-page-not-found/error-page-not-found.ts ***!
  \*********************************************************************************/
/*! exports provided: MErrorPageNotFound, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorPageNotFound", function() { return MErrorPageNotFound; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_page_not_found_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-page-not-found.html */ "./src/components/error-pages/error-page-not-found/error-page-not-found.html");
/* harmony import */ var _error_page_not_found_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_page_not_found_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorPageNotFound = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorPageNotFound, _super);
    function MErrorPageNotFound() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Warning;
        _this.svgName = 'message-error-page-not-found';
        return _this;
    }
    MErrorPageNotFound.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-page-not-found', __webpack_require__(/*! ./message-error-page-not-found.svg */ "./src/components/error-pages/error-page-not-found/message-error-page-not-found.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-page-not-found:title'); }
        })
    ], MErrorPageNotFound.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                new _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["Link"]((vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-page-not-found:home-label'), "\\")
            ]; }
        })
    ], MErrorPageNotFound.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-page-not-found:hint.primary')
            ]; }
        })
    ], MErrorPageNotFound.prototype, "hints", void 0);
    MErrorPageNotFound = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_page_not_found_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorPageNotFound);
    return MErrorPageNotFound;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorPageNotFoundPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_PAGE_NOT_FOUND_NAME"], MErrorPageNotFound);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPageNotFoundPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-page-not-found/message-error-page-not-found.svg":
/*!******************************************************************************************!*\
  !*** ./src/components/error-pages/error-page-not-found/message-error-page-not-found.svg ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-page-not-found\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 155\"><rect x=\"11\" y=\"1\" fill=\"#F4F4F4\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"127\" height=\"153\"></rect><g enable-background=\"new\"><path d=\"M39.6,22v-8.4h3.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.6,1,0.6,1.7c0,0.6-0.2,1-0.5,1.5c-0.3,0.4-0.8,0.7-1.5,0.9l1.8,3.7h-1.2 l-1.7-3.6h-1.9V22H39.6z M40.6,17.4h2.3c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1s-0.6-0.4-1.2-0.4h-2.3 V17.4z\"></path><path d=\"M47.5,22v-8.4h5v1h-3.9v2.6h2.6v1h-2.6V21h4.2v1H47.5z\"></path><path d=\"M57.5,22.1c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.2-0.8-0.6-1.1-1c-0.3-0.4-0.5-0.9-0.6-1.4s-0.2-1-0.2-1.6c0-0.6,0.1-1.1,0.2-1.6 c0.1-0.5,0.3-1,0.6-1.4s0.6-0.8,1.1-1s1-0.4,1.6-0.4c1.3,0,2.2,0.5,2.7,1.5l-0.9,0.5c-0.2-0.3-0.5-0.6-0.7-0.8 c-0.3-0.2-0.6-0.3-1-0.3c-0.6,0-1,0.2-1.4,0.5c-0.4,0.4-0.6,0.8-0.8,1.3c-0.1,0.5-0.2,1-0.2,1.6c0,0.9,0.2,1.7,0.6,2.4 c0.4,0.7,1,1,1.8,1s1.4-0.4,1.8-1.1l1,0.4c-0.2,0.5-0.6,0.9-1,1.2C58.8,22,58.2,22.1,57.5,22.1z\"></path><path d=\"M67.1,22v-3.9h-4V22h-1v-8.4h1v3.6h4v-3.6h1V22H67.1z\"></path><path d=\"M70.5,22v-8.4h5v1h-3.9v2.6h2.6v1h-2.6V21h4.2v1H70.5z\"></path><path d=\"M77.7,22v-8.4H81c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.6,1,0.6,1.7c0,0.6-0.2,1-0.5,1.5c-0.3,0.4-0.8,0.7-1.5,0.9l1.8,3.7h-1.2 l-1.7-3.6h-1.9V22H77.7z M78.8,17.4h2.3c0.5,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1s-0.6-0.4-1.2-0.4h-2.3 V17.4z\"></path><path d=\"M88.8,22.1c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.2-0.8-0.6-1.1-1c-0.3-0.4-0.5-0.9-0.6-1.4c-0.1-0.5-0.2-1-0.2-1.6 c0-0.6,0.1-1.1,0.2-1.6s0.3-1,0.6-1.4s0.6-0.8,1.1-1c0.5-0.3,1-0.4,1.6-0.4c1.3,0,2.2,0.5,2.7,1.5l-0.9,0.5 c-0.2-0.3-0.5-0.6-0.7-0.8c-0.3-0.2-0.6-0.3-1-0.3c-0.6,0-1,0.2-1.4,0.5c-0.4,0.4-0.6,0.8-0.8,1.3c-0.1,0.5-0.2,1-0.2,1.6 c0,0.9,0.2,1.7,0.6,2.4c0.4,0.7,1,1,1.8,1c0.8,0,1.4-0.4,1.8-1.1l1,0.4c-0.2,0.5-0.6,0.9-1,1.2C90.1,22,89.5,22.1,88.8,22.1z\"></path><path d=\"M98.5,22v-3.9h-4V22h-1v-8.4h1v3.6h4v-3.6h1V22H98.5z\"></path><path d=\"M101.9,22v-8.4h5v1h-3.9v2.6h2.6v1h-2.6V21h4.2v1H101.9z M103,12.8l1.7-1.9h1.5l-2.1,1.9H103z\"></path></g><rect x=\"32\" y=\"33\" fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"86\" height=\"86\"></rect><path fill=\"#F39612\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\" M93.6,108.9v9.3H55.4v-9.3c0-4.9,1.9-9.4,4.9-12.8c3.5-3.8,8.5-6.3,14.1-6.3s10.6,2.4,14.1,6.3C91.7,99.5,93.6,104,93.6,108.9z\"></path><path opacity=\"0.7\" fill=\"#FFFFFF\" enable-background=\"new\" d=\"M84.4,116.7c0,0.5,0,0.4-0.1,0.9H65.4c0-0.5-0.1-0.4-0.1-0.9 c0-6.9,4.3-12.5,9.5-12.5C80.1,104.2,84.4,109.8,84.4,116.7z\"></path><path fill=\"#C96E0A\" d=\"M88.6,96.1c-3.7,2.4-8.6,3.8-14.1,3.8s-10.4-1.4-14.1-3.8c3.5-3.8,8.5-6.3,14.1-6.3S85.1,92.3,88.6,96.1z\"></path><g stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path fill=\"none\" d=\" M93.6,108.9v9.3H55.4v-9.3c0-4.9,1.9-9.4,4.9-12.8c3.5-3.8,8.5-6.3,14.1-6.3s10.6,2.4,14.1,6.3C91.7,99.5,93.6,104,93.6,108.9z\"></path><path fill=\"#C96E0A\" d=\" M98.5,73.8V49c0-1.3-1.5-1.9-2.4-1l-6.8,6.8\"></path><path fill=\"#C96E0A\" d=\" M50.5,73.8V49c0-1.3,1.5-1.9,2.4-1l6.8,6.8\"></path></g><circle fill=\"#C96E0A\" cx=\"74.5\" cy=\"73.8\" r=\"24\"></circle><ellipse fill=\"#F39612\" cx=\"76.3\" cy=\"74.2\" rx=\"22.2\" ry=\"22.9\"></ellipse><g fill=\"none\" stroke=\"#000000\"><g stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><line x1=\"63.2\" y1=\"69.6\" x2=\"63.2\" y2=\"71.7\"></line><line x1=\"85.8\" y1=\"69.6\" x2=\"85.8\" y2=\"71.7\"></line></g><path stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M98.5,73.8c0,13.3-10.7,24-24,24s-24-10.7-24-24\"></path><g stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\" M56.9,57.5c4.4-4.7,10.7-7.7,17.6-7.7c7,0,13.2,3,17.6,7.7\"></path><line x1=\"50.5\" y1=\"74.5\" x2=\"50.5\" y2=\"67.4\"></line><line x1=\"98.5\" y1=\"73.8\" x2=\"98.5\" y2=\"65.3\"></line></g></g><g opacity=\"0.7\" fill=\"#FFFFFF\" enable-background=\"new\"><circle cx=\"68.9\" cy=\"83.7\" r=\"5.6\"></circle><circle cx=\"80.1\" cy=\"83.7\" r=\"5.6\"></circle></g><g stroke=\"#000000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><circle fill=\"#FC9081\" stroke-width=\"2\" cx=\"74.5\" cy=\"80.2\" r=\"2.8\"></circle><g fill=\"none\"><g stroke-width=\"2\"><path d=\" M74.5,83.7c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6\"></path><path d=\" M85.8,83.7c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6\"></path><line x1=\"31\" y1=\"128\" x2=\"117\" y2=\"128\"></line><line x1=\"31\" y1=\"133\" x2=\"117\" y2=\"133\"></line><line x1=\"31\" y1=\"138\" x2=\"117\" y2=\"138\"></line><line x1=\"31\" y1=\"143\" x2=\"99\" y2=\"143\"></line></g><line x1=\"80\" y1=\"79\" x2=\"94\" y2=\"79\"></line><line x1=\"80\" y1=\"80.8\" x2=\"94\" y2=\"83.3\"></line><line x1=\"69.2\" y1=\"79\" x2=\"55.2\" y2=\"79\"></line><line x1=\"69.2\" y1=\"80.8\" x2=\"55.2\" y2=\"83.3\"></line></g><g></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.html":
/*!***********************************************************************************************!*\
  !*** ./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.html ***!
  \***********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-message-page", {
    attrs: {
      state: _vm.state,
      "svg-name": _vm.svgName,
      title: _vm.title,
      hints: _vm.hints,
      links: _vm.links
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-d56bb40e'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.ts ***!
  \*********************************************************************************************/
/*! exports provided: MErrorResourceUnavailable, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorResourceUnavailable", function() { return MErrorResourceUnavailable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _error_resource_unavailable_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-resource-unavailable.html */ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.html");
/* harmony import */ var _error_resource_unavailable_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_resource_unavailable_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorResourceUnavailable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorResourceUnavailable, _super);
    function MErrorResourceUnavailable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessageState"].Warning;
        _this.svgName = 'message-error-resource-unavailable';
        return _this;
    }
    MErrorResourceUnavailable.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-resource-unavailable', __webpack_require__(/*! ./message-error-resource-unavailable.svg */ "./src/components/error-pages/error-resource-unavailable/message-error-resource-unavailable.svg"));
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-resource-unavailable:title'); }
        })
    ], MErrorResourceUnavailable.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                new _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["Link"]((vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-resource-unavailable:home-label'), "\\")
            ]; }
        })
    ], MErrorResourceUnavailable.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-error-resource-unavailable:hint.primary')
            ]; }
        })
    ], MErrorResourceUnavailable.prototype, "hints", void 0);
    MErrorResourceUnavailable = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_resource_unavailable_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_6__["MMessagePage"],
                _a)
        })
    ], MErrorResourceUnavailable);
    return MErrorResourceUnavailable;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ErrorResourceUnavailablePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ERROR_RESOURCE_UNAVAILABLE_NAME"], MErrorResourceUnavailable);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorResourceUnavailablePlugin);


/***/ }),

/***/ "./src/components/error-pages/error-resource-unavailable/message-error-resource-unavailable.svg":
/*!******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-resource-unavailable/message-error-resource-unavailable.svg ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-missing-resources\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 116.5\"><g stroke-width=\"2\" stroke-miterlimit=\"10\"><g stroke=\"#000000\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path fill=\"#FFC103\" d=\"M65.6,115.5H9.1c-4.5,0-8.1-3.7-8.1-8.1V67.6h64.6V115.5z\"></path><path fill=\"#E30513\" d=\"M130.2,67.6v43.8c0,2.2-1.8,4.1-4.1,4.1H65.6V97.4c-0.6,0.2-1.3,0.3-2,0.3c-4,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1 c0.7,0,1.4,0.1,2,0.3V67.6h25.7c-0.2-0.6-0.3-1.3-0.3-2c0-4,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1c0,0.7-0.1,1.4-0.3,2H130.2z\"></path><path fill=\"#1895FD\" d=\" M56.4,43.7c0,4,3.2,7.1,7.1,7.1c0.7,0,1.4-0.1,2-0.3v17.1H40.4c0.2,0.6,0.3,1.3,0.3,2c0,4-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1 c0-0.7,0.1-1.4,0.3-2H1V23.9c0-2.2,1.8-4.1,4.1-4.1h60.5v17.1c-0.6-0.2-1.3-0.3-2-0.3C59.7,36.6,56.4,39.9,56.4,43.7z\"></path></g><path fill=\"#FFFFFF\" stroke=\"#C1C1C1\" d=\"M149,5.1v43.8h-25.2c0.2-0.6,0.3-1.3,0.3-2 c0-4-3.2-7.1-7.1-7.1s-7.1,3.2-7.1,7.1c0,0.7,0.1,1.4,0.3,2H84.4V31.7c-0.6,0.2-1.3,0.3-2,0.3c-4,0-7.1-3.2-7.1-7.1 s3.2-7.1,7.1-7.1c0.7,0,1.4,0.1,2,0.3V1h60.5C147.2,1,149,2.8,149,5.1z\"></path></g><path fill=\"#C1C1C1\" d=\"M118.4,16.6c0-1.3-0.8-2.4-2.4-2.4c-1.1,0-2.1,0.5-2.9,1.5l-1.2-1.1c1-1.2,2.4-2.1,4.2-2.1 c2.6,0,4.3,1.5,4.3,4c0,3.3-4,4.6-3.6,8.1H115C114.4,20.6,118.4,19.2,118.4,16.6z M115.9,26.6c0.8,0,1.5,0.7,1.5,1.6 c0,0.9-0.7,1.6-1.5,1.6c-0.8,0-1.5-0.7-1.5-1.6C114.5,27.3,115.1,26.6,115.9,26.6z\"></path></svg>"

/***/ }),

/***/ "./src/components/error-pages/error-session-expired/error-session-expired.html":
/*!*************************************************************************************!*\
  !*** ./src/components/error-pages/error-session-expired/error-session-expired.html ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "m-message",
        { attrs: { state: "information" } },
        [_c("m-i18n", { attrs: { k: "m-session-expired:message" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [_c("m-i18n", { attrs: { k: "m-session-expired:directions-1" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [_c("m-i18n", { attrs: { k: "m-session-expired:directions-2" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "m-link",
        {
          attrs: { mode: "link", url: _vm.url, target: _vm.target },
          on: { click: _vm.onClick }
        },
        [_vm._v("\n        " + _vm._s(_vm.backToLabel) + "\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-08055225'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-session-expired/error-session-expired.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/error-pages/error-session-expired/error-session-expired.ts ***!
  \***********************************************************************************/
/*! exports provided: MErrorSessionExpired, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorSessionExpired", function() { return MErrorSessionExpired; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _error_session_expired_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./error-session-expired.html */ "./src/components/error-pages/error-session-expired/error-session-expired.html");
/* harmony import */ var _error_session_expired_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_error_session_expired_html__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MErrorSessionExpired = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorSessionExpired, _super);
    function MErrorSessionExpired() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MErrorSessionExpired.prototype.onClick = function (event) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: function () { return vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$i18n.translate('m-session-expired:back-to-portal'); }
        })
    ], MErrorSessionExpired.prototype, "backToLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '/' })
    ], MErrorSessionExpired.prototype, "url", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MErrorSessionExpired.prototype, "target", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MErrorSessionExpired.prototype, "onClick", null);
    MErrorSessionExpired = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_session_expired_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_7__["MMessagePage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_6__["MLink"],
                _a)
        })
    ], MErrorSessionExpired);
    return MErrorSessionExpired;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var SessionExpiredPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["ERROR_SESSION_EXPIRED_NAME"], MErrorSessionExpired);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SessionExpiredPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.html?style=./error-technical-difficulty.scss":
/*!***************************************************************************************************************************************!*\
  !*** ./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.html?style=./error-technical-difficulty.scss ***!
  \***************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=265e9e39!./error-technical-difficulty.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=265e9e39!./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-message-page",
    {
      staticClass: "m-error-technical-difficulty",
      attrs: {
        state: _vm.state,
        "svg-name": _vm.svgName,
        title: _vm.title,
        hints: _vm.hints,
        links: _vm.links
      }
    },
    [
      _c(
        "m-accordion",
        {
          attrs: {
            skin: "light",
            "icon-size": "small",
            open: _vm.openAccordion
          }
        },
        [
          _c("m-i18n", {
            attrs: {
              slot: "header",
              k: "m-error-technical-difficulty:details"
            },
            slot: "header"
          }),
          _vm._v(" "),
          _c("p", { staticClass: "m-error-technical-difficulty__browser" }, [
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm._f("f-m-i18n")("m-error-technical-difficulty:browser")
                ) + ": "
              )
            ]),
            _vm._v(_vm._s(_vm.userAgent))
          ]),
          _vm._v(" "),
          !!_vm.errorReferenceNumber
            ? _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm._f("f-m-i18n")(
                        "m-error-technical-difficulty:reference-number"
                      )
                    ) + ": "
                  )
                ]),
                _vm._v(_vm._s(_vm.errorReferenceNumber))
              ])
            : _vm._e(),
          _vm._v(" "),
          !!_vm.system
            ? _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm._f("f-m-i18n")("m-error-technical-difficulty:system")
                    ) + ": "
                  )
                ]),
                _vm._v(_vm._s(_vm.system))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("f-m-i18n")(
                    "m-error-technical-difficulty:date.primary"
                  )
                ) +
                "\n            "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.formattedDate))]),
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("f-m-i18n")(
                    "m-error-technical-difficulty:date.secondary"
                  )
                ) +
                "\n            "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.formattedTime))])
          ]),
          _vm._v(" "),
          _vm.propStacktrace
            ? _c(
                "m-panel",
                {
                  staticClass: "m-error-technical-difficulty__stacktrace",
                  attrs: { padding: false }
                },
                [_c("pre", [_vm._v(_vm._s(_vm.error.stack))])]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-265e9e39'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.ts ***!
  \*********************************************************************************************/
/*! exports provided: MErrorTechnicalDifficulty, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MErrorTechnicalDifficulty", function() { return MErrorTechnicalDifficulty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _accordion_accordion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../accordion/accordion */ "./src/components/accordion/accordion.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _panel_panel__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../panel/panel */ "./src/components/panel/panel.ts");
/* harmony import */ var _error_technical_difficulty_html_style_error_technical_difficulty_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./error-technical-difficulty.html?style=./error-technical-difficulty.scss */ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.html?style=./error-technical-difficulty.scss");
/* harmony import */ var _error_technical_difficulty_html_style_error_technical_difficulty_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_error_technical_difficulty_html_style_error_technical_difficulty_scss__WEBPACK_IMPORTED_MODULE_14__);
var _a;

// tslint:disable-next-line: import-blacklist














var MErrorTechnicalDifficulty = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MErrorTechnicalDifficulty, _super);
    function MErrorTechnicalDifficulty() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _message_message__WEBPACK_IMPORTED_MODULE_12__["MMessageState"].Error;
        _this.svgName = 'message-error-technical-difficulty';
        return _this;
    }
    MErrorTechnicalDifficulty.prototype.beforeCreate = function () {
        this.$svgSprite.addSvg('message-error-technical-difficulty', __webpack_require__(/*! ./message-error-technical-difficulty.svg */ "./src/components/error-pages/error-technical-difficulty/message-error-technical-difficulty.svg"));
    };
    Object.defineProperty(MErrorTechnicalDifficulty.prototype, "formattedDate", {
        /**
         * Returns the formatted date for the value received as props (format = YYYY-MM-DD). Used to display the date when the error was generated.
         */
        get: function () {
            return this.errorDate.format('YYYY-MM-DD');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MErrorTechnicalDifficulty.prototype, "formattedTime", {
        /**
         * Returns the formatted time for the value received as props (format = HH:mm:ss). Used to display the time when the error was generated.
         */
        get: function () {
            return this.errorDate.format('HH:mm:ss');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MErrorTechnicalDifficulty.prototype, "propStacktrace", {
        /**
         * Defines if the stack trace is to be displayed based on the showStrackTrace prop and the presence of the attribute stack in the error.
         */
        get: function () {
            return this.showStackTrace && !!this.error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MErrorTechnicalDifficulty.prototype, "userAgent", {
        /**
         * Returns the current userAgent string.
         */
        get: function () {
            return window.navigator.userAgent;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype).$i18n.translate('m-error-technical-difficulty:title'); }
        })
    ], MErrorTechnicalDifficulty.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: function () { return [
                new _message_page_message_page__WEBPACK_IMPORTED_MODULE_11__["Link"]((vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype).$i18n.translate('m-error-technical-difficulty:home-label'), '\\')
            ]; }
        })
    ], MErrorTechnicalDifficulty.prototype, "links", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: function () { return [
                (vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype).$i18n.translate('m-error-technical-difficulty:hint.primary'),
                (vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype).$i18n.translate('m-error-technical-difficulty:hint.secondary')
            ]; }
        })
    ], MErrorTechnicalDifficulty.prototype, "hints", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: function () { return moment__WEBPACK_IMPORTED_MODULE_1___default()(); }
        })
    ], MErrorTechnicalDifficulty.prototype, "errorDate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])()
    ], MErrorTechnicalDifficulty.prototype, "errorReferenceNumber", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: false
        })
    ], MErrorTechnicalDifficulty.prototype, "showStackTrace", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])()
    ], MErrorTechnicalDifficulty.prototype, "error", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])()
    ], MErrorTechnicalDifficulty.prototype, "system", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_4__["Prop"])({
            default: false
        })
    ], MErrorTechnicalDifficulty.prototype, "openAccordion", void 0);
    MErrorTechnicalDifficulty = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _error_technical_difficulty_html_style_error_technical_difficulty_scss__WEBPACK_IMPORTED_MODULE_14___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_3___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_11__["MMessagePage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_10__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["ACCORDION_NAME"]] = _accordion_accordion__WEBPACK_IMPORTED_MODULE_7__["MAccordion"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["PANEL_NAME"]] = _panel_panel__WEBPACK_IMPORTED_MODULE_13__["MPanel"],
                _a),
            filters: {
                'f-m-i18n': _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["i18nFilter"]
            }
        })
    ], MErrorTechnicalDifficulty);
    return MErrorTechnicalDifficulty;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var ErrorTechnicalDifficultyPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["ERROR_TECHNICAL_DIFFICULTY_NAME"], MErrorTechnicalDifficulty);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorTechnicalDifficultyPlugin);


/***/ }),

/***/ "./src/components/error-pages/error-technical-difficulty/message-error-technical-difficulty.svg":
/*!******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-technical-difficulty/message-error-technical-difficulty.svg ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg id=\"m-svg__message-error-technical-difficulty\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 153 132\"><path fill=\"none\" stroke=\"#000000\" stroke-width=\"5\" stroke-miterlimit=\"10\" d=\"M89.5,65.4c17.2-17.6,19.3-27,16.9-32.3 c-2.7-6-10.8-6.4-12.6-13.7c-1.5-5.9,1.9-13.3,7.1-15.7c8.5-3.9,22.2,5.8,24.2,15.7c1.5,7.6-4.5,13-1.3,21.2 c1.4,3.5,3.8,5.9,5.5,7.3\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M111.5,85l-1.7,7.1c-0.4,1.5-1.9,2.4-3.4,2.1 l-27-6.5c-1.5-0.4-2.4-1.9-2.1-3.4l1.7-7.1c0.4-1.5,1.9-2.4,3.4-2.1l27,6.5C110.9,82,111.8,83.5,111.5,85z\"></path><path fill=\"#D7D7D7\" d=\"M109.8,90.7l-0.3,1.3c-0.2,1-1.2,1.6-2.2,1.4l-28.8-7c-1-0.2-1.6-1.2-1.4-2.2l0.3-1.3c0.2-1,1.2-1.6,2.2-1.4 l28.8,7C109.5,88.7,110.1,89.7,109.8,90.7z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M110.7,72.1l3.4,0.8l-5.8,24l-13.7-3.3 c-1.8-0.4-2.9-2.3-2.5-4.1l2.5-10.4c0.4-1.8,2.3-2.9,4.1-2.5l3.7,0.9l0.1-0.3C103.3,73.5,107,71.2,110.7,72.1z\"></path><rect x=\"100.3\" y=\"83.8\" transform=\"matrix(0.2355 -0.9719 0.9719 0.2355 3.1518 174.735)\" fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"24.7\" height=\"3.2\"></rect><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"102.3\" y1=\"77.5\" x2=\"101\" y2=\"82.9\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"112.6\" y1=\"92.7\" x2=\"111\" y2=\"92.3\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"113.7\" y1=\"88\" x2=\"112.1\" y2=\"87.7\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"114.8\" y1=\"83.4\" x2=\"113.3\" y2=\"83\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"115.9\" y1=\"78.7\" x2=\"114.4\" y2=\"78.4\"></line><rect x=\"94.9\" y=\"81.7\" transform=\"matrix(0.2355 -0.9719 0.9719 0.2355 -8.7167 158.006)\" fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"2.4\" height=\"5.6\"></rect><path fill=\"#D7D7D7\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M74.2,123.9l7-2c1.5-0.4,2.3-2,1.9-3.5l-7.7-26.7 c-0.4-1.5-2-2.3-3.5-1.9l-7,2c-1.5,0.4-2.3,2-1.9,3.5l7.7,26.7C71.2,123.4,72.7,124.3,74.2,123.9z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M61.3,123.6l1,3.4l23.8-6.8l-3.9-13.6 c-0.5-1.8-2.4-2.8-4.2-2.3l-10.3,3c-1.8,0.5-2.8,2.4-2.3,4.2l1,3.6l-0.3,0.1C62.4,116.2,60.2,120,61.3,123.6z\"></path><rect x=\"62.2\" y=\"123.5\" transform=\"matrix(0.9612 -0.276 0.276 0.9612 -31.6262 25.4444)\" fill=\"#D7D7D7\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"24.7\" height=\"3.2\"></rect><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"66.3\" y1=\"115\" x2=\"71.7\" y2=\"113.5\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"81.9\" y1=\"124.6\" x2=\"81.5\" y2=\"123.1\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"77.3\" y1=\"126\" x2=\"76.9\" y2=\"124.4\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"72.7\" y1=\"127.3\" x2=\"72.3\" y2=\"125.8\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"68.1\" y1=\"128.6\" x2=\"67.7\" y2=\"127.1\"></line><rect x=\"71.9\" y=\"105.7\" transform=\"matrix(0.9612 -0.276 0.276 0.9612 -27.1057 24.4025)\" fill=\"#D7D7D7\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" width=\"2.4\" height=\"5.6\"></rect><path fill=\"#929292\" d=\"M57.5,107.9c-0.6,0-1.1-0.2-1.6-0.6L16.5,69.5c-1.7-1.6-2.7-3.8-2.7-6.2s0.8-4.6,2.5-6.3l25.5-26.6 c1.7-1.8,4-2.7,6.4-2.7c2.3,0,4.5,0.9,6.2,2.5L93.8,68c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.6,1.6l-34.7,36.2 C58.7,107.7,58.1,107.9,57.5,107.9z\"></path><path d=\"M48.2,28.6L48.2,28.6c2.1,0,4,0.8,5.5,2.2l39.4,37.8c0.5,0.5,0.5,1.3,0,1.8l-34.7,36.2c-0.2,0.2-0.6,0.4-0.9,0.4 c-0.3,0-0.6-0.1-0.9-0.3L17.2,68.8c-1.5-1.5-2.4-3.4-2.4-5.5c0-2.1,0.7-4.1,2.2-5.6l25.5-26.6C44,29.5,46,28.6,48.2,28.6 M48.2,26.6 c-2.6,0-5.2,1-7.1,3L15.6,56.2c-3.8,3.9-3.6,10.2,0.3,14L55.3,108c0.6,0.6,1.4,0.9,2.2,0.9c0.9,0,1.7-0.3,2.3-1l34.8-36.1 c1.2-1.3,1.2-3.4-0.1-4.6L55,29.4C53.1,27.5,50.6,26.6,48.2,26.6L48.2,26.6z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M77.8,37.4L77.8,37.4c0.4,0.4,0.7,0.9,0.9,1.5 l0.3,1.3c0.2,0.8,0.1,1.6-0.3,2.3c-0.4,0.8-1.2,1.4-2.1,1.6l-4.4,1l-1.8-7.5l0,0l4.4-1.1C75.8,36.2,77,36.6,77.8,37.4z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\"M84.7,44.7 c0.8-0.2,1.6-0.2,2.3,0.1l3.9,1.1c0.7,0.2,1.5-0.1,1.7-0.8s-0.1-1.5-0.8-1.7l-4.2-1.5l8-0.3c0.7,0,1.3-0.6,1.3-1.3S96.3,39,95.6,39 h-6.8l8.2-1.9c0.7-0.2,1.2-0.9,1-1.6c-0.2-0.7-0.9-1.2-1.6-1l-8.2,1.9l6.5-3c0.7-0.3,1-1.1,0.7-1.8s-1.1-1-1.8-0.7l-9.4,3.6l1.7-3.1 c0.4-0.6,0.1-1.5-0.5-1.8c-0.6-0.4-1.5-0.1-1.8,0.5l-5,5.9c-0.6,0.9-0.8,2-0.6,3.1c0.1,0.6,0.5,2.4,0.7,3 C79.2,45,81.8,45.3,84.7,44.7z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\"M32.4,99.2 c-0.1,0.8-0.1,1.6,0.2,2.3l1.2,3.9c0.3,0.7-0.1,1.5-0.8,1.7c-0.7,0.3-1.5-0.1-1.7-0.8l-1.7-4.2v8c0,0.7-0.6,1.4-1.3,1.4 c-0.7,0-1.4-0.6-1.4-1.3l-0.3-6.8l-1.5,8.3c-0.1,0.7-0.8,1.2-1.6,1.1s-1.2-0.8-1.1-1.6l1.5-8.3l-2.7,6.6c-0.3,0.7-1.1,1-1.7,0.7 c-0.7-0.3-1-1.1-0.7-1.7L22,99l-3,1.8c-0.6,0.4-1.4,0.2-1.8-0.4S17,99,17.6,98.6l5.7-5.3c0.9-0.6,2-0.9,3.1-0.7 c0.6,0.1,2.4,0.4,3.1,0.6C32.5,93.7,32.9,96.3,32.4,99.2z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M34.6,90l-0.4,2.1c-0.2,1.2-1.3,2.1-2.5,2.2 c-0.3,0-0.5,0-0.8,0l-3.2-0.6l-1.3-0.3l-2.5-0.5l-0.8-0.1c-1.5-0.3-2.5-1.8-2.2-3.3l0.4-2.1c0.3-1.5,1.8-2.5,3.3-2.2h0.1l7.6,1.5 h0.1C33.9,87.1,34.9,88.5,34.6,90z\"></path><path fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M70.4,37.6l1.8,7.5l-8.4,2l19.9,19.1 c7.2,6.9,6.4,19.5-1.9,28s-20.7,9.9-27.9,3L34,78.2l-1.7,8.5l-7.6-1.5l3-14.8c0.3-1.7,2.1-2.9,3.8-2.5L32,68l21.5-22.4l-0.1-0.5 c-0.4-1.7,0.6-3.5,2.4-3.9L70.4,37.6z\"></path><path fill=\"none\" stroke=\"#000000\" stroke-width=\"5\" stroke-miterlimit=\"10\" d=\"M137,55.8c16,16,3.3,26-1,30 c-2.2,2.1-4.6,3.7-7.3,6.4c-5.2,5.3-9.7,15.3-6.4,23.9c3.7,9.6,16.4,15.7,29.5,12\"></path><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"127\" y1=\"47.8\" x2=\"130\" y2=\"50.8\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"132.7\" y1=\"55.3\" x2=\"136.4\" y2=\"57.3\"></line><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"135.7\" y1=\"55.2\" x2=\"139.4\" y2=\"57.4\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"129\" y1=\"47.8\" x2=\"133.2\" y2=\"50.6\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"136.5\" y1=\"51.5\" x2=\"138.6\" y2=\"55.1\"></line><line fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"128.6\" y1=\"45.5\" x2=\"132.5\" y2=\"47.1\"></line><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M70.4,37.6l1.8,7.5l-8.4,2l19.9,19.1 c7.2,6.9,6.4,19.5-1.9,28s-20.7,9.9-27.9,3L34,78.2l-1.7,8.5l-7.6-1.5l3-14.8c0.3-1.7,2.1-2.9,3.8-2.5L32,68l21.5-22.4l-0.1-0.5 c-0.4-1.7,0.6-3.5,2.4-3.9L70.4,37.6z\"></path><path fill=\"#D7D7D7\" d=\"M82.6,64.2L82.6,64.2c8.3,8.3,8.3,22-0.1,30.4s-22.1,8.4-30.5,0L35.2,77.8L82.6,64.2z\"></path><path fill=\"#FFFFFF\" d=\"M80.8,62.7l1.8,3.1c6.7,7.4,2,18.3-5.4,25.1c-7.4,6.7-18.1,6-26.8-0.6L32.2,75.8L80.8,62.7z\"></path><path fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M70.4,37.6l1.8,7.5l-8.4,2l19.9,19.1 c7.2,6.9,6.4,19.5-1.9,28s-20.7,9.9-27.9,3L34,78.2l-1.7,8.5l-7.6-1.5l3-14.8c0.3-1.7,2.1-2.9,3.8-2.5L32,68l21.5-22.4l-0.1-0.5 c-0.4-1.7,0.6-3.5,2.4-3.9L70.4,37.6z\"></path><path fill=\"#F39612\" d=\"M62.9,89.4c0,0-0.1,0-0.2-0.1L45.2,72.6c-0.1-0.1-0.1-0.3,0-0.5l12.9-13.5c0.1-0.1,0.2-0.1,0.2-0.1 s0.1,0,0.2,0.1l17.4,16.7c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.1-0.1,0.2L63.1,89.3C63,89.4,62.9,89.4,62.9,89.4z\"></path><path d=\"M58.4,59.8l16.5,15.8l-12,12.5L46.4,72.3L58.4,59.8 M58.4,57.6c-0.3,0-0.7,0.1-1,0.4L44.5,71.4c-0.5,0.5-0.5,1.4,0,1.9 L61.9,90c0.3,0.2,0.6,0.4,0.9,0.4c0.3,0,0.7-0.1,1-0.4l12.9-13.5c0.5-0.5,0.5-1.4,0-1.9L59.3,57.9C59,57.7,58.7,57.6,58.4,57.6 L58.4,57.6z\"></path><path fill=\"#B3040F\" d=\"M53.3,74.8c-0.5,0-1-0.2-1.3-0.5c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.5,0.2-1,0.5-1.4c0.4-0.4,0.9-0.6,1.4-0.6 s1,0.2,1.3,0.5c0.4,0.4,0.6,0.9,0.6,1.4s-0.2,1-0.5,1.4C54.3,74.6,53.8,74.8,53.3,74.8z\"></path><path d=\"M53.3,71.4L53.3,71.4c0.4,0,0.7,0.1,1,0.4c0.6,0.5,0.6,1.5,0,2c-0.3,0.3-0.6,0.4-1,0.4s-0.7-0.1-1-0.4s-0.4-0.6-0.4-1 s0.1-0.7,0.4-1C52.5,71.5,52.9,71.4,53.3,71.4 M53.3,70.4c-0.6,0-1.3,0.3-1.8,0.8c-0.9,1-0.9,2.5,0.1,3.4c0.5,0.5,1.1,0.7,1.7,0.7 c0.6,0,1.3-0.3,1.8-0.8c0.9-1,0.9-2.5-0.1-3.4C54.5,70.6,53.9,70.4,53.3,70.4L53.3,70.4z\"></path><path fill=\"#0075C3\" stroke=\"#000000\" stroke-miterlimit=\"10\" d=\"M60.9,68.4l-1.7,1.8c-0.9,1-2.5,1-3.4,0.1l0,0 c-1-0.9-1-2.5-0.1-3.4l1.7-1.8c0.9-1,2.5-1,3.4-0.1l0,0C61.8,65.8,61.9,67.4,60.9,68.4z\"></path><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"56.8\" y1=\"66.1\" x2=\"60.1\" y2=\"69.2\"></line><path fill=\"#98D5FF\" stroke=\"#000000\" stroke-miterlimit=\"10\" d=\"M71.2,76.5l-7.6,7.9c-0.5,0.5-1.2,0.5-1.7,0l-5.3-5 c-0.5-0.5-0.5-1.2,0-1.7l7.6-7.9c0.5-0.5,1.2-0.5,1.7,0l5.3,5C71.7,75.3,71.7,76.1,71.2,76.5z\"></path><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"58.9\" y1=\"75.7\" x2=\"66\" y2=\"82.5\"></line><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"62.3\" y1=\"72.2\" x2=\"69.4\" y2=\"79\"></line><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"58.2\" y1=\"80.5\" x2=\"67.5\" y2=\"70.8\"></line><line fill=\"none\" stroke=\"#000000\" stroke-miterlimit=\"10\" x1=\"60.6\" y1=\"83.2\" x2=\"69.9\" y2=\"73.6\"></line><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M54,48.5L34.9,68.4c-1.7,1.8-4.6,1.9-6.4,0.1 l-0.9-0.9c-1.8-1.7-1.9-4.6-0.1-6.4l19.1-19.9c1.7-1.8,4.6-1.9,6.4-0.1l0.9,0.9C55.6,43.8,55.7,46.7,54,48.5z\"></path><path fill=\"#FFFFFF\" d=\"M25.8,62.9c-6.2,0-12.1-2.4-16.7-6.8S1.9,45.9,1.6,39.7s1.9-12,6.1-16.4s10-6.8,16.2-6.8s12.1,2.4,16.7,6.8 s7.2,10.2,7.5,16.4s-1.9,12-6.1,16.4C37.7,60.5,32,62.9,25.8,62.9z\"></path><path d=\"M23.9,15.4v2l0,0c5.9,0,11.6,2.3,16,6.5c9,8.7,9.6,22.8,1.3,31.4c-4,4.2-9.5,6.5-15.4,6.5s-11.6-2.3-16-6.5 s-6.9-9.8-7.2-15.8C2.4,33.6,4.4,28,8.5,23.8c4-4.2,9.5-6.5,15.4-6.5V15.4 M23.9,15.4c-6.2,0-12.3,2.4-16.9,7.1 C-2.1,32-1.5,47.4,8.4,56.8c4.9,4.7,11.2,7.1,17.4,7.1s12.3-2.4,16.9-7.1c9.1-9.5,8.5-24.8-1.4-34.3C36.4,17.8,30.1,15.4,23.9,15.4 L23.9,15.4z\"></path><ellipse transform=\"matrix(0.6921 -0.7218 0.7218 0.6921 -20.9882 30.0775)\" cx=\"24.8\" cy=\"39.6\" rx=\"19.9\" ry=\"20.7\"></ellipse><path fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\" M9.4,31c4.9-9.7,17.9-10.1,23.3-7\"></path><path fill=\"#FFFFFF\" d=\"M8.3,35.6c1.9,0,1.9-3,0-3S6.4,35.6,8.3,35.6L8.3,35.6z\"></path><path fill=\"#FFFFFF\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M77.8,35.7l0.2,0.8l0.6,2.4l0.3,1.3l0.8,3.2 c0.1,0.3,0.1,0.6,0.1,0.8c-0.1,1.2-0.9,2.3-2.1,2.6l-2.1,0.5c-1.5,0.4-3-0.6-3.4-2.1v-0.1l-1.8-7.5l0,0v-0.1c-0.4-1.5,0.6-3,2.1-3.4 l2.1-0.5C76,33.2,77.5,34.2,77.8,35.7z\"></path><path fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M77.8,35.7l0.2,0.8l0.6,2.4l0.3,1.3l0.8,3.2 c0.1,0.3,0.1,0.6,0.1,0.8c-0.1,1.2-0.9,2.3-2.1,2.6l-2.1,0.5c-1.5,0.4-3-0.6-3.4-2.1v-0.1l-1.8-7.5l0,0v-0.1c-0.4-1.5,0.6-3,2.1-3.4 l2.1-0.5C76,33.2,77.5,34.2,77.8,35.7z\"></path><ellipse transform=\"matrix(0.82 -0.5724 0.5724 0.82 -56.3444 59.2237)\" fill=\"#D7D7D7\" cx=\"66\" cy=\"119.2\" rx=\"4\" ry=\"2\"></ellipse></svg>"

/***/ }),

/***/ "./src/components/expandable-layout/expandable-layout.html?style=./expandable-layout.scss":
/*!************************************************************************************************!*\
  !*** ./src/components/expandable-layout/expandable-layout.html?style=./expandable-layout.scss ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c2f61!./expandable-layout.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c2f61!./src/components/expandable-layout/expandable-layout.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-expandable-layout", class: _vm.styleClasses },
    [
      _c(
        "div",
        { staticClass: "m-expandable-layout__main" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-expandable-layout__panel", style: _vm.panelStyle },
        [
          _c(
            "div",
            {
              ref: "panelContent",
              staticClass: "m-expandable-layout__panel-content",
              style: _vm.panelContentStyle
            },
            [_vm._t("panel")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-056c2f61'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/expandable-layout/expandable-layout.ts":
/*!***************************************************************!*\
  !*** ./src/components/expandable-layout/expandable-layout.ts ***!
  \***************************************************************/
/*! exports provided: MExpandableLayoutPanelScrollMode, MExpandableLayoutPanelPosition, MExpandableLayout, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayoutPanelScrollMode", function() { return MExpandableLayoutPanelScrollMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayoutPanelPosition", function() { return MExpandableLayoutPanelPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayout", function() { return MExpandableLayout; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modul_modul__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/modul/modul */ "./src/utils/modul/modul.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _expandable_layout_html_style_expandable_layout_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./expandable-layout.html?style=./expandable-layout.scss */ "./src/components/expandable-layout/expandable-layout.html?style=./expandable-layout.scss");
/* harmony import */ var _expandable_layout_html_style_expandable_layout_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_expandable_layout_html_style_expandable_layout_scss__WEBPACK_IMPORTED_MODULE_6__);







var MExpandableLayoutPanelScrollMode;
(function (MExpandableLayoutPanelScrollMode) {
    MExpandableLayoutPanelScrollMode["Follow"] = "follow";
    MExpandableLayoutPanelScrollMode["Static"] = "static";
})(MExpandableLayoutPanelScrollMode || (MExpandableLayoutPanelScrollMode = {}));
var MExpandableLayoutPanelPosition;
(function (MExpandableLayoutPanelPosition) {
    MExpandableLayoutPanelPosition["Left"] = "left";
    MExpandableLayoutPanelPosition["Right"] = "right";
})(MExpandableLayoutPanelPosition || (MExpandableLayoutPanelPosition = {}));
var MExpandableLayout = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MExpandableLayout, _super);
    function MExpandableLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MExpandableLayout.prototype.updateMode = function () {
        if (this.panelScrollMode === MExpandableLayoutPanelScrollMode.Static) {
            this.$refs.panelContent.style.top = '';
            this.$refs.panelContent.style.bottom = '';
        }
    };
    MExpandableLayout.prototype.mounted = function () {
        this.$modul.event.$on('scroll', this.setPanelPosition);
        this.$modul.event.$on('resize', this.setPanelPosition);
    };
    MExpandableLayout.prototype.beforeDestroy = function () {
        this.$modul.event.$off('scroll', this.setPanelPosition);
        this.$modul.event.$off('resize', this.setPanelPosition);
    };
    MExpandableLayout.prototype.setPanelPosition = function () {
        if (this.panelScrollMode === MExpandableLayoutPanelScrollMode.Follow) {
            var _a = this.$el.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
            if (top < 0) {
                this.$refs.panelContent.style.top = -top + 'px';
            }
            else {
                this.$refs.panelContent.style.top = '';
            }
            if (bottom > document.documentElement.clientHeight) {
                this.$refs.panelContent.style.bottom = (bottom - document.documentElement.clientHeight) + 'px';
            }
            else {
                this.$refs.panelContent.style.bottom = '';
            }
        }
    };
    Object.defineProperty(MExpandableLayout.prototype, "styleClasses", {
        get: function () {
            return {
                'm--has-left-panel': !!this.$slots.panel && this.panelPosition === MExpandableLayoutPanelPosition.Left,
                'm--has-right-panel': !!this.$slots.panel && this.panelPosition === MExpandableLayoutPanelPosition.Right,
                'm--is-panel-over-content': this.overContent
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MExpandableLayout.prototype, "panelStyle", {
        get: function () {
            return {
                width: this.open ? this.panelWidth : '0'
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MExpandableLayout.prototype, "panelContentStyle", {
        get: function () {
            return {
                width: this.panelWidth
            };
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MExpandableLayout.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MExpandableLayoutPanelScrollMode.Static,
            validator: function (value) {
                return value === MExpandableLayoutPanelScrollMode.Static ||
                    value === MExpandableLayoutPanelScrollMode.Follow;
            }
        })
    ], MExpandableLayout.prototype, "panelScrollMode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MExpandableLayoutPanelPosition.Left,
            validator: function (value) {
                return value === MExpandableLayoutPanelPosition.Left ||
                    value === MExpandableLayoutPanelPosition.Right;
            }
        })
    ], MExpandableLayout.prototype, "panelPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '320px' })
    ], MExpandableLayout.prototype, "panelWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MExpandableLayout.prototype, "overContent", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('panelScrollMode')
    ], MExpandableLayout.prototype, "updateMode", null);
    MExpandableLayout = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _expandable_layout_html_style_expandable_layout_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MExpandableLayout);
    return MExpandableLayout;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ExpandableLayoutPlugin = {
    install: function (v, options) {
        v.use(_utils_modul_modul__WEBPACK_IMPORTED_MODULE_3__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["EXPANDABLE_LAYOUT_NAME"], MExpandableLayout);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ExpandableLayoutPlugin);


/***/ }),

/***/ "./src/components/file-select/file-select.html?style=./file-select.scss":
/*!******************************************************************************!*\
  !*** ./src/components/file-select/file-select.html?style=./file-select.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bcbac466!./file-select.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bcbac466!./src/components/file-select/file-select.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-file-select" },
    [
      _c("input", {
        ref: "inputFile",
        staticClass: "m-file-select__hidden",
        attrs: {
          type: "file",
          id: _vm.id,
          disabled: _vm.disabled || _vm.isWaiting,
          tabindex: "-1",
          multiple: _vm.multiple,
          accept: _vm.extensions
        },
        on: { change: _vm.processFile }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "m-file-select__hidden", attrs: { for: _vm.id } },
        [
          !_vm.hasLabel
            ? _c("m-i18n", { attrs: { k: "m-select-file:label" } })
            : [_vm._v(_vm._s(_vm.label))]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "m-button",
        {
          attrs: {
            "aria-hidden": "true",
            skin: _vm.skin,
            disabled: _vm.disabled,
            waiting: _vm.waiting,
            "full-size": _vm.fullSize,
            "icon-name": _vm.iconName,
            "icon-position": _vm.iconPosition,
            "icon-size": _vm.iconSize
          },
          on: { click: _vm.onClick, focus: _vm.onFocus, blur: _vm.onBlur }
        },
        [
          !_vm.hasLabel
            ? _c("m-i18n", { attrs: { k: "m-select-file:label" } })
            : [_vm._v(_vm._s(_vm.label))]
        ],
        2
      ),
      _vm._v(" "),
      _c("m-validation-message", {
        ref: "validation",
        attrs: {
          disabled: _vm.isDisabled,
          error: _vm.hasError,
          "error-message": _vm.errorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-bcbac466'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/file-select/file-select.ts":
/*!***************************************************!*\
  !*** ./src/components/file-select/file-select.ts ***!
  \***************************************************/
/*! exports provided: MFileSelect, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFileSelect", function() { return MFileSelect; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_file_file__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/file/file */ "./src/utils/file/file.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _file_select_html_style_file_select_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./file-select.html?style=./file-select.scss */ "./src/components/file-select/file-select.html?style=./file-select.scss");
/* harmony import */ var _file_select_html_style_file_select_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_file_select_html_style_file_select_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var MFileSelect = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MFileSelect, _super);
    function MFileSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mFileSelect-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__["default"].generate();
        return _this;
    }
    MFileSelect.prototype.destroyed = function () {
        if (!this.keepStore) {
            this.$file.destroy(this.storeName);
        }
    };
    MFileSelect.prototype.onClick = function (event) {
        this.$refs.inputFile.click();
        this.$emit('click', event);
        this.$refs.inputFile.blur();
    };
    MFileSelect.prototype.onFocus = function (event) {
        this.$emit('focus');
    };
    MFileSelect.prototype.onBlur = function (event) {
        this.$emit('blur');
    };
    MFileSelect.prototype.processFile = function (event) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var file;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        file = this.$refs.inputFile.files;
                        if (!file) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$file.add(file, this.storeName)];
                    case 1:
                        _a.sent();
                        this.$emit('file-selected');
                        _a.label = 2;
                    case 2:
                        this.$refs.inputFile.value = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MFileSelect.prototype, "hasLabel", {
        get: function () {
            return !!this.label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileSelect.prototype, "extensions", {
        get: function () {
            return this.allowedExtensions.map(function (ext) { return (ext.startsWith('.') ? '' : '.') + ext; }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonSkin"].Secondary,
            validator: function (value) {
                return value === _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonSkin"].Primary || value === _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonSkin"].Secondary;
            }
        })
    ], MFileSelect.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "fullSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonIconPosition"].Left,
            validator: function (value) {
                return value === _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonIconPosition"].Left ||
                    value === _button_button__WEBPACK_IMPORTED_MODULE_7__["MButtonIconPosition"].Right;
            }
        })
    ], MFileSelect.prototype, "iconPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '12px' })
    ], MFileSelect.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileSelect.prototype, "multiple", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _utils_file_file__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_STORE_NAME"]
        })
    ], MFileSelect.prototype, "storeName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MFileSelect.prototype, "keepStore", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MFileSelect.prototype, "allowedExtensions", void 0);
    MFileSelect = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _file_select_html_style_file_select_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_7__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_10__["MValidationMessage"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MFileSelect);
    return MFileSelect;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var FileSelectPlugin = {
    install: function (v, options) {
        v.use(_utils_file_file__WEBPACK_IMPORTED_MODULE_4__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["FILE_SELECT_NAME"], MFileSelect);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FileSelectPlugin);


/***/ }),

/***/ "./src/components/file-upload/file-upload.html?style=./file-upload.scss":
/*!******************************************************************************!*\
  !*** ./src/components/file-upload/file-upload.html?style=./file-upload.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=58475183!./file-upload.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=58475183!./src/components/file-upload/file-upload.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.title,
        open: _vm.propOpen,
        "close-on-backdrop": false,
        "padding-body": false
      },
      on: {
        "update:open": function($event) {
          _vm.propOpen = $event
        },
        open: _vm.onOpen,
        close: _vm.onClose,
        "portal-after-open": _vm.onPortalAfterOpen
      }
    },
    [
      _c(
        "span",
        { attrs: { slot: "trigger" }, slot: "trigger" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "m-file-drop",
              rawName: "v-m-file-drop.keep-store",
              value: _vm.storeName,
              expression: "storeName",
              modifiers: { "keep-store": true }
            }
          ],
          staticClass: "m-file-upload"
        },
        [
          _vm.hasRejectedFiles
            ? _c(
                "m-message",
                {
                  ref: "message",
                  staticClass: "m-file-upload__error-message",
                  attrs: { state: "error", "close-button": true },
                  on: { close: _vm.onMessageClose }
                },
                [
                  _c(
                    "p",
                    { staticClass: "m-file-upload__error-message__title" },
                    [
                      _c("m-i18n", {
                        attrs: {
                          nb: _vm.rejectedFiles.length,
                          k: "m-file-upload:rejectFileMsg"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "m-file-upload__error-message__list" },
                    _vm._l(_vm.rejectedFiles, function(file) {
                      return _c("li", { key: file.uid }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "m-file-upload__error-message__file-name"
                          },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        _vm._v(" "),
                        _vm.hasExtensionsRejection(file)
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "m-file-upload__error-message__error"
                              },
                              [
                                _c("m-i18n", {
                                  attrs: { k: "m-file-upload:extensionFileMsg" }
                                })
                              ],
                              1
                            )
                          : _vm.hasSizeRejection(file)
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "m-file-upload__error-message__error"
                              },
                              [
                                _c("m-i18n", {
                                  attrs: { k: "m-file-upload:maxSizeMsg" }
                                }),
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm._f("f-m-filesize")(
                                        _vm.maxSizeKb * 1024
                                      )
                                    ) +
                                    ").\n                    "
                                )
                              ],
                              1
                            )
                          : _vm.hasMaxFilesRejection(file)
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "m-file-upload__error-message__error"
                              },
                              [
                                _c("m-i18n", {
                                  attrs: { k: "m-file-upload:maxNumberMsg" }
                                }),
                                _vm._v(
                                  " (" +
                                    _vm._s(_vm.propMaxFiles) +
                                    "\n                        "
                                ),
                                _c("m-i18n", {
                                  attrs: {
                                    nb: _vm.propMaxFiles,
                                    k: "m-file-upload:file"
                                  }
                                }),
                                _vm._v(")\n                    ")
                              ],
                              1
                            )
                          : _vm.hasCustomValidationRejection(file)
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "m-file-upload__error-message__error"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.customValidation.message) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("header"),
          _vm._v(" "),
          _vm.isDropZoneEnabled
            ? _c("div", { staticClass: "m-file-upload__drop-zone" }, [
                _c(
                  "div",
                  { staticClass: "m-file-upload__drop-zone__instructions" },
                  [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "m-file-upload__drop-zone__instructions__title"
                      },
                      [
                        _c("m-icon", {
                          attrs: { name: "m-svg__arrow--down", size: "32px" }
                        }),
                        _vm._v(" "),
                        _c("m-i18n", {
                          attrs: {
                            k: "m-file-upload:dropFile",
                            nb: _vm.propMaxFiles
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("m-file-select", {
                      staticClass:
                        "m-file-upload__drop-zone__instructions__button",
                      attrs: {
                        skin: "secondary",
                        multiple: _vm.multipleSelection,
                        "store-name": _vm.storeName,
                        "keep-store": "true",
                        "allowed-extensions": _vm.allowedExtensions
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasAllowedExtensions
                  ? _c(
                      "p",
                      { staticClass: "m-file-upload__drop-zone__format" },
                      [
                        _c("m-i18n", {
                          staticClass:
                            "m-file-upload__drop-zone__format__label",
                          attrs: {
                            k: "m-file-upload:format",
                            nb: _vm.allowedExtensions.length,
                            "format-mode": "vsprintf"
                          }
                        }),
                        _vm._v(
                          ": " +
                            _vm._s(_vm.fileAllowedExtensions) +
                            "\n            "
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectionHelpMessage
                  ? _c(
                      "p",
                      { staticClass: "m-file-upload__drop-zone__format" },
                      [_vm._v(_vm._s(_vm.selectionHelpMessage) + " ")]
                    )
                  : _vm._e()
              ])
            : _c(
                "div",
                { staticClass: "m-file-upload__no-drop-zone" },
                [
                  _c(
                    "h3",
                    { staticClass: "m-file-upload__no-drop-zone__title" },
                    [
                      _c("m-i18n", {
                        attrs: {
                          k: "m-file-upload:selectFile",
                          nb: _vm.propMaxFiles
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("m-file-select", {
                    staticClass:
                      "m-file-upload__no-drop-zone__instructions__button",
                    attrs: {
                      skin: "primary",
                      multiple: _vm.maxFiles > 1 ? true : false,
                      "store-name": _vm.storeName,
                      "keep-store": "true",
                      "allowed-extensions": _vm.allowedExtensions
                    }
                  }),
                  _vm._v(" "),
                  _vm.hasAllowedExtensions
                    ? _c(
                        "p",
                        { staticClass: "m-file-upload__no-drop-zone__format" },
                        [
                          _c("m-i18n", {
                            staticClass:
                              "m-file-upload__no-drop-zone__format__label",
                            attrs: {
                              k: "m-file-upload:format",
                              nb: _vm.allowedExtensions.length
                            }
                          }),
                          _vm._v(
                            ": " +
                              _vm._s(_vm.fileAllowedExtensions) +
                              "\n            "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectionHelpMessage
                    ? _c(
                        "p",
                        { staticClass: "m-file-upload__drop-zone__format" },
                        [_vm._v(_vm._s(_vm.selectionHelpMessage) + " ")]
                      )
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          !_vm.hasUploadingFiles
            ? _c(
                "h3",
                { staticClass: "m-file-upload__title" },
                [
                  _c("m-i18n", { attrs: { k: "m-file-upload:import" } }),
                  _vm._v(
                    " (" + _vm._s(_vm.uploadingFiles.length) + "\n            "
                  ),
                  _c("m-i18n", {
                    attrs: {
                      nb: _vm.uploadingFiles.length,
                      k: "m-file-upload:file"
                    }
                  }),
                  _vm._v(")\n        ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasUploadingFiles
            ? _c(
                "div",
                { staticClass: "m-file-upload__import-list" },
                [
                  _c(
                    "transition-group",
                    {
                      staticClass: "m-file-upload__import-list__wrap",
                      attrs: { name: "m--is", tag: "ul" }
                    },
                    _vm._l(_vm.uploadingFiles, function(file, index) {
                      return _c("li", { key: file.uid }, [
                        _c(
                          "div",
                          {
                            staticClass: "m-file-upload__import-list__content"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__import-list__file-icon"
                              },
                              [
                                _c("m-icon-file", {
                                  directives: [
                                    {
                                      name: "m-badge",
                                      rawName: "v-m-badge",
                                      value: { state: _vm.getBadgeState(file) },
                                      expression:
                                        "{ state: getBadgeState(file) }"
                                    }
                                  ],
                                  attrs: {
                                    extension: file.extension,
                                    size: "30px"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__import-list__progress-wrap"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m-file-upload__import-list__infos"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "m-file-upload__import-list__name"
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "m-file-upload__import-list__size"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("f-m-filesize")(
                                              file.file.size
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("m-progress", {
                                  attrs: {
                                    value: file.progress,
                                    state: _vm.getFileStatus(file)
                                  }
                                }),
                                _vm._v(" "),
                                _vm.getFileStatus(file) === "error"
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "m-file-upload__import-list__error-message"
                                      },
                                      [
                                        _c("m-i18n", {
                                          attrs: { k: "m-file-upload:errorMsg" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__import-list__delete"
                              },
                              [
                                _c("m-icon-button", {
                                  ref: "cancelUploadButton",
                                  refInFor: true,
                                  staticClass:
                                    "m-file-upload__import-list__button",
                                  attrs: {
                                    title: _vm.tooltipCancel,
                                    "icon-name": "m-svg__close-clear",
                                    "button-size": "32px",
                                    "icon-size": "12px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onUploadCancel(file)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasCompletedFiles
            ? _c(
                "div",
                {
                  staticClass: "m-file-upload__completed-list",
                  class: { "m--has-border": !_vm.hasUploadingFiles }
                },
                [
                  _c(
                    "transition-group",
                    {
                      staticClass: "m-file-upload__completed-list__wrap",
                      attrs: { name: "m--is", tag: "ul" }
                    },
                    _vm._l(_vm.completedFiles, function(file, index) {
                      return _c("li", { key: file.uid }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "m-file-upload__completed-list__content"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__completed-list__file-icon"
                              },
                              [
                                _c("m-icon-file", {
                                  directives: [
                                    {
                                      name: "m-badge",
                                      rawName: "v-m-badge",
                                      value: { state: _vm.getBadgeState(file) },
                                      expression:
                                        "{ state: getBadgeState(file) }"
                                    }
                                  ],
                                  attrs: {
                                    extension: file.extension,
                                    size: "30px"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__completed-list__infos"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "m-file-upload__completed-list__infos-label"
                                  },
                                  [
                                    file.url
                                      ? _c(
                                          "m-link",
                                          {
                                            attrs: {
                                              url: file.url,
                                              mode: "link",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(_vm._s(file.name))]
                                        )
                                      : [_vm._v(_vm._s(file.name))]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "m-file-upload__completed-list__infos-size"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("f-m-filesize")(file.file.size)
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "m-file-upload__completed-list__delete"
                              },
                              [
                                _c("m-icon-button", {
                                  ref: "removeButton",
                                  refInFor: true,
                                  staticClass:
                                    "m-file-upload__completed-list__button",
                                  attrs: {
                                    title: _vm.tooltipDelete,
                                    "icon-name": "m-svg__delete",
                                    "button-size": "32px",
                                    "icon-size": "20px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onFileRemove(file)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { style: _vm.buttonCompletedStyle },
          [
            _c(
              "m-button",
              {
                ref: "modalConfirmButton",
                staticClass: "m-file-upload__footer-add",
                attrs: { disabled: !_vm.isAddBtnEnabled },
                on: { click: _vm.onAddClick }
              },
              [
                _vm._v(_vm._s(_vm.buttonAdd) + "\n                "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.completedFiles.length > 0,
                        expression: "completedFiles.length > 0"
                      }
                    ],
                    attrs: { slot: "precision" },
                    slot: "precision"
                  },
                  [
                    _c(
                      "span",
                      [
                        _vm._v(
                          _vm._s(_vm.completedFiles.length) +
                            "\n                        "
                        ),
                        _c("m-i18n", {
                          attrs: {
                            nb: _vm.completedFiles.length,
                            k: "m-file-upload:file"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "m-button",
              {
                ref: "modalCancelButton",
                staticClass: "m-file-upload__footer-cancel",
                attrs: { skin: "secondary" },
                on: { click: _vm.onCancelClick }
              },
              [_c("m-i18n", { attrs: { k: "m-file-upload:cancel" } })],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-58475183'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/file-upload/file-upload.ts":
/*!***************************************************!*\
  !*** ./src/components/file-upload/file-upload.ts ***!
  \***************************************************/
/*! exports provided: MFileUpload, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFileUpload", function() { return MFileUpload; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_badge_badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/badge/badge */ "./src/directives/badge/badge.ts");
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_file_drop_file_drop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../directives/file-drop/file-drop */ "./src/directives/file-drop/file-drop.ts");
/* harmony import */ var _filters_filesize_filesize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../filters/filesize/filesize */ "./src/filters/filesize/filesize.ts");
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_file_file__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/file/file */ "./src/utils/file/file.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/user-agent/user-agent */ "./src/utils/user-agent/user-agent.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _file_select_file_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../file-select/file-select */ "./src/components/file-select/file-select.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_file_icon_file__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../icon-file/icon-file */ "./src/components/icon-file/icon-file.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _modal_modal__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../modal/modal */ "./src/components/modal/modal.ts");
/* harmony import */ var _progress_progress__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../progress/progress */ "./src/components/progress/progress.ts");
/* harmony import */ var _file_upload_html_style_file_upload_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./file-upload.html?style=./file-upload.scss */ "./src/components/file-upload/file-upload.html?style=./file-upload.scss");
/* harmony import */ var _file_upload_html_style_file_upload_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_file_upload_html_style_file_upload_scss__WEBPACK_IMPORTED_MODULE_23__);
var _a, _b, _c;
























var COMPLETED_FILES_VISUAL_HINT_DELAY = 1000;
var defaultDragEvent = function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'none';
};
var MFileUpload = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MFileUpload, _super);
    function MFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalOpen = false;
        _this.tooltipCancel = _this.$i18n.translate('m-file-upload:cancelFileUpload');
        _this.tooltipDelete = _this.$i18n.translate('m-file-upload:deleteUploadedFile');
        return _this;
    }
    Object.defineProperty(MFileUpload.prototype, "isDropZoneEnabled", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_11__["default"].isDesktop() && this.$mq.state.isMqMinS;
        },
        enumerable: true,
        configurable: true
    });
    MFileUpload.prototype.created = function () {
        this.updateValidationOptions();
    };
    MFileUpload.prototype.destroyed = function () {
        this.$file.destroy(this.storeName);
    };
    MFileUpload.prototype.updateValidationOptions = function () {
        this.$file.setValidationOptions({
            allowedExtensions: this.allowedExtensions,
            rejectedExtensions: this.rejectedExtensions,
            maxSizeKb: this.maxSizeKb,
            maxFiles: this.propMaxFiles,
            customValidationFunction: this.customValidation ? this.customValidation.validationFunction : undefined
        }, this.storeName);
    };
    MFileUpload.prototype.openChanged = function (open) {
        this.internalOpen = open;
    };
    MFileUpload.prototype.onFilesChanged = function () {
        var newReadyFiles = [];
        for (var _i = 0, _a = this.readyFiles; _i < _a.length; _i++) {
            var f = _a[_i];
            if (!f.hasOwnProperty('completeHinted')) {
                this.$set(f, 'completeHinted', false);
                newReadyFiles.push(f);
            }
        }
        if (newReadyFiles.length > 0) {
            this.$emit('files-ready', this.readyFiles);
        }
    };
    MFileUpload.prototype.onFreshlyCompletedFilesChanged = function () {
        var _this = this;
        if (this.freshlyCompletedFiles.length > 0) {
            setTimeout(function () {
                for (var _i = 0, _a = _this.freshlyCompletedFiles; _i < _a.length; _i++) {
                    var f = _a[_i];
                    f.completeHinted = true;
                }
            }, COMPLETED_FILES_VISUAL_HINT_DELAY);
        }
    };
    MFileUpload.prototype.onFilesRejected = function () {
        var nbNewRejection = this.rejectedFiles.reduce(function (cnt, f) {
            var nbNewRejection = 0;
            if (!f.isOldRejection) {
                ++nbNewRejection;
                f.isOldRejection = true;
            }
            return cnt + nbNewRejection;
        }, 0);
        if (nbNewRejection > 0) {
            if (this.$refs.modal && this.$refs.modal.$refs) {
                this.$refs.modal.$refs.body.scrollTop = 0;
            }
            // TODO Change function to have a smooth scroll when it will work on a diferent element than the body of the page
            // ScrollTo.startScroll(bodyRef, 0, ScrollToDuration.Regular);
        }
    };
    MFileUpload.prototype.onPortalAfterOpen = function () {
        var _this = this;
        this.dropEvents.forEach(function (evt) {
            _this.$refs.modal.$refs.modalWrap.addEventListener(evt, defaultDragEvent);
        });
    };
    MFileUpload.prototype.onMessageClose = function () {
        for (var _i = 0, _a = this.rejectedFiles; _i < _a.length; _i++) {
            var f = _a[_i];
            this.$file.remove(f.uid, this.storeName);
        }
    };
    MFileUpload.prototype.onAddClick = function () {
        this.$emit('done', this.completedFiles);
        this.$refs.modal.closeModal();
    };
    MFileUpload.prototype.onCancelClick = function () {
        this.$emit('cancel');
        this.$refs.modal.closeModal();
    };
    MFileUpload.prototype.onUploadCancel = function (file) {
        file.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].UPLOADING
            ? this.$emit('file-upload-cancel', file)
            : this.onFileRemove(file);
    };
    MFileUpload.prototype.onFileRemove = function (file) {
        this.$emit('file-remove', file);
        this.$file.remove(file.uid, this.storeName);
    };
    MFileUpload.prototype.onOpen = function () {
        this.$emit('open');
        this.propOpen = true;
        this.updateValidationOptions();
    };
    MFileUpload.prototype.onClose = function () {
        var _this = this;
        this.propOpen = false;
        this.$emit('close');
        this.allFiles
            .filter(function (f) { return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].UPLOADING; })
            .forEach(this.onUploadCancel);
        this.$file.clear(this.storeName);
        this.dropEvents.forEach(function (evt) {
            _this.$refs.modal.$refs.modalWrap.removeEventListener(evt, defaultDragEvent);
        });
    };
    MFileUpload.prototype.getFileStatus = function (file) {
        switch (file.status) {
            case _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].FAILED:
                return _progress_progress__WEBPACK_IMPORTED_MODULE_22__["MProgressState"].Error;
            case _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED:
                return _progress_progress__WEBPACK_IMPORTED_MODULE_22__["MProgressState"].Completed;
            default:
                return _progress_progress__WEBPACK_IMPORTED_MODULE_22__["MProgressState"].InProgress;
        }
    };
    MFileUpload.prototype.getBadgeState = function (file) {
        switch (file.status) {
            case _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].FAILED:
                return _directives_badge_badge__WEBPACK_IMPORTED_MODULE_3__["MBadgeState"].Error;
            case _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED:
                return _directives_badge_badge__WEBPACK_IMPORTED_MODULE_3__["MBadgeState"].Completed;
            default:
                return undefined;
        }
    };
    MFileUpload.prototype.hasExtensionsRejection = function (file) {
        return file.rejection === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileRejectionCause"].FILE_TYPE;
    };
    MFileUpload.prototype.hasSizeRejection = function (file) {
        return file.rejection === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileRejectionCause"].FILE_SIZE;
    };
    MFileUpload.prototype.hasMaxFilesRejection = function (file) {
        return file.rejection === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileRejectionCause"].MAX_FILES;
    };
    MFileUpload.prototype.hasCustomValidationRejection = function (file) {
        return file.rejection === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileRejectionCause"].CUSTOM_VALIDATION;
    };
    Object.defineProperty(MFileUpload.prototype, "title", {
        get: function () {
            return this.fileReplacement ? this.$i18n.translate('m-file-upload:header-title-file-replacement') : this.$i18n.translate('m-file-upload:header-title', {}, this.propMaxFiles);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "buttonAdd", {
        get: function () {
            return this.fileReplacement ? this.$i18n.translate('m-file-upload:replace') : this.$i18n.translate('m-file-upload:add');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "fileAllowedExtensions", {
        get: function () {
            return this.allowedExtensions.join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "isAddBtnEnabled", {
        get: function () {
            return (this.completedFiles.length > 0 && this.uploadingFilesOnly.length === 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "readyFiles", {
        get: function () {
            return this.allFiles.filter(function (f) { return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].READY; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "freshlyCompletedFiles", {
        get: function () {
            return this.allFiles.filter(function (f) { return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED && !f.completeHinted; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "uploadingFilesOnly", {
        get: function () {
            return this.allFiles.filter(function (f) {
                return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].UPLOADING ||
                    (f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED && !f.completeHinted);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "uploadingFiles", {
        get: function () {
            return this.allFiles.filter(function (f) {
                return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].UPLOADING ||
                    f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].FAILED ||
                    (f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED && !f.completeHinted);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "completedFiles", {
        get: function () {
            return this.allFiles.filter(function (f) { return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].COMPLETED && f.completeHinted; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "rejectedFiles", {
        get: function () {
            return this.allFiles.filter(function (f) { return f.status === _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["MFileStatus"].REJECTED; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "allFiles", {
        get: function () {
            return this.$file.files(this.storeName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "hasUploadingFiles", {
        get: function () {
            return this.uploadingFiles.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "hasCompletedFiles", {
        get: function () {
            return this.completedFiles.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "buttonCompletedStyle", {
        get: function () {
            return !this.hasCompletedFiles ? 'display: flex;' : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "hasRejectedFiles", {
        get: function () {
            return this.rejectedFiles.length !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "hasAllowedExtensions", {
        get: function () {
            return this.allowedExtensions.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "propOpen", {
        get: function () {
            return this.open ? this.open : this.internalOpen;
        },
        set: function (value) {
            if (value !== this.internalOpen) {
                this.internalOpen = value;
                this.$emit('update:open', value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "propMaxFiles", {
        get: function () {
            return this.fileReplacement ? 1 : this.maxFiles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "multipleSelection", {
        get: function () {
            return this.propMaxFiles !== undefined && this.propMaxFiles > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MFileUpload.prototype, "dropEvents", {
        get: function () {
            return ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'];
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MFileUpload.prototype, "allowedExtensions", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MFileUpload.prototype, "rejectedExtensions", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileUpload.prototype, "maxSizeKb", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileUpload.prototype, "maxFiles", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileUpload.prototype, "selectionHelpMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _utils_file_file__WEBPACK_IMPORTED_MODULE_9__["DEFAULT_STORE_NAME"]
        })
    ], MFileUpload.prototype, "storeName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileUpload.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MFileUpload.prototype, "fileReplacement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MFileUpload.prototype, "customValidation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('allowedExtensions'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('rejectedExtensions'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('maxSizeKb'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('maxFiles'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('customValidation')
    ], MFileUpload.prototype, "updateValidationOptions", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open')
    ], MFileUpload.prototype, "openChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('readyFiles')
    ], MFileUpload.prototype, "onFilesChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('freshlyCompletedFiles')
    ], MFileUpload.prototype, "onFreshlyCompletedFilesChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('rejectedFiles')
    ], MFileUpload.prototype, "onFilesRejected", null);
    MFileUpload = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _file_upload_html_style_file_upload_scss__WEBPACK_IMPORTED_MODULE_23___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_13__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["MODAL_NAME"]] = _modal_modal__WEBPACK_IMPORTED_MODULE_21__["MModal"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["MESSAGE_NAME"]] = _message_message__WEBPACK_IMPORTED_MODULE_20__["MMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_16__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["FILE_SELECT_NAME"]] = _file_select_file_select__WEBPACK_IMPORTED_MODULE_15__["MFileSelect"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["ICON_FILE_NAME"]] = _icon_file_icon_file__WEBPACK_IMPORTED_MODULE_18__["MIconFile"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_17__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["PROGRESS_NAME"]] = _progress_progress__WEBPACK_IMPORTED_MODULE_22__["MProgress"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_14__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_19__["MLink"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_4__["FILE_DROP_NAME"]] = _directives_file_drop_file_drop__WEBPACK_IMPORTED_MODULE_5__["MFileDropDirective"],
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_4__["BADGE_NAME"]] = _directives_badge_badge__WEBPACK_IMPORTED_MODULE_3__["MBadgeDirective"],
                _b),
            filters: (_c = {},
                _c[_filters_filter_names__WEBPACK_IMPORTED_MODULE_7__["FILESIZE_NAME"]] = _filters_filesize_filesize__WEBPACK_IMPORTED_MODULE_6__["fileSize"],
                _c),
            mixins: [
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_8__["MediaQueries"]
            ]
        })
    ], MFileUpload);
    return MFileUpload;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__["ModulVue"]));

var FileUploadPlugin = {
    install: function (v, options) {
        v.use(_utils_file_file__WEBPACK_IMPORTED_MODULE_9__["default"]);
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_10__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_14__["FILE_UPLOAD_NAME"], MFileUpload);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FileUploadPlugin);


/***/ }),

/***/ "./src/components/form/control-directive.ts":
/*!**************************************************!*\
  !*** ./src/components/form/control-directive.ts ***!
  \**************************************************/
/*! exports provided: AbstractControlDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function() { return AbstractControlDirective; });
/* harmony import */ var _utils_form_form_control__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/form/form-control */ "./src/utils/form/form-control.ts");

var INPUT_SELECTOR = 'input, textarea, [contenteditable=true]';
var AbstractControlDirective = {
    bind: function (el, binding, vnode) {
        var control = binding.value;
        // We can't assign the element directly on recent Vue version.
        // https://github.com/vuejs/vue/issues/7788
        control.htmlElementAccessor = function () { return el.querySelector(INPUT_SELECTOR); };
        if (control instanceof _utils_form_form_control__WEBPACK_IMPORTED_MODULE_0__["FormControl"]) {
            Object.defineProperty(el, 'ControlDirectiveListeners', {
                value: {
                    focusListener: function () { return control.initEdition(); },
                    blurListener: function () { return control.endEdition(); }
                }
            });
            vnode.componentInstance.$on('focus', el['ControlDirectiveListeners'].focusListener);
            vnode.componentInstance.$on('blur', el['ControlDirectiveListeners'].blurListener);
        }
    },
    unbind: function (el, binding, vnode) {
        var control = binding.value;
        control.htmlElementAccessor = function () { return undefined; };
        if (control instanceof _utils_form_form_control__WEBPACK_IMPORTED_MODULE_0__["FormControl"] && el['ControlDirectiveListeners'] !== undefined) {
            vnode.componentInstance.$off('focus', el['ControlDirectiveListeners'].focusListener);
            vnode.componentInstance.$off('blur', el['ControlDirectiveListeners'].blurListener);
        }
    }
};


/***/ }),

/***/ "./src/components/form/fallouts/built-in-form-action-fallouts.ts":
/*!***********************************************************************!*\
  !*** ./src/components/form/fallouts/built-in-form-action-fallouts.ts ***!
  \***********************************************************************/
/*! exports provided: ClearErrorToast, ErrorToast, FocusOnFirstError, SummaryMessage, ClearSummaryMessage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClearErrorToast", function() { return ClearErrorToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorToast", function() { return ErrorToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusOnFirstError", function() { return FocusOnFirstError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SummaryMessage", function() { return SummaryMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClearSummaryMessage", function() { return ClearSummaryMessage; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_form_form_control__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/form/form-control */ "./src/utils/form/form-control.ts");
/* harmony import */ var _form_action_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../form-action-type */ "./src/components/form/form-action-type.ts");



var scrollToElement = function (element, offset) {
    (vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype).$scrollTo.goTo(element, offset);
};
/**
 * Recursive fonction to return the first formControl in error. If none is returned then undefined is returned (in case of an error in the formGroup).
 * @param formGroup
 */
var getFirstControlInError = function (formGroup) {
    var invalidControl;
    var controls = formGroup.controls;
    if (controls && controls.length > 0) {
        for (var index = 0; index < controls.length; ++index) {
            if (controls[index] instanceof _utils_form_form_control__WEBPACK_IMPORTED_MODULE_1__["FormControl"]) {
                if (controls[index].hasError()) {
                    return controls[index];
                }
            }
            else {
                var invalidControlInGroup = getFirstControlInError(controls[index]);
                if (invalidControlInGroup) {
                    return invalidControlInGroup;
                }
            }
        }
    }
    return invalidControl;
};
var ClearErrorToast = {
    action: _form_action_type__WEBPACK_IMPORTED_MODULE_2__["FormActions"].ValidSubmitOrResetOrDestroyed,
    fallout: function (form) {
        form.displayToast = false;
    }
};
var ErrorToast = {
    action: _form_action_type__WEBPACK_IMPORTED_MODULE_2__["FormActions"].InvalidSubmit,
    fallout: function (form) {
        form.displayToast = true;
    }
};
var FocusOnFirstError = {
    action: _form_action_type__WEBPACK_IMPORTED_MODULE_2__["FormActions"].InvalidSubmit,
    fallout: function (form) {
        var control = getFirstControlInError(form.formGroup);
        if (control) {
            if (control.htmlElement instanceof HTMLInputElement || control.htmlElement instanceof HTMLTextAreaElement) {
                scrollToElement(control.htmlElement, form.$form.scrollToOffset);
                control.htmlElement.focus();
            }
            else if (control.htmlElement) {
                scrollToElement(control.htmlElement, form.$form.scrollToOffset);
            }
        }
    }
};
var SummaryMessage = {
    action: _form_action_type__WEBPACK_IMPORTED_MODULE_2__["FormActions"].InvalidSubmit,
    fallout: function (form) {
        form.displaySummary = true;
    }
};
var ClearSummaryMessage = {
    action: _form_action_type__WEBPACK_IMPORTED_MODULE_2__["FormActions"].ValidSubmitOrReset,
    fallout: function (form) {
        form.displaySummary = false;
    }
};


/***/ }),

/***/ "./src/components/form/form-action-type.ts":
/*!*************************************************!*\
  !*** ./src/components/form/form-action-type.ts ***!
  \*************************************************/
/*! exports provided: FormActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormActions", function() { return FormActions; });
var FormActions;
(function (FormActions) {
    FormActions[FormActions["None"] = 1] = "None";
    FormActions[FormActions["InvalidSubmit"] = 2] = "InvalidSubmit";
    FormActions[FormActions["ValidSubmit"] = 4] = "ValidSubmit";
    FormActions[FormActions["Reset"] = 16] = "Reset";
    FormActions[FormActions["Created"] = 256] = "Created";
    FormActions[FormActions["Updated"] = 65536] = "Updated";
    FormActions[FormActions["Destroyed"] = 1] = "Destroyed";
    FormActions[FormActions["ValidSubmitOrReset"] = 20] = "ValidSubmitOrReset";
    FormActions[FormActions["ValidSubmitOrResetOrDestroyed"] = 21] = "ValidSubmitOrResetOrDestroyed";
})(FormActions || (FormActions = {}));


/***/ }),

/***/ "./src/components/form/form-service.ts":
/*!*********************************************!*\
  !*** ./src/components/form/form-service.ts ***!
  \*********************************************/
/*! exports provided: MFormService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFormService", function() { return MFormService; });
var MFormService = /** @class */ (function () {
    function MFormService(formActionFallouts, scrollToOffset) {
        if (scrollToOffset === void 0) { scrollToOffset = -200; }
        this.formActionFallouts = formActionFallouts;
        this.scrollToOffset = scrollToOffset;
    }
    return MFormService;
}());



/***/ }),

/***/ "./src/components/form/form.html?style=./form.scss":
/*!*********************************************************!*\
  !*** ./src/components/form/form.html?style=./form.scss ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=78dffdae!./form.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=78dffdae!./src/components/form/form.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "m-form",
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit(false)
        },
        reset: function($event) {
          $event.preventDefault()
          return _vm.reset(false)
        }
      }
    },
    [
      _c(
        "m-accordion-transition",
        [
          _vm.displaySummary
            ? _c(
                "m-message",
                {
                  ref: "summary",
                  staticClass: "m-form__message-summary",
                  attrs: { state: "error", "close-button": true }
                },
                [
                  _c(
                    "ul",
                    _vm._l(_vm.summaryMessages, function(errorMessage, index) {
                      return _c("li", {
                        key: index,
                        domProps: { innerHTML: _vm._s(errorMessage) }
                      })
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "m-toast",
        {
          attrs: {
            open: _vm.displayToast,
            position: "top-center",
            state: "error"
          },
          on: {
            "update:open": function($event) {
              _vm.displayToast = $event
            }
          }
        },
        [
          _c("p", {
            staticClass: "m-form__toast-message",
            domProps: { innerHTML: _vm._s(_vm.toastMessage) }
          })
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-78dffdae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/form/form.plugin.ts":
/*!********************************************!*\
  !*** ./src/components/form/form.plugin.ts ***!
  \********************************************/
/*! exports provided: FormPlugin, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormPlugin", function() { return FormPlugin; });
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/scroll-to/scroll-to */ "./src/utils/scroll-to/scroll-to.ts");
/* harmony import */ var _utils_toast_toast_service_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/toast/toast-service.plugin */ "./src/utils/toast/toast-service.plugin.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _control_directive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./control-directive */ "./src/components/form/control-directive.ts");
/* harmony import */ var _fallouts_built_in_form_action_fallouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./fallouts/built-in-form-action-fallouts */ "./src/components/form/fallouts/built-in-form-action-fallouts.ts");
/* harmony import */ var _form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./form */ "./src/components/form/form.ts");
/* harmony import */ var _form_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./form-service */ "./src/components/form/form-service.ts");








var FormPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_3__["FORM_NAME"], 'plugin.install');
        v.use(_utils_toast_toast_service_plugin__WEBPACK_IMPORTED_MODULE_2__["default"]);
        v.use(_utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_1__["default"]);
        v.directive(_directives_directive_names__WEBPACK_IMPORTED_MODULE_0__["ABSTRACT_CONTROL_NAME"], _control_directive__WEBPACK_IMPORTED_MODULE_4__["AbstractControlDirective"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_3__["FORM_NAME"], _form__WEBPACK_IMPORTED_MODULE_6__["MForm"]);
        (v.prototype).$form = new _form_service__WEBPACK_IMPORTED_MODULE_7__["MFormService"](options && options.formAfterActionEffects ?
            options.formAfterActionEffects : [
            _fallouts_built_in_form_action_fallouts__WEBPACK_IMPORTED_MODULE_5__["ErrorToast"],
            _fallouts_built_in_form_action_fallouts__WEBPACK_IMPORTED_MODULE_5__["ClearErrorToast"],
            _fallouts_built_in_form_action_fallouts__WEBPACK_IMPORTED_MODULE_5__["FocusOnFirstError"]
        ]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FormPlugin);


/***/ }),

/***/ "./src/components/form/form.ts":
/*!*************************************!*\
  !*** ./src/components/form/form.ts ***!
  \*************************************/
/*! exports provided: MForm */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MForm", function() { return MForm; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_form_form_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/form/form-array */ "./src/utils/form/form-array.ts");
/* harmony import */ var _utils_form_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/form/form-control */ "./src/utils/form/form-control.ts");
/* harmony import */ var _utils_form_form_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/form/form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_str_str__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/str/str */ "./src/utils/str/str.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _toast_toast__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../toast/toast */ "./src/components/toast/toast.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _form_action_type__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./form-action-type */ "./src/components/form/form-action-type.ts");
/* harmony import */ var _form_html_style_form_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./form.html?style=./form.scss */ "./src/components/form/form.html?style=./form.scss");
/* harmony import */ var _form_html_style_form_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_form_html_style_form_scss__WEBPACK_IMPORTED_MODULE_14__);
var _a;















var MForm = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MForm, _super);
    function MForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displaySummary = false;
        _this.displayToast = false;
        return _this;
    }
    MForm.prototype.emitSubmit = function () { };
    MForm.prototype.emitReset = function () { };
    MForm.prototype.onFormGroupErrorsChange = function (controlErrors) {
        if (this.formErrors.length === 0) {
            this._hideSummaryAndToast();
        }
    };
    Object.defineProperty(MForm.prototype, "formErrors", {
        get: function () {
            return this.formGroup.errorsDeep;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MForm.prototype, "summaryMessages", {
        get: function () {
            return this.formErrors.map(function (error) { return Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_6__["getString"])(error.groupMessage) || Object(_utils_str_str__WEBPACK_IMPORTED_MODULE_6__["getString"])(error.message); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MForm.prototype, "toastMessage", {
        get: function () {
            var count = this._formControlsInErrorCount();
            return this.$i18n.translate(count <= 1 ? 'm-form:multipleErrorsToCorrect' : 'm-form:multipleErrorsToCorrect.p', { totalNbOfErrors: count }, undefined, undefined, undefined, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["FormatMode"].Sprintf);
        },
        enumerable: true,
        configurable: true
    });
    MForm.prototype.triggerActionFallouts = function (action) {
        var _this = this;
        this.actionFallouts
            .filter(function (a) { return action & a.action; })
            .forEach(function (a) { return a.fallout(_this); });
    };
    MForm.prototype.submit = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.formGroup.submit()];
                    case 1:
                        _a.sent();
                        if (!this.formGroup.valid) {
                            this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].InvalidSubmit);
                            return [2 /*return*/];
                        }
                        this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].ValidSubmit);
                        this.emitSubmit();
                        return [2 /*return*/];
                }
            });
        });
    };
    MForm.prototype.reset = function () {
        this.formGroup.reset();
        this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].Reset);
        this.emitReset();
    };
    MForm.prototype.created = function () {
        this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].Created);
    };
    MForm.prototype.updated = function () {
        this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].Updated);
    };
    MForm.prototype.beforeDestroy = function () {
        this.triggerActionFallouts(_form_action_type__WEBPACK_IMPORTED_MODULE_13__["FormActions"].Destroyed);
        this.formGroup.reset();
    };
    MForm.prototype._getAllFormValidators = function (control) {
        var _this = this;
        var result = control.validators;
        control.controls.forEach(function (c) {
            if (c instanceof _utils_form_form_control__WEBPACK_IMPORTED_MODULE_3__["FormControl"]) {
                result = result.concat(c.validators);
            }
            else if (c instanceof _utils_form_form_group__WEBPACK_IMPORTED_MODULE_4__["FormGroup"] || c instanceof _utils_form_form_array__WEBPACK_IMPORTED_MODULE_2__["FormArray"]) {
                result = result.concat(_this._getAllFormValidators(c));
            }
        });
        return result;
    };
    MForm.prototype._hideSummaryAndToast = function () {
        this.displaySummary = this.displayToast = false;
    };
    MForm.prototype._formControlsInErrorCount = function (control) {
        var _this = this;
        var first = false;
        if (!control) {
            control = this.formGroup;
            first = true;
        }
        return control.controls.reduce(function (a, c) {
            if (c instanceof _utils_form_form_group__WEBPACK_IMPORTED_MODULE_4__["FormGroup"] || c instanceof _utils_form_form_array__WEBPACK_IMPORTED_MODULE_2__["FormArray"]) {
                if (c.hasError()) {
                    a++;
                }
                if (c.hasErrorDeep()) {
                    a += _this._formControlsInErrorCount(c);
                }
            }
            else if (c instanceof _utils_form_form_control__WEBPACK_IMPORTED_MODULE_3__["FormControl"] && c.hasError()) {
                a++;
            }
            return a;
        }, first && this.formGroup.hasError() ? 1 : 0);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            required: true
        })
    ], MForm.prototype, "formGroup", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: function () { return _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"].prototype.$form.formActionFallouts || []; } })
    ], MForm.prototype, "actionFallouts", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('submit')
    ], MForm.prototype, "emitSubmit", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('reset')
    ], MForm.prototype, "emitReset", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('formErrors')
    ], MForm.prototype, "onFormGroupErrorsChange", null);
    MForm = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _form_html_style_form_scss__WEBPACK_IMPORTED_MODULE_14___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_12__["MAccordionTransition"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["TOAST"]] = _toast_toast__WEBPACK_IMPORTED_MODULE_11__["MToast"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["MESSAGE_NAME"]] = _message_message__WEBPACK_IMPORTED_MODULE_10__["MMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__["MI18n"],
                _a)
        })
    ], MForm);
    return MForm;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));



/***/ }),

/***/ "./src/components/i18n/i18n.html":
/*!***************************************!*\
  !*** ./src/components/i18n/i18n.html ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    staticClass: "m-i18n",
    domProps: { innerHTML: _vm._s(_vm.text) }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-15e2e0e9'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/i18n/i18n.ts":
/*!*************************************!*\
  !*** ./src/components/i18n/i18n.ts ***!
  \*************************************/
/*! exports provided: MI18n, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MI18n", function() { return MI18n; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./i18n.html */ "./src/components/i18n/i18n.html");
/* harmony import */ var _i18n_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_i18n_html__WEBPACK_IMPORTED_MODULE_5__);






var MI18n = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MI18n, _super);
    function MI18n() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MI18n.prototype.created = function () {
        if (!this.$i18n) {
            throw new Error('<' + _component_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"] + '>: this.$i18n is undefined, you must register the i18n plugin.');
        }
    };
    Object.defineProperty(MI18n.prototype, "text", {
        get: function () {
            var result = '';
            if (this.k) {
                result = this.$i18n.translate(this.k, this.params, this.nb, this.modifier, this.htmlEncode, this.formatMode ? this.formatMode : undefined);
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MI18n.prototype, "k", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MI18n.prototype, "params", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MI18n.prototype, "nb", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MI18n.prototype, "modifier", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MI18n.prototype, "htmlEncode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MI18n.prototype, "formatMode", void 0);
    MI18n = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _i18n_html__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MI18n);
    return MI18n;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var I18nPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"], MI18n);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (I18nPlugin);


/***/ }),

/***/ "./src/components/icon-button/icon-button.html?style=./icon-button.scss":
/*!******************************************************************************!*\
  !*** ./src/components/icon-button/icon-button.html?style=./icon-button.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e62b15b!./icon-button.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e62b15b!./src/components/icon-button/icon-button.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "m-icon-button",
      class: {
        "m--is-skin-light": _vm.isSkinLight,
        "m--is-skin-link": _vm.isSkinLink,
        "m--is-skin-dark": _vm.isSkinDark,
        "m--is-skin-primary": _vm.isSkinPrimary,
        "m--is-skin-secondary": _vm.isSkinSecondary,
        "m--is-skin-bold": _vm.isSkinBold,
        "m--has-ripple": _vm.ripple,
        "m--is-disabled": _vm.disabled
      },
      style: { width: _vm.buttonSize, height: _vm.buttonSize },
      attrs: { disabled: _vm.disabled, type: "button", title: _vm.title },
      on: {
        click: _vm.onClick,
        focus: _vm.onFocus,
        blur: _vm.onBlur,
        keydown: _vm.onKeydown
      }
    },
    [
      _c("m-icon", {
        ref: "icon",
        staticClass: "m-icon-button__icon",
        attrs: { name: _vm.iconName, size: _vm.iconSize }
      }),
      _vm._v(" "),
      _vm.hasSlot
        ? _c(
            "span",
            { staticClass: "m-icon-button__hidden" },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-5e62b15b'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/icon-button/icon-button.ts":
/*!***************************************************!*\
  !*** ./src/components/icon-button/icon-button.ts ***!
  \***************************************************/
/*! exports provided: MIconButtonSkin, MIconButton, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIconButtonSkin", function() { return MIconButtonSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIconButton", function() { return MIconButton; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _icon_button_html_style_icon_button_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./icon-button.html?style=./icon-button.scss */ "./src/components/icon-button/icon-button.html?style=./icon-button.scss");
/* harmony import */ var _icon_button_html_style_icon_button_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_icon_button_html_style_icon_button_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MIconButtonSkin;
(function (MIconButtonSkin) {
    MIconButtonSkin["Light"] = "light";
    MIconButtonSkin["Dark"] = "dark";
    MIconButtonSkin["Primary"] = "primary";
    MIconButtonSkin["Secondary"] = "secondary";
    MIconButtonSkin["Link"] = "link";
    MIconButtonSkin["Bold"] = "bold";
})(MIconButtonSkin || (MIconButtonSkin = {}));
var MIconButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MIconButton, _super);
    function MIconButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSlot = false;
        return _this;
    }
    MIconButton.prototype.onKeydown = function (event) { };
    MIconButton.prototype.mounted = function () {
        this.hasSlot = !!this.$slots.default;
        if (!this.hasSlot) {
            // Vue.prototype.$log.warn('<' + ICON_BUTTON_NAME + '> needs a text in its default slot that will describe its function. This text will be hidden and only read by the screen readers.');
        }
    };
    MIconButton.prototype.onClick = function (event) {
        this.$emit('click', event);
        this.$el.blur();
    };
    MIconButton.prototype.onFocus = function (event) {
        this.$emit('focus');
    };
    MIconButton.prototype.onBlur = function (event) {
        this.$emit('blur');
    };
    Object.defineProperty(MIconButton.prototype, "isSkinLight", {
        get: function () {
            return this.skin === MIconButtonSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIconButton.prototype, "isSkinDark", {
        get: function () {
            return this.skin === MIconButtonSkin.Dark;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIconButton.prototype, "isSkinPrimary", {
        get: function () {
            return this.skin === MIconButtonSkin.Primary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIconButton.prototype, "isSkinSecondary", {
        get: function () {
            return this.skin === MIconButtonSkin.Secondary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIconButton.prototype, "isSkinLink", {
        get: function () {
            return this.skin === MIconButtonSkin.Link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIconButton.prototype, "isSkinBold", {
        get: function () {
            return this.skin === MIconButtonSkin.Bold;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MIconButtonSkin.Light,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__["Enums"].toValueArray(MIconButtonSkin).indexOf(value) !== -1; }
        })
    ], MIconButton.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MIconButton.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '44px' })
    ], MIconButton.prototype, "buttonSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 'm-svg__close-clear' })
    ], MIconButton.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '20px' })
    ], MIconButton.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MIconButton.prototype, "ripple", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MIconButton.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('keydown')
    ], MIconButton.prototype, "onKeydown", null);
    MIconButton = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _icon_button_html_style_icon_button_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a)
        })
    ], MIconButton);
    return MIconButton;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var IconButtonPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_BUTTON_NAME"], 'plugin.install');
        v.use(_icon_icon__WEBPACK_IMPORTED_MODULE_6__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_BUTTON_NAME"], MIconButton);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (IconButtonPlugin);


/***/ }),

/***/ "./src/components/icon-file/icon-file.html":
/*!*************************************************!*\
  !*** ./src/components/icon-file/icon-file.html ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-icon", {
    staticClass: "m-icon-file",
    attrs: { name: _vm.spriteId, svgTitle: _vm.svgTitle, size: _vm.size },
    on: { click: _vm.onClick, keydown: _vm.onKeydown }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-22523987'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/icon-file/icon-file.ts":
/*!***********************************************!*\
  !*** ./src/components/icon-file/icon-file.ts ***!
  \***********************************************/
/*! exports provided: MIconFile, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIconFile", function() { return MIconFile; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _icon_file_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./icon-file.html */ "./src/components/icon-file/icon-file.html");
/* harmony import */ var _icon_file_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_icon_file_html__WEBPACK_IMPORTED_MODULE_6__);
var _a;







// Extensions list
var EXT_IMAGE = 'bmp,eps,gif,jpeg,jpg,png,tif,tiff,psd,ai,indd';
var EXT_TEXT = 'txt,csv';
var EXT_DOC = 'doc,docx';
var EXT_VSD = 'vsd,vsdx';
var EXT_PPT = 'ppt,pptx,pps,ppsx';
var EXT_XLS = 'xls,xlsx,xlt,xlv,xlw';
var EXT_ACCDB = 'mdb,accdb';
var EXT_PDF = 'pdf';
var EXT_RM = 'rm';
var EXT_MOV = 'mov';
var EXT_WMA = 'wma,wmv,asf';
var EXT_SWF = 'swf,flv,fla';
var EXT_VIDEO = 'mpeg,mp4,avi';
var EXT_MUSIC = 'mp3,ogg,wav,aiff,aac,ra';
var EXT_ARCHIVE = 'zip,rar,tar,gtar,gz';
var EXT_OPEN_OFFICE = 'sxw,sxi,sxd,sxc,sxm,sxg';
var EXT_ODT = 'odt';
var EXT_ODP = 'odp';
var EXT_ODG = 'odg';
var EXT_ODS = 'ods';
var EXT_ODF = 'odf';
var EXT_ODB = 'odb';
var EXT_DWG = 'dwg,dao,cao,dxf,dwf';
var EXT_MARKUP_XML = 'xml';
var EXT_MARKUP_HTML = 'html,htm';
var EXT_CODE_CSS = 'css,scss';
var EXT_CODE_JSON = 'json';
var EXT_CODE_SCRIPT = 'js,ts';
// Extensions Groups
var GROUP_IMAGE = 'm-svg__file-image';
var GROUP_TEXT = 'm-svg__file-text';
var GROUP_WORD = 'm-svg__file-word';
var GROUP_VISIO = 'm-svg__file-visio';
var GROUP_POWERPOINT = 'm-svg__file-powerpoint';
var GROUP_EXCEL = 'm-svg__file-excel';
var GROUP_ACCESS = 'm-svg__file-access';
var GROUP_PDF = 'm-svg__file-pdf';
var GROUP_REALPLAYER = 'm-svg__file-realplayer';
var GROUP_QUICKTIME = 'm-svg__file-quicktime';
var GROUP_MEDIAPLAYER = 'm-svg__file-mediaplayer';
var GROUP_FLASH = 'm-svg__file-flash';
var GROUP_VIDEO = 'm-svg__file-video';
var GROUP_AUDIO = 'm-svg__file-audio';
var GROUP_ZIP = 'm-svg__file-zip';
var GROUP_OPENOFFICE_DEFAULT = 'm-svg__file-openoffice-default';
var GROUP_OPENOFFICE_WRITTER = 'm-svg__file-openoffice-writter';
var GROUP_OPENOFFICE_IMPRESS = 'm-svg__file-openoffice-impress';
var GROUP_OPENOFFICE_DRAW = 'm-svg__file-openoffice-draw';
var GROUP_OPENOFFICE_CALC = 'm-svg__file-openoffice-calc';
var GROUP_OPENOFFICE_MATH = 'm-svg__file-openoffice-math';
var GROUP_OPENOFFICE_BASE = 'm-svg__file-openoffice-base';
var GROUP_DWG = 'm-svg__file-dwg';
var GROUP_CODE = 'm-svg__file-code';
var GROUP_MARKUP = 'm-svg__file-markup';
var GROUP_OTHER = 'm-svg__file-default';
// Extensions Tooltips
var TOOLTIP_IMAGE = 'image';
var TOOLTIP_TEXT = 'txt';
var TOOLTIP_WORD = 'doc';
var TOOLTIP_VISIO = 'vsd';
var TOOLTIP_POWERPOINT = 'ppt';
var TOOLTIP_EXCEL = 'xls';
var TOOLTIP_ACCESS = 'accdb';
var TOOLTIP_PDF = 'pdf';
var TOOLTIP_REALPLAYER = 'rm';
var TOOLTIP_QUICKTIME = 'mov';
var TOOLTIP_MEDIAPLAYER = 'wma';
var TOOLTIP_FLASH = 'swf';
var TOOLTIP_VIDEO = 'video';
var TOOLTIP_AUDIO = 'music';
var TOOLTIP_ZIP = 'zip';
var TOOLTIP_OPENOFFICE_DEFAULT = 'openoffice1';
var TOOLTIP_OPENOFFICE_WRITTER = 'odt';
var TOOLTIP_OPENOFFICE_IMPRESS = 'odp';
var TOOLTIP_OPENOFFICE_DRAW = 'odg';
var TOOLTIP_OPENOFFICE_CALC = 'ods';
var TOOLTIP_OPENOFFICE_MATH = 'odf';
var TOOLTIP_OPENOFFICE_BASE = 'odb';
var TOOLTIP_DWG = 'dwg';
var TOOLTIP_MARKUP_XML = 'xml';
var TOOLTIP_MARKUP_HTML = 'html';
var TOOLTIP_CODE_CSS = 'css';
var TOOLTIP_CODE_JSON = 'json';
var TOOLTIP_CODE_SCRIPT = 'js';
var TOOLTIP_OTHER = 'default';
var MIconFile = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MIconFile, _super);
    function MIconFile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tooltipGroup = {};
        _this.fileMap = {};
        return _this;
    }
    MIconFile.prototype.onClick = function (event) { };
    MIconFile.prototype.onKeydown = function (event) { };
    Object.defineProperty(MIconFile.prototype, "spriteId", {
        get: function () {
            var cleanExtension = this.extension ? this.extension.replace('.', '').toLowerCase() : '';
            return this.fileMap[cleanExtension] || GROUP_OTHER;
        },
        enumerable: true,
        configurable: true
    });
    MIconFile.prototype.beforeMount = function () {
        this.mapExtensionsGroup(EXT_IMAGE, GROUP_IMAGE, TOOLTIP_IMAGE);
        this.mapExtensionsGroup(EXT_TEXT, GROUP_TEXT, TOOLTIP_TEXT);
        this.mapExtensionsGroup(EXT_DOC, GROUP_WORD, TOOLTIP_WORD);
        this.mapExtensionsGroup(EXT_VSD, GROUP_VISIO, TOOLTIP_VISIO);
        this.mapExtensionsGroup(EXT_PPT, GROUP_POWERPOINT, TOOLTIP_POWERPOINT);
        this.mapExtensionsGroup(EXT_XLS, GROUP_EXCEL, TOOLTIP_EXCEL);
        this.mapExtensionsGroup(EXT_ACCDB, GROUP_ACCESS, TOOLTIP_ACCESS);
        this.mapExtensionsGroup(EXT_PDF, GROUP_PDF, TOOLTIP_PDF);
        this.mapExtensionsGroup(EXT_RM, GROUP_REALPLAYER, TOOLTIP_REALPLAYER);
        this.mapExtensionsGroup(EXT_MOV, GROUP_QUICKTIME, TOOLTIP_QUICKTIME);
        this.mapExtensionsGroup(EXT_WMA, GROUP_MEDIAPLAYER, TOOLTIP_MEDIAPLAYER);
        this.mapExtensionsGroup(EXT_SWF, GROUP_FLASH, TOOLTIP_FLASH);
        this.mapExtensionsGroup(EXT_VIDEO, GROUP_VIDEO, TOOLTIP_VIDEO);
        this.mapExtensionsGroup(EXT_MUSIC, GROUP_AUDIO, TOOLTIP_AUDIO);
        this.mapExtensionsGroup(EXT_ARCHIVE, GROUP_ZIP, TOOLTIP_ZIP);
        this.mapExtensionsGroup(EXT_OPEN_OFFICE, GROUP_OPENOFFICE_DEFAULT, TOOLTIP_OPENOFFICE_DEFAULT);
        this.mapExtensionsGroup(EXT_ODT, GROUP_OPENOFFICE_WRITTER, TOOLTIP_OPENOFFICE_WRITTER);
        this.mapExtensionsGroup(EXT_ODP, GROUP_OPENOFFICE_IMPRESS, TOOLTIP_OPENOFFICE_IMPRESS);
        this.mapExtensionsGroup(EXT_ODG, GROUP_OPENOFFICE_DRAW, TOOLTIP_OPENOFFICE_DRAW);
        this.mapExtensionsGroup(EXT_ODS, GROUP_OPENOFFICE_CALC, TOOLTIP_OPENOFFICE_CALC);
        this.mapExtensionsGroup(EXT_ODF, GROUP_OPENOFFICE_MATH, TOOLTIP_OPENOFFICE_MATH);
        this.mapExtensionsGroup(EXT_ODB, GROUP_OPENOFFICE_BASE, TOOLTIP_OPENOFFICE_BASE);
        this.mapExtensionsGroup(EXT_DWG, GROUP_DWG, TOOLTIP_DWG);
        this.mapExtensionsGroup(EXT_CODE_CSS, GROUP_CODE, TOOLTIP_CODE_CSS);
        this.mapExtensionsGroup(EXT_CODE_JSON, GROUP_CODE, TOOLTIP_CODE_JSON);
        this.mapExtensionsGroup(EXT_CODE_SCRIPT, GROUP_CODE, TOOLTIP_CODE_SCRIPT);
        this.mapExtensionsGroup(EXT_MARKUP_XML, GROUP_MARKUP, TOOLTIP_MARKUP_XML);
        this.mapExtensionsGroup(EXT_MARKUP_HTML, GROUP_MARKUP, TOOLTIP_MARKUP_HTML);
    };
    Object.defineProperty(MIconFile.prototype, "svgTitle", {
        get: function () {
            var cleanExtension = this.extension ? this.extension.replace('.', '').toLowerCase() : '';
            var currentTooltip = this.tooltipGroup[cleanExtension] || TOOLTIP_OTHER;
            var i18n = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n;
            var tooltipContent = i18n.translate("m-icon-file:" + currentTooltip);
            return tooltipContent;
        },
        enumerable: true,
        configurable: true
    });
    MIconFile.prototype.mapExtensionsGroup = function (extensions, category, tooltip) {
        var _this = this;
        extensions.split(',').forEach(function (ex) { return _this.fileMap[ex] = category; });
        extensions.split(',').forEach(function (ex) { return _this.tooltipGroup[ex] = tooltip; });
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MIconFile.prototype, "extension", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '24px' })
    ], MIconFile.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MIconFile.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('keydown')
    ], MIconFile.prototype, "onKeydown", null);
    MIconFile = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _icon_file_html__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_5__["MIcon"],
                _a)
        })
    ], MIconFile);
    return MIconFile;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var IconFilePlugin = {
    install: function (v, options) {
        v.use(_icon_icon__WEBPACK_IMPORTED_MODULE_5__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_FILE_NAME"], MIconFile);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (IconFilePlugin);


/***/ }),

/***/ "./src/components/icon/icon.html?style=./icon.scss":
/*!*********************************************************!*\
  !*** ./src/components/icon/icon.html?style=./icon.scss ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0bd3a7ee!./icon.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0bd3a7ee!./src/components/icon/icon.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "m-icon",
      attrs: {
        "aria-hidden": !_vm.hasSvgTitle,
        width: _vm.size,
        height: _vm.size
      },
      on: {
        click: _vm.onClick,
        keydown: _vm.onKeydown,
        mouseover: _vm.onMouseOver,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.hasSvgTitle ? _c("title", [_vm._v(_vm._s(_vm.svgTitle))]) : _vm._e(),
      _vm._v(" "),
      _c("use", {
        class: _vm.showNameAsClassInHtml,
        attrs: { "xlink:href": _vm.spriteId, "aria-hidden": "true" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-0bd3a7ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/icon/icon.ts":
/*!*************************************!*\
  !*** ./src/components/icon/icon.ts ***!
  \*************************************/
/*! exports provided: MIcon, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIcon", function() { return MIcon; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_html_style_icon_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./icon.html?style=./icon.scss */ "./src/components/icon/icon.html?style=./icon.scss");
/* harmony import */ var _icon_html_style_icon_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_icon_html_style_icon_scss__WEBPACK_IMPORTED_MODULE_5__);






var MIcon = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MIcon, _super);
    function MIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MIcon.prototype.onClick = function (event) { };
    MIcon.prototype.onKeydown = function (event) { };
    Object.defineProperty(MIcon.prototype, "hasSvgTitle", {
        get: function () {
            return !!this.svgTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIcon.prototype, "spriteId", {
        get: function () {
            var svg = this.$svg;
            if (document.getElementById(this.name)) {
                return '#' + this.name;
            }
            else if (document.getElementById('m-svg__' + this.name)) {
                return '#m-svg__' + this.name;
            }
            else if (svg && svg.getExternalSpritesFromSpriteId(this.name)) {
                return svg.getExternalSpritesFromSpriteId(this.name);
            }
            else if (svg && svg.getExternalSpritesFromSpriteId('m-svg__' + this.name)) {
                return svg.getExternalSpritesFromSpriteId('m-svg__' + this.name);
            }
            else if (this.name) {
                vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$log.warn('"' + this.name + '" is not a valid svg id. Make sure that the sprite has been loaded via the $svg instance service.');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIcon.prototype, "showNameAsClassInHtml", {
        get: function () {
            return this.showNameAsClass ? this.name : '';
        },
        enumerable: true,
        configurable: true
    });
    MIcon.prototype.onMouseOver = function (event) { };
    MIcon.prototype.onMouseLeave = function (event) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ required: true })
    ], MIcon.prototype, "name", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MIcon.prototype, "svgTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: '20px' })
    ], MIcon.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MIcon.prototype, "showNameAsClass", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MIcon.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('keydown')
    ], MIcon.prototype, "onKeydown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('mouseover')
    ], MIcon.prototype, "onMouseOver", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('mouseleave')
    ], MIcon.prototype, "onMouseLeave", null);
    MIcon = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _icon_html_style_icon_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MIcon);
    return MIcon;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var IconPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"], MIcon);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (IconPlugin);


/***/ }),

/***/ "./src/components/inplace-edit/inplace-edit.html?style=./inplace-edit.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/inplace-edit/inplace-edit.html?style=./inplace-edit.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4bf3aaee!./inplace-edit.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4bf3aaee!./src/components/inplace-edit/inplace-edit.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-inplace-edit",
      class: {
        "m--has-erreur": _vm.error && _vm.propEditMode,
        "m--is-edit-mode": _vm.propEditMode && _vm.isMqMinS
      },
      style: _vm.propPadding,
      on: { click: _vm.emitClick }
    },
    [
      !_vm.propEditMode || !_vm.isMqMinS ? _vm._t("readMode") : _vm._e(),
      _vm._v(" "),
      _vm.isMqMinS
        ? [
            _c("transition", { attrs: { duration: "300" } }, [
              _c(
                "form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.propEditMode,
                      expression: "propEditMode"
                    }
                  ],
                  attrs: { "aria-hidden": !_vm.propEditMode }
                },
                [
                  _vm.propEditMode ? _vm._t("editMode") : _vm._e(),
                  _vm._v(" "),
                  _c("m-accordion-transition", [
                    _vm.propEditMode
                      ? _c(
                          "div",
                          { staticClass: "m-inplace-edit__buttons-wrap" },
                          [
                            _c(
                              "div",
                              { staticClass: "m-inplace-edit__buttons" },
                              [
                                _c(
                                  "m-button",
                                  {
                                    ref: "confirm-control",
                                    attrs: {
                                      waiting: _vm.waiting,
                                      skin: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onConfirm($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("m-i18n", {
                                      attrs: { k: "m-inplace-edit:save" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "m-button",
                                  {
                                    ref: "cancel-control",
                                    attrs: {
                                      disabled: _vm.waiting,
                                      skin: "secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onCancel($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("m-i18n", {
                                      attrs: { k: "m-inplace-edit:cancel" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                2
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMqMinS
        ? [
            _c(
              "m-overlay",
              {
                ref: "overlay",
                attrs: { open: _vm.propEditMode },
                on: {
                  close: _vm.onCancel,
                  save: _vm.onConfirm,
                  "portal-after-open": _vm.emitMobileAfterOpen,
                  "portal-after-close": _vm.emitMobileAfterClose
                }
              },
              [
                _c(
                  "h2",
                  {
                    staticClass: "m-edit-inplace__title",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c("form", [_vm._t("editMode")], 2)
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4bf3aaee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/inplace-edit/inplace-edit.ts":
/*!*****************************************************!*\
  !*** ./src/components/inplace-edit/inplace-edit.ts ***!
  \*****************************************************/
/*! exports provided: MInplaceEdit, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MInplaceEdit", function() { return MInplaceEdit; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _overlay_overlay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../overlay/overlay */ "./src/components/overlay/overlay.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _inplace_edit_html_style_inplace_edit_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./inplace-edit.html?style=./inplace-edit.scss */ "./src/components/inplace-edit/inplace-edit.html?style=./inplace-edit.scss");
/* harmony import */ var _inplace_edit_html_style_inplace_edit_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_inplace_edit_html_style_inplace_edit_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var MInplaceEdit = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MInplaceEdit, _super);
    function MInplaceEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalEditMode = false;
        return _this;
    }
    MInplaceEdit.prototype.emitOk = function (event) { };
    MInplaceEdit.prototype.emitCancel = function (event) { };
    MInplaceEdit.prototype.emitClick = function (event) { };
    MInplaceEdit.prototype.emitMobileAfterOpen = function () { };
    MInplaceEdit.prototype.emitMobileAfterClose = function () { };
    MInplaceEdit.prototype.onEditModeChange = function (value) {
        this.internalEditMode = value;
    };
    MInplaceEdit.prototype.onIsMqMaxSChange = function (value, old) {
        if (this.mqMounted) {
            this.propEditMode = false;
        }
    };
    MInplaceEdit.prototype.mounted = function () {
        var _this = this;
        // should be in next tick to skip the media query initial trigger on mounted
        this.$nextTick(function () { return _this.mqMounted = true; });
    };
    Object.defineProperty(MInplaceEdit.prototype, "propEditMode", {
        get: function () {
            return this.internalEditMode;
        },
        set: function (value) {
            this.internalEditMode = value;
            this.$emit('update:editMode', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInplaceEdit.prototype, "propPadding", {
        get: function () {
            if (!this.propEditMode && this.padding) {
                return "padding: " + this.padding;
            }
            else if (this.propEditMode && this.editModePadding) {
                return "padding: " + this.editModePadding;
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    MInplaceEdit.prototype.onConfirm = function (event) {
        if (this.propEditMode) {
            this.emitOk(event);
        }
    };
    MInplaceEdit.prototype.onCancel = function (event) {
        if (this.propEditMode) {
            this.propEditMode = false;
            this.emitCancel(event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInplaceEdit.prototype, "editMode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInplaceEdit.prototype, "error", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInplaceEdit.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInplaceEdit.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInplaceEdit.prototype, "editModePadding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: function () { return (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n.translate('m-inplace-edit:modify'); }
        })
    ], MInplaceEdit.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('ok')
    ], MInplaceEdit.prototype, "emitOk", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('cancel')
    ], MInplaceEdit.prototype, "emitCancel", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MInplaceEdit.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mobile-after-open')
    ], MInplaceEdit.prototype, "emitMobileAfterOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mobile-after-close')
    ], MInplaceEdit.prototype, "emitMobileAfterClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('editMode', { immediate: true })
    ], MInplaceEdit.prototype, "onEditModeChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('isMqMaxS')
    ], MInplaceEdit.prototype, "onIsMqMaxSChange", null);
    MInplaceEdit = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _inplace_edit_html_style_inplace_edit_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Component"])({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_9__["MAccordionTransition"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_5__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["OVERLAY_NAME"]] = _overlay_overlay__WEBPACK_IMPORTED_MODULE_8__["MOverlay"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["MediaQueries"]]
        })
    ], MInplaceEdit);
    return MInplaceEdit;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var InplaceEditPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["INPLACE_EDIT_NAME"], MInplaceEdit);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (InplaceEditPlugin);


/***/ }),

/***/ "./src/components/input-group/input-group.html?style=./input-group.scss":
/*!******************************************************************************!*\
  !*** ./src/components/input-group/input-group.html?style=./input-group.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b759f322!./input-group.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b759f322!./src/components/input-group/input-group.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-input-group",
      class: {
        "m--is-disabled": _vm.isDisabled,
        "m--has-error": _vm.hasError,
        "m--is-valid": _vm.isValid,
        "m--has-validation-message": _vm.hasValidationMessage,
        "m--is-validation-message-position-bottom":
          _vm.isValidationMessagePositionBottom
      }
    },
    [
      _vm.hasLabel
        ? _c(
            "p",
            { staticClass: "m-input-group__label", attrs: { id: _vm.idLabel } },
            [
              _vm._v(_vm._s(_vm.label)),
              _vm.$slots.icon
                ? _c(
                    "span",
                    { staticClass: "m-input-group__icon" },
                    [_vm._t("icon")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.requiredMarker
                ? _c("sup", { staticClass: "m-input-group__required-marker" }, [
                    _vm._v("*")
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-input-group__body" },
        [
          _c("m-validation-message", {
            staticClass: "m-input-group__message",
            attrs: {
              id: _vm.idValidationMessage,
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasError,
              "error-message": _vm.errorMessage,
              valid: _vm.isValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          }),
          _vm._v(" "),
          _vm.$slots.default
            ? _c(
                "div",
                {
                  staticClass: "m-input-group__content",
                  attrs: {
                    "aria-labelledby": _vm.idLabel,
                    "aria-describedby": _vm.idValidationMessage
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-b759f322'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/input-group/input-group.ts":
/*!***************************************************!*\
  !*** ./src/components/input-group/input-group.ts ***!
  \***************************************************/
/*! exports provided: MMInputGroupValidationMessagePosition, MInputGroup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMInputGroupValidationMessagePosition", function() { return MMInputGroupValidationMessagePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MInputGroup", function() { return MInputGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _input_group_html_style_input_group_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./input-group.html?style=./input-group.scss */ "./src/components/input-group/input-group.html?style=./input-group.scss");
/* harmony import */ var _input_group_html_style_input_group_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_input_group_html_style_input_group_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MMInputGroupValidationMessagePosition;
(function (MMInputGroupValidationMessagePosition) {
    MMInputGroupValidationMessagePosition["Top"] = "top";
    MMInputGroupValidationMessagePosition["Bottom"] = "bottom";
})(MMInputGroupValidationMessagePosition || (MMInputGroupValidationMessagePosition = {}));
var MInputGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MInputGroup, _super);
    function MInputGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MInputGroup.prototype, "hasLabel", {
        get: function () {
            return !!this.label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputGroup.prototype, "isValidationMessagePositionBottom", {
        get: function () {
            return this.validationMessagePosition === MMInputGroupValidationMessagePosition.Bottom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputGroup.prototype, "idLabel", {
        get: function () {
            return this.hasLabel ? _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputGroup.prototype, "idValidationMessage", {
        get: function () {
            return this.as().errorMessage || this.as().validMessage || this.as().helperMessage ? _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputGroup.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputGroup.prototype, "requiredMarker", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MMInputGroupValidationMessagePosition.Top,
            validator: function (value) {
                return value === MMInputGroupValidationMessagePosition.Top ||
                    value === MMInputGroupValidationMessagePosition.Bottom;
            }
        })
    ], MInputGroup.prototype, "validationMessagePosition", void 0);
    MInputGroup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _input_group_html_style_input_group_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_5__["MValidationMessage"],
                _a),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__["InputState"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__["InputManagement"]
            ]
        })
    ], MInputGroup);
    return MInputGroup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var InputGroupPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["INPUT_GROUP_NAME"], MInputGroup);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (InputGroupPlugin);


/***/ }),

/***/ "./src/components/input-mask/input-mask.html":
/*!***************************************************!*\
  !*** ./src/components/input-mask/input-mask.html ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    attrs: { maxlength: _vm.maxLength },
    on: {
      focus: _vm.onFocus,
      blur: _vm.onBlur,
      keyup: _vm.onKeyup,
      keydown: [
        _vm.onKeydownTextfield,
        function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onEnter($event)
        }
      ],
      change: _vm.onChange,
      paste: _vm.onPasteTextfield,
      drop: _vm.onDropTextfield,
      textInput: _vm.onTextInput
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-8c98c06e'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/input-mask/input-mask.ts":
/*!*************************************************!*\
  !*** ./src/components/input-mask/input-mask.ts ***!
  \*************************************************/
/*! exports provided: MInputMask */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MInputMask", function() { return MInputMask; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cleave_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! cleave.js */ "cleave.js");
/* harmony import */ var cleave_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cleave_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _input_mask_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./input-mask.html */ "./src/components/input-mask/input-mask.html");
/* harmony import */ var _input_mask_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_input_mask_html__WEBPACK_IMPORTED_MODULE_5__);






/**
 * inspired from https://github.com/ankurk91/vue-cleave-component/blob/master/src/component.js
 */
var MInputMask = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MInputMask, _super);
    function MInputMask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalModel = '';
        return _this;
    }
    MInputMask.prototype.mounted = function () {
        this.internalModel = this.value || '';
        this.cleave = new cleave_js__WEBPACK_IMPORTED_MODULE_1___default.a(this.$refs.input, this.getOptions());
        this.updateRawValue(this.value);
    };
    MInputMask.prototype.beforeDestroy = function () {
        this.cleave.destroy();
    };
    MInputMask.prototype.getOptions = function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.options), { onValueChanged: (function (event) {
                var _value = _this.raw ? event.target.rawValue : event.target.value;
                // only emit if model is changed
                // when v-model is not masked (raw)
                if (_this.internalModel === _value) {
                    return;
                }
                else {
                    _this.internalModel = _value;
                    _this.$emit('input', _value);
                }
            }) });
    };
    MInputMask.prototype.focusAndSelectAll = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.$refs.input.focus();
                        this.$refs.input.setSelectionRange(0, this.$refs.input.value.length);
                        return [2 /*return*/];
                }
            });
        });
    };
    MInputMask.prototype.focus = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.$refs.input.focus();
                        return [2 /*return*/];
                }
            });
        });
    };
    MInputMask.prototype.optionsChanged = function (options) {
        this.cleave.destroy();
        this.cleave = new cleave_js__WEBPACK_IMPORTED_MODULE_1___default.a(this.$el, this.getOptions());
        this.updateRawValue(this.value);
    };
    MInputMask.prototype.inputValueChanged = function (inputValue) {
        // when v-model is not masked (raw)
        if (this.raw && inputValue === this.cleave.getRawValue()) {
            return;
        }
        //  when v-model is masked (NOT raw)
        if (!this.raw && inputValue === this.$refs.input.value) {
            return;
        }
        this.internalModel = this.value || '';
        this.updateRawValue(inputValue);
    };
    MInputMask.prototype.onFocus = function ($event) {
        this.$emit('focus', $event);
    };
    MInputMask.prototype.onBlur = function ($event) {
        this.updateRawValue();
        this.$emit('blur', $event);
    };
    MInputMask.prototype.onKeyup = function ($event) {
        this.$emit('keyup', $event);
    };
    MInputMask.prototype.onKeydownTextfield = function ($event) {
        var rawValue = this.cleave.getRawValue();
        if (($event.key === '.' || $event.key === ',') && !rawValue.endsWith('.')) {
            this.cleave.setRawValue(rawValue + ".");
        }
        this.$emit('keydown', $event);
    };
    // Hack pour android qui lève toujours le key code 229.
    MInputMask.prototype.onTextInput = function ($event) {
        var key = $event.data;
        var rawValue = this.cleave.getRawValue();
        if (key === '.' && !rawValue.endsWith('.')) {
            this.cleave.setRawValue(rawValue + ".");
        }
        this.$emit('keydown', $event);
    };
    MInputMask.prototype.onEnter = function ($event) {
        this.$emit('keydown.enter', $event);
    };
    MInputMask.prototype.onPasteTextfield = function ($event) {
        this.$emit('paste', $event);
    };
    MInputMask.prototype.onDropTextfield = function ($event) {
        this.$emit('drop', $event);
    };
    MInputMask.prototype.onChange = function ($event) {
        this.$emit('change', $event);
    };
    MInputMask.prototype.updateRawValue = function (rawValue) {
        if (rawValue === void 0) { rawValue = this.cleave.getRawValue(); }
        // See what happens with issue https://github.com/nosir/cleave.js/issues/463.
        // Remove this code if it's resolved.
        if (this.options.removeTrailingDecimalMark && this.options.numeral === true && rawValue[rawValue.length - 1] === '.') {
            this.cleave.setRawValue(rawValue.replace('.', ''));
        }
        else if (this.options.forceDecimalScale && this.options.numeral && rawValue.includes('.') && this.options.numeralDecimalScale) {
            var valueStringParts = rawValue.split('.');
            var integerPart = valueStringParts[0];
            var decimalPart = valueStringParts[1];
            this.cleave.setRawValue(integerPart + "." + decimalPart.padEnd(this.options.numeralDecimalScale, '0'));
        }
        else {
            this.cleave.setRawValue(rawValue);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MInputMask.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])(),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Model"])('input')
    ], MInputMask.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MInputMask.prototype, "raw", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MInputMask.prototype, "options", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('options', { deep: true })
    ], MInputMask.prototype, "optionsChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('value')
    ], MInputMask.prototype, "inputValueChanged", null);
    MInputMask = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _input_mask_html__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MInputMask);
    return MInputMask;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));



/***/ }),

/***/ "./src/components/input-style/input-style.html":
/*!*****************************************************!*\
  !*** ./src/components/input-style/input-style.html ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "m-input-style",
      class: [
        {
          "m--is-focus": _vm.isFocus,
          "m--is-readonly": _vm.isReadonly,
          "m--is-label-up": _vm.isLabelUp,
          "m--is-disabled": _vm.isDisabled,
          "m--is-waiting": _vm.isWaiting,
          "m--has-cursor-pointer": _vm.cursorPointer,
          "m--has-error": _vm.hasError,
          "m--is-valid": _vm.isValid,
          "m--has-label": _vm.hasLabel,
          "m--has-value": _vm.hasValue,
          "m--is-anim-ready": _vm.animReady
        },
        "m--is-tag-" + _vm.tagStyle
      ],
      style: { width: _vm.width, marginTop: _vm.labelOffset },
      on: {
        click: _vm.onClick,
        mousedown: _vm.onMousedown,
        mouseup: _vm.onMouseup
      }
    },
    [
      _c("div", { staticClass: "m-input-style__main" }, [
        _c("div", { staticClass: "m-input-style__body" }, [
          _vm.hasLabel
            ? _c(
                "label",
                {
                  ref: "label",
                  staticClass: "m-input-style__label",
                  style: { marginRight: _vm.suffixOffset },
                  attrs: { for: _vm.labelFor }
                },
                [
                  _c("span", { staticClass: "m-input-style__text" }, [
                    _c("span", [_vm._v(_vm._s(_vm.label))]),
                    _vm._v(" "),
                    _vm.requiredMarker
                      ? _c(
                          "sup",
                          { staticClass: "m-input-style__required-marker" },
                          [_vm._v("*")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _c(
                "span",
                {
                  staticClass: "m-input-style__label",
                  staticStyle: { "z-index": "-1" }
                },
                [_c("span", { staticClass: "m-input-style__text" })]
              ),
          _vm._v(" "),
          _c("div", { ref: "input", staticClass: "m-input-style__input" }, [
            _vm.showPrefix
              ? _c(
                  "div",
                  { ref: "prefix", staticClass: "m-input-style__prefix" },
                  [_vm._t("prefix")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-input-style__content" },
              [
                _vm._t("default"),
                _vm._v(" "),
                !_vm.hasDefaultSlot
                  ? _c("m-i18n", {
                      staticClass: "m-input-style__transparent-text",
                      attrs: {
                        k: "m-input-style:empty-value",
                        "aria-hidden": "true"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAdjustWidthAutoSlot
                  ? _c(
                      "div",
                      {
                        ref: "adjustWidthAuto",
                        staticClass: "m-input-style__adjust-width-auto",
                        attrs: { "aria-hidden": "true" }
                      },
                      [_vm._t("adjust-width-auto")],
                      2
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "suffix", staticClass: "m-input-style__suffix" },
              [
                _vm._t("suffix"),
                _vm._v(" "),
                _vm.isWaiting
                  ? _c("m-spinner", {
                      staticClass: "m-input-style__spinner",
                      attrs: { size: "small" }
                    })
                  : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm.append
          ? _c(
              "div",
              { ref: "append", staticClass: "m-input-style__append" },
              [_vm._t("append")],
              2
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-26c2718b'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/input-style/input-style.scss":
/*!*****************************************************!*\
  !*** ./src/components/input-style/input-style.scss ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/input-style/input-style.ts":
/*!***************************************************!*\
  !*** ./src/components/input-style/input-style.ts ***!
  \***************************************************/
/*! exports provided: CSS_LABEL_DEFAULT_MARGIN, MInputStyle, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CSS_LABEL_DEFAULT_MARGIN", function() { return CSS_LABEL_DEFAULT_MARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MInputStyle", function() { return MInputStyle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _spinner_spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../spinner/spinner */ "./src/components/spinner/spinner.ts");
/* harmony import */ var _input_style_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./input-style.html */ "./src/components/input-style/input-style.html");
/* harmony import */ var _input_style_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_input_style_html__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _input_style_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./input-style.scss */ "./src/components/input-style/input-style.scss");
/* harmony import */ var _input_style_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_input_style_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var CSS_LABEL_DEFAULT_MARGIN = 10;
var MInputStyle = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MInputStyle, _super);
    function MInputStyle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.labelOffset = CSS_LABEL_DEFAULT_MARGIN + 'px';
        _this.suffixOffset = '0px';
        _this.animReady = false;
        return _this;
    }
    MInputStyle.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            _this.animReady = true;
            _this.setInputWidth();
        }, 0);
    };
    MInputStyle.prototype.mounted = function () {
        this.computeLabelOffset();
        this.computeSuffixOffset();
    };
    MInputStyle.prototype.setInputWidth = function () {
        var _this = this;
        // This is not very VueJs friendly.  It should be replaced by :style or something similar.
        this.$nextTick(function () {
            var labelEl = _this.$refs.label;
            var inputEl = _this.as().getInput();
            var adjustWidthAutoEl = _this.$refs.adjustWidthAuto;
            if (_this.width === 'auto' && _this.hasAdjustWidthAutoSlot) {
                setTimeout(function () {
                    if (inputEl !== undefined) {
                        inputEl.style.width = '0px';
                        setTimeout(function () {
                            if (inputEl !== null) {
                                var width = adjustWidthAutoEl.clientWidth < 50 ? 50 : adjustWidthAutoEl.clientWidth;
                                if (_this.hasLabel) {
                                    width = !_this.isLabelUp && (labelEl.clientWidth > width) ? labelEl.clientWidth : width;
                                }
                                inputEl.style.width = width + 'px';
                            }
                        }, 0);
                    }
                }, 0);
            }
            else if (inputEl) {
                if (inputEl.style.width) {
                    inputEl.style.removeProperty('width');
                }
            }
        });
    };
    MInputStyle.prototype.computeLabelOffset = function () {
        if (this.label) {
            var labelOffset = this.$refs.label.clientHeight / 2;
            this.labelOffset = this.isLabelUp && labelOffset > CSS_LABEL_DEFAULT_MARGIN ? labelOffset + "px" : CSS_LABEL_DEFAULT_MARGIN + "px";
        }
        else {
            this.labelOffset = undefined;
        }
    };
    MInputStyle.prototype.computeSuffixOffset = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (this.label && this.$refs.suffix) {
                            this.suffixOffset = this.$refs.suffix.clientWidth + 'px';
                        }
                        else {
                            this.suffixOffset = undefined;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MInputStyle.prototype, "isLabelUp", {
        get: function () {
            return (this.hasValue || (this.isFocus && this.hasValue) || this.labelUp) && this.hasLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "showPrefix", {
        get: function () {
            return this.hasLabel ? this.isFocus : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "hasValue", {
        get: function () {
            return this.hasDefaultSlot && !this.empty;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "hasLabel", {
        get: function () {
            return !!this.label && this.label !== '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "isFocus", {
        get: function () {
            var focus = this.focus && this.as().active;
            this.$emit('focus', focus);
            return focus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "hasDefaultSlot", {
        get: function () {
            return !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MInputStyle.prototype, "hasAdjustWidthAutoSlot", {
        get: function () {
            return !!this.$slots['adjust-width-auto'];
        },
        enumerable: true,
        configurable: true
    });
    MInputStyle.prototype.onClick = function (event) { };
    MInputStyle.prototype.onMousedown = function (event) { };
    MInputStyle.prototype.onMouseup = function (event) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '' })
    ], MInputStyle.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputStyle.prototype, "labelFor", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MInputStyle.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MInputStyle.prototype, "append", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MInputStyle.prototype, "empty", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputStyle.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputStyle.prototype, "requiredMarker", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MInputStyle.prototype, "readonly", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MInputStyle.prototype, "cursorPointer", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MInputStyle.prototype, "labelUp", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('isLabelUp')
    ], MInputStyle.prototype, "computeLabelOffset", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MInputStyle.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mousedown')
    ], MInputStyle.prototype, "onMousedown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseup')
    ], MInputStyle.prototype, "onMouseup", null);
    MInputStyle = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _input_style_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_6__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["SPINNER_NAME"]] = _spinner_spinner__WEBPACK_IMPORTED_MODULE_7__["MSpinner"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MInputStyle);
    return MInputStyle;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var InputStylePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["INPUT_STYLE_NAME"], MInputStyle);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (InputStylePlugin);


/***/ }),

/***/ "./src/components/integerfield/integerfield.html?style=./integerfield.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/integerfield/integerfield.html?style=./integerfield.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f68819ae!./integerfield.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=f68819ae!./src/components/integerfield/integerfield.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-integerfield",
      class: [
        {
          "m--is-disabled": _vm.isDisabled,
          "m--is-waiting": _vm.isWaiting,
          "m--is-readonly": _vm.isReadonly,
          "m--has-error": _vm.hasDecimalfieldError,
          "m--is-valid": _vm.isDecimalfieldValid,
          "m--has-label": _vm.hasLabel,
          "m--has-validation-message": _vm.hasValidationMessage
        }
      ],
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasDecimalfieldError,
            valid: _vm.isDecimalfieldValid,
            label: _vm.label,
            "label-for": _vm.id,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2),
          _vm._v(" "),
          _c("m-input-mask", {
            ref: "inputMask",
            staticClass: "m-integerfield__input",
            attrs: {
              id: _vm.id,
              disabled: _vm.isDisabled || _vm.isWaiting,
              placeholder: _vm.placeholder,
              readonly: _vm.isReadonly,
              autocomplete: _vm.autocomplete,
              options: _vm.inputMaskOptions,
              inputmode: "decimal"
            },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              keyup: _vm.onKeyup,
              change: _vm.onChange
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _vm._v(" "),
          _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-integerfield__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-integerfield__validation__message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasDecimalfieldError,
              "error-message": _vm.errorMessage,
              valid: _vm.isDecimalfieldValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-f68819ae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/integerfield/integerfield.ts":
/*!*****************************************************!*\
  !*** ./src/components/integerfield/integerfield.ts ***!
  \*****************************************************/
/*! exports provided: MIntegerfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIntegerfield", function() { return MIntegerfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../input-mask/input-mask */ "./src/components/input-mask/input-mask.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _integerfield_html_style_integerfield_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./integerfield.html?style=./integerfield.scss */ "./src/components/integerfield/integerfield.html?style=./integerfield.scss");
/* harmony import */ var _integerfield_html_style_integerfield_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_integerfield_html_style_integerfield_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a;














var MIntegerfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MIntegerfield, _super);
    function MIntegerfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mIntegerfield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__["default"].generate();
        return _this;
    }
    Object.defineProperty(MIntegerfield.prototype, "hasDecimalfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIntegerfield.prototype, "isDecimalfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIntegerfield.prototype, "inputMaskOptions", {
        get: function () {
            return {
                numeral: true,
                numeralThousandsGroupStyle: 'none',
                numeralIntegerScale: this.maxLength,
                numeralDecimalScale: 0,
                numeralDecimalMark: '',
                numeralPositiveOnly: true,
                stripLeadingZeroes: true,
                delimiter: ''
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIntegerfield.prototype, "currentLocale", {
        get: function () {
            return this.$i18n.currentLocale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MIntegerfield.prototype, "model", {
        get: function () {
            return (!this.value && this.value !== 0 ? '' : this.value).toString();
        },
        set: function (value) {
            var valueAsNumber = Number.parseFloat(value);
            this.emitNewValue(valueAsNumber);
        },
        enumerable: true,
        configurable: true
    });
    MIntegerfield.prototype.emitNewValue = function (_newValue) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MIntegerfield.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 16,
            validator: function (value) {
                if (!(typeof value === 'number')) {
                    return false;
                }
                if (!isNaN(value) && value <= 16) {
                    return true;
                }
                return false;
            }
        })
    ], MIntegerfield.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], MIntegerfield.prototype, "emitNewValue", null);
    MIntegerfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _integerfield_html_style_integerfield_scss__WEBPACK_IMPORTED_MODULE_13___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ],
            components: (_a = {
                    MInputMask: _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_10__["MInputMask"]
                },
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_11__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_12__["MValidationMessage"],
                _a)
        })
    ], MIntegerfield);
    return MIntegerfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var IntegerfieldPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["INTEGERFIELD_NAME"], MIntegerfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (IntegerfieldPlugin);


/***/ }),

/***/ "./src/components/limit-text/limit-text.html?style=./limit-text.scss":
/*!***************************************************************************!*\
  !*** ./src/components/limit-text/limit-text.html?style=./limit-text.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=367dd5c9!./limit-text.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=367dd5c9!./src/components/limit-text/limit-text.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-limit-text" },
    [
      !_vm.html
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.contentTooTall,
                  expression: "!contentTooTall"
                }
              ],
              ref: "originalText",
              staticClass: "m-limit-text__original",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._t("default")],
            2
          )
        : _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.contentTooTall,
                expression: "!contentTooTall"
              }
            ],
            ref: "originalText",
            staticClass: "m-limit-text__original",
            attrs: { "aria-hidden": "true" },
            domProps: { innerHTML: _vm._s(_vm.html) }
          }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hasFinish,
            expression: "!hasFinish"
          }
        ],
        ref: "testingText",
        staticClass: "m-limit-text__testing-text",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      !_vm.internalOpen
        ? _c("m-dynamic-template", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentTooTall,
                expression: "contentTooTall"
              }
            ],
            staticClass: "m-limit-text__content",
            attrs: { template: _vm.getReduceText },
            on: {
              updated: function($event) {
                return _vm.onUpdatedOpen($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.internalOpen
        ? _c("m-dynamic-template", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentTooTall,
                expression: "contentTooTall"
              }
            ],
            staticClass: "m-limit-text__content",
            attrs: { template: _vm.getFullText },
            on: {
              updated: function($event) {
                return _vm.onUpdatedClose($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-367dd5c9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/limit-text/limit-text.ts":
/*!*************************************************!*\
  !*** ./src/components/limit-text/limit-text.ts ***!
  \*************************************************/
/*! exports provided: MLimitText, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MLimitText", function() { return MLimitText; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/element-queries/element-queries */ "./src/mixins/element-queries/element-queries.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../dynamic-template/dynamic-template */ "./src/components/dynamic-template/dynamic-template.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _limit_text_html_style_limit_text_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./limit-text.html?style=./limit-text.scss */ "./src/components/limit-text/limit-text.html?style=./limit-text.scss");
/* harmony import */ var _limit_text_html_style_limit_text_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_limit_text_html_style_limit_text_scss__WEBPACK_IMPORTED_MODULE_12__);
var _a;













var MLimitText = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MLimitText, _super);
    function MLimitText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reduceContent = '';
        _this.testingContent = '';
        _this.fullContent = '';
        _this.internalOpen = false;
        _this.hasFinish = false;
        _this.contentTooTall = false;
        _this.initLineHeigh = '';
        _this.maxHeight = 0;
        _this.uuid = _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__["default"].generate();
        return _this;
    }
    MLimitText.prototype.mounted = function () {
        var _this = this;
        this.internalOpen = this.open;
        // ------------ Resize section ------------
        this.$nextTick(function () {
            _this.as().$on('resizeDone', _this.reset);
        });
        // ---------------------------------------
        // ------------ Watch slot content -------
        this.observer = new MutationObserver(function () {
            _this.reset();
        });
        this.observer.observe(this.$refs.originalText, { subtree: true, childList: true, characterData: true });
        // ---------------------------------------
        this.initialize();
    };
    MLimitText.prototype.destroyed = function () {
        if (this.child) {
            this.child.removeEventListener('click', this.openText);
            this.child.removeEventListener('click', this.closeText);
        }
        this.observer.disconnect();
    };
    MLimitText.prototype.initialize = function () {
        this.el = this.$refs.testingText;
        if (this.el) {
            this.el.innerHTML = this.$refs.originalText.innerHTML;
            this.testingContent = this.el.innerHTML;
            this.el.style.whiteSpace = 'nowrap';
            for (var i = 1; i < this.el.children.length; i++) {
                this.el.children[i].style.display = 'none';
            }
            this.initLineHeigh = this.el.clientHeight;
            for (var i = 1; i < this.el.children.length; i++) {
                this.el.children[i].style.display = 'block';
            }
            this.el.style.whiteSpace = 'normal';
            this.maxHeight = this.lines * this.initLineHeigh;
            // Generate the full content - Add the close link if an HTML tag is present
            if (this.testingContent.match('</')) {
                var tagIndex = this.testingContent.lastIndexOf('</');
                this.fullContent = this.testingContent.substring(0, tagIndex) + this.closeLink + this.testingContent.substring(tagIndex);
            }
            else {
                this.fullContent = this.testingContent + this.closeLink;
            }
            // Get the limited text
            this.adjustText();
        }
    };
    MLimitText.prototype.adjustText = function () {
        if (this.isContentTooTall(false)) {
            this.contentTooTall = true;
            this.hasFinish = false;
            this.getReduceContent();
            this.hasFinish = true;
        }
        else {
            this.contentTooTall = false;
            this.hasFinish = true;
        }
    };
    MLimitText.prototype.isContentTooTall = function (update) {
        if (update) {
            this.updateContent(this.reduceContent, this.el);
        }
        var currentHeight = (this.el).clientHeight;
        return (currentHeight > this.maxHeight);
    };
    MLimitText.prototype.updateContent = function (content, el) {
        el.innerHTML = content;
    };
    MLimitText.prototype.reset = function () {
        var _this = this;
        this.hasFinish = false;
        this.reduceContent = '';
        this.testingContent = '';
        this.$nextTick(function () {
            _this.initialize();
        });
    };
    MLimitText.prototype.getReduceContent = function () {
        var HTMLcontent = this.fullContent;
        var index = 0;
        var lastValidContent = '';
        var closingTag = '';
        while (index < HTMLcontent.length && !this.isContentTooTall(true)) {
            if (HTMLcontent[index] === '<' && (index + 1) < HTMLcontent.length) {
                switch (true) {
                    // Opening tag
                    case /\w/.test(HTMLcontent[index + 1]):
                        var tag = '</';
                        index++;
                        var endTagName = false;
                        while (HTMLcontent[index] !== '>') {
                            if (!endTagName && /\w/.test(HTMLcontent[index])) {
                                tag += HTMLcontent[index];
                            }
                            else {
                                endTagName = true;
                            }
                            index++;
                        }
                        tag += '>';
                        // Do not keep the tag if it is a "self closing" tag
                        if (!/<\/(area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)>$/.test(tag)) {
                            closingTag = tag + closingTag;
                        }
                        break;
                    // Closing tag
                    case (HTMLcontent[index + 1] === '/'):
                        var endTag = '</';
                        index += 2;
                        while (HTMLcontent[index] !== '>') {
                            endTag += HTMLcontent[index];
                            index++;
                        }
                        endTag += '>';
                        closingTag = closingTag.slice(endTag.length);
                        break;
                }
            }
            lastValidContent = this.reduceContent;
            this.reduceContent = HTMLcontent.substring(0, index + 1) + this.openLinkOriginal + closingTag;
            index++;
        }
        this.reduceContent = lastValidContent.replace(this.openLinkOriginal, this.openLink);
    };
    Object.defineProperty(MLimitText.prototype, "getReduceText", {
        get: function () {
            return this.reduceContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "getFullText", {
        get: function () {
            return this.fullContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "openLinkOriginal", {
        get: function () {
            return '...&nbsp' + new this.openLinkOriginalRendered().$mount().$el.outerHTML;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "openLinkOriginalRendered", {
        get: function () {
            var vNodeData = {
                props: {
                    mode: _link_link__WEBPACK_IMPORTED_MODULE_11__["MLinkMode"].Button,
                    underline: false
                },
                attrs: {
                    style: 'font-weight:400;',
                    title: this.getOpenLabelTitle,
                    'data-id': this.uuid
                }
            };
            var vNodeChildren = '[' + (this.openLabel ? this.openLabel.replace(/\s/g, '\xa0') : '\xa0+\xa0') + ']';
            return vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
                render: function (createElement) {
                    return createElement(_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"], vNodeData, vNodeChildren);
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "openLink", {
        get: function () {
            return '...&nbsp' + new this.openLinkRendered().$mount().$el.outerHTML;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "openLinkRendered", {
        get: function () {
            var vNodeData = {
                props: {
                    mode: _link_link__WEBPACK_IMPORTED_MODULE_11__["MLinkMode"].Button,
                    underline: false
                },
                attrs: {
                    title: this.getOpenLabelTitle,
                    'data-id': this.uuid
                }
            };
            var vNodeChildren = '[' + (this.openLabel ? this.openLabel.replace(/\s/g, '\xa0') : '\xa0+\xa0') + ']';
            return vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
                render: function (createElement) {
                    return createElement(_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"], vNodeData, vNodeChildren);
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "closeLink", {
        get: function () {
            return '&nbsp;' + new this.closeLinkRendered().$mount().$el.outerHTML;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "closeLinkRendered", {
        get: function () {
            var vNodeData = {
                props: {
                    mode: _link_link__WEBPACK_IMPORTED_MODULE_11__["MLinkMode"].Button,
                    underline: false
                },
                attrs: {
                    title: this.getCloseLabelTitle,
                    'data-id': this.uuid
                }
            };
            var vNodeChildren = '[' + (this.closeLabel ? this.closeLabel.replace(/\s/g, '\xa0') : '\xa0-\xa0') + ']';
            return vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
                render: function (createElement) {
                    return createElement(_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"], vNodeData, vNodeChildren);
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "getOpenLabelTitle", {
        get: function () {
            return this.openLabel ? this.openLabel.replace(/\s/g, '\xa0') : this.$i18n.translate('m-limit-text:open');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLimitText.prototype, "getCloseLabelTitle", {
        get: function () {
            return this.closeLabel ? this.closeLabel.replace(/\s/g, '\xa0') : this.$i18n.translate('m-limit-text:close');
        },
        enumerable: true,
        configurable: true
    });
    MLimitText.prototype.openChanged = function (open) {
        this.internalOpen = open;
    };
    MLimitText.prototype.openText = function (event) {
        this.internalOpen = true;
        this.$emit('open');
        event.preventDefault();
    };
    MLimitText.prototype.closeText = function (event) {
        this.internalOpen = false;
        this.$emit('close');
        event.preventDefault();
    };
    MLimitText.prototype.onUpdatedOpen = function (component) {
        var link = component[0].$el.querySelector('a[data-id="' + this.uuid + '"]');
        if (this.child) {
            this.child.removeEventListener('click', this.openText);
        }
        if (link) {
            this.child = link;
            this.child.addEventListener('click', this.openText);
        }
    };
    MLimitText.prototype.onUpdatedClose = function (component) {
        var link = component[0].$el.querySelector('a[data-id="' + this.uuid + '"]');
        if (this.child) {
            this.child.removeEventListener('click', this.closeText);
        }
        if (link) {
            this.child = link;
            this.child.addEventListener('click', this.closeText);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MLimitText.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 4 })
    ], MLimitText.prototype, "lines", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MLimitText.prototype, "openLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MLimitText.prototype, "closeLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MLimitText.prototype, "html", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('open')
    ], MLimitText.prototype, "openChanged", null);
    MLimitText = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _limit_text_html_style_limit_text_scss__WEBPACK_IMPORTED_MODULE_12___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_10__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_11__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["DYNAMIC_TEMPLATE_NAME"]] = _dynamic_template_dynamic_template__WEBPACK_IMPORTED_MODULE_9__["MDynamicTemplate"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"], _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_4__["ElementQueries"]]
        })
    ], MLimitText);
    return MLimitText;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var LimitTextPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["LIMIT_TEXT_NAME"], MLimitText);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LimitTextPlugin);


/***/ }),

/***/ "./src/components/link/link.html?style=./link.scss":
/*!*********************************************************!*\
  !*** ./src/components/link/link.html?style=./link.scss ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=62718769!./link.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=62718769!./src/components/link/link.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tagName,
    {
      ref: _vm.linkRef,
      tag: "component",
      staticClass: "m-link",
      class: {
        "m--is-unvisited": _vm.isUnvisited,
        "m--is-disabled": _vm.disabled,
        "m--no-underline": !_vm.underline,
        "m--is-button": _vm.isButton,
        "m--is-skin-text": _vm.isSkinText,
        "m--is-skin-light": _vm.isSkinLight,
        "m--has-right-icon": _vm.isIconPositionRight,
        "m--has-left-icon": _vm.isIconPositionLeft,
        "m--has-content": _vm.$slots.default
      },
      attrs: {
        to: _vm.routerLinkUrl,
        event: _vm.routerEvent,
        role: _vm.roleButton,
        href: _vm.propUrl,
        target: _vm.target,
        tabindex: _vm.disabled ? "-1" : _vm.tabindex
      },
      on: { keyup: _vm.onKeyup, click: _vm.onClick }
    },
    [
      _vm.hasIcon
        ? _c("m-icon", {
            staticClass: "m-link__icon",
            class: { "m--has-large-stroke": _vm.iconHasLargeStroke },
            attrs: {
              name: _vm.propIconName,
              size: _vm.propIconSize,
              "aria-hidden": "true"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "m-link__text" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.isTargetBlank
        ? _c("m-i18n", {
            staticClass: "m-link__hidden",
            attrs: { k: "m-link:open-new-tab" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-62718769'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/link/link.ts":
/*!*************************************!*\
  !*** ./src/components/link/link.ts ***!
  \*************************************/
/*! exports provided: MLinkMode, MLinkIconPosition, MLinkSkin, MLink, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MLinkMode", function() { return MLinkMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MLinkIconPosition", function() { return MLinkIconPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MLinkSkin", function() { return MLinkSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MLink", function() { return MLink; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/keycode/keycode */ "./src/utils/keycode/keycode.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _link_html_style_link_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./link.html?style=./link.scss */ "./src/components/link/link.html?style=./link.scss");
/* harmony import */ var _link_html_style_link_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_link_html_style_link_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MLinkMode;
(function (MLinkMode) {
    MLinkMode["RouterLink"] = "router-link";
    MLinkMode["Link"] = "link";
    MLinkMode["Button"] = "button";
})(MLinkMode || (MLinkMode = {}));
var MLinkIconPosition;
(function (MLinkIconPosition) {
    MLinkIconPosition["Left"] = "left";
    MLinkIconPosition["Right"] = "right";
})(MLinkIconPosition || (MLinkIconPosition = {}));
var MLinkSkin;
(function (MLinkSkin) {
    MLinkSkin["Default"] = "default";
    MLinkSkin["Light"] = "light";
    MLinkSkin["Text"] = "text";
})(MLinkSkin || (MLinkSkin = {}));
var ICON_NAME_CHEVRON = 'm-svg__chevron--right';
var MLink = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MLink, _super);
    function MLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MLink.prototype.emitClick = function (event) { };
    Object.defineProperty(MLink.prototype, "isRouterLink", {
        get: function () {
            return this.mode === MLinkMode.RouterLink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "roleButton", {
        get: function () {
            return this.isButton ? 'button' : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "iconHasLargeStroke", {
        get: function () {
            switch (this.propIconName) {
                case 'm-svg__chevron--up':
                case 'm-svg__chevron--right':
                case 'm-svg__chevron--down':
                case 'm-svg__chevron--left':
                    return true;
                default:
                    return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "linkRef", {
        get: function () {
            return this.isRouterLink ? 'router' : 'link';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isButton", {
        get: function () {
            return this.mode === MLinkMode.Button;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isSkinText", {
        get: function () {
            return this.skin === MLinkSkin.Text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isSkinLight", {
        get: function () {
            return this.skin === MLinkSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isUnvisited", {
        get: function () {
            return this.isButton ? true : this.unvisited;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isIconPositionLeft", {
        get: function () {
            return this.hasIcon && this.iconPosition === MLinkIconPosition.Left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isIconPositionRight", {
        get: function () {
            return this.hasIcon && this.iconPosition === MLinkIconPosition.Right;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "hasIcon", {
        get: function () {
            return Boolean(this.propIconName) || this.bulletPoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "propIconSize", {
        get: function () {
            return this.bulletPoint ? '12px' : this.iconSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "propIconName", {
        get: function () {
            return this.bulletPoint ? ICON_NAME_CHEVRON : this.iconName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "propUrl", {
        get: function () {
            switch (this.mode) {
                case MLinkMode.Link:
                    return !this.disabled ? this.url : undefined;
                case MLinkMode.Button:
                    return '#';
                case MLinkMode.RouterLink:
                default:
                    return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "routerLinkUrl", {
        get: function () {
            switch (this.mode) {
                case MLinkMode.Link:
                case MLinkMode.Button:
                    return undefined;
                case MLinkMode.RouterLink:
                default:
                    if (this.disabled || !this.url) {
                        return { path: '/' };
                    }
                    else {
                        return this.isObject(this.url) ? this.url : { path: this.url };
                    }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "isTargetBlank", {
        get: function () {
            return this.target === '_blank';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "routerEvent", {
        get: function () {
            if (!this.isRouterLink) {
                return undefined;
            }
            return this.disabled ? '' : 'click';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MLink.prototype, "tagName", {
        get: function () {
            return this.isRouterLink ? 'router-link' : 'a';
        },
        enumerable: true,
        configurable: true
    });
    MLink.prototype.isObject = function (a) {
        return !!a && a.constructor === Object;
    };
    MLink.prototype.onClick = function (event) {
        this.$el.blur();
        if (this.isButton || this.disabled) {
            event.preventDefault();
        }
        if (!this.disabled) {
            this.emitClick(event);
        }
    };
    MLink.prototype.onKeyup = function (event) {
        // tslint:disable-next-line: deprecation
        event = event || window.event;
        if (event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_3__["KeyCode"].M_SPACE && this.isButton) {
            this.onClick(event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '/' })
    ], MLink.prototype, "url", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MLinkMode.RouterLink,
            validator: function (value) {
                return value === MLinkMode.RouterLink ||
                    value === MLinkMode.Link ||
                    value === MLinkMode.Button;
            }
        })
    ], MLink.prototype, "mode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MLink.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MLink.prototype, "unvisited", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MLink.prototype, "underline", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MLinkSkin.Default,
            validator: function (value) {
                return value === MLinkSkin.Default ||
                    value === MLinkSkin.Light ||
                    value === MLinkSkin.Text;
            }
        })
    ], MLink.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MLink.prototype, "target", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MLink.prototype, "bulletPoint", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MLink.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MLinkIconPosition.Left,
            validator: function (value) {
                return value === MLinkIconPosition.Left || value === MLinkIconPosition.Right;
            }
        })
    ], MLink.prototype, "iconPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '1em' })
    ], MLink.prototype, "iconSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '0' })
    ], MLink.prototype, "tabindex", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MLink.prototype, "emitClick", null);
    MLink = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _link_html_style_link_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_7__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_6__["MI18n"],
                _a)
        })
    ], MLink);
    return MLink;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var LinkPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["LINK_NAME"], MLink);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LinkPlugin);


/***/ }),

/***/ "./src/components/list-item/list-item.html?style=./list-item.scss":
/*!************************************************************************!*\
  !*** ./src/components/list-item/list-item.html?style=./list-item.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d802e53a!./list-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d802e53a!./src/components/list-item/list-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-list-item",
      class: {
        "m--is-disabled": _vm.disabled,
        "m--is-waiting": _vm.isWaiting,
        "m--has-trigger": _vm.$slots["trigger"],
        "m--has-icon": _vm.hasIcon,
        "m--has-border-top": _vm.borderTop,
        "m--has-border-bottom": _vm.borderBottom,
        "m--has-menu": _vm.$slots["menu"],
        "m--is-full-width": _vm.fullWidth,
        "m--is-full-height": _vm.fullHeight
      }
    },
    [
      _c(
        "div",
        { staticClass: "m-list-item__content" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      !_vm.disabled
        ? [
            _vm.hasIcon && !_vm.isWaiting
              ? _c(
                  "div",
                  { staticClass: "m-list-item__icon" },
                  [
                    _c(
                      "m-icon-button",
                      {
                        attrs: { "icon-name": _vm.iconName },
                        on: {
                          click: function($event) {
                            return _vm.click($event)
                          }
                        }
                      },
                      [_c("m-i18n", { attrs: { k: _vm.iconHiddenText } })],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots["menu"] && !_vm.hasIcon && !_vm.isWaiting
              ? _c(
                  "div",
                  { staticClass: "m-list-item__icon" },
                  [_vm._t("menu")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots["trigger"] && !_vm.hasIcon && !_vm.isWaiting
              ? _c(
                  "div",
                  { staticClass: "m-list-item__trigger" },
                  [_vm._t("trigger")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWaiting
              ? _c(
                  "div",
                  { staticClass: "m-list-item__icon" },
                  [_c("m-spinner", { attrs: { size: "small" } })],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-d802e53a'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/list-item/list-item.ts":
/*!***********************************************!*\
  !*** ./src/components/list-item/list-item.ts ***!
  \***********************************************/
/*! exports provided: MListItem, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MListItem", function() { return MListItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _spinner_spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../spinner/spinner */ "./src/components/spinner/spinner.ts");
/* harmony import */ var _list_item_html_style_list_item_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./list-item.html?style=./list-item.scss */ "./src/components/list-item/list-item.html?style=./list-item.scss");
/* harmony import */ var _list_item_html_style_list_item_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_list_item_html_style_list_item_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MListItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MListItem, _super);
    function MListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MListItem.prototype.click = function (event) { };
    Object.defineProperty(MListItem.prototype, "hasIcon", {
        get: function () {
            return this.iconName !== '' && this.iconName !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MListItem.prototype, "isWaiting", {
        get: function () {
            return this.waiting && !this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MListItem.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MListItem.prototype, "iconHiddenText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MListItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MListItem.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MListItem.prototype, "fullWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MListItem.prototype, "fullHeight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MListItem.prototype, "borderTop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MListItem.prototype, "borderBottom", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MListItem.prototype, "click", null);
    MListItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _list_item_html_style_list_item_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["SPINNER_NAME"]] = _spinner_spinner__WEBPACK_IMPORTED_MODULE_7__["MSpinner"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButton"],
                _a)
        })
    ], MListItem);
    return MListItem;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var ListItemPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["LIST_ITEM_NAME"], MListItem);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ListItemPlugin);


/***/ }),

/***/ "./src/components/maskedfield/maskedfield.html?style=./maskedfield.scss":
/*!******************************************************************************!*\
  !*** ./src/components/maskedfield/maskedfield.html?style=./maskedfield.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8a22ccee!./maskedfield.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8a22ccee!./src/components/maskedfield/maskedfield.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-maskedlfield",
      class: [
        {
          "m--is-disabled": _vm.isDisabled,
          "m--is-waiting": _vm.isWaiting,
          "m--is-readonly": _vm.isReadonly,
          "m--has-error": _vm.hasMaskedfieldError,
          "m--is-valid": _vm.isMaskedfieldValid,
          "m--has-label": _vm.hasLabel,
          "m--has-validation-message": _vm.hasValidationMessage
        }
      ],
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          staticClass: "m-maskedfield__input-style",
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasMaskedfieldError,
            valid: _vm.isMaskedfieldValid,
            label: _vm.label,
            "label-for": _vm.id,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2),
          _vm._v(" "),
          _c("m-input-mask", {
            ref: "inputMask",
            attrs: {
              id: _vm.id,
              autocomplete: _vm.autocomplete,
              disabled: _vm.isDisabled || _vm.isWaiting,
              readonly: _vm.isReadonly,
              placeholder: _vm.placeholder,
              raw: _vm.raw,
              options: _vm.maskOptions
            },
            on: {
              blur: _vm.onBlur,
              change: _vm.onChange,
              focus: _vm.onFocus,
              keyup: _vm.onKeyup,
              keydown: _vm.onKeydown,
              paste: _vm.onPaste
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _vm._v(" "),
          _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-maskedfield__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-maskedfield__validation-message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasMaskedfieldError,
              "error-message": _vm.errorMessage,
              valid: _vm.isMaskedfieldValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-8a22ccee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/maskedfield/maskedfield.ts":
/*!***************************************************!*\
  !*** ./src/components/maskedfield/maskedfield.ts ***!
  \***************************************************/
/*! exports provided: MMaskedfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMaskedfield", function() { return MMaskedfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../input-mask/input-mask */ "./src/components/input-mask/input-mask.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _maskedfield_html_style_maskedfield_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./maskedfield.html?style=./maskedfield.scss */ "./src/components/maskedfield/maskedfield.html?style=./maskedfield.scss");
/* harmony import */ var _maskedfield_html_style_maskedfield_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_maskedfield_html_style_maskedfield_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a;














var MMaskedfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMaskedfield, _super);
    function MMaskedfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mMaskedfield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__["default"].generate();
        return _this;
    }
    Object.defineProperty(MMaskedfield.prototype, "hasMaskedfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMaskedfield.prototype, "isMaskedfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: {} })
    ], MMaskedfield.prototype, "maskOptions", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MMaskedfield.prototype, "raw", void 0);
    MMaskedfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _maskedfield_html_style_maskedfield_scss__WEBPACK_IMPORTED_MODULE_13___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ],
            components: (_a = {
                    MInputMask: _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_10__["MInputMask"]
                },
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_11__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_12__["MValidationMessage"],
                _a)
        })
    ], MMaskedfield);
    return MMaskedfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var MaskedfieldPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["MASKEDFIELD_NAME"], MMaskedfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MaskedfieldPlugin);


/***/ }),

/***/ "./src/components/menu/menu-item/menu-item.html":
/*!******************************************************!*\
  !*** ./src/components/menu/menu-item/menu-item.html ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-menu-item",
      class: {
        "m--is-selected": _vm.selected,
        "m--is-disabled": _vm.isDisabled,
        "m--is-group": _vm.group,
        "m--is-open": _vm.propOpen,
        "m--is-custom-content": _vm.$slots["content"],
        "m--is-inside-group": _vm.insideGroup
      },
      attrs: { role: "none" }
    },
    [
      _vm.isUrl
        ? _c(
            "router-link",
            {
              staticClass: "m-menu-item__link",
              class: { "m--is-disabled": _vm.isDisabled },
              attrs: {
                to: _vm.url,
                "aria-selected": _vm.selected,
                role: "menuitem"
              },
              on: { click: _vm.onClick }
            },
            [
              _vm.iconName
                ? _c("m-icon", {
                    ref: "icon",
                    staticClass: "m-menu-item__icon",
                    attrs: { name: _vm.iconName, size: "1em" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "m-menu-item__label" }, [
                _vm._v(_vm._s(_vm.label))
              ])
            ],
            1
          )
        : _c(
            "span",
            {
              staticClass: "m-menu-item__link",
              class: {
                "m--is-disabled": _vm.isDisabled,
                "m--is-custom-content": _vm.$slots["content"]
              },
              attrs: {
                tabindex: _vm.isDisabled ? "-1" : "0",
                "aria-selected": _vm.selected,
                "aria-haspopup": _vm.group,
                "aria-controls": _vm.group ? _vm.ariaControls : undefined,
                "aria-expanded": _vm.group ? _vm.propOpen : undefined
              },
              on: {
                click: _vm.onClick,
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onClick($event)
                }
              }
            },
            [
              _vm._t("content", [
                _vm.iconName
                  ? _c("m-icon", {
                      ref: "icon",
                      staticClass: "m-menu-item__icon",
                      attrs: { name: _vm.iconName, size: "1em" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "m-menu-item__label" }, [
                  _vm._v(_vm._s(_vm.label))
                ]),
                _vm._v(" "),
                _vm.group
                  ? _c("m-plus", {
                      ref: "plus",
                      staticClass: "m-menu-item__plus",
                      attrs: {
                        skin: "current-color",
                        open: _vm.propOpen,
                        large: _vm.selected
                      }
                    })
                  : _vm._e()
              ])
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "m-accordion-transition",
        {
          ref: "transition",
          attrs: { disabled: !_vm.animReady || _vm.isDisabled }
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.propOpen,
                  expression: "propOpen"
                }
              ],
              ref: "group",
              staticClass: "m-menu-item__group",
              attrs: { id: _vm.ariaControls, "aria-hidden": !_vm.propOpen }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-58222277'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/menu/menu-item/menu-item.scss":
/*!******************************************************!*\
  !*** ./src/components/menu/menu-item/menu-item.scss ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/menu/menu-item/menu-item.ts":
/*!****************************************************!*\
  !*** ./src/components/menu/menu-item/menu-item.ts ***!
  \****************************************************/
/*! exports provided: BaseMenuItem, MMenuItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseMenuItem", function() { return BaseMenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMenuItem", function() { return MMenuItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _plus_plus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../plus/plus */ "./src/components/plus/plus.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../menu */ "./src/components/menu/menu.ts");
/* harmony import */ var _menu_item_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./menu-item.html */ "./src/components/menu/menu-item/menu-item.html");
/* harmony import */ var _menu_item_html__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_menu_item_html__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _menu_item_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./menu-item.scss */ "./src/components/menu/menu-item/menu-item.scss");
/* harmony import */ var _menu_item_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_menu_item_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var BaseMenuItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseMenuItem, _super);
    function BaseMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseMenuItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var MMenuItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMenuItem, _super);
    function MMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = false;
        _this.selected = false;
        _this.insideGroup = false;
        _this.animReady = false;
        _this.ariaControls = "mMenuItem-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate() + "-controls";
        // tslint:disable-next-line:no-null-keyword
        _this.menuRoot = null;
        // tslint:disable-next-line:no-null-keyword
        _this.groupItemRoot = null;
        _this.internalOpen = false;
        return _this;
    }
    MMenuItem_1 = MMenuItem;
    MMenuItem.prototype.mounted = function () {
        var _this = this;
        var menuRoot = this.getParent(function (p) { return p instanceof _menu__WEBPACK_IMPORTED_MODULE_9__["BaseMenu"] || p.$options.name === 'MMenu'; });
        if (menuRoot) {
            this.menuRoot = menuRoot;
        }
        else {
            console.error('<m-menu-item> need to be inside <m-menu>');
        }
        this.$nextTick(function () {
            _this.onGroupObserverChange();
            _this.groupObserver = new MutationObserver(function () { return _this.onGroupObserverChange(); });
            if (_this.$refs.group) {
                _this.groupObserver.observe(_this.$refs.group, { subtree: true, childList: true });
            }
        });
    };
    MMenuItem.prototype.beforeDestroy = function () {
        if (this.groupObserver) {
            this.groupObserver.disconnect();
        }
    };
    MMenuItem.prototype.emitClick = function (event) { };
    MMenuItem.prototype.openChanged = function (open) {
        this.propOpen = open;
    };
    Object.defineProperty(MMenuItem.prototype, "propOpen", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            if (this.group) {
                this.animReady = false;
                this.internalOpen = open;
                this.animReady = true;
                this.$emit('update:open', open);
            }
        },
        enumerable: true,
        configurable: true
    });
    MMenuItem.prototype.getGroupItem = function () {
        return this.$refs.transition.$children
            .filter(function (child) { return child instanceof MMenuItem_1; })
            .map(function (child) { return child; });
    };
    Object.defineProperty(MMenuItem.prototype, "isAnimReady", {
        get: function () {
            return this.menuRoot ? this.menuRoot.animReady : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMenuItem.prototype, "isUrl", {
        get: function () {
            return !!this.url && !this.group;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMenuItem.prototype, "isDisabled", {
        get: function () {
            return this.menuRoot && this.menuRoot.propDisabled ? true : this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    MMenuItem.prototype.onClick = function (event) {
        if (!this.isDisabled && this.menuRoot && !this.menuRoot.closeOnSelectionInAction) {
            if (this.group) {
                this.toggleOpen();
            }
            else {
                this.menuRoot.updateValue(this.value);
                this.menuRoot.onClick(event, this.value);
            }
            this.emitClick(event);
        }
    };
    MMenuItem.prototype.onGroupObserverChange = function () {
        this.group = !!this.$refs.transition.$children.find(function (item) { return item instanceof MMenuItem_1; });
    };
    MMenuItem.prototype.toggleOpen = function () {
        this.propOpen = !this.propOpen;
    };
    var MMenuItem_1;
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "url", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenuItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MMenuItem.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open', { immediate: true })
    ], MMenuItem.prototype, "openChanged", null);
    MMenuItem = MMenuItem_1 = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _menu_item_html__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["PLUS_NAME"]] = _plus_plus__WEBPACK_IMPORTED_MODULE_7__["MPlus"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_8__["MAccordionTransition"],
                _a)
        })
    ], MMenuItem);
    return MMenuItem;
}(BaseMenuItem));



/***/ }),

/***/ "./src/components/menu/menu.html":
/*!***************************************!*\
  !*** ./src/components/menu/menu.html ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-menu",
      class: [
        "m--is-skin-" + _vm.skin,
        { "m--is-open": _vm.propOpen, "m--is-disabled": _vm.propDisabled }
      ]
    },
    [
      _vm.$slots.trigger
        ? _c(
            "div",
            {
              ref: "buttonMenu",
              staticClass: "m-menu__trigger",
              class: { "m--is-disabled": _vm.propDisabled },
              attrs: {
                tabindex: _vm.propDisabled ? "-1" : "0",
                "aria-controls": _vm.idAriaControls,
                "aria-expanded": _vm.propOpen,
                "aria-haspopup": "true"
              },
              on: {
                click: _vm.toggleMenu,
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.toggleMenu($event)
                }
              }
            },
            [
              _c("m-plus", {
                staticClass: "m-menu__trigger__plus",
                attrs: {
                  large: true,
                  open: _vm.propOpen,
                  "title-open": _vm.titleMenuOpen,
                  "title-close": _vm.titleMenuClose,
                  skin: "current-color"
                }
              }),
              _vm._v(" "),
              _vm._t("trigger")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "m-accordion-transition",
        {
          ref: "transition",
          attrs: { disabled: !_vm.animReady || _vm.propDisabled },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.afterEnter,
            "enter-cancelled": _vm.enterCancelled,
            "before-leave": _vm.beforeLeave,
            leave: _vm.leave,
            "after-leave": _vm.afterLeave,
            "leave-cancelled": _vm.leaveCancelled
          }
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.propOpen,
                  expression: "propOpen"
                }
              ],
              ref: "menu",
              staticClass: "m-menu__body",
              attrs: {
                id: _vm.idAriaControls,
                "aria-hidden": !_vm.propOpen,
                role: "menu"
              }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-61026449'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/menu/menu.scss":
/*!***************************************!*\
  !*** ./src/components/menu/menu.scss ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/menu/menu.ts":
/*!*************************************!*\
  !*** ./src/components/menu/menu.ts ***!
  \*************************************/
/*! exports provided: BaseMenu, MMenuSkin, MMenu, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseMenu", function() { return BaseMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMenuSkin", function() { return MMenuSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMenu", function() { return MMenu; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _plus_plus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../plus/plus */ "./src/components/plus/plus.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _menu_item_menu_item__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./menu-item/menu-item */ "./src/components/menu/menu-item/menu-item.ts");
/* harmony import */ var _menu_html__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./menu.html */ "./src/components/menu/menu.html");
/* harmony import */ var _menu_html__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_menu_html__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _menu_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./menu.scss */ "./src/components/menu/menu.scss");
/* harmony import */ var _menu_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_menu_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var BaseMenu = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseMenu, _super);
    function BaseMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseMenu;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var MMenuSkin;
(function (MMenuSkin) {
    MMenuSkin["Light"] = "light";
    MMenuSkin["Dark"] = "dark";
})(MMenuSkin || (MMenuSkin = {}));
var MMenu = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMenu, _super);
    function MMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animReady = false;
        _this.closeOnSelectionInAction = false;
        _this.titleMenuOpen = _this.$i18n.translate('m-menu:open');
        _this.titleMenuClose = _this.$i18n.translate('m-menu:close');
        _this.internalValue = '';
        _this.internalOpen = false;
        _this.internalDisabled = false;
        _this.internalItems = [];
        return _this;
    }
    MMenu.prototype.onClick = function (event, value) { };
    MMenu.prototype.beforeEnter = function (event, value) { };
    MMenu.prototype.enter = function (event, value) { };
    MMenu.prototype.afterEnter = function (event, value) { };
    MMenu.prototype.enterCancelled = function (event, value) { };
    MMenu.prototype.beforeLeave = function (event, value) { };
    MMenu.prototype.leave = function (event, value) { };
    MMenu.prototype.afterLeave = function (event, value) { };
    MMenu.prototype.leaveCancelled = function (event, value) { };
    MMenu.prototype.updateValue = function (value) {
        this.model = value;
    };
    MMenu.prototype.onOpenChanged = function (open) {
        this.internalOpen = open;
    };
    MMenu.prototype.onDisabledChanged = function (disabled) {
        this.propDisabled = disabled;
    };
    MMenu.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.buildItemsMap();
            _this.menuObserver = new MutationObserver(function () { return _this.buildItemsMap(); });
            if (_this.$refs.menu) {
                _this.menuObserver.observe(_this.$refs.menu, { subtree: true, childList: true });
            }
        });
    };
    MMenu.prototype.beforeDestroy = function () {
        if (this.menuObserver) {
            this.menuObserver.disconnect();
        }
    };
    Object.defineProperty(MMenu.prototype, "propDisabled", {
        get: function () {
            return this.internalDisabled;
        },
        set: function (disabled) {
            this.internalDisabled = disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMenu.prototype, "propOpen", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            this.animReady = false;
            this.selectedItem();
            this.internalOpen = open;
            this.$emit('update:open', open);
            this.animReady = true;
        },
        enumerable: true,
        configurable: true
    });
    MMenu.prototype.toggleMenu = function (event) {
        if (!this.propDisabled) {
            this.propOpen = !this.propOpen;
            this.$refs.buttonMenu.blur();
            this.onClick(event, '');
        }
    };
    Object.defineProperty(MMenu.prototype, "model", {
        get: function () {
            return this.internalValue;
        },
        set: function (value) {
            var _this = this;
            if (!this.closeOnSelectionInAction) {
                this.internalValue = value;
                this.selectedItem();
                this.$emit('update:selected', value);
                if (this.closeOnSelection) {
                    this.closeOnSelectionInAction = true;
                    // Add a delay before closing the menu to display the selected item
                    setTimeout(function () {
                        _this.propOpen = false;
                        _this.closeOnSelectionInAction = false;
                    }, 600);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    MMenu.prototype.buildItemsMap = function () {
        var items = [];
        this.$refs.transition.$children.forEach(function (item) {
            if (item instanceof _menu_item_menu_item__WEBPACK_IMPORTED_MODULE_8__["MMenuItem"]) {
                items.push(item);
                if (item.group) {
                    item.getGroupItem().forEach(function (groupItem) {
                        groupItem.insideGroup = true;
                        items.push(groupItem);
                    });
                }
            }
        });
        this.internalItems = items;
    };
    MMenu.prototype.selectedItem = function () {
        var _this = this;
        if (this.internalItems) {
            this.internalItems.forEach(function (item) {
                if (!item.isDisabled) {
                    if (item.value === _this.model) {
                        item.selected = true;
                    }
                    else if (item.selected) {
                        item.selected = false;
                    }
                }
            });
            this.internalItems.forEach(function (item) {
                item.propOpen = false;
                if (!item.isDisabled && item.group) {
                    item.$children.forEach(function (itemGroup) {
                        itemGroup.$children.forEach(function (subItem) {
                            if (subItem.isUrl) {
                                subItem.selected = _this.isRouterLinkActive(subItem);
                            }
                            if (subItem.selected) {
                                item.propOpen = true;
                                item.selected = true;
                            }
                        });
                    });
                }
            });
        }
    };
    MMenu.prototype.isRouterLinkActive = function (menuItem) {
        return !!menuItem.$el.querySelector('.router-link-exact-active');
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenu.prototype, "selected", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenu.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MMenu.prototype, "closeOnSelection", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MMenuSkin.Dark,
            validator: function (value) {
                return value === MMenuSkin.Light ||
                    value === MMenuSkin.Dark;
            }
        })
    ], MMenu.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMenu.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: "mMenu-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate() + "-controls" })
    ], MMenu.prototype, "idAriaControls", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MMenu.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-enter')
    ], MMenu.prototype, "beforeEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter')
    ], MMenu.prototype, "enter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-enter')
    ], MMenu.prototype, "afterEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter-cancelled')
    ], MMenu.prototype, "enterCancelled", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-leave')
    ], MMenu.prototype, "beforeLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave')
    ], MMenu.prototype, "leave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-leave')
    ], MMenu.prototype, "afterLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave-cancelled')
    ], MMenu.prototype, "leaveCancelled", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('selected', { immediate: true })
    ], MMenu.prototype, "updateValue", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open', { immediate: true })
    ], MMenu.prototype, "onOpenChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('disabled', { immediate: true })
    ], MMenu.prototype, "onDisabledChanged", null);
    MMenu = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _menu_html__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["PLUS_NAME"]] = _plus_plus__WEBPACK_IMPORTED_MODULE_6__["MPlus"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__["MAccordionTransition"],
                _a)
        })
    ], MMenu);
    return MMenu;
}(BaseMenu));

var MenuPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["MENU_ITEM_NAME"], _menu_item_menu_item__WEBPACK_IMPORTED_MODULE_8__["MMenuItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["MENU_NAME"], MMenu);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MenuPlugin);


/***/ }),

/***/ "./src/components/message-page/message-page.html?style=./message-page.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/message-page/message-page.html?style=./message-page.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=163b32ee!./message-page.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=163b32ee!./src/components/message-page/message-page.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "m-message-page",
      class: {
        "m--is-state-confirmation": _vm.isStateConfirmation,
        "m--is-state-information": _vm.isStateInformation,
        "m--is-state-warning": _vm.isStateWarning,
        "m--is-state-error": _vm.isStateError,
        "m--is-skin-default": _vm.isSkinDefault,
        "m--is-skin-light": _vm.isSkinLight
      }
    },
    [
      _c("header", { staticClass: "m-message-page__header" }, [
        _vm.title
          ? _c("h2", {
              staticClass: "m-message-page__title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-message-page__icon-container",
            attrs: { "aria-hidden": "true" }
          },
          [
            _vm.svgName
              ? _c("m-svg", {
                  staticClass: "m-message-page__icon",
                  attrs: {
                    width: _vm.propImageSize,
                    height: _vm.propImageSize,
                    name: _vm.svgName
                  }
                })
              : _c("m-icon", {
                  staticClass: "m-message-page__icon",
                  attrs: { name: _vm.iconNameProp, size: _vm.propImageSize }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.hasBody
        ? _c(
            "div",
            { staticClass: "m-message-page__body" },
            [
              _vm._l(_vm.hints, function(hint) {
                return _vm.hasHints
                  ? _c(
                      "p",
                      {
                        ref: "hint",
                        refInFor: true,
                        staticClass: "m-message-page__hints",
                        class: { "m--no-content": !_vm.hasLinksAndSlot }
                      },
                      [_vm._v(_vm._s(hint))]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.$slots.default
                ? _c(
                    "div",
                    { staticClass: "m-message-page__details" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasLinks
                ? _c(
                    "ul",
                    { staticClass: "m-message-page__links" },
                    _vm._l(_vm.links, function(link) {
                      return _c(
                        "li",
                        { ref: "link", refInFor: true },
                        [
                          _c(
                            "m-link",
                            {
                              staticClass: "m-message-page__link",
                              attrs: {
                                "bullet-point": "true",
                                mode: "link",
                                url: link.url,
                                target: _vm.isTargetExternal(link.external)
                              }
                            },
                            [_vm._v(_vm._s(link.label))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-163b32ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/message-page/message-page.ts":
/*!*****************************************************!*\
  !*** ./src/components/message-page/message-page.ts ***!
  \*****************************************************/
/*! exports provided: Link, MMessagePageSkin, MMessagePageImageSize, MMessagePageState, MMessagePage, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessagePageSkin", function() { return MMessagePageSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessagePageImageSize", function() { return MMessagePageImageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessagePageState", function() { return MMessagePageState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessagePage", function() { return MMessagePage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modul_icons_modul_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/modul-icons/modul-icons */ "./src/utils/modul-icons/modul-icons.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _svg_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../svg/svg */ "./src/components/svg/svg.ts");
/* harmony import */ var _message_page_html_style_message_page_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./message-page.html?style=./message-page.scss */ "./src/components/message-page/message-page.html?style=./message-page.scss");
/* harmony import */ var _message_page_html_style_message_page_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_message_page_html_style_message_page_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










/**
 * Utility class to manage the properties related to the link displayed in the error pages.
 */
var Link = /** @class */ (function () {
    /**
     * Constructor
     * @param label Label for the url link to display.
     * @param url Target for the location to navigate to, can be relative.
     * @param external Defines to the target is external (opens in new tab), or internal (opens in same tab) to the application.
     */
    function Link(label, url, external) {
        if (external === void 0) { external = false; }
        this.label = label;
        this.url = url;
        this.external = external;
    }
    return Link;
}());

var MMessagePageSkin;
(function (MMessagePageSkin) {
    MMessagePageSkin["Default"] = "default";
    MMessagePageSkin["Light"] = "light";
})(MMessagePageSkin || (MMessagePageSkin = {}));
var MMessagePageImageSize;
(function (MMessagePageImageSize) {
    MMessagePageImageSize["Default"] = "130px";
    MMessagePageImageSize["Small"] = "76px";
})(MMessagePageImageSize || (MMessagePageImageSize = {}));
var MMessagePageState;
(function (MMessagePageState) {
    MMessagePageState["Information"] = "information";
    MMessagePageState["Warning"] = "warning";
    MMessagePageState["Confirmation"] = "confirmation";
    MMessagePageState["Error"] = "error";
})(MMessagePageState || (MMessagePageState = {}));
var MMessagePage = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMessagePage, _super);
    function MMessagePage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MMessagePage.prototype, "hasHints", {
        get: function () {
            return this.hints.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "hasLinks", {
        get: function () {
            return this.links.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "propImageSize", {
        get: function () {
            if (this.imageSize) {
                return this.imageSize;
            }
            return this.isSkinLight ? MMessagePageImageSize.Small : MMessagePageImageSize.Default;
        },
        enumerable: true,
        configurable: true
    });
    MMessagePage.prototype.isTargetExternal = function (isExternal) {
        return isExternal ? '_blank' : '';
    };
    Object.defineProperty(MMessagePage.prototype, "hasLinksAndSlot", {
        get: function () {
            return this.hasLinks || !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "hasBody", {
        get: function () {
            return this.hasHints || this.hasLinks || !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isSkinDefault", {
        get: function () {
            return this.skin === MMessagePageSkin.Default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isSkinLight", {
        get: function () {
            return this.skin === MMessagePageSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isStateInformation", {
        get: function () {
            return this.state === MMessagePageState.Information;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isStateWarning", {
        get: function () {
            return this.state === MMessagePageState.Warning;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isStateError", {
        get: function () {
            return this.state === MMessagePageState.Error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "isStateConfirmation", {
        get: function () {
            return this.state === MMessagePageState.Confirmation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessagePage.prototype, "iconNameProp", {
        get: function () {
            if (this.iconName) {
                return this.iconName;
            }
            else {
                switch (this.state) {
                    case MMessagePageState.Confirmation:
                        return _utils_modul_icons_modul_icons__WEBPACK_IMPORTED_MODULE_3__["ModulIconName"].ConfirmationWhiteFilled;
                    case MMessagePageState.Information:
                        return _utils_modul_icons_modul_icons__WEBPACK_IMPORTED_MODULE_3__["ModulIconName"].InformationWhiteFilled;
                    case MMessagePageState.Warning:
                        return _utils_modul_icons_modul_icons__WEBPACK_IMPORTED_MODULE_3__["ModulIconName"].WarningWhiteFilled;
                    default:
                        return _utils_modul_icons_modul_icons__WEBPACK_IMPORTED_MODULE_3__["ModulIconName"].ErrorWhiteFilled;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 'error',
            validator: function (value) {
                return value === MMessagePageState.Information ||
                    value === MMessagePageState.Warning ||
                    value === MMessagePageState.Confirmation ||
                    value === MMessagePageState.Error;
            }
        })
    ], MMessagePage.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MMessagePageSkin.Default,
            validator: function (value) {
                return value === MMessagePageSkin.Default ||
                    value === MMessagePageSkin.Light;
            }
        })
    ], MMessagePage.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMessagePage.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({})
    ], MMessagePage.prototype, "svgName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMessagePage.prototype, "imageSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMessagePage.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MMessagePage.prototype, "hints", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MMessagePage.prototype, "links", void 0);
    MMessagePage = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _message_page_html_style_message_page_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_7__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["SVG_NAME"]] = _svg_svg__WEBPACK_IMPORTED_MODULE_8__["MSvg"],
                _a)
        })
    ], MMessagePage);
    return MMessagePage;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var MessagePagePlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["MESSAGE_PAGE_NAME"], MMessagePage);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MessagePagePlugin);


/***/ }),

/***/ "./src/components/message/message.html?style=./message.scss":
/*!******************************************************************!*\
  !*** ./src/components/message/message.html?style=./message.scss ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c5519!./message.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=056c5519!./src/components/message/message.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.propVisible
    ? _c(
        "div",
        {
          staticClass: "m-message",
          class: {
            "m--is-state-confirmation": _vm.isStateConfirmation,
            "m--is-state-information": _vm.isStateInformation,
            "m--is-state-warning": _vm.isStateWarning,
            "m--is-state-error": _vm.isStateError,
            "m--is-skin-default": _vm.isSkinDefault,
            "m--is-skin-light": _vm.isSkinLight,
            "m--is-skin-page": _vm.isSkinPage,
            "m--is-skin-page-light": _vm.isSkinPageLight
          }
        },
        [
          _vm.isNotSkinPage
            ? _c(
                "div",
                { staticClass: "m-message__wrap" },
                [
                  _vm.icon
                    ? _c(
                        "div",
                        { staticClass: "m-message__icon" },
                        [
                          _c("m-icon", {
                            attrs: { name: _vm.getIcon(), size: "1em" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "m-message__body",
                      class: { "m--has-close-button": _vm.closeButton }
                    },
                    [
                      _vm.title
                        ? _c("h2", { staticClass: "m-message__title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$slots.default
                        ? _c(
                            "div",
                            { staticClass: "m-message__text" },
                            [_vm._t("default")],
                            2
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showCloseButton
                    ? _c(
                        "m-icon-button",
                        {
                          staticClass: "m-message__body__close-button",
                          attrs: {
                            "icon-name": "m-svg__close-clear",
                            "icon-size": "10px"
                          },
                          on: { click: _vm.onClose }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("f-m-i18n")("m-message:close")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "m-message-page",
                {
                  staticClass: "m-message__page",
                  attrs: {
                    state: _vm.state,
                    skin: _vm.skinPageValue,
                    title: _vm.title
                  }
                },
                [_vm._t("default")],
                2
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-056c5519'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/message/message.ts":
/*!*******************************************!*\
  !*** ./src/components/message/message.ts ***!
  \*******************************************/
/*! exports provided: MMessageState, MMessageSkin, MMessage, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessageState", function() { return MMessageState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessageSkin", function() { return MMessageSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMessage", function() { return MMessage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _message_page_message_page__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony import */ var _message_html_style_message_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./message.html?style=./message.scss */ "./src/components/message/message.html?style=./message.scss");
/* harmony import */ var _message_html_style_message_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_message_html_style_message_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a, _b;











var MMessageState;
(function (MMessageState) {
    MMessageState["Confirmation"] = "confirmation";
    MMessageState["Information"] = "information";
    MMessageState["Warning"] = "warning";
    MMessageState["Error"] = "error";
})(MMessageState || (MMessageState = {}));
var MMessageSkin;
(function (MMessageSkin) {
    MMessageSkin["Default"] = "default";
    MMessageSkin["Light"] = "light";
    MMessageSkin["PageLight"] = "page-light";
    MMessageSkin["Page"] = "page";
})(MMessageSkin || (MMessageSkin = {}));
var MMessage = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMessage, _super);
    function MMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalVisible = true;
        _this.animReady = false;
        return _this;
    }
    MMessage.prototype.onClose = function (event) {
        this.propVisible = false;
    };
    MMessage.prototype.mounted = function () {
        var _this = this;
        this.propVisible = this.visible;
        setTimeout(function () {
            _this.animReady = true;
        });
    };
    MMessage.prototype.onVisibleChange = function (value) {
        this.propVisible = value;
    };
    Object.defineProperty(MMessage.prototype, "propVisible", {
        get: function () {
            return this.internalVisible;
        },
        set: function (visible) {
            this.internalVisible = visible === undefined ? true : visible;
            this.$emit('update:visible', this.internalVisible);
        },
        enumerable: true,
        configurable: true
    });
    MMessage.prototype.getIcon = function () {
        var icon = '';
        switch (this.state) {
            case MMessageState.Confirmation:
                icon = 'm-svg__confirmation';
                break;
            case MMessageState.Information:
                icon = 'm-svg__information';
                break;
            case MMessageState.Warning:
                icon = 'm-svg__warning';
                break;
            case MMessageState.Error:
                icon = 'm-svg__error';
                break;
            default:
                break;
        }
        return icon;
    };
    Object.defineProperty(MMessage.prototype, "isSkinDefault", {
        get: function () {
            return this.skin === MMessageSkin.Default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isSkinLight", {
        get: function () {
            return this.skin === MMessageSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isNotSkinPage", {
        get: function () {
            return !this.isSkinPage && !this.isSkinPageLight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "skinPageValue", {
        get: function () {
            return this.isSkinPage ? _message_page_message_page__WEBPACK_IMPORTED_MODULE_9__["MMessagePageSkin"].Default : _message_page_message_page__WEBPACK_IMPORTED_MODULE_9__["MMessagePageSkin"].Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isSkinPage", {
        get: function () {
            return this.skin === MMessageSkin.Page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isSkinPageLight", {
        get: function () {
            return this.skin === MMessageSkin.PageLight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isStateInformation", {
        get: function () {
            return this.state === MMessageState.Information;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isStateWarning", {
        get: function () {
            return this.state === MMessageState.Warning;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isStateError", {
        get: function () {
            return this.state === MMessageState.Error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "isStateConfirmation", {
        get: function () {
            return this.state === MMessageState.Confirmation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMessage.prototype, "showCloseButton", {
        get: function () {
            return this.skin === MMessageSkin.Default && this.closeButton;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MMessageState.Confirmation,
            validator: function (value) {
                return value === MMessageState.Confirmation ||
                    value === MMessageState.Information ||
                    value === MMessageState.Warning ||
                    value === MMessageState.Error;
            }
        })
    ], MMessage.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MMessageSkin.Default,
            validator: function (value) {
                return value === MMessageSkin.Default ||
                    value === MMessageSkin.Light ||
                    value === MMessageSkin.PageLight ||
                    value === MMessageSkin.Page;
            }
        })
    ], MMessage.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MMessage.prototype, "icon", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MMessage.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MMessage.prototype, "closeButton", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MMessage.prototype, "visible", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('close')
    ], MMessage.prototype, "onClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Watch"])('visible')
    ], MMessage.prototype, "onVisibleChange", null);
    MMessage = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _message_html_style_message_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_8__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["MESSAGE_PAGE_NAME"]] = _message_page_message_page__WEBPACK_IMPORTED_MODULE_9__["MMessagePage"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_4__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_5__["i18nFilter"],
                _b)
        })
    ], MMessage);
    return MMessage;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var MessagePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["MESSAGE_NAME"], MMessage);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MessagePlugin);


/***/ }),

/***/ "./src/components/modal/modal.html":
/*!*****************************************!*\
  !*** ./src/components/modal/modal.html ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "baseWindow", staticClass: "m-modal" },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      _vm.portalCreated
        ? _c(
            "portal",
            { attrs: { "target-el": _vm.portalTargetSelector } },
            [
              _c("transition", { attrs: { name: "m--is" } }, [
                _vm.portalMounted
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propOpen,
                            expression: "propOpen"
                          }
                        ],
                        ref: "modalWrap",
                        staticClass: "m-modal__wrap",
                        class: [
                          {
                            "m--is-small": _vm.sizeSmall,
                            "m--is-large": _vm.sizeLarge,
                            "m--is-full-screen": _vm.sizeFullSceen,
                            "m--has-body-max-width": _vm.bodyMaxWidth,
                            "m--is-close-on-backdrop": _vm.closeOnBackdrop,
                            "m--is-disabled": _vm.disabled
                          },
                          _vm.className
                        ],
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.backdropClick()
                          }
                        }
                      },
                      [
                        _c(
                          "article",
                          { ref: "article", staticClass: "m-modal__article" },
                          [
                            _c(
                              "header",
                              { staticClass: "m-modal__header" },
                              [
                                _vm.title
                                  ? _c("h2", [_vm._v(_vm._s(_vm.title))])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._t("header"),
                                _vm._v(" "),
                                _vm._t("header-bouton", [
                                  _c("m-icon-button", {
                                    staticClass: "m-modal__close-button",
                                    attrs: {
                                      "icon-name": "m-svg__close-clear",
                                      skin: "dark",
                                      title: _vm.closeTitle
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeModal()
                                      }
                                    }
                                  })
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "body",
                                staticClass: "m-modal__body",
                                class: { "m--is-android": _vm.hasKeyboard }
                              },
                              [
                                _vm.$slots.default
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "m-modal__content",
                                        class: {
                                          "m--has-no-padding": !_vm.paddingBody
                                        },
                                        on: {
                                          focusin: _vm.onFocusIn,
                                          focusout: _vm.onFocusOut
                                        }
                                      },
                                      [_vm._t("default")],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasKeyboard && _vm.$slots.footer
                                  ? _c(
                                      "footer",
                                      { staticClass: "m-modal__footer" },
                                      [_vm._t("footer")],
                                      2
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.hasKeyboard && _vm.$slots.footer
                              ? _c(
                                  "footer",
                                  { staticClass: "m-modal__footer" },
                                  [_vm._t("footer")],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-49f00566'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/modal/modal.scss":
/*!*****************************************!*\
  !*** ./src/components/modal/modal.scss ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/modal/modal.ts":
/*!***************************************!*\
  !*** ./src/components/modal/modal.ts ***!
  \***************************************/
/*! exports provided: MModalSize, MModal, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MModalSize", function() { return MModalSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MModal", function() { return MModal; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/user-agent/user-agent */ "./src/utils/user-agent/user-agent.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _modal_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modal.html */ "./src/components/modal/modal.html");
/* harmony import */ var _modal_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modal_html__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modal_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modal.scss */ "./src/components/modal/modal.scss");
/* harmony import */ var _modal_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modal_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MModalSize;
(function (MModalSize) {
    MModalSize["FullScreen"] = "full-screen";
    MModalSize["Large"] = "large";
    MModalSize["Regular"] = "regular";
    MModalSize["Small"] = "small";
})(MModalSize || (MModalSize = {}));
var MModal = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MModal, _super);
    function MModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasKeyboard = false;
        _this.closeTitle = _this.$i18n.translate('m-modal:close');
        return _this;
    }
    MModal.prototype.closeModal = function () {
        this.as().tryClose();
    };
    MModal.prototype.handlesFocus = function () {
        return this.focusManagement;
    };
    MModal.prototype.doCustomPropOpen = function (value) {
        return false;
    };
    MModal.prototype.getBackdropMode = function () {
        return this.sizeFullSceen
            ? _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["BackdropMode"].ScrollOnly
            : _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["BackdropMode"].BackdropFast;
    };
    Object.defineProperty(MModal.prototype, "sizeFullSceen", {
        get: function () {
            var fullScreen = !this.as().isMqMinS
                ? true
                : this.size === MModalSize.FullScreen
                    ? true
                    : false;
            this.as().transitionDuration = fullScreen
                ? _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["PortalTransitionDuration"].XSlow
                : _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["PortalTransitionDuration"].Regular;
            return fullScreen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MModal.prototype, "sizeLarge", {
        get: function () {
            return (this.as().isMqMinS && this.size === MModalSize.Large);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MModal.prototype, "sizeSmall", {
        get: function () {
            return (this.as().isMqMinS && this.size === MModalSize.Small);
        },
        enumerable: true,
        configurable: true
    });
    MModal.prototype.getPortalElement = function () {
        return this.$refs.article;
    };
    MModal.prototype.mounted = function () {
        if (!this.title && !Boolean(this.$slots.header)) {
            this.$log.warn('<m-modal> needs a header slot or title prop.');
        }
    };
    MModal.prototype.backdropClick = function () {
        if (this.closeOnBackdrop) {
            this.as().tryClose();
        }
    };
    Object.defineProperty(MModal.prototype, "isAndroid", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_4__["default"].isAndroid();
        },
        enumerable: true,
        configurable: true
    });
    MModal.prototype.onFocusIn = function () {
        if (this.isAndroid) {
            this.hasKeyboard = true;
        }
    };
    MModal.prototype.onFocusOut = function () {
        var _this = this;
        if (!this.isAndroid) {
            return;
        }
        setTimeout(function () {
            _this.hasKeyboard = false;
        });
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MModalSize.Regular,
            validator: function (value) {
                return value === MModalSize.Regular ||
                    value === MModalSize.FullScreen ||
                    value === MModalSize.Large ||
                    value === MModalSize.Small;
            }
        })
    ], MModal.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MModal.prototype, "closeOnBackdrop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MModal.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MModal.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MModal.prototype, "bodyMaxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MModal.prototype, "paddingBody", void 0);
    MModal = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _modal_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButton"],
                _a),
            mixins: [_mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["Portal"]]
        })
    ], MModal);
    return MModal;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var ModalPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["MODAL_NAME"], MModal);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ModalPlugin);


/***/ }),

/***/ "./src/components/moneyfield/moneyfield.html?style=./moneyfield.scss":
/*!***************************************************************************!*\
  !*** ./src/components/moneyfield/moneyfield.html?style=./moneyfield.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2a89eca9!./moneyfield.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2a89eca9!./src/components/moneyfield/moneyfield.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-moneyfield",
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
    },
    [
      _c(
        "m-decimalfield",
        _vm._g(
          _vm._b(
            {
              attrs: { "force-rounding-format": true, precision: _vm.precision }
            },
            "m-decimalfield",
            _vm.bindData,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.currencyDetail.symbolPosition === "before"
            ? _c("template", { slot: "prefix" }, [
                _c("span", { staticClass: "m-moneyfield__currency-symbol" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.currencyDetail.localizedSymbol) +
                      "\n            "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currencyDetail.symbolPosition === "after"
            ? _c("template", { slot: "suffix" }, [
                _c("span", { staticClass: "m-moneyfield__currency-symbol" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.currencyDetail.localizedSymbol) +
                      "\n            "
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-2a89eca9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/moneyfield/moneyfield.ts":
/*!*************************************************!*\
  !*** ./src/components/moneyfield/moneyfield.ts ***!
  \*************************************************/
/*! exports provided: MMoneyfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMoneyfield", function() { return MMoneyfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/l10n/l10n */ "./src/utils/l10n/l10n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../decimalfield/decimalfield */ "./src/components/decimalfield/decimalfield.ts");
/* harmony import */ var _moneyfield_html_style_moneyfield_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./moneyfield.html?style=./moneyfield.scss */ "./src/components/moneyfield/moneyfield.html?style=./moneyfield.scss");
/* harmony import */ var _moneyfield_html_style_moneyfield_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_moneyfield_html_style_moneyfield_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












// TODO: Everything here is dispensable.  This will be all replaced by a wrapper of decimal-field.
var MMoneyfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMoneyfield, _super);
    function MMoneyfield() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MMoneyfield.prototype, "currencyDetail", {
        get: function () {
            return this.$l10n.getCurrencyDetail(this.currentLocale);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMoneyfield.prototype, "currentLocale", {
        get: function () {
            return this.$i18n.currentLocale;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMoneyfield.prototype, "bindData", {
        get: function () {
            return Object.assign({}, this.$props || {}, this.$attrs || {});
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMoneyfield.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputMaxWidth"].Small })
    ], MMoneyfield.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 11
        })
    ], MMoneyfield.prototype, "precision", void 0);
    MMoneyfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _moneyfield_html_style_moneyfield_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            inheritAttrs: false,
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["DECIMALFIELD_NAME"]] = _decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_10__["MDecimalfield"],
                _a),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ]
        })
    ], MMoneyfield);
    return MMoneyfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var MoneyFieldPlugin = {
    install: function (v) {
        v.use(_utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_7__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["MONEYFIELD_NAME"], MMoneyfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MoneyFieldPlugin);


/***/ }),

/***/ "./src/components/multi-select/multi-select.html?style=./multi-select.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/multi-select/multi-select.html?style=./multi-select.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=37de12a9!./multi-select.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=37de12a9!./src/components/multi-select/multi-select.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("m-base-select", {
    ref: "baseSelect",
    attrs: {
      "control-id": _vm.id,
      active: _vm.active,
      items: _vm.options,
      "selected-items": _vm.selectedItems,
      open: _vm.open,
      "input-max-width": _vm.inputMaxWidth,
      "close-on-select": false,
      "hide-radio-button-mobile": true,
      "enable-animation": !_vm.linkSelectAll,
      width: _vm.width,
      "max-width": _vm.maxWidth
    },
    on: {
      "update:open": function($event) {
        _vm.open = $event
      },
      "select-item": _vm.onSelect
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(scope) {
            return [
              _c(
                "div",
                {
                  staticClass: "m-multi-select",
                  class: {
                    "m--is-open": _vm.open,
                    "m--is-disabled": _vm.isDisabled,
                    "m--is-waiting": _vm.isWaiting
                  },
                  style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
                  attrs: { tabindex: "0" },
                  on: {
                    focus: _vm.onFocus,
                    blur: _vm.onBlur,
                    click: _vm.toggle,
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp"
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onKeydownUp($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown"
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onKeydownDown($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onKeydownEnter($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "return",
                            undefined,
                            $event.key,
                            undefined
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onKeydownEnter($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        return scope.keyEsc($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        return scope.keyTab($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onKeydownSpace($event)
                      }
                    ]
                  }
                },
                [
                  _c(
                    "m-input-style",
                    {
                      attrs: {
                        label: _vm.label,
                        "label-for": _vm.id,
                        disabled: _vm.isDisabled,
                        waiting: _vm.isWaiting,
                        focus: _vm.internalIsFocus,
                        "label-up": _vm.labelUp,
                        empty: _vm.isEmpty,
                        error: _vm.hasError,
                        "cursor-pointer": true,
                        valid: _vm.isValid,
                        "required-marker": _vm.requiredMarker,
                        "tag-style": _vm.tagStyle
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "m-multi-select__chips" },
                        [
                          _vm.numberOfItemsSelected === 0
                            ? [
                                _c("input", {
                                  attrs: {
                                    placeholder: _vm.placeholder,
                                    type: "text",
                                    readonly: ""
                                  }
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chipsDisplayMode === 1
                            ? [
                                _c("m-chip-delete", {
                                  staticClass: "m-multi-select__chip",
                                  attrs: { size: "small" },
                                  on: {
                                    delete: function($event) {
                                      return _vm.onDeleteAll()
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function() {
                                          return [
                                            _vm._t("chips-all", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.textNumberOfSelectedItems
                                                  ) +
                                                  "\n                                "
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            : _vm.chipsDisplayMode === 0
                            ? [
                                _vm._l(
                                  _vm.internalValue.slice(
                                    0,
                                    _vm.maxVisibleChips
                                  ),
                                  function(item, index) {
                                    return _c("m-chip-delete", {
                                      key: index,
                                      staticClass: "m-multi-select__chip",
                                      attrs: { size: "small" },
                                      on: {
                                        delete: function($event) {
                                          return _vm.onDelete(index)
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function() {
                                              return [
                                                _vm._t(
                                                  "chips",
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.getChipLabel(item)
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ],
                                                  { item: item, index: index }
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "m-multi-select__more" },
                                  [
                                    _vm._t("more", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.textNumberOfUnselectedItemsLeft
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ]
                            : _vm.chipsDisplayMode === -1
                            ? _vm._l(_vm.internalValue, function(item, index) {
                                return _c("m-chip-delete", {
                                  key: index,
                                  staticClass: "m-multi-select__chip",
                                  attrs: { size: "small" },
                                  on: {
                                    delete: function($event) {
                                      return _vm.onDelete(index)
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function() {
                                          return [
                                            _vm._t(
                                              "chips",
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.getChipLabel(item)
                                                    ) +
                                                    "\n                                "
                                                )
                                              ],
                                              { item: item, index: index }
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              })
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.active
                        ? _c(
                            "div",
                            {
                              staticClass: "m-multi-select__arrow",
                              class: { "m--is-open": _vm.open },
                              attrs: { slot: "suffix" },
                              slot: "suffix"
                            },
                            [
                              _c(
                                "m-icon",
                                {
                                  ref: "arrow",
                                  staticClass: "m-multi-select__arrow__icon",
                                  attrs: {
                                    name: "m-svg__arrow-head-filled--down",
                                    size: "16px",
                                    disabled: !_vm.active
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      _vm.open = _vm.active
                                    }
                                  }
                                },
                                [
                                  !_vm.open
                                    ? _c("m-i18n", {
                                        attrs: { k: "m-multi-select:open" }
                                      })
                                    : _c("m-i18n", {
                                        attrs: { k: "m-multi-select:close" }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ]
          }
        },
        {
          key: "validation-message",
          fn: function() {
            return [
              _c("m-validation-message", {
                staticClass: "m-multi-select__validation-message",
                class: {
                  "m--has-validation-message": _vm.hasValidationMessage
                },
                attrs: {
                  disabled: _vm.isDisabled,
                  waiting: _vm.isWaiting,
                  error: _vm.hasError,
                  valid: _vm.isValid,
                  "error-message": _vm.errorMessage,
                  "valid-message": _vm.validMessage,
                  "helper-message": _vm.helperMessage
                }
              })
            ]
          },
          proxy: true
        },
        _vm.linkSelectAll
          ? {
              key: "popup-header",
              fn: function() {
                return [
                  _c(
                    "m-select-item",
                    {
                      staticClass: "m-multi-select__popup-header",
                      attrs: {
                        focused: _vm.selectAllFocused,
                        "hide-radio-button-mobile": true
                      },
                      on: { click: _vm.onToggleAll }
                    },
                    [
                      !_vm.allSelected
                        ? _c("m-i18n", {
                            attrs: { k: "m-multi-select:link-select-all" }
                          })
                        : _c("m-i18n", {
                            attrs: { k: "m-multi-select:link-deselect-all" }
                          })
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "items",
          fn: function(ref) {
            var item = ref.item
            var index = ref.index
            return [
              _vm._t(
                "items",
                [_c("span", { domProps: { innerHTML: _vm._s(item) } })],
                { item: item, index: index }
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-37de12a9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/multi-select/multi-select.ts":
/*!*****************************************************!*\
  !*** ./src/components/multi-select/multi-select.ts ***!
  \*****************************************************/
/*! exports provided: MMultiSelect, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MMultiSelect", function() { return MMultiSelect; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _chip_chip_delete_chip_delete__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./../chip/chip-delete/chip-delete */ "./src/components/chip/chip-delete/chip-delete.ts");
/* harmony import */ var _select_base_select_base_select__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./../select/base-select/base-select */ "./src/components/select/base-select/base-select.ts");
/* harmony import */ var _select_select_item_select_item__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./../select/select-item/select-item */ "./src/components/select/select-item/select-item.ts");
/* harmony import */ var _multi_select_html_style_multi_select_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./multi-select.html?style=./multi-select.scss */ "./src/components/multi-select/multi-select.html?style=./multi-select.scss");
/* harmony import */ var _multi_select_html_style_multi_select_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_multi_select_html_style_multi_select_scss__WEBPACK_IMPORTED_MODULE_18__);
var _a;



















var MMultiSelect = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MMultiSelect, _super);
    function MMultiSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = _component_names__WEBPACK_IMPORTED_MODULE_10__["MULTI_SELECT_NAME"] + "-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_8__["default"].generate();
        _this.internalValue = [];
        _this.internalIsFocus = false;
        _this.selectAllFocused = false;
        _this.open = false;
        return _this;
    }
    MMultiSelect.prototype.created = function () {
        if (!Array.isArray(this.value)) {
            this.$log.error('MMultiSelect - The model must be an array');
        }
    };
    MMultiSelect.prototype.mounted = function () {
        if (this.focus) {
            this.focusChanged(this.focus);
        }
    };
    Object.defineProperty(MMultiSelect.prototype, "model", {
        get: function () {
            return this.internalValue;
        },
        set: function (value) {
            this.internalValue = value;
            this.$emit('input', this.internalValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "selectedItems", {
        get: function () {
            if (this.value) {
                return this.value;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "numberOfItemsSelected", {
        get: function () {
            return this.selectedItems.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "isEmpty", {
        get: function () {
            return this.hasValue || (this.open) ? false : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "hasValue", {
        get: function () {
            return !!(this.model && this.model.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "allSelected", {
        get: function () {
            return this.options && this.options.length > 0 && this.options.length === this.value.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "chipsDisplayMode", {
        get: function () {
            if (this.allSelected) {
                return 1;
            }
            else if (this.numberOfItemsSelected > this.maxVisibleChips) {
                return 0;
            }
            return -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "textNumberOfSelectedItems", {
        get: function () {
            return this.$i18n.translate('m-multi-select:all-selected', [this.numberOfItemsSelected], undefined, undefined, false, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["FormatMode"].Default);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MMultiSelect.prototype, "textNumberOfUnselectedItemsLeft", {
        get: function () {
            return this.$i18n.translate('m-multi-select:more', [this.numberOfItemsSelected - this.maxVisibleChips], undefined, undefined, false, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["FormatMode"].Default);
        },
        enumerable: true,
        configurable: true
    });
    MMultiSelect.prototype.toggle = function () {
        this.selectAllFocused = false;
        this.$refs.baseSelect.togglePopup();
    };
    MMultiSelect.prototype.onSelect = function (option, index, $event) {
        var positionInModel = this.model.indexOf(option);
        if (positionInModel === -1) {
            this.model = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.model, [(this.options[index])]);
        }
        else {
            this.onDelete(positionInModel);
        }
        this.$refs.baseSelect.update();
        if ($event.type === 'click') {
            this.$refs.baseSelect.focusedIndex = -1;
        }
    };
    MMultiSelect.prototype.onDelete = function (index) {
        this.model = this.model.slice(0, index).concat(this.model.slice(index + 1));
        this.$refs.baseSelect.update();
    };
    MMultiSelect.prototype.onDeleteAll = function () {
        this.model = [];
        this.$refs.baseSelect.update();
    };
    MMultiSelect.prototype.onFocus = function ($event) {
        this.internalIsFocus = this.as().active;
        if (this.internalIsFocus) {
            this.$emit('focus', $event);
        }
    };
    MMultiSelect.prototype.onBlur = function ($event) {
        this.internalIsFocus = false;
    };
    MMultiSelect.prototype.onKeydownDown = function ($event) {
        if (this.options) {
            if (this.$refs.baseSelect.focusedIndex === this.options.length - 1 && this.linkSelectAll) {
                this.$refs.baseSelect.focusedIndex = -1;
                this.selectAllFocused = true;
            }
            else {
                this.selectAllFocused = false;
                this.$refs.baseSelect.focusNextItem();
            }
        }
    };
    MMultiSelect.prototype.onKeydownUp = function ($event) {
        if (this.options) {
            if (this.$refs.baseSelect.focusedIndex === 0 && this.linkSelectAll) {
                this.$refs.baseSelect.focusedIndex = -1;
                this.selectAllFocused = true;
            }
            else {
                this.selectAllFocused = false;
                this.$refs.baseSelect.focusPreviousItem();
            }
        }
    };
    MMultiSelect.prototype.onKeydownEnter = function ($event) {
        if (this.options) {
            if (this.$refs.baseSelect.focusedIndex > -1) {
                this.$refs.baseSelect.select(this.$refs.baseSelect.items[this.$refs.baseSelect.focusedIndex], this.$refs.baseSelect.focusedIndex, $event);
            }
            else if (this.selectAllFocused) {
                this.onToggleAll();
            }
        }
    };
    MMultiSelect.prototype.onKeydownSpace = function ($event) {
        if (this.options) {
            this.selectAllFocused = false;
            this.$refs.baseSelect.onKeydownSpace($event);
        }
    };
    MMultiSelect.prototype.onToggleAll = function () {
        if (this.allSelected) {
            this.model = [];
        }
        else {
            this.model = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.options);
        }
    };
    MMultiSelect.prototype.getChipLabel = function (item) {
        var ellipsis = item.toString().length > this.defaultChipCharsTrunk ? '...' : '';
        return "" + item.toString().substring(0, this.defaultChipCharsTrunk) + ellipsis;
    };
    MMultiSelect.prototype.onValueChange = function (value) {
        this.internalValue = this.value;
    };
    MMultiSelect.prototype.focusChanged = function (focus) {
        this.internalIsFocus = focus && this.as().active;
        var inputEl = this.as().getInput();
        if (inputEl) {
            if (this.internalIsFocus) {
                inputEl.focus();
            }
            else {
                inputEl.blur();
            }
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('input'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            validator: function (value) { return Array.isArray(value); }
        })
    ], MMultiSelect.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            validator: function (value) { return Array.isArray(value); }
        })
    ], MMultiSelect.prototype, "options", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMultiSelect.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MMultiSelect.prototype, "linkSelectAll", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 5
        })
    ], MMultiSelect.prototype, "maxVisibleChips", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 12
        })
    ], MMultiSelect.prototype, "defaultChipCharsTrunk", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MMultiSelect.prototype, "placeholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('select-item')
    ], MMultiSelect.prototype, "onSelect", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('blur')
    ], MMultiSelect.prototype, "onBlur", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], MMultiSelect.prototype, "onValueChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('focus')
    ], MMultiSelect.prototype, "focusChanged", null);
    MMultiSelect = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _multi_select_html_style_multi_select_scss__WEBPACK_IMPORTED_MODULE_18___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {
                    MBaseSelect: _select_base_select_base_select__WEBPACK_IMPORTED_MODULE_16__["MBaseSelect"],
                    MSelectItem: _select_select_item_select_item__WEBPACK_IMPORTED_MODULE_17__["MSelectItem"],
                    MChipDelete: _chip_chip_delete_chip_delete__WEBPACK_IMPORTED_MODULE_15__["default"]
                },
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_11__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_14__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_12__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_13__["MInputStyle"],
                _a),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_4__["InputState"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_6__["MediaQueries"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_5__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"]
            ]
        })
    ], MMultiSelect);
    return MMultiSelect;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_9__["ModulVue"]));

var MultiSelectPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_10__["MULTI_SELECT_NAME"], MMultiSelect);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MultiSelectPlugin);


/***/ }),

/***/ "./src/components/navbar/navbar-item/navbar-item-helper.ts":
/*!*****************************************************************!*\
  !*** ./src/components/navbar/navbar-item/navbar-item-helper.ts ***!
  \*****************************************************************/
/*! exports provided: NavbarItemHelper, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarItemHelper", function() { return NavbarItemHelper; });
var NavbarItemHelper = /** @class */ (function () {
    function NavbarItemHelper() {
    }
    NavbarItemHelper.prototype.isRouterLinkActive = function (navbarItem) {
        return !!navbarItem.$el.querySelector('.router-link-active');
    };
    return NavbarItemHelper;
}());

/* harmony default export */ __webpack_exports__["default"] = (new NavbarItemHelper());


/***/ }),

/***/ "./src/components/navbar/navbar-item/navbar-item.html?style=./navbar-item.scss":
/*!*************************************************************************************!*\
  !*** ./src/components/navbar/navbar-item/navbar-item.html?style=./navbar-item.scss ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=59e37688!./navbar-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=59e37688!./src/components/navbar/navbar-item/navbar-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-navbar-item",
      class: {
        "m--is-selected": _vm.isSelected,
        "m--is-disabled": _vm.disabled
      },
      attrs: { role: "none" },
      on: {
        click: _vm.onClick,
        mouseover: _vm.onMouseover,
        mouseleave: _vm.onMouseleave
      }
    },
    [
      _c(
        _vm.isRouterLink ? "router-link" : "div",
        {
          ref: "item",
          tag: "component",
          staticClass: "m-navbar-item__contents",
          attrs: {
            to: _vm.isRouterLink ? _vm.url : undefined,
            tabindex: _vm.url || _vm.disabled ? undefined : "0",
            role: "menuitem",
            "aria-selected": _vm.isSelected,
            "aria-haspopup": _vm.ariaHaspopup,
            "aria-expanded": _vm.ariaExpanded,
            "aria-controls": _vm.ariaControls
          },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onClick($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "m-navbar-item__text",
              class: { "m--is-nowrap": _vm.shouldNotWrap }
            },
            [
              _vm.$slots.leftContain
                ? _c(
                    "div",
                    { staticClass: "m-navbar-item__text-left-contain" },
                    [_vm._t("leftContain")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formatedLabel
                ? _c("span", {
                    ref: "itemValue",
                    domProps: { innerHTML: _vm._s(_vm.formatedLabel) }
                  })
                : _vm.$slots.default
                ? _c("div", [_vm._t("default", [_vm._v(_vm._s(_vm.value))])], 2)
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.rightContain
                ? _c(
                    "div",
                    { staticClass: "m-navbar-item__text-right-contain" },
                    [_vm._t("rightContain")],
                    2
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-59e37688'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/navbar/navbar-item/navbar-item.ts":
/*!**********************************************************!*\
  !*** ./src/components/navbar/navbar-item/navbar-item.ts ***!
  \**********************************************************/
/*! exports provided: MNavbarItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MNavbarItem", function() { return MNavbarItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _navbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../navbar */ "./src/components/navbar/navbar.ts");
/* harmony import */ var _navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../navbar-unscoped.scss */ "./src/components/navbar/navbar-unscoped.scss");
/* harmony import */ var _navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _navbar_item_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./navbar-item-helper */ "./src/components/navbar/navbar-item/navbar-item-helper.ts");
/* harmony import */ var _navbar_item_html_style_navbar_item_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./navbar-item.html?style=./navbar-item.scss */ "./src/components/navbar/navbar-item/navbar-item.html?style=./navbar-item.scss");
/* harmony import */ var _navbar_item_html_style_navbar_item_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_navbar_item_html_style_navbar_item_scss__WEBPACK_IMPORTED_MODULE_7__);








// must be sync with selected css class
var FAKE_SELECTED_CLASS = 'm--is-fake-selected';
var MNavbarItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MNavbarItem, _super);
    function MNavbarItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatedLabel = '';
        // should be initialized to be reactive
        // tslint:disable-next-line:no-null-keyword
        _this.parentNavbar = null;
        return _this;
    }
    MNavbarItem.prototype.emitClick = function (event) { };
    MNavbarItem.prototype.emitMouseover = function (event) { };
    MNavbarItem.prototype.emitMouseleave = function (event) { };
    MNavbarItem.prototype.labelChanged = function () {
        this.setFormatedLabel();
    };
    MNavbarItem.prototype.isMultilineChanged = function () {
        this.setDimension();
        this.setFormatedLabel();
    };
    MNavbarItem.prototype.routeChanged = function () {
        var _this = this;
        this.$nextTick(function () {
            if (_this.parentNavbar && _this.parentNavbar.autoSelect && _navbar_item_helper__WEBPACK_IMPORTED_MODULE_6__["default"].isRouterLinkActive(_this)) {
                _this.parentNavbar.updateValue(_this.value);
            }
        });
    };
    MNavbarItem.prototype.mounted = function () {
        this.formatedLabel = this.label;
        var parentNavbar;
        parentNavbar = this.getParent(function (p) { return p instanceof _navbar__WEBPACK_IMPORTED_MODULE_4__["BaseNavbar"] || // these will fail with Jest, but should pass in prod mode
            p.$options.name === 'MNavbar'; } // these are necessary for Jest, but the first two should pass in prod mode
        );
        if (parentNavbar) {
            this.parentNavbar = parentNavbar;
            this.setDimension();
            this.setFormatedLabel();
            if (this.parentNavbar.autoSelect && _navbar_item_helper__WEBPACK_IMPORTED_MODULE_6__["default"].isRouterLinkActive(this)) {
                this.parentNavbar.updateValue(this.value);
            }
        }
        else {
            console.error('m-navbar-item need to be inside m-navbar');
        }
        this.$modul.event.$on('resize', this.setFormatedLabel);
        this.$modul.event.$on('resize', this.setDimension);
    };
    MNavbarItem.prototype.beforeDestroy = function () {
        this.$modul.event.$off('resize', this.setDimension);
        this.$modul.event.$off('resize', this.setFormatedLabel);
    };
    Object.defineProperty(MNavbarItem.prototype, "shouldNotWrap", {
        get: function () {
            return Boolean(this.label) && this.label.length < 15;
        },
        enumerable: true,
        configurable: true
    });
    MNavbarItem.prototype.setFormatedLabel = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var itemValue, itemComputedStyle, fontSize;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.formatedLabel = this.label;
                        if (!this.label || !this.isMultiline) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        if (this.label) {
                            if (this.label.length < 15) {
                                return [2 /*return*/];
                            }
                            else if (this.label.length > 30) {
                                this.splitAndWrap();
                                return [2 /*return*/];
                            }
                        }
                        itemValue = this.$refs.itemValue;
                        if (!itemValue) {
                            return [2 /*return*/];
                        }
                        itemComputedStyle = window.getComputedStyle(itemValue);
                        fontSize = parseFloat(itemComputedStyle.getPropertyValue('font-size'));
                        if (itemValue.clientHeight / fontSize <= 3) {
                            return [2 /*return*/];
                        }
                        this.splitAndWrap();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MNavbarItem.prototype, "isSelected", {
        get: function () {
            return !!this.parentNavbar && !this.disabled && this.value === this.parentNavbar.model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbarItem.prototype, "isMultiline", {
        get: function () {
            return !this.multiline && this.parentNavbar ? this.parentNavbar.multiline : this.multiline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbarItem.prototype, "isRouterLink", {
        get: function () {
            return Boolean(this.url) && !this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    MNavbarItem.prototype.onClick = function (event) {
        if (!this.disabled && this.parentNavbar) {
            this.parentNavbar.onClick(event, this.value);
            if (this.value !== this.parentNavbar.model) {
                this.parentNavbar.updateValue(this.value);
            }
            this.emitClick(event);
        }
    };
    MNavbarItem.prototype.onMouseover = function (event) {
        if (!this.disabled && this.parentNavbar) {
            this.parentNavbar.onMouseover(event, this.value);
            this.emitMouseover(event);
        }
    };
    MNavbarItem.prototype.onMouseleave = function (event) {
        if (!this.disabled && this.parentNavbar) {
            this.parentNavbar.onMouseleave(event, this.value);
            this.emitMouseleave(event);
        }
    };
    MNavbarItem.prototype.setDimension = function () {
        if (this.label || !this.isMultiline) {
            return;
        }
        var itemEl = this.$refs.item;
        if (itemEl && itemEl.style) {
            itemEl.style.removeProperty('width');
            itemEl.style.removeProperty('max-width');
            itemEl.style.removeProperty('white-space');
            if (this.isMultiline && ((itemEl.innerText === undefined ? '' : itemEl.innerText).trim().length > 15)) {
                var itemElComputedStyle = window.getComputedStyle(itemEl);
                var fontSize = parseFloat(itemElComputedStyle.getPropertyValue('font-size'));
                var paddingH = parseInt(itemElComputedStyle.getPropertyValue('padding-top'), 10) + parseInt(itemElComputedStyle.getPropertyValue('padding-bottom'), 10);
                // must subtract the padding, create a infinite loop
                var itemElHeight = itemEl.clientHeight - paddingH;
                var lines = Math.floor(itemElHeight / fontSize);
                if (lines > 2) {
                    // use selected class to reserve space for when selected
                    this.$el.classList.add(FAKE_SELECTED_CLASS);
                    // create a infinite loop if the parent has 'align-items: stretch'
                    this.$parent.$refs.list.style.alignItems = 'flex-start';
                    do {
                        itemEl.style.width = itemEl.clientWidth + 1 + 'px'; // increment width
                        // update values
                        itemElHeight = itemEl.clientHeight - paddingH;
                        lines = Math.floor(itemElHeight / fontSize);
                    } while (lines > 2);
                    itemEl.style.width = itemEl.clientWidth + 2 + 'px'; // Add 2px for never to fall on more than two lines
                    // reset styles once completed
                    this.$el.classList.remove(FAKE_SELECTED_CLASS);
                    this.$parent.$refs.list.style.removeProperty('align-items');
                }
            }
            else {
                itemEl.style.whiteSpace = 'nowrap';
            }
        }
    };
    MNavbarItem.prototype.splitAndWrap = function () {
        var split = this.label.split(' ');
        split.splice(Math.round(split.length / 2), 0, '</br>');
        this.formatedLabel = '<span style="all: inherit; white-space: nowrap;">'
            + split.join(' ')
            + '</span>';
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "url", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "ariaHaspopup", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "ariaExpanded", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "ariaControls", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbarItem.prototype, "multiline", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MNavbarItem.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseover')
    ], MNavbarItem.prototype, "emitMouseover", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseleave')
    ], MNavbarItem.prototype, "emitMouseleave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('label')
    ], MNavbarItem.prototype, "labelChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('isMultiline')
    ], MNavbarItem.prototype, "isMultilineChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('$route')
    ], MNavbarItem.prototype, "routeChanged", null);
    MNavbarItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _navbar_item_html_style_navbar_item_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({})
    ], MNavbarItem);
    return MNavbarItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/navbar/navbar-unscoped.scss":
/*!****************************************************!*\
  !*** ./src/components/navbar/navbar-unscoped.scss ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/navbar/navbar.html?style=./navbar.scss":
/*!***************************************************************!*\
  !*** ./src/components/navbar/navbar.html?style=./navbar.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=357ca42e!./navbar.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=357ca42e!./src/components/navbar/navbar.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-navbar",
      class: [
        "m--is-skin-" + _vm.skin,
        {
          "m--is-disabled": _vm.disabled,
          "m--is-anim-ready": _vm.animReady,
          "m--is-multiline": _vm.multiline
        }
      ]
    },
    [
      _c(
        "m-auto-horizontal-scroll",
        {
          staticClass: "m-navbar__wrap",
          style: { maxWidth: _vm.maxWidth },
          attrs: {
            "min-width": _vm.minWidth,
            "horizontal-scroll-offset": _vm.horizontalScrollOffset,
            "drag-active": true,
            "left-gradient-active": _vm.hasGradient,
            "right-gradient-active": _vm.hasGradient,
            "gradient-style": _vm.gradientStyle,
            "previous-button-active": _vm.navigationArrow,
            "next-button-active": _vm.navigationArrow,
            "previous-button-text": _vm.titleButtonLeft,
            "next-button-text": _vm.titleButtonRight,
            "display-horizontal-scrollbar": false
          },
          on: {
            "update:horizontalScrollOffset": function($event) {
              _vm.horizontalScrollOffset = $event
            },
            "update:horizontal-scroll-offset": function($event) {
              _vm.horizontalScrollOffset = $event
            },
            resize: function($event) {
              return _vm.resizeComponant($event)
            },
            "previous-button-click": function($event) {
              return _vm.onPreviousButtonClick($event)
            },
            "next-button-click": function($event) {
              return _vm.onNextButtonClick($event)
            }
          }
        },
        [
          _c(
            "ul",
            {
              ref: "list",
              staticClass: "m-navbar__list",
              attrs: { role: "menubar" }
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _vm.isTabUnderlineSkin
                ? _c("li", {
                    ref: "tab-underline",
                    staticClass: "m-navbar__line",
                    attrs: { role: "none", "aria-hidden": "true" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isTabArrowSkin
                ? _c("li", {
                    ref: "tab-arrow",
                    staticClass: "m-navbar__arrow",
                    attrs: { role: "none", "aria-hidden": "true" }
                  })
                : _vm._e()
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-357ca42e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/navbar/navbar.ts":
/*!*****************************************!*\
  !*** ./src/components/navbar/navbar.ts ***!
  \*****************************************/
/*! exports provided: BaseNavbar, MNavbarSkin, MNavbarMaxWidth, MNavbar, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseNavbar", function() { return BaseNavbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MNavbarSkin", function() { return MNavbarSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MNavbarMaxWidth", function() { return MNavbarMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MNavbar", function() { return MNavbar; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../auto-horizontal-scroll/auto-horizontal-scroll */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.ts");
/* harmony import */ var _navbar_item_navbar_item__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./navbar-item/navbar-item */ "./src/components/navbar/navbar-item/navbar-item.ts");
/* harmony import */ var _navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./navbar-unscoped.scss */ "./src/components/navbar/navbar-unscoped.scss");
/* harmony import */ var _navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_navbar_unscoped_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _navbar_html_style_navbar_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./navbar.html?style=./navbar.scss */ "./src/components/navbar/navbar.html?style=./navbar.scss");
/* harmony import */ var _navbar_html_style_navbar_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_navbar_html_style_navbar_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var BaseNavbar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseNavbar, _super);
    function BaseNavbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseNavbar;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var MNavbarSkin;
(function (MNavbarSkin) {
    MNavbarSkin["Any"] = "any";
    MNavbarSkin["NavMain"] = "nav-main";
    MNavbarSkin["NavSub"] = "nav-sub";
    MNavbarSkin["NavSoft"] = "nav-soft";
    MNavbarSkin["TabLight"] = "tab-light";
    MNavbarSkin["TabLightMain"] = "tab-light-main";
    MNavbarSkin["TabDark"] = "tab-dark";
    MNavbarSkin["TabDarkMain"] = "tab-dark-main";
    MNavbarSkin["TabArrow"] = "tab-arrow";
    MNavbarSkin["TabUnderline"] = "tab-underline";
    MNavbarSkin["TabSoft"] = "tab-soft";
    MNavbarSkin["Plain"] = "plain";
})(MNavbarSkin || (MNavbarSkin = {}));
var MNavbarMaxWidth;
(function (MNavbarMaxWidth) {
    MNavbarMaxWidth["XLarge"] = "1400px";
    MNavbarMaxWidth["Large"] = "1200px";
    MNavbarMaxWidth["Regular"] = "1000px";
    MNavbarMaxWidth["Small"] = "800px";
    MNavbarMaxWidth["Text"] = "720px";
})(MNavbarMaxWidth || (MNavbarMaxWidth = {}));
var MNavbar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MNavbar, _super);
    function MNavbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animReady = false;
        _this.minWidth = '100px';
        _this.componentWidth = '';
        _this.horizontalScrollOffset = 0;
        _this.internalValue = '';
        _this.navbarItemsInterne = [];
        return _this;
    }
    MNavbar.prototype.emitUpdateSelected = function (value) { };
    MNavbar.prototype.emitClick = function (event, value) { };
    MNavbar.prototype.emitMouseover = function (event, value) { };
    MNavbar.prototype.emitMouseleave = function (event, value) { };
    MNavbar.prototype.setAndUpdate = function (value) {
        var _this = this;
        this.internalValue = value;
        this.$nextTick(function () {
            _this.scrollToSelected();
        });
    };
    MNavbar.prototype.created = function () {
        if (this.skin === MNavbarSkin.TabLight) {
            this.$log.warn('MNavbarSkin.TabLight is deprecated, please use MNavbarSkin.TabLightMain instead.');
        }
        else if (this.skin === MNavbarSkin.TabDark) {
            this.$log.warn('MNavbarSkin.TabDark is deprecated, please use MNavbarSkin.TabDarkMain instead.');
        }
        this.internalValue = undefined;
    };
    MNavbar.prototype.mounted = function () {
        var _this = this;
        this.observer = new MutationObserver(function (mutations) {
            _this.setNavbarItems();
            if (mutations.some(function (mutation) { return mutation.type === 'childList'; })) {
                _this.resizeComponant();
            }
            _this.setSelectedIndicatorPosition();
        });
        this.observer.observe(this.$refs.list, { subtree: true, childList: true, characterData: true });
        this.setNavbarItems();
    };
    MNavbar.prototype.beforeDestroy = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    Object.defineProperty(MNavbar.prototype, "model", {
        get: function () {
            return this.selected === undefined ? this.internalValue : this.selected;
        },
        set: function (value) {
            this.setAndUpdate(value);
            this.emitUpdateSelected(value);
        },
        enumerable: true,
        configurable: true
    });
    MNavbar.prototype.updateValue = function (value) {
        this.model = value;
    };
    MNavbar.prototype.onMouseover = function (event, value) {
        this.emitMouseover(event, value);
    };
    MNavbar.prototype.onMouseleave = function (event, value) {
        this.emitMouseleave(event, value);
    };
    MNavbar.prototype.onClick = function (event, value) {
        this.emitClick(event, value);
    };
    Object.defineProperty(MNavbar.prototype, "gradientStyle", {
        get: function () {
            if (this.buttonGradientStyle) {
                return this.buttonGradientStyle;
            }
            else {
                switch (this.skin) {
                    case MNavbarSkin.NavMain:
                    case MNavbarSkin.TabDark:
                    case MNavbarSkin.TabDarkMain:
                        return _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].Dark;
                    case MNavbarSkin.NavSub:
                        return _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].GreyBlack;
                    case MNavbarSkin.NavSoft:
                        return _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].Interactive;
                    case MNavbarSkin.TabLightMain:
                        return _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].Light;
                    case MNavbarSkin.TabArrow:
                    default:
                        return _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].White;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbar.prototype, "hasGradient", {
        get: function () {
            return !((this.isTabLightSkin || this.isTabDarkSkin) && this.navigationArrow);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbar.prototype, "isTabLightSkin", {
        get: function () {
            return this.skin === MNavbarSkin.TabLight || this.skin === MNavbarSkin.TabLightMain;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbar.prototype, "isTabDarkSkin", {
        get: function () {
            return this.skin === MNavbarSkin.TabDarkMain || this.skin === MNavbarSkin.TabDark;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbar.prototype, "isTabUnderlineSkin", {
        get: function () {
            return this.skin === MNavbarSkin.TabUnderline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MNavbar.prototype, "isTabArrowSkin", {
        get: function () {
            return this.skin === MNavbarSkin.TabArrow;
        },
        enumerable: true,
        configurable: true
    });
    MNavbar.prototype.onPreviousButtonClick = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var outbound;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (this.navbarItemsInterne.length < 1) {
                    return [2 /*return*/];
                }
                // find the previus element outside visible area
                this.navbarItemsInterne.forEach(function (item) {
                    if (item.$el.offsetLeft < _this.horizontalScrollOffset) {
                        outbound = item;
                    }
                });
                if (outbound) {
                    this.horizontalScrollOffset = outbound.$el.offsetLeft;
                }
                return [2 /*return*/];
            });
        });
    };
    MNavbar.prototype.onNextButtonClick = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var cRight, outbound, threshold;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (this.navbarItemsInterne.length < 1) {
                    return [2 /*return*/];
                }
                cRight = this.horizontalScrollOffset + parseInt(this.componentWidth, 10);
                outbound = this.navbarItemsInterne.find(function (item) {
                    return item.$el.offsetLeft + item.$el.clientWidth > cRight;
                });
                if (outbound) {
                    threshold = cRight - outbound.$el.offsetLeft;
                    // move the container scroll
                    this.horizontalScrollOffset += (outbound.$el.clientWidth) - threshold;
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(MNavbar.prototype, "selectedNavbarItem", {
        get: function () {
            var _this = this;
            return this.navbarItemsInterne.length > 0 ?
                this.navbarItemsInterne.find(function (i) { return i && i.$props.value === _this.model; }) :
                undefined;
        },
        enumerable: true,
        configurable: true
    });
    MNavbar.prototype.resizeComponant = function (properties) {
        this.minWidth = this.$refs.list.clientWidth + "px";
        if (properties) {
            this.componentWidth = properties.componentWidth;
        }
    };
    MNavbar.prototype.setSelectedIndicatorPosition = function () {
        var navbarItemElement = this.selectedNavbarItem && this.selectedNavbarItem.$el ?
            this.selectedNavbarItem.$el :
            undefined;
        var localRef = this.skin && this.$refs[this.skin] ?
            this.$refs[this.skin] :
            undefined;
        if (!(this.isTabUnderlineSkin || this.isTabArrowSkin) ||
            !(navbarItemElement && localRef)) {
            return;
        }
        var positionX = navbarItemElement.offsetLeft;
        var width = navbarItemElement.clientWidth;
        localRef.style.transform = 'translate3d(' + positionX + 'px, 0, 0)';
        localRef.style.width = width + 'px';
    };
    MNavbar.prototype.setNavbarItems = function () {
        this.navbarItemsInterne = this.$children &&
            this.$children[0] &&
            this.$children[0].$children ?
            this.$children[0].$children.filter(function (element) { return element instanceof _navbar_item_navbar_item__WEBPACK_IMPORTED_MODULE_9__["MNavbarItem"]; })
            : [];
    };
    MNavbar.prototype.scrollToSelected = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var navbarItemSelectedEl, componentWidth, scrollPositionAlignLeft;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (this.navbarItemsInterne.length < 1) {
                    this.animReady = true;
                    return [2 /*return*/];
                }
                navbarItemSelectedEl = this.selectedNavbarItem && this.selectedNavbarItem.$el ?
                    this.selectedNavbarItem.$el :
                    undefined;
                if (navbarItemSelectedEl) {
                    componentWidth = parseInt(this.componentWidth, 10);
                    scrollPositionAlignLeft = navbarItemSelectedEl.offsetLeft;
                    // Check if selected element is visible in navbar
                    if (componentWidth >
                        (navbarItemSelectedEl.offsetLeft -
                            this.horizontalScrollOffset)) {
                        // Check if the selected element exceeds on the left side
                        if ((navbarItemSelectedEl.offsetLeft -
                            this.horizontalScrollOffset)
                            < 0) {
                            this.horizontalScrollOffset = scrollPositionAlignLeft;
                            // Check if the selected element exceeds on the right side
                        }
                        else if (componentWidth < (navbarItemSelectedEl.offsetLeft -
                            this.horizontalScrollOffset + navbarItemSelectedEl.clientWidth)) {
                            this.horizontalScrollOffset = this.horizontalScrollOffset +
                                navbarItemSelectedEl.clientWidth -
                                (this.horizontalScrollOffset +
                                    componentWidth -
                                    navbarItemSelectedEl.offsetLeft);
                        }
                    }
                    else {
                        this.horizontalScrollOffset = scrollPositionAlignLeft;
                    }
                    this.setSelectedIndicatorPosition();
                }
                this.animReady = true;
                return [2 /*return*/];
            });
        });
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbar.prototype, "selected", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MNavbarSkin.NavMain,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MNavbarSkin).includes(value); }
        })
    ], MNavbar.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbar.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MNavbar.prototype, "navigationArrow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MNavbarMaxWidth.Large,
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_4__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MNavbar.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MNavbar.prototype, "multiline", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbar.prototype, "titleButtonLeft", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MNavbar.prototype, "titleButtonRight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"]).includes(value);
            }
        })
    ], MNavbar.prototype, "buttonGradientStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MNavbar.prototype, "autoSelect", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:selected')
    ], MNavbar.prototype, "emitUpdateSelected", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MNavbar.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseover')
    ], MNavbar.prototype, "emitMouseover", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseleave')
    ], MNavbar.prototype, "emitMouseleave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('selected', { immediate: true })
    ], MNavbar.prototype, "setAndUpdate", null);
    MNavbar = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _navbar_html_style_navbar_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_7__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["AUTO_HORIZONTAL_SCROLL"]] = _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScroll"],
                _a)
        })
    ], MNavbar);
    return MNavbar;
}(BaseNavbar));

var NavbarPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["NAVBAR_ITEM_NAME"], _navbar_item_navbar_item__WEBPACK_IMPORTED_MODULE_9__["MNavbarItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["NAVBAR_NAME"], MNavbar);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (NavbarPlugin);


/***/ }),

/***/ "./src/components/option/option-item/option-item-add.ts":
/*!**************************************************************!*\
  !*** ./src/components/option/option-item/option-item-add.ts ***!
  \**************************************************************/
/*! exports provided: MOptionItemAdd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItemAdd", function() { return MOptionItemAdd; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _option_item_predefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./option-item-predefined */ "./src/components/option/option-item/option-item-predefined.ts");


var MOptionItemAdd = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItemAdd, _super);
    function MOptionItemAdd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MOptionItemAdd.prototype, "iconName", {
        get: function () {
            return 'm-svg__add-circle';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItemAdd.prototype, "label", {
        get: function () {
            return this.$i18n.translate('m-option:add');
        },
        enumerable: true,
        configurable: true
    });
    return MOptionItemAdd;
}(_option_item_predefined__WEBPACK_IMPORTED_MODULE_1__["MOptionItemPredefined"]));



/***/ }),

/***/ "./src/components/option/option-item/option-item-archive.ts":
/*!******************************************************************!*\
  !*** ./src/components/option/option-item/option-item-archive.ts ***!
  \******************************************************************/
/*! exports provided: MOptionItemArchive */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItemArchive", function() { return MOptionItemArchive; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _option_item_predefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./option-item-predefined */ "./src/components/option/option-item/option-item-predefined.ts");


var MOptionItemArchive = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItemArchive, _super);
    function MOptionItemArchive() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MOptionItemArchive.prototype, "iconName", {
        get: function () {
            return 'm-svg__folder-open';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItemArchive.prototype, "label", {
        get: function () {
            return this.$i18n.translate('m-option:archive');
        },
        enumerable: true,
        configurable: true
    });
    return MOptionItemArchive;
}(_option_item_predefined__WEBPACK_IMPORTED_MODULE_1__["MOptionItemPredefined"]));



/***/ }),

/***/ "./src/components/option/option-item/option-item-delete.ts":
/*!*****************************************************************!*\
  !*** ./src/components/option/option-item/option-item-delete.ts ***!
  \*****************************************************************/
/*! exports provided: MOptionItemDelete */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItemDelete", function() { return MOptionItemDelete; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _option_item_predefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./option-item-predefined */ "./src/components/option/option-item/option-item-predefined.ts");


var MOptionItemDelete = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItemDelete, _super);
    function MOptionItemDelete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MOptionItemDelete.prototype, "iconName", {
        get: function () {
            return 'm-svg__delete';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItemDelete.prototype, "label", {
        get: function () {
            return this.$i18n.translate('m-option:delete');
        },
        enumerable: true,
        configurable: true
    });
    return MOptionItemDelete;
}(_option_item_predefined__WEBPACK_IMPORTED_MODULE_1__["MOptionItemPredefined"]));



/***/ }),

/***/ "./src/components/option/option-item/option-item-edit.ts":
/*!***************************************************************!*\
  !*** ./src/components/option/option-item/option-item-edit.ts ***!
  \***************************************************************/
/*! exports provided: MOptionItemEdit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItemEdit", function() { return MOptionItemEdit; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _option_item_predefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./option-item-predefined */ "./src/components/option/option-item/option-item-predefined.ts");


var MOptionItemEdit = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItemEdit, _super);
    function MOptionItemEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MOptionItemEdit.prototype, "iconName", {
        get: function () {
            return 'm-svg__edit';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItemEdit.prototype, "label", {
        get: function () {
            return this.$i18n.translate('m-option:edit');
        },
        enumerable: true,
        configurable: true
    });
    return MOptionItemEdit;
}(_option_item_predefined__WEBPACK_IMPORTED_MODULE_1__["MOptionItemPredefined"]));



/***/ }),

/***/ "./src/components/option/option-item/option-item-predefined.html":
/*!***********************************************************************!*\
  !*** ./src/components/option/option-item/option-item-predefined.html ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-option-item",
    {
      attrs: { "icon-name": _vm.iconName, disabled: _vm.disabled },
      on: { click: _vm.onClick }
    },
    [_vm._v("\n    " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-3e145a12'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/option/option-item/option-item-predefined.ts":
/*!*********************************************************************!*\
  !*** ./src/components/option/option-item/option-item-predefined.ts ***!
  \*********************************************************************/
/*! exports provided: MOptionItemPredefined */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItemPredefined", function() { return MOptionItemPredefined; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _option_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./option-item */ "./src/components/option/option-item/option-item.ts");
/* harmony import */ var _option_item_predefined_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./option-item-predefined.html */ "./src/components/option/option-item/option-item-predefined.html");
/* harmony import */ var _option_item_predefined_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_option_item_predefined_html__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MOptionItemPredefined = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItemPredefined, _super);
    function MOptionItemPredefined() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MOptionItemPredefined.prototype, "iconName", {
        get: function () {
            throw new Error('not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItemPredefined.prototype, "label", {
        get: function () {
            throw new Error('not implemented');
        },
        enumerable: true,
        configurable: true
    });
    MOptionItemPredefined.prototype.onClick = function (_event) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOptionItemPredefined.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MOptionItemPredefined.prototype, "onClick", null);
    MOptionItemPredefined = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _option_item_predefined_html__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["OPTION_ITEM_NAME"]] = _option_item__WEBPACK_IMPORTED_MODULE_5__["MOptionItem"],
                _a)
        })
    ], MOptionItemPredefined);
    return MOptionItemPredefined;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/option/option-item/option-item.html?style=./option-item.scss":
/*!*************************************************************************************!*\
  !*** ./src/components/option/option-item/option-item.html?style=./option-item.scss ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8ba3d5e6!./option-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=8ba3d5e6!./src/components/option/option-item/option-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      ref: "m-option-item",
      staticClass: "m-option-item",
      class: {
        "m--is-disabled": _vm.disabled,
        "m--has-icon-spacing": _vm.hasIcon,
        "m--has-no-border": !_vm.hasBorder
      },
      attrs: { tabindex: _vm.disabled ? "-1" : "0", role: "option" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.onClick($event)
        },
        click: function($event) {
          $event.preventDefault()
          return _vm.onClick($event)
        }
      }
    },
    [
      _vm.hasIcon
        ? _c(
            "span",
            { ref: "icon", staticClass: "m-option-item__icon" },
            [
              _vm.hasIconNameProp
                ? _c("m-icon", { attrs: { name: _vm.iconName, size: "20px" } })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { ref: "text", staticClass: "m-option-item__text" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-8ba3d5e6'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/option/option-item/option-item.ts":
/*!**********************************************************!*\
  !*** ./src/components/option/option-item/option-item.ts ***!
  \**********************************************************/
/*! exports provided: MOptionItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionItem", function() { return MOptionItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _option__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../option */ "./src/components/option/option.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _option_item_html_style_option_item_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./option-item.html?style=./option-item.scss */ "./src/components/option/option-item/option-item.html?style=./option-item.scss");
/* harmony import */ var _option_item_html_style_option_item_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_option_item_html_style_option_item_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MOptionItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionItem, _super);
    function MOptionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasRoot = false;
        return _this;
    }
    MOptionItem.prototype.mounted = function () {
        var rootNode = this.getParent(function (p) { return p instanceof _option__WEBPACK_IMPORTED_MODULE_5__["BaseOption"]; });
        if (rootNode) {
            this.root = rootNode;
            this.hasRoot = true;
        }
        else {
            console.error('m-option-item need to be inside m-option');
        }
    };
    MOptionItem.prototype.emitClick = function (_event) { };
    MOptionItem.prototype.onClick = function (event) {
        if (!this.disabled) {
            if (this.hasRoot) {
                (this.root).close();
                this.emitClick(event);
            }
        }
        else {
            event.stopPropagation();
        }
    };
    Object.defineProperty(MOptionItem.prototype, "hasIconNameProp", {
        get: function () {
            return !!this.iconName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItem.prototype, "hasIcon", {
        get: function () {
            if (this.hasRoot) {
                (this.root).checkIcon(this.hasIconNameProp);
                return (this.root).hasIcon;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItem.prototype, "hasBorder", {
        get: function () {
            if (this.hasRoot) {
                (this.root).checkBorder();
                return (this.root).hasItemBorder;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOptionItem.prototype, "hasDefaultSlot", {
        get: function () {
            return !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOptionItem.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOptionItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MOptionItem.prototype, "emitClick", null);
    MOptionItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _option_item_html_style_option_item_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a)
        })
    ], MOptionItem);
    return MOptionItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/option/option-separator/option-separator.html?style=./option-separator.scss":
/*!****************************************************************************************************!*\
  !*** ./src/components/option/option-separator/option-separator.html?style=./option-separator.scss ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=47b4f576!./option-separator.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=47b4f576!./src/components/option/option-separator/option-separator.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", {
    staticClass: "m-option-separator",
    attrs: { role: "separator" }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-47b4f576'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/option/option-separator/option-separator.ts":
/*!********************************************************************!*\
  !*** ./src/components/option/option-separator/option-separator.ts ***!
  \********************************************************************/
/*! exports provided: MOptionSeparator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionSeparator", function() { return MOptionSeparator; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _option__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../option */ "./src/components/option/option.ts");
/* harmony import */ var _option_separator_html_style_option_separator_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./option-separator.html?style=./option-separator.scss */ "./src/components/option/option-separator/option-separator.html?style=./option-separator.scss");
/* harmony import */ var _option_separator_html_style_option_separator_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_option_separator_html_style_option_separator_scss__WEBPACK_IMPORTED_MODULE_4__);





var MOptionSeparator = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionSeparator, _super);
    function MOptionSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MOptionSeparator.prototype.mounted = function () {
        var rootNode = this.getParent(function (p) { return p instanceof _option__WEBPACK_IMPORTED_MODULE_3__["BaseOption"]; });
        if (rootNode === undefined) {
            console.error('m-option-item need to be inside m-option');
        }
    };
    MOptionSeparator = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _option_separator_html_style_option_separator_scss__WEBPACK_IMPORTED_MODULE_4___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MOptionSeparator);
    return MOptionSeparator;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__["ModulVue"]));



/***/ }),

/***/ "./src/components/option/option-title/option-title.html?style=./option-title.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/option/option-title/option-title.html?style=./option-title.scss ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=087b1865!./option-title.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=087b1865!./src/components/option/option-title/option-title.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "m-option-title" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-087b1865'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/option/option-title/option-title.ts":
/*!************************************************************!*\
  !*** ./src/components/option/option-title/option-title.ts ***!
  \************************************************************/
/*! exports provided: MOptionTitle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionTitle", function() { return MOptionTitle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _option__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../option */ "./src/components/option/option.ts");
/* harmony import */ var _option_title_html_style_option_title_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./option-title.html?style=./option-title.scss */ "./src/components/option/option-title/option-title.html?style=./option-title.scss");
/* harmony import */ var _option_title_html_style_option_title_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_option_title_html_style_option_title_scss__WEBPACK_IMPORTED_MODULE_4__);





var MOptionTitle = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOptionTitle, _super);
    function MOptionTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MOptionTitle.prototype.mounted = function () {
        var rootNode = this.getParent(function (p) { return p instanceof _option__WEBPACK_IMPORTED_MODULE_3__["BaseOption"]; });
        if (rootNode === undefined) {
            console.error('m-option-item need to be inside m-option');
        }
    };
    MOptionTitle = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _option_title_html_style_option_title_scss__WEBPACK_IMPORTED_MODULE_4___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MOptionTitle);
    return MOptionTitle;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__["ModulVue"]));



/***/ }),

/***/ "./src/components/option/option.html":
/*!*******************************************!*\
  !*** ./src/components/option/option.html ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-option" },
    [
      _c(
        "m-popup",
        {
          attrs: {
            open: _vm.open,
            padding: false,
            placement: _vm.placement,
            disabled: _vm.disabled,
            "close-on-backdrop": true,
            background: false,
            shadow: false,
            "focus-management": _vm.focusManagement
          },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            },
            open: _vm.onOpen,
            close: _vm.onClose
          }
        },
        [
          _vm.isSkinMixed
            ? _c(
                "button",
                {
                  staticClass: "m-option__button",
                  attrs: {
                    slot: "trigger",
                    id: _vm.id,
                    "aria-haspopup": "true",
                    "aria-controls": _vm.ariaControls,
                    "aria-expanded": _vm.open,
                    disabled: _vm.disabled
                  },
                  on: { click: _vm.onClick },
                  slot: "trigger"
                },
                [
                  _c("m-icon", {
                    attrs: { title: _vm.propTitle, name: "m-svg__options" }
                  })
                ],
                1
              )
            : _c("m-icon-button", {
                attrs: {
                  slot: "trigger",
                  id: _vm.id,
                  "aria-haspopup": "true",
                  "aria-controls": _vm.ariaControls,
                  "aria-expanded": _vm.open,
                  skin: _vm.iconButtonSkin,
                  title: _vm.propTitle,
                  "icon-name": "m-svg__options",
                  disabled: _vm.disabled,
                  "button-size": _vm.size
                },
                on: { click: _vm.onClick },
                slot: "trigger"
              }),
          _vm._v(" "),
          _c(
            "ul",
            {
              ref: "menu",
              staticClass: "m-option__list",
              style: {
                maxHeight: _vm.menuMaxHeight,
                maxWidth: _vm.optionMaxWidth
              },
              attrs: { id: _vm.ariaControls, "aria-labelledby": _vm.id }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-274e3589'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/option/option.scss":
/*!*******************************************!*\
  !*** ./src/components/option/option.scss ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/option/option.ts":
/*!*****************************************!*\
  !*** ./src/components/option/option.ts ***!
  \*****************************************/
/*! exports provided: BaseOption, MOptionsSkin, MOption, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseOption", function() { return BaseOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOptionsSkin", function() { return MOptionsSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOption", function() { return MOption; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _popper_popper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../popper/popper */ "./src/components/popper/popper.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _option_item_option_item__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./option-item/option-item */ "./src/components/option/option-item/option-item.ts");
/* harmony import */ var _option_item_option_item_add__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./option-item/option-item-add */ "./src/components/option/option-item/option-item-add.ts");
/* harmony import */ var _option_item_option_item_archive__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./option-item/option-item-archive */ "./src/components/option/option-item/option-item-archive.ts");
/* harmony import */ var _option_item_option_item_delete__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./option-item/option-item-delete */ "./src/components/option/option-item/option-item-delete.ts");
/* harmony import */ var _option_item_option_item_edit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./option-item/option-item-edit */ "./src/components/option/option-item/option-item-edit.ts");
/* harmony import */ var _option_separator_option_separator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./option-separator/option-separator */ "./src/components/option/option-separator/option-separator.ts");
/* harmony import */ var _option_title_option_title__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./option-title/option-title */ "./src/components/option/option-title/option-title.ts");
/* harmony import */ var _option_html__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./option.html */ "./src/components/option/option.html");
/* harmony import */ var _option_html__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_option_html__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _option_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./option.scss */ "./src/components/option/option.scss");
/* harmony import */ var _option_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_option_scss__WEBPACK_IMPORTED_MODULE_19__);
var _a;




















var BaseOption = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseOption, _super);
    function BaseOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseOption;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var MOptionsSkin;
(function (MOptionsSkin) {
    MOptionsSkin["Light"] = "over-light";
    MOptionsSkin["Dark"] = "over-dark";
    MOptionsSkin["Mixed"] = "over-mixed";
})(MOptionsSkin || (MOptionsSkin = {}));
var MOption = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOption, _super);
    function MOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasIcon = false;
        _this.hasItemBorder = true;
        _this.open = false;
        _this.id = "mOption-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__["default"].generate();
        return _this;
    }
    MOption.prototype.checkIcon = function (icon) {
        if (icon) {
            this.hasIcon = true;
        }
    };
    MOption.prototype.checkBorder = function () {
        var _this = this;
        this.$slots.default.forEach(function (vNode) {
            if (vNode && vNode.componentOptions && (vNode.componentOptions.tag === _component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_SEPARATOR"] || vNode.componentOptions.tag === _component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_TITLE"])) {
                _this.hasItemBorder = false;
            }
        });
    };
    MOption.prototype.close = function () {
        this.open = false;
        this.onClose();
    };
    MOption.prototype.onOpen = function () {
        this.$emit('open');
    };
    MOption.prototype.onClose = function () {
        this.$emit('close');
    };
    MOption.prototype.onClick = function ($event) {
        this.$emit('click', $event);
    };
    MOption.prototype.getOpenTitle = function () {
        return this.openTitle === undefined ? this.$i18n.translate('m-option:open') : this.openTitle;
    };
    MOption.prototype.getCloseTitle = function () {
        return this.closeTitle === undefined ? this.$i18n.translate('m-option:close') : this.closeTitle;
    };
    Object.defineProperty(MOption.prototype, "propTitle", {
        get: function () {
            return this.open ? this.getCloseTitle() : this.getOpenTitle();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOption.prototype, "optionMaxWidth", {
        get: function () {
            return this.as().isMqMinM ? this.maxWidth : 'none';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOption.prototype, "ariaControls", {
        get: function () {
            return this.id + '-controls';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOption.prototype, "menuMaxHeight", {
        get: function () {
            return this.scroll ? undefined : 'none';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOption.prototype, "isSkinMixed", {
        get: function () {
            return this.skin === MOptionsSkin.Mixed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOption.prototype, "iconButtonSkin", {
        get: function () {
            switch (this.skin) {
                case MOptionsSkin.Light:
                    return _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__["MIconButtonSkin"].Light;
                case MOptionsSkin.Dark:
                    return _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__["MIconButtonSkin"].Dark;
                default:
                    throw new Error('skin not supported!');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Bottom,
            validator: function (value) {
                return value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Bottom ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].BottomEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].BottomStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Left ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].LeftEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].LeftStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Right ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].RightEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].RightStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Top ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].TopEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].TopStart;
            }
        })
    ], MOption.prototype, "placement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MOptionsSkin.Light,
            validator: function (value) {
                return value === MOptionsSkin.Light ||
                    value === MOptionsSkin.Dark ||
                    value === MOptionsSkin.Mixed;
            }
        })
    ], MOption.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOption.prototype, "openTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOption.prototype, "closeTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MOption.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '44px' })
    ], MOption.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MOption.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOption.prototype, "scroll", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '220px' })
    ], MOption.prototype, "maxWidth", void 0);
    MOption = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _option_html__WEBPACK_IMPORTED_MODULE_18___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_10__["MPopup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__["MIconButton"],
                _a),
            mixins: [
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["MediaQueries"]
            ]
        })
    ], MOption);
    return MOption;
}(BaseOption));

var OptionPlugin = {
    install: function (v, options) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_ITEM_NAME"], _option_item_option_item__WEBPACK_IMPORTED_MODULE_11__["MOptionItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_ITEM_ARCHIVE_NAME"], _option_item_option_item_archive__WEBPACK_IMPORTED_MODULE_13__["MOptionItemArchive"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_ITEM_ADD_NAME"], _option_item_option_item_add__WEBPACK_IMPORTED_MODULE_12__["MOptionItemAdd"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_ITEM_DELETE_NAME"], _option_item_option_item_delete__WEBPACK_IMPORTED_MODULE_14__["MOptionItemDelete"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_ITEM_EDIT_NAME"], _option_item_option_item_edit__WEBPACK_IMPORTED_MODULE_15__["MOptionItemEdit"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_TITLE"], _option_title_option_title__WEBPACK_IMPORTED_MODULE_17__["MOptionTitle"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_SEPARATOR"], _option_separator_option_separator__WEBPACK_IMPORTED_MODULE_16__["MOptionSeparator"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["OPTION_NAME"], MOption);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (OptionPlugin);


/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns-modal.html?style=./organize-table-columns-modal.scss":
/*!*********************************************************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns-modal.html?style=./organize-table-columns-modal.scss ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b18183ae!./organize-table-columns-modal.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=b18183ae!./src/components/organize-table-columns-modal/organize-table-columns-modal.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-modal",
    {
      staticClass: "m-organize-table-columns-modal",
      attrs: {
        open: _vm.open,
        size: "small",
        title: _vm._f("f-m-i18n")("m-organize-table-columns-modal:title")
      },
      on: {
        "update:open": function($event) {
          _vm.open = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "m-button",
                {
                  staticClass:
                    "m-organize-table-columns-modal__reorganize-button",
                  on: {
                    click: function($event) {
                      return _vm.saveReorganize()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("f-m-i18n")(
                          "m-organize-table-columns-modal:action.reorganize"
                        )
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "m-button",
                {
                  attrs: { skin: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.reset()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("f-m-i18n")(
                          "m-organize-table-columns-modal:action.reset"
                        )
                      ) +
                      "\n        "
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._t(
        "trigger",
        [
          _c("m-button", [
            _vm._v(
              _vm._s(_vm._f("f-m-i18n")("m-organize-table-columns-modal:title"))
            )
          ])
        ],
        { slot: "trigger" }
      ),
      _vm._v(" "),
      _c("m-organize-table-columns", {
        attrs: { columns: _vm.internalColumns },
        on: { reorganize: _vm.reorganize }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-b18183ae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns-modal.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns-modal.ts ***!
  \*************************************************************************************/
/*! exports provided: MOrganizeTableColumnsModal, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOrganizeTableColumnsModal", function() { return MOrganizeTableColumnsModal; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _modal_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../modal/modal */ "./src/components/modal/modal.ts");
/* harmony import */ var _organize_table_columns_modal_html_style_organize_table_columns_modal_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./organize-table-columns-modal.html?style=./organize-table-columns-modal.scss */ "./src/components/organize-table-columns-modal/organize-table-columns-modal.html?style=./organize-table-columns-modal.scss");
/* harmony import */ var _organize_table_columns_modal_html_style_organize_table_columns_modal_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_organize_table_columns_modal_html_style_organize_table_columns_modal_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _organize_table_columns_organize_table_columns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./organize-table-columns/organize-table-columns */ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.ts");
var _a, _b;











var MOrganizeTableColumnsModal = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOrganizeTableColumnsModal, _super);
    function MOrganizeTableColumnsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalColumns = [];
        _this.open = false;
        return _this;
    }
    MOrganizeTableColumnsModal.prototype.setInternalColumns = function (columns) {
        this.internalColumns = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.columns);
    };
    MOrganizeTableColumnsModal.prototype.reorganize = function (columns) {
        this.internalColumns = columns;
    };
    MOrganizeTableColumnsModal.prototype.saveReorganize = function () {
        this.emitReorganize(this.internalColumns);
    };
    MOrganizeTableColumnsModal.prototype.emitReorganize = function (columns) {
        this.open = false;
    };
    MOrganizeTableColumnsModal.prototype.reset = function () {
        this.setInternalColumns(this.columns);
        this.open = false;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MOrganizeTableColumnsModal.prototype, "columns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('columns', { immediate: true })
    ], MOrganizeTableColumnsModal.prototype, "setInternalColumns", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('reorganize')
    ], MOrganizeTableColumnsModal.prototype, "emitReorganize", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('reset')
    ], MOrganizeTableColumnsModal.prototype, "reset", null);
    MOrganizeTableColumnsModal = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _organize_table_columns_modal_html_style_organize_table_columns_modal_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            filters: (_a = {},
                _a[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _a),
            components: (_b = {},
                _b[_component_names__WEBPACK_IMPORTED_MODULE_7__["MODAL_NAME"]] = _modal_modal__WEBPACK_IMPORTED_MODULE_8__["MModal"],
                _b[_component_names__WEBPACK_IMPORTED_MODULE_7__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_6__["MButton"],
                _b[_component_names__WEBPACK_IMPORTED_MODULE_7__["ORGANIZE_TABLE_COLUMNS_NAME"]] = _organize_table_columns_organize_table_columns__WEBPACK_IMPORTED_MODULE_10__["MOrganizeTableColumns"],
                _b)
        })
    ], MOrganizeTableColumnsModal);
    return MOrganizeTableColumnsModal;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var OrganizeTableColumnsModalPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["ORGANIZE_TABLE_COLUMNS_MODAL_NAME"], MOrganizeTableColumnsModal);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (OrganizeTableColumnsModalPlugin);


/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.html?style=./organize-table-columns.scss":
/*!********************************************************************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.html?style=./organize-table-columns.scss ***!
  \********************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=28c4efa6!./organize-table-columns.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=28c4efa6!./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-organize-table-columns" },
    [
      _c("div", { staticClass: "m-organize-table-columns__header" }, [
        _c("h2", { staticClass: "m-organize-table-columns__title" }, [
          _vm._v(_vm._s(_vm._f("f-m-i18n")("m-organize-table-columns:title")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm._f("f-m-i18n")("m-organize-table-columns:helper-1")) +
              " (" +
              _vm._s(_vm.numberDisplayedColumns) +
              ")"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "m-sortable",
              rawName: "v-m-sortable",
              value: true,
              expression: "true"
            }
          ],
          staticClass: "m-organize-table-columns__visible-columns",
          attrs: { items: _vm.displayedColumns },
          on: { "sortable:move": _vm.moveColumn }
        },
        _vm._l(_vm.displayedColumns, function(column, index) {
          return _c(
            "m-list-item",
            {
              key: column.propName,
              staticClass: "m-organize-table-columns__list-item",
              attrs: {
                disabled: column.fixed,
                "can-drag": _vm.isDraggable(column),
                "can-drop": _vm.isDroppable(column)
              }
            },
            [
              _c(
                "div",
                { staticClass: "m-organize-table-columns__item" },
                [
                  _c(
                    "div",
                    { staticClass: "m-organize-table-columns__item-title" },
                    [
                      column.fixed
                        ? _c("m-icon", { attrs: { name: "m-svg__lock" } })
                        : _c("m-icon", {
                            attrs: { name: "m-svg__drag-vertical" }
                          }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "m-organize-table-columns__item-title-text"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(column.title) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !column.fixed
                    ? _c("m-icon-button", {
                        attrs: { "button-size": "20px", "icon-name": "delete" },
                        on: {
                          click: function($event) {
                            return _vm.removeColumn(column)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.numberHiddenColumns > 0
        ? [
            _c("div", { staticClass: "m-organize-table-columns__header" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("f-m-i18n")("m-organize-table-columns:helper-2")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "m-organize-table-columns__hidden-columns" },
              _vm._l(_vm.hiddenColumns, function(column, index) {
                return _c(
                  "m-list-item",
                  {
                    key: index,
                    staticClass: "m-organize-table-columns__list-item"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "m-organize-table-columns__item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-organize-table-columns__item-title"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "m-organize-table-columns__item-title-text"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(column.title) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("m-add", {
                          attrs: {
                            title: _vm._f("f-m-i18n")(
                              "m-organize-table-columns:add-column"
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.addColumn(column)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-28c4efa6'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.ts ***!
  \******************************************************************************************************/
/*! exports provided: MOrganizeTableColumns, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOrganizeTableColumns", function() { return MOrganizeTableColumns; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_sortable_sortable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../directives/sortable/sortable */ "./src/directives/sortable/sortable.ts");
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _add_add__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../add/add */ "./src/components/add/add.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _list_item_list_item__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../list-item/list-item */ "./src/components/list-item/list-item.ts");
/* harmony import */ var _organize_table_columns_html_style_organize_table_columns_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./organize-table-columns.html?style=./organize-table-columns.scss */ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.html?style=./organize-table-columns.scss");
/* harmony import */ var _organize_table_columns_html_style_organize_table_columns_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_organize_table_columns_html_style_organize_table_columns_scss__WEBPACK_IMPORTED_MODULE_14__);
var _a, _b, _c;















var MOrganizeTableColumns = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOrganizeTableColumns, _super);
    function MOrganizeTableColumns() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayedColumns = [];
        _this.hiddenColumns = [];
        return _this;
    }
    MOrganizeTableColumns.prototype.setInternalsColumns = function () {
        var internalColumns = JSON.parse(JSON.stringify(this.columns.filter(function (c) { return c.ignored === undefined || !c.ignored; })));
        var canBeFixed = true;
        for (var i = 0; i < internalColumns.length; i++) {
            if (internalColumns[i].fixed && !(internalColumns[i].visible === undefined || internalColumns[i].visible)) {
                // Une colonne ne peut pas être fixed et non visible
                throw new Error(this.$i18n.translate('m-organize-table-columns:error.fixed1'));
            }
            if (!canBeFixed && internalColumns[i].fixed) {
                // Une colonne ne peut pas être fixed et après une colonne non fixed
                throw new Error(this.$i18n.translate('m-organize-table-columns:error.fixed2'));
            }
            if (internalColumns[i].fixed === undefined || !internalColumns[i].fixed) {
                canBeFixed = false;
            }
        }
        this.displayedColumns = internalColumns.filter(function (c) { return c.visible === undefined || c.visible; });
        this.hiddenColumns = internalColumns.filter(function (c) { return (c.fixed === undefined || c.fixed === false) && c.visible === false; });
    };
    Object.defineProperty(MOrganizeTableColumns.prototype, "numberDisplayedColumns", {
        get: function () {
            return this.displayedColumns.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOrganizeTableColumns.prototype, "numberHiddenColumns", {
        get: function () {
            return this.hiddenColumns.length;
        },
        enumerable: true,
        configurable: true
    });
    MOrganizeTableColumns.prototype.removeColumn = function (column) {
        this.displayedColumns.splice(this.displayedColumns.findIndex(function (c) { return c.id === column.id; }), 1);
        column.visible = false;
        this.hiddenColumns.push(column);
        this.emitReorganize(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.displayedColumns, this.hiddenColumns));
    };
    MOrganizeTableColumns.prototype.addColumn = function (column) {
        this.hiddenColumns.splice(this.hiddenColumns.findIndex(function (c) { return c.id === column.id; }), 1);
        column.visible = true;
        this.displayedColumns.push(column);
        this.emitReorganize(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.displayedColumns, this.hiddenColumns));
    };
    MOrganizeTableColumns.prototype.moveColumn = function (event) {
        this.moveItemInList(this.displayedColumns, event.sortInfo.oldPosition, event.sortInfo.newPosition);
        this.emitReorganize(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.displayedColumns, this.hiddenColumns));
    };
    MOrganizeTableColumns.prototype.isDraggable = function (column) {
        return column.fixed !== undefined && column.fixed ? 'false' : 'true';
    };
    MOrganizeTableColumns.prototype.isDroppable = function (column) {
        return column.fixed !== undefined && column.fixed ? 'false' : 'true';
    };
    MOrganizeTableColumns.prototype.emitReorganize = function (columns) {
    };
    MOrganizeTableColumns.prototype.moveItemInList = function (arr, oldIndex, newIndex) {
        var element = arr[oldIndex];
        arr.splice(oldIndex, 1);
        arr.splice(newIndex, 0, element);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MOrganizeTableColumns.prototype, "columns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('columns', { immediate: true })
    ], MOrganizeTableColumns.prototype, "setInternalsColumns", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('reorganize')
    ], MOrganizeTableColumns.prototype, "emitReorganize", null);
    MOrganizeTableColumns = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _organize_table_columns_html_style_organize_table_columns_scss__WEBPACK_IMPORTED_MODULE_14___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["ADD_NAME"]] = _add_add__WEBPACK_IMPORTED_MODULE_8__["MAdd"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_9__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["LIST_ITEM_NAME"]] = _list_item_list_item__WEBPACK_IMPORTED_MODULE_13__["MListItem"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_11__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_10__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_12__["MIcon"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_5__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_6__["i18nFilter"],
                _b),
            directives: (_c = {},
                _c[_directives_directive_names__WEBPACK_IMPORTED_MODULE_3__["SORTABLE_NAME"]] = _directives_sortable_sortable__WEBPACK_IMPORTED_MODULE_4__["SortableDirective"],
                _c)
        })
    ], MOrganizeTableColumns);
    return MOrganizeTableColumns;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var OrganizeTableColumnsPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_10__["ORGANIZE_TABLE_COLUMNS_NAME"], MOrganizeTableColumns);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (OrganizeTableColumnsPlugin);


/***/ }),

/***/ "./src/components/overlay/overlay.html?style=./overlay.scss":
/*!******************************************************************!*\
  !*** ./src/components/overlay/overlay.html?style=./overlay.scss ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=058310c7!./overlay.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=058310c7!./src/components/overlay/overlay.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "baseWindow", staticClass: "m-overlay" },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      _vm.portalCreated
        ? _c(
            "portal",
            { attrs: { "target-el": _vm.portalTargetSelector } },
            [
              _c(
                "transition",
                {
                  attrs: { name: "m--is", duration: { enter: 800, leave: 600 } }
                },
                [
                  _vm.portalMounted
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.propOpen,
                              expression: "propOpen"
                            }
                          ],
                          ref: "modalWrap",
                          staticClass: "m-overlay__wrap",
                          class: [
                            { "m--is-disabled": _vm.disabled },
                            _vm.className
                          ]
                        },
                        [
                          _c(
                            "section",
                            {
                              ref: "article",
                              staticClass: "m-overlay__article"
                            },
                            [
                              _c(
                                "header",
                                {
                                  staticClass: "m-overlay__header",
                                  class: {
                                    "m--no-padding":
                                      !_vm.padding || !_vm.paddingHeader
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "m-overlay__header-left" },
                                    [_vm._t("header")],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.$slots["header-right"]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "m-overlay__header-right"
                                        },
                                        [_vm._t("header-right")],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "m-overlay__body",
                                  class: { "m--is-android": _vm.hasKeyboard }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "body",
                                      staticClass: "m-overlay__content",
                                      class: {
                                        "m--no-padding":
                                          !_vm.padding || !_vm.paddingBody
                                      },
                                      on: {
                                        focusin: _vm.onFocusIn,
                                        focusout: _vm.onFocusOut
                                      }
                                    },
                                    [_vm._t("default")],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.hasKeyboard && !_vm.hideFooter
                                    ? _c(
                                        "footer",
                                        {
                                          ref: "footer",
                                          staticClass: "m-overlay__footer",
                                          class: {
                                            "m--no-padding":
                                              !_vm.padding || !_vm.paddingFooter
                                          }
                                        },
                                        [
                                          _vm._t("footer", [
                                            _c(
                                              "m-button",
                                              {
                                                staticClass:
                                                  "m-overlay__save-button",
                                                attrs: {
                                                  disabled:
                                                    _vm.isSaveButtonDisabled,
                                                  waiting: _vm.isWaiting
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.save()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm._f("f-m-i18n")(
                                                        "m-overlay:save"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "m-button",
                                              {
                                                attrs: {
                                                  skin: "secondary",
                                                  disabled: _vm.isWaiting
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.cancel()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm._f("f-m-i18n")(
                                                        "m-overlay:cancel"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.hasKeyboard && !_vm.hideFooter
                                ? _c(
                                    "footer",
                                    {
                                      ref: "footer",
                                      staticClass:
                                        "m-overlay__footer m--no-keyboard",
                                      class: {
                                        "m--no-padding":
                                          !_vm.padding || !_vm.paddingFooter
                                      }
                                    },
                                    [
                                      _vm._t("footer", [
                                        _c(
                                          "m-button",
                                          {
                                            staticClass:
                                              "m-overlay__save-button",
                                            attrs: {
                                              disabled:
                                                _vm.isSaveButtonDisabled,
                                              waiting: _vm.isWaiting
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.save()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm._f("f-m-i18n")(
                                                    "m-overlay:save"
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "m-button",
                                          {
                                            attrs: {
                                              skin: "secondary",
                                              disabled: _vm.isWaiting
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.cancel()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm._f("f-m-i18n")(
                                                    "m-overlay:cancel"
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-058310c7'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/overlay/overlay.ts":
/*!*******************************************!*\
  !*** ./src/components/overlay/overlay.ts ***!
  \*******************************************/
/*! exports provided: MOverlay, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOverlay", function() { return MOverlay; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/user-agent/user-agent */ "./src/utils/user-agent/user-agent.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _overlay_html_style_overlay_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./overlay.html?style=./overlay.scss */ "./src/components/overlay/overlay.html?style=./overlay.scss");
/* harmony import */ var _overlay_html_style_overlay_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_overlay_html_style_overlay_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a, _b;












var MOverlay = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOverlay, _super);
    function MOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasKeyboard = false;
        return _this;
    }
    MOverlay.prototype.emitSave = function (event) { };
    MOverlay.prototype.emitCancel = function (event) { };
    MOverlay.prototype.mounted = function () {
        this.as().transitionDuration = _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__["PortalTransitionDuration"].Regular + _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__["PortalTransitionDuration"].XSlow;
    };
    Object.defineProperty(MOverlay.prototype, "popupBody", {
        get: function () {
            return (this.$refs.article).querySelector('.m-popup__body');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOverlay.prototype, "isAndroid", {
        get: function () {
            return _utils_user_agent_user_agent__WEBPACK_IMPORTED_MODULE_6__["default"].isAndroid();
        },
        enumerable: true,
        configurable: true
    });
    MOverlay.prototype.onFocusIn = function () {
        if (this.isAndroid) {
            this.hasKeyboard = true;
        }
    };
    MOverlay.prototype.onFocusOut = function () {
        var _this = this;
        if (!this.isAndroid) {
            return;
        }
        setTimeout(function () {
            _this.hasKeyboard = false;
        });
    };
    MOverlay.prototype.handlesFocus = function () {
        return this.focusManagement;
    };
    MOverlay.prototype.doCustomPropOpen = function (value) {
        return false;
    };
    MOverlay.prototype.getBackdropMode = function () {
        return _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__["BackdropMode"].ScrollOnly;
    };
    MOverlay.prototype.getPortalElement = function () {
        return this.$refs.article;
    };
    Object.defineProperty(MOverlay.prototype, "isSaveButtonDisabled", {
        get: function () {
            return this.disableSaveButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MOverlay.prototype, "isWaiting", {
        get: function () {
            return this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    MOverlay.prototype.save = function (event) {
        this.emitSave(event);
    };
    MOverlay.prototype.cancel = function (event) {
        this.emitCancel(event);
        this.close();
    };
    MOverlay.prototype.close = function () {
        this.as().tryClose();
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOverlay.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOverlay.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOverlay.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOverlay.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOverlay.prototype, "paddingFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MOverlay.prototype, "disableSaveButton", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MOverlay.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MOverlay.prototype, "hideFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('save')
    ], MOverlay.prototype, "emitSave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('cancel')
    ], MOverlay.prototype, "emitCancel", null);
    MOverlay = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _overlay_html_style_overlay_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_8__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_10__["MI18n"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b),
            mixins: [_mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__["Portal"]]
        })
    ], MOverlay);
    return MOverlay;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var OverlayPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["OVERLAY_NAME"], MOverlay);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (OverlayPlugin);


/***/ }),

/***/ "./src/components/pagination/pagination.html?style=./pagination.scss":
/*!***************************************************************************!*\
  !*** ./src/components/pagination/pagination.html?style=./pagination.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bc006eae!./pagination.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=bc006eae!./src/components/pagination/pagination.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-pagination", class: { "m--is-loading": _vm.loading } },
    [
      _c("div", { ref: "status", staticClass: "m-pagination__status" }, [
        _vm._v(_vm._s(_vm.status))
      ]),
      _vm._v(" "),
      _vm.pagesTotal > 1
        ? _c("div", { staticClass: "m-pagination__indicator" })
        : _vm._e(),
      _vm._v(" "),
      _vm.pagesTotal > 1
        ? _c(
            "div",
            { ref: "navigation", staticClass: "m-pagination__nav" },
            [
              _c(
                "m-icon-button",
                {
                  ref: "previous",
                  staticClass: "m-pagination__previous-button",
                  attrs: {
                    disabled: _vm.firstPageSelected || _vm.loading,
                    "icon-name": "m-svg__chevron-circle--left",
                    title: _vm._f("f-m-i18n")("m-pagination:previous"),
                    skin: "link"
                  },
                  on: {
                    click: function($event) {
                      return _vm.goToPage(_vm.value - 1)
                    }
                  }
                },
                [_c("m-i18n", { attrs: { k: "m-pagination:previous" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "m-pagination__pages" },
                _vm._l(_vm.paginationItems, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "m-pagination__item",
                      class: {
                        "m-pagination__item--ellipsis": item.ellipsis,
                        "m--is-active": _vm.isPageActive(parseInt(item.label))
                      }
                    },
                    [
                      item.clickable
                        ? _c(
                            "m-link",
                            {
                              staticClass: "m-pagination__item--link",
                              attrs: { disabled: _vm.loading, mode: "button" },
                              on: {
                                click: function($event) {
                                  _vm.goToPage(parseInt(item.label))
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        : _c(
                            "span",
                            { staticClass: "m-pagination__item--text" },
                            [_vm._v(_vm._s(item.label))]
                          )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "m-icon-button",
                {
                  ref: "next",
                  staticClass: "m-pagination__next-button",
                  attrs: {
                    disabled: _vm.lastPageSelected || _vm.loading,
                    "icon-name": "m-svg__chevron-circle--right",
                    title: _vm._f("f-m-i18n")("m-pagination:next"),
                    skin: "link"
                  },
                  on: {
                    click: function($event) {
                      return _vm.goToPage(_vm.value + 1)
                    }
                  }
                },
                [_c("m-i18n", { attrs: { k: "m-pagination:next" } })],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-bc006eae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/pagination/pagination.ts":
/*!*************************************************!*\
  !*** ./src/components/pagination/pagination.ts ***!
  \*************************************************/
/*! exports provided: MPagination, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPagination", function() { return MPagination; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _pagination_html_style_pagination_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pagination.html?style=./pagination.scss */ "./src/components/pagination/pagination.html?style=./pagination.scss");
/* harmony import */ var _pagination_html_style_pagination_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_pagination_html_style_pagination_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a, _b;














var FIRST_PAGE = 1;
var DELTA_DESKTOP = 4;
var DELTA_MOBILE = 1;
var MPagination = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPagination, _super);
    function MPagination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MPagination.prototype.goToPage = function (value) { };
    Object.defineProperty(MPagination.prototype, "pagesTotal", {
        get: function () {
            return Math.ceil(this.itemsTotal / this.itemsPerPage);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPagination.prototype, "paginationItems", {
        get: function () {
            var items = [];
            var delta = this.as().isMqMinS ? DELTA_DESKTOP : DELTA_MOBILE;
            var minDelta;
            var maxDelta;
            if (this.value <= FIRST_PAGE + delta) {
                var adjustDelta = (delta * 2) - (this.value - (FIRST_PAGE + 1));
                minDelta = FIRST_PAGE + 1;
                maxDelta = this.value + adjustDelta > this.pagesTotal - 1 ? this.pagesTotal - 1 : this.value + adjustDelta;
            }
            else if (this.value >= this.pagesTotal - delta) {
                var adjustDelta = (delta * 2) - ((this.pagesTotal - 1) - this.value);
                minDelta = this.value - adjustDelta < FIRST_PAGE + 1 ? FIRST_PAGE + 1 : this.value - adjustDelta;
                maxDelta = this.pagesTotal - 1;
            }
            else {
                minDelta = this.value - delta < FIRST_PAGE + 1 ? FIRST_PAGE + 1 : this.value - delta;
                maxDelta = this.value + delta > this.pagesTotal - 1 ? this.pagesTotal - 1 : this.value + delta;
            }
            items.push({ label: FIRST_PAGE.toString(), clickable: this.isPageActive(FIRST_PAGE) ? false : true });
            if (minDelta !== FIRST_PAGE + 1) {
                items.push({ label: this.$i18n.translate('m-pagination:ellipsis'), clickable: false, ellipsis: true });
            }
            for (var i = minDelta; i <= maxDelta; i++) {
                items.push({ label: i.toString(), clickable: this.isPageActive(i) ? false : true });
            }
            if (maxDelta !== this.pagesTotal - 1) {
                items.push({ label: this.$i18n.translate('m-pagination:ellipsis'), clickable: false, ellipsis: true });
            }
            items.push({ label: this.pagesTotal.toString(), clickable: this.isPageActive(this.pagesTotal) ? false : true });
            return items;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPagination.prototype, "firstPageSelected", {
        get: function () {
            return this.value === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPagination.prototype, "lastPageSelected", {
        get: function () {
            return this.value === this.pagesTotal;
        },
        enumerable: true,
        configurable: true
    });
    MPagination.prototype.pageFirstItemIndex = function () {
        return ((this.value - 1) * this.itemsPerPage) + 1;
    };
    MPagination.prototype.pageLastItemIndex = function () {
        return Math.min(this.value * this.itemsPerPage, this.itemsTotal);
    };
    Object.defineProperty(MPagination.prototype, "status", {
        get: function () {
            var key = this.itemsTotal <= this.itemsPerPage ?
                'm-pagination:status-single' : 'm-pagination:status';
            return this.$i18n.translate(key, {
                idxFirst: this.pageFirstItemIndex,
                idxLast: this.pageLastItemIndex,
                nbResults: this.itemsTotal
            }, this.itemsTotal, undefined, undefined, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_6__["FormatMode"].Sprintf);
        },
        enumerable: true,
        configurable: true
    });
    MPagination.prototype.isPageActive = function (page) {
        return page === this.value;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: FIRST_PAGE })
    ], MPagination.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ required: true })
    ], MPagination.prototype, "itemsTotal", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 20 })
    ], MPagination.prototype, "itemsPerPage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MPagination.prototype, "loading", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change')
    ], MPagination.prototype, "goToPage", null);
    MPagination = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _pagination_html_style_pagination_scss__WEBPACK_IMPORTED_MODULE_13___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_11__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_12__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__["MI18n"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"]]
        })
    ], MPagination);
    return MPagination;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var PaginationPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["PAGINATION_NAME"], MPagination);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PaginationPlugin);


/***/ }),

/***/ "./src/components/panel/panel.html?style=./panel.scss":
/*!************************************************************!*\
  !*** ./src/components/panel/panel.html?style=./panel.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=74129ec2!./panel.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=74129ec2!./src/components/panel/panel.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "m-panel",
      class: {
        "m--is-skin-light": _vm.lightSkin,
        "m--is-skin-dark": _vm.darkSkin,
        "m--is-skin-darker": _vm.darkerSkin,
        "m--has-shadow": _vm.shadow,
        "m--has-border": _vm.border,
        "m--has-border-large": _vm.borderLarge,
        "m--has-padding-large": _vm.paddingLarge,
        "m--is-highlighted": _vm.highlighted
      },
      on: { click: _vm.onClick }
    },
    [
      _vm.$slots.header || _vm.$slots["header-right-content"]
        ? _c(
            "header",
            {
              staticClass: "m-panel__header",
              class: {
                "m--no-padding": !_vm.hasPaddingHeader,
                "m--is-right-content-alone": !(
                  _vm.$slots.header || _vm.$slots["header-right-content"]
                ),
                "m--has-menu": _vm.$slots.menu
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-panel__header__content",
                  attrs: {
                    "aria-hidden": !(
                      _vm.$slots.header || _vm.$slots["header-right-content"]
                    )
                  }
                },
                [_vm._t("header")],
                2
              ),
              _vm._v(" "),
              _vm.$slots["header-right-content"]
                ? _c(
                    "div",
                    { staticClass: "m-panel__header__content-right" },
                    [_vm._t("header-right-content")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.menu
                ? _c(
                    "div",
                    { staticClass: "m-panel__header__menu" },
                    [_vm._t("menu")],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "div",
            {
              staticClass: "m-panel__body",
              class: {
                "m--no-padding": !_vm.hasPaddingBody,
                "m--has-padding-top": !_vm.$slots.header && _vm.hasPaddingBody,
                "m--has-padding-bottom": _vm.hasPaddingBody
              }
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c(
            "footer",
            {
              staticClass: "m-panel__footer",
              class: { "m--no-padding": !_vm.hasPaddingFooter }
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-74129ec2'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/panel/panel.ts":
/*!***************************************!*\
  !*** ./src/components/panel/panel.ts ***!
  \***************************************/
/*! exports provided: MPanelSkin, MPanel, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPanelSkin", function() { return MPanelSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPanel", function() { return MPanel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _panel_html_style_panel_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./panel.html?style=./panel.scss */ "./src/components/panel/panel.html?style=./panel.scss");
/* harmony import */ var _panel_html_style_panel_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_panel_html_style_panel_scss__WEBPACK_IMPORTED_MODULE_5__);






var MPanelSkin;
(function (MPanelSkin) {
    MPanelSkin["Light"] = "light";
    MPanelSkin["Dark"] = "dark";
    MPanelSkin["Darker"] = "darker";
})(MPanelSkin || (MPanelSkin = {}));
var MPanel = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPanel, _super);
    function MPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MPanel.prototype.onClick = function () { };
    Object.defineProperty(MPanel.prototype, "lightSkin", {
        get: function () {
            return this.skin === MPanelSkin.Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPanel.prototype, "darkSkin", {
        get: function () {
            return this.skin === MPanelSkin.Dark;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPanel.prototype, "darkerSkin", {
        get: function () {
            return this.skin === MPanelSkin.Darker;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPanel.prototype, "hasPaddingHeader", {
        get: function () {
            return this.paddingHeader && this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPanel.prototype, "hasPaddingBody", {
        get: function () {
            return this.paddingBody && this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPanel.prototype, "hasPaddingFooter", {
        get: function () {
            return this.paddingFooter && this.padding;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MPanelSkin.Light,
            validator: function (value) {
                return value === MPanelSkin.Light ||
                    value === MPanelSkin.Dark ||
                    value === MPanelSkin.Darker;
            }
        })
    ], MPanel.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPanel.prototype, "highlighted", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPanel.prototype, "shadow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPanel.prototype, "border", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPanel.prototype, "borderLarge", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPanel.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPanel.prototype, "paddingLarge", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPanel.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPanel.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPanel.prototype, "paddingFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MPanel.prototype, "onClick", null);
    MPanel = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _panel_html_style_panel_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MPanel);
    return MPanel;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var PanelPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["PANEL_NAME"], MPanel);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PanelPlugin);


/***/ }),

/***/ "./src/components/periodpicker/periodpicker.html?style=./periodpicker.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/periodpicker/periodpicker.html?style=./periodpicker.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6dce6849!./periodpicker.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6dce6849!./src/components/periodpicker/periodpicker.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-periodpicker" },
    [
      _c("div", { staticClass: "m-periodpicker__body" }, [
        _c(
          "div",
          {
            staticClass: "m-periodpicker__item",
            style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
          },
          [
            _vm._t("first", null, {
              props: _vm.firstInputState.props,
              handlers: _vm.firstInputState.handlers
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-periodpicker__item",
            style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
          },
          [
            _vm._t("second", null, {
              props: _vm.secondInputState.props,
              handlers: _vm.secondInputState.handlers
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("m-validation-message", {
        attrs: {
          disabled: _vm.isDisabled,
          waiting: _vm.isWaiting,
          error: _vm.hasTextfieldError,
          "error-message": _vm.errorMessage,
          valid: _vm.isTextfieldValid,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-6dce6849'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/periodpicker/periodpicker.ts":
/*!*****************************************************!*\
  !*** ./src/components/periodpicker/periodpicker.ts ***!
  \*****************************************************/
/*! exports provided: MDateRange, MPeriodpicker, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDateRange", function() { return MDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPeriodpicker", function() { return MPeriodpicker; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _periodpicker_html_style_periodpicker_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./periodpicker.html?style=./periodpicker.scss */ "./src/components/periodpicker/periodpicker.html?style=./periodpicker.scss");
/* harmony import */ var _periodpicker_html_style_periodpicker_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_periodpicker_html_style_periodpicker_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var MDateRange = /** @class */ (function () {
    function MDateRange(from, to, hasValidFormat) {
        this.from = from;
        this.to = to;
        this.hasValidFormat = hasValidFormat;
    }
    Object.defineProperty(MDateRange.prototype, "fromIsoString", {
        get: function () {
            if (!this.from) {
                return undefined;
            }
            if (typeof this.from === 'string') {
                return this.from.includes('T') ? this.from : new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_6__["default"](this.from).toISOString();
            }
            else {
                return this.from.toISOString();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MDateRange.prototype, "toIsoString", {
        get: function () {
            if (!this.to) {
                return undefined;
            }
            if (typeof this.to === 'string') {
                return this.to.includes('T') ? this.to : new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_6__["default"](this.to).endOfDay().toISOString();
            }
            else {
                return this.to.toISOString();
            }
        },
        enumerable: true,
        configurable: true
    });
    return MDateRange;
}());

var MPeriodpicker = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPeriodpicker, _super);
    function MPeriodpicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dateFromInternalValue = '';
        _this.dateToInternalValue = '';
        _this.fromIsFocused = false;
        _this.toIsFocused = false;
        _this.beginSelection = false;
        return _this;
    }
    MPeriodpicker_1 = MPeriodpicker;
    MPeriodpicker.prototype.emitNewValue = function (newValue) { };
    Object.defineProperty(MPeriodpicker.prototype, "firstInputState", {
        get: function () {
            var _this = this;
            return {
                props: {
                    focus: this.fromIsFocused,
                    value: this.dateFromInternalValue,
                    min: this.min,
                    max: this.max,
                    disabled: this.as().isDisabled,
                    waiting: this.as().isWaiting,
                    error: this.as().hasError,
                    valid: this.as().isValid,
                    readonly: this.as().readonly
                },
                handlers: {
                    change: function (newValue) { return _this.onDateFromChange(newValue); },
                    blur: function () {
                        _this.fromIsFocused = false;
                        if (!_this.toIsFocused) {
                            _this.endSelection();
                        }
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPeriodpicker.prototype, "secondInputState", {
        get: function () {
            var _this = this;
            return {
                props: {
                    focus: this.toIsFocused,
                    value: this.dateToInternalValue,
                    min: this.minDateTo,
                    max: this.max,
                    disabled: this.as().isDisabled,
                    waiting: this.as().isWaiting,
                    error: this.as().hasError,
                    valid: this.as().isValid,
                    readonly: this.as().readonly
                },
                handlers: {
                    change: function (newValue) { return _this.onDateToChange(newValue); },
                    blur: function () {
                        _this.toIsFocused = false;
                        if (_this.beginSelection) {
                            _this.beginSelection = false;
                            _this.endSelection();
                        }
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPeriodpicker.prototype, "internalValue", {
        get: function () {
            return new MDateRange(this.dateFromInternalValue, this.dateToInternalValue, MPeriodpicker_1.validateDateFormat(this.dateFromInternalValue)
                && MPeriodpicker_1.validateDateFormat(this.dateToInternalValue));
        },
        enumerable: true,
        configurable: true
    });
    MPeriodpicker.prototype.onValueChange = function (value) {
        this.dateFromInternalValue = MPeriodpicker_1.formatIsoDateToLocalString((this.value || { from: undefined }).from);
        this.dateToInternalValue = MPeriodpicker_1.formatIsoDateToLocalString((this.value || { to: undefined }).to);
    };
    Object.defineProperty(MPeriodpicker.prototype, "minDateTo", {
        get: function () {
            return this.internalValue.from ? this.internalValue.from : this.min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPeriodpicker.prototype, "hasTextfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPeriodpicker.prototype, "isTextfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    MPeriodpicker.prototype.onDateFromChange = function (newValue) {
        this.beginSelection = true;
        this.dateFromInternalValue = newValue;
        if (newValue) {
            var newDateValue = this.getNewModelValue(newValue);
            if (newValue && newDateValue) {
                this.toIsFocused = true;
            }
        }
    };
    MPeriodpicker.prototype.onDateToChange = function (newValue) {
        this.beginSelection = true;
        this.dateToInternalValue = newValue;
        if (newValue) {
            var newDateValue = this.getNewModelValue(newValue, true);
            if (newValue && newDateValue) {
                this.endSelection();
            }
        }
    };
    MPeriodpicker.prototype.getNewModelValue = function (newValue, endOfDay) {
        if (endOfDay === void 0) { endOfDay = false; }
        if (!newValue
            || (newValue.toString().length !== 10 && !(newValue instanceof Date) && !isFinite(newValue))
            || !MPeriodpicker_1.validateDateFormat(newValue.toString())) {
            return;
        }
        var modulDate = new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_6__["default"](newValue);
        var isoString = endOfDay ? modulDate.endOfDay().toISOString() : modulDate.beginOfDay().toISOString();
        return new Date(isoString);
    };
    MPeriodpicker.prototype.endSelection = function () {
        var newDateFrom = this.convertToIso ? this.internalDateFromIsoString : this.dateFromInternalValue;
        var newDateTo = this.convertToIso ? this.internalDateToIsoString : this.dateToInternalValue;
        var isDateFromValid = MPeriodpicker_1.validateDateFormat(this.dateFromInternalValue);
        var isDateToValid = MPeriodpicker_1.validateDateFormat(this.dateToInternalValue);
        this.emitNewValue(new MDateRange(isDateFromValid ? newDateFrom : this.dateFromInternalValue, isDateToValid ? newDateTo : this.dateToInternalValue, isDateFromValid && isDateToValid));
        this.beginSelection = false;
    };
    Object.defineProperty(MPeriodpicker.prototype, "internalDateFromIsoString", {
        get: function () {
            return this.getNewModelValue(this.dateFromInternalValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPeriodpicker.prototype, "internalDateToIsoString", {
        get: function () {
            return this.getNewModelValue(this.dateToInternalValue, true);
        },
        enumerable: true,
        configurable: true
    });
    MPeriodpicker.validateDateFormat = function (dateString) {
        try {
            return new _utils_modul_date_modul_date__WEBPACK_IMPORTED_MODULE_6__["default"](dateString) ? true : false;
        }
        catch (_a) {
            return false;
        }
    };
    /**
     * This method convert a date or a iso string into a local date string with format YYYY-MM-DD
     *
     * @param date
     */
    MPeriodpicker.formatIsoDateToLocalString = function (date) {
        if (!date) {
            return '';
        }
        if (!this.validateDateFormat(date)) {
            return date;
        }
        var _date = undefined;
        if (typeof date === 'string') {
            _date = new Date(date.includes('T') ? date : new Date(date + "T00:00"));
        }
        else if (date instanceof Date) {
            _date = date;
        }
        if (!_date) {
            return;
        }
        var month = '' + (_date.getMonth() + 1);
        var day = '' + _date.getDate();
        var year = _date.getFullYear();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    };
    var MPeriodpicker_1;
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPeriodpicker.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPeriodpicker.prototype, "min", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPeriodpicker.prototype, "max", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MPeriodpicker.prototype, "convertToIso", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], MPeriodpicker.prototype, "emitNewValue", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], MPeriodpicker.prototype, "onValueChange", null);
    MPeriodpicker = MPeriodpicker_1 = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _periodpicker_html_style_periodpicker_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_9__["MValidationMessage"],
                _a),
            mixins: [
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"],
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__["InputWidth"]
            ]
        })
    ], MPeriodpicker);
    return MPeriodpicker;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var PeriodpickerPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["PERIODPICKER_NAME"], MPeriodpicker);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PeriodpickerPlugin);


/***/ }),

/***/ "./src/components/plus/plus.html?style=./plus.scss":
/*!*********************************************************!*\
  !*** ./src/components/plus/plus.html?style=./plus.scss ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c9caf92e!./plus.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c9caf92e!./src/components/plus/plus.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    staticClass: "m-plus",
    class: [
      "m--is-skin-" + _vm.skin,
      {
        "m--is-open": _vm.open,
        "m--is-disabled": _vm.disabled,
        "m--is-large": _vm.large,
        "m--has-border": _vm.border
      }
    ],
    attrs: { title: _vm.title },
    on: { click: _vm.onClick }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-c9caf92e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/plus/plus.ts":
/*!*************************************!*\
  !*** ./src/components/plus/plus.ts ***!
  \*************************************/
/*! exports provided: MPlusSkin, MPlus, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPlusSkin", function() { return MPlusSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPlus", function() { return MPlus; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _plus_html_style_plus_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./plus.html?style=./plus.scss */ "./src/components/plus/plus.html?style=./plus.scss");
/* harmony import */ var _plus_html_style_plus_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_plus_html_style_plus_scss__WEBPACK_IMPORTED_MODULE_5__);






var MPlusSkin;
(function (MPlusSkin) {
    MPlusSkin["Default"] = "default";
    MPlusSkin["Light"] = "light";
    MPlusSkin["CurrentColor"] = "current-color";
})(MPlusSkin || (MPlusSkin = {}));
var MPlus = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPlus, _super);
    function MPlus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MPlus.prototype, "title", {
        get: function () {
            return this.open ? this.titleClose : this.titleOpen;
        },
        enumerable: true,
        configurable: true
    });
    MPlus.prototype.onClick = function (event) {
        if (!this.disabled) {
            this.$emit('click', event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "titleOpen", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "titleClose", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "large", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "border", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MPlusSkin.Default,
            validator: function (value) {
                return value === MPlusSkin.Default ||
                    value === MPlusSkin.Light ||
                    value === MPlusSkin.CurrentColor;
            }
        })
    ], MPlus.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPlus.prototype, "disabled", void 0);
    MPlus = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _plus_html_style_plus_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MPlus);
    return MPlus;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var PlusPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["PLUS_NAME"], MPlus);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PlusPlugin);


/***/ }),

/***/ "./src/components/popper/popper.html?style=./popper.scss":
/*!***************************************************************!*\
  !*** ./src/components/popper/popper.html?style=./popper.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e450952e!./popper.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e450952e!./src/components/popper/popper.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-popper", class: { "m--is-open": _vm.propOpen } },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      (_vm.$slots.default || _vm.$slots.header || _vm.$slots.footer) &&
      _vm.portalCreated
        ? _c(
            "portal",
            { attrs: { "target-el": _vm.portalTargetSelector } },
            [
              _c(
                "transition",
                {
                  attrs: { name: "m--is" },
                  on: {
                    "before-enter": _vm.onBeforeEnter,
                    enter: _vm.onEnter,
                    "after-enter": _vm.onAfterEnter,
                    "enter-cancelled": _vm.onEnterCancelled,
                    "before-leave": _vm.onAfterLeave,
                    leave: _vm.onLeave,
                    "after-leave": _vm.onAfterLeave,
                    "leave-cancelled": _vm.onLeaveCancelled
                  }
                },
                [
                  _vm.portalMounted
                    ? _c(
                        "article",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.propOpen,
                              expression: "propOpen"
                            }
                          ],
                          ref: "popper",
                          staticClass: "m-popper__article",
                          class: [
                            {
                              "m--is-default-anim": _vm.defaultAnimActive,
                              "m--is-open": _vm.defaultAnimOpen,
                              "m--has-shadow": _vm.shadow,
                              "m--has-background": _vm.background,
                              "m--is-hidden": _vm.isHidden
                            },
                            "m--is-placement-" + _vm.placement,
                            _vm.className
                          ],
                          style: { width: _vm.width },
                          attrs: {
                            "aria-hidden": !_vm.propOpen || _vm.isHidden
                          }
                        },
                        [
                          _vm.$slots.header
                            ? _c(
                                "header",
                                {
                                  staticClass: "m-popper__header",
                                  class: {
                                    "m--no-padding":
                                      !_vm.padding || !_vm.paddingHeader
                                  }
                                },
                                [_vm._t("header")],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$slots.default
                            ? _c(
                                "div",
                                {
                                  ref: "body",
                                  staticClass: "m-popper__body",
                                  class: {
                                    "m--no-padding":
                                      !_vm.padding || !_vm.paddingBody
                                  }
                                },
                                [_vm._t("default")],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$slots.footer
                            ? _c(
                                "footer",
                                {
                                  staticClass: "m-popper__footer",
                                  class: {
                                    "m--no-padding":
                                      !_vm.padding || !_vm.paddingFooter
                                  }
                                },
                                [_vm._t("footer")],
                                2
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-e450952e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/popper/popper.ts":
/*!*****************************************!*\
  !*** ./src/components/popper/popper.ts ***!
  \*****************************************/
/*! exports provided: MPopperPlacement, MPopper, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPopperPlacement", function() { return MPopperPlacement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPopper", function() { return MPopper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! popper.js */ "popper.js");
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(popper_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _popper_html_style_popper_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./popper.html?style=./popper.scss */ "./src/components/popper/popper.html?style=./popper.scss");
/* harmony import */ var _popper_html_style_popper_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_popper_html_style_popper_scss__WEBPACK_IMPORTED_MODULE_9__);










var MPopperPlacement;
(function (MPopperPlacement) {
    MPopperPlacement["Top"] = "top";
    MPopperPlacement["TopStart"] = "top-start";
    MPopperPlacement["TopEnd"] = "top-end";
    MPopperPlacement["Right"] = "right";
    MPopperPlacement["RightStart"] = "right-start";
    MPopperPlacement["RightEnd"] = "right-end";
    MPopperPlacement["Bottom"] = "bottom";
    MPopperPlacement["BottomStart"] = "bottom-start";
    MPopperPlacement["BottomEnd"] = "bottom-end";
    MPopperPlacement["Left"] = "left";
    MPopperPlacement["LeftStart"] = "left-start";
    MPopperPlacement["LeftEnd"] = "left-end";
})(MPopperPlacement || (MPopperPlacement = {}));
var MPopper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPopper, _super);
    function MPopper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultAnimOpen = false;
        _this.internalOpen = false;
        _this.isHidden = false;
        return _this;
    }
    Object.defineProperty(MPopper.prototype, "popupBody", {
        get: function () {
            return this.$refs.body;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPopper.prototype, "defaultAnimActive", {
        get: function () {
            return !(this.beforeEnter ||
                this.enter ||
                this.afterEnter ||
                this.beforeLeave ||
                this.leave ||
                this.afterLeave);
        },
        enumerable: true,
        configurable: true
    });
    MPopper.prototype.handlesFocus = function () {
        return this.focusManagement;
    };
    MPopper.prototype.getBackdropMode = function () {
        return _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_4__["BackdropMode"].None;
    };
    MPopper.prototype.getPortalElement = function () {
        return this.$refs.popper;
    };
    MPopper.prototype.doCustomPropOpen = function (value, el) {
        var _this = this;
        if (value) {
            if (this.popper === undefined) {
                var options = {
                    placement: this.placement,
                    eventsEnabled: true,
                    onUpdate: function (data) {
                        _this.isHidden = data.hide;
                    },
                    modifiers: {
                        preventOverflow: {
                            boundariesElement: this.boundariesElement ? document.querySelector(this.boundariesElement) : 'window'
                        }
                    }
                };
                var reference = this.as().getTrigger();
                if (!reference) {
                    reference = document.getElementsByTagName('body')[0];
                }
                this.popper = new popper_js__WEBPACK_IMPORTED_MODULE_1___default.a(reference, el, options);
            }
            else {
                this.popper.update();
            }
        }
        return true;
    };
    MPopper.prototype.update = function () {
        if (this.popper !== undefined) {
            this.popper.scheduleUpdate();
        }
    };
    MPopper.prototype.onBeforeEnter = function (el) {
        if (this.beforeEnter) {
            this.beforeEnter(el.children[0]);
        }
    };
    MPopper.prototype.onEnter = function (el, done) {
        var _this = this;
        this.$nextTick(function () {
            _this.update();
            if (_this.enter) {
                _this.enter(el.children[0], done);
            }
            else {
                var transitionDuration = window.getComputedStyle(el).getPropertyValue('transition-duration').slice(1, -1) * 1000;
                setTimeout(function () {
                    _this.defaultAnimOpen = true;
                    done();
                }, transitionDuration);
            }
        });
    };
    MPopper.prototype.onAfterEnter = function (el) {
        if (this.afterEnter) {
            this.afterEnter(el.children[0]);
        }
        this.$emit('after-enter', el);
        this.as().setFocusToPortal();
    };
    MPopper.prototype.onEnterCancelled = function (el) {
        if (this.enterCancelled) {
            this.enterCancelled(el);
        }
    };
    MPopper.prototype.onBeforeLeave = function (el) {
        if (this.beforeLeave) {
            this.beforeLeave(el.children[0]);
        }
    };
    MPopper.prototype.onLeave = function (el, done) {
        if (this.leave) {
            this.leave(el.children[0], done);
        }
        else {
            this.defaultAnimOpen = false;
            setTimeout(done, 300);
        }
    };
    MPopper.prototype.onAfterLeave = function (el) {
        if (this.afterLeave) {
            this.afterLeave(el.children[0]);
        }
        this.as().setFocusToTrigger();
    };
    MPopper.prototype.onLeaveCancelled = function (el) {
        if (this.leaveCancelled) {
            this.leaveCancelled(el.children[0]);
        }
    };
    MPopper.prototype.mounted = function () {
        this.$modul.event.$on('updateAfterResize', this.update);
        // sometimes, the document.click event is stopped causing a menu to stay open, even if another menu has been clicked.
        // mouseup will always be caught even if click is stopped.
        document.addEventListener('mouseup', this.onDocumentClick);
        this.$on('portal-mounted', this.setPopperMutationObserver);
    };
    MPopper.prototype.beforeDestroy = function () {
        this.$modul.event.$off('updateAfterResize', this.update);
        document.removeEventListener('mouseup', this.onDocumentClick);
        if (this.observer) {
            this.observer.disconnect();
        }
        this.$off('portal-mounted', this.setPopperMutationObserver);
        this.destroyPopper();
    };
    MPopper.prototype.setPopperMutationObserver = function () {
        var _this = this;
        this.observer = new MutationObserver(function () {
            _this.update();
        });
        if (this.$refs.popper) {
            this.observer.observe(this.$refs.popper, { subtree: true, childList: true });
        }
    };
    MPopper.prototype.onDocumentClick = function (event) {
        if (this.as().propOpen) {
            var trigger = this.as().getTrigger();
            var element = this.as().getPortalElement();
            if (this.closeOnClickOutside
                && !(element && element.contains(event.target)
                    || this.$el.contains(event.target) ||
                    (trigger && trigger.contains(event.target)))) {
                this.as().propOpen = false;
            }
        }
    };
    MPopper.prototype.destroyPopper = function () {
        if (this.popper !== undefined) {
            this.popper.destroy();
            this.popper = undefined;
            this.isHidden = false;
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MPopperPlacement.Bottom,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__["Enums"].toValueArray(MPopperPlacement).includes(value); }
        })
    ], MPopper.prototype, "placement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPopper.prototype, "closeOnClickOutside", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPopper.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPopper.prototype, "shadow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MPopper.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MPopper.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MPopper.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MPopper.prototype, "paddingFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MPopper.prototype, "background", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: 'auto',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__["REGEX_CSS_NUMBER_VALUE"].test(value) || value === 'auto';
            }
        })
    ], MPopper.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "beforeEnter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "enter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "afterEnter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "enterCancelled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "beforeLeave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "leave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "afterLeave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "leaveCancelled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MPopper.prototype, "boundariesElement", void 0);
    MPopper = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _popper_html_style_popper_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            mixins: [_mixins_portal_portal__WEBPACK_IMPORTED_MODULE_4__["Portal"]]
        })
    ], MPopper);
    return MPopper;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var PopperPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["POPPER_NAME"], MPopper);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PopperPlugin);


/***/ }),

/***/ "./src/components/popup/popup.html?style=./popup.scss":
/*!************************************************************!*\
  !*** ./src/components/popup/popup.html?style=./popup.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=893ed962!./popup.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=893ed962!./src/components/popup/popup.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isSidebarUsed
    ? _c(
        "m-popper",
        {
          ref: "popper",
          staticClass: "m-popup",
          class: { "m--is-inline": _vm.$slots.trigger },
          attrs: {
            id: _vm.id,
            "class-name": _vm.className,
            open: _vm.popperOpen,
            disabled: _vm.disabled,
            placement: _vm.placement,
            "focus-management": _vm.focusManagement,
            "open-trigger": _vm.propOpenTrigger,
            trigger: _vm.propTrigger,
            lazy: _vm.lazy,
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.afterEnter,
            "enter-cancelled": _vm.enterCancelled,
            "before-leave": _vm.beforeLeave,
            leave: _vm.leave,
            "after-leave": _vm.afterLeave,
            "leave-cancelled": _vm.leaveCancelled,
            shadow: _vm.shadow,
            padding: _vm.padding,
            "padding-header": _vm.paddingHeader,
            "padding-body": _vm.paddingBody,
            "padding-footer": _vm.paddingFooter,
            preload: _vm.preload,
            width: _vm.width,
            background: _vm.background,
            "close-on-click-outside": _vm.closeOnBackdrop
          },
          on: {
            "update:open": function($event) {
              _vm.popperOpen = $event
            },
            open: _vm.emitOpen,
            close: _vm.emitClose,
            "portal-mounted": _vm.emitPortalMounted,
            "portal-after-open": _vm.emitPortalAfterOpen
          }
        },
        [
          _vm.$slots.trigger
            ? _c(
                "div",
                { attrs: { slot: "trigger" }, slot: "trigger" },
                [_vm._t("trigger")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("header", null, { slot: "header" }),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm._t("footer", null, { slot: "footer" })
        ],
        2
      )
    : _vm.isSidebarUsed
    ? _c(
        "m-sidebar",
        {
          staticClass: "m-popup",
          class: { "m--is-inline": _vm.$slots.trigger },
          attrs: {
            id: _vm.id,
            "class-name": _vm.className,
            open: _vm.sideBarOpen,
            disabled: _vm.disabled,
            "focus-management": _vm.focusManagement,
            "close-on-backdrop": _vm.closeOnBackdrop,
            preload: _vm.preload,
            lazy: _vm.lazy,
            trigger: _vm.propTrigger,
            padding: _vm.padding,
            "padding-header": _vm.paddingHeader,
            "padding-body": _vm.paddingBody,
            "padding-footer": _vm.paddingFooter,
            "open-trigger": _vm.propOpenTrigger,
            "full-height": _vm.sidebarFullHeight
          },
          on: {
            "update:open": function($event) {
              _vm.sideBarOpen = $event
            },
            open: _vm.emitOpen,
            close: _vm.emitClose,
            "portal-mounted": _vm.emitPortalMounted,
            "portal-after-open": _vm.emitPortalAfterOpen
          }
        },
        [
          _vm.$slots.trigger
            ? _c(
                "div",
                { attrs: { slot: "trigger" }, slot: "trigger" },
                [_vm._t("trigger")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("header", null, { slot: "header" }),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm._t("footer", null, { slot: "footer" })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-893ed962'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/popup/popup.ts":
/*!***************************************!*\
  !*** ./src/components/popup/popup.ts ***!
  \***************************************/
/*! exports provided: MPopup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPopup", function() { return MPopup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _mixins_open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/open-trigger/open-trigger */ "./src/mixins/open-trigger/open-trigger.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _popper_popper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../popper/popper */ "./src/components/popper/popper.ts");
/* harmony import */ var _sidebar_sidebar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../sidebar/sidebar */ "./src/components/sidebar/sidebar.ts");
/* harmony import */ var _popup_html_style_popup_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./popup.html?style=./popup.scss */ "./src/components/popup/popup.html?style=./popup.scss");
/* harmony import */ var _popup_html_style_popup_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_popup_html_style_popup_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var MPopup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPopup, _super);
    function MPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalOpen = false;
        return _this;
    }
    MPopup.prototype.emitUpdateOpen = function (open) { };
    MPopup.prototype.emitOpen = function () { };
    MPopup.prototype.emitClose = function () { };
    MPopup.prototype.emitPortalMounted = function () { };
    MPopup.prototype.emitPortalAfterOpen = function () { };
    MPopup.prototype.onOpenChange = function (open) {
        if (this.disabled) {
            return;
        }
        this.internalOpen = open;
    };
    Object.defineProperty(MPopup.prototype, "popupBody", {
        get: function () {
            return this.$children[0].popupBody;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPopup.prototype, "propOpenTrigger", {
        get: function () {
            return this.openTrigger; // todo: mobile + hover ??
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPopup.prototype, "propTrigger", {
        get: function () {
            return this.trigger || this.as().triggerHook || undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPopup.prototype, "popperOpen", {
        get: function () {
            return !this.isSidebarUsed ? this.internalOpen : false;
        },
        set: function (open) {
            if (this.isSidebarUsed) {
                return;
            }
            this.setOpen(open);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPopup.prototype, "sideBarOpen", {
        get: function () {
            return this.isSidebarUsed ? this.internalOpen : false;
        },
        set: function (open) {
            if (!this.isSidebarUsed) {
                return;
            }
            this.setOpen(open);
        },
        enumerable: true,
        configurable: true
    });
    MPopup.prototype.update = function () {
        if (!this.isSidebarUsed) { // Pas de popper en mobile
            this.$refs.popper.update();
        }
    };
    Object.defineProperty(MPopup.prototype, "isSidebarUsed", {
        get: function () {
            // Use a sidebar instead when in mobile
            return this.as().isMqMaxS;
        },
        enumerable: true,
        configurable: true
    });
    MPopup.prototype.setOpen = function (open) {
        if (this.disabled) {
            return;
        }
        this.internalOpen = open;
        this.emitUpdateOpen(open);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"].Bottom,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_5__["Enums"].toValueArray(_popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopperPlacement"]).includes(value); }
        })
    ], MPopup.prototype, "placement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _mixins_open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_4__["MOpenTrigger"].Click })
    ], MPopup.prototype, "openTrigger", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "closeOnBackdrop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 'auto',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__["REGEX_CSS_NUMBER_VALUE"].test(value) || value === 'auto';
            }
        })
    ], MPopup.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "shadow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "paddingFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "background", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "beforeEnter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "enter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "afterEnter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "enterCancelled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "beforeLeave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "leave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "afterLeave", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "leaveCancelled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "desktopOnly", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "className", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "preload", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "trigger", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MPopup.prototype, "lazy", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MPopup.prototype, "sidebarFullHeight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:open')
    ], MPopup.prototype, "emitUpdateOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('open')
    ], MPopup.prototype, "emitOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close')
    ], MPopup.prototype, "emitClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('portal-mounted')
    ], MPopup.prototype, "emitPortalMounted", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('portal-after-open')
    ], MPopup.prototype, "emitPortalAfterOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open', { immediate: true })
    ], MPopup.prototype, "onOpenChange", null);
    MPopup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _popup_html_style_popup_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["POPPER_NAME"]] = _popper_popper__WEBPACK_IMPORTED_MODULE_9__["MPopper"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["SIDEBAR_NAME"]] = _sidebar_sidebar__WEBPACK_IMPORTED_MODULE_10__["MSidebar"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["MediaQueries"], _mixins_open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_4__["OpenTrigger"]]
        })
    ], MPopup);
    return MPopup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var PopupPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["POPUP_NAME"], MPopup);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PopupPlugin);


/***/ }),

/***/ "./src/components/postalcodefield/postalcodefield.html":
/*!*************************************************************!*\
  !*** ./src/components/postalcodefield/postalcodefield.html ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-maskedfield",
    _vm._g(
      _vm._b(
        {
          staticClass: "m-postalcodefield",
          attrs: { id: _vm.id, "mask-options": _vm.maskOptions }
        },
        "m-maskedfield",
        _vm.bindData,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-1be69163'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/postalcodefield/postalcodefield.ts":
/*!***********************************************************!*\
  !*** ./src/components/postalcodefield/postalcodefield.ts ***!
  \***********************************************************/
/*! exports provided: MPostalCodeCountry, MPostalcodefield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPostalCodeCountry", function() { return MPostalCodeCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPostalcodefield", function() { return MPostalcodefield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _maskedfield_maskedfield__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../maskedfield/maskedfield */ "./src/components/maskedfield/maskedfield.ts");
/* harmony import */ var _postalcodefield_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./postalcodefield.html */ "./src/components/postalcodefield/postalcodefield.html");
/* harmony import */ var _postalcodefield_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_postalcodefield_html__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var MPostalCodeCountry;
(function (MPostalCodeCountry) {
    MPostalCodeCountry["CA"] = "ca";
    MPostalCodeCountry["FR"] = "fr";
    MPostalCodeCountry["Other"] = "other";
    MPostalCodeCountry["US"] = "us";
})(MPostalCodeCountry || (MPostalCodeCountry = {}));
var MPostalcodefield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MPostalcodefield, _super);
    function MPostalcodefield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mPostalcodefield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__["default"].generate();
        return _this;
    }
    Object.defineProperty(MPostalcodefield.prototype, "maskOptions", {
        get: function () {
            switch (this.postalCodeFormat.toLowerCase()) {
                case MPostalCodeCountry.CA:
                    return {
                        blocks: [3, 3],
                        delimiter: ' ',
                        delimiterLazyShow: true,
                        uppercase: true
                    };
                case MPostalCodeCountry.FR:
                    return {
                        blocks: [5],
                        numericOnly: true,
                        uppercase: true
                    };
                case MPostalCodeCountry.US:
                    return {
                        blocks: [5, 4],
                        delimiter: '-',
                        delimiterLazyShow: true,
                        numericOnly: true,
                        uppercase: true
                    };
                case MPostalCodeCountry.Other:
                default:
                    // Infinite value to display normally with no space the default values, if value is other or invalid!
                    return {
                        blocks: [1e+23],
                        uppercase: true
                    };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MPostalcodefield.prototype, "bindData", {
        get: function () {
            return Object.assign({}, this.$props || {}, this.$attrs || {});
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: MPostalCodeCountry.CA })
    ], MPostalcodefield.prototype, "postalCodeFormat", void 0);
    MPostalcodefield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _postalcodefield_html__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["MASKEDFIELD_NAME"]] = _maskedfield_maskedfield__WEBPACK_IMPORTED_MODULE_10__["MMaskedfield"],
                _a),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ]
        })
    ], MPostalcodefield);
    return MPostalcodefield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var PostalcodefieldPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["POSTALCODEFIELD_NAME"], MPostalcodefield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PostalcodefieldPlugin);


/***/ }),

/***/ "./src/components/progress/progress.html?style=./progress.scss":
/*!*********************************************************************!*\
  !*** ./src/components/progress/progress.html?style=./progress.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e93c04ee!./progress.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=e93c04ee!./src/components/progress/progress.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "m--is", appear: "" } }, [
    _c(
      "div",
      {
        staticClass: "m-progress",
        class: {
          "m--is-circle": _vm.circle,
          "m--is-indeterminate": _vm.indeterminate,
          "m--is-determinate ": !_vm.indeterminate,
          "m--is-completed": _vm.propState == "completed",
          "m--is-in-progress": _vm.propState == "in-progress",
          "m--is-error": _vm.propState == "error",
          "m--is-monochrome": _vm.isMonochrome
        },
        style: _vm.styleObject
      },
      [
        !_vm.circle
          ? _c("div", {
              staticClass: "m-progress__bar",
              style: _vm.barStyleObject
            })
          : _c(
              "div",
              { staticClass: "m-progress__wrap", style: _vm.svgStyles },
              [
                [
                  _c(
                    "svg",
                    {
                      staticClass: "m-progress__draw",
                      style: _vm.svgStyles,
                      attrs: {
                        preserveAspectRatio: "xMidYMid meet",
                        focusable: "false",
                        viewBox: _vm.svgViewbox
                      }
                    },
                    [
                      !_vm.indeterminate
                        ? _c("circle", {
                            staticClass: "m-progress__background",
                            style: _vm.backgroundCircleStyles,
                            attrs: { cx: "50%", cy: "50%", r: _vm.circleRadius }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "m-progress__circle",
                        style: _vm.circleStyles,
                        attrs: { cx: "50%", cy: "50%", r: _vm.circleRadius }
                      })
                    ]
                  )
                ]
              ],
              2
            ),
        _vm._v(" "),
        _vm.circle
          ? _c(
              "div",
              { staticClass: "m-progress__slot" },
              [_vm._t("default")],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-e93c04ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/progress/progress.ts":
/*!*********************************************!*\
  !*** ./src/components/progress/progress.ts ***!
  \*********************************************/
/*! exports provided: MProgressState, MProgressSkin, MProgress, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MProgressState", function() { return MProgressState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MProgressSkin", function() { return MProgressSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MProgress", function() { return MProgress; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _progress_html_style_progress_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./progress.html?style=./progress.scss */ "./src/components/progress/progress.html?style=./progress.scss");
/* harmony import */ var _progress_html_style_progress_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_progress_html_style_progress_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _progressSpinnerAnimation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./progressSpinnerAnimation */ "./src/components/progress/progressSpinnerAnimation.ts");







var MProgressState;
(function (MProgressState) {
    MProgressState["Completed"] = "completed";
    MProgressState["InProgress"] = "in-progress";
    MProgressState["Error"] = "error";
})(MProgressState || (MProgressState = {}));
var MProgressSkin;
(function (MProgressSkin) {
    MProgressSkin["Default"] = "default";
    MProgressSkin["Monochrome"] = "monochrome";
})(MProgressSkin || (MProgressSkin = {}));
var MProgress = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MProgress, _super);
    function MProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MProgress.prototype.mounted = function () {
        this.attachStyleTag();
    };
    MProgress.prototype.setAttachStyleTag = function () {
        this.attachStyleTag();
    };
    MProgress.prototype.attachStyleTag = function () {
        if (!this.styleTag) {
            this.styleTag = document.getElementById('m-progress-spinner-styles');
        }
        if (!this.styleTag) {
            this.styleTag = document.createElement('style');
            this.styleTag.id = 'm-progress-spinner-styles';
            if (this.$modul !== undefined && this.$modul.CSPNonce !== undefined) {
                this.styleTag.setAttribute('nonce', this.$modul.CSPNonce);
            }
            document.head.appendChild(this.styleTag);
        }
        if (this.styleTag && this.styleTag.sheet) {
            this.styleTag.sheet.insertRule(this.animationCSS, 0);
        }
    };
    Object.defineProperty(MProgress.prototype, "animationCSS", {
        get: function () {
            return _progressSpinnerAnimation__WEBPACK_IMPORTED_MODULE_6__["default"]
                .replace(/START_VALUE/g, "" + 0.95 * this.circleCircumference)
                .replace(/END_VALUE/g, "" + 0.2 * this.circleCircumference)
                .replace(/DIAMETER/g, "" + this.diameter);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "propSize", {
        get: function () {
            return this.circle ? '100%' : this.size + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "propState", {
        get: function () {
            return this.state ? this.state : this.value >= 100 ? MProgressState.Completed : MProgressState.InProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "radiusSize", {
        get: function () {
            return this.circle || !this.borderRadius ? 'initial' : this.size / 2 + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "styleObject", {
        get: function () {
            return {
                height: this.propSize,
                borderRadius: this.radiusSize
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "barStyleObject", {
        get: function () {
            return this.value >= 100 ? {
                width: this.stringValue,
                borderRadius: this.radiusSize
            } :
                {
                    width: this.stringValue,
                    'border-bottom-left-radius': this.radiusSize,
                    'border-top-left-radius': this.radiusSize
                };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "stringValue", {
        get: function () {
            if (!this.indeterminate) {
                if (this.value < 0) {
                    return '0%';
                }
                else if (this.value > 100) {
                    return '100%';
                }
                else if (this.value !== undefined) {
                    return this.value + '%';
                }
                else {
                    return '0%';
                }
            }
            else {
                return '0%';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "numberValue", {
        get: function () {
            if (!this.indeterminate) {
                if (this.value < 0) {
                    return 0;
                }
                else if (this.value > 100) {
                    return 100;
                }
                else {
                    return this.value;
                }
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "isDeterminate", {
        get: function () {
            if (this.circle === false) {
                this.mode = 'determinate';
            }
            return this.circle === false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "isIndeterminate", {
        get: function () {
            if (this.circle === true) {
                this.mode = 'indeterminate';
            }
            return this.circle === true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "progressClasses", {
        get: function () {
            var _a;
            var animationClass = 'm-progress-spinner-indeterminate';
            return _a = {},
                _a[animationClass] = true,
                _a['m-' + this.mode] = true,
                _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "svgViewbox", {
        get: function () {
            return "0 0 " + this.diameter + " " + this.diameter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "svgStyles", {
        get: function () {
            var circleSize = this.diameter + "px";
            return {
                width: circleSize,
                height: circleSize
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleStyles", {
        get: function () {
            return {
                'stroke-dashoffset': this.circleStrokeDashOffset,
                'stroke-dasharray': this.circleStrokeDashArray,
                'stroke-width': this.circleStrokeWidth,
                'animation-name': 'm-progress-spinner-stroke-rotate-' + this.diameter
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "backgroundCircleStyles", {
        get: function () {
            return {
                'stroke-dasharray': this.circleStrokeDashArray,
                'stroke-width': this.circleStrokeWidth,
                'animation-name': 'm-progress-spinner-stroke-rotate-' + this.diameter
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleRadius", {
        get: function () {
            return (this.diameter - this.stroke) / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleStrokeWidth", {
        get: function () {
            return this.stroke + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleCircumference", {
        get: function () {
            return 2 * Math.PI * this.circleRadius;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleStrokeDashArray", {
        get: function () {
            return this.circleCircumference + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "circleStrokeDashOffset", {
        get: function () {
            if (!this.indeterminate) {
                return this.circleCircumference * (100 - this.numberValue) / 100 + 'px';
            }
            else if (this.indeterminate) {
                return this.circleCircumference * 0.2 + 'px';
            }
            return '0px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MProgress.prototype, "isMonochrome", {
        get: function () {
            return this.skin === MProgressSkin.Monochrome;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MProgress.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MProgress.prototype, "indeterminate", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 6 })
    ], MProgress.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MProgress.prototype, "circle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 50 })
    ], MProgress.prototype, "diameter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 4 })
    ], MProgress.prototype, "stroke", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            validator: function (value) {
                return value === MProgressState.Completed ||
                    value === MProgressState.InProgress ||
                    value === MProgressState.Error;
            }
        })
    ], MProgress.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MProgress.prototype, "borderRadius", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: MProgressSkin.Default })
    ], MProgress.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('diameter')
    ], MProgress.prototype, "setAttachStyleTag", null);
    MProgress = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _progress_html_style_progress_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MProgress);
    return MProgress;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var ProgressPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["PROGRESS_NAME"], MProgress);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ProgressPlugin);


/***/ }),

/***/ "./src/components/progress/progressSpinnerAnimation.ts":
/*!*************************************************************!*\
  !*** ./src/components/progress/progressSpinnerAnimation.ts ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n  @keyframes m-progress-spinner-stroke-rotate-DIAMETER {\n    0% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(0);\n    }\n    12.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(0);\n    }\n    12.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(72.5deg);\n    }\n    25% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(72.5deg);\n    }\n    25.1% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(270deg);\n    }\n    37.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(270deg);\n    }\n    37.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(161.5deg);\n    }\n    50% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(161.5deg);\n    }\n    50.01% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(180deg);\n    }\n    62.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(180deg);\n    }\n    62.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(251.5deg);\n    }\n    75% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(251.5deg);\n    }\n    75.01% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotate(90deg);\n    }\n    87.5% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotate(90deg);\n    }\n    87.51% {\n      stroke-dashoffset: END_VALUE;\n      transform: rotateX(180deg) rotate(341.5deg);\n    }\n    100% {\n      stroke-dashoffset: START_VALUE;\n      transform: rotateX(180deg) rotate(341.5deg);\n    }\n  }\n");


/***/ }),

/***/ "./src/components/radio-group/radio-group.html?style=./radio-group.scss":
/*!******************************************************************************!*\
  !*** ./src/components/radio-group/radio-group.html?style=./radio-group.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=710d8e4d!./radio-group.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=710d8e4d!./src/components/radio-group/radio-group.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-radio-group",
      class: {
        "m--is-inline": _vm.inline,
        "m--is-disabled": _vm.isDisabled,
        "m--has-error": _vm.hasError,
        "m--is-valid": _vm.isValid,
        "m--has-validation-message": _vm.hasValidationMessage
      },
      on: { focusin: _vm.onFocus, focusout: _vm.onBlur }
    },
    [
      _c(
        "m-input-group",
        {
          attrs: {
            label: _vm.label,
            "required-marker": _vm.requiredMarker,
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasError,
            "error-message": _vm.errorMessage,
            valid: _vm.isValid,
            "valid-message": _vm.validMessage,
            "helper-message": _vm.helperMessage,
            validationMessagePosition: _vm.validationMessagePosition
          }
        },
        [
          _c("template", { slot: "icon" }, [_vm._t("icon")], 2),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "m-radio-group__body",
              attrs: { role: "radiogroup" }
            },
            [_vm._t("default")],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-710d8e4d'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/radio-group/radio-group.ts":
/*!***************************************************!*\
  !*** ./src/components/radio-group/radio-group.ts ***!
  \***************************************************/
/*! exports provided: MRadioGroup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadioGroup", function() { return MRadioGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _input_group_input_group__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../input-group/input-group */ "./src/components/input-group/input-group.ts");
/* harmony import */ var _radio_radio__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../radio/radio */ "./src/components/radio/radio.ts");
/* harmony import */ var _radio_group_html_style_radio_group_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./radio-group.html?style=./radio-group.scss */ "./src/components/radio-group/radio-group.html?style=./radio-group.scss");
/* harmony import */ var _radio_group_html_style_radio_group_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_radio_group_html_style_radio_group_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var FOCUS_OUT_TIMEOUT_MS = 200;
var MRadioGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MRadioGroup, _super);
    function MRadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        _this.internalValue = '';
        _this.internalIsFocus = false;
        _this.internalIsBlur = false;
        return _this;
    }
    MRadioGroup.prototype.onChange = function (value) { };
    MRadioGroup.prototype.emitFocus = function (event) { };
    MRadioGroup.prototype.emitBlur = function (event) { };
    MRadioGroup.prototype.created = function () {
        this.internalValue = undefined;
    };
    MRadioGroup.prototype.mounted = function () {
        if (this.focus) {
            this.focusChanged(this.focus);
        }
    };
    Object.defineProperty(MRadioGroup.prototype, "stateIsDisabled", {
        get: function () {
            return this.as().isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadioGroup.prototype, "stateIsError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadioGroup.prototype, "stateIsValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadioGroup.prototype, "idLabel", {
        get: function () {
            return this.hasLabel ? _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    MRadioGroup.prototype.getValue = function () {
        return this.model;
    };
    MRadioGroup.prototype.updateValue = function (value) {
        this.model = value;
    };
    MRadioGroup.prototype.onFocus = function (event) {
        clearTimeout(this.hasFocusInTimeout);
        if (!this.internalIsBlur) {
            this.emitFocus(event);
        }
        this.internalIsFocus = true;
    };
    MRadioGroup.prototype.onBlur = function (event) {
        var _this = this;
        this.internalIsFocus = false;
        this.internalIsBlur = true;
        this.hasFocusInTimeout = setTimeout(function () {
            if (!_this.internalIsFocus) {
                _this.emitBlur(event);
            }
            _this.internalIsBlur = false;
        }, FOCUS_OUT_TIMEOUT_MS);
    };
    MRadioGroup.prototype.onValueChange = function (value) {
        this.internalValue = value;
    };
    MRadioGroup.prototype.focusChanged = function (focus) {
        var _this = this;
        var elements = this.$el.querySelectorAll('input');
        var inputEl;
        // Find right element to focus
        if (elements.length > 1) {
            elements.forEach(function (radio) {
                if (radio.value === _this.value) {
                    inputEl = radio;
                }
            });
            if (inputEl === undefined) {
                inputEl = elements[0];
            }
        }
        else {
            inputEl = elements[0];
        }
        // Focus on the element
        if (inputEl) {
            if (focus) {
                inputEl.focus();
            }
            else {
                inputEl.blur();
            }
        }
    };
    Object.defineProperty(MRadioGroup.prototype, "model", {
        get: function () {
            return this.value === undefined ? this.internalValue : this.value;
        },
        set: function (value) {
            this.internalValue = value;
            this.onChange(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadioGroup.prototype, "hasLabel", {
        get: function () {
            return !!this.label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadioGroup.prototype, "idValidationMessage", {
        get: function () {
            return this.as().errorMessage || this.as().validMessage || this.as().helperMessage ? _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioPosition"].Left,
            validator: function (value) {
                return value === _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioPosition"].Left ||
                    value === _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioPosition"].Right;
            }
        })
    ], MRadioGroup.prototype, "radiosPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "inline", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "requiredMarker", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioVerticalAlignement"].Top,
            validator: function (value) {
                return value === _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioVerticalAlignement"].Top ||
                    value === _radio_radio__WEBPACK_IMPORTED_MODULE_7__["MRadioVerticalAlignement"].Center;
            }
        })
    ], MRadioGroup.prototype, "radiosVerticalAlign", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "radiosMarginTop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioGroup.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _input_group_input_group__WEBPACK_IMPORTED_MODULE_6__["MMInputGroupValidationMessagePosition"].Top,
            validator: function (value) {
                return value === _input_group_input_group__WEBPACK_IMPORTED_MODULE_6__["MMInputGroupValidationMessagePosition"].Top ||
                    value === _input_group_input_group__WEBPACK_IMPORTED_MODULE_6__["MMInputGroupValidationMessagePosition"].Bottom;
            }
        })
    ], MRadioGroup.prototype, "validationMessagePosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change')
    ], MRadioGroup.prototype, "onChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('focus')
    ], MRadioGroup.prototype, "emitFocus", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('blur')
    ], MRadioGroup.prototype, "emitBlur", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value')
    ], MRadioGroup.prototype, "onValueChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('focus')
    ], MRadioGroup.prototype, "focusChanged", null);
    MRadioGroup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _radio_group_html_style_radio_group_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["INPUT_GROUP_NAME"]] = _input_group_input_group__WEBPACK_IMPORTED_MODULE_6__["MInputGroup"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MRadioGroup);
    return MRadioGroup;
}(_radio_radio__WEBPACK_IMPORTED_MODULE_7__["BaseRadioGroup"]));

var RadioGroupPlugin = {
    install: function (v, options) {
        v.use(_radio_radio__WEBPACK_IMPORTED_MODULE_7__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["RADIO_GROUP_NAME"], MRadioGroup);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RadioGroupPlugin);


/***/ }),

/***/ "./src/components/radio-style/radio-style.html?style=./radio-style.scss":
/*!******************************************************************************!*\
  !*** ./src/components/radio-style/radio-style.html?style=./radio-style.scss ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=19060d2e!./radio-style.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=19060d2e!./src/components/radio-style/radio-style.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-radio-style",
      class: {
        "m--is-full-width": _vm.fullWidth,
        "m--is-input-right": _vm.isInputRight,
        "m--is-checked": _vm.checked,
        "m--is-disabled": _vm.disabled,
        "m--is-focus": _vm.focus
      },
      on: { click: _vm.onClick }
    },
    [
      _c("div", {
        staticClass: "m-radio-style__input",
        style: {
          minWidth: _vm.inputSize,
          width: _vm.inputSize,
          height: _vm.inputSize
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "m-radio-style__label" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-19060d2e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/radio-style/radio-style.ts":
/*!***************************************************!*\
  !*** ./src/components/radio-style/radio-style.ts ***!
  \***************************************************/
/*! exports provided: MRadioStylePosition, MRadioStyle, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadioStylePosition", function() { return MRadioStylePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadioStyle", function() { return MRadioStyle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _radio_style_html_style_radio_style_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./radio-style.html?style=./radio-style.scss */ "./src/components/radio-style/radio-style.html?style=./radio-style.scss");
/* harmony import */ var _radio_style_html_style_radio_style_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_radio_style_html_style_radio_style_scss__WEBPACK_IMPORTED_MODULE_5__);






var MRadioStylePosition;
(function (MRadioStylePosition) {
    MRadioStylePosition["Left"] = "left";
    MRadioStylePosition["Right"] = "right";
})(MRadioStylePosition || (MRadioStylePosition = {}));
var MRadioStyle = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MRadioStyle, _super);
    function MRadioStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MRadioStyle.prototype, "isInputRight", {
        get: function () {
            return this.radioPosition === MRadioStylePosition.Right;
        },
        enumerable: true,
        configurable: true
    });
    MRadioStyle.prototype.onClick = function (event) {
        if (!this.disabled) {
            this.$emit('click', event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MRadioStylePosition.Right,
            validator: function (value) {
                return value === MRadioStylePosition.Left ||
                    value === MRadioStylePosition.Right;
            }
        })
    ], MRadioStyle.prototype, "radioPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '1em' })
    ], MRadioStyle.prototype, "inputSize", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioStyle.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioStyle.prototype, "checked", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioStyle.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadioStyle.prototype, "fullWidth", void 0);
    MRadioStyle = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _radio_style_html_style_radio_style_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MRadioStyle);
    return MRadioStyle;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var RadioStylePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["RADIO_STYLE_NAME"], MRadioStyle);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RadioStylePlugin);


/***/ }),

/***/ "./src/components/radio/radio.html?style=./radio.scss":
/*!************************************************************!*\
  !*** ./src/components/radio/radio.html?style=./radio.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3a102eb1!./radio.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3a102eb1!./src/components/radio/radio.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-radio",
      class: {
        "m--is-disabled": _vm.propDisabled,
        "m--is-readonly": _vm.propReadonly,
        "m--is-error": _vm.propError,
        "m--is-valid": _vm.propValid,
        "m--is-checked": _vm.isChecked,
        "m--is-focus": _vm.hasFocus && !_vm.propDisabled,
        "m--is-input-right": _vm.propPosition === "right",
        "m--is-inline": _vm.propInline,
        "m--is-align-center": _vm.propVerticalAlign === "center"
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          }
        ],
        ref: "radioInput",
        staticClass: "m-radio__hidden",
        attrs: {
          "aria-hidden": _vm.propDisabled,
          disabled: _vm.propDisabled || _vm.isReadonlyUnchecked,
          id: _vm.radioID,
          name: _vm.propName,
          type: "radio"
        },
        domProps: { value: _vm.value, checked: _vm._q(_vm.model, _vm.value) },
        on: {
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          change: function($event) {
            _vm.model = _vm.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          ref: "label",
          staticClass: "m-radio__wrap",
          attrs: { for: _vm.radioID }
        },
        [
          _c("span", {
            staticClass: "m-radio__input",
            style: { "margin-top": _vm.propRadioMarginTop },
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "m-radio__label" }, [_vm._t("default")], 2)
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-3a102eb1'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/radio/radio.ts":
/*!***************************************!*\
  !*** ./src/components/radio/radio.ts ***!
  \***************************************/
/*! exports provided: MRadioPosition, MRadioVerticalAlignement, BaseRadioGroup, MRadio, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadioPosition", function() { return MRadioPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadioVerticalAlignement", function() { return MRadioVerticalAlignement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseRadioGroup", function() { return BaseRadioGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRadio", function() { return MRadio; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _radio_html_style_radio_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./radio.html?style=./radio.scss */ "./src/components/radio/radio.html?style=./radio.scss");
/* harmony import */ var _radio_html_style_radio_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_radio_html_style_radio_scss__WEBPACK_IMPORTED_MODULE_7__);








var MRadioPosition;
(function (MRadioPosition) {
    MRadioPosition["Left"] = "left";
    MRadioPosition["Right"] = "right";
})(MRadioPosition || (MRadioPosition = {}));
var MRadioVerticalAlignement;
(function (MRadioVerticalAlignement) {
    MRadioVerticalAlignement["Center"] = "center";
    MRadioVerticalAlignement["Top"] = "top";
})(MRadioVerticalAlignement || (MRadioVerticalAlignement = {}));
var BaseRadioGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseRadioGroup, _super);
    function BaseRadioGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseRadioGroup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var MRadio = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MRadio, _super);
    function MRadio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioID = _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        _this.hasFocus = false;
        _this.hasParentGroup = undefined;
        _this.internalDisabled = false;
        return _this;
    }
    MRadio.prototype.onChange = function (value) { };
    MRadio.prototype.onFocus = function (event) {
        this.hasFocus = true;
    };
    MRadio.prototype.onBlur = function (event) {
        this.hasFocus = false;
    };
    MRadio.prototype.focusChanged = function (focus) {
        if (focus) {
            this.$refs.radioInput.focus();
        }
        else {
            this.$refs.radioInput.blur();
        }
    };
    MRadio.prototype.mounted = function () {
        if (this.focus) {
            this.focusChanged(this.focus);
        }
    };
    Object.defineProperty(MRadio.prototype, "model", {
        get: function () {
            return this.isGroup() ? this.parentGroup.getValue() : this.modelValue;
        },
        set: function (value) {
            if (this.isGroup()) {
                this.parentGroup.updateValue(value);
            }
            else {
                this.onChange(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propPosition", {
        get: function () {
            return this.isGroup() ? this.parentGroup.radiosPosition : this.radioPosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propVerticalAlign", {
        get: function () {
            return this.isGroup() ? this.parentGroup.radiosVerticalAlign : this.radioVerticalAlign;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propRadioMarginTop", {
        get: function () {
            return this.isGroup() ? this.parentGroup.radiosMarginTop : this.radioMarginTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propDisabled", {
        get: function () {
            var groupDisabled = this.isGroup() ? this.parentGroup.stateIsDisabled : false;
            return groupDisabled || this.as().isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propError", {
        get: function () {
            var groupHasError = this.isGroup() ? this.parentGroup.stateIsError : false;
            return groupHasError || this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propValid", {
        get: function () {
            var groupValid = this.isGroup() ? this.parentGroup.stateIsValid : false;
            return groupValid || this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propName", {
        get: function () {
            return this.isGroup() ? this.parentGroup.name : this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propInline", {
        get: function () {
            return this.isGroup() ? this.parentGroup.inline : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "propReadonly", {
        get: function () {
            if (this.as().readonly !== undefined) {
                return this.as().readonly;
            }
            else {
                return this.isGroup() ? this.parentGroup.readonly : false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "isChecked", {
        get: function () {
            return this.model === this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MRadio.prototype, "isReadonlyUnchecked", {
        get: function () {
            return this.propReadonly && !this.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    MRadio.prototype.isGroup = function () {
        if (this.hasParentGroup === undefined) {
            var parentGroup = void 0;
            parentGroup = this.getParent(function (p) { return p instanceof BaseRadioGroup || // these will fail with Jest, but should pass in prod mode
                p.$options.name === 'MRadioGroup'; } // these are necessary for Jest, but the first two should pass in prod mode
            );
            if (parentGroup) {
                this.parentGroup = parentGroup;
                this.hasParentGroup = true;
            }
            else {
                this.hasParentGroup = false;
            }
        }
        return !!this.hasParentGroup;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])(),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change')
    ], MRadio.prototype, "modelValue", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadio.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadio.prototype, "name", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MRadioPosition.Left,
            validator: function (value) {
                return value === MRadioPosition.Left ||
                    value === MRadioPosition.Right;
            }
        })
    ], MRadio.prototype, "radioPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadio.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MRadioVerticalAlignement.Top,
            validator: function (value) {
                return value === MRadioVerticalAlignement.Top ||
                    value === MRadioVerticalAlignement.Center;
            }
        })
    ], MRadio.prototype, "radioVerticalAlign", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadio.prototype, "radioMarginTop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MRadio.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change')
    ], MRadio.prototype, "onChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('focus')
    ], MRadio.prototype, "onFocus", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('blur')
    ], MRadio.prototype, "onBlur", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('focus')
    ], MRadio.prototype, "focusChanged", null);
    MRadio = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _radio_html_style_radio_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MRadio);
    return MRadio;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var RadioPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["RADIO_NAME"], MRadio);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RadioPlugin);


/***/ }),

/***/ "./src/components/responsive-table/responsive-table-commons.ts":
/*!*********************************************************************!*\
  !*** ./src/components/responsive-table/responsive-table-commons.ts ***!
  \*********************************************************************/
/*! exports provided: MTableSortDirection, MTableTextAlign, MTableColspan, MTableAccordionIconPosition, MTableHeadStyle, MTableRowsStyle, MTableGroupHeaderStyle, getCellAlignmentClass, getCellWidthStyle, getHeadRowsFilterAndSort, getTotalColumnsLength */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableSortDirection", function() { return MTableSortDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableTextAlign", function() { return MTableTextAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableColspan", function() { return MTableColspan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableAccordionIconPosition", function() { return MTableAccordionIconPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableHeadStyle", function() { return MTableHeadStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableRowsStyle", function() { return MTableRowsStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableGroupHeaderStyle", function() { return MTableGroupHeaderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCellAlignmentClass", function() { return getCellAlignmentClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCellWidthStyle", function() { return getCellWidthStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeadRowsFilterAndSort", function() { return getHeadRowsFilterAndSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTotalColumnsLength", function() { return getTotalColumnsLength; });
var MTableSortDirection;
(function (MTableSortDirection) {
    MTableSortDirection[MTableSortDirection["None"] = 0] = "None";
    MTableSortDirection[MTableSortDirection["Asc"] = 1] = "Asc";
    MTableSortDirection[MTableSortDirection["Dsc"] = -1] = "Dsc";
})(MTableSortDirection || (MTableSortDirection = {}));
var MTableTextAlign;
(function (MTableTextAlign) {
    MTableTextAlign["Center"] = "center";
    MTableTextAlign["Left"] = "left";
    MTableTextAlign["Right"] = "right";
})(MTableTextAlign || (MTableTextAlign = {}));
var MTableColspan;
(function (MTableColspan) {
    MTableColspan["AllColumns"] = "all-columns";
})(MTableColspan || (MTableColspan = {}));
var MTableAccordionIconPosition;
(function (MTableAccordionIconPosition) {
    MTableAccordionIconPosition["Left"] = "left";
    MTableAccordionIconPosition["Right"] = "right";
})(MTableAccordionIconPosition || (MTableAccordionIconPosition = {}));
var MTableHeadStyle;
(function (MTableHeadStyle) {
    MTableHeadStyle["Dark"] = "dark";
    MTableHeadStyle["Light"] = "light";
    MTableHeadStyle["Lightest"] = "lightest";
    MTableHeadStyle["Any"] = "any";
})(MTableHeadStyle || (MTableHeadStyle = {}));
var MTableRowsStyle;
(function (MTableRowsStyle) {
    MTableRowsStyle["AlternateBackground"] = "alternate-background";
    MTableRowsStyle["Borders"] = "borders";
    MTableRowsStyle["CellBorders"] = "cell-borders";
})(MTableRowsStyle || (MTableRowsStyle = {}));
var MTableGroupHeaderStyle;
(function (MTableGroupHeaderStyle) {
    MTableGroupHeaderStyle["Dark"] = "dark";
    MTableGroupHeaderStyle["Light"] = "light";
    MTableGroupHeaderStyle["Any"] = "any";
})(MTableGroupHeaderStyle || (MTableGroupHeaderStyle = {}));
var getCellAlignmentClass = function (textAlign) {
    return textAlign ? "m--is-text-align-" + textAlign : 'm--is-text-align-left';
};
var getCellWidthStyle = function (column) {
    var width = column.width || undefined;
    return width ? "width: " + width : undefined;
};
var getHeadRowsFilterAndSort = function (headRows) {
    var headRowsClone = Object.assign({}, headRows);
    var headRowKeys = Object.keys(headRowsClone).sort(function (a, b) {
        return headRowsClone
            && headRowsClone[a]
            && headRowsClone[b]
            && headRowsClone[a].order
            && headRowsClone[b].order
            ? headRowsClone[a].order - headRowsClone[b].order
            : 0;
    });
    headRows = {};
    headRowKeys.forEach(function (key) {
        headRows[key] = headRowsClone[key];
        if (headRows[key].columns) {
            headRows[key].columns = getColumnFilterAndSorted(headRows[key].columns);
        }
    });
    return headRows;
};
var getTotalColumnsLength = function (columns) {
    return columns.reduce(function (acc, curr) { return curr.colspan
        && curr.colspan > 0
        && curr.colspan !== MTableColspan.AllColumns
        ? acc + curr.colspan
        : acc + 1; }, 0);
};
var getColumnFilterAndSorted = function (columns) {
    return columns
        .filter(function (c) { return c.visible === undefined || c.visible; })
        .sort(function (a, b) {
        if (a.order && b.order) {
            return a.order - b.order;
        }
        return 0;
    });
};


/***/ }),

/***/ "./src/components/responsive-table/responsive-table.html?style=./responsive-table.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/responsive-table/responsive-table.html?style=./responsive-table.scss ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0133e889!./responsive-table.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0133e889!./src/components/responsive-table/responsive-table.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-auto-horizontal-scroll",
    {
      staticClass: "m-responsive-table",
      attrs: {
        "min-width": _vm.tableMinWidth,
        "horizontal-scroll-offset": _vm.horizontalScrollOffsetProp,
        "drag-active": _vm.dragActive,
        "left-gradient-active": !_vm.firstColumnFixed && _vm.leftGradientActive,
        "right-gradient-active": _vm.rightGradientActive,
        "gradient-style": _vm.gradientStyle,
        "previous-button-active": _vm.previousButtonActive,
        "next-button-active": _vm.nextButtonActive,
        "previous-button-text": _vm.previousButtonText,
        "next-button-text": _vm.nextButtonText,
        "display-horizontal-scrollbar": _vm.displayHorizontalScrollbar
      },
      on: {
        "update:horizontalScrollOffset": function($event) {
          _vm.horizontalScrollOffsetProp = $event
        },
        "update:horizontal-scroll-offset": function($event) {
          _vm.horizontalScrollOffsetProp = $event
        },
        resize: function($event) {
          return _vm.resizeComponant($event)
        },
        "previous-button-click": function($event) {
          return _vm.emitPreviousButtonClick($event)
        },
        "next-button-click": function($event) {
          return _vm.emitNextButtonClick($event)
        }
      }
    },
    [
      _c(
        "table",
        {
          staticClass: "m-responsive-table__table",
          attrs: { id: "idTable", cellspacing: "0" }
        },
        [
          _vm.displayTableHead
            ? _c(
                "m-table-head",
                {
                  attrs: {
                    id: "idTable",
                    "head-rows": _vm.headRowsFilterAndSort,
                    "first-column-fixed": _vm.firstColumnFixed,
                    "head-style": _vm.headStyle
                  },
                  on: {
                    "update:headRows": function($event) {
                      _vm.headRowsFilterAndSort = $event
                    },
                    "update:head-rows": function($event) {
                      _vm.headRowsFilterAndSort = $event
                    },
                    sort: function($event) {
                      return _vm.emitSort($event)
                    }
                  }
                },
                [
                  _vm._l(_vm.allColumns, function(column, index) {
                    return _c(
                      "template",
                      { slot: "head-cell." + column.name },
                      [
                        _vm._t(
                          "head-cell." + column.name,
                          [
                            _vm._t(
                              "head-cell",
                              [
                                _c("div", {
                                  key: index,
                                  domProps: { innerHTML: _vm._s(column.value) }
                                })
                              ],
                              { column: column }
                            )
                          ],
                          { column: column }
                        )
                      ],
                      2
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.waiting
            ? _c("tr", { staticClass: "m-responsive-table__waiting" }, [
                _c(
                  "td",
                  { attrs: { colspan: _vm.mainColumnsLength } },
                  [
                    _c("m-progress", {
                      style: {
                        left: _vm.horizontalScrollOffsetProp + "px",
                        width: _vm.tableComponentWidth
                      },
                      attrs: { indeterminate: true, "border-radius": false }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.formatRowGroups, function(rowsGroup, index) {
            return [
              _vm.getSpacingTop(rowsGroup)
                ? _c(
                    "tr",
                    {
                      staticClass:
                        "m-responsive-table__spacing-top-rows-group-area",
                      style: _vm.getSpacingTopAreaStyle(rowsGroup),
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _c("td", {
                        staticClass:
                          "m-responsive-table__spacing-top-rows-group",
                        class: rowsGroup.spacingClassName,
                        style: _vm.getSpacingTopStyle(rowsGroup)
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("m-table-group", {
                key: index,
                attrs: {
                  columns: _vm.mainColumns,
                  "rows-group": rowsGroup,
                  "first-column-fixed": _vm.firstColumnFixed,
                  "rows-style": _vm.rowsStyle,
                  "horizontal-scroll-offset": _vm.horizontalScrollOffsetProp,
                  "table-component-width": _vm.tableComponentWidth,
                  "group-header-style": _vm.groupHeaderStyle,
                  "group-header-class-name": _vm.groupHeaderClassName,
                  "row-highlighted-on-hover": _vm.rowHighlightedOnHover
                },
                on: {
                  "open-accordion": _vm.emitOpenAccordion,
                  "close-accordion": _vm.emitCloseAccordion,
                  "empty-button-click": function($event) {
                    return _vm.emitEmptyButtonClick($event)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "group-header-title",
                      fn: function(ref) {
                        var rowsGroup = ref.rowsGroup
                        var title = ref.title
                        return [
                          _vm._t(
                            "group-header-title." + rowsGroup.name,
                            [
                              _vm._t(
                                "group-header-title",
                                [
                                  title
                                    ? _c("div", {
                                        key: index,
                                        domProps: { innerHTML: _vm._s(title) }
                                      })
                                    : _vm._e()
                                ],
                                { rowsGroup: rowsGroup, title: title }
                              )
                            ],
                            { rowsGroup: rowsGroup, title: title }
                          )
                        ]
                      }
                    },
                    _vm._l(_vm.mainColumns, function(column, columnIndex) {
                      return {
                        key: "group-header-cell." + column.name,
                        fn: function(ref) {
                          var rowsGroup = ref.rowsGroup
                          var header = ref.header
                          var cell = ref.cell
                          return [
                            _vm._t(
                              "group-header-cell." +
                                column.name +
                                "." +
                                rowsGroup.name,
                              [
                                _vm._t(
                                  "group-header-cell." + column.name,
                                  [
                                    _vm._t(
                                      "group-header-cell",
                                      [
                                        cell.value
                                          ? _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(cell.value)
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      {
                                        rowsGroup: rowsGroup,
                                        header: header,
                                        cell: cell
                                      }
                                    )
                                  ],
                                  {
                                    rowsGroup: rowsGroup,
                                    header: header,
                                    cell: cell
                                  }
                                )
                              ],
                              {
                                rowsGroup: rowsGroup,
                                header: header,
                                cell: cell
                              }
                            )
                          ]
                        }
                      }
                    }),
                    _vm._l(_vm.mainColumns, function(column, index) {
                      return {
                        key: "row-cell." + column.name,
                        fn: function(ref) {
                          var rowsGroup = ref.rowsGroup
                          var row = ref.row
                          var cell = ref.cell
                          var column = ref.column
                          return [
                            _vm._t(
                              "row-cell." + column.name + "." + rowsGroup.name,
                              [
                                _vm._t(
                                  "row-cell." + column.name,
                                  [
                                    _vm._t(
                                      "row-cell",
                                      [
                                        cell && cell.value
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(cell.value) +
                                                  "\n                                "
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      {
                                        rowsGroup: rowsGroup,
                                        row: row,
                                        cell: cell,
                                        column: column
                                      }
                                    )
                                  ],
                                  {
                                    rowsGroup: rowsGroup,
                                    row: row,
                                    cell: cell,
                                    column: column
                                  }
                                )
                              ],
                              {
                                rowsGroup: rowsGroup,
                                row: row,
                                cell: cell,
                                column: column
                              }
                            )
                          ]
                        }
                      }
                    })
                  ],
                  null,
                  true
                )
              })
            ]
          }),
          _vm._v(" "),
          !_vm.hasRowsGroup && _vm.defaultEmptyArea
            ? _c(
                "tbody",
                [
                  _c("m-table-empty-row", {
                    attrs: {
                      "empty-area": _vm.defaultEmptyArea,
                      "horizontal-scroll-offset":
                        _vm.horizontalScrollOffsetProp,
                      "table-component-width": _vm.tableComponentWidth,
                      "nb-columns": _vm.mainColumnsLength,
                      "display-default-text": true,
                      waiting: _vm.waiting
                    },
                    on: {
                      "empty-button-click": function($event) {
                        return _vm.emitEmptyButtonClick({})
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-0133e889'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/responsive-table/responsive-table.ts":
/*!*************************************************************!*\
  !*** ./src/components/responsive-table/responsive-table.ts ***!
  \*************************************************************/
/*! exports provided: MResponsiveTable, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MResponsiveTable", function() { return MResponsiveTable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../auto-horizontal-scroll/auto-horizontal-scroll */ "./src/components/auto-horizontal-scroll/auto-horizontal-scroll.ts");
/* harmony import */ var _progress_progress__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../progress/progress */ "./src/components/progress/progress.ts");
/* harmony import */ var _responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./responsive-table-commons */ "./src/components/responsive-table/responsive-table-commons.ts");
/* harmony import */ var _responsive_table_html_style_responsive_table_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./responsive-table.html?style=./responsive-table.scss */ "./src/components/responsive-table/responsive-table.html?style=./responsive-table.scss");
/* harmony import */ var _responsive_table_html_style_responsive_table_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_responsive_table_html_style_responsive_table_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _table_empty_row_table_empty_row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./table-empty-row/table-empty-row */ "./src/components/responsive-table/table-empty-row/table-empty-row.ts");
/* harmony import */ var _table_group_table_group__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./table-group/table-group */ "./src/components/responsive-table/table-group/table-group.ts");
/* harmony import */ var _table_head_table_head__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./table-head/table-head */ "./src/components/responsive-table/table-head/table-head.ts");
var _a;















var MResponsiveTable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MResponsiveTable, _super);
    function MResponsiveTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.horizontalScrollOffsetInterne = 0;
        _this.hasHorizontalScroll = false;
        _this.tableComponentWidth = '100%';
        _this.headRowsInterne = {};
        return _this;
    }
    MResponsiveTable.prototype.emitEmptyButtonClick = function (rowsGroup) { };
    MResponsiveTable.prototype.emitSort = function (_column) { };
    MResponsiveTable.prototype.emitUpdateHorizontalScrollOffset = function (horizontalScrollOffset) { };
    MResponsiveTable.prototype.emitHorizontalScollbarWidth = function (scrollbarWidth) { };
    MResponsiveTable.prototype.emitOpenAccordion = function (rowsGroup) { };
    MResponsiveTable.prototype.emitCloseAccordion = function (rowsGroup) { };
    MResponsiveTable.prototype.emitPreviousButtonClick = function (event) { };
    MResponsiveTable.prototype.emitNextButtonClick = function (event) { };
    MResponsiveTable.prototype.onHorizontalScrollOffsetChangement = function (value) {
        if (this.horizontalScrollOffsetInterne !== value && value) {
            this.horizontalScrollOffsetInterne = value;
        }
    };
    MResponsiveTable.prototype.onHeadRowsChange = function () {
        this.initializeHeadRow();
    };
    MResponsiveTable.prototype.onColumnsChange = function () {
        this.initializeHeadRow();
    };
    Object.defineProperty(MResponsiveTable.prototype, "idTable", {
        get: function () {
            return this.id || "m-responsive-table-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "formatRowGroups", {
        get: function () {
            if (this.rows && this.rows.length) {
                var newRowsGroup = [
                    {
                        name: "rowGroupName" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate(),
                        rows: this.rows
                    }
                ];
                return this.rowGroups
                    ? this.rowGroups.concat(newRowsGroup)
                    : newRowsGroup;
            }
            else if (this.rowGroups) {
                return this.rowGroups;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "headRowsFilterAndSort", {
        get: function () {
            return this.headRowsInterne;
        },
        set: function (headRows) {
            var headRowsArray = this.getHeadRowsArray(headRows || {});
            var hasSomeMainColumnsInHeadRowsArray = this.hasSomeMainColumnsInHeadRowsArray(headRowsArray);
            if (!hasSomeMainColumnsInHeadRowsArray && headRowsArray.length) {
                headRows[Object.keys(headRows)[headRowsArray.length - 1]].mainColumns = true;
            }
            this.headRowsInterne = Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["getHeadRowsFilterAndSort"])(headRows);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "allColumns", {
        get: function () {
            var _this = this;
            return Object.keys(this.headRowsFilterAndSort)
                .reduce(function (acc, cur) {
                _this.headRowsFilterAndSort[cur].columns.forEach(function (c) {
                    acc.push(c);
                });
                return acc;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "mainColumns", {
        get: function () {
            var _this = this;
            var formatHeadRowKeys = Object.keys(this.headRowsFilterAndSort);
            var keyMainColumns = formatHeadRowKeys[formatHeadRowKeys.findIndex(function (key) { return _this.headRowsFilterAndSort[key].mainColumns; })];
            return this.headRowsFilterAndSort[keyMainColumns].columns || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "mainColumnsLength", {
        get: function () {
            return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["getTotalColumnsLength"])(this.mainColumns);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "hasRowsGroup", {
        get: function () {
            return Boolean(this.formatRowGroups && this.formatRowGroups.length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "horizontalScrollOffsetProp", {
        get: function () {
            return this.horizontalScrollOffsetInterne;
        },
        set: function (value) {
            this.horizontalScrollOffsetInterne = value;
            this.emitUpdateHorizontalScrollOffset(this.horizontalScrollOffsetInterne);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "firstColumnFixed", {
        get: function () {
            return this.firstColumnFixedActive && this.hasHorizontalScroll;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MResponsiveTable.prototype, "hasDefaultEmptyArea", {
        get: function () {
            return Boolean(this.defaultEmptyArea &&
                Object.keys(this.defaultEmptyArea).length > 0);
        },
        enumerable: true,
        configurable: true
    });
    MResponsiveTable.prototype.resizeComponant = function (properties) {
        if (!properties) {
            return;
        }
        this.hasHorizontalScroll = properties.hasHorizontalScroll;
        this.tableComponentWidth = properties.componentWidth;
        this.emitHorizontalScollbarWidth(properties.horizontalScollbarWidth);
    };
    MResponsiveTable.prototype.getSpacingTop = function (rowsGroup) {
        if (rowsGroup.spacingTop === undefined) {
            if (this.groupHeaderStyle === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableGroupHeaderStyle"].Any) {
                return undefined;
            }
            return '2px';
        }
        else if (_utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_7__["REGEX_CSS_NUMBER_VALUE"].test(rowsGroup.spacingTop)) {
            return rowsGroup.spacingTop;
        }
        else {
            this.$log.error("rowsGroup.spacingTop value (\"" + rowsGroup.spacingTop + "\") must match with this regEx " + _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_7__["REGEX_CSS_NUMBER_VALUE"]);
            return undefined;
        }
    };
    MResponsiveTable.prototype.getSpacingTopAreaStyle = function (rowsGroup) {
        return {
            height: this.getSpacingTop(rowsGroup)
        };
    };
    MResponsiveTable.prototype.getSpacingTopStyle = function (rowsGroup) {
        return {
            height: this.getSpacingTop(rowsGroup),
            width: this.tableComponentWidth,
            left: this.horizontalScrollOffsetInterne + "px"
        };
    };
    MResponsiveTable.prototype.beforeMount = function () {
        if (!this.rows && !this.rowGroups) {
            this.$log.error("\"rows\" prop or \"row-groups\" need to be declared on \"" + _component_names__WEBPACK_IMPORTED_MODULE_6__["RESPONSIVE_TABLE_NAME"] + "\" component.");
        }
        this.initializeHeadRow();
    };
    MResponsiveTable.prototype.initializeHeadRow = function () {
        if (!this.columns && !this.headRows) {
            this.$log.error("\"columns\" prop or \"head-rows\" prop need to be declared on \"" + _component_names__WEBPACK_IMPORTED_MODULE_6__["RESPONSIVE_TABLE_NAME"] + "\" component.");
            return;
        }
        var headRows = this.headRows ? this.headRows : {};
        var headRowsArray = this.getHeadRowsArray(headRows);
        if (this.columns && this.columns.length > 0) {
            var hasSomeMainColumnsInHeadRowsArray = this.hasSomeMainColumnsInHeadRowsArray(headRowsArray);
            var maxOrder = Math.max.apply(Math, headRowsArray.map(function (hr) { return hr.order; }));
            headRows = headRowsArray.length ? headRows : {};
            headRows[hasSomeMainColumnsInHeadRowsArray ? "last-row-" + this.idTable + "-internal-name" : "main-row-" + this.idTable + "-internal-name"] = {
                order: maxOrder && maxOrder > 0 ? maxOrder + 1 : 1,
                mainColumns: !hasSomeMainColumnsInHeadRowsArray,
                columns: this.columns
            };
            this.headRowsFilterAndSort = headRows;
        }
        else if (headRowsArray.length > 0) {
            this.headRowsFilterAndSort = headRows;
        }
    };
    MResponsiveTable.prototype.getHeadRowsArray = function (headRows) {
        return headRows ? Object.keys(headRows).map(function (key) {
            return headRows[key];
        }) : [];
    };
    MResponsiveTable.prototype.hasSomeMainColumnsInHeadRowsArray = function (headRowsArray) {
        return Boolean(headRowsArray.length) && headRowsArray.some(function (hr) {
            return hr.mainColumns;
        });
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "headRows", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "columns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "rowGroups", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "rows", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "defaultEmptyArea", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MResponsiveTable.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MResponsiveTable.prototype, "displayTableHead", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MResponsiveTable.prototype, "rowHighlightedOnHover", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableHeadStyle"].Light,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableHeadStyle"]).includes(value);
            }
        })
    ], MResponsiveTable.prototype, "headStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableRowsStyle"].AlternateBackground,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableRowsStyle"]).includes(value);
            }
        })
    ], MResponsiveTable.prototype, "rowsStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableGroupHeaderStyle"].Light,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_10__["MTableGroupHeaderStyle"]).includes(value);
            }
        })
    ], MResponsiveTable.prototype, "groupHeaderStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "groupHeaderClassName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MResponsiveTable.prototype, "dragActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MResponsiveTable.prototype, "leftGradientActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MResponsiveTable.prototype, "rightGradientActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"].White,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScrollGradientStyle"]).includes(value);
            }
        })
    ], MResponsiveTable.prototype, "gradientStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MResponsiveTable.prototype, "previousButtonActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MResponsiveTable.prototype, "nextButtonActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "previousButtonText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "nextButtonText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MResponsiveTable.prototype, "firstColumnFixedActive", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '100%',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_7__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MResponsiveTable.prototype, "tableMinWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MResponsiveTable.prototype, "horizontalScrollOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MResponsiveTable.prototype, "displayHorizontalScrollbar", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('empty-button-click')
    ], MResponsiveTable.prototype, "emitEmptyButtonClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('sort')
    ], MResponsiveTable.prototype, "emitSort", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:horizontalScrollOffset')
    ], MResponsiveTable.prototype, "emitUpdateHorizontalScrollOffset", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('horizontal-scollbar-width')
    ], MResponsiveTable.prototype, "emitHorizontalScollbarWidth", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('open-accordion')
    ], MResponsiveTable.prototype, "emitOpenAccordion", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close-accordion')
    ], MResponsiveTable.prototype, "emitCloseAccordion", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('previous-button-click')
    ], MResponsiveTable.prototype, "emitPreviousButtonClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('next-button-click')
    ], MResponsiveTable.prototype, "emitNextButtonClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('horizontalScrollOffset', { immediate: true })
    ], MResponsiveTable.prototype, "onHorizontalScrollOffsetChangement", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('headRows', { immediate: true })
    ], MResponsiveTable.prototype, "onHeadRowsChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('columns')
    ], MResponsiveTable.prototype, "onColumnsChange", null);
    MResponsiveTable = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _responsive_table_html_style_responsive_table_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["AUTO_HORIZONTAL_SCROLL"]] = _auto_horizontal_scroll_auto_horizontal_scroll__WEBPACK_IMPORTED_MODULE_8__["MAutoHorizontalScroll"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["TABLE_HEAD_NAME"]] = _table_head_table_head__WEBPACK_IMPORTED_MODULE_14__["MTableHead"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["TABLE_GROUP_NAME"]] = _table_group_table_group__WEBPACK_IMPORTED_MODULE_13__["MTableGroup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["TABLE_EMPTY_ROW_NAME"]] = _table_empty_row_table_empty_row__WEBPACK_IMPORTED_MODULE_12__["MTableEmptyRow"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["PROGRESS_NAME"]] = _progress_progress__WEBPACK_IMPORTED_MODULE_9__["MProgress"],
                _a)
        })
    ], MResponsiveTable);
    return MResponsiveTable;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var ResponsiveTablePlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_6__["RESPONSIVE_TABLE_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["RESPONSIVE_TABLE_NAME"], MResponsiveTable);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ResponsiveTablePlugin);


/***/ }),

/***/ "./src/components/responsive-table/table-empty-row/table-empty-row.html?style=./table-empty-row.scss":
/*!***********************************************************************************************************!*\
  !*** ./src/components/responsive-table/table-empty-row/table-empty-row.html?style=./table-empty-row.scss ***!
  \***********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=9ecc5126!./table-empty-row.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=9ecc5126!./src/components/responsive-table/table-empty-row/table-empty-row.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "m-table-empty-row",
      class: ["m--is-background-style-" + _vm.backgroundStyle]
    },
    [
      _c(
        "td",
        { attrs: { colspan: _vm.nbColumns } },
        [
          _c("m-empty-area", {
            style: {
              left: _vm.horizontalScrollOffset + "px",
              width: _vm.tableComponentWidth
            },
            attrs: {
              title: _vm.title,
              subtitle: _vm.subtitle,
              "svg-name": _vm.svgName,
              "svg-size": _vm.svgSize,
              "button-text": _vm.buttonText,
              "button-type": _vm.emptyArea.buttonType,
              "background-style": _vm.backgroundStyle,
              "display-mode": _vm.displayMode,
              "min-height": _vm.minHeight
            },
            on: {
              "button-click": function($event) {
                return _vm.emitEmptyButtonClick($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-9ecc5126'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/responsive-table/table-empty-row/table-empty-row.lang.en.json":
/*!**************************************************************************************!*\
  !*** ./src/components/responsive-table/table-empty-row/table-empty-row.lang.en.json ***!
  \**************************************************************************************/
/*! exports provided: m-table-empty-row, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-table-empty-row\":{\"loading\":\"Loading\",\"no-data\":\"No data to display\"}}");

/***/ }),

/***/ "./src/components/responsive-table/table-empty-row/table-empty-row.lang.fr.json":
/*!**************************************************************************************!*\
  !*** ./src/components/responsive-table/table-empty-row/table-empty-row.lang.fr.json ***!
  \**************************************************************************************/
/*! exports provided: m-table-empty-row, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-table-empty-row\":{\"loading\":\"Chargement en cours\",\"no-data\":\"Aucune donnée à afficher\"}}");

/***/ }),

/***/ "./src/components/responsive-table/table-empty-row/table-empty-row.ts":
/*!****************************************************************************!*\
  !*** ./src/components/responsive-table/table-empty-row/table-empty-row.ts ***!
  \****************************************************************************/
/*! exports provided: MTableEmptyRow, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableEmptyRow", function() { return MTableEmptyRow; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../../empty-area/empty-area */ "./src/components/empty-area/empty-area.ts");
/* harmony import */ var _table_empty_row_html_style_table_empty_row_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./table-empty-row.html?style=./table-empty-row.scss */ "./src/components/responsive-table/table-empty-row/table-empty-row.html?style=./table-empty-row.scss");
/* harmony import */ var _table_empty_row_html_style_table_empty_row_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_table_empty_row_html_style_table_empty_row_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MTableEmptyRow = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableEmptyRow, _super);
    function MTableEmptyRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MTableEmptyRow.prototype.emitEmptyButtonClick = function (event) { };
    Object.defineProperty(MTableEmptyRow.prototype, "title", {
        get: function () {
            if (this.waiting) {
                return this.$i18n.translate('m-table-empty-row:loading');
            }
            var title = this.emptyArea && this.emptyArea.title ? this.emptyArea.title : '';
            return !title && this.displayDefaultText
                ? this.$i18n.translate('m-table-empty-row:no-data')
                : title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "subtitle", {
        get: function () {
            return this.emptyArea && this.emptyArea.subtitle && !this.waiting
                ? this.emptyArea.subtitle
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "svgName", {
        get: function () {
            return this.emptyArea && this.emptyArea.svgName && !this.waiting
                ? this.emptyArea.svgName
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "svgSize", {
        get: function () {
            if (this.emptyArea && this.emptyArea.svgSize) {
                return this.emptyArea.svgSize;
            }
            return this.insideOfTableGroup ? '30px' : '60px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "buttonText", {
        get: function () {
            return this.emptyArea && this.emptyArea.buttonText && !this.waiting
                ? this.emptyArea.buttonText
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "backgroundStyle", {
        get: function () {
            if (this.emptyArea && this.emptyArea.backgroundStyle) {
                return this.emptyArea.backgroundStyle;
            }
            return this.insideOfTableGroup ? _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__["MEmptyAreaBackgroundStyle"].Any : _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__["MEmptyAreaBackgroundStyle"].Light;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "displayMode", {
        get: function () {
            if (this.emptyArea && this.emptyArea.displayMode) {
                return this.emptyArea.displayMode;
            }
            return this.insideOfTableGroup ? _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__["MEmptyAreaDisplayMode"].Inline : _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__["MEmptyAreaDisplayMode"].Block;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableEmptyRow.prototype, "minHeight", {
        get: function () {
            if (this.emptyArea && this.emptyArea.minHeight) {
                return this.emptyArea.minHeight;
            }
            return this.insideOfTableGroup ? 'auto' : '280px';
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MTableEmptyRow.prototype, "tableComponentWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: false
        })
    ], MTableEmptyRow.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MTableEmptyRow.prototype, "horizontalScrollOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTableEmptyRow.prototype, "nbColumns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTableEmptyRow.prototype, "emptyArea", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MTableEmptyRow.prototype, "displayDefaultText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MTableEmptyRow.prototype, "insideOfTableGroup", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('empty-button-click')
    ], MTableEmptyRow.prototype, "emitEmptyButtonClick", null);
    MTableEmptyRow = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_empty_row_html_style_table_empty_row_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            modul: {
                i18n: {
                    'fr': __webpack_require__(/*! ./table-empty-row.lang.fr.json */ "./src/components/responsive-table/table-empty-row/table-empty-row.lang.fr.json"),
                    'en': __webpack_require__(/*! ./table-empty-row.lang.en.json */ "./src/components/responsive-table/table-empty-row/table-empty-row.lang.en.json")
                }
            },
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["EMPTY_AREA_NAME"]] = _empty_area_empty_area__WEBPACK_IMPORTED_MODULE_5__["MEmptyArea"],
                _a)
        })
    ], MTableEmptyRow);
    return MTableEmptyRow;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var TableEmptyRowPlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_4__["TABLE_EMPTY_ROW_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["TABLE_EMPTY_ROW_NAME"], MTableEmptyRow);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TableEmptyRowPlugin);


/***/ }),

/***/ "./src/components/responsive-table/table-group-header/table-group-header.html?style=./table-group-header.scss":
/*!********************************************************************************************************************!*\
  !*** ./src/components/responsive-table/table-group-header/table-group-header.html?style=./table-group-header.scss ***!
  \********************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=71302225!./table-group-header.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=71302225!./src/components/responsive-table/table-group-header/table-group-header.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasHeader
    ? _c(
        "tr",
        {
          staticClass: "m-table-group-header",
          class: [
            {
              "m--is-disabled": _vm.isAccordionDisabled,
              "m--has-accordion": _vm.hasAccordion,
              "m--is-accordion-icon-position-left":
                _vm.isAccordeonIconPositionLeft,
              "m--is-accordion-icon-position-right":
                _vm.isAccordeonIconPositionRight,
              "m--is-first-column-fixed": _vm.firstColumnFixed
            },
            "m--is-group-header-style-" + _vm.groupHeaderStyle,
            _vm.rowsGroupHeaderClassName,
            _vm.groupHeaderClassName
          ],
          style: [_vm.rowsGroup.header.style],
          attrs: { tabindex: _vm.tabindexEnteteAccordeon },
          on: {
            click: function($event) {
              return _vm.toggleAccordeon($event)
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.toggleAccordeon($event)
            }
          }
        },
        [
          _vm.hasHeaderWithoutCell || (!_vm.hasHeaderCell && !_vm.hasHeader)
            ? _c(
                "th",
                {
                  staticClass: "m--is-text-align-left",
                  attrs: { colspan: _vm.totalColumnsLength }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-table-group-header__cell",
                      style: _vm.headerWithoutCellsStyle
                    },
                    [
                      _vm.displayAccordionIcon
                        ? _c("m-plus", {
                            staticClass: "m-table-group-header__accordion-icon",
                            class: [_vm.rowsGroup.accordion.iconClassName],
                            attrs: {
                              open: _vm.isAccordionOpen,
                              disabled: _vm.isAccordionDisabled,
                              skin: _vm.mPlusSkin,
                              large: true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "m-table-group-header__content-cell" },
                        [
                          _vm._t(
                            "group-header-title",
                            [
                              _vm.rowsGroup.header.title
                                ? [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.rowsGroup.header.title) +
                                        "\n                    "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            {
                              rowsGroup: _vm.rowsGroup,
                              title: _vm.rowsGroup.header.title
                            }
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm.hasHeaderCell
            ? _vm._l(_vm.columns, function(column, columnIndex) {
                return [
                  _vm.rowsGroup.header.cells[column.name]
                    ? _c(
                        "th",
                        {
                          key: columnIndex,
                          class: [
                            _vm.getRowAlignmentClass(_vm.rowsGroup, column),
                            _vm.rowsGroup.header.cells[column.name].className
                          ],
                          style: _vm.rowsGroup.header.cells[column.name].style,
                          attrs: {
                            colspan: _vm.getColspan(
                              _vm.rowsGroup.header.cells[column.name].colspan
                            )
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "m-table-group-header__cell",
                              style: _vm.getCellStyle(
                                _vm.rowsGroup.header.cells[column.name],
                                columnIndex
                              )
                            },
                            [
                              _vm.displayAccordionIconInCorrectCell(
                                column.name,
                                columnIndex
                              )
                                ? _c("m-plus", {
                                    staticClass:
                                      "m-table-group-header__accordion-icon",
                                    class: [
                                      _vm.rowsGroup.accordion.iconClassName
                                    ],
                                    attrs: {
                                      open: _vm.isAccordionOpen,
                                      disabled: _vm.isAccordionDisabled,
                                      skin: _vm.mPlusSkin,
                                      large: true
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-table-group-header__content-cell"
                                },
                                [
                                  columnIndex === 0 &&
                                  _vm.rowsGroup.header.title
                                    ? _vm._t(
                                        "group-header-title",
                                        [
                                          _vm.rowsGroup.header.title
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.rowsGroup.header.title
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        {
                                          rowsGroup: _vm.rowsGroup,
                                          title: _vm.rowsGroup.header.title,
                                          column: column
                                        }
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasHeaderCell
                                    ? _vm._t(
                                        "group-header-cell." + column.name,
                                        [
                                          _vm._t(
                                            "group-header-cell",
                                            [
                                              _vm.rowsGroup.header.cells[
                                                column.name
                                              ].value
                                                ? [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          _vm.rowsGroup.header
                                                            .cells[column.name]
                                                            .value
                                                        ) +
                                                        "\n                            "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            {
                                              rowsGroup: _vm.rowsGroup,
                                              header: _vm.rowsGroup.header,
                                              cell:
                                                _vm.rowsGroup.header.cells[
                                                  column.name
                                                ],
                                              column: column
                                            }
                                          )
                                        ],
                                        {
                                          rowsGroup: _vm.rowsGroup,
                                          header: _vm.rowsGroup.header,
                                          cell:
                                            _vm.rowsGroup.header.cells[
                                              column.name
                                            ],
                                          column: column
                                        }
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _c(
                        "th",
                        {
                          class: [
                            _vm.getRowAlignmentClass(_vm.rowsGroup, column)
                          ]
                        },
                        [
                          columnIndex === 0 && _vm.rowsGroup.header.title
                            ? _c(
                                "div",
                                { staticClass: "m-table-group-header__cell" },
                                [
                                  _vm.displayAccordionIconInCorrectCell(
                                    column.name,
                                    columnIndex
                                  )
                                    ? _c("m-plus", {
                                        staticClass:
                                          "m-table-group-header__accordion-icon",
                                        class: [
                                          _vm.rowsGroup.accordion.iconClassName
                                        ],
                                        attrs: {
                                          open: _vm.isAccordionOpen,
                                          disabled: _vm.isAccordionDisabled,
                                          skin: _vm.mPlusSkin,
                                          large: true
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "m-table-group-header__content-cell"
                                    },
                                    [
                                      _vm._t(
                                        "group-header-title",
                                        [
                                          _vm.rowsGroup.header.title
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.rowsGroup.header.title
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        {
                                          rowsGroup: _vm.rowsGroup,
                                          title: _vm.rowsGroup.header.title,
                                          column: column
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                ]
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-71302225'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/responsive-table/table-group-header/table-group-header.ts":
/*!**********************************************************************************!*\
  !*** ./src/components/responsive-table/table-group-header/table-group-header.ts ***!
  \**********************************************************************************/
/*! exports provided: MTableGroupHeader, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableGroupHeader", function() { return MTableGroupHeader; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _accordion_accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../accordion/accordion */ "./src/components/accordion/accordion.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _plus_plus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../plus/plus */ "./src/components/plus/plus.ts");
/* harmony import */ var _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../responsive-table-commons */ "./src/components/responsive-table/responsive-table-commons.ts");
/* harmony import */ var _table_group_table_group_mixin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../table-group/table-group-mixin */ "./src/components/responsive-table/table-group/table-group-mixin.ts");
/* harmony import */ var _table_group_header_html_style_table_group_header_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./table-group-header.html?style=./table-group-header.scss */ "./src/components/responsive-table/table-group-header/table-group-header.html?style=./table-group-header.scss");
/* harmony import */ var _table_group_header_html_style_table_group_header_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_table_group_header_html_style_table_group_header_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MTableGroupHeader = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableGroupHeader, _super);
    function MTableGroupHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mPlusSkin = _plus_plus__WEBPACK_IMPORTED_MODULE_6__["MPlusSkin"].CurrentColor;
        return _this;
    }
    Object.defineProperty(MTableGroupHeader.prototype, "tabindexEnteteAccordeon", {
        get: function () {
            return !this.as().hasAccordion ||
                this.as().isAccordionDisabled
                ? undefined
                : '0';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "isAccordeonIconPositionRight", {
        get: function () {
            return (this.accordionIconPosition ===
                _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableAccordionIconPosition"].Right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "isAccordeonIconPositionLeft", {
        get: function () {
            return (this.accordionIconPosition ===
                _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableAccordionIconPosition"].Left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "accordionIconPosition", {
        get: function () {
            if (this.as().hasAccordion &&
                this.as().rowsGroup.accordion.iconPosition &&
                this.as().rowsGroup.accordion.iconPosition ===
                    _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableAccordionIconPosition"].Right) {
                return _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableAccordionIconPosition"].Right;
            }
            return _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableAccordionIconPosition"].Left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "headerLeftPositionStyle", {
        get: function () {
            return {
                left: this.as().firstColumnFixed && this.horizontalScrollOffset
                    ? this.horizontalScrollOffset + "px"
                    : undefined
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "headerWithoutCellsStyle", {
        get: function () {
            return {
                left: this.headerLeftPositionStyle.left,
                width: this.tableComponentWidth
            };
        },
        enumerable: true,
        configurable: true
    });
    MTableGroupHeader.prototype.getCellStyle = function (cell, columnIndex) {
        if (cell.colspan
            && columnIndex === 0
            && (cell.colspan === Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["getTotalColumnsLength"])(this.as().columns)
                || cell.colspan === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableColspan"].AllColumns)) {
            return this.headerWithoutCellsStyle;
        }
        return undefined;
    };
    Object.defineProperty(MTableGroupHeader.prototype, "rowsGroupHeaderClassName", {
        get: function () {
            return this.as().rowsGroup &&
                this.as().rowsGroup.header &&
                this.as().rowsGroup.header.className
                ? this.as().rowsGroup.header
                    .className
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "firstCellsItem", {
        get: function () {
            return this.as().hasHeaderCell
                ? Object.keys(this.as().rowsGroup.header.cells)[0]
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupHeader.prototype, "displayAccordionIcon", {
        get: function () {
            return this.as().rowsGroup
                && this.as().rowsGroup.accordion ?
                this.as().rowsGroup.accordion.displayIcon === undefined
                    || Boolean(this.as().rowsGroup.accordion.displayIcon)
                : false;
        },
        enumerable: true,
        configurable: true
    });
    MTableGroupHeader.prototype.displayAccordionIconInCorrectCell = function (columnId, columnIndex) {
        if (!this.displayAccordionIcon) {
            return false;
        }
        var arrayCells = this.as().hasHeaderCell
            ? Object.keys(this.as().rowsGroup.header.cells)
            : [];
        if (this.isAccordeonIconPositionLeft || arrayCells.length <= 1) {
            return columnIndex === 0;
        }
        else {
            return arrayCells[arrayCells.length - 1] === columnId;
        }
    };
    MTableGroupHeader.prototype.toggleAccordeon = function (event) {
        var target = event.target.closest(_accordion_accordion__WEBPACK_IMPORTED_MODULE_4__["ACCORDION_CLOSEST_ELEMENTS"]);
        if (!this.as().hasAccordion ||
            this.as().isAccordionDisabled ||
            Boolean(target)) {
            return;
        }
        this.as().rowsGroup.accordion.open = !this.as().rowsGroup.accordion.open;
        if (event.currentTarget) {
            event.currentTarget.blur();
        }
        if (this.as().rowsGroup.accordion.open) {
            this.as().emitOpenAccordion(this.as().rowsGroup);
        }
        else {
            this.as().emitCloseAccordion(this.as().rowsGroup);
        }
    };
    MTableGroupHeader.prototype.getColspan = function (colspan) {
        return colspan === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableColspan"].AllColumns ? this.as().totalColumnsLength : colspan;
    };
    MTableGroupHeader.prototype.getRowAlignmentClass = function (rowsGroup, column) {
        if (rowsGroup.header && rowsGroup.header.cells && rowsGroup.header.cells[column.name] && rowsGroup.header.cells[column.name].textAlign) {
            return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["getCellAlignmentClass"])(rowsGroup.header.cells[column.name].textAlign);
        }
        return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["getCellAlignmentClass"])(column.textAlign);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 0
        })
    ], MTableGroupHeader.prototype, "horizontalScrollOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '100%'
        })
    ], MTableGroupHeader.prototype, "tableComponentWidth", void 0);
    MTableGroupHeader = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_group_header_html_style_table_group_header_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["PLUS_NAME"]] = _plus_plus__WEBPACK_IMPORTED_MODULE_6__["MPlus"],
                _a),
            mixins: [_table_group_table_group_mixin__WEBPACK_IMPORTED_MODULE_8__["MTableGroupMixin"]]
        })
    ], MTableGroupHeader);
    return MTableGroupHeader;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var TableGroupHeaderPlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_GROUP_HEADER_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_GROUP_HEADER_NAME"], MTableGroupHeader);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TableGroupHeaderPlugin);


/***/ }),

/***/ "./src/components/responsive-table/table-group/table-group-mixin.ts":
/*!**************************************************************************!*\
  !*** ./src/components/responsive-table/table-group/table-group-mixin.ts ***!
  \**************************************************************************/
/*! exports provided: MTableGroupMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableGroupMixin", function() { return MTableGroupMixin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _responsive_table_commons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../responsive-table-commons */ "./src/components/responsive-table/responsive-table-commons.ts");






var MTableGroupMixin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableGroupMixin, _super);
    function MTableGroupMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MTableGroupMixin.prototype.emitOpenAccordion = function (rowsGroup) { };
    MTableGroupMixin.prototype.emitCloseAccordion = function (rowsGroup) { };
    Object.defineProperty(MTableGroupMixin.prototype, "hasHeader", {
        get: function () {
            return Boolean(this.rowsGroup.header && Object.keys(this.rowsGroup.header).length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasHeaderTitle", {
        get: function () {
            return this.hasHeader && Boolean(this.rowsGroup.header.title);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasHeaderWithoutCell", {
        get: function () {
            return this.hasHeader && !this.hasHeaderCell;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasHeaderCell", {
        get: function () {
            return Boolean(this.hasHeader &&
                this.rowsGroup.header.cells &&
                Object.keys(this.rowsGroup.header.cells).length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasEmptyArea", {
        get: function () {
            return Boolean(this.rowsGroup.emptyArea &&
                Object.keys(this.rowsGroup.emptyArea).length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasRows", {
        get: function () {
            return Boolean(this.rowsGroup.rows && this.rowsGroup.rows.length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasRowsOrEmptyArea", {
        get: function () {
            return Boolean(this.hasRows || this.hasDefaultEmptyArea || this.hasEmptyArea);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasDefaultEmptyArea", {
        get: function () {
            return Boolean(this.defaultEmptyArea && Object.keys(this.defaultEmptyArea).length);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "emptyArea", {
        get: function () {
            if (this.hasEmptyArea) {
                return this.rowsGroup.emptyArea;
            }
            else if (this.hasDefaultEmptyArea) {
                return this.defaultEmptyArea;
            }
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasAccordion", {
        get: function () {
            return Boolean(this.rowsGroup.accordion);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "isAccordionDisabled", {
        get: function () {
            return (this.hasAccordion &&
                Boolean(this.rowsGroup.accordion.disabled));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "isAccordionOpen", {
        get: function () {
            return this.hasAccordion && this.rowsGroup.accordion.open;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "hasRowContent", {
        get: function () {
            return this.hasAccordion
                ? this.isAccordionOpen && this.hasRowsOrEmptyArea
                : this.hasRowsOrEmptyArea;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTableGroupMixin.prototype, "totalColumnsLength", {
        get: function () {
            return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_5__["getTotalColumnsLength"])(this.columns);
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            required: true
        })
    ], MTableGroupMixin.prototype, "columns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            required: true
        })
    ], MTableGroupMixin.prototype, "rowsGroup", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: false
        })
    ], MTableGroupMixin.prototype, "firstColumnFixed", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MTableGroupMixin.prototype, "defaultEmptyArea", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_5__["MTableGroupHeaderStyle"].Light,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_5__["MTableGroupHeaderStyle"]).includes(value);
            }
        })
    ], MTableGroupMixin.prototype, "groupHeaderStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MTableGroupMixin.prototype, "groupHeaderClassName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('open-accordion')
    ], MTableGroupMixin.prototype, "emitOpenAccordion", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('close-accordion')
    ], MTableGroupMixin.prototype, "emitCloseAccordion", null);
    MTableGroupMixin = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MTableGroupMixin);
    return MTableGroupMixin;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));



/***/ }),

/***/ "./src/components/responsive-table/table-group/table-group.html?style=./table-group.scss":
/*!***********************************************************************************************!*\
  !*** ./src/components/responsive-table/table-group/table-group.html?style=./table-group.scss ***!
  \***********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0381e6e3!./table-group.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0381e6e3!./src/components/responsive-table/table-group/table-group.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasHeader || _vm.hasRowsOrEmptyArea
    ? _c(
        "tbody",
        {
          staticClass: "m-table-group",
          class: [
            {
              "m--is-disabled": _vm.isAccordionDisabled,
              "m--has-header": _vm.hasHeader,
              "m--no-header": !_vm.hasHeader,
              "m--has-row-highlighted-on-hover": _vm.rowHighlightedOnHover,
              "m--is-first-column-fixed": _vm.firstColumnFixed
            },
            "m--is-rows-style-" + _vm.rowsStyle
          ]
        },
        [
          _c("m-table-group-header", {
            staticClass: "m-table-group__header",
            attrs: {
              columns: _vm.columns,
              "rows-group": _vm.rowsGroup,
              "first-column-fixed": _vm.firstColumnFixed,
              "horizontal-scroll-offset": _vm.horizontalScrollOffset,
              "table-component-width": _vm.tableComponentWidth,
              "default-empty-area": _vm.defaultEmptyArea,
              "group-header-style": _vm.groupHeaderStyle,
              "group-header-class-name": _vm.groupHeaderClassName
            },
            on: {
              "open-accordion": function($event) {
                return _vm.emitOpenAccordion($event)
              },
              "close-accordion": function($event) {
                return _vm.emitCloseAccordion($event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "group-header-title",
                  fn: function(ref) {
                    var rowsGroup = ref.rowsGroup
                    var title = ref.title
                    var column = ref.column
                    return [
                      _vm._t(
                        "group-header-title." + rowsGroup.name,
                        [
                          _vm._t(
                            "group-header-title",
                            [
                              title
                                ? [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(title) +
                                        "\n                    "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            {
                              rowsGroup: rowsGroup,
                              title: title,
                              column: column
                            }
                          )
                        ],
                        { rowsGroup: rowsGroup, title: title, column: column }
                      )
                    ]
                  }
                },
                _vm._l(_vm.columns, function(column, columnIndex) {
                  return {
                    key: "group-header-cell." + column.name,
                    fn: function(ref) {
                      var rowsGroup = ref.rowsGroup
                      var header = ref.header
                      var cell = ref.cell
                      var column = ref.column
                      return [
                        _vm._t(
                          "group-header-cell." +
                            column.name +
                            "." +
                            rowsGroup.name,
                          [
                            _vm._t(
                              "group-header-cell." + column.name,
                              [
                                _vm._t(
                                  "group-header-cell",
                                  [
                                    cell.value
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(cell.value) +
                                              "\n                        "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  {
                                    rowsGroup: rowsGroup,
                                    header: header,
                                    cell: cell,
                                    column: column
                                  }
                                )
                              ],
                              {
                                rowsGroup: rowsGroup,
                                header: header,
                                cell: cell,
                                column: column
                              }
                            )
                          ],
                          {
                            rowsGroup: rowsGroup,
                            header: header,
                            cell: cell,
                            column: column
                          }
                        )
                      ]
                    }
                  }
                })
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _vm.hasRowContent
            ? [
                _vm._l(_vm.rowsGroup.rows, function(row, rowIndex) {
                  return _c(
                    "tr",
                    { key: rowIndex },
                    _vm._l(_vm.columns, function(column, indexColumn) {
                      return _c(
                        _vm.isCellHeader(row, column.name) ? "th" : "td",
                        {
                          key: indexColumn,
                          tag: "component",
                          staticClass: "m-table-group__cell",
                          class: [
                            _vm.getRowAlignmentClass(row, column),
                            _vm.getRowClassName(row, column.name)
                          ],
                          style: _vm.getRowWidthStyle(column),
                          attrs: {
                            colspan: _vm.getRowColspan(row, column),
                            rowspan: _vm.getRowspan(row, column),
                            scope: _vm.isCellHeader(row, column.name)
                              ? "row"
                              : undefined
                          }
                        },
                        [
                          _vm._t(
                            "row-cell." +
                              column.name +
                              "." +
                              _vm.rowsGroup.name,
                            [
                              _vm._t(
                                "row-cell." + column.name,
                                [
                                  _vm._t(
                                    "row-cell",
                                    [
                                      row.cells && row.cells[column.name]
                                        ? [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  row.cells[column.name].value
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    {
                                      rowsGroup: _vm.rowsGroup,
                                      row: row,
                                      cell: row.cells[column.name],
                                      column: column
                                    }
                                  )
                                ],
                                {
                                  rowsGroup: _vm.rowsGroup,
                                  row: row,
                                  cell: row.cells[column.name],
                                  column: column
                                }
                              )
                            ],
                            {
                              rowsGroup: _vm.rowsGroup,
                              row: row,
                              cell: row.cells[column.name],
                              column: column
                            }
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                }),
                _vm._v(" "),
                !_vm.hasRows && (_vm.hasEmptyArea || _vm.hasDefaultEmptyArea)
                  ? _c("m-table-empty-row", {
                      attrs: {
                        "empty-area": _vm.emptyArea,
                        "horizontal-scroll-offset": _vm.horizontalScrollOffset,
                        "table-component-width": _vm.tableComponentWidth,
                        "inside-of-table-group": true,
                        "nb-columns": _vm.totalColumnsLength
                      },
                      on: {
                        "empty-button-click": function($event) {
                          return _vm.emitEmptyButtonClick(_vm.rowsGroup)
                        }
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-0381e6e3'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/responsive-table/table-group/table-group.ts":
/*!********************************************************************!*\
  !*** ./src/components/responsive-table/table-group/table-group.ts ***!
  \********************************************************************/
/*! exports provided: MTableGroup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableGroup", function() { return MTableGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../responsive-table-commons */ "./src/components/responsive-table/responsive-table-commons.ts");
/* harmony import */ var _table_empty_row_table_empty_row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../table-empty-row/table-empty-row */ "./src/components/responsive-table/table-empty-row/table-empty-row.ts");
/* harmony import */ var _table_group_header_table_group_header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../table-group-header/table-group-header */ "./src/components/responsive-table/table-group-header/table-group-header.ts");
/* harmony import */ var _table_group_mixin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./table-group-mixin */ "./src/components/responsive-table/table-group/table-group-mixin.ts");
/* harmony import */ var _table_group_html_style_table_group_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./table-group.html?style=./table-group.scss */ "./src/components/responsive-table/table-group/table-group.html?style=./table-group.scss");
/* harmony import */ var _table_group_html_style_table_group_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_table_group_html_style_table_group_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a;











var MTableGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableGroup, _super);
    function MTableGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MTableGroup.prototype.emitEmptyButtonClick = function (rowsGroup) { };
    MTableGroup.prototype.getRowClassName = function (row, columnid) {
        return row.cells &&
            row.cells[columnid] &&
            row.cells[columnid].className
            ? row.cells[columnid].className
            : undefined;
    };
    MTableGroup.prototype.getRowColspan = function (row, column) {
        var colspan = row.cells &&
            row.cells[column.id] &&
            row.cells[column.id].colspan
            ? row.cells[column.id].colspan
            : undefined;
        return colspan === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["MTableColspan"].AllColumns
            ? this.as().totalColumnsLength
            : colspan;
    };
    MTableGroup.prototype.getRowspan = function (row, column) {
        return row.cells &&
            row.cells[column.id] &&
            row.cells[column.id].rowspan
            ? row.cells[column.id].rowspan
            : undefined;
    };
    MTableGroup.prototype.getRowAlignmentClass = function (row, column) {
        if (row.cells && row.cells[column.name] && row.cells[column.name].textAlign) {
            return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["getCellAlignmentClass"])(row.cells[column.name].textAlign);
        }
        return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["getCellAlignmentClass"])(column.textAlign);
    };
    MTableGroup.prototype.getRowWidthStyle = function (column) {
        return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["getCellWidthStyle"])(column);
    };
    MTableGroup.prototype.isCellHeader = function (row, columnName) {
        return Boolean(row.cells && row.cells[columnName] && row.cells[columnName].isHeader);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["MTableRowsStyle"].AlternateBackground,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_6__["MTableRowsStyle"]).includes(value);
            }
        })
    ], MTableGroup.prototype, "rowsStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MTableGroup.prototype, "rowHighlightedOnHover", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: 0
        })
    ], MTableGroup.prototype, "horizontalScrollOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '100%'
        })
    ], MTableGroup.prototype, "tableComponentWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('empty-button-click')
    ], MTableGroup.prototype, "emitEmptyButtonClick", null);
    MTableGroup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_group_html_style_table_group_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_GROUP_HEADER_NAME"]] = _table_group_header_table_group_header__WEBPACK_IMPORTED_MODULE_8__["MTableGroupHeader"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_EMPTY_ROW_NAME"]] = _table_empty_row_table_empty_row__WEBPACK_IMPORTED_MODULE_7__["MTableEmptyRow"],
                _a),
            mixins: [_table_group_mixin__WEBPACK_IMPORTED_MODULE_9__["MTableGroupMixin"]]
        })
    ], MTableGroup);
    return MTableGroup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var TableGroupPlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_GROUP_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_GROUP_NAME"], MTableGroup);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TableGroupPlugin);


/***/ }),

/***/ "./src/components/responsive-table/table-head/table-head.html?style=./table-head.scss":
/*!********************************************************************************************!*\
  !*** ./src/components/responsive-table/table-head/table-head.html?style=./table-head.scss ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7311a776!./table-head.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7311a776!./src/components/responsive-table/table-head/table-head.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "thead",
    {
      staticClass: "m-table-head",
      class: [
        "m--is-head-style-" + _vm.headStyle,
        {
          "m--is-first-column-fixed": _vm.firstColumnFixed,
          "m--has-multiple-head-row": _vm.hasMultipleHeadRow
        }
      ]
    },
    _vm._l(_vm.headRows, function(headRow, headRowKey) {
      return _c(
        "tr",
        { key: headRowKey, class: headRow.className },
        _vm._l(headRow.columns, function(column, i) {
          return _c(
            "th",
            {
              key: i,
              class: [
                {
                  "m--is-sortable": column.sortable,
                  "m--is-sorted": _vm.isColumnSorted(column),
                  "m--is-disabled": _vm.disabled,
                  "m--is-initial-sort": column.isInitialSort
                },
                _vm.getColumnAlignmentClass(column),
                column.className
              ],
              style: [_vm.getColumnWidthStyle(column), column.style],
              attrs: {
                id: column.name + "-" + _vm.id,
                colspan: column.colspan,
                rowspan: column.rowspan,
                scope: "col"
              }
            },
            [
              !column.sortable
                ? _vm._t(
                    "head-cell." + column.name,
                    [
                      _vm._t(
                        "head-cell",
                        [
                          column.value
                            ? [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(column.value) +
                                    "\n                    "
                                )
                              ]
                            : _vm._e()
                        ],
                        { column: column }
                      )
                    ],
                    { column: column }
                  )
                : _c("div", { staticClass: "m-table-head__cell" }, [
                    _c(
                      "div",
                      {
                        staticClass: "m-table-head__cell-content",
                        on: {
                          click: function($event) {
                            return _vm.sort(column, headRow.columns)
                          }
                        }
                      },
                      [
                        _vm._t(
                          "head-cell." + column.name,
                          [
                            _vm._t(
                              "head-cell",
                              [
                                column.value
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(column.value) +
                                          "\n                            "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              { column: column }
                            )
                          ],
                          { column: column }
                        ),
                        _vm._v(" "),
                        _c("m-icon-button", {
                          staticClass: "m-table-head__sort-icon",
                          class: _vm.getColumnSortDirectionClass(column),
                          attrs: {
                            skin: _vm.getSkinSortIcon(headRowKey),
                            disabled: _vm.disabled,
                            "button-size": "14px",
                            "icon-size": "12px",
                            "icon-name": _vm.getColumnSortIcon(column)
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.sort(column, headRow.columns)
                            }
                          }
                        })
                      ],
                      2
                    )
                  ])
            ],
            2
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-7311a776'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/responsive-table/table-head/table-head.ts":
/*!******************************************************************!*\
  !*** ./src/components/responsive-table/table-head/table-head.ts ***!
  \******************************************************************/
/*! exports provided: MTableHead, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableHead", function() { return MTableHead; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../responsive-table-commons */ "./src/components/responsive-table/responsive-table-commons.ts");
/* harmony import */ var _table_head_html_style_table_head_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./table-head.html?style=./table-head.scss */ "./src/components/responsive-table/table-head/table-head.html?style=./table-head.scss");
/* harmony import */ var _table_head_html_style_table_head_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_table_head_html_style_table_head_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MTableHead = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableHead, _super);
    function MTableHead() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MTableHead.prototype.emitSort = function (column) { };
    MTableHead.prototype.emitUpdateHeadRows = function (headRows) { };
    Object.defineProperty(MTableHead.prototype, "hasMultipleHeadRow", {
        get: function () {
            return Object.keys(this.headRows).length > 1;
        },
        enumerable: true,
        configurable: true
    });
    MTableHead.prototype.getSkinSortIcon = function (headRowKey) {
        var rowIndex = Object.keys(this.headRows).findIndex(function (key) { return key === headRowKey; });
        if (this.headStyle === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableHeadStyle"].Dark && rowIndex <= 1) {
            return _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButtonSkin"].Dark;
        }
        return _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButtonSkin"].Light;
    };
    MTableHead.prototype.sort = function (currentColumn, columns) {
        if (this.disabled || !currentColumn.sortable) {
            return;
        }
        var sortDirection = this.getCurrentColumnSortDirection(currentColumn);
        columns.forEach(function (c) {
            if (c !== currentColumn) {
                c.sortDirection = _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None;
            }
        });
        switch (sortDirection) {
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc:
                currentColumn.sortDirection = this.getNextSortDirectionWhenDirectionAsc(currentColumn);
                currentColumn.isInitialSort = false;
                break;
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc:
                currentColumn.sortDirection = this.getNextSortDirectionWhenDirectionDsc(currentColumn);
                currentColumn.isInitialSort = false;
                break;
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None:
            default:
                currentColumn.sortDirection = this.getNextSortDirectionWhenDirectionNone(currentColumn);
                currentColumn.isInitialSort = true;
                break;
        }
        this.emitSort(currentColumn);
        this.emitUpdateHeadRows(this.headRows);
    };
    MTableHead.prototype.isColumnSorted = function (currentColumn) {
        return Boolean(this.getColumnSortDirectionClass(currentColumn));
    };
    MTableHead.prototype.getColumnAlignmentClass = function (column) {
        return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["getCellAlignmentClass"])(column.textAlign);
    };
    MTableHead.prototype.getColumnSortIcon = function (currentColumn) {
        if (currentColumn.sortDirection) {
            return 'm-svg__arrow-thin--up'; // CSS rotate transform animation takes care of the arrow position
        }
        else {
            return currentColumn.defaultSortDirection === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc
                ? 'm-svg__arrow-thin--down'
                : 'm-svg__arrow-thin--up';
        }
    };
    MTableHead.prototype.getColumnSortDirectionClass = function (currentColumn) {
        switch (this.getCurrentColumnSortDirection(currentColumn)) {
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc:
                return 'm--is-sort-asc';
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc:
                return 'm--is-sort-desc';
            case _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None:
            default:
                return undefined;
        }
    };
    MTableHead.prototype.getColumnWidthStyle = function (column) {
        return Object(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["getCellWidthStyle"])(column);
    };
    MTableHead.prototype.getNextSortDirectionWhenDirectionAsc = function (column) {
        if (column.enableUnsort) {
            return column.defaultSortDirection === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc
                ? _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None
                : _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc;
        }
        else {
            return _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Dsc;
        }
    };
    MTableHead.prototype.getNextSortDirectionWhenDirectionDsc = function (column) {
        if (column.enableUnsort) {
            return column.defaultSortDirection === _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc ||
                column.defaultSortDirection === undefined
                ? _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None
                : _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc;
        }
        else {
            return _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc;
        }
    };
    MTableHead.prototype.getNextSortDirectionWhenDirectionNone = function (column) {
        return column.defaultSortDirection
            ? column.defaultSortDirection
            : _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].Asc;
    };
    MTableHead.prototype.getCurrentColumnSortDirection = function (currentColumn) {
        if (typeof currentColumn.sortDirection === 'undefined') {
            return _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None;
        }
        return currentColumn.sortDirection || _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableSortDirection"].None;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MTableHead.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTableHead.prototype, "headRows", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableHeadStyle"].Light,
            validator: function (value) {
                return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(_responsive_table_commons__WEBPACK_IMPORTED_MODULE_7__["MTableHeadStyle"]).includes(value);
            }
        })
    ], MTableHead.prototype, "headStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MTableHead.prototype, "firstColumnFixed", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: false
        })
    ], MTableHead.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('sort')
    ], MTableHead.prototype, "emitSort", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:headRows')
    ], MTableHead.prototype, "emitUpdateHeadRows", null);
    MTableHead = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_head_html_style_table_head_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButton"],
                _a)
        })
    ], MTableHead);
    return MTableHead;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var TableHeadPlugin = {
    install: function (v) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_HEAD_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_HEAD_NAME"], MTableHead);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TableHeadPlugin);


/***/ }),

/***/ "./src/components/rich-text-editor/rich-text-license-plugin.ts":
/*!*********************************************************************!*\
  !*** ./src/components/rich-text-editor/rich-text-license-plugin.ts ***!
  \*********************************************************************/
/*! exports provided: RichTextLicensePlugin, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RichTextLicensePlugin", function() { return RichTextLicensePlugin; });
/* harmony import */ var _utils_license_license__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/license/license */ "./src/utils/license/license.ts");
/* harmony import */ var _file_upload_file_upload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../file-upload/file-upload */ "./src/components/file-upload/file-upload.ts");


var RICH_TEXT_LICENSE_KEY = 'm-rich-text-license-key';
var RichTextLicensePlugin = /** @class */ (function () {
    function RichTextLicensePlugin() {
    }
    RichTextLicensePlugin.prototype.install = function (v, options) {
        if (options === void 0) { options = { key: '' }; }
        v.use(_utils_license_license__WEBPACK_IMPORTED_MODULE_0__["default"]);
        v.use(_file_upload_file_upload__WEBPACK_IMPORTED_MODULE_1__["default"]);
        if (options.key) {
            v.prototype.$license.addLicense(RICH_TEXT_LICENSE_KEY, options.key);
        }
    };
    return RichTextLicensePlugin;
}());

/* harmony default export */ __webpack_exports__["default"] = (new RichTextLicensePlugin());


/***/ }),

/***/ "./src/components/rich-text/rich-text.html?style=./rich-text.scss":
/*!************************************************************************!*\
  !*** ./src/components/rich-text/rich-text.html?style=./rich-text.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0d06b22b!./rich-text.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0d06b22b!./src/components/rich-text/rich-text.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "m-rich-text",
    domProps: { innerHTML: _vm._s(_vm.value) }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-0d06b22b'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/rich-text/rich-text.ts":
/*!***********************************************!*\
  !*** ./src/components/rich-text/rich-text.ts ***!
  \***********************************************/
/*! exports provided: MRichText, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRichText", function() { return MRichText; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _rich_text_html_style_rich_text_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./rich-text.html?style=./rich-text.scss */ "./src/components/rich-text/rich-text.html?style=./rich-text.scss");
/* harmony import */ var _rich_text_html_style_rich_text_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_rich_text_html_style_rich_text_scss__WEBPACK_IMPORTED_MODULE_5__);






var MRichText = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MRichText, _super);
    function MRichText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '' })
    ], MRichText.prototype, "value", void 0);
    MRichText = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _rich_text_html_style_rich_text_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MRichText);
    return MRichText;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var RichTextPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["RICH_TEXT_NAME"], MRichText);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RichTextPlugin);


/***/ }),

/***/ "./src/components/scroll-top/scroll-top.html?style=./scroll-top.scss":
/*!***************************************************************************!*\
  !*** ./src/components/scroll-top/scroll-top.html?style=./scroll-top.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2ff620ee!./scroll-top.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=2ff620ee!./src/components/scroll-top/scroll-top.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-scroll-top",
      class: {
        "m--is-position-fixed": _vm.isPositionFixed,
        "m--is-position-relative": !_vm.isPositionFixed
      }
    },
    [
      _c("transition", { attrs: { name: "m--is" } }, [
        _vm.show
          ? _c(
              "button",
              {
                ref: "scrollButton",
                staticClass: "m-scroll-top__button",
                class: { "m--is-position-fixed": _vm.isPositionFixed },
                attrs: { title: _vm._f("f-m-i18n")("m-scroll-top:top") },
                on: { click: _vm.onClick }
              },
              [
                _c("m-icon", {
                  attrs: { name: "m-svg__chevron--right", size: "16px" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-2ff620ee'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/scroll-top/scroll-top.ts":
/*!*************************************************!*\
  !*** ./src/components/scroll-top/scroll-top.ts ***!
  \*************************************************/
/*! exports provided: MScrollTopPosition, MScrollTop, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MScrollTopPosition", function() { return MScrollTopPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MScrollTop", function() { return MScrollTop; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/scroll-to/scroll-to */ "./src/utils/scroll-to/scroll-to.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _scroll_top_html_style_scroll_top_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scroll-top.html?style=./scroll-top.scss */ "./src/components/scroll-top/scroll-top.html?style=./scroll-top.scss");
/* harmony import */ var _scroll_top_html_style_scroll_top_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_scroll_top_html_style_scroll_top_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a, _b;










var MScrollTopPosition;
(function (MScrollTopPosition) {
    MScrollTopPosition["Fixed"] = "fixed";
    MScrollTopPosition["Relative"] = "relative";
})(MScrollTopPosition || (MScrollTopPosition = {}));
var MScrollTop = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MScrollTop, _super);
    function MScrollTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.show = false;
        _this.scrollTopBreakPoint = window.innerHeight * 0.2;
        return _this;
    }
    MScrollTop.prototype.onClick = function (event) {
        this.$scrollTo.goToTop(this.duration);
    };
    MScrollTop.prototype.created = function () {
        if (this.isPositionFixed) {
            this.$modul.event.$on('scroll', this.onScroll);
        }
        else {
            this.show = true;
        }
    };
    MScrollTop.prototype.onScroll = function () {
        var scrollPosition = window.pageYOffset;
        this.show = scrollPosition > this.scrollTopBreakPoint;
    };
    Object.defineProperty(MScrollTop.prototype, "isPositionFixed", {
        get: function () {
            return this.position === MScrollTopPosition.Fixed;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MScrollTopPosition.Fixed,
            validator: function (value) {
                return value === MScrollTopPosition.Fixed ||
                    value === MScrollTopPosition.Relative;
            }
        })
    ], MScrollTop.prototype, "position", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_5__["ScrollToDuration"].Regular,
            validator: function (value) {
                return value === _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_5__["ScrollToDuration"].Regular ||
                    value === _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_5__["ScrollToDuration"].Long;
            }
        })
    ], MScrollTop.prototype, "duration", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MScrollTop.prototype, "onClick", null);
    MScrollTop = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _scroll_top_html_style_scroll_top_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_8__["MIcon"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b)
        })
    ], MScrollTop);
    return MScrollTop;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var ScrollTopPlugin = {
    install: function (v, options) {
        v.use(_utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_5__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["SCROLL_TOP_NAME"], MScrollTop);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ScrollTopPlugin);


/***/ }),

/***/ "./src/components/searchfield/searchfield.html":
/*!*****************************************************!*\
  !*** ./src/components/searchfield/searchfield.html ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-searchfield",
      class: [
        {
          "m--is-disabled": _vm.isDisabled,
          "m--is-readonly": _vm.isReadonly,
          "m--is-waiting": _vm.isWaiting,
          "m--has-error": _vm.hasSearchfieldError,
          "m--is-valid": _vm.isSearchfieldValid,
          "m--has-validation-message": _vm.hasValidationMessage
        }
      ],
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasSearchfieldError,
            valid: _vm.isSearchfieldValid,
            label: _vm.label,
            "label-for": _vm.id,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "word-wrap": true,
            append: true,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            ref: "input",
            staticClass: "m-textfield__input",
            attrs: {
              id: _vm.id,
              type: "search",
              autocomplete: _vm.autocomplete,
              disabled: _vm.isDisabled || _vm.isWaiting,
              placeholder: _vm.placeholder,
              readonly: _vm.isReadonly
            },
            domProps: { value: _vm.model },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              change: _vm.onChange,
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onSearch($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.model = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "suffix" },
            [
              _vm.hasValue
                ? _c("m-icon-button", {
                    key: "resetIcon",
                    staticClass: "m-searchfield__reset",
                    attrs: {
                      "aria-controls": _vm.id,
                      "button-size": "1em",
                      "icon-size": "11px",
                      "icon-name": "m-svg__close-clear"
                    },
                    on: { click: _vm.onReset }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "append" }, [
            _c(
              "button",
              {
                key: "searchIcon",
                staticClass: "m-searchfield__search-button",
                attrs: {
                  "aria-controls": _vm.id,
                  title: _vm.searchIconDescription
                },
                on: { click: _vm.onSearch }
              },
              [
                _c("m-icon", {
                  staticClass: "m-searchfield__search-button-icon",
                  attrs: { name: "m-svg__search", size: "22px" }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-searchfield__validation" },
        [
          _c("m-validation-message", {
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasSearchfieldError,
              "error-message": _vm.errorMessage,
              valid: _vm.isSearchfieldValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-ea28207a'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/searchfield/searchfield.scss":
/*!*****************************************************!*\
  !*** ./src/components/searchfield/searchfield.scss ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/searchfield/searchfield.ts":
/*!***************************************************!*\
  !*** ./src/components/searchfield/searchfield.ts ***!
  \***************************************************/
/*! exports provided: MSearchfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSearchfield", function() { return MSearchfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _searchfield_html__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./searchfield.html */ "./src/components/searchfield/searchfield.html");
/* harmony import */ var _searchfield_html__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_searchfield_html__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _searchfield_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./searchfield.scss */ "./src/components/searchfield/searchfield.scss");
/* harmony import */ var _searchfield_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_searchfield_scss__WEBPACK_IMPORTED_MODULE_15__);
var _a;
















var MSearchfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSearchfield, _super);
    function MSearchfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mSearchfield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_7__["default"].generate();
        _this.searchIconDescription = _this.$i18n.translate('m-textfield:search');
        return _this;
    }
    MSearchfield.prototype.onReset = function () {
        this.as().model = '';
    };
    MSearchfield.prototype.onSearch = function (event) {
        this.search(this.as().model);
    };
    MSearchfield.prototype.search = function (model) { };
    Object.defineProperty(MSearchfield.prototype, "hasSearchfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSearchfield.prototype, "isSearchfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('empty-field')
    ], MSearchfield.prototype, "onReset", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('search')
    ], MSearchfield.prototype, "search", null);
    MSearchfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _searchfield_html__WEBPACK_IMPORTED_MODULE_14___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_12__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_11__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_13__["MValidationMessage"],
                _a),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_3__["InputLabel"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_4__["InputManagement"]
            ]
        })
    ], MSearchfield);
    return MSearchfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var SearchfieldPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["SEARCHFIELD_NAME"], MSearchfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SearchfieldPlugin);


/***/ }),

/***/ "./src/components/select/base-select/base-select.html":
/*!************************************************************!*\
  !*** ./src/components/select/base-select/base-select.html ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-base-select",
      style: {
        width: _vm.inputWidth,
        maxWidth: _vm.inputMaxWidth
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            { name: "m-popup", rawName: "v-m-popup:popup", arg: "popup" }
          ],
          staticClass: "m-base-select__popup"
        },
        [
          _vm._t("default", null, {
            toggle: _vm.togglePopup,
            keyUp: _vm.onKeydownUp,
            keyDown: _vm.onKeydownDown,
            keyTab: _vm.onKeydownTab,
            keyEsc: _vm.onKeydownEsc,
            keyEnter: _vm.onKeydownEnter,
            keySpace: _vm.onKeydownSpace,
            keyHome: _vm.onKeydownHome,
            keyEnd: _vm.onKeydownEnd,
            keyLetter: _vm.onKeydownLetter
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("validation-message"),
      _vm._v(" "),
      _c(
        "m-popup",
        {
          ref: "popup",
          attrs: {
            placement: "bottom-start",
            open: _vm.popupOpen,
            disabled: !_vm.active,
            enter: _vm.transitionEnter,
            leave: _vm.transitionLeave,
            padding: false,
            preload: true,
            lazy: false,
            "focus-management": false,
            "close-on-backdrop": true,
            "open-trigger": "manual",
            "sidebar-full-height": _vm.sidebarFullHeight,
            width: "100%"
          },
          on: {
            "update:open": function($event) {
              _vm.popupOpen = $event
            },
            open: _vm.emitOpen,
            close: _vm.emitClose
          }
        },
        [
          _vm._t("popup-header", null, {
            slot: "header",
            keyUp: _vm.onKeydownUp,
            keyDown: _vm.onKeydownDown,
            keyTab: _vm.onKeydownTab,
            keyEsc: _vm.onKeydownEsc,
            keyEnter: _vm.onKeydownEnter,
            keySpace: _vm.onKeydownSpace,
            keyHome: _vm.onKeydownHome,
            keyEnd: _vm.onKeydownEnd,
            keyLetter: _vm.onKeydownLetter
          }),
          _vm._v(" "),
          _c(
            "ul",
            {
              ref: "items",
              staticClass: "m-base-select__list",
              class: { "m--is-virutalScroll": _vm.virtualScroll },
              style: {
                minWidth: _vm.inputMaxWidth,
                maxHeight: _vm.listMaxHeightProps
              },
              attrs: {
                id: _vm.ariaControls,
                "aria-labelledby": _vm.controlId,
                "aria-live": "polite"
              }
            },
            [
              _vm._t(
                "outer-items",
                [
                  _vm._l(_vm.items, function(item, index) {
                    return [
                      _c(
                        "m-select-item",
                        _vm._g(
                          _vm._b(
                            {},
                            "m-select-item",
                            _vm.getItemProps(item, index),
                            false
                          ),
                          _vm.getItemHandlers(item, index)
                        ),
                        [
                          _vm._t(
                            "items",
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(item) }
                              })
                            ],
                            { item: item, index: index }
                          )
                        ],
                        2
                      )
                    ]
                  })
                ],
                {
                  items: _vm.items,
                  getItemProps: _vm.getItemProps,
                  getItemHandlers: _vm.getItemHandlers
                }
              )
            ],
            2
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-d20ecce8'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/select/base-select/base-select.scss":
/*!************************************************************!*\
  !*** ./src/components/select/base-select/base-select.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/select/base-select/base-select.ts":
/*!**********************************************************!*\
  !*** ./src/components/select/base-select/base-select.ts ***!
  \**********************************************************/
/*! exports provided: MBaseSelect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MBaseSelect", function() { return MBaseSelect; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../directives/popup/popup */ "./src/directives/popup/popup.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _select_select_item_select_item__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../select/select-item/select-item */ "./src/components/select/select-item/select-item.ts");
/* harmony import */ var _base_select_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./base-select.html */ "./src/components/select/base-select/base-select.html");
/* harmony import */ var _base_select_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_base_select_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _base_select_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./base-select.scss */ "./src/components/select/base-select/base-select.scss");
/* harmony import */ var _base_select_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_base_select_scss__WEBPACK_IMPORTED_MODULE_12__);
var _a, _b;













var BASE_SELECT_STYLE_TRANSITION = 'max-height 0.3s ease';
var MBaseSelect = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MBaseSelect, _super);
    function MBaseSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusedIndex = -1;
        _this.internalOpen = false;
        return _this;
    }
    MBaseSelect.prototype.emitUpdateOpen = function (open) { };
    MBaseSelect.prototype.emitOpen = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.focusFirstSelected();
                        this.scrollToFocused();
                        return [2 /*return*/];
                }
            });
        });
    };
    MBaseSelect.prototype.emitClose = function () {
        this.focusedIndex = -1;
    };
    MBaseSelect.prototype.onOpenChange = function (open) {
        if (open !== this.internalOpen) {
            this.internalOpen = open;
        }
    };
    Object.defineProperty(MBaseSelect.prototype, "popupOpen", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            this.internalOpen = open;
            this.emitUpdateOpen(open);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseSelect.prototype, "ariaControls", {
        get: function () {
            return this.controlId + '-controls';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MBaseSelect.prototype, "listMaxHeightProps", {
        get: function () {
            if (this.as().isMqMinS) {
                return this.listMaxHeight;
            }
        },
        enumerable: true,
        configurable: true
    });
    MBaseSelect.prototype.select = function (option, index, $event) {
        this.$emit('select-item', option, index, $event);
    };
    MBaseSelect.prototype.getItemProps = function (item, index) {
        return {
            value: item,
            focused: index === this.focusedIndex,
            selected: this.isSelected(item),
            hideRadioButtonMobile: this.hideRadioButtonMobile
        };
    };
    MBaseSelect.prototype.getItemHandlers = function (item, index) {
        var _this = this;
        return {
            click: function (event) { return _this.onSelectItem(item, index, event); }
        };
    };
    MBaseSelect.prototype.togglePopup = function () {
        if (this.active) {
            this.popupOpen = !this.popupOpen;
        }
    };
    MBaseSelect.prototype.closePopup = function () {
        this.popupOpen = false;
    };
    MBaseSelect.prototype.setFocusedIndex = function (index) {
        this.focusedIndex = index;
    };
    MBaseSelect.prototype.selectFocusedItem = function ($event) {
        this.select(this.items[this.focusedIndex], this.focusedIndex, $event);
    };
    MBaseSelect.prototype.focusFirstSelected = function () {
        if (this.selectedItems && this.selectedItems.length > 0) {
            this.focusedIndex = this.items.indexOf(this.selectedItems[0]);
        }
        else {
            this.focusedIndex = 0;
        }
    };
    MBaseSelect.prototype.focusNextItem = function () {
        if (this.focusedIndex > -1) {
            this.focusedIndex++;
            if (this.focusedIndex >= this.items.length) {
                this.focusedIndex = 0;
            }
        }
        else {
            this.focusedIndex = this.items.length === 0 ? -1 : 0;
        }
        this.scrollToFocused();
    };
    MBaseSelect.prototype.focusPreviousItem = function () {
        if (this.focusedIndex > -1) {
            this.focusedIndex--;
            if (this.focusedIndex < 0) {
                this.focusedIndex = this.items.length - 1;
            }
        }
        else {
            this.focusedIndex = this.items.length - 1;
        }
        this.scrollToFocused();
    };
    MBaseSelect.prototype.update = function () {
        this.$refs.popup.update();
    };
    MBaseSelect.prototype.transitionEnter = function (el, done) {
        var _this = this;
        if (this.enableAnimation) {
            this.$nextTick(function () {
                if (_this.as().isMqMinS) {
                    var height_1 = el.clientHeight;
                    el.style.transition = BASE_SELECT_STYLE_TRANSITION;
                    el.style.overflowY = 'hidden';
                    el.style.maxHeight = '0';
                    el.style.width = _this.$el.clientWidth + 'px';
                    if (_this.listMinWidth) {
                        el.style.minWidth = _this.listMinWidth;
                    }
                    requestAnimationFrame(function () {
                        el.style.maxHeight = height_1 + 'px';
                        done();
                    });
                }
                else {
                    done();
                }
            });
        }
        else {
            done();
        }
    };
    MBaseSelect.prototype.transitionLeave = function (el, done) {
        var _this = this;
        if (this.enableAnimation) {
            this.$nextTick(function () {
                if (_this.as().isMqMinS) {
                    var height = el.clientHeight;
                    el.style.maxHeight = height + 'px';
                    el.style.maxHeight = '0';
                    setTimeout(function () {
                        el.style.maxHeight = 'none';
                        done();
                    }, 300);
                }
                else {
                    done();
                }
            });
        }
        else {
            done();
        }
    };
    // keyboard navigation of a drowdown
    // tab or esc : close the popup
    // up and down : change the focused option
    // enter : select the focused option and close popup
    // space : open the popup
    MBaseSelect.prototype.onKeydownDown = function ($event) {
        if (!this.popupOpen) {
            this.togglePopup();
        }
        else {
            this.focusNextItem();
        }
    };
    MBaseSelect.prototype.onKeydownUp = function ($event) {
        if (!this.popupOpen) {
            this.togglePopup();
        }
        this.focusPreviousItem();
    };
    MBaseSelect.prototype.onKeydownSpace = function ($event) {
        if (this.focusedIndex > -1) {
            this.select(this.items[this.focusedIndex], this.focusedIndex, $event);
            this.closePopup();
        }
        else {
            this.togglePopup();
        }
    };
    MBaseSelect.prototype.onKeydownTab = function ($event) {
        this.closePopup();
    };
    MBaseSelect.prototype.onKeydownEsc = function ($event) {
        this.closePopup();
    };
    MBaseSelect.prototype.onKeydownEnter = function ($event) {
        if (this.focusedIndex > -1) {
            this.select(this.items[this.focusedIndex], this.focusedIndex, $event);
            this.closePopup();
        }
        else {
            this.togglePopup();
        }
    };
    MBaseSelect.prototype.onKeydownHome = function ($event) {
        if (this.popupOpen) {
            this.focusedIndex = 0;
            this.scrollToFocused();
        }
    };
    MBaseSelect.prototype.onKeydownEnd = function ($event) {
        if (this.popupOpen) {
            this.focusedIndex = this.items.length - 1;
            this.scrollToFocused();
        }
    };
    MBaseSelect.prototype.onKeydownLetter = function ($event) {
        if (/^[a-z0-9]$/i.test($event.key)) {
            this.findFirstItemWithLetter($event.key);
        }
    };
    MBaseSelect.prototype.onSelectItem = function (option, index, $event) {
        this.select(option, index, $event);
        if (this.closeOnSelect) {
            this.closePopup();
        }
    };
    MBaseSelect.prototype.findFirstItemWithLetter = function (key) {
        if (this.as().isMqMinS) {
            var index = this.items.indexOf(this.items.find(function (item) { return item.startsWith(key); }));
            if (index !== -1) {
                this.focusedIndex = index;
                this.scrollToFocused();
            }
        }
    };
    MBaseSelect.prototype.scrollToFocused = function () {
        if (this.focusedIndex > -1 && this.as().isMqMinS) {
            var container = this.$refs.items;
            if (container) {
                var element = container.children[this.focusedIndex];
                if (element) {
                    var top = element.offsetTop;
                    var bottom = element.offsetTop + element.offsetHeight;
                    var viewRectTop = container.scrollTop;
                    var viewRectBottom = viewRectTop + container.clientHeight;
                    if (top < viewRectTop) {
                        container.scrollTop = top;
                    }
                    else if (bottom > viewRectBottom) {
                        container.scrollTop = bottom - container.clientHeight;
                    }
                }
            }
        }
    };
    MBaseSelect.prototype.isSelected = function (option) {
        if (this.selectedItems && this.selectedItems.length > 0) {
            return this.selectedItems.indexOf(option) > -1;
        }
        return false;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MBaseSelect.prototype, "items", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MBaseSelect.prototype, "selectedItems", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MBaseSelect.prototype, "active", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ required: true })
    ], MBaseSelect.prototype, "controlId", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: false })
    ], MBaseSelect.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MBaseSelect.prototype, "closeOnSelect", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: false })
    ], MBaseSelect.prototype, "hideRadioButtonMobile", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: false })
    ], MBaseSelect.prototype, "sidebarFullHeight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: true })
    ], MBaseSelect.prototype, "enableAnimation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: false })
    ], MBaseSelect.prototype, "virtualScroll", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MBaseSelect.prototype, "listMinWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_6__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MBaseSelect.prototype, "listMaxHeight", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('update:open')
    ], MBaseSelect.prototype, "emitUpdateOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('open')
    ], MBaseSelect.prototype, "emitOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('close')
    ], MBaseSelect.prototype, "emitClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Watch"])('open', { immediate: true })
    ], MBaseSelect.prototype, "onOpenChange", null);
    MBaseSelect = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _base_select_html__WEBPACK_IMPORTED_MODULE_11___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: (_a = {
                    MSelectItem: _select_select_item_select_item__WEBPACK_IMPORTED_MODULE_10__["MSelectItem"]
                },
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_9__["MPopup"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_2__["POPUP_NAME"]] = _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__["MPopupDirective"],
                _b),
            mixins: [
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_4__["InputWidth"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"]
            ]
        })
    ], MBaseSelect);
    return MBaseSelect;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));



/***/ }),

/***/ "./src/components/select/select-item/select-item.html?style=./select-item.scss":
/*!*************************************************************************************!*\
  !*** ./src/components/select/select-item/select-item.html?style=./select-item.scss ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=69da5218!./select-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=69da5218!./src/components/select/select-item/select-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-select-item",
      class: {
        "m--is-focus": _vm.focused && _vm.isItemActive,
        "m--is-selected": _vm.selected && _vm.isItemActive,
        "m--is-item-active": _vm.isItemActive,
        "m--is-disabled": _vm.disabled,
        "m--readonly": _vm.readonly,
        "m--without-radio": _vm.hideRadioButtonMobile
      },
      attrs: {
        role: "option",
        "aria-selected": _vm.selected && _vm.isItemActive
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.onClick($event)
        }
      }
    },
    [
      _vm.isMqMinS || _vm.readonly || _vm.hideRadioButtonMobile
        ? _vm._t("default", [
            _c("span", { staticClass: "m-select-item__element-text" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ])
        : _c(
            "m-radio-style",
            {
              attrs: {
                "full-width": true,
                "radio-position": "right",
                focus: _vm.focused,
                checked: _vm.selected,
                disabled: _vm.disabled,
                tabindex: "0"
              }
            },
            [
              _vm._t("default", [
                _c("span", { staticClass: "m-select-item__element-text" }, [
                  _vm._v(_vm._s(_vm.label))
                ])
              ])
            ],
            2
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-69da5218'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/select/select-item/select-item.ts":
/*!**********************************************************!*\
  !*** ./src/components/select/select-item/select-item.ts ***!
  \**********************************************************/
/*! exports provided: MSelectItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSelectItem", function() { return MSelectItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _radio_style_radio_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../radio-style/radio-style */ "./src/components/radio-style/radio-style.ts");
/* harmony import */ var _select_item_html_style_select_item_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./select-item.html?style=./select-item.scss */ "./src/components/select/select-item/select-item.html?style=./select-item.scss");
/* harmony import */ var _select_item_html_style_select_item_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_select_item_html_style_select_item_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MSelectItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSelectItem, _super);
    function MSelectItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MSelectItem.prototype.emitClick = function ($event) { };
    Object.defineProperty(MSelectItem.prototype, "isItemActive", {
        get: function () {
            return !this.disabled;
        },
        enumerable: true,
        configurable: true
    });
    MSelectItem.prototype.onClick = function ($event) {
        if (!this.disabled) {
            this.emitClick($event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "readonly", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "selected", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])()
    ], MSelectItem.prototype, "focused", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Prop"])({ default: false })
    ], MSelectItem.prototype, "hideRadioButtonMobile", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Emit"])('click')
    ], MSelectItem.prototype, "emitClick", null);
    MSelectItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _select_item_html_style_select_item_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_1__["Component"])({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["RADIO_STYLE_NAME"]] = _radio_style_radio_style__WEBPACK_IMPORTED_MODULE_5__["MRadioStyle"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_2__["MediaQueries"]]
        })
    ], MSelectItem);
    return MSelectItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/show-more/show-more.html?style=./show-more.scss":
/*!************************************************************************!*\
  !*** ./src/components/show-more/show-more.html?style=./show-more.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6f985e5d!./show-more.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6f985e5d!./src/components/show-more/show-more.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "m-show-more" },
        [
          _c("div", { ref: "countTotal", staticClass: "m-show-more__status" }, [
            _vm._v(_vm._s(_vm.status))
          ]),
          _vm._v(" "),
          _vm.isProgressVisible
            ? _c("m-progress", {
                ref: "progress",
                attrs: {
                  value: _vm.visiblePourcentage,
                  "border-radius": false,
                  skin: _vm.skin
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isButtonVisible
            ? _c(
                "m-button",
                {
                  ref: "button",
                  attrs: { skin: _vm.buttonSkin, waiting: _vm.loading },
                  on: { click: _vm.showMore }
                },
                [_vm._v(_vm._s(_vm.buttonLabel))]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-6f985e5d'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/show-more/show-more.ts":
/*!***********************************************!*\
  !*** ./src/components/show-more/show-more.ts ***!
  \***********************************************/
/*! exports provided: MShowMore, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MShowMore", function() { return MShowMore; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _progress_progress__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../progress/progress */ "./src/components/progress/progress.ts");
/* harmony import */ var _show_more_html_style_show_more_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./show-more.html?style=./show-more.scss */ "./src/components/show-more/show-more.html?style=./show-more.scss");
/* harmony import */ var _show_more_html_style_show_more_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_show_more_html_style_show_more_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MShowMore = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MShowMore, _super);
    function MShowMore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MShowMore.prototype, "isVisible", {
        get: function () {
            return this.nbTotal !== undefined && this.nbTotal > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "isProgressVisible", {
        get: function () {
            return this.nbVisible < this.nbTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "status", {
        get: function () {
            return this.$i18n.translate('m-show-more:status', { nbVisible: this.nbVisible, nbTotal: this.nbTotal }, undefined, undefined, undefined, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_3__["FormatMode"].Sprintf);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "visiblePourcentage", {
        get: function () {
            return (this.nbVisible / this.nbTotal) * 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "buttonLabel", {
        get: function () {
            return this.$i18n.translate('m-show-more:button-label');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "buttonSkin", {
        get: function () {
            return _button_button__WEBPACK_IMPORTED_MODULE_5__["MButtonSkin"].Secondary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MShowMore.prototype, "isButtonVisible", {
        get: function () {
            return this.nbVisible < this.nbTotal;
        },
        enumerable: true,
        configurable: true
    });
    MShowMore.prototype.showMore = function () {
        this.$emit('update:loading', true);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MShowMore.prototype, "nbVisible", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ required: true })
    ], MShowMore.prototype, "nbTotal", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MShowMore.prototype, "loading", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MShowMore.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MShowMore.prototype, "showMore", null);
    MShowMore = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _show_more_html_style_show_more_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_5__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["PROGRESS_NAME"]] = _progress_progress__WEBPACK_IMPORTED_MODULE_7__["MProgress"],
                _a)
        })
    ], MShowMore);
    return MShowMore;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ShowMorePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["SHOW_MORE_NAME"], MShowMore);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ShowMorePlugin);


/***/ }),

/***/ "./src/components/sidebar/sidebar.html?style=./sidebar.scss":
/*!******************************************************************!*\
  !*** ./src/components/sidebar/sidebar.html?style=./sidebar.scss ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5116ddaf!./sidebar.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5116ddaf!./src/components/sidebar/sidebar.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "baseWindow", staticClass: "m-sidebar" },
    [
      _vm._t("trigger"),
      _vm._v(" "),
      _vm.portalCreated
        ? _c(
            "portal",
            { attrs: { "target-el": _vm.portalTargetSelector } },
            [
              _c("transition", { attrs: { name: "m--is" } }, [
                _vm.portalMounted
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propOpen,
                            expression: "propOpen"
                          }
                        ],
                        ref: "modalWrap",
                        staticClass: "m-sidebar__wrap",
                        class: [
                          {
                            "m--is-close-on-backdrop": _vm.closeOnBackdrop,
                            "m--is-disabled": _vm.disabled,
                            "m--is-full-height": _vm.fullHeight
                          },
                          "m--is-origin-" + _vm.origin,
                          _vm.className
                        ],
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.backdropClick($event)
                          }
                        }
                      },
                      [
                        _c(
                          "article",
                          {
                            ref: "article",
                            staticClass: "m-sidebar__article",
                            style: {
                              width: _vm.propWidth,
                              "margin-left": _vm.marginLeft
                            }
                          },
                          [
                            _vm.closeButton && _vm.origin === "bottom"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "m-sidebar__close-button",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("m-i18n", {
                                      attrs: { k: "m-sidebar:close" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$slots.header || _vm.hasHeader
                              ? _c(
                                  "header",
                                  {
                                    staticClass: "m-sidebar__header",
                                    class: {
                                      "m--has-close-button-right":
                                        _vm.closeButton &&
                                        _vm.closeButtonPosition === "right" &&
                                        _vm.origin !== "bottom",
                                      "m--has-close-button-left":
                                        _vm.closeButton &&
                                        _vm.closeButtonPosition === "left" &&
                                        _vm.origin !== "bottom",
                                      "m--no-content":
                                        (!_vm.$slots.header || !_vm.title) &&
                                        _vm.closeButton &&
                                        _vm.origin !== "bottom",
                                      "m--no-padding":
                                        !_vm.padding || !_vm.paddingHeader
                                    }
                                  },
                                  [
                                    _vm.title
                                      ? _c(
                                          "h2",
                                          { staticClass: "m-sidebar__title" },
                                          [_vm._v(_vm._s(_vm.title))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("header"),
                                    _vm._v(" "),
                                    _vm.closeButton && _vm.origin !== "bottom"
                                      ? _c(
                                          "m-icon-button",
                                          {
                                            staticClass:
                                              "m-sidebar__header__close-button",
                                            attrs: {
                                              "icon-name": "m-svg__close-clear"
                                            },
                                            on: { click: _vm.closeModal }
                                          },
                                          [
                                            _c("m-i18n", {
                                              attrs: { k: "m-sidebar:close" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$slots.default
                              ? _c(
                                  "div",
                                  {
                                    ref: "body",
                                    staticClass: "m-sidebar__body",
                                    class: {
                                      "m--no-padding":
                                        !_vm.padding || !_vm.paddingBody
                                    }
                                  },
                                  [_vm._t("default")],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$slots.footer
                              ? _c(
                                  "footer",
                                  {
                                    staticClass: "m-sidebar__footer",
                                    class: {
                                      "m--no-padding":
                                        !_vm.padding || !_vm.paddingFooter
                                    }
                                  },
                                  [_vm._t("footer")],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-5116ddaf'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/sidebar/sidebar.ts":
/*!*******************************************!*\
  !*** ./src/components/sidebar/sidebar.ts ***!
  \*******************************************/
/*! exports provided: MSidebarOrigin, MSidebarCloseButtonPosition, MSidebar, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSidebarOrigin", function() { return MSidebarOrigin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSidebarCloseButtonPosition", function() { return MSidebarCloseButtonPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSidebar", function() { return MSidebar; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _sidebar_html_style_sidebar_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./sidebar.html?style=./sidebar.scss */ "./src/components/sidebar/sidebar.html?style=./sidebar.scss");
/* harmony import */ var _sidebar_html_style_sidebar_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_sidebar_html_style_sidebar_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MSidebarOrigin;
(function (MSidebarOrigin) {
    MSidebarOrigin["Top"] = "top";
    MSidebarOrigin["Right"] = "right";
    MSidebarOrigin["Bottom"] = "bottom";
    MSidebarOrigin["Left"] = "left";
})(MSidebarOrigin || (MSidebarOrigin = {}));
var MSidebarCloseButtonPosition;
(function (MSidebarCloseButtonPosition) {
    MSidebarCloseButtonPosition["Left"] = "left";
    MSidebarCloseButtonPosition["Right"] = "right";
})(MSidebarCloseButtonPosition || (MSidebarCloseButtonPosition = {}));
var MSidebar = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSidebar, _super);
    function MSidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MSidebar.prototype, "popupBody", {
        get: function () {
            return this.$refs.article.querySelector('.m-popup__body');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSidebar.prototype, "hasHeader", {
        get: function () {
            return Boolean(this.title) || (this.closeButton && this.origin !== MSidebarOrigin.Bottom);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSidebar.prototype, "marginLeft", {
        get: function () {
            return this.origin === MSidebarOrigin.Right ? 'calc(100% - ' + this.propWidth + ')' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSidebar.prototype, "propWidth", {
        get: function () {
            if (this.origin === MSidebarOrigin.Left || this.origin === MSidebarOrigin.Right) {
                return this.width ? this.width : '50%';
            }
            else {
                return '100%';
            }
        },
        enumerable: true,
        configurable: true
    });
    MSidebar.prototype.handlesFocus = function () {
        return this.focusManagement;
    };
    MSidebar.prototype.doCustomPropOpen = function (value) {
        return false;
    };
    MSidebar.prototype.getBackdropMode = function () {
        return _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["BackdropMode"].BackdropFast;
    };
    MSidebar.prototype.getPortalElement = function () {
        return this.$refs.article;
    };
    MSidebar.prototype.closeModal = function () {
        this.as().tryClose();
    };
    MSidebar.prototype.backdropClick = function () {
        if (this.closeOnBackdrop) {
            this.as().tryClose();
        }
    };
    MSidebar.prototype.mounted = function () {
        this.as().transitionDuration = _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["PortalTransitionDuration"].Slow;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSidebarOrigin.Bottom,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__["Enums"].toValueArray(MSidebarOrigin).includes(value); }
        })
    ], MSidebar.prototype, "origin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSidebar.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSidebar.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "closeButton", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSidebarCloseButtonPosition.Right,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_4__["Enums"].toValueArray(MSidebarCloseButtonPosition).includes(value); }
        })
    ], MSidebar.prototype, "closeButtonPosition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "focusManagement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "closeOnBackdrop", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "padding", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "paddingHeader", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "paddingBody", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSidebar.prototype, "paddingFooter", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MSidebar.prototype, "fullHeight", void 0);
    MSidebar = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _sidebar_html_style_sidebar_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["MI18n"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__["MIconButton"],
                _a),
            mixins: [_mixins_portal_portal__WEBPACK_IMPORTED_MODULE_3__["Portal"]]
        })
    ], MSidebar);
    return MSidebar;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var SidebarPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["SIDEBAR_NAME"], MSidebar);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SidebarPlugin);


/***/ }),

/***/ "./src/components/spinner/spinner.html?style=./spinner.scss":
/*!******************************************************************!*\
  !*** ./src/components/spinner/spinner.html?style=./spinner.scss ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5814d975!./spinner.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5814d975!./src/components/spinner/spinner.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { appear: true, css: false },
      on: {
        enter: function($event) {
          return _vm.openProcessingPortal()
        },
        leave: function($event) {
          return _vm.removeBackdrop()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "m-spinner" },
        [
          _vm.initialized
            ? _c("portal", { attrs: { "target-el": _vm.spinnerElement } }, [
                _c(
                  "div",
                  {
                    ref: "spinnerWrap",
                    staticClass: "m-spinner__wrap",
                    class: {
                      "m--is-processing": _vm.processing,
                      "m--is-dark": _vm.skin === "dark",
                      "m--is-light": _vm.skin === "light",
                      "m--is-lighter": _vm.skin === "lighter"
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "m-spinner__icon",
                      class: { "m--is-small": _vm.size === "small" },
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _vm.titleMessage ||
                    (_vm.title && _vm.processing) ||
                    _vm.title
                      ? _c(
                          "h2",
                          { staticClass: "m-spinner__title" },
                          [
                            _vm.titleMessage
                              ? [_vm._v(_vm._s(_vm.titleMessage))]
                              : _vm.title && _vm.processing
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("f-m-i18n")("m-spinner:processing")
                                    )
                                  )
                                ]
                              : _vm.title
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("f-m-i18n")("m-spinner:loading")
                                    )
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.description || _vm.descriptionMessage
                      ? _c(
                          "p",
                          { staticClass: "m-spinner__description" },
                          [
                            _vm.descriptionMessage
                              ? [_vm._v(_vm._s(_vm.descriptionMessage))]
                              : [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("f-m-i18n")(
                                        "m-spinner:description"
                                      )
                                    )
                                  )
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.processing ? _c("div", { ref: "spinnerContainer" }) : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-5814d975'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/spinner/spinner.ts":
/*!*******************************************!*\
  !*** ./src/components/spinner/spinner.ts ***!
  \*******************************************/
/*! exports provided: MSpinnerStyle, MSpinnerSize, PROCESSING_WARN, MSpinner, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSpinnerStyle", function() { return MSpinnerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSpinnerSize", function() { return MSpinnerSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROCESSING_WARN", function() { return PROCESSING_WARN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSpinner", function() { return MSpinner; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _spinner_html_style_spinner_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./spinner.html?style=./spinner.scss */ "./src/components/spinner/spinner.html?style=./spinner.scss");
/* harmony import */ var _spinner_html_style_spinner_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_spinner_html_style_spinner_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a, _b;











var MSpinnerStyle;
(function (MSpinnerStyle) {
    MSpinnerStyle["Dark"] = "dark";
    MSpinnerStyle["Regular"] = "regular";
    MSpinnerStyle["Light"] = "light";
    MSpinnerStyle["Lighter"] = "lighter";
})(MSpinnerStyle || (MSpinnerStyle = {}));
var MSpinnerSize;
(function (MSpinnerSize) {
    MSpinnerSize["Large"] = "large";
    MSpinnerSize["Small"] = "small";
})(MSpinnerSize || (MSpinnerSize = {}));
var PROCESSING_WARN = 'Change of property "processing" is not supported';
var SPINNER_ID = 'MSpinner';
var MSpinner = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSpinner, _super);
    function MSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.spinnerId = SPINNER_ID + '-' + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_6__["default"].generate();
        _this.portalTargetEl = {}; // initialized to be responsive
        _this.initialized = false; // seems to be necessary since $refs are not responsive
        return _this;
    }
    MSpinner.prototype.created = function () {
        this.portalTargetEl = undefined;
    };
    MSpinner.prototype.beforeDestroy = function () {
        this.removeBackdrop();
    };
    MSpinner.prototype.onProcessingChange = function (value) {
        if (value) {
            this.openProcessingPortal();
        }
        else {
            this.removeBackdrop();
        }
    };
    Object.defineProperty(MSpinner.prototype, "spinnerElement", {
        get: function () {
            return this.processing ? this.portalTargetEl : this.$refs.spinnerContainer;
        },
        enumerable: true,
        configurable: true
    });
    MSpinner.prototype.openProcessingPortal = function () {
        if (!this.portalTargetEl && this.processing) {
            var element = document.createElement('div');
            element.setAttribute('id', this.spinnerId);
            document.body.appendChild(element);
            this.portalTargetEl = document.getElementById(this.spinnerId);
            this.stackId = this.$modul.pushElement(this.portalTargetEl, _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_5__["BackdropMode"].BackdropSlow, false);
            this.portalTargetEl.style.position = 'absolute';
        }
        this.initialized = true;
    };
    MSpinner.prototype.removeBackdrop = function () {
        if (this.portalTargetEl) {
            this.$modul.popElement(this.stackId);
            this.portalTargetEl.style.position = '';
            this.portalTargetEl = undefined;
        }
        var el = document.getElementById(this.spinnerId);
        if (el) {
            document.body.removeChild(el);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSpinner.prototype, "title", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSpinner.prototype, "titleMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSpinner.prototype, "description", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSpinner.prototype, "descriptionMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSpinnerStyle.Regular,
            validator: function (value) {
                return value === MSpinnerStyle.Dark ||
                    value === MSpinnerStyle.Light ||
                    value === MSpinnerStyle.Lighter ||
                    value === MSpinnerStyle.Regular;
            }
        })
    ], MSpinner.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSpinnerSize.Large,
            validator: function (value) {
                return value === MSpinnerSize.Large ||
                    value === MSpinnerSize.Small;
            }
        })
    ], MSpinner.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSpinner.prototype, "processing", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('processing')
    ], MSpinner.prototype, "onProcessingChange", null);
    MSpinner = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _spinner_html_style_spinner_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_9__["MI18n"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b)
        })
    ], MSpinner);
    return MSpinner;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_7__["ModulVue"]));

var SpinnerPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_8__["SPINNER_NAME"], MSpinner);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SpinnerPlugin);


/***/ }),

/***/ "./src/components/steppers/steppers-item/steppers-item.html?style=./steppers-item.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/steppers/steppers-item/steppers-item.html?style=./steppers-item.scss ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=827d400c!./steppers-item.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=827d400c!./src/components/steppers/steppers-item/steppers-item.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-steppers-item",
      class: {
        "m--is-visited": _vm.isVisited,
        "m--is-in-progress": _vm.isInProgress,
        "m--is-disabled": _vm.isDisabled,
        "m--is-completed": _vm.completed,
        "m--is-link": _vm.isLink
      }
    },
    [
      _c(
        _vm.componentToShow,
        {
          tag: "component",
          staticClass: "m-steppers-item__button",
          attrs: {
            to: _vm.propUrl,
            tabindex: _vm.isTabIndex,
            role: _vm.role,
            "aria-selected": _vm.isInProgress
          },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onClick($event)
            },
            click: _vm.onClick
          }
        },
        [
          _c(
            "div",
            { staticClass: "m-steppers-item__icon" },
            [
              _c("m-icon", {
                attrs: { name: _vm.iconName, "svg-title": _vm.iconTitle }
              }),
              _vm._v(" "),
              _vm.completed
                ? _c("m-icon", {
                    staticClass: "m-steppers-item__icon-completed",
                    attrs: { name: "m-svg__completed-filled" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "title",
              staticClass: "m-steppers-item__title",
              on: { click: _vm.onClick }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-827d400c'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/steppers/steppers-item/steppers-item.ts":
/*!****************************************************************!*\
  !*** ./src/components/steppers/steppers-item/steppers-item.ts ***!
  \****************************************************************/
/*! exports provided: MSteppersItemState, BaseSteppers, MSteppersItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSteppersItemState", function() { return MSteppersItemState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseSteppers", function() { return BaseSteppers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSteppersItem", function() { return MSteppersItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _steppers_item_html_style_steppers_item_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./steppers-item.html?style=./steppers-item.scss */ "./src/components/steppers/steppers-item/steppers-item.html?style=./steppers-item.scss");
/* harmony import */ var _steppers_item_html_style_steppers_item_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_steppers_item_html_style_steppers_item_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MSteppersItemState;
(function (MSteppersItemState) {
    MSteppersItemState["Visited"] = "visited";
    MSteppersItemState["InProgress"] = "in-progress";
    MSteppersItemState["Disabled"] = "disabled";
})(MSteppersItemState || (MSteppersItemState = {}));
var BaseSteppers = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BaseSteppers, _super);
    function BaseSteppers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseSteppers;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var MSteppersItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSteppersItem, _super);
    function MSteppersItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MSteppersItem.prototype.stateChanged = function (value) {
        if (this.$parent instanceof BaseSteppers) {
            this.$parent.setAnim(true);
            this.$parent.setLineWidth();
            this.$parent.setAnim(false);
        }
        this.$emit('update:value', this.state);
    };
    Object.defineProperty(MSteppersItem.prototype, "isVisited", {
        get: function () {
            return this.state === MSteppersItemState.Visited;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "isInProgress", {
        get: function () {
            return this.state === MSteppersItemState.InProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "isDisabled", {
        get: function () {
            return this.state === MSteppersItemState.Disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "isTabIndex", {
        get: function () {
            return this.isVisited ? 0 : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "isLink", {
        get: function () {
            return !!this.url && this.isVisited;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "componentToShow", {
        get: function () {
            return this.isLink ? 'router-link' : 'div';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "role", {
        get: function () {
            return this.isLink || this.isDisabled ? undefined : 'button';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSteppersItem.prototype, "propUrl", {
        get: function () {
            return this.isLink ? this.url : undefined;
        },
        enumerable: true,
        configurable: true
    });
    MSteppersItem.prototype.onClick = function (event) {
        if (this.isVisited) {
            this.$emit('click', event);
            this.$refs.title.blur();
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSteppersItemState.Disabled,
            validator: function (value) {
                return value === MSteppersItemState.Visited ||
                    value === MSteppersItemState.InProgress ||
                    value === MSteppersItemState.Disabled;
            }
        })
    ], MSteppersItem.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSteppersItem.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSteppersItem.prototype, "iconTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MSteppersItem.prototype, "completed", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSteppersItem.prototype, "url", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('state')
    ], MSteppersItem.prototype, "stateChanged", null);
    MSteppersItem = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _steppers_item_html_style_steppers_item_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_5__["MIcon"],
                _a)
        })
    ], MSteppersItem);
    return MSteppersItem;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/steppers/steppers.html?style=./steppers.scss":
/*!*********************************************************************!*\
  !*** ./src/components/steppers/steppers.html?style=./steppers.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3f3dc9e9!./steppers.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=3f3dc9e9!./src/components/steppers/steppers.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-steppers" }, [
    _c(
      "div",
      { ref: "overflowWrapper", staticClass: "m-steppers__overflow-wrapper" },
      [
        _c(
          "ul",
          { ref: "wrapItem", staticClass: "m-steppers__wrap" },
          [
            _c("li", {
              ref: "defaultLine",
              staticClass: "m-steppers__default-line",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("li", {
              ref: "selectedLine",
              staticClass: "m-steppers__selected-line",
              class: { "m--is-anim-active": _vm.isAnimActive },
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-3f3dc9e9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/steppers/steppers.ts":
/*!*********************************************!*\
  !*** ./src/components/steppers/steppers.ts ***!
  \*********************************************/
/*! exports provided: MSteppers, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSteppers", function() { return MSteppers; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/element-queries/element-queries */ "./src/mixins/element-queries/element-queries.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./steppers-item/steppers-item */ "./src/components/steppers/steppers-item/steppers-item.ts");
/* harmony import */ var _steppers_html_style_steppers_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./steppers.html?style=./steppers.scss */ "./src/components/steppers/steppers.html?style=./steppers.scss");
/* harmony import */ var _steppers_html_style_steppers_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_steppers_html_style_steppers_scss__WEBPACK_IMPORTED_MODULE_6__);







var MSteppers = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSteppers, _super);
    function MSteppers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isAnimActive = false;
        return _this;
    }
    MSteppers.prototype.setLineWidth = function () {
        var defaultLineEL = this.$refs.defaultLine;
        var selectedLineEL = this.$refs.selectedLine;
        var wrapItem = this.$refs.wrapItem;
        var parentWidth = wrapItem.clientWidth;
        var leftSpacing = 0;
        var rightSpacing = 0;
        var hasFindFirst = false;
        for (var i = 0; i <= this.$children.length - 1; i++) {
            if (i === 0 && this.$children.length >= 1) {
                leftSpacing = this.$children[i].$el.clientWidth / 2;
            }
            if (this.$children.length - 1 === i && this.$children.length > 1) {
                rightSpacing = this.$children[i].$el.clientWidth / 2;
            }
            if (this.$children[i].$props.state === _steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__["MSteppersItemState"].InProgress) {
                this.scrollElement(this.$children[i].$el);
            }
        }
        for (var i = this.$children.length - 1; i >= 0; i--) {
            if (hasFindFirst === false && this.$children[i].$props.state === _steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__["MSteppersItemState"].InProgress || hasFindFirst === false && this.$children[i].$props.state === _steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__["MSteppersItemState"].Visited) {
                var childWidth = this.$children[i].$el.clientWidth;
                var childOffset = this.$children[i].$el.offsetLeft;
                this.lineWidth = ((childOffset - leftSpacing + (childWidth / 2)) / parentWidth) * 100;
                hasFindFirst = true;
            }
        }
        defaultLineEL.style.left = leftSpacing + 'px';
        defaultLineEL.style.right = rightSpacing + 'px';
        selectedLineEL.style.width = this.lineWidth + '%';
        selectedLineEL.style.left = leftSpacing + 'px';
    };
    MSteppers.prototype.setAnim = function (value) {
        var _this = this;
        if (value === true) {
            this.isAnimActive = value;
        }
        else {
            setTimeout(function () {
                _this.isAnimActive = value;
            }, 1000);
        }
    };
    MSteppers.prototype.mounted = function () {
        this.initWidthAndHeightOfSteppers();
    };
    MSteppers.prototype.initWidthAndHeightOfSteppers = function () {
        var _this = this;
        this.setLineWidth();
        this.as().$on('resizeDone', this.setLineWidth);
        var overflowWrapperStyleHeight = this.$refs.overflowWrapper.style.height;
        var elStyleHeight = this.$el.style.height;
        var wrapItem = this.$refs.wrapItem;
        var initHeight = wrapItem.clientHeight;
        var scrollbarSpace = 40;
        if (document.readyState === 'complete' || initHeight > 0) {
            elStyleHeight = initHeight + 'px';
            overflowWrapperStyleHeight = initHeight + scrollbarSpace + 'px';
            this.setMinWidth();
        }
        else {
            var intervalForDomReady_1 = setInterval(function () {
                // The document is ready when the clientHeight is larger than 0
                if (wrapItem.clientHeight > 0) {
                    initHeight = wrapItem.clientHeight;
                    elStyleHeight = initHeight + 'px';
                    overflowWrapperStyleHeight = initHeight + scrollbarSpace + 'px';
                    _this.setMinWidth();
                    _this.setLineWidth();
                    window.clearInterval(intervalForDomReady_1);
                }
            }, 100);
        }
    };
    MSteppers.prototype.setMinWidth = function () {
        var wrapItem = this.$refs.wrapItem;
        wrapItem.style.opacity = '0';
        wrapItem.style.display = 'block';
        var childsWidth = 0;
        this.$children.forEach(function (child, index, arr) {
            childsWidth += child.$el.clientWidth;
        });
        var minWidth;
        var numberOfChild = this.$children.length;
        minWidth = childsWidth + ((numberOfChild - 1) * 24);
        wrapItem.style.minWidth = minWidth + 'px';
        wrapItem.style.display = 'flex';
        wrapItem.style.opacity = '1';
    };
    MSteppers.prototype.centeringElement = function (element) {
        this.$refs.overflowWrapper.scrollLeft = element.offsetLeft - ((this.$el.clientWidth / 2) - (element.clientWidth / 2));
    };
    MSteppers.prototype.scrollElement = function (element) {
        this.$refs.overflowWrapper.scrollLeft = element.offsetLeft;
    };
    MSteppers = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _steppers_html_style_steppers_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [_mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_2__["ElementQueries"]]
        })
    ], MSteppers);
    return MSteppers;
}(_steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__["BaseSteppers"]));

var SteppersPlugin = {
    install: function (v, options) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["STEPPERS_ITEM_NAME"], _steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_5__["MSteppersItem"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["STEPPERS_NAME"], MSteppers);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SteppersPlugin);


/***/ }),

/***/ "./src/components/svg/svg.html":
/*!*************************************!*\
  !*** ./src/components/svg/svg.html ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("svg", {
    staticClass: "m-svg",
    class: _vm.classAttribute,
    attrs: {
      width: _vm.width,
      height: _vm.height,
      version: _vm.version,
      xmlns: _vm.xmlns,
      viewBox: _vm.viewBox,
      "data-svg-id": _vm.dataSvgId,
      "data-badge-origin": _vm.badgeOrigin,
      "aria-hidden": !_vm.svgTitle
    },
    domProps: { innerHTML: _vm._s(_vm.svgChildrenContent) },
    on: {
      click: _vm.emitClick,
      keydown: _vm.emitKeydown,
      mouseover: _vm.emitMouseOver,
      mouseleave: _vm.emitMouseLeave
    }
  })
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4484361f'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/svg/svg.ts":
/*!***********************************!*\
  !*** ./src/components/svg/svg.ts ***!
  \***********************************/
/*! exports provided: MSvg, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSvg", function() { return MSvg; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_icons_svg_profile_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../assets/icons/svg/profile.svg */ "./src/assets/icons/svg/profile.svg");
/* harmony import */ var _assets_icons_svg_profile_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_svg_profile_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_clean_htmlClean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/clean/htmlClean */ "./src/utils/clean/htmlClean.ts");
/* harmony import */ var _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/props-validation/props-validation */ "./src/utils/props-validation/props-validation.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _svg_html__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./svg.html */ "./src/components/svg/svg.html");
/* harmony import */ var _svg_html__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_svg_html__WEBPACK_IMPORTED_MODULE_8__);









var MSvg = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSvg, _super);
    function MSvg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MSvg.prototype.emitClick = function (event) { };
    MSvg.prototype.emitKeydown = function (event) { };
    MSvg.prototype.emitMouseOver = function (event) { };
    MSvg.prototype.emitMouseLeave = function (event) { };
    MSvg.prototype.emitSvgId = function (svgId) { };
    MSvg.prototype.beforeCreated = function () {
        if (!this.$svgSprite) {
            throw new Error('$svgSprite not installed , install SvgSpritesPlugin to use this component');
        }
    };
    MSvg.prototype.onDataSvgIdChange = function (svgId) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!svgId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        this.emitSvgId(svgId);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MSvg.prototype, "testSvg", {
        get: function () {
            return _assets_icons_svg_profile_svg__WEBPACK_IMPORTED_MODULE_3___default.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "svg", {
        get: function () {
            if (!this.name) {
                return '';
            }
            var svgString = this.$svgSprite.getSvgString(this.name);
            return svgString ? svgString : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "svgChildrenContent", {
        get: function () {
            var cleanSvg = this.svg ? Object(_utils_clean_htmlClean__WEBPACK_IMPORTED_MODULE_4__["eraseTagAndAllIsContent"])('title', Object(_utils_clean_htmlClean__WEBPACK_IMPORTED_MODULE_4__["eraseTag"])('svg', this.svg)) : '';
            if (this.svgTitle) {
                cleanSvg = "<title>" + this.svgTitle + "</title>" + cleanSvg;
            }
            return cleanSvg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "svgHTML", {
        get: function () {
            var domParser = new DOMParser().parseFromString(this.svg, 'text/html');
            return domParser && domParser.querySelector('svg') ? domParser.querySelector('svg') : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "classAttribute", {
        get: function () {
            return this.getSvgAttibute('class');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "version", {
        get: function () {
            return this.getSvgAttibute('version');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "xmlns", {
        get: function () {
            return this.getSvgAttibute('xmlns');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "viewBox", {
        get: function () {
            return this.getSvgAttibute('viewBox');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "dataSvgId", {
        get: function () {
            var svgId = this.getSvgAttibute('id');
            this.onDataSvgIdChange(svgId);
            return svgId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSvg.prototype, "badgeOrigin", {
        get: function () {
            return this.getSvgAttibute('data-badge-origin');
        },
        enumerable: true,
        configurable: true
    });
    MSvg.prototype.getSvgAttibute = function (attribute) {
        return this.svgHTML && this.svgHTML.getAttribute(attribute)
            ? this.svgHTML.getAttribute(attribute).toString()
            : undefined;
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MSvg.prototype, "name", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '1em',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_5__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MSvg.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '1em',
            validator: function (value) {
                return _utils_props_validation_props_validation__WEBPACK_IMPORTED_MODULE_5__["REGEX_CSS_NUMBER_VALUE"].test(value);
            }
        })
    ], MSvg.prototype, "height", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSvg.prototype, "svgTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MSvg.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('keydown')
    ], MSvg.prototype, "emitKeydown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseover')
    ], MSvg.prototype, "emitMouseOver", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('mouseleave')
    ], MSvg.prototype, "emitMouseLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('svg-id')
    ], MSvg.prototype, "emitSvgId", null);
    MSvg = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _svg_html__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MSvg);
    return MSvg;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var MSvgPlugin = {
    install: function (v) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["SVG_NAME"], MSvg);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MSvgPlugin);


/***/ }),

/***/ "./src/components/switch/switch.html?style=./switch.scss":
/*!***************************************************************!*\
  !*** ./src/components/switch/switch.html?style=./switch.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=00356e69!./switch.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=00356e69!./src/components/switch/switch.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-switch",
      class: {
        "m--is-switch-left": _vm.hasSwitchLeft,
        "m--is-switch-right": !_vm.hasSwitchLeft,
        "m--is-disabled": _vm.isDisabled,
        "m--is-waiting": _vm.isWaiting,
        "m--has-error": _vm.hasError,
        "m--is-valid": _vm.isValid,
        "m--is-checked": _vm.propChecked,
        "m--is-focus": _vm.isFocus,
        "m--no-state-text": !_vm.stateText
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.propChecked,
            expression: "propChecked"
          }
        ],
        ref: "switch",
        staticClass: "m-switch__hidden",
        attrs: {
          disabled: _vm.isDisabled || _vm.isWaiting,
          type: "checkbox",
          id: _vm.id
        },
        domProps: {
          checked: Array.isArray(_vm.propChecked)
            ? _vm._i(_vm.propChecked, null) > -1
            : _vm.propChecked
        },
        on: {
          click: _vm.onClick,
          focus: function($event) {
            _vm.isFocus = true
          },
          blur: function($event) {
            _vm.isFocus = false
          },
          change: function($event) {
            var $$a = _vm.propChecked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.propChecked = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.propChecked = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.propChecked = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "m-switch__body",
          attrs: { for: _vm.id, "aria-hidden": !_vm.label }
        },
        [
          _c(
            "span",
            {
              staticClass: "m-switch__input",
              attrs: { "aria-hidden": "true" }
            },
            [
              _c("span", { staticClass: "m-switch__button" }),
              _vm._v(" "),
              _vm.stateText
                ? _c("span", { staticClass: "m-switch__text" }, [
                    _vm.propChecked
                      ? _c(
                          "span",
                          [_c("m-i18n", { attrs: { k: "m-switch:yes" } })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.propChecked
                      ? _c(
                          "span",
                          [_c("m-i18n", { attrs: { k: "m-switch:no" } })],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.label
            ? _c(
                "span",
                { staticClass: "m-switch__label" },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("m-validation-message", {
        attrs: {
          disabled: _vm.isDisabled,
          waiting: _vm.isWaiting,
          "error-message": _vm.errorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-00356e69'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/switch/switch.ts":
/*!*****************************************!*\
  !*** ./src/components/switch/switch.ts ***!
  \*****************************************/
/*! exports provided: MSwitchPosition, MSwitch, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSwitchPosition", function() { return MSwitchPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSwitch", function() { return MSwitch; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _switch_html_style_switch_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./switch.html?style=./switch.scss */ "./src/components/switch/switch.html?style=./switch.scss");
/* harmony import */ var _switch_html_style_switch_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_switch_html_style_switch_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var MSwitchPosition;
(function (MSwitchPosition) {
    MSwitchPosition["Left"] = "left";
    MSwitchPosition["Right"] = "right";
})(MSwitchPosition || (MSwitchPosition = {}));
var MSwitch = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSwitch, _super);
    function MSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalValue = false;
        _this.isFocus = false;
        _this.id = "switch" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate();
        return _this;
    }
    MSwitch.prototype.onValueChange = function (value) {
        this.internalValue = value;
    };
    Object.defineProperty(MSwitch.prototype, "propChecked", {
        get: function () {
            return this.value !== undefined ? this.value : this.internalValue;
        },
        set: function (value) {
            this.$emit('change', value);
            this.internalValue = value;
        },
        enumerable: true,
        configurable: true
    });
    MSwitch.prototype.onClick = function (event) {
        this.$emit('click', event);
        this.$refs['switch']['blur']();
    };
    Object.defineProperty(MSwitch.prototype, "hasSwitchLeft", {
        get: function () {
            return ((this.position === MSwitchPosition.Right) ? false : true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSwitch.prototype, "label", {
        get: function () {
            return !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MSwitch.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSwitchPosition.Left,
            validator: function (value) {
                return value === MSwitchPosition.Left ||
                    value === MSwitchPosition.Right;
            }
        })
    ], MSwitch.prototype, "position", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSwitch.prototype, "stateText", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value')
    ], MSwitch.prototype, "onValueChange", null);
    MSwitch = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _switch_html_style_switch_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_8__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_7__["MI18n"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MSwitch);
    return MSwitch;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var SwitchPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["SWITCH_NAME"], MSwitch);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SwitchPlugin);


/***/ }),

/***/ "./src/components/table-header/table-header.html?style=./table-header.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/table-header/table-header.html?style=./table-header.scss ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=519225ae!./table-header.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=519225ae!./src/components/table-header/table-header.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-table-header" },
    [
      _vm._t("left"),
      _vm._v(" "),
      _c("div", { staticClass: "m-table-header__spacer" }),
      _vm._v(" "),
      _vm._t("right"),
      _vm._v(" "),
      _vm.addBtnLabel
        ? _c(
            "m-link",
            {
              ref: "addBtn",
              staticClass: "m-table-header__add-btn",
              class: { "m--has-margin": _vm.$slots.right },
              attrs: {
                icon: true,
                "icon-name": "m-svg__add-circle-filled",
                "icon-size": "22px",
                mode: "button"
              },
              on: { click: _vm.add }
            },
            [_vm._v(_vm._s(_vm.addBtnLabel))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-519225ae'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/table-header/table-header.ts":
/*!*****************************************************!*\
  !*** ./src/components/table-header/table-header.ts ***!
  \*****************************************************/
/*! exports provided: MTableHeader, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableHeader", function() { return MTableHeader; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _table_header_html_style_table_header_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./table-header.html?style=./table-header.scss */ "./src/components/table-header/table-header.html?style=./table-header.scss");
/* harmony import */ var _table_header_html_style_table_header_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_table_header_html_style_table_header_scss__WEBPACK_IMPORTED_MODULE_7__);
var _a;








var MTableHeader = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTableHeader, _super);
    function MTableHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addButtonSkin = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_5__["MIconButtonSkin"].Link;
        return _this;
    }
    MTableHeader.prototype.add = function () {
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTableHeader.prototype, "addBtnLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('add')
    ], MTableHeader.prototype, "add", null);
    MTableHeader = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_header_html_style_table_header_scss__WEBPACK_IMPORTED_MODULE_7___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_4__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_6__["MLink"],
                _a)
        })
    ], MTableHeader);
    return MTableHeader;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var TableHeaderPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["TABLE_HEADER_NAME"], MTableHeader);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TableHeaderPlugin);


/***/ }),

/***/ "./src/components/table/table.html?style=./table.scss":
/*!************************************************************!*\
  !*** ./src/components/table/table.html?style=./table.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e83b90b!./table.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5e83b90b!./src/components/table/table.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "m-table",
      class: [
        "m--is-skin-" + _vm.skin,
        {
          "m--is-loading": _vm.loading,
          "m--is-row-highlighted-on-hover": _vm.rowHighlightedOnHover
        }
      ],
      attrs: { cellspacing: "0" }
    },
    [
      _vm._t("header", [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.columnsInternal, function(column, index) {
              return _c(
                "th",
                {
                  key: column.id,
                  class: [
                    {
                      "m--is-sortable": column.sortable,
                      "m--is-sorted": _vm.isColumnSorted(column),
                      "m--is-text-align-center": _vm.isColumnTextAlignCenter(
                        column
                      ),
                      "m--is-text-align-left": _vm.isColumnTextAlignLeft(
                        column
                      ),
                      "m--is-text-align-right": _vm.isColumnTextAlignRight(
                        column
                      ),
                      "m--is-initial-sort": column.isInitialSort
                    },
                    column.class
                  ],
                  style: _vm.columnWidth(column),
                  attrs: { scope: "col" },
                  on: {
                    click: function($event) {
                      return _vm.sort(column)
                    }
                  }
                },
                [
                  column.sortable
                    ? _c("div", { staticClass: "m-table__header-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "m-table__sortable-icon-wrap" },
                          [
                            _vm._t(
                              "header." + column.dataProp,
                              [
                                _c("div", {
                                  staticClass: "m-table__header-name",
                                  domProps: { innerHTML: _vm._s(column.title) }
                                })
                              ],
                              { column: column }
                            ),
                            _vm._v(" "),
                            column.sortable
                              ? _c("m-icon-button", {
                                  staticClass: "m-table__sortable-icon",
                                  class: [
                                    _vm.getColumnSortDirectionClass(column)
                                  ],
                                  attrs: {
                                    disabled: _vm.loading,
                                    "icon-name": _vm.getColumnSortIcon(column),
                                    skin: "bold",
                                    "button-size": "14px",
                                    "icon-size": "12px",
                                    title: _vm.i18nSort
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.sort(column)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    : _vm._t(
                        "header." + column.dataProp,
                        [
                          _c("div", {
                            staticClass: "m-table__header-name",
                            domProps: { innerHTML: _vm._s(column.title) }
                          })
                        ],
                        { column: column }
                      )
                ],
                2
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _vm._t("body", [
        _c(
          "tbody",
          [
            _vm.isEmpty || _vm.loading
              ? _c("tr", { staticClass: "m-table__placeholder" }, [
                  _c(
                    "td",
                    {
                      staticClass: "m-table__placeholder-container",
                      style: { position: _vm.placeholderPositionType },
                      attrs: { colspan: "100%" }
                    },
                    [
                      _vm.loading
                        ? _c("m-progress", {
                            attrs: {
                              indeterminate: true,
                              "border-radius": false
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "m-table__placeholder-message",
                          style: { width: _vm.widthPlaceholder }
                        },
                        [
                          _vm.isEmpty
                            ? _vm._t("empty", [
                                _c("p", [_vm._v(_vm._s(_vm.i18nEmptyTable))])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loading
                            ? _vm._t("loading", [
                                _c("p", [_vm._v(_vm._s(_vm.i18nLoading))]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "m-table__placeholder-precision"
                                  },
                                  [_vm._v(_vm._s(_vm.i18nPleaseWait))]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ])
              : _vm._l(_vm.rows, function(row, index) {
                  return _c(
                    "tr",
                    { key: index },
                    [
                      _vm._t(
                        "row",
                        _vm._l(_vm.columnsInternal, function(column) {
                          return _c(
                            "td",
                            {
                              key: "body." + column.id,
                              class: [
                                {
                                  "m--is-sortable": column.sortable,
                                  "m--is-text-align-center": _vm.isColumnTextAlignCenter(
                                    column
                                  ),
                                  "m--is-text-align-left": _vm.isColumnTextAlignLeft(
                                    column
                                  ),
                                  "m--is-text-align-right": _vm.isColumnTextAlignRight(
                                    column
                                  )
                                },
                                column.class
                              ]
                            },
                            [
                              _vm._t(
                                "body." + column.dataProp,
                                [_vm._v(_vm._s(row[column.dataProp]))],
                                { data: row }
                              )
                            ],
                            2
                          )
                        }),
                        { data: row }
                      )
                    ],
                    2
                  )
                })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("tfoot", [_c("tr", [_vm._t("footer")], 2)])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-5e83b90b'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/table/table.ts":
/*!***************************************!*\
  !*** ./src/components/table/table.ts ***!
  \***************************************/
/*! exports provided: MTableSkin, MColumnSortDirection, MColumnTextAlign, MTable, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTableSkin", function() { return MTableSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MColumnSortDirection", function() { return MColumnSortDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MColumnTextAlign", function() { return MColumnTextAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTable", function() { return MTable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/enums/enums */ "./src/utils/enums/enums.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _progress_progress__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../progress/progress */ "./src/components/progress/progress.ts");
/* harmony import */ var _table_html_style_table_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./table.html?style=./table.scss */ "./src/components/table/table.html?style=./table.scss");
/* harmony import */ var _table_html_style_table_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_table_html_style_table_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MTableSkin;
(function (MTableSkin) {
    MTableSkin["Regular"] = "regular";
    MTableSkin["Simple"] = "simple";
})(MTableSkin || (MTableSkin = {}));
var MColumnSortDirection;
(function (MColumnSortDirection) {
    MColumnSortDirection[MColumnSortDirection["None"] = 0] = "None";
    MColumnSortDirection[MColumnSortDirection["Asc"] = 1] = "Asc";
    MColumnSortDirection[MColumnSortDirection["Dsc"] = -1] = "Dsc";
})(MColumnSortDirection || (MColumnSortDirection = {}));
var MColumnTextAlign;
(function (MColumnTextAlign) {
    MColumnTextAlign["Center"] = "center";
    MColumnTextAlign["Left"] = "left";
    MColumnTextAlign["Right"] = "right";
})(MColumnTextAlign || (MColumnTextAlign = {}));
var MTable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTable, _super);
    function MTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18nEmptyTable = _this.$i18n.translate('m-table:no-data');
        _this.i18nLoading = _this.$i18n.translate('m-table:loading');
        _this.i18nPleaseWait = _this.$i18n.translate('m-table:please-wait');
        _this.i18nSort = _this.$i18n.translate('m-table:sort');
        return _this;
    }
    MTable.prototype.onAdd = function () {
    };
    MTable.prototype.emitSortApplied = function (columnTable) { };
    Object.defineProperty(MTable.prototype, "isEmpty", {
        get: function () {
            return this.rows.length === 0 && !this.loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTable.prototype, "placeholderPositionType", {
        get: function () {
            return this.widthPlaceholder.search(/^\d+(\.[0-9]{1,4})?px$/) ? 'absolute' : 'sticky';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTable.prototype, "columnsInternal", {
        get: function () {
            return this.columns.filter(function (c) { return c.visible === undefined || c.visible; }).map(function (c) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, c)); });
        },
        enumerable: true,
        configurable: true
    });
    MTable.prototype.sort = function (columnTable) {
        if (this.loading || !columnTable.sortable) {
            return;
        }
        if (typeof columnTable.sortDirection === 'undefined') {
            columnTable.sortDirection = MColumnSortDirection.None;
        }
        this.columnsInternal.forEach(function (c) {
            if (c !== columnTable) {
                c.sortDirection = MColumnSortDirection.None;
            }
        });
        switch (columnTable.sortDirection) {
            case MColumnSortDirection.None:
                columnTable.sortDirection = columnTable.defaultSortDirection ? columnTable.defaultSortDirection : MColumnSortDirection.Asc;
                columnTable.isInitialSort = true;
                break;
            case MColumnSortDirection.Asc:
                if (columnTable.enableUnsort) {
                    columnTable.sortDirection = columnTable.defaultSortDirection === MColumnSortDirection.Dsc ? MColumnSortDirection.None : MColumnSortDirection.Dsc;
                }
                else {
                    columnTable.sortDirection = MColumnSortDirection.Dsc;
                }
                columnTable.isInitialSort = false;
                break;
            case MColumnSortDirection.Dsc:
                if (columnTable.enableUnsort) {
                    columnTable.sortDirection = (columnTable.defaultSortDirection === MColumnSortDirection.Asc || columnTable.defaultSortDirection === undefined) ? MColumnSortDirection.None : MColumnSortDirection.Asc;
                }
                else {
                    columnTable.sortDirection = MColumnSortDirection.Asc;
                }
                columnTable.isInitialSort = false;
                break;
        }
        this.emitSortApplied(columnTable);
    };
    MTable.prototype.isColumnSorted = function (columnTable) {
        return columnTable.sortDirection === MColumnSortDirection.Asc || columnTable.sortDirection === MColumnSortDirection.Dsc;
    };
    MTable.prototype.isColumnTextAlignCenter = function (columnTable) {
        return columnTable.textAlign === MColumnTextAlign.Center;
    };
    MTable.prototype.isColumnTextAlignLeft = function (columnTable) {
        return columnTable.textAlign === MColumnTextAlign.Left;
    };
    MTable.prototype.isColumnTextAlignRight = function (columnTable) {
        return columnTable.textAlign === MColumnTextAlign.Right;
    };
    MTable.prototype.getColumnSortDirectionClass = function (columnTable) {
        switch (columnTable.sortDirection) {
            case MColumnSortDirection.Asc:
                return 'm--is-sort-asc';
            case MColumnSortDirection.Dsc:
                return 'm--is-sort-desc';
            default:
                if (columnTable.defaultSortDirection) {
                    return columnTable.defaultSortDirection === MColumnSortDirection.Asc ? 'm--is-sort-asc' : 'm--is-sort-desc';
                }
                else {
                    return undefined;
                }
        }
    };
    MTable.prototype.getColumnSortIcon = function (columnTable) {
        if (columnTable.sortDirection) {
            return 'm-svg__arrow-thin--down'; // CSS rotate transform animation takes care of the arrow position
        }
        else {
            return columnTable.defaultSortDirection === MColumnSortDirection.Dsc ? 'm-svg__arrow-thin--up' : 'm-svg__arrow-thin--down';
        }
    };
    MTable.prototype.columnWidth = function (col) {
        return col.width ? { width: col.width } : '';
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MTableSkin.Regular,
            validator: function (value) { return _utils_enums_enums__WEBPACK_IMPORTED_MODULE_3__["Enums"].toValueArray(MTableSkin).includes(value); }
        })
    ], MTable.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MTable.prototype, "columns", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: function () { return []; } })
    ], MTable.prototype, "rows", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTable.prototype, "loading", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTable.prototype, "rowHighlightedOnHover", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '100%',
            validator: function (value) {
                var pixelOrPercentageNumberRegExp = /^\d+(\.[0-9]{1,4})?(px|%)$/;
                var isPixelOrPercentageNumber = pixelOrPercentageNumberRegExp.test(value);
                if (!isPixelOrPercentageNumber) {
                    _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"].prototype.$log.warn("width-placeholder value needs to respect this RegEx: " + pixelOrPercentageNumberRegExp);
                }
                return isPixelOrPercentageNumber;
            }
        })
    ], MTable.prototype, "widthPlaceholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('add')
    ], MTable.prototype, "onAdd", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('sort-applied')
    ], MTable.prototype, "emitSortApplied", null);
    MTable = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _table_html_style_table_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["PROGRESS_NAME"]] = _progress_progress__WEBPACK_IMPORTED_MODULE_7__["MProgress"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__["MIconButton"],
                _a)
        })
    ], MTable);
    return MTable;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var TablePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["TABLE_NAME"], MTable);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TablePlugin);


/***/ }),

/***/ "./src/components/textarea/textarea.html?style=./textarea.scss":
/*!*********************************************************************!*\
  !*** ./src/components/textarea/textarea.html?style=./textarea.scss ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5ff5c2e9!./textarea.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=5ff5c2e9!./src/components/textarea/textarea.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-textarea",
      class: {
        "m--is-disabled": _vm.isDisabled,
        "m--is-waiting": _vm.isWaiting,
        "m--is-readonly": _vm.isReadonly,
        "m--has-error": _vm.hasTextareaError,
        "m--is-valid": _vm.isTextareaValid,
        "m--is-focus": _vm.isFocus,
        "m--has-label": _vm.hasLabel,
        "m--has-validation-message": _vm.hasValidationMessage
      },
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasTextareaError,
            valid: _vm.isTextareaValid,
            label: _vm.label,
            "label-for": _vm.id,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              },
              {
                name: "m-textarea-auto-height",
                rawName: "v-m-textarea-auto-height"
              }
            ],
            ref: "input",
            staticClass: "m-textarea__input",
            attrs: {
              id: _vm.id,
              disabled: _vm.isDisabled || _vm.isWaiting,
              readonly: _vm.isReadonly,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLengthNumber,
              autocomplete: _vm.autocomplete,
              rows: "1"
            },
            domProps: { value: _vm.model },
            on: {
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              change: _vm.onChange,
              keyup: _vm.onKeyup,
              keydown: _vm.onKeydown,
              paste: _vm.onPaste,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.model = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-textarea__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-textarea__validation__message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasTextareaError,
              "error-message": _vm.errorMessage,
              valid: _vm.isTextareaValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          }),
          _vm._v(" "),
          _vm.characterCount
            ? _c("m-character-count", {
                staticClass: "m-textarea__validation__character-count",
                attrs: {
                  "value-length": _vm.valueLength,
                  "max-length": _vm.maxLength,
                  threshold: _vm.characterCountThreshold
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-5ff5c2e9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/textarea/textarea.ts":
/*!*********************************************!*\
  !*** ./src/components/textarea/textarea.ts ***!
  \*********************************************/
/*! exports provided: MTextarea, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTextarea", function() { return MTextarea; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/textarea-auto-height/textarea-auto-height */ "./src/directives/textarea-auto-height/textarea-auto-height.ts");
/* harmony import */ var _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/element-queries/element-queries */ "./src/mixins/element-queries/element-queries.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _character_count_character_count__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../character-count/character-count */ "./src/components/character-count/character-count.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _textarea_html_style_textarea_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./textarea.html?style=./textarea.scss */ "./src/components/textarea/textarea.html?style=./textarea.scss");
/* harmony import */ var _textarea_html_style_textarea_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_textarea_html_style_textarea_scss__WEBPACK_IMPORTED_MODULE_16__);
var _a, _b;

















var MTextarea = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTextarea, _super);
    function MTextarea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalTextareaHeight = '0';
        _this.id = "mTextarea-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__["default"].generate();
        return _this;
    }
    Object.defineProperty(MTextarea.prototype, "valueLength", {
        get: function () {
            return this.internalValue.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextarea.prototype, "maxLengthNumber", {
        get: function () {
            return !this.lengthOverflow && this.maxLength > 0 ? this.maxLength : Infinity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextarea.prototype, "hasTextareaError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextarea.prototype, "isTextareaValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTextarea.prototype, "characterCount", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTextarea.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTextarea.prototype, "lengthOverflow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTextarea.prototype, "characterCountThreshold", void 0);
    MTextarea = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _textarea_html_style_textarea_scss__WEBPACK_IMPORTED_MODULE_16___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_14__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_15__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["CHARACTER_COUNT_NAME"]] = _character_count_character_count__WEBPACK_IMPORTED_MODULE_12__["MCharacterCount"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_3__["TEXTAREA_AUTO_HEIGHT"]] = _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_4__["MTextareaAutoHeight"],
                _b),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_8__["InputState"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_7__["InputManagement"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_9__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_6__["InputLabel"],
                _mixins_element_queries_element_queries__WEBPACK_IMPORTED_MODULE_5__["ElementQueries"]
            ]
        })
    ], MTextarea);
    return MTextarea;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__["ModulVue"]));

var TextareaPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_13__["TEXTAREA_NAME"], MTextarea);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TextareaPlugin);


/***/ }),

/***/ "./src/components/textfield/textfield.html?style=./textfield.scss":
/*!************************************************************************!*\
  !*** ./src/components/textfield/textfield.html?style=./textfield.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6d5502cd!./textfield.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=6d5502cd!./src/components/textfield/textfield.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-textfield",
      class: [
        {
          "m--is-disabled": _vm.isDisabled,
          "m--is-readonly": _vm.isReadonly,
          "m--is-waiting": _vm.isWaiting,
          "m--has-error": _vm.hasTextfieldError,
          "m--is-valid": _vm.isTextfieldValid,
          "m--has-label": _vm.hasLabel,
          "m--has-word-wrap": _vm.hasWordWrap,
          "m--has-validation-message": _vm.hasValidationMessage
        },
        "m--is-type-" + _vm.inputType
      ],
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            waiting: _vm.isWaiting,
            error: _vm.hasTextfieldError,
            valid: _vm.isTextfieldValid,
            label: _vm.label,
            "label-for": _vm.id,
            append: _vm.append,
            focus: _vm.isFocus,
            "label-up": _vm.labelUp,
            empty: _vm.isEmpty,
            readonly: _vm.isReadonly,
            "required-marker": _vm.requiredMarker,
            "tag-style": _vm.tagStyle
          }
        },
        [
          _vm.inputType === "checkbox" && !_vm.hasWordWrap
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                ref: "input",
                staticClass: "m-textfield__input",
                attrs: {
                  id: _vm.id,
                  autocomplete: _vm.autocomplete,
                  disabled: _vm.isDisabled || _vm.isWaiting,
                  placeholder: _vm.placeholder,
                  readonly: _vm.isReadonly,
                  maxlength: _vm.maxLengthNumber,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm.model
                },
                on: {
                  blur: _vm.onBlur,
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    _vm.onChange
                  ],
                  focus: _vm.onFocus,
                  keyup: _vm.onKeyup,
                  keydown: _vm.onKeydown,
                  paste: _vm.onPaste
                }
              })
            : _vm.inputType === "radio" && !_vm.hasWordWrap
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                ref: "input",
                staticClass: "m-textfield__input",
                attrs: {
                  id: _vm.id,
                  autocomplete: _vm.autocomplete,
                  disabled: _vm.isDisabled || _vm.isWaiting,
                  placeholder: _vm.placeholder,
                  readonly: _vm.isReadonly,
                  maxlength: _vm.maxLengthNumber,
                  type: "radio"
                },
                domProps: { checked: _vm._q(_vm.model, null) },
                on: {
                  blur: _vm.onBlur,
                  change: [
                    function($event) {
                      _vm.model = null
                    },
                    _vm.onChange
                  ],
                  focus: _vm.onFocus,
                  keyup: _vm.onKeyup,
                  keydown: _vm.onKeydown,
                  paste: _vm.onPaste
                }
              })
            : !_vm.hasWordWrap
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                ref: "input",
                staticClass: "m-textfield__input",
                attrs: {
                  id: _vm.id,
                  autocomplete: _vm.autocomplete,
                  disabled: _vm.isDisabled || _vm.isWaiting,
                  placeholder: _vm.placeholder,
                  readonly: _vm.isReadonly,
                  maxlength: _vm.maxLengthNumber,
                  type: _vm.inputType
                },
                domProps: { value: _vm.model },
                on: {
                  blur: _vm.onBlur,
                  change: _vm.onChange,
                  focus: _vm.onFocus,
                  keyup: _vm.onKeyup,
                  keydown: _vm.onKeydown,
                  paste: _vm.onPaste,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.model = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasWordWrap
            ? _c(
                "template",
                { slot: "suffix" },
                [
                  _c(
                    "transition",
                    {
                      staticStyle: { "white-space": "nowrap" },
                      attrs: { name: "m--is" }
                    },
                    [
                      _vm.passwordIcon && _vm.hasValue
                        ? _c("m-icon-button", {
                            key: "passwordIcon",
                            staticClass: "m-textfield__icon-password",
                            attrs: {
                              "aria-controls": _vm.id,
                              title: _vm.passwordIconDescription,
                              "icon-name": _vm.passwordIconName,
                              "button-size": "22px"
                            },
                            on: { click: _vm.togglePasswordVisibility }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("suffix")
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("template", { slot: "append" }, [_vm._t("append")], 2),
          _vm._v(" "),
          _vm.hasWordWrap
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  },
                  {
                    name: "m-textarea-auto-height",
                    rawName: "v-m-textarea-auto-height"
                  }
                ],
                ref: "input",
                staticClass: "m-textfield__input",
                attrs: {
                  id: _vm.id,
                  autocomplete: _vm.autocomplete,
                  disabled: _vm.isDisabled || _vm.isWaiting,
                  placeholder: _vm.placeholder,
                  readonly: _vm.isReadonly,
                  maxlength: _vm.maxLengthNumber,
                  rows: "1"
                },
                domProps: { value: _vm.model },
                on: {
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  change: _vm.onChange,
                  keypress: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                  },
                  keyup: _vm.onKeyup,
                  keydown: _vm.onKeydown,
                  paste: _vm.onPaste,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.model = $event.target.value
                  }
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-textfield__validation" },
        [
          _c("m-validation-message", {
            staticClass: "m-textfield__validation__message",
            attrs: {
              disabled: _vm.isDisabled,
              waiting: _vm.isWaiting,
              error: _vm.hasTextfieldError,
              "error-message": _vm.errorMessage,
              valid: _vm.isTextfieldValid,
              "valid-message": _vm.validMessage,
              "helper-message": _vm.helperMessage
            }
          }),
          _vm._v(" "),
          _vm.characterCount
            ? _c("m-character-count", {
                staticClass: "m-textfield__validation__character-count",
                attrs: {
                  "value-length": _vm.valueLength,
                  "max-length": _vm.maxLength,
                  threshold: _vm.characterCountThreshold
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-6d5502cd'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/textfield/textfield.ts":
/*!***********************************************!*\
  !*** ./src/components/textfield/textfield.ts ***!
  \***********************************************/
/*! exports provided: MTextfieldType, MTextfield, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTextfieldType", function() { return MTextfieldType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTextfield", function() { return MTextfield; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/textarea-auto-height/textarea-auto-height */ "./src/directives/textarea-auto-height/textarea-auto-height.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _utils_input_input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/input/input */ "./src/utils/input/input.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _character_count_character_count__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../character-count/character-count */ "./src/components/character-count/character-count.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _textfield_html_style_textfield_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./textfield.html?style=./textfield.scss */ "./src/components/textfield/textfield.html?style=./textfield.scss");
/* harmony import */ var _textfield_html_style_textfield_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_textfield_html_style_textfield_scss__WEBPACK_IMPORTED_MODULE_17__);
var _a, _b;


















var MTextfieldType;
(function (MTextfieldType) {
    MTextfieldType["Text"] = "text";
    MTextfieldType["Password"] = "password";
    MTextfieldType["Email"] = "email";
    MTextfieldType["Url"] = "url";
    MTextfieldType["Telephone"] = "tel";
    MTextfieldType["Number"] = "number";
})(MTextfieldType || (MTextfieldType = {}));
var ICON_NAME_PASSWORD_VISIBLE = 'm-svg__show';
var ICON_NAME_PASSWORD_HIDDEN = 'm-svg__hide';
var MTextfield = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTextfield, _super);
    function MTextfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.passwordAsText = false;
        _this.iconDescriptionShowPassword = _this.$i18n.translate('m-textfield:show-password');
        _this.iconDescriptionHidePassword = _this.$i18n.translate('m-textfield:hide-password');
        _this.id = "mTextfield-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__["default"].generate();
        return _this;
    }
    MTextfield.prototype.created = function () {
        if (!this.$i18n) {
            throw new Error('<m-text-field> -> this.$i18n is undefined, you must install the i18n plugin.');
        }
    };
    MTextfield.prototype.mounted = function () {
        this.as().trimWordWrap = this.hasWordWrap;
    };
    MTextfield.prototype.typeChanged = function (type) {
        this.$log.warn(_component_names__WEBPACK_IMPORTED_MODULE_13__["TEXTFIELD_NAME"] + ': Change of property "type" is not supported');
    };
    MTextfield.prototype.inputTypeChanged = function (value) {
        this.as().trimWordWrap = this.hasWordWrap;
    };
    MTextfield.prototype.wordWrapChanged = function (wordWrap) {
        this.as().trimWordWrap = this.hasWordWrap;
    };
    MTextfield.prototype.togglePasswordVisibility = function (event) {
        this.passwordAsText = !this.passwordAsText;
    };
    Object.defineProperty(MTextfield.prototype, "inputType", {
        get: function () {
            switch (this.type) {
                case MTextfieldType.Password:
                    return this.passwordAsText ? MTextfieldType.Text : MTextfieldType.Password;
                default:
                    return this.type;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "passwordIcon", {
        get: function () {
            return this.icon && this.type === MTextfieldType.Password && this.as().active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "passwordIconName", {
        get: function () {
            return this.passwordAsText ? ICON_NAME_PASSWORD_HIDDEN : ICON_NAME_PASSWORD_VISIBLE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "passwordIconDescription", {
        get: function () {
            return this.passwordAsText ? this.iconDescriptionHidePassword : this.iconDescriptionShowPassword;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "hasWordWrap", {
        get: function () {
            var hasWordWrap = this.inputType === MTextfieldType.Text && this.wordWrap;
            if (this.inputType !== MTextfieldType.Text && this.wordWrap) {
                this.$log.warn(_component_names__WEBPACK_IMPORTED_MODULE_13__["TEXTFIELD_NAME"] + ': If you want to use word-wrap prop, you need to set type prop at "text"');
            }
            return hasWordWrap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "valueLength", {
        get: function () {
            return (this.internalValue || '').length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "maxLengthNumber", {
        get: function () {
            return !this.lengthOverflow && this.maxLength > 0 ? this.maxLength : Infinity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "hasTextfieldError", {
        get: function () {
            return this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "isTextfieldValid", {
        get: function () {
            return this.as().isValid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTextfield.prototype, "hasCounterTransition", {
        get: function () {
            return !this.as().hasErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    MTextfield.prototype.resetModel = function () {
        this.$emit('input', '');
    };
    MTextfield.prototype.updateSelection = function () {
        Object(_utils_input_input__WEBPACK_IMPORTED_MODULE_9__["changeSelection"])(this.as().getInput(), this.selection);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MTextfieldType.Text,
            validator: function (value) {
                return value === MTextfieldType.Email ||
                    value === MTextfieldType.Password ||
                    value === MTextfieldType.Telephone ||
                    value === MTextfieldType.Text ||
                    value === MTextfieldType.Url ||
                    value === MTextfieldType.Number;
            }
        })
    ], MTextfield.prototype, "type", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTextfield.prototype, "icon", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTextfield.prototype, "wordWrap", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTextfield.prototype, "characterCount", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTextfield.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTextfield.prototype, "lengthOverflow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTextfield.prototype, "characterCountThreshold", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '' })
    ], MTextfield.prototype, "selection", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTextfield.prototype, "append", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('type')
    ], MTextfield.prototype, "typeChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('inputType')
    ], MTextfield.prototype, "inputTypeChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('wordWrap')
    ], MTextfield.prototype, "wordWrapChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('selection')
    ], MTextfield.prototype, "updateSelection", null);
    MTextfield = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _textfield_html_style_textfield_scss__WEBPACK_IMPORTED_MODULE_17___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_15__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_16__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["CHARACTER_COUNT_NAME"]] = _character_count_character_count__WEBPACK_IMPORTED_MODULE_12__["MCharacterCount"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_13__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_14__["MIconButton"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_3__["TEXTAREA_AUTO_HEIGHT"]] = _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_4__["MTextareaAutoHeight"],
                _b),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__["InputState"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__["InputManagement"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_8__["InputWidth"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_5__["InputLabel"]
            ]
        })
    ], MTextfield);
    return MTextfield;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__["ModulVue"]));

var TextfieldPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_13__["TEXTFIELD_NAME"], MTextfield);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TextfieldPlugin);


/***/ }),

/***/ "./src/components/timepicker/timepicker.html?style=./timepicker.scss":
/*!***************************************************************************!*\
  !*** ./src/components/timepicker/timepicker.html?style=./timepicker.scss ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=72503f49!./timepicker.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=72503f49!./src/components/timepicker/timepicker.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-timepicker",
      class: {
        "m--is-disabled": _vm.isDisabled,
        "m--is-readonly": _vm.isReadonly,
        "m--has-validation-message": _vm.hasValidationMessage
      },
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
    },
    [
      _c(
        "m-input-style",
        {
          attrs: {
            disabled: _vm.isDisabled,
            readonly: _vm.isReadonly,
            waiting: _vm.isWaiting,
            focus: _vm.isFocus,
            "required-marker": _vm.requiredMarker,
            "label-up": _vm.labelUp,
            label: _vm.label,
            "label-for": _vm.id,
            empty: _vm.isEmpty,
            error: _vm.timeError,
            valid: _vm.isValid
          },
          on: {
            click: function($event) {
              return _vm.focusInput()
            }
          }
        },
        [
          _c("m-input-mask", {
            ref: "input",
            attrs: {
              "aria-haspopup": "true",
              "aria-controls": _vm.ariaControls,
              "aria-expanded": _vm.open,
              disabled: _vm.isDisabled || _vm.isWaiting,
              id: _vm.id,
              inputmode: "decimal",
              options: _vm.inputMaskOptions,
              placeholder: _vm.i18nPlaceHolder,
              min: _vm.min,
              max: _vm.max,
              readonly: _vm.isReadonly,
              step: _vm.currentStep,
              type: "text",
              raw: false
            },
            on: { blur: _vm.onBlur, focus: _vm.onFocus },
            model: {
              value: _vm.currentTime,
              callback: function($$v) {
                _vm.currentTime = $$v
              },
              expression: "currentTime"
            }
          }),
          _vm._v(" "),
          _c(
            "m-icon-button",
            {
              directives: [
                { name: "m-popup", rawName: "v-m-popup:popup", arg: "popup" }
              ],
              attrs: {
                slot: "suffix",
                "icon-name": "m-svg__clock",
                disabled: !_vm.active,
                "button-size": "22px",
                "aria-controls": _vm.id
              },
              slot: "suffix"
            },
            [
              !_vm.open
                ? _c("m-i18n", { attrs: { k: "m-timepicker:open" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.open
                ? _c("m-i18n", { attrs: { k: "m-timepicker:close" } })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("m-validation-message", {
        staticClass: "m-timepicker__validation-message",
        attrs: {
          disabled: _vm.isDisabled,
          waiting: _vm.isWaiting,
          error: _vm.timeError,
          "error-message": _vm.timeErrorMessage,
          "valid-message": _vm.validMessage,
          "helper-message": _vm.helperMessage
        }
      }),
      _vm._v(" "),
      _c(
        "m-popup",
        {
          ref: "popup",
          attrs: {
            open: _vm.open,
            disabled: !_vm.active,
            padding: false,
            "focus-management": _vm.isMqMaxS
          },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            },
            open: _vm.onPopupOpen,
            close: _vm.onClose
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "m-timepicker__header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("m-i18n", {
                staticClass: "m-timepicker__header__hours",
                attrs: { k: "m-timepicker:hours" }
              }),
              _vm._v(":\n            "),
              _c("m-i18n", {
                staticClass: "m-timepicker__header__minutes",
                attrs: { k: "m-timepicker:minutes" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "m-timepicker__body",
              attrs: { id: _vm.ariaControls, "aria-labelledby": _vm.id }
            },
            [
              _c(
                "ul",
                {
                  ref: "hours",
                  staticClass: "m-timepicker__hours",
                  attrs: {
                    "aria-activedescendant": _vm.currentHour,
                    role: "listbox"
                  },
                  on: {
                    mousedown: _vm.onMousedown,
                    mouseup: _vm.onMouseup,
                    scroll: _vm.onScroll
                  }
                },
                _vm._l(_vm.currentfilteredHours, function(h, hoursIndex) {
                  return _c(
                    "li",
                    {
                      key: hoursIndex,
                      staticClass: "m-timepicker__hours-item",
                      attrs: { id: h }
                    },
                    [
                      _c(
                        "m-calendar-button",
                        {
                          attrs: {
                            selected: h == _vm.currentHour,
                            role: "option"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelectHour(h)
                            },
                            keyup: function($event) {
                              return _vm.onSelectHourKeyup($event, h)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.formatNumber(h)))]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  ref: "minutes",
                  staticClass: "m-timepicker__minutes",
                  attrs: { "aria-activedescendant": _vm.currentMinute },
                  on: {
                    mousedown: _vm.onMousedown,
                    mouseup: _vm.onMouseup,
                    scroll: _vm.onScroll
                  }
                },
                _vm._l(_vm.currentFilteredMinutes, function(m, minutesIndex) {
                  return _c(
                    "li",
                    {
                      key: minutesIndex,
                      staticClass: "m-timepicker__minutes-item",
                      attrs: { id: minutesIndex }
                    },
                    [
                      _c(
                        "m-calendar-button",
                        {
                          attrs: {
                            selected: m == _vm.currentMinute,
                            role: "option"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSelectMinute(m)
                            },
                            keyup: function($event) {
                              return _vm.onSelectMinuteKeyup($event, m)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.formatNumber(m)))]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "m-timepicker__footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "m-link",
                { attrs: { mode: "button" }, on: { click: _vm.onOk } },
                [_vm._v(_vm._s(_vm.i18nButton))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-72503f49'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/timepicker/timepicker.ts":
/*!*************************************************!*\
  !*** ./src/components/timepicker/timepicker.ts ***!
  \*************************************************/
/*! exports provided: MTimepicker, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTimepicker", function() { return MTimepicker; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/popup/popup */ "./src/directives/popup/popup.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/keycode/keycode */ "./src/utils/keycode/keycode.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _calendar_calendar_button_calendar_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../calendar/calendar-button/calendar-button */ "./src/components/calendar/calendar-button/calendar-button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../input-mask/input-mask */ "./src/components/input-mask/input-mask.ts");
/* harmony import */ var _input_style_input_style__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../input-style/input-style */ "./src/components/input-style/input-style.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _directives_directive_names__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./../../directives/directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _timepicker_html_style_timepicker_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./timepicker.html?style=./timepicker.scss */ "./src/components/timepicker/timepicker.html?style=./timepicker.scss");
/* harmony import */ var _timepicker_html_style_timepicker_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_timepicker_html_style_timepicker_scss__WEBPACK_IMPORTED_MODULE_25__);
var _a, _b;


























var MAXIMUM_HOURS = 23;
var MAXIMUM_MINUTES = 59;
var MINUTE_SECONDS = 60;
function validateTimeString(value) {
    var regex = /(\d\d):(\d\d)/g;
    return !(value || '').length || value.match(regex) ? true : false;
}
var MTimepicker = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTimepicker, _super);
    function MTimepicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18nButton = _this.$i18n.translate('m-timepicker:button-ok');
        _this.i18nPlaceHolder = _this.$i18n.translate('m-timepicker:placeholder');
        _this.i18nOutOfBoundsError = _this.$i18n.translate('m-timepicker:out-of-bounds-error', { min: _this.min, max: _this.max }, undefined, undefined, undefined, _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_8__["FormatMode"].Sprintf);
        _this.hours = [];
        _this.minutes = [];
        _this.internalTime = '';
        _this.internalHour = NaN;
        _this.internalMinute = NaN;
        _this.internalFilteredMinutes = [];
        _this.internalFilteredHours = [];
        _this.isMousedown = false;
        _this.internalOpen = false;
        _this.internalTimeErrorMessage = '';
        _this.id = "mTimepicker-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_11__["default"].generate();
        return _this;
    }
    MTimepicker.prototype.created = function () {
        this.internalTime = this.value;
        this.updatePopupTime(this.internalTime);
    };
    MTimepicker.prototype.mounted = function () {
        // create hours
        for (var i = -1; i < MAXIMUM_HOURS; i++) {
            this.hours.push(i + 1);
        }
        // create minutes
        for (var i = -1; i < MAXIMUM_MINUTES; i++) {
            this.minutes.push(i + 1);
        }
        this.internalFilteredMinutes = this.minutes;
    };
    MTimepicker.prototype.timeStringToNumber = function (value) {
        var timeString = value.split(':');
        var timeObject = {
            hour: parseInt(timeString[0], 10),
            minute: parseInt(timeString[1], 10)
        };
        return timeObject;
    };
    MTimepicker.prototype.validateTime = function (value) {
        this.internalTimeErrorMessage = '';
        if (!this.skipInputValidation && validateTimeString(value)) {
            if (this.validateTimeRange(value)) {
                this.internalTimeErrorMessage = '';
                return true;
            }
            else {
                this.internalTimeErrorMessage = this.i18nOutOfBoundsError;
                return false;
            }
        }
        return true;
    };
    MTimepicker.prototype.validateTimeRange = function (value) {
        return !value.length || (this.validateHour(value) && this.validateMinute(value));
    };
    MTimepicker.prototype.validateHour = function (value) {
        return this.timeStringToNumber(value).hour >= this.timeStringToNumber(this.min).hour &&
            this.timeStringToNumber(value).hour <= this.timeStringToNumber(this.max).hour;
    };
    MTimepicker.prototype.validateMinute = function (value) {
        if (this.timeStringToNumber(value).hour === this.timeStringToNumber(this.min).hour) {
            return this.timeStringToNumber(value).minute >= this.timeStringToNumber(this.min).minute;
        }
        else if (this.timeStringToNumber(value).hour === this.timeStringToNumber(this.max).hour) {
            return this.timeStringToNumber(value).minute <= this.timeStringToNumber(this.max).minute;
        }
        else {
            return true;
        }
    };
    MTimepicker.prototype.formatTimeString = function () {
        return this.formatNumber(this.internalHour) + ':' + this.formatNumber(this.internalMinute);
    };
    MTimepicker.prototype.formatNumber = function (value) {
        return value < 10 ? '0' + value : value.toString();
    };
    MTimepicker.prototype.scrollToSelection = function (container) {
        var selectedElement = container.querySelector('.m--is-selected');
        setTimeout(function () {
            if (selectedElement) {
                container.scrollTop = selectedElement['offsetTop'] - container.clientHeight / 2 + selectedElement.clientHeight / 2;
            }
        }, 10);
    };
    MTimepicker.prototype.positionScroll = function (el) {
        el.scrollTop = Math.round(el.scrollTop / 44) * 44;
    };
    ///////////////////////////////////////
    MTimepicker.prototype.updateInternalTime = function (value) {
        if (!this.as().isFocus || value) {
            this.currentTime = value;
        }
    };
    MTimepicker.prototype.updatePopupTime = function (value) {
        if (value) {
            this.internalHour = this.timeStringToNumber(value).hour;
            this.internalMinute = this.timeStringToNumber(value).minute;
        }
        else {
            this.resetPopupTime();
        }
    };
    MTimepicker.prototype.resetPopupTime = function () {
        this.internalHour = NaN;
        this.internalMinute = NaN;
    };
    ///////////////////////////////////////
    MTimepicker.prototype.onScroll = function (event) {
        var _this = this;
        if (!this.isMousedown) {
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(function () {
                // tslint:disable-next-line: deprecation
                if (event.srcElement) {
                    // tslint:disable-next-line: deprecation
                    _this.positionScroll(event.srcElement);
                }
            }, 300);
        }
    };
    MTimepicker.prototype.onSelectHour = function (hour) {
        var _this = this;
        this.internalHour = hour;
        // change available minutes in function of min/max value
        if (hour === this.timeStringToNumber(this.min).hour) {
            this.internalFilteredMinutes = this.minutes.filter(function (x) { return (x >= _this.timeStringToNumber(_this.min).minute); });
        }
        else if (hour === this.timeStringToNumber(this.max).hour) {
            this.internalFilteredMinutes = this.minutes.filter(function (x) { return (x <= _this.timeStringToNumber(_this.max).minute); });
        }
        else {
            this.internalFilteredMinutes = this.minutes;
        }
    };
    MTimepicker.prototype.onSelectHourKeyup = function ($event, hour) {
        // tslint:disable-next-line: deprecation
        if ($event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].M_ENTER || $event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].M_RETURN) {
            this.onSelectHour(hour);
        }
    };
    MTimepicker.prototype.onSelectMinute = function (minute) {
        this.internalMinute = minute;
        if (!isNaN(this.internalHour)) {
            this.currentTime = this.formatTimeString();
            this.open = false;
        }
    };
    MTimepicker.prototype.onSelectMinuteKeyup = function ($event, minute) {
        // tslint:disable-next-line: deprecation
        if ($event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].M_ENTER || $event.keyCode === _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_9__["KeyCode"].M_RETURN) {
            this.onSelectMinute(minute);
        }
    };
    MTimepicker.prototype.onMousedown = function (event) {
        this.isMousedown = true;
    };
    MTimepicker.prototype.onMouseup = function (event) {
        this.isMousedown = false;
        // tslint:disable-next-line: deprecation
        if (event.srcElement) {
            // tslint:disable-next-line: deprecation
            this.positionScroll(event.srcElement);
        }
    };
    MTimepicker.prototype.onOk = function () {
        if (!isNaN(this.internalHour) && !isNaN(this.internalMinute)) {
            this.currentTime = this.formatTimeString();
        }
        this.open = false;
    };
    MTimepicker.prototype.onClose = function () {
        if (isNaN(this.internalHour) || isNaN(this.internalMinute)) {
            this.resetPopupTime();
        }
        else {
            this.updatePopupTime(this.internalTime);
        }
    };
    MTimepicker.prototype.onPopupOpen = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                this.open = true;
                this.focusInput();
                return [2 /*return*/];
            });
        });
    };
    MTimepicker.prototype.focusInput = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var inputEl;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        inputEl = this.$refs.input.$el;
                        inputEl.focus();
                        this.open = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MTimepicker.prototype, "currentTime", {
        ///////////////////////////////////////
        get: function () {
            if (!this.internalTime) {
                return '';
            }
            var hourParts = this.internalTime.split(':');
            return hourParts.length > 1 ? hourParts[0] + ":" + hourParts[1] : '';
        },
        set: function (value) {
            var hourParts = (value || '').split(':');
            var newValue = hourParts.length > 1 ? hourParts[0] + ":" + hourParts[1] : '';
            var oldTime = this.internalTime;
            this.internalTime = newValue;
            // When the user type in something we close de popup.
            this.open = false;
            if (value && this.skipInputValidation) {
                this.$emit('input', newValue);
            }
            else if (value && this.validateTime(value) && validateTimeString(value)) {
                this.updatePopupTime(newValue);
                if (newValue !== oldTime) {
                    this.$emit('input', newValue);
                }
            }
            else {
                this.resetPopupTime();
                this.$emit('input', undefined);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "currentHour", {
        get: function () {
            return this.internalHour;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "currentMinute", {
        get: function () {
            return this.internalMinute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "currentfilteredHours", {
        get: function () {
            var _this = this;
            return this.internalFilteredHours = this.hours.filter(function (x) { return (x >= _this.timeStringToNumber(_this.min).hour) && (x <= _this.timeStringToNumber(_this.max).hour); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "currentFilteredMinutes", {
        get: function () {
            var _this = this;
            return this.internalFilteredMinutes.filter(function (x) { return (x % _this.step === 0); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "currentStep", {
        get: function () {
            return this.step * MINUTE_SECONDS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "timeError", {
        get: function () {
            return this.internalTimeErrorMessage !== '' || this.as().hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "timeErrorMessage", {
        get: function () {
            if (this.hideInternalErrorMessage) {
                return '';
            }
            else {
                return this.internalTimeErrorMessage || this.as().errorMessage;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "open", {
        get: function () {
            return this.internalOpen;
        },
        set: function (open) {
            var _this = this;
            this.internalOpen = open;
            setTimeout(function () {
                if (_this.internalOpen) {
                    _this.scrollToSelection(_this.$refs.hours);
                    _this.scrollToSelection(_this.$refs.minutes);
                    _this.$emit('open');
                }
                else {
                    _this.$emit('close');
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "inputMaskOptions", {
        get: function () {
            return {
                time: true,
                timePattern: ['h', 'm']
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTimepicker.prototype, "ariaControls", {
        get: function () {
            return this.id + '-controls';
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('input')
    ], MTimepicker.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '00:00' })
    ], MTimepicker.prototype, "min", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '23:59' })
    ], MTimepicker.prototype, "max", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 5 })
    ], MTimepicker.prototype, "step", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputMaxWidth"].Small })
    ], MTimepicker.prototype, "maxWidth", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTimepicker.prototype, "hideInternalErrorMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTimepicker.prototype, "skipInputValidation", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value')
    ], MTimepicker.prototype, "updateInternalTime", null);
    MTimepicker = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _timepicker_html_style_timepicker_scss__WEBPACK_IMPORTED_MODULE_25___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_13__["MButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_21__["MPopup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_17__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_22__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_20__["MLink"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["INPUT_STYLE_NAME"]] = _input_style_input_style__WEBPACK_IMPORTED_MODULE_19__["MInputStyle"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_15__["I18N_NAME"]] = _i18n_i18n__WEBPACK_IMPORTED_MODULE_16__["MI18n"],
                _a.MInputMask = _input_mask_input_mask__WEBPACK_IMPORTED_MODULE_18__["MInputMask"],
                _a.MCalendarButton = _calendar_calendar_button_calendar_button__WEBPACK_IMPORTED_MODULE_14__["MCalendarButton"],
                _a),
            directives: (_b = {},
                _b[_directives_directive_names__WEBPACK_IMPORTED_MODULE_23__["POPUP_NAME"]] = _directives_popup_popup__WEBPACK_IMPORTED_MODULE_3__["MPopupDirective"],
                _b),
            mixins: [
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_5__["InputState"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_24__["InputManagement"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_6__["InputWidth"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__["MediaQueries"],
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_4__["InputLabel"]
            ]
        })
    ], MTimepicker);
    return MTimepicker;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_12__["ModulVue"]));

var TimepickerPlugin = {
    install: function (v) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_10__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_15__["TIMEPICKER_NAME"], MTimepicker);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TimepickerPlugin);


/***/ }),

/***/ "./src/components/toast/toast.html?style=./toast.scss":
/*!************************************************************!*\
  !*** ./src/components/toast/toast.html?style=./toast.scss ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c1365b4e!./toast.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=c1365b4e!./src/components/toast/toast.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.portalCreated
    ? _c(
        "portal",
        {
          attrs: {
            "target-el": _vm.portalTargetSelector,
            "open-trigger": "manual"
          }
        },
        [
          _c("transition", { attrs: { name: "m--is" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.portalMounted && _vm.propOpen,
                    expression: "portalMounted && propOpen"
                  }
                ],
                ref: "toast",
                staticClass: "m-toast",
                class: {
                  "m--is-state-confirmation": _vm.isStateConfirmation,
                  "m--is-state-information": _vm.isStateInformation,
                  "m--is-state-warning": _vm.isStateWarning,
                  "m--is-state-error": _vm.isStateError,
                  "m--is-top": _vm.isTop,
                  "m--is-bottom": !_vm.isTop,
                  "m--is-left": _vm.isLeft,
                  "m--is-center": _vm.isCenter,
                  "m--is-right": _vm.isRight,
                  "m--is-mobile": _vm.isMqMaxS,
                  "m--is-desktop": !_vm.isMqMaxS
                },
                on: {
                  mouseover: _vm.mouseEnterToast,
                  mouseleave: _vm.mouseLeaveToast
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "m-toast__wrap" },
                  [
                    _vm.icon
                      ? _c(
                          "div",
                          { staticClass: "m-toast__icon" },
                          [
                            _c("m-icon", {
                              attrs: { name: _vm.getIcon(), size: "1em" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-toast__body" }, [
                      _c(
                        "div",
                        { staticClass: "m-toast__text" },
                        [_vm._t("default")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.actionLabel
                        ? _c(
                            "div",
                            { staticClass: "m-toast__actions" },
                            [
                              _c(
                                "m-link",
                                {
                                  attrs: { mode: _vm.buttonMode },
                                  on: { click: _vm.onAction }
                                },
                                [_vm._v(_vm._s(_vm.actionLabel))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.closeButton
                      ? _c("m-icon-button", {
                          ref: "toastclose",
                          staticClass: "m-toast__close-button",
                          attrs: {
                            title: _vm._f("f-m-i18n")("m-toast:close"),
                            "icon-name": "m-svg__close-clear",
                            iconSize: "12px",
                            skin: "link"
                          },
                          on: { click: _vm.onClose }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-c1365b4e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/toast/toast.ts":
/*!***************************************!*\
  !*** ./src/components/toast/toast.ts ***!
  \***************************************/
/*! exports provided: MToastTimeout, MToastPosition, MToastState, MToastDuration, MToast, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToastTimeout", function() { return MToastTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToastPosition", function() { return MToastPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToastState", function() { return MToastState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToastDuration", function() { return MToastDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToast", function() { return MToast; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _toast_html_style_toast_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./toast.html?style=./toast.scss */ "./src/components/toast/toast.html?style=./toast.scss");
/* harmony import */ var _toast_html_style_toast_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_toast_html_style_toast_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a, _b;














var MToastTimeout;
(function (MToastTimeout) {
    MToastTimeout["none"] = "none";
    MToastTimeout["xshort"] = "xshort";
    MToastTimeout["short"] = "short";
    MToastTimeout["long"] = "long";
})(MToastTimeout || (MToastTimeout = {}));
var MToastPosition;
(function (MToastPosition) {
    MToastPosition["TopLeft"] = "top-left";
    MToastPosition["TopCenter"] = "top-center";
    MToastPosition["TopRight"] = "top-right";
    MToastPosition["BottomLeft"] = "bottom-left";
    MToastPosition["BottomCenter"] = "bottom-center";
    MToastPosition["BottomRight"] = "bottom-right";
})(MToastPosition || (MToastPosition = {}));
var MToastState;
(function (MToastState) {
    MToastState["Confirmation"] = "confirmation";
    MToastState["Information"] = "information";
    MToastState["Warning"] = "warning";
    MToastState["Error"] = "error";
})(MToastState || (MToastState = {}));
var MToastDuration;
(function (MToastDuration) {
    MToastDuration[MToastDuration["MobileLong"] = 5000] = "MobileLong";
    MToastDuration[MToastDuration["MobileShort"] = 3000] = "MobileShort";
    MToastDuration[MToastDuration["MobileXShort"] = 1500] = "MobileXShort";
    MToastDuration[MToastDuration["DesktopLong"] = 8000] = "DesktopLong";
    MToastDuration[MToastDuration["DesktopShort"] = 5000] = "DesktopShort";
    MToastDuration[MToastDuration["DesktopXShort"] = 2500] = "DesktopXShort";
    MToastDuration[MToastDuration["None"] = 0] = "None";
})(MToastDuration || (MToastDuration = {}));
var MToast = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MToast, _super);
    function MToast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonMode = _link_link__WEBPACK_IMPORTED_MODULE_12__["MLinkMode"].Button;
        return _this;
    }
    MToast.prototype.doCustomPropOpen = function (value, el) {
        el.style.position = 'absolute';
        if (value) {
            if (this.offset !== '0') {
                this.getPortalElement().style.transform = "translateY(" + this.offset + ")";
            }
            this.internalTimeout = this.convertTimeout(this.timeout);
            this.startCloseToast();
        }
        return true;
    };
    MToast.prototype.startCloseToast = function () {
        var _this = this;
        this.instantTimeoutStart = Date.now();
        if (this.internalTimeout > 0) {
            this.timerCloseToast
                = setTimeout(function () {
                    _this.onClose();
                }, this.internalTimeout);
        }
    };
    MToast.prototype.getPortalElement = function () {
        return this.$refs.toast;
    };
    MToast.prototype.getBackdropMode = function () {
        return _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_6__["BackdropMode"].None;
    };
    MToast.prototype.handlesFocus = function () {
        return false;
    };
    MToast.prototype.mounted = function () {
        if (this.open === undefined || this.open === true) {
            this.as().propOpen = true;
        }
    };
    MToast.prototype.convertTimeout = function (timeout) {
        switch (timeout) {
            case MToastTimeout.long:
                return this.isMobile ? MToastDuration.MobileLong : MToastDuration.DesktopLong;
            case MToastTimeout.short:
                return this.isMobile ? MToastDuration.MobileShort : MToastDuration.DesktopShort;
            case MToastTimeout.xshort:
                return this.isMobile ? MToastDuration.MobileXShort : MToastDuration.DesktopXShort;
            case MToastTimeout.none:
            default:
                return MToastDuration.None;
        }
    };
    MToast.prototype.onAction = function (event) {
        this.onClose();
    };
    MToast.prototype.onClose = function () {
        this.as().propOpen = false;
    };
    Object.defineProperty(MToast.prototype, "isStateInformation", {
        get: function () {
            return this.state === MToastState.Information;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isStateWarning", {
        get: function () {
            return this.state === MToastState.Warning;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isStateError", {
        get: function () {
            return this.state === MToastState.Error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isStateConfirmation", {
        get: function () {
            return this.state === MToastState.Confirmation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isTop", {
        get: function () {
            return this.position === MToastPosition.TopLeft ||
                this.position === MToastPosition.TopCenter ||
                this.position === MToastPosition.TopRight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isLeft", {
        get: function () {
            return this.position === MToastPosition.TopLeft ||
                this.position === MToastPosition.BottomLeft;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isCenter", {
        get: function () {
            return this.position === MToastPosition.TopCenter ||
                this.position === MToastPosition.BottomCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isRight", {
        get: function () {
            return this.position === MToastPosition.TopRight ||
                this.position === MToastPosition.BottomRight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MToast.prototype, "isMobile", {
        get: function () {
            return this.as().isMqMaxS;
        },
        enumerable: true,
        configurable: true
    });
    MToast.prototype.getIcon = function () {
        var icon = '';
        switch (this.state) {
            case MToastState.Confirmation:
                icon = 'm-svg__confirmation';
                break;
            case MToastState.Information:
                icon = 'm-svg__information';
                break;
            case MToastState.Warning:
                icon = 'm-svg__warning';
                break;
            case MToastState.Error:
                icon = 'm-svg__error';
                break;
            default:
                break;
        }
        return icon;
    };
    MToast.prototype.mouseEnterToast = function () {
        if (!this.isMobile && this.timerCloseToast !== undefined) {
            this.restoreTimeout();
            clearTimeout(this.timerCloseToast);
            this.timerCloseToast = undefined;
        }
    };
    MToast.prototype.restoreTimeout = function () {
        var instantTimeoutStop = Date.now();
        this.internalTimeout -= (instantTimeoutStop - this.instantTimeoutStart);
    };
    MToast.prototype.mouseLeaveToast = function () {
        if (!this.isMobile) {
            this.startCloseToast();
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MToastState.Confirmation,
            validator: function (value) {
                return value === MToastState.Confirmation ||
                    value === MToastState.Information ||
                    value === MToastState.Warning ||
                    value === MToastState.Error;
            }
        })
    ], MToast.prototype, "state", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MToastPosition.BottomRight,
            validator: function (value) {
                return value === MToastPosition.TopRight ||
                    value === MToastPosition.TopCenter ||
                    value === MToastPosition.TopLeft ||
                    value === MToastPosition.BottomLeft ||
                    value === MToastPosition.BottomCenter ||
                    value === MToastPosition.BottomRight;
            }
        })
    ], MToast.prototype, "position", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MToastTimeout.none,
            validator: function (value) {
                return value === MToastTimeout.none ||
                    value === MToastTimeout.xshort ||
                    value === MToastTimeout.short ||
                    value === MToastTimeout.long;
            }
        })
    ], MToast.prototype, "timeout", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MToast.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MToast.prototype, "actionLabel", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MToast.prototype, "icon", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: '0'
        })
    ], MToast.prototype, "offset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: true
        })
    ], MToast.prototype, "closeButton", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('action-button')
    ], MToast.prototype, "onAction", null);
    MToast = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _toast_html_style_toast_scss__WEBPACK_IMPORTED_MODULE_13___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_11__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_10__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_9__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_12__["MLink"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"], _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_6__["Portal"]]
        })
    ], MToast);
    return MToast;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_8__["ModulVue"]));

var ToastPlugin = {
    install: function (v, options) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_9__["TOAST"], MToast);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ToastPlugin);


/***/ }),

/***/ "./src/components/toggle-buttons/toggle-buttons.html?style=./toggle-buttons.scss":
/*!***************************************************************************************!*\
  !*** ./src/components/toggle-buttons/toggle-buttons.html?style=./toggle-buttons.scss ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=448dcde9!./toggle-buttons.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=448dcde9!./src/components/toggle-buttons/toggle-buttons.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "toggle", staticClass: "m-toggle-buttons", class: _vm.skinButtons },
    _vm._l(_vm.buttons, function(button) {
      return _c(
        "m-button",
        {
          key: button.id,
          staticClass: "m-toggle-buttons__button",
          attrs: {
            "aria-pressed": button.pressed ? "true" : "false",
            disabled: _vm.disabled,
            skin: _vm.getSkin(button)
          },
          on: {
            click: function($event) {
              return _vm.toggle(button)
            }
          }
        },
        [_vm._t("default", [_vm._v(_vm._s(button.title))], { button: button })],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-448dcde9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/toggle-buttons/toggle-buttons.ts":
/*!*********************************************************!*\
  !*** ./src/components/toggle-buttons/toggle-buttons.ts ***!
  \*********************************************************/
/*! exports provided: MToggleButtonSkin, MToggleButtons, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToggleButtonSkin", function() { return MToggleButtonSkin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MToggleButtons", function() { return MToggleButtons; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../button/button */ "./src/components/button/button.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _toggle_buttons_html_style_toggle_buttons_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./toggle-buttons.html?style=./toggle-buttons.scss */ "./src/components/toggle-buttons/toggle-buttons.html?style=./toggle-buttons.scss");
/* harmony import */ var _toggle_buttons_html_style_toggle_buttons_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_toggle_buttons_html_style_toggle_buttons_scss__WEBPACK_IMPORTED_MODULE_6__);
var _a;







var MToggleButtonSkin;
(function (MToggleButtonSkin) {
    MToggleButtonSkin["SQUARED"] = "default";
    MToggleButtonSkin["ROUNDED"] = "rounded";
})(MToggleButtonSkin || (MToggleButtonSkin = {}));
var MToggleButtons = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MToggleButtons, _super);
    function MToggleButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MToggleButtons.prototype.toggle = function (button) {
        var _this = this;
        this.$emit('change', this.buttons.map(function (b) { return b.id !== button.id ?
            _this.multiple ? b : Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b), { pressed: false }) : Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b), { pressed: !b.pressed }); }));
        this.onClick(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, button), { pressed: !button.pressed }));
    };
    MToggleButtons.prototype.onClick = function (button) { };
    MToggleButtons.prototype.getSkin = function (button) {
        return !button.pressed ? _button_button__WEBPACK_IMPORTED_MODULE_4__["MButtonSkin"].Secondary : _button_button__WEBPACK_IMPORTED_MODULE_4__["MButtonSkin"].Primary;
    };
    Object.defineProperty(MToggleButtons.prototype, "skinButtons", {
        get: function () {
            return {
                'm--is-default': this.skin === MToggleButtonSkin.SQUARED,
                'm--is-rounded': this.skin === MToggleButtonSkin.ROUNDED
            };
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Model"])('change'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: function () { return []; } })
    ], MToggleButtons.prototype, "buttons", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: true })
    ], MToggleButtons.prototype, "multiple", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: false })
    ], MToggleButtons.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({
            default: MToggleButtonSkin.SQUARED,
            validator: function (value) {
                return value === MToggleButtonSkin.SQUARED ||
                    value === MToggleButtonSkin.ROUNDED;
            }
        })
    ], MToggleButtons.prototype, "skin", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Emit"])('click')
    ], MToggleButtons.prototype, "onClick", null);
    MToggleButtons = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _toggle_buttons_html_style_toggle_buttons_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["BUTTON_NAME"]] = _button_button__WEBPACK_IMPORTED_MODULE_4__["MButton"],
                _a)
        })
    ], MToggleButtons);
    return MToggleButtons;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var ToggleButtonsPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug(_component_names__WEBPACK_IMPORTED_MODULE_5__["TOGGLE_BUTTONS_NAME"], 'plugin.install');
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["TOGGLE_BUTTONS_NAME"], MToggleButtons);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ToggleButtonsPlugin);


/***/ }),

/***/ "./src/components/tooltip/tooltip.html":
/*!*********************************************!*\
  !*** ./src/components/tooltip/tooltip.html ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-popup",
    {
      staticClass: "m-tooltip",
      class: {
        "m--is-disabled": _vm.disabled,
        "m--is-mode-definition": _vm.isModeDefinition
      },
      attrs: {
        "class-name": _vm.className,
        "close-on-backdrop": true,
        "focus-management": _vm.isMqMaxS,
        open: _vm.propOpen,
        padding: false,
        background: false,
        placement: _vm.placement,
        disabled: _vm.disabled
      },
      on: {
        "update:open": function($event) {
          _vm.propOpen = $event
        },
        open: _vm.onOpen,
        close: _vm.onClose
      }
    },
    [
      _vm.isModeIcon
        ? _c("m-icon-button", {
            staticClass: "m-tooltip__icon",
            attrs: {
              slot: "trigger",
              id: _vm.id,
              "aria-controls": _vm.ariaControls,
              "aria-expanded": _vm.propOpen,
              "icon-name": _vm.iconName,
              title: _vm.title,
              "button-size": "22px",
              disabled: _vm.disabled
            },
            slot: "trigger"
          })
        : _c(
            "m-link",
            {
              staticClass: "m-tooltip__link",
              attrs: {
                slot: "trigger",
                id: _vm.id,
                "aria-haspopup": "true",
                "aria-controls": _vm.ariaControls,
                "aria-expanded": _vm.propOpen,
                mode: "button",
                underline: _vm.isModeLink,
                disabled: _vm.disabled
              },
              on: { click: _vm.onClick },
              slot: "trigger"
            },
            [_vm._t("link")],
            2
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "m-tooltip__body-container",
          class: {
            "m--is-mode-icon": _vm.isModeIcon,
            "m--is-size-large": _vm.isSizeLarge,
            "m--has-close-button": _vm.hasCloseButton
          },
          attrs: { id: _vm.ariaControls, "aria-labelledby": _vm.id }
        },
        [
          _vm.hasCloseButton
            ? _c("m-icon-button", {
                staticClass: "m-tooltip__close-button",
                attrs: {
                  "icon-name": "m-svg__close-clear",
                  "icon-size": "14px",
                  "svg-tile": _vm.CloseTitle
                },
                on: { click: _vm.close }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "m-tooltip__body" }, [_vm._t("default")], 2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-c697a7be'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/tooltip/tooltip.scss":
/*!*********************************************!*\
  !*** ./src/components/tooltip/tooltip.scss ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/tooltip/tooltip.ts":
/*!*******************************************!*\
  !*** ./src/components/tooltip/tooltip.ts ***!
  \*******************************************/
/*! exports provided: MTooltipMode, MTooltipSize, MTooltip, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTooltipMode", function() { return MTooltipMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTooltipSize", function() { return MTooltipSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTooltip", function() { return MTooltip; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../link/link */ "./src/components/link/link.ts");
/* harmony import */ var _popper_popper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../popper/popper */ "./src/components/popper/popper.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../popup/popup */ "./src/components/popup/popup.ts");
/* harmony import */ var _tooltip_html__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./tooltip.html */ "./src/components/tooltip/tooltip.html");
/* harmony import */ var _tooltip_html__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_tooltip_html__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _tooltip_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./tooltip.scss */ "./src/components/tooltip/tooltip.scss");
/* harmony import */ var _tooltip_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_tooltip_scss__WEBPACK_IMPORTED_MODULE_13__);
var _a;














var MTooltipMode;
(function (MTooltipMode) {
    MTooltipMode["Icon"] = "icon";
    MTooltipMode["Link"] = "link";
    MTooltipMode["Definition"] = "definition";
})(MTooltipMode || (MTooltipMode = {}));
var MTooltipSize;
(function (MTooltipSize) {
    MTooltipSize["Small"] = "small";
    MTooltipSize["Large"] = "large";
})(MTooltipSize || (MTooltipSize = {}));
var MTooltip = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTooltip, _super);
    function MTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "mTooltip-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_5__["default"].generate();
        _this.ariaControls = _this.id + '-controls';
        _this.propOpen = false;
        return _this;
    }
    MTooltip.prototype.mounted = function () {
        this.propOpen = this.open;
    };
    MTooltip.prototype.onClick = function (event) {
    };
    Object.defineProperty(MTooltip.prototype, "isModeIcon", {
        get: function () {
            return this.mode === MTooltipMode.Icon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "isModeLink", {
        get: function () {
            return this.mode === MTooltipMode.Link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "isModeDefinition", {
        get: function () {
            return this.mode === MTooltipMode.Definition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "isSizeLarge", {
        get: function () {
            return this.size === MTooltipSize.Large;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "hasCloseButton", {
        get: function () {
            return this.as().isMqMaxS ? false : this.closeButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "title", {
        get: function () {
            return this.propOpen ? this.CloseTitle : this.OpenTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "OpenTitle", {
        get: function () {
            return this.openTitle === undefined ? this.$i18n.translate('m-tooltip:open') : this.openTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTooltip.prototype, "CloseTitle", {
        get: function () {
            return this.closeTitle === undefined ? this.$i18n.translate('m-tooltip:close') : this.closeTitle;
        },
        enumerable: true,
        configurable: true
    });
    MTooltip.prototype.close = function () {
        this.propOpen = false;
    };
    Object.defineProperty(MTooltip.prototype, "hasDefaultSlot", {
        get: function () {
            return !!this.$slots.default;
        },
        enumerable: true,
        configurable: true
    });
    MTooltip.prototype.openChanged = function (open) {
        this.propOpen = open;
    };
    MTooltip.prototype.onOpen = function () {
    };
    MTooltip.prototype.onClose = function () {
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTooltip.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MTooltipMode.Icon,
            validator: function (value) {
                return value === MTooltipMode.Icon ||
                    value === MTooltipMode.Link ||
                    value === MTooltipMode.Definition;
            }
        })
    ], MTooltip.prototype, "mode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].Bottom,
            validator: function (value) {
                return value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].Bottom ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].BottomEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].BottomStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].Left ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].LeftEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].LeftStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].Right ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].RightEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].RightStart ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].Top ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].TopEnd ||
                    value === _popper_popper__WEBPACK_IMPORTED_MODULE_10__["MPopperPlacement"].TopStart;
            }
        })
    ], MTooltip.prototype, "placement", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTooltip.prototype, "closeButton", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTooltip.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTooltip.prototype, "openTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTooltip.prototype, "closeTitle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTooltip.prototype, "className", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MTooltipSize.Small,
            validator: function (value) {
                return value === MTooltipSize.Large ||
                    value === MTooltipSize.Small;
            }
        })
    ], MTooltip.prototype, "size", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 'm-svg__information' })
    ], MTooltip.prototype, "iconName", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close')
    ], MTooltip.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open')
    ], MTooltip.prototype, "openChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('open')
    ], MTooltip.prototype, "onOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close')
    ], MTooltip.prototype, "onClose", null);
    MTooltip = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _tooltip_html__WEBPACK_IMPORTED_MODULE_12___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["POPUP_NAME"]] = _popup_popup__WEBPACK_IMPORTED_MODULE_11__["MPopup"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_8__["MIconButton"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_7__["LINK_NAME"]] = _link_link__WEBPACK_IMPORTED_MODULE_9__["MLink"],
                _a),
            mixins: [_mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_3__["MediaQueries"]]
        })
    ], MTooltip);
    return MTooltip;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_6__["ModulVue"]));

var TooltipPlugin = {
    install: function (v, options) {
        v.use(_utils_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_4__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_7__["TOOLTIP_NAME"], MTooltip);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TooltipPlugin);


/***/ }),

/***/ "./src/components/touch/enums.ts":
/*!***************************************!*\
  !*** ./src/components/touch/enums.ts ***!
  \***************************************/
/*! exports provided: MZingTouchGestures, MZingGestureDirections, MZingTapInteractions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MZingTouchGestures", function() { return MZingTouchGestures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MZingGestureDirections", function() { return MZingGestureDirections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MZingTapInteractions", function() { return MZingTapInteractions; });
var MZingTouchGestures;
(function (MZingTouchGestures) {
    MZingTouchGestures["Tap"] = "tap";
    MZingTouchGestures["Swipe"] = "swipe";
})(MZingTouchGestures || (MZingTouchGestures = {}));
var MZingGestureDirections;
(function (MZingGestureDirections) {
    MZingGestureDirections["Left"] = "left";
    MZingGestureDirections["Right"] = "right";
    MZingGestureDirections["None"] = "none";
})(MZingGestureDirections || (MZingGestureDirections = {}));
var MZingTapInteractions;
(function (MZingTapInteractions) {
    MZingTapInteractions["Click"] = "click";
    MZingTapInteractions["Tap"] = "tap";
})(MZingTapInteractions || (MZingTapInteractions = {}));


/***/ }),

/***/ "./src/components/touch/touch.html":
/*!*****************************************!*\
  !*** ./src/components/touch/touch.html ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.tag, { tag: "component" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-8a23dfae'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/touch/touch.ts":
/*!***************************************!*\
  !*** ./src/components/touch/touch.ts ***!
  \***************************************/
/*! exports provided: MTouchSwipeDirection, MTouch, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTouchSwipeDirection", function() { return MTouchSwipeDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTouch", function() { return MTouch; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./enums */ "./src/components/touch/enums.ts");
/* harmony import */ var _touch_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./touch.html */ "./src/components/touch/touch.html");
/* harmony import */ var _touch_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_touch_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _zingtouch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./zingtouch */ "./src/components/touch/zingtouch.ts");








var MTouchSwipeDirection;
(function (MTouchSwipeDirection) {
    MTouchSwipeDirection["horizontal"] = "horizontal";
    MTouchSwipeDirection["vertical"] = "vertical";
    MTouchSwipeDirection["both"] = "both";
})(MTouchSwipeDirection || (MTouchSwipeDirection = {}));
var MTouch = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTouch, _super);
    function MTouch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MTouch.prototype, "internalSwipeOptions", {
        get: function () {
            var swipeOptions = this.swipeOptions || {};
            return Object.assign({
                direction: swipeOptions.direction || MTouchSwipeDirection.both,
                angleThreshold: swipeOptions.angleThreshold || 20,
                velocity: swipeOptions.velocity || 0.3
            });
        },
        enumerable: true,
        configurable: true
    });
    MTouch.prototype.mounted = function () {
        this.initializeZingTouch();
    };
    MTouch.prototype.beforeDestroy = function () {
        this.destroyZingTouch();
    };
    MTouch.prototype.initializeZingTouch = function () {
        this.destroyZingTouch();
        this.zingRegion = _zingtouch__WEBPACK_IMPORTED_MODULE_7__["default"].setupRegion(this.$el, false, false);
        this.configureZingSwipe();
        this.configureZingTap();
    };
    MTouch.prototype.configureZingSwipe = function () {
        var _this = this;
        this.zingRegion.bind(this.$el, _zingtouch__WEBPACK_IMPORTED_MODULE_7__["default"].GestureFactory.getGesture(_enums__WEBPACK_IMPORTED_MODULE_5__["MZingTouchGestures"].Swipe, this.internalSwipeOptions), function (event) {
            switch (_this.internalSwipeOptions.direction) {
                case MTouchSwipeDirection.both:
                case MTouchSwipeDirection.horizontal:
                    _this.handleHorizontalSwipe(event);
                    break;
            }
        });
    };
    MTouch.prototype.handleHorizontalSwipe = function (event) {
        var swipeOptions = this.internalSwipeOptions;
        switch (_zingtouch__WEBPACK_IMPORTED_MODULE_7__["default"].detectDirection(event, swipeOptions.angleThreshold)) {
            case _enums__WEBPACK_IMPORTED_MODULE_5__["MZingGestureDirections"].Right:
                this.handleZingEvent(event);
                this.$emit('swiperight', event);
                break;
            case _enums__WEBPACK_IMPORTED_MODULE_5__["MZingGestureDirections"].Left:
                this.handleZingEvent(event);
                this.$emit('swipeleft', event);
                break;
        }
    };
    MTouch.prototype.configureZingTap = function () {
        var _this = this;
        this.zingRegion.bind(this.$el, _zingtouch__WEBPACK_IMPORTED_MODULE_7__["default"].GestureFactory.getGesture(_enums__WEBPACK_IMPORTED_MODULE_5__["MZingTouchGestures"].Tap), function (event) {
            switch (_zingtouch__WEBPACK_IMPORTED_MODULE_7__["default"].detectTap(event)) {
                case _enums__WEBPACK_IMPORTED_MODULE_5__["MZingTapInteractions"].Tap:
                    _this.handleZingEvent(event);
                    _this.$emit('tap', event);
                    break;
                case _enums__WEBPACK_IMPORTED_MODULE_5__["MZingTapInteractions"].Click:
                    _this.handleZingEvent(event);
                    _this.$emit('click', event);
                    break;
            }
        });
    };
    MTouch.prototype.destroyZingTouch = function () {
        if (this.zingRegion) {
            this.zingRegion.unbind(this.$el);
        }
        this.zingRegion = undefined;
    };
    MTouch.prototype.handleZingEvent = function (event) {
        // Since we reemit the event, we stop event propagation.  Event whould be handled twice from each listener otherwise.
        event.stopPropagation();
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])({ default: 'div' })
    ], MTouch.prototype, "tag", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_3__["Prop"])()
    ], MTouch.prototype, "swipeOptions", void 0);
    MTouch = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _touch_html__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MTouch);
    return MTouch;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var TouchPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["TOUCH_NAME"], MTouch);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TouchPlugin);


/***/ }),

/***/ "./src/components/touch/zingtouch.ts":
/*!*******************************************!*\
  !*** ./src/components/touch/zingtouch.ts ***!
  \*******************************************/
/*! exports provided: MZingTouchGestureFactory, MZingTouchUtil, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MZingTouchGestureFactory", function() { return MZingTouchGestureFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MZingTouchUtil", function() { return MZingTouchUtil; });
/* harmony import */ var zingtouch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! zingtouch */ "zingtouch");
/* harmony import */ var zingtouch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(zingtouch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./enums */ "./src/components/touch/enums.ts");


var MZingTouchGestureFactory = /** @class */ (function () {
    function MZingTouchGestureFactory() {
    }
    MZingTouchGestureFactory.prototype.getGesture = function (gesture, params) {
        switch (gesture) {
            case 'tap':
                return new zingtouch__WEBPACK_IMPORTED_MODULE_0___default.a.Tap(params || {});
            case 'swipe':
                return new zingtouch__WEBPACK_IMPORTED_MODULE_0___default.a.Swipe(params || {});
            default: throw new Error("ZingTouchUtil: Unrecognized gesture " + gesture + ".");
        }
    };
    return MZingTouchGestureFactory;
}());

var MZingTouchUtil = /** @class */ (function () {
    function MZingTouchUtil() {
        this.GestureFactory = new MZingTouchGestureFactory();
    }
    MZingTouchUtil.prototype.setupRegion = function (element, capture, preventDefault) {
        if (capture === void 0) { capture = true; }
        if (preventDefault === void 0) { preventDefault = true; }
        element.style.touchAction = '';
        return new zingtouch__WEBPACK_IMPORTED_MODULE_0___default.a.Region(element, capture, preventDefault);
    };
    MZingTouchUtil.prototype.detectDirection = function (event, threshold) {
        if (threshold === void 0) { threshold = 0; }
        var angle = event.detail.data[0].currentDirection;
        if ((angle >= 360 - threshold && angle <= 360) || (angle <= threshold && angle >= 0)) {
            event.detail.events.forEach(function (event) { return event.originalEvent.preventDefault(); });
            return _enums__WEBPACK_IMPORTED_MODULE_1__["MZingGestureDirections"].Right;
        }
        else if (angle >= 180 - threshold && angle <= 180 + threshold) {
            event.detail.events.forEach(function (event) { return event.originalEvent.preventDefault(); });
            return _enums__WEBPACK_IMPORTED_MODULE_1__["MZingGestureDirections"].Left;
        }
        return _enums__WEBPACK_IMPORTED_MODULE_1__["MZingGestureDirections"].None;
    };
    MZingTouchUtil.prototype.detectTap = function (event) {
        var interval = event.detail.interval;
        if (interval <= 5) {
            return _enums__WEBPACK_IMPORTED_MODULE_1__["MZingTapInteractions"].Click;
        }
        else {
            return _enums__WEBPACK_IMPORTED_MODULE_1__["MZingTapInteractions"].Tap;
        }
    };
    return MZingTouchUtil;
}());

/* harmony default export */ __webpack_exports__["default"] = (new MZingTouchUtil());


/***/ }),

/***/ "./src/components/transitions/accordion-transition/accordion-transition.html":
/*!***********************************************************************************!*\
  !*** ./src/components/transitions/accordion-transition/accordion-transition.html ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "m--is", css: !_vm.disabled },
      on: {
        "before-enter": _vm.beforeEnter,
        enter: _vm.enter,
        "after-enter": _vm.afterEnter,
        "enter-cancelled": _vm.enterCancelled,
        "before-leave": _vm.beforeLeave,
        leave: _vm.leave,
        "after-leave": _vm.afterLeave,
        "leave-cancelled": _vm.leaveCancelled
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-35734b5a'
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/transitions/accordion-transition/accordion-transition.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/transitions/accordion-transition/accordion-transition.scss ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/components/transitions/accordion-transition/accordion-transition.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/transitions/accordion-transition/accordion-transition.ts ***!
  \*********************************************************************************/
/*! exports provided: MAccordionTransition, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAccordionTransition", function() { return MAccordionTransition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _accordion_transition_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./accordion-transition.html */ "./src/components/transitions/accordion-transition/accordion-transition.html");
/* harmony import */ var _accordion_transition_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_accordion_transition_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _accordion_transition_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./accordion-transition.scss */ "./src/components/transitions/accordion-transition/accordion-transition.scss");
/* harmony import */ var _accordion_transition_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_accordion_transition_scss__WEBPACK_IMPORTED_MODULE_6__);







var CLASS_HAS_TRANSITION = 'm--has-transition';
var MAccordionTransition = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MAccordionTransition, _super);
    function MAccordionTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MAccordionTransition.prototype.setClassHasTransition = function (el) {
        if (!el.classList.contains(_component_names__WEBPACK_IMPORTED_MODULE_4__["ACCORDION_TRANSITION_NAME"])) {
            el.classList.add(_component_names__WEBPACK_IMPORTED_MODULE_4__["ACCORDION_TRANSITION_NAME"]);
        }
        if (!this.disabled) {
            if (!el.classList.contains(CLASS_HAS_TRANSITION)) {
                el.classList.add(CLASS_HAS_TRANSITION);
            }
        }
        else if (el.classList.contains(CLASS_HAS_TRANSITION)) {
            el.classList.remove(CLASS_HAS_TRANSITION);
        }
    };
    MAccordionTransition.prototype.beforeEnter = function (el) {
        this.setClassHasTransition(el);
    };
    MAccordionTransition.prototype.enter = function (el, done) {
        var heightDelta = this.heightDelta || 0;
        el.style.height = el.scrollHeight - heightDelta + "px";
    };
    MAccordionTransition.prototype.afterEnter = function (el) {
        el.style.removeProperty('height');
    };
    MAccordionTransition.prototype.enterCancelled = function (el) {
        el.style.removeProperty('height');
    };
    MAccordionTransition.prototype.beforeLeave = function (el) {
        el.style.height = parseInt(window.getComputedStyle(el).height, 10) + 'px';
        this.setClassHasTransition(el);
    };
    MAccordionTransition.prototype.leave = function (el, done) { };
    MAccordionTransition.prototype.afterLeave = function (el) {
        el.style.removeProperty('height');
    };
    MAccordionTransition.prototype.leaveCancelled = function (el) {
        el.style.removeProperty('height');
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MAccordionTransition.prototype, "heightDelta", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MAccordionTransition.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-enter')
    ], MAccordionTransition.prototype, "beforeEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter')
    ], MAccordionTransition.prototype, "enter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-enter')
    ], MAccordionTransition.prototype, "afterEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter-cancelled')
    ], MAccordionTransition.prototype, "enterCancelled", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-leave')
    ], MAccordionTransition.prototype, "beforeLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave')
    ], MAccordionTransition.prototype, "leave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-leave')
    ], MAccordionTransition.prototype, "afterLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave-cancelled')
    ], MAccordionTransition.prototype, "leaveCancelled", null);
    MAccordionTransition = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _accordion_transition_html__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MAccordionTransition);
    return MAccordionTransition;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var AccordionTransitionPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["ACCORDION_TRANSITION_NAME"], MAccordionTransition);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AccordionTransitionPlugin);


/***/ }),

/***/ "./src/components/transitions/opacity-transition/opacity-transition.html?style=./opacity-transition.scss":
/*!***************************************************************************************************************!*\
  !*** ./src/components/transitions/opacity-transition/opacity-transition.html?style=./opacity-transition.scss ***!
  \***************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4b19ed3a!./opacity-transition.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4b19ed3a!./src/components/transitions/opacity-transition/opacity-transition.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "m--is", css: !_vm.disabled },
      on: {
        "before-enter": _vm.beforeEnter,
        enter: _vm.enter,
        "after-enter": _vm.afterEnter,
        "enter-cancelled": _vm.enterCancelled,
        "before-leave": _vm.beforeLeave,
        leave: _vm.leave,
        "after-leave": _vm.afterLeave,
        "leave-cancelled": _vm.leaveCancelled
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4b19ed3a'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/transitions/opacity-transition/opacity-transition.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/transitions/opacity-transition/opacity-transition.ts ***!
  \*****************************************************************************/
/*! exports provided: MOpacityTransition, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOpacityTransition", function() { return MOpacityTransition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _opacity_transition_html_style_opacity_transition_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./opacity-transition.html?style=./opacity-transition.scss */ "./src/components/transitions/opacity-transition/opacity-transition.html?style=./opacity-transition.scss");
/* harmony import */ var _opacity_transition_html_style_opacity_transition_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_opacity_transition_html_style_opacity_transition_scss__WEBPACK_IMPORTED_MODULE_5__);






var CLASS_HAS_TRANSITION = 'm--has-transition';
var CLASS_HAS_ZOOM_EFFECT = 'm--has-zoom-effect';
var MOpacityTransition = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MOpacityTransition, _super);
    function MOpacityTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MOpacityTransition.prototype.setClassOfTransition = function (el) {
        if (!el.classList.contains(_component_names__WEBPACK_IMPORTED_MODULE_4__["OPACITY_TRANSITION_NAME"])) {
            el.classList.add(_component_names__WEBPACK_IMPORTED_MODULE_4__["OPACITY_TRANSITION_NAME"]);
        }
        if (!this.disabled) {
            if (!el.classList.contains(CLASS_HAS_TRANSITION)) {
                el.classList.add(CLASS_HAS_TRANSITION);
            }
        }
        else if (el.classList.contains(CLASS_HAS_TRANSITION)) {
            el.classList.remove(CLASS_HAS_TRANSITION);
        }
        if (this.zoomEffect && !this.disabled) {
            if (!el.classList.contains(CLASS_HAS_ZOOM_EFFECT)) {
                el.classList.add(CLASS_HAS_ZOOM_EFFECT);
            }
        }
        else if (el.classList.contains(CLASS_HAS_ZOOM_EFFECT)) {
            el.classList.remove(CLASS_HAS_ZOOM_EFFECT);
        }
    };
    MOpacityTransition.prototype.beforeEnter = function (el) {
        this.setClassOfTransition(el);
    };
    MOpacityTransition.prototype.enter = function (el, done) { };
    MOpacityTransition.prototype.afterEnter = function (el) { };
    MOpacityTransition.prototype.enterCancelled = function (el) { };
    MOpacityTransition.prototype.beforeLeave = function (el) {
        this.setClassOfTransition(el);
    };
    MOpacityTransition.prototype.leave = function (el, done) { };
    MOpacityTransition.prototype.afterLeave = function (el) { };
    MOpacityTransition.prototype.leaveCancelled = function (el) { };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MOpacityTransition.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MOpacityTransition.prototype, "zoomEffect", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-enter')
    ], MOpacityTransition.prototype, "beforeEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter')
    ], MOpacityTransition.prototype, "enter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-enter')
    ], MOpacityTransition.prototype, "afterEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter-cancelled')
    ], MOpacityTransition.prototype, "enterCancelled", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-leave')
    ], MOpacityTransition.prototype, "beforeLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave')
    ], MOpacityTransition.prototype, "leave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-leave')
    ], MOpacityTransition.prototype, "afterLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave-cancelled')
    ], MOpacityTransition.prototype, "leaveCancelled", null);
    MOpacityTransition = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _opacity_transition_html_style_opacity_transition_scss__WEBPACK_IMPORTED_MODULE_5___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MOpacityTransition);
    return MOpacityTransition;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));

var OpacityTransitionPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_4__["OPACITY_TRANSITION_NAME"], MOpacityTransition);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (OpacityTransitionPlugin);


/***/ }),

/***/ "./src/components/transitions/slide-transition/slide-transition.html?style=./slide-transition.scss":
/*!*********************************************************************************************************!*\
  !*** ./src/components/transitions/slide-transition/slide-transition.html?style=./slide-transition.scss ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0733b00c!./slide-transition.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=0733b00c!./src/components/transitions/slide-transition/slide-transition.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-slide-transition",
      class: { "m--is-left-to-right-transition": _vm.isLeftToRight }
    },
    [
      _c(
        "transition",
        {
          attrs: { name: _vm.transitionName, css: !_vm.disabled },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.afterEnter,
            "enter-cancelled": _vm.enterCancelled,
            "before-leave": _vm.beforeLeave,
            leave: _vm.leave,
            "after-leave": _vm.afterLeave,
            "leave-cancelled": _vm.leaveCancelled
          }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-0733b00c'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/transitions/slide-transition/slide-transition.ts":
/*!*************************************************************************!*\
  !*** ./src/components/transitions/slide-transition/slide-transition.ts ***!
  \*************************************************************************/
/*! exports provided: MSlideTransitionDirection, MSlideTransition, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSlideTransitionDirection", function() { return MSlideTransitionDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSlideTransition", function() { return MSlideTransition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/scroll-to/scroll-to */ "./src/utils/scroll-to/scroll-to.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _slide_transition_html_style_slide_transition_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./slide-transition.html?style=./slide-transition.scss */ "./src/components/transitions/slide-transition/slide-transition.html?style=./slide-transition.scss");
/* harmony import */ var _slide_transition_html_style_slide_transition_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_slide_transition_html_style_slide_transition_scss__WEBPACK_IMPORTED_MODULE_6__);







var MSlideTransitionDirection;
(function (MSlideTransitionDirection) {
    MSlideTransitionDirection["LeftToRight"] = "left-to-right";
    MSlideTransitionDirection["RightToLeft"] = "right-to-left";
})(MSlideTransitionDirection || (MSlideTransitionDirection = {}));
var MSlideTransition = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSlideTransition, _super);
    function MSlideTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MSlideTransition.prototype, "transitionName", {
        get: function () {
            return !this.disabled ? 'm--is' : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MSlideTransition.prototype, "isLeftToRight", {
        get: function () {
            return this.direction === MSlideTransitionDirection.LeftToRight;
        },
        enumerable: true,
        configurable: true
    });
    MSlideTransition.prototype.beforeEnter = function (el) { };
    MSlideTransition.prototype.enter = function (el, done) {
        var _this = this;
        if (!this.disabled) {
            if (this.automaticScroll) {
                this.$scrollTo.goTo(this.$el, this.scrollToOffset, _utils_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_3__["ScrollToDuration"].Regular);
            }
            setTimeout(function () {
                _this.addStyleProperty(el);
            }, 100);
        }
        else {
            done();
        }
    };
    MSlideTransition.prototype.afterEnter = function (el) {
        this.removeStyleProperty(el);
    };
    MSlideTransition.prototype.enterCancelled = function (el) { };
    MSlideTransition.prototype.beforeLeave = function (el) {
        this.addStyleProperty(el);
    };
    MSlideTransition.prototype.leave = function (el, done) { };
    MSlideTransition.prototype.afterLeave = function (el) {
        this.removeStyleProperty(el);
    };
    MSlideTransition.prototype.leaveCancelled = function (el) { };
    MSlideTransition.prototype.addStyleProperty = function (el) {
        this.$el.style.height = this.getHeightEl(el) + 'px';
        this.$el.style.overflow = 'hidden';
    };
    MSlideTransition.prototype.removeStyleProperty = function (el) {
        this.$el.style.removeProperty('height');
        this.$el.style.removeProperty('overflow');
    };
    MSlideTransition.prototype.getHeightEl = function (el) {
        var elComputedStyle = window.getComputedStyle(el);
        return el.getBoundingClientRect().height +
            +parseInt(elComputedStyle.marginTop, 10)
            + parseInt(elComputedStyle.marginBottom, 10);
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: MSlideTransitionDirection.LeftToRight })
    ], MSlideTransition.prototype, "direction", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MSlideTransition.prototype, "scrollToOffset", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MSlideTransition.prototype, "automaticScroll", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MSlideTransition.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-enter')
    ], MSlideTransition.prototype, "beforeEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter')
    ], MSlideTransition.prototype, "enter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-enter')
    ], MSlideTransition.prototype, "afterEnter", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('enter-cancelled')
    ], MSlideTransition.prototype, "enterCancelled", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('before-leave')
    ], MSlideTransition.prototype, "beforeLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave')
    ], MSlideTransition.prototype, "leave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('after-leave')
    ], MSlideTransition.prototype, "afterLeave", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('leave-cancelled')
    ], MSlideTransition.prototype, "leaveCancelled", null);
    MSlideTransition = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _slide_transition_html_style_slide_transition_scss__WEBPACK_IMPORTED_MODULE_6___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MSlideTransition);
    return MSlideTransition;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var SlideTransitionPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["SLIDE_TRANSITION_NAME"], MSlideTransition);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SlideTransitionPlugin);


/***/ }),

/***/ "./src/components/tree/component-names.ts":
/*!************************************************!*\
  !*** ./src/components/tree/component-names.ts ***!
  \************************************************/
/*! exports provided: TREE_NODE_NAME, TREE_ICON_NAME */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_NODE_NAME", function() { return TREE_NODE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE_ICON_NAME", function() { return TREE_ICON_NAME; });
var TREE_NODE_NAME = 'm-tree-node';
var TREE_ICON_NAME = 'm-tree-icon';


/***/ }),

/***/ "./src/components/tree/tree-icon/tree-icon.html?style=./tree-icon.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/tree/tree-icon/tree-icon.html?style=./tree-icon.scss ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d7835cec!./tree-icon.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=d7835cec!./src/components/tree/tree-icon/tree-icon.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showFolderIcon
    ? _c("m-icon", {
        staticClass: "m-tree-icon",
        attrs: { size: "24px", showNameAsClass: true, name: _vm.folderIcon }
      })
    : _vm.useFilesIcons
    ? _c("m-icon-file", {
        staticClass: "m-tree-icon",
        attrs: { name: _vm.extensionFile, extension: _vm.extensionFile }
      })
    : _vm.isFolder
    ? _c("m-plus", {
        ref: "plus-icon",
        staticClass: "m-tree-icon",
        class: { "m--is-left": "true" },
        attrs: {
          open: _vm.isFolderOpen,
          large: false,
          skin: "light",
          "aria-hidden": "true"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-d7835cec'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/tree/tree-icon/tree-icon.ts":
/*!****************************************************!*\
  !*** ./src/components/tree/tree-icon/tree-icon.ts ***!
  \****************************************************/
/*! exports provided: MTreeIcon */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTreeIcon", function() { return MTreeIcon; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_file_file__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/file/file */ "./src/utils/file/file.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_file_icon_file__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../icon-file/icon-file */ "./src/components/icon-file/icon-file.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _plus_plus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../plus/plus */ "./src/components/plus/plus.ts");
/* harmony import */ var _tree_icon_html_style_tree_icon_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./tree-icon.html?style=./tree-icon.scss */ "./src/components/tree/tree-icon/tree-icon.html?style=./tree-icon.scss");
/* harmony import */ var _tree_icon_html_style_tree_icon_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_tree_icon_html_style_tree_icon_scss__WEBPACK_IMPORTED_MODULE_9__);
var _a;










var FOLDER_OPEN = 'm-svg__folder-open';
var FOLDER_CLOSED = 'm-svg__folder';
var MTreeIcon = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTreeIcon, _super);
    function MTreeIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MTreeIcon.prototype, "folderIcon", {
        get: function () {
            return this.isFolderOpen ? FOLDER_OPEN : FOLDER_CLOSED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeIcon.prototype, "extensionFile", {
        get: function () {
            return '.' + Object(_utils_file_file__WEBPACK_IMPORTED_MODULE_3__["extractExtension"])(this.filename);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeIcon.prototype, "showFolderIcon", {
        get: function () {
            return this.isFolder && this.useFilesIcons;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeIcon.prototype, "filename", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeIcon.prototype, "isFolderOpen", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTreeIcon.prototype, "isFolder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTreeIcon.prototype, "useFilesIcons", void 0);
    MTreeIcon = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _tree_icon_html_style_tree_icon_scss__WEBPACK_IMPORTED_MODULE_9___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["PLUS_NAME"]] = _plus_plus__WEBPACK_IMPORTED_MODULE_8__["MPlus"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_FILE_NAME"]] = _icon_file_icon_file__WEBPACK_IMPORTED_MODULE_6__["MIconFile"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_7__["MIcon"],
                _a)
        })
    ], MTreeIcon);
    return MTreeIcon;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));



/***/ }),

/***/ "./src/components/tree/tree-node/tree-node.html?style=./tree-node.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/tree/tree-node/tree-node.html?style=./tree-node.scss ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4ec0ce10!./tree-node.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=4ec0ce10!./src/components/tree/tree-node/tree-node.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "m-tree-node",
      class: {
        "m--is-selected": _vm.isSelected && !_vm.isDisabled,
        "m--is-disabled": _vm.isDisabled,
        "m--is-read-only": _vm.isReadonlyStyle,
        "m--has-children": _vm.isFolder,
        "m--is-with-checkboxes": _vm.withCheckboxes,
        "m--has-file-icons": _vm.useFilesIcons
      }
    },
    [
      _c(
        "div",
        {
          ref: "item",
          staticClass: "m-tree-node__item",
          class: { "m--no-hover": _vm.moveSelectionZoneToCheckbox },
          attrs: {
            tabindex:
              _vm.isDisabled || (_vm.withCheckboxes && !_vm.isFolder)
                ? "-1"
                : 0,
            "aria-selected": _vm.isSelected && !_vm.isDisabled,
            role: "button"
          },
          on: {
            click: _vm.onClick,
            keypress: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onClick($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.onClick($event)
              }
            ]
          }
        },
        [
          _vm.useFilesIcons
            ? _c("m-tree-icon", {
                attrs: {
                  "is-folder-open": _vm.internalOpen,
                  "is-folder": _vm.isFolder
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("m-tree-icon", {
            attrs: {
              filename: _vm.node.id,
              "is-folder-open": _vm.internalOpen,
              "use-files-icons": _vm.useFilesIcons,
              "is-folder": _vm.isFolder
            }
          }),
          _vm._v(" "),
          _vm.withCheckboxes
            ? _c(
                "m-checkbox",
                {
                  ref: "checkbox",
                  staticClass: "m-tree-node__checkbox",
                  attrs: {
                    value: _vm.isSelected,
                    indeterminate: _vm.isIndeterminate,
                    disabled: _vm.isDisabled,
                    readonly: _vm.readonly
                  },
                  on: { change: _vm.onCheckboxClick }
                },
                [_vm._v(_vm._s(_vm.label))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.withCheckboxes
            ? [
                _c("span", { staticClass: "m-tree-node__item-label" }, [
                  _vm._v(_vm._s(_vm.label))
                ]),
                _vm._v(" "),
                !_vm.isFolder
                  ? _c("span", {
                      staticClass: "m-tree-node__item-check",
                      attrs: { "aria-hidden": "true" }
                    })
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRightIcon
            ? _c("m-icon", {
                staticClass: "m-tree-node__warning-icon",
                attrs: { name: _vm.node.rightIconName, size: "1em" }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.isFolder
        ? [
            _vm.hasChildren
              ? _c("m-accordion-transition", [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.internalOpen,
                          expression: "internalOpen"
                        }
                      ],
                      ref: "children",
                      staticClass: "m-tree-node__children",
                      class: { "m--has-line-extension": _vm.hasSibling },
                      attrs: { role: "tabpanel" }
                    },
                    _vm._l(_vm.node.children, function(childNode, index) {
                      return _c("m-tree-node", {
                        key: childNode.id,
                        staticClass: "m-tree-node__child",
                        attrs: {
                          path: _vm.currentPath,
                          selectable: _vm.selectable,
                          selected: _vm.isSelected,
                          readonly: _vm.readonly,
                          open: childNode.open,
                          node: childNode,
                          "use-files-icons": _vm.useFilesIcons,
                          "selected-nodes": _vm.selectedNodes,
                          "disabled-nodes": _vm.disabledNodes,
                          checkboxes: _vm.checkboxes,
                          "has-sibling": _vm.childHasSibling(index)
                        },
                        on: {
                          "update:open": function($event) {
                            return _vm.$set(childNode, "open", $event)
                          },
                          "auto-select-child-checkbox-change":
                            _vm.onAutoSelectChildCheckboxChange,
                          click: _vm.emitClick
                        }
                      })
                    }),
                    1
                  )
                ])
              : _c("m-accordion-transition", [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.internalOpen,
                          expression: "internalOpen"
                        }
                      ],
                      staticClass: "m-tree-node__children",
                      class: { "m--has-line-extension": _vm.hasSibling },
                      attrs: { role: "tabpanel" }
                    },
                    [
                      _c("li", { staticClass: "m-tree-node__child-empty" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.emptyContentMessage) +
                            "\n                "
                        )
                      ])
                    ]
                  )
                ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.displaySelectionButton
        ? [
            _c("button", {
              ref: "autoSelectButton",
              staticClass: "m-tree-node__auto-select-button",
              class: { "m--is-selected": _vm.allChildrenAndSelfSelected },
              on: { click: _vm.onAutoSelectButtonClick }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-4ec0ce10'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/tree/tree-node/tree-node.ts":
/*!****************************************************!*\
  !*** ./src/components/tree/tree-node/tree-node.ts ***!
  \****************************************************/
/*! exports provided: MTreeNode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTreeNode", function() { return MTreeNode; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _checkbox_checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../checkbox/checkbox */ "./src/components/checkbox/checkbox.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../component-names */ "./src/components/tree/component-names.ts");
/* harmony import */ var _tree__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../tree */ "./src/components/tree/tree.ts");
/* harmony import */ var _tree_icon_tree_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../tree-icon/tree-icon */ "./src/components/tree/tree-icon/tree-icon.ts");
/* harmony import */ var _tree_node_html_style_tree_node_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./tree-node.html?style=./tree-node.scss */ "./src/components/tree/tree-node/tree-node.html?style=./tree-node.scss");
/* harmony import */ var _tree_node_html_style_tree_node_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_tree_node_html_style_tree_node_scss__WEBPACK_IMPORTED_MODULE_11__);
var _a;












var MTreeNode = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTreeNode, _super);
    function MTreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalOpen = false;
        _this.allChildrenAndSelfSelected = false;
        _this.selectedChildrenCount = 0;
        return _this;
    }
    MTreeNode.prototype.notifyParentOfChildCheckboxState = function () {
        if (this.withCheckboxes) {
            if (!this.hasChildren || this.isParentAutoSelect) {
                this.$emit('auto-select-child-checkbox-change', this.isSelected);
            }
            else if (this.isButtonAutoSelect && this.hasChildren) {
                this.onAutoSelectChildCheckboxChange(this.isSelected, true);
            }
        }
    };
    MTreeNode.prototype.emitClick = function (path) {
        return path;
    };
    MTreeNode.prototype.mounted = function () {
        this.internalOpen = this.open || this.isParentOfOpenedFolder() || this.isParentOfSelectedFile;
        if (this.isSelected) {
            this.notifyParentOfChildCheckboxState();
        }
    };
    MTreeNode.prototype.onClick = function () {
        if (this.isFolder) {
            this.internalOpen = !this.internalOpen;
            this.$emit('update:open', this.internalOpen);
        }
        else if (this.selectable) {
            this.emitClick(this.currentPath);
        }
    };
    MTreeNode.prototype.onAutoSelectButtonClick = function () {
        this.recursiveSelect();
    };
    MTreeNode.prototype.onAutoSelectChildCheckboxChange = function (selected, ignoreCount) {
        if (ignoreCount === void 0) { ignoreCount = false; }
        if (!ignoreCount) {
            this.selectedChildrenCount += selected ? 1 : -1;
        }
        var allChildrenSelected = this.selectedChildrenCount === (this.node.children ? this.node.children.length : -1);
        if (this.isCheckboxAutoSelect || (this.isParentAutoSelect && !selected)) { // Parent checkbox mode does not select parent by itself
            this.updateCheckboxParentNode(allChildrenSelected);
        }
        else if (this.isButtonAutoSelect) {
            this.updateButtonParentNode(allChildrenSelected, selected);
        }
    };
    MTreeNode.prototype.childHasSibling = function (index) {
        if (this.node.children) {
            return !!this.node.children[index + 1];
        }
        return false;
    };
    MTreeNode.prototype.onCheckboxClick = function () {
        if (this.hasChildren && (this.isCheckboxAutoSelect || this.isParentAutoSelect)) {
            this.recursiveSelect();
        }
        else {
            this.emitClick(this.currentPath);
        }
    };
    MTreeNode.prototype.recursiveSelect = function () {
        var childrenPaths = [];
        var addNodesToSelected = false;
        if (this.isButtonAutoSelect) {
            childrenPaths.concat(this.currentPath);
            if (!this.allChildrenAndSelfSelected) {
                addNodesToSelected = true;
            }
        }
        else if (!this.isButtonAutoSelect && !this.isSelected) {
            addNodesToSelected = true;
        }
        this.fetchChildrenPaths(this.node, childrenPaths, this.path + '/' + this.node.id, (this.isParentAutoSelect || this.isButtonAutoSelect));
        this.updateSelectedNodes(childrenPaths, addNodesToSelected);
    };
    MTreeNode.prototype.updateSelectedNodes = function (paths, addNodesToSelected) {
        var _this = this;
        if (paths === void 0) { paths = []; }
        paths = Array.from(new Set(paths));
        paths.forEach(function (path) {
            var nodeAlreadySelected = _this.selectedNodes.indexOf(path) !== -1;
            if ((addNodesToSelected && !nodeAlreadySelected) || (!addNodesToSelected && nodeAlreadySelected)) { // Prevent nodes to be pushed twice or unselected nodes to be removed
                _this.emitClick(path);
            }
        });
    };
    MTreeNode.prototype.fetchChildrenPaths = function (currentNode, childrenPath, path, includeParent) {
        var _this = this;
        if (includeParent === void 0) { includeParent = false; }
        if (currentNode.children && currentNode.children.length > 0) {
            currentNode.children.forEach(function (child) {
                _this.fetchChildrenPaths(child, childrenPath, path + '/' + child.id, includeParent);
            });
            if (includeParent) {
                childrenPath.push(path);
            }
        }
        else {
            childrenPath.push(path);
        }
    };
    MTreeNode.prototype.isParentOfOpenedFolder = function (currentNode) {
        var _this = this;
        if (currentNode === void 0) { currentNode = this.node; }
        var found = false;
        if (currentNode.children && currentNode.children.length > 0) {
            currentNode.children.forEach(function (child) {
                if (child.children && child.children.length > 0) {
                    if (child.open) {
                        found = true;
                    }
                    else {
                        found = _this.isParentOfOpenedFolder(child);
                    }
                }
            });
        }
        return found;
    };
    MTreeNode.prototype.updateCheckboxParentNode = function (allChildrenSelected) {
        if (allChildrenSelected && !this.isSelected) {
            this.emitClick(this.currentPath); // Auto-push current, emit to parent for recursivity
            this.$emit('auto-select-child-checkbox-change', true);
        }
        else if (this.isSelected) {
            this.emitClick(this.currentPath);
            this.$emit('auto-select-child-checkbox-change', false); // Not all children are selected, stop recursivity
        }
    };
    MTreeNode.prototype.updateButtonParentNode = function (allChildrenSelected, selected) {
        if (allChildrenSelected && selected && this.isSelected) { // New element selected was added, current and all children are selected
            this.allChildrenAndSelfSelected = true;
            this.$emit('auto-select-child-checkbox-change', true); // Notifies immidiate parent's button that current button is on
        }
        else if (this.allChildrenAndSelfSelected) { // Button was on, but something was removed.
            this.allChildrenAndSelfSelected = false;
            this.$emit('auto-select-child-checkbox-change', false); // Something was removed so every parent buttons must know
        }
    };
    Object.defineProperty(MTreeNode.prototype, "isParentOfSelectedFile", {
        get: function () {
            var _this = this;
            var pathMatchesSelectedNode = false;
            this.selectedNodes.forEach(function (selectedNode) {
                var parentPath = _this.currentPath + '/';
                if (selectedNode.indexOf(parentPath) !== -1) {
                    pathMatchesSelectedNode = true;
                }
            });
            return pathMatchesSelectedNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isDisabled", {
        get: function () {
            var isDisabled = false;
            var inDisabledNodes = this.disabledNodes && this.disabledNodes.indexOf(this.currentPath) !== -1;
            if (!this.selectable && !this.isFolder && !this.readonly || inDisabledNodes && !this.readonly) {
                isDisabled = true;
            }
            return isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isReadonlyStyle", {
        get: function () {
            var isReadonly = false;
            if (!this.selectable && this.readonly) {
                isReadonly = true;
            }
            return isReadonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "currentPath", {
        get: function () {
            return this.path + "/" + this.node.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "label", {
        get: function () {
            return this.node.label || this.node.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "propCheckboxes", {
        get: function () {
            return this.checkboxes || _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].False;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "moveSelectionZoneToCheckbox", {
        get: function () {
            return this.withCheckboxes && !this.isFolder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "displaySelectionButton", {
        get: function () {
            return this.hasChildren && this.checkboxes === _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].WithButtonAutoSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "hasChildren", {
        get: function () {
            return !!this.node.children && this.node.children.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isFolder", {
        get: function () {
            return this.node.hasChildren || !!this.node.children;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isSelected", {
        get: function () {
            return this.selectedNodes.indexOf(this.currentPath) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isIndeterminate", {
        get: function () {
            return (this.isCheckboxAutoSelect || this.isParentAutoSelect) && this.isParentOfSelectedFile && !this.isSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "emptyContentMessage", {
        get: function () {
            return this.placeholder || this.$i18n.translate('m-tree-node:empty');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "withCheckboxes", {
        get: function () {
            return this.checkboxes !== _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].False;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isParentAutoSelect", {
        get: function () {
            return this.checkboxes === _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].WithParentAutoSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isButtonAutoSelect", {
        get: function () {
            return this.checkboxes === _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].WithButtonAutoSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "isCheckboxAutoSelect", {
        get: function () {
            return this.checkboxes === _tree__WEBPACK_IMPORTED_MODULE_9__["MCheckboxes"].WithCheckboxAutoSelect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTreeNode.prototype, "hasRightIcon", {
        get: function () {
            return this.withCheckboxes && !!this.node.rightIconName;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "node", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: false })
    ], MTreeNode.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: [] })
    ], MTreeNode.prototype, "selectedNodes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "checkboxes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "selectable", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "readonly", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "useFilesIcons", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '' })
    ], MTreeNode.prototype, "path", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "placeholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "hasSibling", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTreeNode.prototype, "disabledNodes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('isSelected')
    ], MTreeNode.prototype, "notifyParentOfChildCheckboxState", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MTreeNode.prototype, "emitClick", null);
    MTreeNode = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _tree_node_html_style_tree_node_scss__WEBPACK_IMPORTED_MODULE_11___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            name: _component_names__WEBPACK_IMPORTED_MODULE_8__["TREE_NODE_NAME"],
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["TREE_ICON_NAME"]] = _tree_icon_tree_icon__WEBPACK_IMPORTED_MODULE_10__["MTreeIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__["MAccordionTransition"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["CHECKBOX_NAME"]] = _checkbox_checkbox__WEBPACK_IMPORTED_MODULE_4__["MCheckbox"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a)
        })
    ], MTreeNode);
    return MTreeNode;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/components/tree/tree.html?style=./tree.scss":
/*!*********************************************************!*\
  !*** ./src/components/tree/tree.html?style=./tree.scss ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7418f0e9!./tree.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=7418f0e9!./src/components/tree/tree.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-tree",
      class: {
        "m-tree__multiple-node-checkbox": _vm.isMultipleSelectWithCheckboxes,
        "m-tree__file-icons": _vm.useFilesIcons
      }
    },
    [
      _vm.errorTree
        ? _c(
            "m-message",
            {
              ref: "error-tree-txt",
              staticClass: "m-tree__error",
              attrs: { state: "warning", skin: "light" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("f-m-i18n")("m-tree:error")) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.propTreeEmpty
        ? _c("p", { ref: "empty-tree-txt", staticClass: "m-tree__empty" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("f-m-i18n")("m-tree:empty")) +
                "\n    "
            )
          ])
        : _c(
            "ul",
            { staticClass: "m-tree__content" },
            _vm._l(_vm.tree, function(node) {
              return _c("m-tree-node", {
                key: node.id,
                ref: "tree-node",
                refInFor: true,
                class: { "m--is-single": _vm.isSingleNodeTree },
                attrs: {
                  selectable: _vm.selectable,
                  open: node.open,
                  node: node,
                  "selected-nodes": _vm.propSelectedNodes,
                  "disabled-nodes": _vm.disabledNodes,
                  readonly: _vm.isReadonly,
                  checkboxes: _vm.checkboxes,
                  "use-files-icons": _vm.useFilesIcons
                },
                on: {
                  "update:open": function($event) {
                    return _vm.$set(node, "open", $event)
                  },
                  click: _vm.onClick
                }
              })
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-7418f0e9'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/tree/tree.ts":
/*!*************************************!*\
  !*** ./src/components/tree/tree.ts ***!
  \*************************************/
/*! exports provided: MSelectionMode, MCheckboxes, MTree, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSelectionMode", function() { return MSelectionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCheckboxes", function() { return MCheckboxes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTree", function() { return MTree; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _message_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../message/message */ "./src/components/message/message.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./component-names */ "./src/components/tree/component-names.ts");
/* harmony import */ var _tree_node_tree_node__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./tree-node/tree-node */ "./src/components/tree/tree-node/tree-node.ts");
/* harmony import */ var _tree_html_style_tree_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./tree.html?style=./tree.scss */ "./src/components/tree/tree.html?style=./tree.scss");
/* harmony import */ var _tree_html_style_tree_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_tree_html_style_tree_scss__WEBPACK_IMPORTED_MODULE_10__);
var _a, _b;











var MSelectionMode;
(function (MSelectionMode) {
    MSelectionMode["None"] = "none";
    MSelectionMode["Single"] = "single";
    MSelectionMode["Multiple"] = "multiple";
    MSelectionMode["Readonly"] = "readonly";
})(MSelectionMode || (MSelectionMode = {}));
var MCheckboxes;
(function (MCheckboxes) {
    MCheckboxes["True"] = "true";
    MCheckboxes["False"] = "false";
    MCheckboxes["WithButtonAutoSelect"] = "with-button-auto-select";
    MCheckboxes["WithCheckboxAutoSelect"] = "with-checkbox-auto-select";
    MCheckboxes["WithParentAutoSelect"] = "with-parent-auto-select"; // Children can be selected by parent & children can unselect parent
})(MCheckboxes || (MCheckboxes = {}));
var MTree = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTree, _super);
    function MTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.propSelectedNodes = _this.selectedNodes || [];
        _this.errorTree = false;
        _this.selectedNodesFound = [];
        return _this;
    }
    MTree.prototype.onClick = function (path) {
        if (!this.pathIsDisabled(path)) {
            if (this.propSelectedNodes.indexOf(path) === -1) {
                if (this.selectionMode === MSelectionMode.Multiple) {
                    this.propSelectedNodes.push(path);
                }
                else {
                    this.propSelectedNodes = [path];
                }
            }
            else if (this.selectionMode === MSelectionMode.Multiple) {
                this.propSelectedNodes.splice(this.propSelectedNodes.indexOf(path), 1);
            }
        }
        return path;
    };
    MTree.prototype.created = function () {
        this.browseTree();
    };
    MTree.prototype.browseTree = function () {
        var _this = this;
        this.errorTree = false;
        this.tree.forEach(function (node) {
            _this.browseNode(node);
        });
        this.propSelectedNodes.forEach(function (selectedNode) {
            if (_this.selectedNodesFound.indexOf(selectedNode) === -1) {
                console.error("modUL - The selected node was not found: \"" + selectedNode + "\"");
            }
        });
    };
    MTree.prototype.pathIsDisabled = function (path) {
        return this.propDisabledNodes.indexOf(path) !== -1;
    };
    MTree.prototype.browseNode = function (node, path) {
        var _this = this;
        if (path === void 0) { path = ''; }
        if (node.id.trim() === '') {
            this.errorTree = true;
        }
        var currentPath = path + '/' + node.id;
        if (this.propSelectedNodes.indexOf(currentPath) !== -1) {
            this.selectedNodesFound.push(currentPath);
        }
        if (node.children) {
            node.children.forEach(function (childNode) {
                _this.browseNode(childNode, currentPath);
            });
        }
    };
    Object.defineProperty(MTree.prototype, "propTreeEmpty", {
        get: function () {
            return !this.tree.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "propDisabledNodes", {
        get: function () {
            return this.disabledNodes || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "selectable", {
        get: function () {
            return this.selectionMode !== MSelectionMode.None && !this.isReadonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "isReadonly", {
        get: function () {
            return this.selectionMode === MSelectionMode.Readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "isMultipleSelectWithCheckboxes", {
        get: function () {
            return this.selectionMode === MSelectionMode.Multiple && this.withCheckboxes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "withCheckboxes", {
        get: function () {
            return this.checkboxes !== MCheckboxes.False;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTree.prototype, "isSingleNodeTree", {
        get: function () {
            return this.tree.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTree.prototype, "tree", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MSelectionMode.Single,
            validator: function (value) {
                return value === MSelectionMode.None ||
                    value === MSelectionMode.Single ||
                    value === MSelectionMode.Multiple ||
                    value === MSelectionMode.Readonly;
            }
        })
    ], MTree.prototype, "selectionMode", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: MCheckboxes.False,
            validator: function (value) {
                return value === MCheckboxes.False ||
                    value === MCheckboxes.True ||
                    value === MCheckboxes.WithButtonAutoSelect ||
                    value === MCheckboxes.WithCheckboxAutoSelect ||
                    value === MCheckboxes.WithParentAutoSelect;
            }
        })
    ], MTree.prototype, "checkboxes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTree.prototype, "selectedNodes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTree.prototype, "useFilesIcons", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTree.prototype, "disabledNodes", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('select')
    ], MTree.prototype, "onClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('tree')
    ], MTree.prototype, "browseTree", null);
    MTree = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _tree_html_style_tree_scss__WEBPACK_IMPORTED_MODULE_10___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_8__["TREE_NODE_NAME"]] = _tree_node_tree_node__WEBPACK_IMPORTED_MODULE_9__["MTreeNode"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_6__["MESSAGE_NAME"]] = _message_message__WEBPACK_IMPORTED_MODULE_7__["MMessage"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b)
        })
    ], MTree);
    return MTree;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));

var TreePlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_6__["TREE_NAME"], MTree);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TreePlugin);


/***/ }),

/***/ "./src/components/typeahead/typeahead.html?style=./typeahead.scss":
/*!************************************************************************!*\
  !*** ./src/components/typeahead/typeahead.html?style=./typeahead.scss ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=eebd53ce!./typeahead.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=eebd53ce!./src/components/typeahead/typeahead.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "m-typeahead",
      class: {
        "m--is-results-window-open": _vm.isResultsPopupOpen,
        "m--is-disabled": _vm.isDisabled,
        "m--is-waiting": _vm.isWaiting
      },
      style: { width: _vm.inputWidth, maxWidth: _vm.inputMaxWidth }
    },
    [
      _c("m-base-select", {
        ref: "mBaseSelect",
        attrs: {
          "control-id": _vm.id,
          active: _vm.active,
          items: _vm.filteredResults,
          open: _vm.isResultsPopupOpen,
          "input-max-width": _vm.inputMaxWidth,
          "sidebar-full-height": true,
          "enable-animation": false
        },
        on: {
          "update:open": function($event) {
            _vm.isResultsPopupOpen = $event
          },
          "select-item": _vm.onSelect
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(scope) {
                return [
                  _c("m-textfield", {
                    ref: "mTextfield",
                    attrs: {
                      value: _vm.textfieldValue,
                      label: _vm.label,
                      placeholder: _vm.placeholder,
                      disabled: _vm.isDisabled,
                      waiting: _vm.isWaiting,
                      focus: _vm.focus,
                      error: _vm.hasError,
                      valid: _vm.isValid,
                      "required-marker": _vm.requiredMarker,
                      "tag-style": _vm.tagStyle,
                      "cursor-pointer": true,
                      "max-length": _vm.maxLength,
                      "length-overflow": _vm.lengthOverflow,
                      "character-count": _vm.characterCount,
                      "character-count-threshold": _vm.characterCountThreshold,
                      "max-width": _vm.inputMaxWidth,
                      "aria-controls": _vm.ariaControls,
                      "aria-haspopup": "true",
                      "aria-expanded": scope.open
                    },
                    on: {
                      input: _vm.onInput,
                      keydown: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.onKeydownUp($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.onKeydownDown($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.onKeydownEnter($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "return",
                              undefined,
                              $event.key,
                              undefined
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.onKeydownEnter($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          return _vm.onKeydownEsc($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          ) {
                            return null
                          }
                          return _vm.onKeydownTab($event)
                        },
                        _vm.onKeydown
                      ],
                      keyup: _vm.onKeyup,
                      focus: _vm.onFocus,
                      blur: _vm.onBlur,
                      paste: _vm.onPaste
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "suffix",
                          fn: function() {
                            return [
                              _vm.waitingResults
                                ? _c(
                                    "div",
                                    [
                                      _c("m-spinner", {
                                        staticClass: "m-input-style__spinner",
                                        attrs: { size: "small" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                ]
              }
            },
            {
              key: "validation-message",
              fn: function() {
                return [
                  _c("m-validation-message", {
                    staticClass: "m-typeahead__validation-message",
                    class: {
                      "m--has-validation-message": _vm.hasValidationMessage
                    },
                    attrs: {
                      disabled: _vm.isDisabled,
                      waiting: _vm.isWaiting,
                      error: _vm.hasError,
                      valid: _vm.isValid,
                      "error-message": _vm.errorMessage,
                      "valid-message": _vm.validMessage,
                      "helper-message": _vm.helperMessage
                    }
                  })
                ]
              },
              proxy: true
            },
            _vm.isMqMaxS
              ? {
                  key: "popup-header",
                  fn: function(scope) {
                    return [
                      _vm.label
                        ? _c(
                            "h2",
                            { staticClass: "m-typeahead__label-popup" },
                            [_vm._v(_vm._s(_vm.label))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "m-typeahead__research-popup" },
                        [
                          _c("input", {
                            ref: "researchInput",
                            staticClass: "m-typeahead__research-input-popup",
                            attrs: {
                              type: "text",
                              placeholder: _vm._f("f-m-i18n")(
                                _vm.placeholder || "m-typeahead:search"
                              ),
                              "max-length": _vm.maxLength,
                              "aria-controls": _vm.ariaControls
                            },
                            domProps: { value: _vm.textfieldValue },
                            on: {
                              input: function($event) {
                                return _vm.onInput($event.target.value)
                              },
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "up",
                                      38,
                                      $event.key,
                                      ["Up", "ArrowUp"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.onKeydownUp($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "down",
                                      40,
                                      $event.key,
                                      ["Down", "ArrowDown"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.onKeydownDown($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.onKeydownEnter($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "return",
                                      undefined,
                                      $event.key,
                                      undefined
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.onKeydownEnter($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.onKeydownEsc($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "tab",
                                      9,
                                      $event.key,
                                      "Tab"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.onKeydownTab($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "m-icon-button",
                            {
                              staticClass: "m-typeahead__research-button-popup",
                              attrs: { "icon-name": "m-svg__search" },
                              on: { click: _vm.focusOnResearchInput }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("f-m-i18n")("m-typeahead:research")
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              : null,
            {
              key: "items",
              fn: function(ref) {
                var item = ref.item
                var index = ref.index
                return [
                  _vm._t(
                    "items",
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.getTextHighlight(item))
                        }
                      })
                    ],
                    {
                      item: item,
                      index: index,
                      highlight: _vm.getTextHighlight(item)
                    }
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-eebd53ce'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/typeahead/typeahead.ts":
/*!***********************************************!*\
  !*** ./src/components/typeahead/typeahead.ts ***!
  \***********************************************/
/*! exports provided: MTypeahead, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTypeahead", function() { return MTypeahead; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _filters_filter_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../filters/filter-names */ "./src/filters/filter-names.ts");
/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony import */ var _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/input-label/input-label */ "./src/mixins/input-label/input-label.ts");
/* harmony import */ var _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/input-management/input-management */ "./src/mixins/input-management/input-management.ts");
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/input-width/input-width */ "./src/mixins/input-width/input-width.ts");
/* harmony import */ var _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixins/media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony import */ var _select_base_select_base_select__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../select/base-select/base-select */ "./src/components/select/base-select/base-select.ts");
/* harmony import */ var _textfield_textfield__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../textfield/textfield */ "./src/components/textfield/textfield.ts");
/* harmony import */ var _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony import */ var _typeahead_html_style_typeahead_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./typeahead.html?style=./typeahead.scss */ "./src/components/typeahead/typeahead.html?style=./typeahead.scss");
/* harmony import */ var _typeahead_html_style_typeahead_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_typeahead_html_style_typeahead_scss__WEBPACK_IMPORTED_MODULE_17__);
var _a, _b;


















var MTypeahead = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MTypeahead, _super);
    function MTypeahead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = _component_names__WEBPACK_IMPORTED_MODULE_12__["TYPEAHEAD_NAME"] + "-" + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_10__["default"].generate();
        _this.isResultsPopupOpen = false;
        _this.textfieldValue = '';
        _this.filteredResults = [];
        _this.ariaControls = _this.id + '-controls';
        _this.throttleTimeoutActive = false;
        return _this;
    }
    MTypeahead.prototype.emitInput = function (event) { };
    MTypeahead.prototype.emitFilterResults = function () { };
    MTypeahead.prototype.onValueChange = function (newValue) {
        this.textfieldValue = newValue;
    };
    MTypeahead.prototype.onResultsChange = function () {
        this.onFilterResults();
    };
    MTypeahead.prototype.onFocusChanged = function (newValue) {
        if (newValue) {
            this.openResultsPopup();
            this.onFilterResults();
        }
    };
    MTypeahead.prototype.onBaseSelectOpen = function (newValue) {
        var _this = this;
        if (newValue && this.as().isMqMaxS) {
            setTimeout(function () {
                _this.$refs.researchInput.focus();
            });
        }
    };
    Object.defineProperty(MTypeahead.prototype, "hasResults", {
        get: function () {
            return this.results && this.results.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTypeahead.prototype, "hasFilteredResults", {
        get: function () {
            return this.filteredResults && this.filteredResults.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTypeahead.prototype, "hasTextfieldValue", {
        get: function () {
            return this.textfieldValue.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTypeahead.prototype, "resultsCouldBeDisplay", {
        get: function () {
            return this.hasFilteredResults && this.hasTextfieldValue && this.as().active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTypeahead.prototype, "hasSomeAResultSelected", {
        get: function () {
            var _this = this;
            return this.filteredResults.some(function (e, index) { return _this.isSelected(index); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MTypeahead.prototype, "sortedResult", {
        get: function () {
            return this.results.sort();
        },
        enumerable: true,
        configurable: true
    });
    MTypeahead.prototype.openResultsPopup = function () {
        if (this.isResultsPopupOpen) {
            return;
        }
        this.isResultsPopupOpen = true;
    };
    MTypeahead.prototype.closeResultsPopup = function () {
        this.isResultsPopupOpen = false;
    };
    MTypeahead.prototype.onSelect = function (option, index) {
        this.textfieldValue = this.filteredResults[index];
        this.emitInput(this.textfieldValue);
    };
    MTypeahead.prototype.isSelected = function (index) {
        return this.isResultsPopupOpen && this.textfieldValue.indexOf(this.filteredResults[index]) > -1;
    };
    MTypeahead.prototype.focusOnResearchInput = function () {
        this.$refs.researchInput.focus();
    };
    MTypeahead.prototype.onFilterResults = function () {
        var _this = this;
        if (this.filterResultsManually) {
            this.filteredResults = this.results.slice(0, this.maxResults);
        }
        else {
            this.filteredResults = this.sortedResult
                .filter(function (r) {
                return _this.hasTextfieldValue
                    &&
                        r.toLowerCase().includes(_this.textfieldValue.toLowerCase());
            }).slice(0, this.maxResults);
        }
    };
    MTypeahead.prototype.getTextHighlight = function (item) {
        var regex = RegExp(this.textfieldValue, 'i');
        return item.replace(regex, '<b>$&</b>');
    };
    MTypeahead.prototype.onInput = function (event) {
        var _this = this;
        this.textfieldValue = event;
        this.emitInput(event);
        window.clearTimeout(this.throttleTimeout);
        this.throttleTimeoutActive = true;
        this.throttleTimeout = window.setTimeout(function () {
            _this.throttleTimeoutActive = false;
            _this.onFilterResults();
            if (_this.resultsCouldBeDisplay) {
                _this.$refs.mBaseSelect.setFocusedIndex(0);
            }
            if (!_this.isResultsPopupOpen) {
                _this.openResultsPopup();
            }
            _this.emitFilterResults();
        }, this.throttle);
    };
    MTypeahead.prototype.onKeydownEnter = function ($event) {
        if (this.resultsCouldBeDisplay && this.as().isMqMinS) {
            this.$refs.mBaseSelect.selectFocusedItem($event);
        }
        this.$refs.mBaseSelect.closePopup();
    };
    MTypeahead.prototype.onKeydownDown = function ($event) {
        if (this.resultsCouldBeDisplay) {
            this.$refs.mBaseSelect.onKeydownDown($event);
        }
    };
    MTypeahead.prototype.onKeydownUp = function ($event) {
        if (this.resultsCouldBeDisplay) {
            this.$refs.mBaseSelect.onKeydownUp($event);
        }
    };
    MTypeahead.prototype.onKeydownTab = function ($event) {
        if (this.resultsCouldBeDisplay) {
            this.$refs.mBaseSelect.onKeydownTab($event);
        }
    };
    MTypeahead.prototype.onKeydownEsc = function ($event) {
        if (this.resultsCouldBeDisplay) {
            this.$refs.mBaseSelect.onKeydownEsc($event);
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('input'),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            required: true
        })
    ], MTypeahead.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTypeahead.prototype, "results", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTypeahead.prototype, "waitingResults", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTypeahead.prototype, "filterResultsManually", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 200 })
    ], MTypeahead.prototype, "throttle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTypeahead.prototype, "maxLength", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MTypeahead.prototype, "lengthOverflow", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], MTypeahead.prototype, "characterCount", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 0 })
    ], MTypeahead.prototype, "characterCountThreshold", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: 20 })
    ], MTypeahead.prototype, "maxResults", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], MTypeahead.prototype, "emitInput", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('filter-results')
    ], MTypeahead.prototype, "emitFilterResults", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], MTypeahead.prototype, "onValueChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('results', { immediate: true })
    ], MTypeahead.prototype, "onResultsChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('internalIsFocus')
    ], MTypeahead.prototype, "onFocusChanged", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('isResultsPopupOpen')
    ], MTypeahead.prototype, "onBaseSelectOpen", null);
    MTypeahead = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _typeahead_html_style_typeahead_scss__WEBPACK_IMPORTED_MODULE_17___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {
                    MBaseSelect: _select_base_select_base_select__WEBPACK_IMPORTED_MODULE_14__["MBaseSelect"]
                },
                _a[_component_names__WEBPACK_IMPORTED_MODULE_12__["TEXTFIELD_NAME"]] = _textfield_textfield__WEBPACK_IMPORTED_MODULE_15__["MTextfield"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_12__["VALIDATION_MESSAGE_NAME"]] = _validation_message_validation_message__WEBPACK_IMPORTED_MODULE_16__["MValidationMessage"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_12__["ICON_BUTTON_NAME"]] = _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_13__["MIconButton"],
                _a),
            filters: (_b = {},
                _b[_filters_filter_names__WEBPACK_IMPORTED_MODULE_3__["I18N_NAME"]] = _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["i18nFilter"],
                _b),
            mixins: [
                _mixins_input_label_input_label__WEBPACK_IMPORTED_MODULE_5__["InputLabel"],
                _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_7__["InputState"],
                _mixins_input_width_input_width__WEBPACK_IMPORTED_MODULE_8__["InputWidth"],
                _mixins_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_9__["MediaQueries"],
                _mixins_input_management_input_management__WEBPACK_IMPORTED_MODULE_6__["InputManagement"]
            ]
        })
    ], MTypeahead);
    return MTypeahead;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_11__["ModulVue"]));

var TypeaheadPlugin = {
    install: function (v, options) {
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_12__["TYPEAHEAD_NAME"], MTypeahead);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TypeaheadPlugin);


/***/ }),

/***/ "./src/components/validation-message/validation-message.html?style=./validation-message.scss":
/*!***************************************************************************************************!*\
  !*** ./src/components/validation-message/validation-message.html?style=./validation-message.scss ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var styles = __webpack_require__(/*! ../../../../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=38d3076e!./validation-message.scss */ "../../node_modules/vue-template-loader/lib/scoped-style-loader.js?id=38d3076e!./src/components/validation-message/validation-message.scss")
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-validation-message", on: { click: _vm.onClick } },
    [
      _c("m-accordion-transition", { attrs: { disabled: !_vm.transition } }, [
        _vm.message
          ? _c(
              "p",
              { class: ["m-validation-message__" + _vm.classMessage] },
              [
                _c("m-icon", {
                  staticClass: "m-validation-message__icon",
                  attrs: {
                    name: _vm.iconName,
                    "svg-title": _vm.svgTitle,
                    size: "1em"
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "m-validation-message__text",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("m-accordion-transition", { attrs: { disabled: !_vm.transition } }, [
        _vm.hasHelperMessage
          ? _c("p", {
              staticClass: "m-validation-message__helper",
              domProps: { innerHTML: _vm._s(_vm.helperMessage) }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  options._scopeId = 'data-v-38d3076e'
  if (Object.keys(styles).length > 0) {
    if (!options.computed) options.computed = {}
    options.computed.$style = function () { return styles }
  }
  if (false) {}
  return _exports
}
var api = null
if (false) {}


/***/ }),

/***/ "./src/components/validation-message/validation-message.ts":
/*!*****************************************************************!*\
  !*** ./src/components/validation-message/validation-message.ts ***!
  \*****************************************************************/
/*! exports provided: MValidationMessage, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MValidationMessage", function() { return MValidationMessage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _component_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../component-names */ "./src/components/component-names.ts");
/* harmony import */ var _icon_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../icon/icon */ "./src/components/icon/icon.ts");
/* harmony import */ var _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony import */ var _validation_message_html_style_validation_message_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./validation-message.html?style=./validation-message.scss */ "./src/components/validation-message/validation-message.html?style=./validation-message.scss");
/* harmony import */ var _validation_message_html_style_validation_message_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_validation_message_html_style_validation_message_scss__WEBPACK_IMPORTED_MODULE_8__);
var _a;









var MValidationMessage = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MValidationMessage, _super);
    function MValidationMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.classMessage = '';
        return _this;
    }
    MValidationMessage.prototype.onClick = function (event) { };
    Object.defineProperty(MValidationMessage.prototype, "message", {
        get: function () {
            var message;
            if (this.as().hasErrorMessage && this.as().hasError) {
                this.classMessage = 'error';
                this.svgTitle = this.$i18n.translate('m-validation-message:title-error-icon');
                this.iconName = 'm-svg__error';
                message = this.as().errorMessage;
            }
            if (this.as().hasValidMessage && this.as().isValid) {
                this.classMessage = 'valid';
                this.svgTitle = this.$i18n.translate('m-validation-message:title-valid-icon');
                this.iconName = 'm-svg__confirmation';
                message = this.as().validMessage;
            }
            return message;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], MValidationMessage.prototype, "transition", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], MValidationMessage.prototype, "onClick", null);
    MValidationMessage = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        _validation_message_html_style_validation_message_scss__WEBPACK_IMPORTED_MODULE_8___default.a,
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            components: (_a = {},
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ICON_NAME"]] = _icon_icon__WEBPACK_IMPORTED_MODULE_6__["MIcon"],
                _a[_component_names__WEBPACK_IMPORTED_MODULE_5__["ACCORDION_TRANSITION_NAME"]] = _transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__["MAccordionTransition"],
                _a),
            mixins: [_mixins_input_state_input_state__WEBPACK_IMPORTED_MODULE_3__["InputState"]]
        })
    ], MValidationMessage);
    return MValidationMessage;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_4__["ModulVue"]));

var ValidationMessagePlugin = {
    install: function (v, options) {
        v.use(_icon_icon__WEBPACK_IMPORTED_MODULE_6__["default"]);
        v.use(_transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_7__["default"]);
        v.component(_component_names__WEBPACK_IMPORTED_MODULE_5__["VALIDATION_MESSAGE_NAME"], MValidationMessage);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ValidationMessagePlugin);


/***/ }),

/***/ "./src/directives/badge/badge.ts":
/*!***************************************!*\
  !*** ./src/directives/badge/badge.ts ***!
  \***************************************/
/*! exports provided: MBadgeState, MBadgeDirective, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MBadgeState", function() { return MBadgeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MBadgeDirective", function() { return MBadgeDirective; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");
var _a, _b;


// Icon state
var MBadgeState;
(function (MBadgeState) {
    MBadgeState["Completed"] = "completed";
    MBadgeState["Error"] = "error";
    MBadgeState["Warning"] = "warning";
})(MBadgeState || (MBadgeState = {}));
var ICON_COMPLETED = 'm-svg__completed-filled';
var ICON_ERROR = 'm-svg__error-filled';
var ICON_WARNING = 'm-svg__warning-filled';
var COLOR_COMPLETED = '#00c77f';
var COLOR_ERROR = '#e30513';
var COLOR_WARNING = '#ffc103';
var DEFAULT_ORIGIN = ['23.5', '23.5'];
var BADGE_SIZE_RATIO = 16 / 30;
var BADGE_ICON = (_a = {},
    _a[MBadgeState.Completed] = ICON_COMPLETED,
    _a[MBadgeState.Error] = ICON_ERROR,
    _a[MBadgeState.Warning] = ICON_WARNING,
    _a);
var BADGE_COLOR = (_b = {},
    _b[MBadgeState.Completed] = COLOR_COMPLETED,
    _b[MBadgeState.Error] = COLOR_ERROR,
    _b[MBadgeState.Warning] = COLOR_WARNING,
    _b);
var getBadgeOrigin = function (vnode) {
    var elTag = vnode.componentOptions.tag;
    var elID = '';
    if (elTag === 'm-icon') {
        elID = vnode.componentInstance.name;
    }
    else if (elTag === 'm-icon-file') {
        elID = vnode.componentInstance.spriteId;
    }
    var element = document.getElementById(elID);
    if (element && element.dataset && element.dataset.badgeOrigin) {
        return (document.getElementById(elID).dataset.badgeOrigin).split(',');
    }
    else {
        return DEFAULT_ORIGIN;
    }
};
var getBadgeOffset = function (binding) {
    return {
        x: binding.value.offsetX !== undefined ? parseInt(binding.value.offsetX, 10) : 0,
        y: binding.value.offsetY !== undefined ? parseInt(binding.value.offsetY, 10) : 0
    };
};
var getBadgePosition = function (element, binding, vnode) {
    var leftDistance;
    var topDistance;
    var badgeOrigin = getBadgeOrigin(vnode);
    var badgeOffset = getBadgeOffset(binding);
    var elSize = (vnode.componentOptions)['propsData']['size'] ? parseInt((vnode.componentOptions)['propsData']['size'], 10) : vnode.elm.clientWidth;
    var badgeSize = elSize * BADGE_SIZE_RATIO;
    var elLeftOrigin = Number(parseFloat(badgeOrigin[0].replace(/,/g, '.')).toFixed(2));
    var elTopOrigin = Number(parseFloat(badgeOrigin[1].replace(/,/g, '.')).toFixed(2));
    leftDistance = ((elLeftOrigin / 24) * elSize) - (badgeSize * 0.5) + badgeOffset.x;
    topDistance = ((elTopOrigin / 24) * elSize) - (badgeSize * (2 / 3)) + badgeOffset.y;
    return { size: badgeSize, leftDistance: leftDistance, topDistance: topDistance };
};
var buildBadge = function (element, binding, vnode) {
    element.style.overflow = 'visible';
    var badge = getBadgePosition(element, binding, vnode);
    var MyComponent = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
        render: function (createElement) {
            return createElement('m-icon', {
                props: {
                    name: BADGE_ICON[binding.value.state],
                    size: badge.size
                },
                attrs: {
                    x: badge.leftDistance,
                    y: badge.topDistance
                }
            });
        }
    });
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(function () {
        var component = new MyComponent().$mount();
        if (component.$el.style) {
            component.$el.style.color = BADGE_COLOR[binding.value.state];
        }
        element.appendChild(component.$el);
    });
};
var MBadgeDirective = {
    inserted: function (element, binding, vnode, oldVnode) {
        if (binding.value.state !== undefined && binding.value.state !== '') {
            buildBadge(element, binding, vnode);
        }
    },
    update: function (element, binding, vnode, oldVnode) {
        if (element
            && element.children
            && element.children[element.children.length - 1] !== undefined
            && element.children[element.children.length - 1].classList.contains('m-icon')) {
            element.removeChild(element.children[element.children.length - 1]);
        }
        if (binding.value.state !== undefined && binding.value.state !== '') {
            buildBadge(element, binding, vnode);
        }
    },
    unbind: function (element, binding, vnode, oldVnode) {
        if (element
            && element.children
            && element.children[element.children.length - 1] !== undefined) {
            element.removeChild(element.children[element.children.length - 1]);
        }
    }
};
var BadgePlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_1__["BADGE_NAME"], MBadgeDirective);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (BadgePlugin);


/***/ }),

/***/ "./src/directives/directive-names.ts":
/*!*******************************************!*\
  !*** ./src/directives/directive-names.ts ***!
  \*******************************************/
/*! exports provided: BADGE_NAME, DRAGGABLE_ALLOW_SCROLL_NAME, DRAGGABLE_NAME, DROPPABLE_GROUP_NAME, DROPPABLE_NAME, FILE_DROP_NAME, ABSTRACT_CONTROL_NAME, I18N_NAME, POPUP_NAME, REMOVE_USER_SELECT_NAME, SORTABLE_NAME, TEXTAREA_AUTO_HEIGHT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BADGE_NAME", function() { return BADGE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DRAGGABLE_ALLOW_SCROLL_NAME", function() { return DRAGGABLE_ALLOW_SCROLL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DRAGGABLE_NAME", function() { return DRAGGABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROPPABLE_GROUP_NAME", function() { return DROPPABLE_GROUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROPPABLE_NAME", function() { return DROPPABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_DROP_NAME", function() { return FILE_DROP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ABSTRACT_CONTROL_NAME", function() { return ABSTRACT_CONTROL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18N_NAME", function() { return I18N_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POPUP_NAME", function() { return POPUP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_USER_SELECT_NAME", function() { return REMOVE_USER_SELECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORTABLE_NAME", function() { return SORTABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXTAREA_AUTO_HEIGHT", function() { return TEXTAREA_AUTO_HEIGHT; });
var BADGE_NAME = 'm-badge';
var DRAGGABLE_ALLOW_SCROLL_NAME = 'm-draggable-allow-scroll';
var DRAGGABLE_NAME = 'm-draggable';
var DROPPABLE_GROUP_NAME = 'm-droppable-group';
var DROPPABLE_NAME = 'm-droppable';
var FILE_DROP_NAME = 'm-file-drop';
var ABSTRACT_CONTROL_NAME = 'm-control';
var I18N_NAME = 'm-i18n';
var POPUP_NAME = 'm-popup';
var REMOVE_USER_SELECT_NAME = 'm-remove-user-select';
var SORTABLE_NAME = 'm-sortable';
var TEXTAREA_AUTO_HEIGHT = 'm-textarea-auto-height';


/***/ }),

/***/ "./src/directives/directives-plugin.ts":
/*!*********************************************!*\
  !*** ./src/directives/directives-plugin.ts ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/logger/logger */ "./src/utils/logger/logger.ts");
/* harmony import */ var _badge_badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./badge/badge */ "./src/directives/badge/badge.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./i18n/i18n */ "./src/directives/i18n/i18n.ts");
/* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./popup/popup */ "./src/directives/popup/popup.ts");
/* harmony import */ var _textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./textarea-auto-height/textarea-auto-height */ "./src/directives/textarea-auto-height/textarea-auto-height.ts");






var DirectivesPlugin = {
    install: function (v, options) {
        if (!v.prototype.$log) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__["default"]);
        }
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_popup_popup__WEBPACK_IMPORTED_MODULE_4__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_5__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_i18n_i18n__WEBPACK_IMPORTED_MODULE_3__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_badge_badge__WEBPACK_IMPORTED_MODULE_2__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DirectivesPlugin);


/***/ }),

/***/ "./src/directives/domPlugin.ts":
/*!*************************************!*\
  !*** ./src/directives/domPlugin.ts ***!
  \*************************************/
/*! exports provided: MDOMPlugin, MElementDomPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDOMPlugin", function() { return MDOMPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MElementDomPlugin", function() { return MElementDomPlugin; });
var MDOMPlugin = /** @class */ (function () {
    function MDOMPlugin() {
    }
    MDOMPlugin.get = function (constructorFunction, element) {
        return element[constructorFunction.defaultMountPoint];
    };
    MDOMPlugin.getRecursive = function (constructorFunction, element) {
        var plugin;
        while (element && !plugin) {
            plugin = MDOMPlugin.get(constructorFunction, element);
            element = element.parentNode;
        }
        return plugin;
    };
    MDOMPlugin.attach = function (constructorFunction, element, options) {
        if (MDOMPlugin.get(constructorFunction, element)) {
            return MDOMPlugin.internalUpdate(constructorFunction, element, options);
        }
        else {
            return MDOMPlugin.internalAttach(constructorFunction, element, options);
        }
    };
    MDOMPlugin.detach = function (constructorFunction, element) {
        var plugin = MDOMPlugin.get(constructorFunction, element);
        if (plugin) {
            plugin.detach();
            delete element[constructorFunction.defaultMountPoint];
        }
    };
    MDOMPlugin.internalAttach = function (constructorFunction, element, options) {
        var plugin = element[constructorFunction.defaultMountPoint];
        if (plugin) {
            MDOMPlugin.detach(constructorFunction, element);
        }
        plugin = new constructorFunction(element, options);
        if (this.mountPlugin(plugin)) {
            element[constructorFunction.defaultMountPoint] = plugin;
            return plugin;
        }
        else {
            return new NullObjectDomPlugin(options);
        }
    };
    MDOMPlugin.internalUpdate = function (constructorFunction, element, options) {
        var plugin = element[constructorFunction.defaultMountPoint];
        if (plugin) {
            if (!this.refreshPlugin(plugin, options)) {
                MDOMPlugin.detach(constructorFunction, element);
                return new NullObjectDomPlugin(options);
            }
        }
        return plugin;
    };
    MDOMPlugin.mountPlugin = function (plugin) {
        var mounted = false;
        plugin.attach(this.getMountFunction(function () { return mounted = true; }));
        return mounted;
    };
    MDOMPlugin.refreshPlugin = function (plugin, options) {
        var updated = false;
        plugin.update(options, this.getMountFunction(function () { return updated = true; }));
        return updated;
    };
    MDOMPlugin.getMountFunction = function (onSuccess) {
        return function (callback) {
            callback();
            onSuccess();
        };
    };
    return MDOMPlugin;
}());

var NullObjectDomPlugin = /** @class */ (function () {
    function NullObjectDomPlugin(options) {
        this.options = options;
    }
    NullObjectDomPlugin.prototype.attach = function (mount) { };
    NullObjectDomPlugin.prototype.update = function (options, refresh) { };
    NullObjectDomPlugin.prototype.detach = function () { };
    NullObjectDomPlugin.prototype.addEventListener = function (eventName, listener) { };
    NullObjectDomPlugin.prototype.removeEventListener = function (eventName, listener) { };
    NullObjectDomPlugin.prototype.removeAllEvents = function () { };
    return NullObjectDomPlugin;
}());
var MElementDomPlugin = /** @class */ (function () {
    function MElementDomPlugin(element, options) {
        this.attachedEvents = new Map();
        this._element = element;
        this._options = options;
    }
    Object.defineProperty(MElementDomPlugin.prototype, "element", {
        get: function () { return this._element; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MElementDomPlugin.prototype, "options", {
        get: function () { return this._options; },
        enumerable: true,
        configurable: true
    });
    MElementDomPlugin.prototype.addEventListener = function (eventName, listener, useCapture) {
        var listeners = this.attachedEvents.get(eventName);
        if (!listeners) {
            this.attachedEvents.set(eventName, [listener]);
            this.element.addEventListener(eventName, listener, useCapture);
        }
        else {
            if (listeners.indexOf(listener) === -1) {
                listeners.push(listener);
                this.element.addEventListener(eventName, listener, useCapture);
            }
            this.attachedEvents.set(eventName, listeners);
        }
    };
    MElementDomPlugin.prototype.removeEventListener = function (eventName) {
        var _this = this;
        var listeners = this.attachedEvents.get(eventName);
        if (!listeners) {
            return;
        }
        listeners.forEach(function (listener) {
            _this.element.removeEventListener(eventName, listener);
        });
        this.attachedEvents.delete(eventName);
    };
    MElementDomPlugin.prototype.removeAllEvents = function () {
        var _this = this;
        this.attachedEvents
            .forEach(function (_listeners, eventName) { return _this.removeEventListener(eventName); });
    };
    return MElementDomPlugin;
}());



/***/ }),

/***/ "./src/directives/drag-and-drop/drag-and-drop-plugin.ts":
/*!**************************************************************!*\
  !*** ./src/directives/drag-and-drop/drag-and-drop-plugin.ts ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/polyfills/drag-and-drop.polyfill */ "./src/utils/polyfills/drag-and-drop.polyfill.ts");
/* harmony import */ var _draggable_draggable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./draggable/draggable */ "./src/directives/drag-and-drop/draggable/draggable.ts");
/* harmony import */ var _draggable_draggable_allow_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./draggable/draggable-allow-scroll */ "./src/directives/drag-and-drop/draggable/draggable-allow-scroll.ts");
/* harmony import */ var _droppable_droppable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./droppable/droppable */ "./src/directives/drag-and-drop/droppable/droppable.ts");
/* harmony import */ var _droppable_droppable_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./droppable/droppable-group */ "./src/directives/drag-and-drop/droppable/droppable-group.ts");





var DragAndDropPlugin = {
    install: function (v, options) {
        v.use(_draggable_draggable__WEBPACK_IMPORTED_MODULE_1__["default"]);
        v.use(_draggable_draggable_allow_scroll__WEBPACK_IMPORTED_MODULE_2__["default"]);
        v.use(_droppable_droppable__WEBPACK_IMPORTED_MODULE_3__["default"]);
        v.use(_droppable_droppable_group__WEBPACK_IMPORTED_MODULE_4__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DragAndDropPlugin);


/***/ }),

/***/ "./src/directives/drag-and-drop/draggable/draggable-allow-scroll.ts":
/*!**************************************************************************!*\
  !*** ./src/directives/drag-and-drop/draggable/draggable-allow-scroll.ts ***!
  \**************************************************************************/
/*! exports provided: MDraggableAllowScrollDirection, MDraggableAllowScroll, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDraggableAllowScrollDirection", function() { return MDraggableAllowScrollDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDraggableAllowScroll", function() { return MDraggableAllowScroll; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/mouse/mouse */ "./src/utils/mouse/mouse.ts");
/* harmony import */ var _utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/polyfills/drag-and-drop.polyfill */ "./src/utils/polyfills/drag-and-drop.polyfill.ts");
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../domPlugin */ "./src/directives/domPlugin.ts");
/* harmony import */ var _scroll_to_scroll_to_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../scroll-to/scroll-to-lib */ "./src/directives/scroll-to/scroll-to-lib.ts");






var MDraggableAllowScrollDirection;
(function (MDraggableAllowScrollDirection) {
    MDraggableAllowScrollDirection["Top"] = "top";
    MDraggableAllowScrollDirection["Bottom"] = "bottom";
})(MDraggableAllowScrollDirection || (MDraggableAllowScrollDirection = {}));
// Naive implementation for a single use case: allow autoscroll on a fixed element that appears at the absolute top of the viewport.
// Furthermore, the user must be dragging something for it to work.
var MDraggableAllowScroll = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDraggableAllowScroll, _super);
    function MDraggableAllowScroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDraggableAllowScroll.prototype.attach = function (mount) {
        var _this = this;
        if (_utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__["polyFillActive"].dragDrop) {
            return;
        }
        // This is cheesy but we only need to fix the scrolling behavior if the polyfill is not active.
        // The polyfill already includes a scroll behavior for mobile devices.  However, it doesn't allow to enable the scrolling behavior for desktops.
        this.cleanUpOptions();
        if (this.options.allowScroll) {
            mount(function () {
                _this.addEventListener('dragover', function (event) { return _this.handleScroll(event); });
            });
        }
    };
    MDraggableAllowScroll.prototype.update = function (options, refresh) {
        var _this = this;
        this.cleanUpOptions();
        if (this.options.allowScroll) {
            refresh(function () { return _this._options = options; });
        }
    };
    MDraggableAllowScroll.prototype.detach = function () {
        this.doCleanUp();
    };
    MDraggableAllowScroll.prototype.doCleanUp = function () {
        this.element.style.display = '';
        this.cancelScroll();
    };
    MDraggableAllowScroll.prototype.cleanUpOptions = function () {
        if (this._options === undefined) {
            this._options = { allowScroll: true, scrollDirection: MDraggableAllowScrollDirection.Top };
        }
        if (this._options.allowScroll === undefined) {
            this._options.allowScroll = true;
        }
        if (this._options.scrollDirection === undefined) {
            this._options.scrollDirection = MDraggableAllowScrollDirection.Top;
        }
    };
    MDraggableAllowScroll.prototype.handleScroll = function (event) {
        var _this = this;
        var watchMouseMove = function (event) {
            if ((!_this.shouldScroll(event) && _this.activeScroll) || MDraggableAllowScroll.currentDraggableScroll !== _this) {
                if (_this.activeScroll) {
                    _this.cancelScroll();
                }
                document.removeEventListener('dragover', watchMouseMove);
            }
            else if (!_this.activeScroll) {
                _this.activateScroll();
            }
        };
        if (this.shouldScroll(event) && window.getComputedStyle(this.element).position === 'fixed') {
            if (MDraggableAllowScroll.currentDraggableScroll && MDraggableAllowScroll.currentDraggableScroll !== this) {
                MDraggableAllowScroll.currentDraggableScroll.doCleanUp();
                MDraggableAllowScroll.currentDraggableScroll = undefined;
                return;
            }
            MDraggableAllowScroll.currentDraggableScroll = this;
            document.addEventListener('dragover', watchMouseMove);
        }
    };
    MDraggableAllowScroll.prototype.shouldScroll = function (event) {
        var scrollThreshold = this.element.offsetHeight;
        switch (this.options.scrollDirection) {
            case MDraggableAllowScrollDirection.Top: return event.clientY < scrollThreshold;
            case MDraggableAllowScrollDirection.Bottom: return Object(_utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_1__["mousePositionElement"])(event, this.element).y >= this.element.offsetHeight - scrollThreshold;
            default: throw new Error("Unhandled value for scrollDirection: " + this.options.scrollDirection);
        }
    };
    MDraggableAllowScroll.prototype.activateScroll = function () {
        switch (this.options.scrollDirection) {
            case MDraggableAllowScrollDirection.Top:
                // tslint:disable-next-line: deprecation
                this.activeScroll = new _scroll_to_scroll_to_lib__WEBPACK_IMPORTED_MODULE_5__["ScrollTo"]().scrollToTop(document.documentElement, _scroll_to_scroll_to_lib__WEBPACK_IMPORTED_MODULE_5__["ScrollToDuration"].Slower);
                break;
            case MDraggableAllowScrollDirection.Bottom:
                // tslint:disable-next-line: deprecation
                this.activeScroll = new _scroll_to_scroll_to_lib__WEBPACK_IMPORTED_MODULE_5__["ScrollTo"]().scrollToBottom(document.documentElement, _scroll_to_scroll_to_lib__WEBPACK_IMPORTED_MODULE_5__["ScrollToDuration"].Slower);
                break;
            default: throw new Error("Unhandled value for scrollDirection: " + this.options.scrollDirection);
        }
    };
    MDraggableAllowScroll.prototype.cancelScroll = function () {
        if (this.activeScroll) {
            this.activeScroll.cancel();
            this.activeScroll = undefined;
            this.doCleanUp();
        }
    };
    MDraggableAllowScroll.defaultMountPoint = '__mdraggableallowscroll__';
    return MDraggableAllowScroll;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_4__["MElementDomPlugin"]));

var extractOptions = function (binding) {
    return {
        allowScroll: binding.value,
        scrollDirection: binding.arg
    };
};
var Directive = {
    inserted: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(MDraggableAllowScroll, element, extractOptions(binding));
    },
    update: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(MDraggableAllowScroll, element, extractOptions(binding));
    },
    unbind: function (element) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(MDraggableAllowScroll, element);
    }
};
var DraggableAllowScrollPlugin = {
    install: function (v) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_3__["DRAGGABLE_ALLOW_SCROLL_NAME"], Directive);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DraggableAllowScrollPlugin);


/***/ }),

/***/ "./src/directives/drag-and-drop/draggable/draggable.scss":
/*!***************************************************************!*\
  !*** ./src/directives/drag-and-drop/draggable/draggable.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/directives/drag-and-drop/draggable/draggable.ts":
/*!*************************************************************!*\
  !*** ./src/directives/drag-and-drop/draggable/draggable.ts ***!
  \*************************************************************/
/*! exports provided: MDraggableClassNames, MDraggableEventNames, MDraggable, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDraggableClassNames", function() { return MDraggableClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDraggableEventNames", function() { return MDraggableEventNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDraggable", function() { return MDraggable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_event_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/event/event */ "./src/utils/event/event.ts");
/* harmony import */ var _utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/polyfills/drag-and-drop.polyfill */ "./src/utils/polyfills/drag-and-drop.polyfill.ts");
/* harmony import */ var _utils_selection_selection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/selection/selection */ "./src/utils/selection/selection.ts");
/* harmony import */ var _utils_vue_directive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/directive */ "./src/utils/vue/directive.ts");
/* harmony import */ var _utils_vue_events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../utils/vue/events */ "./src/utils/vue/events.ts");
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../domPlugin */ "./src/directives/domPlugin.ts");
/* harmony import */ var _sortable_sortable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../sortable/sortable */ "./src/directives/sortable/sortable.ts");
/* harmony import */ var _user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../user-select/remove-user-select */ "./src/directives/user-select/remove-user-select.ts");
/* harmony import */ var _droppable_droppable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../droppable/droppable */ "./src/directives/drag-and-drop/droppable/droppable.ts");
/* harmony import */ var _draggable_allow_scroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./draggable-allow-scroll */ "./src/directives/drag-and-drop/draggable/draggable-allow-scroll.ts");
/* harmony import */ var _draggable_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./draggable.scss */ "./src/directives/drag-and-drop/draggable/draggable.scss");
/* harmony import */ var _draggable_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_draggable_scss__WEBPACK_IMPORTED_MODULE_12__);













var MDraggableClassNames;
(function (MDraggableClassNames) {
    MDraggableClassNames["Draggable"] = "m--is-draggable";
    MDraggableClassNames["Dragging"] = "m--is-dragging";
    MDraggableClassNames["Grabbing"] = "m--is-grabbing";
    MDraggableClassNames["DragImage"] = "dragImage";
    MDraggableClassNames["DragHandle"] = "m-drag-handle";
    MDraggableClassNames["HasDragHandle"] = "m--has-drag-handle";
})(MDraggableClassNames || (MDraggableClassNames = {}));
var MDraggableEventNames;
(function (MDraggableEventNames) {
    MDraggableEventNames["OnDragStart"] = "draggable:dragstart";
    MDraggableEventNames["OnDragEnd"] = "draggable:dragend";
})(MDraggableEventNames || (MDraggableEventNames = {}));
var DEFAULT_ACTION = 'any';
var MDraggable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDraggable, _super);
    function MDraggable(element, options) {
        var _this = _super.call(this, element, options) || this;
        _this.grabEvents = ['mousedown', 'touchstart'];
        _this.cancelGrabEvents = ['mouseup', 'touchend', 'click', 'touchcancel'];
        _this.touchUpListener = _this.doCleanUp.bind(_this);
        _this.intputTouchUpListener = _this.turnDragOn.bind(_this);
        _this.grabDelay = undefined;
        _this.touchHasMoved = false;
        _this.isMouseInitiatedDrag = false;
        return _this;
    }
    MDraggable.prototype.doCleanUp = function () {
        this.destroyGrabBehavior();
        this.cleanupCssClasses();
        MDraggable.currentDraggable = undefined;
    };
    MDraggable.prototype.attach = function (mount) {
        var _this = this;
        this.attachDragImage();
        if (this.options.canDrag === undefined) {
            this.options.canDrag = true;
        }
        if (this.options.canDrag) {
            mount(function () {
                _this.doCleanUp();
                _this.element.classList.add(MDraggableClassNames.Draggable);
                _this.options.action = _this.options.action ? _this.options.action : DEFAULT_ACTION;
                _this.turnDragOn();
            });
        }
    };
    MDraggable.prototype.update = function (options, refresh) {
        var _this = this;
        if (options.canDrag === undefined) {
            options.canDrag = true;
        }
        this._options = options;
        if (this.options.canDrag) {
            refresh(function () {
                _this.options.action = _this.options.action ? _this.options.action : DEFAULT_ACTION;
                _this.attachDragImage();
            });
        }
    };
    MDraggable.prototype.detach = function () {
        this.element.draggable = false;
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].detach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_9__["MRemoveUserSelect"], this.element);
        this.element.classList.remove(MDraggableClassNames.Draggable);
        this.destroyGrabBehavior();
        this.cleanupCssClasses();
        this.removeAllEvents();
    };
    MDraggable.prototype.onDragStart = function (event) {
        // On some mobile devices dragStart will be triggered even though user has not moved / dragged yet.  We want to avoid that.
        if (_utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__["polyFillActive"].dragDrop && (!this.touchHasMoved && !this.isMouseInitiatedDrag)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
        }
        event.stopPropagation();
        this.doCleanUp();
        Object(_utils_selection_selection__WEBPACK_IMPORTED_MODULE_3__["clearUserSelection"])();
        MDraggable.currentDraggable = this;
        this.element.classList.add(MDraggableClassNames.Dragging);
        if (typeof this.options.dragData === 'object') {
            event.dataTransfer.setData('application/json', JSON.stringify(this.options.dragData));
        }
        else {
            event.dataTransfer.setData('text', this.options.dragData);
        }
        this.setEventDragImage(event);
        this.dispatchEvent(event, MDraggableEventNames.OnDragStart);
    };
    MDraggable.prototype.onDragEnd = function (event) {
        event.stopPropagation();
        this.doCleanUp();
        // Fix for IE / Edge.  clientX / clientY don't appear to be out of element on dragLeave.
        // We can't detect whether we're leaving de droppable for real therefore we have to force leave onDragEnd.
        if (_droppable_droppable__WEBPACK_IMPORTED_MODULE_10__["MDroppable"].currentHoverDroppable) {
            _droppable_droppable__WEBPACK_IMPORTED_MODULE_10__["MDroppable"].currentHoverDroppable.leaveDroppable(event);
        }
        if (_sortable_sortable__WEBPACK_IMPORTED_MODULE_8__["MSortable"].activeSortContainer) {
            _sortable_sortable__WEBPACK_IMPORTED_MODULE_8__["MSortable"].activeSortContainer.doCleanUp();
        }
        if (_sortable_sortable__WEBPACK_IMPORTED_MODULE_8__["MSortable"].fromSortContainer) {
            _sortable_sortable__WEBPACK_IMPORTED_MODULE_8__["MSortable"].fromSortContainer.doCleanUp();
        }
        if (_draggable_allow_scroll__WEBPACK_IMPORTED_MODULE_11__["MDraggableAllowScroll"].currentDraggableScroll) {
            _draggable_allow_scroll__WEBPACK_IMPORTED_MODULE_11__["MDraggableAllowScroll"].currentDraggableScroll.doCleanUp();
        }
        this.dispatchEvent(event, MDraggableEventNames.OnDragEnd);
        var dragImage = this.element.querySelector("." + MDraggableClassNames.DragImage);
        if (dragImage) {
            dragImage.hidden = true;
        }
    };
    MDraggable.prototype.setupGrabBehavior = function () {
        var _this = this;
        this.destroyGrabBehavior();
        if (this.draggableHasHandle(this.element)) {
            this.element.classList.add(MDraggableClassNames.HasDragHandle);
        }
        this.grabEvents.forEach(function (eventName) { return _this.removeEventListener(eventName); });
        this.grabEvents.forEach(function (eventName) { return _this.addEventListener(eventName, function (event) {
            if (Object(_utils_event_event__WEBPACK_IMPORTED_MODULE_1__["targetIsInput"])(_this.element, event) || (_this.draggableHasHandle(_this.element) && !_this.isHandleUsedToDrag(event))) {
                _this.turnDragOff();
                _this.cancelGrabEvents.forEach(function (eventName) { return document.addEventListener(eventName, _this.intputTouchUpListener); });
            }
            else if (_this.targetIsGrabbable(event)) {
                _this.cancelGrabEvents.forEach(function (eventName) { return document.addEventListener(eventName, _this.touchUpListener); });
                _this.grabDelay = window.setTimeout(function () {
                    if (!MDraggable.currentDraggable && _this.grabDelay) {
                        _this.element.classList.add(MDraggableClassNames.Grabbing);
                        _this.forceCursorRefresh();
                    }
                }, _utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__["polyFillActive"].dragDrop && !_this.isMouseInitiatedDrag ? _utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__["dragDropDelay"] : 0);
            }
        }); });
    };
    MDraggable.prototype.turnDragOn = function () {
        var _this = this;
        this.element.draggable = true;
        this.addEventListener('dragend', function (event) { return _this.onDragEnd(event); });
        this.addEventListener('dragstart', function (event) { return _this.onDragStart(event); });
        this.addEventListener('touchmove', function () { return _this.touchHasMoved = true; }, true); // here is it important to use capture on devices that supports mouse + touch events.
        this.addEventListener('mousedown', function () { _this.isMouseInitiatedDrag = true; }, true);
        this.setupGrabBehavior();
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].attach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_9__["MRemoveUserSelect"], this.element, true);
    };
    MDraggable.prototype.turnDragOff = function () {
        this.element.draggable = false;
        this.removeEventListener('dragend');
        this.removeEventListener('dragstart');
        this.removeEventListener('touchmove');
        this.removeEventListener('mousedown');
        this.destroyGrabBehavior();
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].detach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_9__["MRemoveUserSelect"], this.element);
    };
    MDraggable.prototype.targetIsGrabbable = function (event) {
        // We can't call event.preventDefault or event.stopPropagation here for the drag to be handled correctly on mobile devices.
        // So we make sure that the draggable affected by the dragEvent is the closest draggable parent of the event target.
        // We don't apply the "grabbing" style on mouse down when target correspond to a link or a button, it just looks weird.
        var draggable = _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].getRecursive(MDraggable, event.target);
        if (!draggable || draggable !== this) {
            return false;
        }
        var recursiveElement = event.target;
        var noGrabTags = ['A', 'BUTTON'];
        var targetGrabbable = true;
        while (recursiveElement && targetGrabbable && recursiveElement !== draggable.element) {
            if (noGrabTags.find(function (tag) { return tag === recursiveElement.tagName; })) {
                targetGrabbable = false;
            }
            recursiveElement = recursiveElement.parentElement;
        }
        return targetGrabbable;
    };
    MDraggable.prototype.destroyGrabBehavior = function () {
        var _this = this;
        this.touchHasMoved = false;
        this.isMouseInitiatedDrag = false;
        this.forceCursorRefresh();
        if (this.grabDelay) {
            window.clearTimeout(this.grabDelay);
            this.grabDelay = undefined;
        }
        this.cancelGrabEvents.forEach(function (eventName) { return document.removeEventListener(eventName, _this.touchUpListener); });
        this.cancelGrabEvents.forEach(function (eventName) { return document.removeEventListener(eventName, _this.intputTouchUpListener); });
    };
    MDraggable.prototype.forceCursorRefresh = function () {
        // Hack to force cursor refresh.
        this.element.style.webkitUserDrag = 'none';
        this.element.style.webkitUserDrag = '';
    };
    MDraggable.prototype.attachDragImage = function () {
        var dragImage = this.element.querySelector("." + MDraggableClassNames.DragImage);
        // We use this property to know if the dragImage was handled or not.
        var dragImagePluginName = '__mdraggableimage__';
        if (dragImage && !dragImage[dragImagePluginName]) {
            var offsetWidth = dragImage.offsetWidth;
            requestAnimationFrame(function () {
                var origin = -9999;
                dragImage.style.left = origin + "px";
                dragImage.style.top = origin + "px";
                dragImage.style.position = 'absolute';
                dragImage.style.overflow = 'hidden';
                dragImage.style.zIndex = '1';
                dragImage.hidden = true;
                dragImage[dragImagePluginName] = true;
            });
        }
    };
    MDraggable.prototype.setEventDragImage = function (event) {
        var dragImage = this.element.querySelector("." + MDraggableClassNames.DragImage);
        if (dragImage && event.dataTransfer.setDragImage) {
            dragImage.hidden = false;
            if (_utils_polyfills_drag_and_drop_polyfill__WEBPACK_IMPORTED_MODULE_2__["polyFillActive"].dragDrop) {
                event.dataTransfer.setDragImage(dragImage, 0, 0);
            }
            else {
                event.dataTransfer.setDragImage(dragImage, this.calculateHorizontalCenterOffset(dragImage), this.calculateVerticalCenterOffset(dragImage));
            }
        }
    };
    MDraggable.prototype.calculateHorizontalCenterOffset = function (dragImage) {
        var dragImageWidth = window.getComputedStyle(dragImage).width;
        return dragImageWidth ? parseInt(dragImageWidth, 10) / 2 : 0;
    };
    MDraggable.prototype.calculateVerticalCenterOffset = function (dragImage) {
        var dragImageHeight = window.getComputedStyle(dragImage).height;
        return dragImageHeight ? parseInt(dragImageHeight, 10) / 2 : 0;
    };
    MDraggable.prototype.dispatchEvent = function (event, name) {
        var data = this.options.dragData ? this.options.dragData : event.dataTransfer.getData('text');
        var dragInfo = {
            action: this.options.action,
            grouping: this.options.grouping,
            data: data
        };
        var customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(name, true, true, Object.assign(event, { dragInfo: dragInfo }));
        customEvent.dragInfo = dragInfo;
        Object(_utils_vue_events__WEBPACK_IMPORTED_MODULE_5__["dispatchEvent"])(this.element, name, customEvent);
    };
    MDraggable.prototype.cleanupCssClasses = function () {
        this.element.classList.remove(MDraggableClassNames.Dragging);
        this.element.classList.remove(MDraggableClassNames.Grabbing);
        this.element.classList.remove(MDraggableClassNames.HasDragHandle);
    };
    MDraggable.prototype.draggableHasHandle = function (element) {
        return element.getElementsByClassName(MDraggableClassNames.DragHandle).length > 0;
    };
    MDraggable.prototype.isHandleUsedToDrag = function (event) {
        var dragHandle = this.element.querySelector('.' + MDraggableClassNames.DragHandle);
        if (dragHandle) {
            return dragHandle.classList.contains(MDraggableClassNames.DragHandle) && dragHandle.contains(event.target);
        }
        else {
            return false;
        }
    };
    MDraggable.defaultMountPoint = '__mdraggable__';
    return MDraggable;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_7__["MElementDomPlugin"]));

var extractVnodeAttributes = function (binding, node) {
    return {
        canDrag: binding.value,
        action: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_4__["getVNodeAttributeValue"])(node, 'action'),
        dragData: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_4__["getVNodeAttributeValue"])(node, 'drag-data'),
        grouping: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_4__["getVNodeAttributeValue"])(node, 'grouping')
    };
};
var Directive = {
    inserted: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].attach(MDraggable, element, extractVnodeAttributes(binding, node));
    },
    update: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].attach(MDraggable, element, extractVnodeAttributes(binding, node));
    },
    unbind: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_7__["MDOMPlugin"].detach(MDraggable, element);
    }
};
var DraggablePlugin = {
    install: function (v, options) {
        v.use(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_9__["default"]);
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_6__["DRAGGABLE_NAME"], Directive);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DraggablePlugin);


/***/ }),

/***/ "./src/directives/drag-and-drop/droppable/droppable-group.ts":
/*!*******************************************************************!*\
  !*** ./src/directives/drag-and-drop/droppable/droppable-group.ts ***!
  \*******************************************************************/
/*! exports provided: MDroppableGroup, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDroppableGroup", function() { return MDroppableGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../domPlugin */ "./src/directives/domPlugin.ts");



var MDroppableGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDroppableGroup, _super);
    function MDroppableGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDroppableGroup.prototype.attach = function (mount) {
        if (this.options) {
            mount(function () { });
        }
    };
    MDroppableGroup.prototype.update = function (options, refresh) {
        var _this = this;
        if (options) {
            refresh(function () { return _this._options = options; });
        }
    };
    MDroppableGroup.prototype.detach = function () { };
    MDroppableGroup.defaultMountPoint = '__mdroppablegroup__';
    return MDroppableGroup;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_2__["MElementDomPlugin"]));

var Directive = {
    bind: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].attach(MDroppableGroup, element, binding.value);
    },
    update: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].attach(MDroppableGroup, element, binding.value);
    },
    unbind: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].detach(MDroppableGroup, element);
    }
};
var DroppableGroupPlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_1__["DROPPABLE_GROUP_NAME"], Directive);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DroppableGroupPlugin);


/***/ }),

/***/ "./src/directives/drag-and-drop/droppable/droppable.scss":
/*!***************************************************************!*\
  !*** ./src/directives/drag-and-drop/droppable/droppable.scss ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/directives/drag-and-drop/droppable/droppable.ts":
/*!*************************************************************!*\
  !*** ./src/directives/drag-and-drop/droppable/droppable.ts ***!
  \*************************************************************/
/*! exports provided: MDroppableClassNames, MDropEffect, MDroppableEventNames, MDroppable, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDroppableClassNames", function() { return MDroppableClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDropEffect", function() { return MDropEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDroppableEventNames", function() { return MDroppableEventNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDroppable", function() { return MDroppable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_event_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../utils/event/event */ "./src/utils/event/event.ts");
/* harmony import */ var _utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/mouse/mouse */ "./src/utils/mouse/mouse.ts");
/* harmony import */ var _utils_vue_directive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/vue/directive */ "./src/utils/vue/directive.ts");
/* harmony import */ var _utils_vue_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/vue/events */ "./src/utils/vue/events.ts");
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../domPlugin */ "./src/directives/domPlugin.ts");
/* harmony import */ var _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../sortable/sortable */ "./src/directives/sortable/sortable.ts");
/* harmony import */ var _user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../user-select/remove-user-select */ "./src/directives/user-select/remove-user-select.ts");
/* harmony import */ var _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../draggable/draggable */ "./src/directives/drag-and-drop/draggable/draggable.ts");
/* harmony import */ var _droppable_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./droppable.scss */ "./src/directives/drag-and-drop/droppable/droppable.scss");
/* harmony import */ var _droppable_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_droppable_scss__WEBPACK_IMPORTED_MODULE_10__);











var MDroppableClassNames;
(function (MDroppableClassNames) {
    MDroppableClassNames["Droppable"] = "m--is-droppable";
    MDroppableClassNames["Overing"] = "m--is-dragover";
    MDroppableClassNames["CanDrop"] = "m--can-drop";
    MDroppableClassNames["CantDrop"] = "m--cant-drop";
})(MDroppableClassNames || (MDroppableClassNames = {}));
var MDropEffect;
(function (MDropEffect) {
    MDropEffect["MMove"] = "move";
    MDropEffect["MNone"] = "none";
})(MDropEffect || (MDropEffect = {}));
var MDroppableEventNames;
(function (MDroppableEventNames) {
    MDroppableEventNames["OnDrop"] = "droppable:drop";
    MDroppableEventNames["OnDragEnter"] = "droppable:dragenter";
    MDroppableEventNames["OnDragLeave"] = "droppable:dragleave";
    MDroppableEventNames["OnDragOver"] = "droppable:dragover";
})(MDroppableEventNames || (MDroppableEventNames = {}));
var DEFAULT_ACTION = 'any';
var MDroppable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MDroppable, _super);
    function MDroppable(element, options) {
        var _this = _super.call(this, element, options) || this;
        _this.grabEvents = ['mousedown', 'touchstart'];
        _this.cancelGrabEvents = ['mouseup', 'touchend', 'click', 'touchcancel'];
        _this.intputTouchUpListener = _this.turnDragOn.bind(_this);
        return _this;
    }
    MDroppable.prototype.attach = function (mount) {
        var _this = this;
        this.setOptions(this.options);
        if (this.options.canDrop) {
            mount(function () {
                _this.attachAll();
            });
        }
        else if (this.options.alwaysMount) {
            mount(function () {
                _this.element.classList.add(MDroppableClassNames.Droppable);
                _this.attachDragOverOnly();
            });
        }
    };
    MDroppable.prototype.update = function (options, refresh) {
        var _this = this;
        this.setOptions(this._options = options);
        if (this.options.canDrop) {
            refresh(function () { _this.element.classList.add(MDroppableClassNames.Droppable); });
        }
        else if (this.options.alwaysMount) {
            refresh(function () {
                _this.detach();
                _this.attachDragOverOnly();
            });
        }
    };
    MDroppable.prototype.detach = function () {
        var _this = this;
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].detach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["MRemoveUserSelect"], this.element);
        this.cleanupCssClasses();
        this.removeAllEvents();
        this.cancelGrabEvents.forEach(function (cancelEventName) { return document.removeEventListener(cancelEventName, _this.intputTouchUpListener); });
        this.element.classList.remove(MDroppableClassNames.Droppable);
    };
    MDroppable.prototype.cleanupCssClasses = function () {
        this.element.classList.remove(MDroppableClassNames.Overing);
        this.element.classList.remove(MDroppableClassNames.CanDrop);
        this.element.classList.remove(MDroppableClassNames.CantDrop);
    };
    MDroppable.prototype.leaveDroppable = function (event) {
        if (MDroppable.currentHoverDroppable === this) {
            MDroppable.previousHoverContainer = this;
            MDroppable.currentHoverDroppable = undefined;
        }
        this.cleanupCssClasses();
        this.dispatchEvent(event, MDroppableEventNames.OnDragLeave);
    };
    MDroppable.prototype.canDropTarget = function (event) {
        var canDropAttr = event && event.currentTarget && event.currentTarget.getAttribute('can-drop');
        var canDropValue = canDropAttr === 'false' ? false : true;
        return canDropValue;
    };
    MDroppable.prototype.canDrop = function (draggable) {
        if (draggable === void 0) { draggable = _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable; }
        if (!draggable) {
            return false;
        }
        var canDrop = this.options.canDrop ? true : false;
        var acceptAny = this.options.acceptedActions.find(function (action) { return action === 'any'; }) !== undefined;
        var draggableAction = draggable.options.action;
        var isAllowedAction = this.options.acceptedActions.find(function (action) { return action === draggableAction; }) !== undefined;
        return canDrop && !this.isHoveringOverDraggedElementChild()
            && (acceptAny || isAllowedAction)
            && !this.isDropRestrictedByEncapsuledSortable();
    };
    MDroppable.prototype.attachAll = function () {
        var _this = this;
        this.element.classList.add(MDroppableClassNames.Droppable);
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["MRemoveUserSelect"], this.element, true);
        this.addEventListener('dragenter', function (event) { return _this.onDragEnter(event); });
        this.addEventListener('dragleave', function (event) { return _this.onDragLeave(event); });
        // Firefox doesn't handle dragLeave correctly.  We have to declare dragexit AND dragleave for that reason.
        this.addEventListener('dragexit', function (event) { return _this.onDragLeave(event); });
        this.addEventListener('dragover', function (event) { return _this.onDragOver(event); });
        this.addEventListener('drop', function (event) { return _this.onDrop(event); });
        this.allowInputTextSelection();
    };
    MDroppable.prototype.attachDragOverOnly = function () {
        var _this = this;
        this.element.classList.add(MDroppableClassNames.Droppable);
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["MRemoveUserSelect"], this.element, true);
        this.addEventListener('dragover', function (event) { return _this.onDragOver(event); });
        this.allowInputTextSelection();
    };
    MDroppable.prototype.isDropRestrictedByEncapsuledSortable = function () {
        var activeSortContainer = _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortable"].activeSortContainer || _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].getRecursive(_sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortable"], this.element);
        if ((activeSortContainer && _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortable"].fromSortContainer)
            && activeSortContainer !== _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortable"].fromSortContainer
            && (activeSortContainer.options.encapsulate || _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortable"].fromSortContainer.options.encapsulate)) {
            return true;
        }
        return false;
    };
    MDroppable.prototype.setOptions = function (value) {
        if (value.canDrop === undefined) {
            value.canDrop = true;
        }
        this._options = value;
        this._options.acceptedActions = this.options.canDrop ? this.options.acceptedActions || [DEFAULT_ACTION] : [];
    };
    MDroppable.prototype.onDragLeave = function (event) {
        var leftFor = event.relatedTarget;
        if (leftFor && leftFor !== this.element && leftFor.contains(this.element)) {
            this.leaveDroppable(event);
        }
        else if (!leftFor && this.isLeavingDroppable(event, this)) {
            this.leaveDroppable(event);
        }
    };
    MDroppable.prototype.isLeavingDroppable = function (event, droppable) {
        if (!droppable) {
            return false;
        }
        return !Object(_utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_2__["isInElement"])(event, droppable.element) || MDroppable.previousHoverContainer !== MDroppable.currentHoverDroppable;
    };
    MDroppable.prototype.onDragEnter = function (event) {
        return this.onDragIn(event);
    };
    MDroppable.prototype.onDragOver = function (event) {
        return this.onDragIn(event);
    };
    MDroppable.prototype.onDragIn = function (event) {
        if (document.elementFromPoint) {
            var element = document.elementFromPoint(event.clientX, event.clientY);
            var droppable = _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].getRecursive(MDroppable, element);
            // Firefox sometime fires events on the wrong container for some reasons.  This fix it.
            if (droppable !== this) {
                this.cleanupCssClasses();
                return;
            }
        }
        var className;
        if (this.canDrop()) {
            event.preventDefault();
            event.dataTransfer.dropEffect = MDropEffect.MMove;
            className = MDroppableClassNames.CanDrop;
        }
        else {
            event.dataTransfer.dropEffect = MDropEffect.MNone;
            className = MDroppableClassNames.CantDrop;
        }
        MDroppable.previousHoverContainer = MDroppable.currentHoverDroppable;
        MDroppable.currentHoverDroppable = this;
        if (MDroppable.previousHoverContainer !== MDroppable.currentHoverDroppable || !this.element.classList.contains(className)) {
            this.cleanupCssClasses();
            this.element.classList.add(MDroppableClassNames.Overing);
            this.element.classList.add(className);
            this.dispatchEvent(event, MDroppableEventNames.OnDragEnter);
        }
        this.dispatchEvent(event, MDroppableEventNames.OnDragOver);
    };
    MDroppable.prototype.onDrop = function (event) {
        event.stopPropagation();
        // Important for firefox as it tries to open dropped content as URL by default.
        event.preventDefault();
        this.cleanupCssClasses();
        MDroppable.currentHoverDroppable = undefined;
        this.canDropTarget(event);
        this.dispatchEvent(event, MDroppableEventNames.OnDrop);
    };
    MDroppable.prototype.dispatchEvent = function (event, name) {
        var dropInfo = this.extractDropInfo(event);
        var customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(name, true, true, Object.assign(event, { dropInfo: dropInfo }));
        customEvent.dropInfo = dropInfo;
        Object(_utils_vue_events__WEBPACK_IMPORTED_MODULE_4__["dispatchEvent"])(this.element, name, customEvent);
    };
    MDroppable.prototype.extractDropInfo = function (event) {
        var data = _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable ? _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable.options.dragData || event.dataTransfer.getData('text') : undefined;
        var action = _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable ? _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable.options.action : DEFAULT_ACTION;
        var grouping = _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable ? _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable.options.grouping : undefined;
        return {
            action: action,
            grouping: action === _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortableAction"].MoveGroup || ![_sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortableAction"].MoveGroup, _sortable_sortable__WEBPACK_IMPORTED_MODULE_7__["MSortableAction"].Move].find(function (item) { return item === action; }) ? grouping : undefined,
            data: data,
            canDrop: this.canDrop()
        };
    };
    MDroppable.prototype.isHoveringOverDraggedElementChild = function () {
        if (!MDroppable.currentHoverDroppable || !_draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable) {
            return false;
        }
        var found = false;
        var element = MDroppable.currentHoverDroppable.element;
        while (!found && element) {
            if (element === _draggable_draggable__WEBPACK_IMPORTED_MODULE_9__["MDraggable"].currentDraggable.element) {
                found = true;
            }
            element = element.parentNode;
        }
        return found;
    };
    MDroppable.prototype.allowInputTextSelection = function () {
        var _this = this;
        this.grabEvents.forEach(function (eventName) {
            _this.addEventListener(eventName, function (event) {
                if (Object(_utils_event_event__WEBPACK_IMPORTED_MODULE_1__["targetIsInput"])(_this.element, event)) {
                    _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].detach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["MRemoveUserSelect"], _this.element);
                    _this.cancelGrabEvents.forEach(function (cancelEventName) { return document.addEventListener(cancelEventName, _this.intputTouchUpListener); });
                }
            });
        });
    };
    MDroppable.prototype.turnDragOn = function () {
        var _this = this;
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["MRemoveUserSelect"], this.element, true);
        this.cancelGrabEvents.forEach(function (cancelEventName) { return document.removeEventListener(cancelEventName, _this.intputTouchUpListener); });
    };
    MDroppable.defaultMountPoint = '__mdroppable__';
    return MDroppable;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_6__["MElementDomPlugin"]));

var extractVnodeAttributes = function (binding, node) {
    return {
        acceptedActions: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_3__["getVNodeAttributeValue"])(node, 'accepted-actions'),
        grouping: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_3__["getVNodeAttributeValue"])(node, 'grouping'),
        canDrop: binding.value
    };
};
var Directive = {
    inserted: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(MDroppable, element, extractVnodeAttributes(binding, node));
    },
    update: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(MDroppable, element, extractVnodeAttributes(binding, node));
    },
    componentUpdated: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].attach(MDroppable, element, extractVnodeAttributes(binding, node));
    },
    unbind: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_6__["MDOMPlugin"].detach(MDroppable, element);
    }
};
var DroppablePlugin = {
    install: function (v, options) {
        v.use(_user_select_remove_user_select__WEBPACK_IMPORTED_MODULE_8__["default"]);
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_5__["DROPPABLE_NAME"], Directive);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DroppablePlugin);


/***/ }),

/***/ "./src/directives/file-drop/file-drop.ts":
/*!***********************************************!*\
  !*** ./src/directives/file-drop/file-drop.ts ***!
  \***********************************************/
/*! exports provided: MFileDropDirective, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFileDropDirective", function() { return MFileDropDirective; });
/* harmony import */ var _utils_file_file__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/file/file */ "./src/utils/file/file.ts");
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");


var MFileDropDirective = {
    bind: function (el, binding, vnode, oldVnode) {
        var $file = vnode.context.$file;
        var onDragEnterOver = function (e) {
            el.classList.add('m--is-drag-over');
            e.stopPropagation();
            e.preventDefault();
        };
        var onDragLeave = function (e) {
            el.classList.remove('m--is-drag-over');
            e.stopPropagation();
            e.preventDefault();
        };
        var onDrop = function (e) {
            el.classList.remove('m--is-drag-over');
            e.preventDefault();
            $file.add(e.dataTransfer.files, binding.value ? binding.value : _utils_file_file__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_STORE_NAME"]);
        };
        var cleanup = function () {
            el.removeEventListener('dragenter', onDragEnterOver);
            el.removeEventListener('dragover', onDragEnterOver);
            el.removeEventListener('dragleave', onDragLeave);
            el.removeEventListener('drop', onDrop);
        };
        el.addEventListener('dragenter', onDragEnterOver);
        el.addEventListener('dragover', onDragEnterOver);
        el.addEventListener('dragleave', onDragLeave);
        el.addEventListener('drop', onDrop);
        el.cleanupMFileDropDirective = cleanup;
    },
    unbind: function (el, binding, vnode, oldVnode) {
        el.cleanupMFileDropDirective();
        var $file = vnode.context.$file;
        if (!binding.modifiers['keep-store']) {
            $file.destroy(binding.value ? binding.value : _utils_file_file__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_STORE_NAME"]);
        }
    }
};
var FileDropPlugin = {
    install: function (v, options) {
        v.use(_utils_file_file__WEBPACK_IMPORTED_MODULE_0__["default"]);
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_1__["FILE_DROP_NAME"], MFileDropDirective);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FileDropPlugin);


/***/ }),

/***/ "./src/directives/i18n/i18n.ts":
/*!*************************************!*\
  !*** ./src/directives/i18n/i18n.ts ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");


var I18nDirective = {
    bind: function (el, binding, vnode) {
        if (binding.arg) {
            if (vnode.componentInstance) {
                vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$log.warn("i18n Directive souldn't be used on a " + vnode.componentInstance.constructor.name + " component. Please use the filter instead.");
            }
            var expression = binding.expression;
            var modifiers = Object.getOwnPropertyNames(binding.modifiers);
            var options = binding.value || {};
            if (modifiers.length > 0) {
                expression = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$i18n.translate(modifiers[0], options.params, options.nb, options.modifier);
            }
            el.setAttribute(binding.arg, expression);
        }
    }
};
var I18nDirectivePlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_1__["I18N_NAME"], I18nDirective);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (I18nDirectivePlugin);


/***/ }),

/***/ "./src/directives/popup/popup.ts":
/*!***************************************!*\
  !*** ./src/directives/popup/popup.ts ***!
  \***************************************/
/*! exports provided: MPopupDirective, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MPopupDirective", function() { return MPopupDirective; });
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");

var MPopupDirective = {
    bind: function (element, binding, node) {
        if (node.context) {
            node.context.$nextTick(function () {
                if (node.context) {
                    node.context.$refs[binding.arg].triggerHook = element;
                }
            });
        }
    }
};
var PopupDirectivePlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_0__["POPUP_NAME"], MPopupDirective);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PopupDirectivePlugin);


/***/ }),

/***/ "./src/directives/scroll-to/scroll-to-lib.ts":
/*!***************************************************!*\
  !*** ./src/directives/scroll-to/scroll-to-lib.ts ***!
  \***************************************************/
/*! exports provided: ScrollToDuration, ScrollTo, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollToDuration", function() { return ScrollToDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollTo", function() { return ScrollTo; });
var ScrollToDuration;
(function (ScrollToDuration) {
    ScrollToDuration["Null"] = "null";
    ScrollToDuration["Slow"] = "slow";
    ScrollToDuration["Slower"] = "slower";
    ScrollToDuration["Regular"] = "regular";
    ScrollToDuration["Fast"] = "fast";
})(ScrollToDuration || (ScrollToDuration = {}));
/**
 * @deprecated use global service in /utils/scroll-to.
 */
var ScrollTo = /** @class */ (function () {
    function ScrollTo() {
    }
    // https://coderwall.com/p/hujlhg/smooth-scrolling-without-jquery
    ScrollTo.prototype.scrollToTop = function (element, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        return this.intertnalStartScroll(element, 0, duration);
    };
    ScrollTo.prototype.scrollToBottom = function (element, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        return this.intertnalStartScroll(element, element.offsetHeight, duration);
    };
    ScrollTo.prototype.startScroll = function (element, target, duration) {
        if (element === void 0) { element = document.body; }
        if (target === void 0) { target = 0; }
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        return this.intertnalStartScroll(element, target, duration).promise;
    };
    ScrollTo.prototype.intertnalStartScroll = function (element, target, duration) {
        if (element === void 0) { element = document.body; }
        if (target === void 0) { target = 0; }
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        target = Math.round(target);
        var time;
        var cancelled = false;
        var cancel = function () {
            cancelled = true;
            if (currentFrame) {
                cancelAnimationFrame(currentFrame);
                currentFrame = undefined;
            }
        };
        var currentFrame;
        switch (duration) {
            case ScrollToDuration.Null:
                time = 0;
                break;
            case ScrollToDuration.Slow:
                time = 1500;
                break;
            case ScrollToDuration.Slower:
                time = 3000;
                break;
            case ScrollToDuration.Fast:
                time = 400;
                break;
            default:
                time = 800;
        }
        if (time < 0) {
            return { promise: Promise.reject('bad duration'), cancel: function () { return cancel(); } };
        }
        if (time === 0) {
            element.scrollTop = target;
            return { promise: Promise.resolve(), cancel: function () { return cancel(); } };
        }
        var startTime = Date.now();
        var endTime = startTime + time;
        var startTop = window.pageYOffset;
        var distance = target - startTop;
        // based on http://en.wikipedia.org/wiki/Smoothstep
        var smoothStep = function (start, end, point) {
            if (point <= start) {
                return 0;
            }
            if (point >= end) {
                return 1;
            }
            var x = (point - start) / (end - start); // interpolation
            return x * x * (3 - 2 * x);
        };
        return {
            promise: new Promise(function (resolve, reject) {
                // This is to keep track of where the element's scrollTop is
                // supposed to be, based on what we're doing
                var previousTop = window.pageYOffset;
                // This is like a think function from a game loop
                var scrollFrame = function () {
                    if (window.pageYOffset !== previousTop || cancelled) {
                        resolve();
                        return;
                    }
                    // set the scrollTop for this frame
                    var now = Date.now();
                    var point = smoothStep(startTime, endTime, now);
                    var frameTop = Math.round(startTop + distance * point);
                    window.scrollTo(0, frameTop);
                    // check if we're done!
                    if (now >= endTime) {
                        resolve();
                        return;
                    }
                    // If we were supposed to scroll but didn't, then we
                    // probably hit the limit, so consider it done; not
                    // interrupted.
                    if (window.pageYOffset === previousTop &&
                        window.pageYOffset !== frameTop) {
                        resolve();
                        return;
                    }
                    previousTop = window.pageYOffset;
                    // schedule next frame for execution
                    currentFrame = requestAnimationFrame(scrollFrame);
                };
                // boostrap the animation process
                currentFrame = requestAnimationFrame(scrollFrame);
            }), cancel: function () { return cancel(); }
        };
    };
    return ScrollTo;
}());

// tslint:disable-next-line: deprecation
var ScrollToLib = new ScrollTo();
/* harmony default export */ __webpack_exports__["default"] = (ScrollToLib);


/***/ }),

/***/ "./src/directives/sortable/insertion-behavior.ts":
/*!*******************************************************!*\
  !*** ./src/directives/sortable/insertion-behavior.ts ***!
  \*******************************************************/
/*! exports provided: MSortableDefaultInsertionMarkerBehavior, MSortableGroupingInsertionMarkerBehavior */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortableDefaultInsertionMarkerBehavior", function() { return MSortableDefaultInsertionMarkerBehavior; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortableGroupingInsertionMarkerBehavior", function() { return MSortableGroupingInsertionMarkerBehavior; });
/* harmony import */ var _utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/mouse/mouse */ "./src/utils/mouse/mouse.ts");
/* harmony import */ var _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../drag-and-drop/droppable/droppable */ "./src/directives/drag-and-drop/droppable/droppable.ts");
/* harmony import */ var _sortable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sortable */ "./src/directives/sortable/sortable.ts");



var MSortableDefaultInsertionMarkerBehavior = /** @class */ (function () {
    function MSortableDefaultInsertionMarkerBehavior() {
    }
    MSortableDefaultInsertionMarkerBehavior.prototype.getInsertPosition = function (event) {
        if (_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable) {
            var mousePosition = Object(_utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_0__["mousePositionElement"])(event, _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable.element);
            if (mousePosition.y < _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable.element.offsetHeight / 2) {
                return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].Before;
            }
            else {
                return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].After;
            }
        }
        return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].After;
    };
    return MSortableDefaultInsertionMarkerBehavior;
}());

var MSortableGroupingInsertionMarkerBehavior = /** @class */ (function () {
    function MSortableGroupingInsertionMarkerBehavior() {
    }
    MSortableGroupingInsertionMarkerBehavior.prototype.getInsertPosition = function (event) {
        if (!_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable) {
            return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].After;
        }
        var mousePosition = Object(_utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_0__["mousePositionElement"])(event, _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable.element);
        if (mousePosition.y <= 10) {
            return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].Before;
        }
        if (mousePosition.y > _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_1__["MDroppable"].currentHoverDroppable.element.offsetHeight - 10) {
            return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].After;
        }
        return _sortable__WEBPACK_IMPORTED_MODULE_2__["MSortInsertPositions"].In;
    };
    return MSortableGroupingInsertionMarkerBehavior;
}());



/***/ }),

/***/ "./src/directives/sortable/sortable.scss":
/*!***********************************************!*\
  !*** ./src/directives/sortable/sortable.scss ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/directives/sortable/sortable.ts":
/*!*********************************************!*\
  !*** ./src/directives/sortable/sortable.ts ***!
  \*********************************************/
/*! exports provided: MSortableEventNames, MSortInsertPositions, MSortableClassNames, MSortableAction, MSortable, SortableDirective, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortableEventNames", function() { return MSortableEventNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortInsertPositions", function() { return MSortInsertPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortableClassNames", function() { return MSortableClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortableAction", function() { return MSortableAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSortable", function() { return MSortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableDirective", function() { return SortableDirective; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_vue_directive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/vue/directive */ "./src/utils/vue/directive.ts");
/* harmony import */ var _utils_vue_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/vue/events */ "./src/utils/vue/events.ts");
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../domPlugin */ "./src/directives/domPlugin.ts");
/* harmony import */ var _drag_and_drop_drag_and_drop_plugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../drag-and-drop/drag-and-drop-plugin */ "./src/directives/drag-and-drop/drag-and-drop-plugin.ts");
/* harmony import */ var _drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../drag-and-drop/draggable/draggable */ "./src/directives/drag-and-drop/draggable/draggable.ts");
/* harmony import */ var _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../drag-and-drop/droppable/droppable */ "./src/directives/drag-and-drop/droppable/droppable.ts");
/* harmony import */ var _drag_and_drop_droppable_droppable_group__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../drag-and-drop/droppable/droppable-group */ "./src/directives/drag-and-drop/droppable/droppable-group.ts");
/* harmony import */ var _insertion_behavior__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./insertion-behavior */ "./src/directives/sortable/insertion-behavior.ts");
/* harmony import */ var _sortable_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./sortable.scss */ "./src/directives/sortable/sortable.scss");
/* harmony import */ var _sortable_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_sortable_scss__WEBPACK_IMPORTED_MODULE_10__);











var MSortableEventNames;
(function (MSortableEventNames) {
    MSortableEventNames["OnAdd"] = "sortable:add";
    MSortableEventNames["OnMove"] = "sortable:move";
    MSortableEventNames["OnRemove"] = "sortable:remove";
})(MSortableEventNames || (MSortableEventNames = {}));
var MSortInsertPositions;
(function (MSortInsertPositions) {
    MSortInsertPositions["Before"] = "before";
    MSortInsertPositions["In"] = "in";
    MSortInsertPositions["After"] = "after";
})(MSortInsertPositions || (MSortInsertPositions = {}));
var MSortableClassNames;
(function (MSortableClassNames) {
    MSortableClassNames["Sortable"] = "m--is-sortable";
    MSortableClassNames["CantSort"] = "m--cant-sort";
    MSortableClassNames["SortBefore"] = "m--is-sortbefore";
    MSortableClassNames["SortIn"] = "m--is-sortin";
    MSortableClassNames["SortAfter"] = "m--is-sortafter";
    MSortableClassNames["EmptyPlaceholder"] = "m--is-sortable-placeholder";
})(MSortableClassNames || (MSortableClassNames = {}));
var MSortableAction;
(function (MSortableAction) {
    MSortableAction["Default"] = "any";
    MSortableAction["Move"] = "move";
    MSortableAction["MoveGroup"] = "move_group";
})(MSortableAction || (MSortableAction = {}));
var MSortable = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MSortable, _super);
    function MSortable(element, options) {
        return _super.call(this, element, options) || this;
    }
    MSortable.prototype.doCleanUp = function () {
        this.cleanUpInsertionClasses();
    };
    MSortable.prototype.attach = function (mount) {
        var _this = this;
        this.observer = new MutationObserver(function (mutations) { return _this.manageMutation(mutations); });
        this.observer.observe(this.element, { childList: true });
        this.setOptions(this.options);
        this.attachChilds();
        if (this.options.canSort) {
            mount(function () {
                _this.element.classList.add(MSortableClassNames.Sortable);
                var plugin = _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], _this.element, {
                    acceptedActions: _this.options.acceptedActions,
                    canDrop: true
                });
                plugin.addEventListener(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppableEventNames"].OnDrop, function (event) { return _this.onDrop(event); });
                plugin.addEventListener(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppableEventNames"].OnDragEnter, function (event) { return _this.onDragEnter(event); });
                plugin.addEventListener(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppableEventNames"].OnDragLeave, function (event) { return _this.onDragLeave(event); });
                plugin.addEventListener(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppableEventNames"].OnDragOver, function (event) { return _this.onDragOver(event); });
            });
        }
    };
    MSortable.prototype.update = function (options, refresh) {
        var _this = this;
        this.setOptions(options);
        if (this.options.canSort) {
            refresh(function () { return _this.attachChilds(); });
        }
    };
    MSortable.prototype.detach = function () {
        this.observer.disconnect();
        this.element.classList.remove(MSortableClassNames.Sortable);
        this.doCleanUp();
        this.detachChilds();
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], this.element);
    };
    MSortable.prototype.manageMutation = function (mutations) {
        var refreshChild = false;
        mutations.forEach(function (mutation) {
            // when an item leave the sortable we have to clean it up.
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length) {
                    for (var i = 0; i < mutation.removedNodes.length; i++) {
                        var currentElement = mutation.removedNodes[i];
                        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"], currentElement);
                        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], currentElement);
                    }
                }
                if (mutation.addedNodes) {
                    refreshChild = true;
                }
            }
        });
        if (refreshChild) {
            this.attachChilds();
        }
    };
    MSortable.prototype.setOptions = function (value) {
        if (value.canSort === undefined) {
            value.canSort = true;
        }
        if (!value.items) {
            value.items = [];
        }
        var sortableGroup = _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].getRecursive(_drag_and_drop_droppable_droppable_group__WEBPACK_IMPORTED_MODULE_8__["MDroppableGroup"], this.element);
        var acceptedActions;
        if (!value.acceptedActions) {
            acceptedActions = [MSortableAction.Default];
        }
        else {
            acceptedActions = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(value.acceptedActions);
        }
        acceptedActions.push(MSortableAction.Move);
        if (!sortableGroup) {
            acceptedActions.push(MSortableAction.MoveGroup);
        }
        this._options = value;
        this._options.acceptedActions = acceptedActions;
    };
    MSortable.prototype.canDrag = function (element) {
        var childDragValue = element.attributes.getNamedItem('can-drag');
        var canDragValue;
        if (!this.options.canSort) {
            canDragValue = false;
        }
        else if (childDragValue && childDragValue.value === 'false') {
            canDragValue = false;
        }
        else if (childDragValue && childDragValue.value === 'true') {
            canDragValue = true;
        }
        else {
            canDragValue = this.options.canSort;
        }
        return canDragValue;
    };
    MSortable.prototype.canDrop = function (element) {
        var childDropValue = element.attributes.getNamedItem('can-drop');
        var canDropValue;
        if (!this.options.canSort) {
            canDropValue = false;
        }
        else if (childDropValue && childDropValue.value === 'false') {
            canDropValue = false;
        }
        else if (childDropValue && childDropValue.value === 'true') {
            canDropValue = true;
        }
        else {
            canDropValue = this.options.canSort;
        }
        return canDropValue;
    };
    MSortable.prototype.attachChilds = function () {
        var _this = this;
        var itemCounter = 0;
        var sortableGroup = _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].getRecursive(_drag_and_drop_droppable_droppable_group__WEBPACK_IMPORTED_MODULE_8__["MDroppableGroup"], this.element);
        for (var i = 0; i < this.element.children.length; i++) {
            var currentElement = this.element.children[i];
            if (currentElement.classList.contains(MSortableClassNames.EmptyPlaceholder)) {
                this.attachEmptyPlaceholder(currentElement, sortableGroup ? sortableGroup.options : undefined);
            }
            else {
                var draggableGroup = _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].get(_drag_and_drop_droppable_droppable_group__WEBPACK_IMPORTED_MODULE_8__["MDroppableGroup"], currentElement);
                var grouping = !sortableGroup ? draggableGroup ? draggableGroup.options : undefined : undefined;
                var draggablePlugin = _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"], currentElement, {
                    action: !grouping ? MSortableAction.Move : MSortableAction.MoveGroup,
                    dragData: this.options.items[itemCounter++],
                    grouping: grouping,
                    canDrag: this.canDrag(currentElement)
                });
                draggablePlugin.removeEventListener(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggableEventNames"].OnDragEnd);
                draggablePlugin.removeEventListener(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggableEventNames"].OnDragStart);
                draggablePlugin.addEventListener(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggableEventNames"].OnDragEnd, function (event) { return _this.onChildDragEnd(event); });
                draggablePlugin.addEventListener(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggableEventNames"].OnDragStart, function (event) { return _this.onChildDragStart(event); });
                _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], currentElement, {
                    acceptedActions: this.options.acceptedActions,
                    canDrop: this.canDrop(currentElement),
                    alwaysMount: true
                });
            }
        }
    };
    MSortable.prototype.detachChilds = function () {
        for (var i = 0; i < this.element.children.length; i++) {
            var currentElement = this.element.children[i];
            _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"], currentElement);
            _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], currentElement);
        }
    };
    MSortable.prototype.attachEmptyPlaceholder = function (element, grouping) {
        if (element) {
            _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"], element, {
                acceptedActions: this.options.acceptedActions,
                canDrop: this.options.canSort
            });
        }
        this.emptyPlaceHolderElement = element;
        if (this.emptyPlaceHolderElement) {
            this.emptyPlaceHolderElement.style.display = this.options.items.length ? 'none' : '';
        }
    };
    MSortable.prototype.onDragEnter = function (event) {
        this.onDragIn(event);
    };
    MSortable.prototype.onDragLeave = function (event) {
        event.stopPropagation();
        var newContainer = _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable ? _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].getRecursive(MSortable, _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element) : undefined;
        if (!newContainer) {
            this.doCleanUp();
            MSortable.activeSortContainer = undefined;
        }
        if (newContainer && newContainer !== this) {
            this.doCleanUp();
        }
    };
    MSortable.prototype.onDragOver = function (event) {
        this.onDragIn(event);
    };
    MSortable.prototype.onDragIn = function (event) {
        event.stopPropagation();
        if (MSortable.activeSortContainer && MSortable.activeSortContainer !== this) {
            MSortable.activeSortContainer.doCleanUp();
        }
        MSortable.activeSortContainer = this;
        this.insertInsertionMarker(event);
    };
    MSortable.prototype.onDrop = function (event) {
        event.stopPropagation();
        var oldIndex = this.options.items.findIndex(function (item) { return item === event.dropInfo.data; });
        var isMoving = oldIndex !== -1 || event.dropInfo.action === MSortableAction.Move || event.dropInfo.action === MSortableAction.MoveGroup;
        var eventName;
        if (isMoving) {
            eventName = MSortableEventNames.OnMove;
        }
        else {
            eventName = MSortableEventNames.OnAdd;
        }
        var sortInfo = {
            canDrop: event.dropInfo.canDrop,
            data: event.dropInfo.data,
            action: event.dropInfo.action,
            oldPosition: oldIndex,
            newPosition: this.getNewPosition(event, oldIndex),
            grouping: event.dropInfo.grouping
        };
        var changed = sortInfo.oldPosition !== sortInfo.newPosition;
        if (!changed) {
            return;
        }
        var customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent(eventName, true, true, Object.assign(event, { sortInfo: sortInfo }));
        customEvent.sortInfo = sortInfo;
        Object(_utils_vue_events__WEBPACK_IMPORTED_MODULE_2__["dispatchEvent"])(this.element, eventName, customEvent);
        if (MSortable.fromSortContainer && MSortable.fromSortContainer !== MSortable.activeSortContainer) {
            MSortable.fromSortContainer.onRemove(event);
        }
        // TODO: review => Verify this line is useful.
        this.onChildDragEnd(event);
    };
    MSortable.prototype.onRemove = function (event) {
        var oldIndex = this.options.items.findIndex(function (item) { return item === event.dropInfo.data; });
        if (oldIndex !== -1) {
            var sortInfo = Object.assign(event.dropInfo, { oldPosition: oldIndex, newPosition: -1 });
            var customEvent = document.createEvent('CustomEvent');
            customEvent.initCustomEvent(MSortableEventNames.OnRemove, true, true, Object.assign(event, { sortInfo: sortInfo }));
            customEvent.sortInfo = sortInfo;
            Object(_utils_vue_events__WEBPACK_IMPORTED_MODULE_2__["dispatchEvent"])(this.element, MSortableEventNames.OnRemove, customEvent);
        }
    };
    MSortable.prototype.onChildDragEnd = function (event) {
        event.stopPropagation();
        if (MSortable.fromSortContainer) {
            MSortable.fromSortContainer.doCleanUp();
        }
        if (MSortable.activeSortContainer) {
            MSortable.activeSortContainer.doCleanUp();
        }
        this.doCleanUp();
        MSortable.fromSortContainer = undefined;
        MSortable.activeSortContainer = undefined;
    };
    MSortable.prototype.onChildDragStart = function (event) {
        event.stopPropagation();
        MSortable.fromSortContainer = this;
    };
    MSortable.prototype.insertInsertionMarker = function (event) {
        // Fix for firefox flickering.
        if (event.detail.target.nodeType === Node.TEXT_NODE) {
            return;
        }
        if (!_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable || !event.dropInfo.canDrop || this.isHoveringOverDraggedElement()) {
            this.doCleanUp();
            return;
        }
        var currentInsertPosition = this.getCurrentInsertPosition();
        var newInsertPosition = this.getInsertionMarkerBehavior().getInsertPosition(event);
        if (_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable === _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].previousHoverContainer && currentInsertPosition === newInsertPosition) {
            return;
        }
        var element;
        if (!this.isInsertingOnChild()) {
            element = newInsertPosition === MSortInsertPositions.Before
                ? this.element.children[0] : this.element.children[this.element.children.length - 1];
        }
        else {
            element = _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element;
        }
        this.doCleanUp();
        var insertionClass;
        switch (newInsertPosition) {
            case MSortInsertPositions.After:
                insertionClass = MSortableClassNames.SortAfter;
                break;
            case MSortInsertPositions.Before:
                insertionClass = MSortableClassNames.SortBefore;
                break;
            case MSortInsertPositions.In:
                insertionClass = MSortableClassNames.SortIn;
                break;
        }
        var isSortingOnPreviousSibling = !!_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable &&
            !!_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable &&
            _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element === _drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable.element.previousElementSibling &&
            newInsertPosition === MSortInsertPositions.After;
        var isSortingOnNextSibling = !!_drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable &&
            !!_drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable &&
            _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element === _drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable.element.nextElementSibling &&
            newInsertPosition === MSortInsertPositions.Before;
        if (insertionClass) {
            element.classList.add(insertionClass);
            if (isSortingOnPreviousSibling || isSortingOnNextSibling) {
                element.classList.add(MSortableClassNames.CantSort);
            }
        }
    };
    MSortable.prototype.getInsertionMarkerBehavior = function () {
        /*const droppable: MDroppable = MDroppable.currentHoverDroppable as MDroppable;

        if (MDOMPlugin.get(MDroppableGroup, droppable.element)) {
            return new MSortableGroupingInsertionMarkerBehavior();
        }
*/
        return new _insertion_behavior__WEBPACK_IMPORTED_MODULE_9__["MSortableDefaultInsertionMarkerBehavior"]();
    };
    MSortable.prototype.getNewPosition = function (event, oldPosition) {
        var index = 0;
        for (var i = 0; i < this.element.children.length; i++) {
            var child = this.element.children[i];
            if (child.classList.contains(MSortableClassNames.EmptyPlaceholder)) {
                index--;
            }
            if (child.classList.contains(MSortableClassNames.SortBefore)) {
                break;
            }
            if (child.classList.contains(MSortableClassNames.SortAfter)) {
                index++;
                break;
            }
            index++;
        }
        var newIndex = index < 0 ? 0 : index;
        if (oldPosition !== -1 && oldPosition < newIndex) {
            newIndex--;
        }
        return newIndex;
    };
    MSortable.prototype.isHoveringOverDraggedElement = function () {
        return _drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable !== undefined && _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable !== undefined
            && _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element === _drag_and_drop_draggable_draggable__WEBPACK_IMPORTED_MODULE_6__["MDraggable"].currentDraggable.element;
    };
    MSortable.prototype.isInsertingOnChild = function () {
        return _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable !== undefined && _drag_and_drop_droppable_droppable__WEBPACK_IMPORTED_MODULE_7__["MDroppable"].currentHoverDroppable.element !== this.element;
    };
    MSortable.prototype.hasItems = function () {
        return this.options.items.length > 0;
    };
    MSortable.prototype.getCurrentInsertPosition = function () {
        var mSortAfterElement = this.element.querySelector("." + MSortableClassNames.SortAfter);
        if (mSortAfterElement) {
            return MSortInsertPositions.After;
        }
        var mSortBeforeElement = this.element.querySelector("." + MSortableClassNames.SortBefore);
        if (mSortBeforeElement) {
            return MSortInsertPositions.Before;
        }
        var mSortInElement = this.element.querySelector("." + MSortableClassNames.SortIn);
        if (mSortInElement) {
            return MSortInsertPositions.In;
        }
        return MSortInsertPositions.After;
    };
    MSortable.prototype.cleanUpInsertionClasses = function () {
        var mSortAfterElement = this.element.querySelector("." + MSortableClassNames.SortAfter);
        if (mSortAfterElement) {
            mSortAfterElement.classList.remove(MSortableClassNames.SortAfter);
        }
        this.element.classList.remove(MSortableClassNames.SortAfter);
        var mSortInElement = this.element.querySelector("." + MSortableClassNames.SortIn);
        if (mSortInElement) {
            mSortInElement.classList.remove(MSortableClassNames.SortIn);
        }
        this.element.classList.remove(MSortableClassNames.SortIn);
        var mSortBeforeElement = this.element.querySelector("." + MSortableClassNames.SortBefore);
        if (mSortBeforeElement) {
            mSortBeforeElement.classList.remove(MSortableClassNames.SortBefore);
        }
        this.element.classList.remove(MSortableClassNames.SortBefore);
        this.element.classList.remove(MSortableClassNames.CantSort);
        var mCantSort = this.element.querySelector("." + MSortableClassNames.CantSort);
        if (mCantSort) {
            mCantSort.classList.remove(MSortableClassNames.CantSort);
        }
    };
    MSortable.defaultMountPoint = '__msortable__';
    return MSortable;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_4__["MElementDomPlugin"]));

var extractVnodeAttributes = function (binding, node) {
    return {
        items: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_1__["getVNodeAttributeValue"])(node, 'items'),
        acceptedActions: Object(_utils_vue_directive__WEBPACK_IMPORTED_MODULE_1__["getVNodeAttributeValue"])(node, 'accepted-actions'),
        canSort: binding.value,
        encapsulate: (binding.modifiers || {}).encapsulate || false
    };
};
var SortableDirective = {
    inserted: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(MSortable, element, extractVnodeAttributes(binding, node));
    },
    update: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].attach(MSortable, element, extractVnodeAttributes(binding, node));
    },
    unbind: function (element) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_4__["MDOMPlugin"].detach(MSortable, element);
    }
};
var SortablePlugin = {
    install: function (v, _options) {
        v.use(_drag_and_drop_drag_and_drop_plugin__WEBPACK_IMPORTED_MODULE_5__["default"]);
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_3__["SORTABLE_NAME"], SortableDirective);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SortablePlugin);


/***/ }),

/***/ "./src/directives/textarea-auto-height/textarea-auto-height.ts":
/*!*********************************************************************!*\
  !*** ./src/directives/textarea-auto-height/textarea-auto-height.ts ***!
  \*********************************************************************/
/*! exports provided: MTextareaAutoHeight, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MTextareaAutoHeight", function() { return MTextareaAutoHeight; });
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");

var ajustHeight = function (element) {
    if (element.tagName === 'TEXTAREA') {
        var outerHeight = parseInt(window.getComputedStyle(element).height, 10);
        var diff = outerHeight - element.clientHeight;
        element.style.height = '0';
        if (element.scrollHeight + diff > 0) {
            element.style.height = element.scrollHeight + diff + 'px';
        }
        else {
            element.style.removeProperty('height');
        }
    }
};
var MTextareaAutoHeight = {
    bind: function (element, binding, node) {
        element.disabledUpdate = false;
        var setDisabledUpdate = function () {
            element.disabledUpdate = true;
            setTimeout(function () {
                if (element.disabledUpdate) {
                    element.disabledUpdate = false;
                }
            }, 800);
        };
        if (node.context && element.tagName === 'TEXTAREA') {
            node.context.$nextTick(function () {
                if (node.context && element) {
                    element.ajustHeight = function () {
                        ajustHeight(element);
                        setDisabledUpdate();
                    };
                    element.setDisabledUpdate = function () {
                        setDisabledUpdate();
                    };
                    element.addEventListener('mousedown', element.setDisabledUpdate);
                    element.addEventListener('input', element.ajustHeight);
                    window.addEventListener('resize', element.ajustHeight);
                    setTimeout(function () {
                        element.ajustHeight();
                    });
                }
            });
        }
    },
    update: function (element) {
        if (!element.disabledUpdate) {
            ajustHeight(element);
        }
    },
    unbind: function (element, binding) {
        if (element.tagName === 'TEXTAREA') {
            if (element.setDisabledUpdate) {
                element.removeEventListener('mousedown', element.setDisabledUpdate);
            }
            element.removeEventListener('input', element.ajustHeight);
            window.removeEventListener('resize', element.ajustHeight);
        }
    }
};
var TextareaAutoHeightPlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_0__["TEXTAREA_AUTO_HEIGHT"], MTextareaAutoHeight);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (TextareaAutoHeightPlugin);


/***/ }),

/***/ "./src/directives/user-select/remove-user-select.ts":
/*!**********************************************************!*\
  !*** ./src/directives/user-select/remove-user-select.ts ***!
  \**********************************************************/
/*! exports provided: MRemoveUserSelect, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MRemoveUserSelect", function() { return MRemoveUserSelect; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _directive_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directive-names */ "./src/directives/directive-names.ts");
/* harmony import */ var _domPlugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../domPlugin */ "./src/directives/domPlugin.ts");



var MRemoveUserSelect = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MRemoveUserSelect, _super);
    function MRemoveUserSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MRemoveUserSelect.prototype.attach = function (mount) {
        var _this = this;
        if (this.options === undefined) {
            this._options = true;
        }
        if (this.options) {
            mount(function () {
                _this.addEventListener('onmouseover', function (event) { event.preventDefault(); });
                _this.element.style.webkitUserSelect = 'none';
                _this.element.style.msUserSelect = 'none';
                _this.element.style.userSelect = 'none';
                _this.element.style['-moz-user-select'] = 'none';
                // mobile ios will display a gray box over element on touch start.  We don't want that.
                _this.element.style.webkitTapHighlightColor = 'rgba(0,0,0,0)';
            });
        }
    };
    MRemoveUserSelect.prototype.update = function (options, refresh) {
        if (options === undefined) {
            options = true;
        }
        this._options = options;
        if (this.options) {
            refresh(function () { });
        }
    };
    MRemoveUserSelect.prototype.detach = function () {
        this.removeAllEvents();
        this.element.style.webkitTapHighlightColor = '';
        this.element.style.userSelect = '';
        this.element.style.msUserSelect = '';
        this.element.style.webkitUserSelect = '';
        this.element.style['-moz-user-select'] = '';
    };
    MRemoveUserSelect.defaultMountPoint = '__mremoveuserselect__';
    return MRemoveUserSelect;
}(_domPlugin__WEBPACK_IMPORTED_MODULE_2__["MElementDomPlugin"]));

var Directive = {
    bind: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].attach(MRemoveUserSelect, element, binding.value);
    },
    update: function (element, binding, node) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].attach(MRemoveUserSelect, element, binding.value);
    },
    unbind: function (element, binding) {
        _domPlugin__WEBPACK_IMPORTED_MODULE_2__["MDOMPlugin"].detach(MRemoveUserSelect, element);
    }
};
var RemoveUserSelectPlugin = {
    install: function (v, options) {
        v.directive(_directive_names__WEBPACK_IMPORTED_MODULE_1__["REMOVE_USER_SELECT_NAME"], Directive);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (RemoveUserSelectPlugin);


/***/ }),

/***/ "./src/filters/date/date/date.ts":
/*!***************************************!*\
  !*** ./src/filters/date/date/date.ts ***!
  \***************************************/
/*! exports provided: dateFilter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateFilter", function() { return dateFilter; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

var dateFilter = function (date, params) {
    var defaultParams = {
        shortMode: false,
        showMonth: true,
        showYear: true,
        showDay: true,
        withTime: false
    };
    var appliedParams = Object.assign(defaultParams, params);
    var options = {
        year: appliedParams.showYear ? 'numeric' : undefined,
        month: appliedParams.showMonth ? (appliedParams.shortMode ? 'short' : 'long') : undefined,
        day: appliedParams.showDay ? 'numeric' : undefined
    };
    var locale = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype).$i18n.getCurrentLocale();
    var formattedDate = date.toLocaleDateString([locale], options);
    formattedDate = addOrdinal(formattedDate, locale);
    return formattedDate;
};
var addOrdinal = function (date, locale) {
    var regexp2 = /(^1 )|(^1$)/;
    var match = regexp2.exec(date);
    if (match && locale === 'fr-CA') {
        return date.replace(match[0], match[0].trim() + "<sup>er</sup> ");
    }
    return date;
};


/***/ }),

/***/ "./src/filters/filesize/filesize.ts":
/*!******************************************!*\
  !*** ./src/filters/filesize/filesize.ts ***!
  \******************************************/
/*! exports provided: fileSize, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileSize", function() { return fileSize; });
/* harmony import */ var filesize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! filesize */ "filesize");
/* harmony import */ var filesize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(filesize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _filter_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../filter-names */ "./src/filters/filter-names.ts");



var filesizeSymbols = undefined;
var fileSize = function (bytes) {
    if (!filesizeSymbols) {
        var i18n = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype).$i18n;
        filesizeSymbols = {
            B: i18n.translate('f-m-filesize:size-b'),
            KB: i18n.translate('f-m-filesize:size-kb'),
            MB: i18n.translate('f-m-filesize:size-mb'),
            GB: i18n.translate('f-m-filesize:size-gb')
        };
    }
    return filesize__WEBPACK_IMPORTED_MODULE_0___default()(bytes, {
        symbols: filesizeSymbols
    });
};
var FileSizeFilterPlugin = {
    install: function (v, options) {
        v.filter(_filter_names__WEBPACK_IMPORTED_MODULE_2__["FILESIZE_NAME"], fileSize);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FileSizeFilterPlugin);


/***/ }),

/***/ "./src/filters/filter-names.ts":
/*!*************************************!*\
  !*** ./src/filters/filter-names.ts ***!
  \*************************************/
/*! exports provided: DATE_NAME, DATE_TIME_NAME, FILESIZE_NAME, I18N_NAME, MONEY_NAME, PERIOD_NAME, PHONE_NAME, POSTAL_CODE_NAME, TIME_ELAPSED_NAME, TIME_NAME, TIME_PERIOD_NAME */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_NAME", function() { return DATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_TIME_NAME", function() { return DATE_TIME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILESIZE_NAME", function() { return FILESIZE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18N_NAME", function() { return I18N_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONEY_NAME", function() { return MONEY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERIOD_NAME", function() { return PERIOD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_NAME", function() { return PHONE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POSTAL_CODE_NAME", function() { return POSTAL_CODE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIME_ELAPSED_NAME", function() { return TIME_ELAPSED_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIME_NAME", function() { return TIME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIME_PERIOD_NAME", function() { return TIME_PERIOD_NAME; });
var DATE_NAME = 'f-m-date';
var DATE_TIME_NAME = 'f-m-date-time';
var FILESIZE_NAME = 'f-m-filesize';
var I18N_NAME = 'f-m-i18n';
var MONEY_NAME = 'f-m-money';
var PERIOD_NAME = 'f-m-period';
var PHONE_NAME = 'f-m-phone';
var POSTAL_CODE_NAME = 'f-m-postal-code';
var TIME_ELAPSED_NAME = 'f-m-time-elapsed';
var TIME_NAME = 'f-m-time';
var TIME_PERIOD_NAME = 'f-m-time-period';


/***/ }),

/***/ "./src/filters/filters-plugin.ts":
/*!***************************************!*\
  !*** ./src/filters/filters-plugin.ts ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/logger/logger */ "./src/utils/logger/logger.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./i18n/i18n */ "./src/filters/i18n/i18n.ts");



var FiltersPlugin = {
    install: function (v, options) {
        if (!v.prototype.$log) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_logger_logger__WEBPACK_IMPORTED_MODULE_1__["default"]);
        }
        // Vue.use(DateFilterPlugin);
        // Vue.use(MoneyPlugin);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_i18n_i18n__WEBPACK_IMPORTED_MODULE_2__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FiltersPlugin);


/***/ }),

/***/ "./src/filters/i18n/i18n.ts":
/*!**********************************!*\
  !*** ./src/filters/i18n/i18n.ts ***!
  \**********************************/
/*! exports provided: i18nFilter, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i18nFilter", function() { return i18nFilter; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _filter_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../filter-names */ "./src/filters/filter-names.ts");


var i18nFilter = function (key, params, nb, modifier, htmlEncodeParams) {
    if (params === void 0) { params = []; }
    if (htmlEncodeParams === void 0) { htmlEncodeParams = true; }
    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$i18n.translate(key, params, nb, modifier, htmlEncodeParams);
};
var I18nFilterPlugin = {
    install: function (v, options) {
        v.filter(_filter_names__WEBPACK_IMPORTED_MODULE_1__["I18N_NAME"], i18nFilter);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (I18nFilterPlugin);


/***/ }),

/***/ "./src/lib.ts":
/*!********************!*\
  !*** ./src/lib.ts ***!
  \********************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModulComponentPlugin", function() { return ModulComponentPlugin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_components_plugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/components-plugin */ "./src/components/components-plugin.ts");
/* harmony import */ var _directives_directives_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./directives/directives-plugin */ "./src/directives/directives-plugin.ts");
/* harmony import */ var _filters_filters_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./filters/filters-plugin */ "./src/filters/filters-plugin.ts");
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _utils_toast_toast_service_plugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/toast/toast-service.plugin */ "./src/utils/toast/toast-service.plugin.ts");
/* harmony import */ var _utils_utils_plugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/utils-plugin */ "./src/utils/utils-plugin.ts");
/* harmony import */ var _components_accordion_group_accordion_group__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/accordion-group/accordion-group */ "./src/components/accordion-group/accordion-group.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordionGroup", function() { return _components_accordion_group_accordion_group__WEBPACK_IMPORTED_MODULE_7__["MAccordionGroup"]; });

/* harmony import */ var _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/accordion/accordion */ "./src/components/accordion/accordion.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordionSkin", function() { return _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__["MAccordionSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordionIconPosition", function() { return _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__["MAccordionIconPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordionIconSize", function() { return _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__["MAccordionIconSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ACCORDION_CLOSEST_ELEMENTS", function() { return _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__["ACCORDION_CLOSEST_ELEMENTS"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordion", function() { return _components_accordion_accordion__WEBPACK_IMPORTED_MODULE_8__["MAccordion"]; });

/* harmony import */ var _components_add_add__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/add/add */ "./src/components/add/add.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAdd", function() { return _components_add_add__WEBPACK_IMPORTED_MODULE_9__["MAdd"]; });

/* harmony import */ var _components_autocomplete_autocomplete__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/autocomplete/autocomplete */ "./src/components/autocomplete/autocomplete.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAutocomplete", function() { return _components_autocomplete_autocomplete__WEBPACK_IMPORTED_MODULE_10__["MAutocomplete"]; });

/* harmony import */ var _components_avatar_avatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/avatar/avatar */ "./src/components/avatar/avatar.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAvatarSize", function() { return _components_avatar_avatar__WEBPACK_IMPORTED_MODULE_11__["MAvatarSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAvatar", function() { return _components_avatar_avatar__WEBPACK_IMPORTED_MODULE_11__["MAvatar"]; });

/* harmony import */ var _components_button_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/button/button */ "./src/components/button/button.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MButtonType", function() { return _components_button_button__WEBPACK_IMPORTED_MODULE_12__["MButtonType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MButtonSkin", function() { return _components_button_button__WEBPACK_IMPORTED_MODULE_12__["MButtonSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MButtonIconPosition", function() { return _components_button_button__WEBPACK_IMPORTED_MODULE_12__["MButtonIconPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MButton", function() { return _components_button_button__WEBPACK_IMPORTED_MODULE_12__["MButton"]; });

/* harmony import */ var _components_calendar_calendar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/calendar/calendar */ "./src/components/calendar/calendar.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalendarMode", function() { return _components_calendar_calendar__WEBPACK_IMPORTED_MODULE_13__["CalendarMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCalendarType", function() { return _components_calendar_calendar__WEBPACK_IMPORTED_MODULE_13__["MCalendarType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCalendar", function() { return _components_calendar_calendar__WEBPACK_IMPORTED_MODULE_13__["MCalendar"]; });

/* harmony import */ var _components_carousel_carousel__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/carousel/carousel */ "./src/components/carousel/carousel.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCarousel", function() { return _components_carousel_carousel__WEBPACK_IMPORTED_MODULE_14__["MCarousel"]; });

/* harmony import */ var _components_character_count_character_count__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/character-count/character-count */ "./src/components/character-count/character-count.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCharacterCount", function() { return _components_character_count_character_count__WEBPACK_IMPORTED_MODULE_15__["MCharacterCount"]; });

/* harmony import */ var _components_checkbox_checkbox__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/checkbox/checkbox */ "./src/components/checkbox/checkbox.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCheckboxPosition", function() { return _components_checkbox_checkbox__WEBPACK_IMPORTED_MODULE_16__["MCheckboxPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCheckboxVerticalAlignement", function() { return _components_checkbox_checkbox__WEBPACK_IMPORTED_MODULE_16__["MCheckboxVerticalAlignement"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCheckbox", function() { return _components_checkbox_checkbox__WEBPACK_IMPORTED_MODULE_16__["MCheckbox"]; });

/* harmony import */ var _components_chip_chip__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/chip/chip */ "./src/components/chip/chip.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MChipMode", function() { return _components_chip_chip__WEBPACK_IMPORTED_MODULE_17__["MChipMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MChipSize", function() { return _components_chip_chip__WEBPACK_IMPORTED_MODULE_17__["MChipSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MChip", function() { return _components_chip_chip__WEBPACK_IMPORTED_MODULE_17__["MChip"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentsPlugin", function() { return _components_components_plugin__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _components_datepicker_datepicker__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/datepicker/datepicker */ "./src/components/datepicker/datepicker.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDatepickerDefaultView", function() { return _components_datepicker_datepicker__WEBPACK_IMPORTED_MODULE_18__["MDatepickerDefaultView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDatepicker", function() { return _components_datepicker_datepicker__WEBPACK_IMPORTED_MODULE_18__["MDatepicker"]; });

/* harmony import */ var _components_daterangepicker_daterangepicker__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/daterangepicker/daterangepicker */ "./src/components/daterangepicker/daterangepicker.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDaterangepicker", function() { return _components_daterangepicker_daterangepicker__WEBPACK_IMPORTED_MODULE_19__["MDaterangepicker"]; });

/* harmony import */ var _components_decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/decimalfield/decimalfield */ "./src/components/decimalfield/decimalfield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDecimalfield", function() { return _components_decimalfield_decimalfield__WEBPACK_IMPORTED_MODULE_20__["MDecimalfield"]; });

/* harmony import */ var _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/dialog/dialog */ "./src/components/dialog/dialog.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDialogWidth", function() { return _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_21__["MDialogWidth"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDialogState", function() { return _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_21__["MDialogState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDialog", function() { return _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_21__["MDialog"]; });

/* harmony import */ var _components_dropdown_dropdown__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/dropdown/dropdown */ "./src/components/dropdown/dropdown.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDropdown", function() { return _components_dropdown_dropdown__WEBPACK_IMPORTED_MODULE_22__["MDropdown"]; });

/* harmony import */ var _components_dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/dropdown/dropdown-item/dropdown-item */ "./src/components/dropdown/dropdown-item/dropdown-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseDropdown", function() { return _components_dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_23__["BaseDropdown"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseDropdownGroup", function() { return _components_dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_23__["BaseDropdownGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDropdownItem", function() { return _components_dropdown_dropdown_item_dropdown_item__WEBPACK_IMPORTED_MODULE_23__["MDropdownItem"]; });

/* harmony import */ var _components_error_pages_error_access_denied_error_access_denied__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/error-pages/error-access-denied/error-access-denied */ "./src/components/error-pages/error-access-denied/error-access-denied.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorAccessDenied", function() { return _components_error_pages_error_access_denied_error_access_denied__WEBPACK_IMPORTED_MODULE_24__["MErrorAccessDenied"]; });

/* harmony import */ var _components_error_pages_error_browser_not_supported_error_browser_not_supported__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/error-pages/error-browser-not-supported/error-browser-not-supported */ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorBrowserNotSupported", function() { return _components_error_pages_error_browser_not_supported_error_browser_not_supported__WEBPACK_IMPORTED_MODULE_25__["MErrorBrowserNotSupported"]; });

/* harmony import */ var _components_error_pages_error_config_not_supported_error_config_not_supported__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/error-pages/error-config-not-supported/error-config-not-supported */ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorConfigNotSupported", function() { return _components_error_pages_error_config_not_supported_error_config_not_supported__WEBPACK_IMPORTED_MODULE_26__["MErrorConfigNotSupported"]; });

/* harmony import */ var _components_error_pages_error_conflict_error_conflict__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/error-pages/error-conflict/error-conflict */ "./src/components/error-pages/error-conflict/error-conflict.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorOperationFailed", function() { return _components_error_pages_error_conflict_error_conflict__WEBPACK_IMPORTED_MODULE_27__["MErrorOperationFailed"]; });

/* harmony import */ var _components_error_pages_error_cookies_not_supported_error_cookies_not_supported__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/error-pages/error-cookies-not-supported/error-cookies-not-supported */ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorCookiesNotSupported", function() { return _components_error_pages_error_cookies_not_supported_error_cookies_not_supported__WEBPACK_IMPORTED_MODULE_28__["MErrorCookiesNotSupported"]; });

/* harmony import */ var _components_error_pages_error_page_not_found_error_page_not_found__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/error-pages/error-page-not-found/error-page-not-found */ "./src/components/error-pages/error-page-not-found/error-page-not-found.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorPageNotFound", function() { return _components_error_pages_error_page_not_found_error_page_not_found__WEBPACK_IMPORTED_MODULE_29__["MErrorPageNotFound"]; });

/* harmony import */ var _components_error_pages_error_resource_unavailable_error_resource_unavailable__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/error-pages/error-resource-unavailable/error-resource-unavailable */ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorResourceUnavailable", function() { return _components_error_pages_error_resource_unavailable_error_resource_unavailable__WEBPACK_IMPORTED_MODULE_30__["MErrorResourceUnavailable"]; });

/* harmony import */ var _components_error_pages_error_session_expired_error_session_expired__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/error-pages/error-session-expired/error-session-expired */ "./src/components/error-pages/error-session-expired/error-session-expired.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorSessionExpired", function() { return _components_error_pages_error_session_expired_error_session_expired__WEBPACK_IMPORTED_MODULE_31__["MErrorSessionExpired"]; });

/* harmony import */ var _components_error_pages_error_technical_difficulty_error_technical_difficulty__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/error-pages/error-technical-difficulty/error-technical-difficulty */ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MErrorTechnicalDifficulty", function() { return _components_error_pages_error_technical_difficulty_error_technical_difficulty__WEBPACK_IMPORTED_MODULE_32__["MErrorTechnicalDifficulty"]; });

/* harmony import */ var _components_expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/expandable-layout/expandable-layout */ "./src/components/expandable-layout/expandable-layout.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayoutPanelScrollMode", function() { return _components_expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_33__["MExpandableLayoutPanelScrollMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayoutPanelPosition", function() { return _components_expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_33__["MExpandableLayoutPanelPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MExpandableLayout", function() { return _components_expandable_layout_expandable_layout__WEBPACK_IMPORTED_MODULE_33__["MExpandableLayout"]; });

/* harmony import */ var _components_file_select_file_select__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/file-select/file-select */ "./src/components/file-select/file-select.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MFileSelect", function() { return _components_file_select_file_select__WEBPACK_IMPORTED_MODULE_34__["MFileSelect"]; });

/* harmony import */ var _components_file_upload_file_upload__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/file-upload/file-upload */ "./src/components/file-upload/file-upload.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MFileUpload", function() { return _components_file_upload_file_upload__WEBPACK_IMPORTED_MODULE_35__["MFileUpload"]; });

/* harmony import */ var _components_form_form__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./components/form/form */ "./src/components/form/form.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MForm", function() { return _components_form_form__WEBPACK_IMPORTED_MODULE_36__["MForm"]; });

/* harmony import */ var _components_form_form_plugin__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./components/form/form.plugin */ "./src/components/form/form.plugin.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormPlugin", function() { return _components_form_form_plugin__WEBPACK_IMPORTED_MODULE_37__["FormPlugin"]; });

/* harmony import */ var _components_i18n_i18n__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./components/i18n/i18n */ "./src/components/i18n/i18n.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MI18n", function() { return _components_i18n_i18n__WEBPACK_IMPORTED_MODULE_38__["MI18n"]; });

/* harmony import */ var _components_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./components/icon-button/icon-button */ "./src/components/icon-button/icon-button.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIconButtonSkin", function() { return _components_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_39__["MIconButtonSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIconButton", function() { return _components_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_39__["MIconButton"]; });

/* harmony import */ var _components_icon_file_icon_file__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./components/icon-file/icon-file */ "./src/components/icon-file/icon-file.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIconFile", function() { return _components_icon_file_icon_file__WEBPACK_IMPORTED_MODULE_40__["MIconFile"]; });

/* harmony import */ var _components_icon_icon__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./components/icon/icon */ "./src/components/icon/icon.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIcon", function() { return _components_icon_icon__WEBPACK_IMPORTED_MODULE_41__["MIcon"]; });

/* harmony import */ var _components_inplace_edit_inplace_edit__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./components/inplace-edit/inplace-edit */ "./src/components/inplace-edit/inplace-edit.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MInplaceEdit", function() { return _components_inplace_edit_inplace_edit__WEBPACK_IMPORTED_MODULE_42__["MInplaceEdit"]; });

/* harmony import */ var _components_input_group_input_group__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./components/input-group/input-group */ "./src/components/input-group/input-group.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMInputGroupValidationMessagePosition", function() { return _components_input_group_input_group__WEBPACK_IMPORTED_MODULE_43__["MMInputGroupValidationMessagePosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MInputGroup", function() { return _components_input_group_input_group__WEBPACK_IMPORTED_MODULE_43__["MInputGroup"]; });

/* harmony import */ var _components_integerfield_integerfield__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./components/integerfield/integerfield */ "./src/components/integerfield/integerfield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MIntegerfield", function() { return _components_integerfield_integerfield__WEBPACK_IMPORTED_MODULE_44__["MIntegerfield"]; });

/* harmony import */ var _components_limit_text_limit_text__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./components/limit-text/limit-text */ "./src/components/limit-text/limit-text.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MLimitText", function() { return _components_limit_text_limit_text__WEBPACK_IMPORTED_MODULE_45__["MLimitText"]; });

/* harmony import */ var _components_link_link__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./components/link/link */ "./src/components/link/link.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MLinkMode", function() { return _components_link_link__WEBPACK_IMPORTED_MODULE_46__["MLinkMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MLinkIconPosition", function() { return _components_link_link__WEBPACK_IMPORTED_MODULE_46__["MLinkIconPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MLinkSkin", function() { return _components_link_link__WEBPACK_IMPORTED_MODULE_46__["MLinkSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MLink", function() { return _components_link_link__WEBPACK_IMPORTED_MODULE_46__["MLink"]; });

/* harmony import */ var _components_list_item_list_item__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./components/list-item/list-item */ "./src/components/list-item/list-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MListItem", function() { return _components_list_item_list_item__WEBPACK_IMPORTED_MODULE_47__["MListItem"]; });

/* harmony import */ var _components_menu_menu__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./components/menu/menu */ "./src/components/menu/menu.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseMenu", function() { return _components_menu_menu__WEBPACK_IMPORTED_MODULE_48__["BaseMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMenuSkin", function() { return _components_menu_menu__WEBPACK_IMPORTED_MODULE_48__["MMenuSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMenu", function() { return _components_menu_menu__WEBPACK_IMPORTED_MODULE_48__["MMenu"]; });

/* harmony import */ var _components_menu_menu_item_menu_item__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./components/menu/menu-item/menu-item */ "./src/components/menu/menu-item/menu-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseMenuItem", function() { return _components_menu_menu_item_menu_item__WEBPACK_IMPORTED_MODULE_49__["BaseMenuItem"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMenuItem", function() { return _components_menu_menu_item_menu_item__WEBPACK_IMPORTED_MODULE_49__["MMenuItem"]; });

/* harmony import */ var _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./components/message-page/message-page */ "./src/components/message-page/message-page.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__["Link"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessagePageSkin", function() { return _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__["MMessagePageSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessagePageImageSize", function() { return _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__["MMessagePageImageSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessagePageState", function() { return _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__["MMessagePageState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessagePage", function() { return _components_message_page_message_page__WEBPACK_IMPORTED_MODULE_50__["MMessagePage"]; });

/* harmony import */ var _components_message_message__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./components/message/message */ "./src/components/message/message.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessageState", function() { return _components_message_message__WEBPACK_IMPORTED_MODULE_51__["MMessageState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessageSkin", function() { return _components_message_message__WEBPACK_IMPORTED_MODULE_51__["MMessageSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMessage", function() { return _components_message_message__WEBPACK_IMPORTED_MODULE_51__["MMessage"]; });

/* harmony import */ var _components_modal_modal__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./components/modal/modal */ "./src/components/modal/modal.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MModalSize", function() { return _components_modal_modal__WEBPACK_IMPORTED_MODULE_52__["MModalSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MModal", function() { return _components_modal_modal__WEBPACK_IMPORTED_MODULE_52__["MModal"]; });

/* harmony import */ var _components_moneyfield_moneyfield__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./components/moneyfield/moneyfield */ "./src/components/moneyfield/moneyfield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMoneyfield", function() { return _components_moneyfield_moneyfield__WEBPACK_IMPORTED_MODULE_53__["MMoneyfield"]; });

/* harmony import */ var _components_multi_select_multi_select__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./components/multi-select/multi-select */ "./src/components/multi-select/multi-select.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MMultiSelect", function() { return _components_multi_select_multi_select__WEBPACK_IMPORTED_MODULE_54__["MMultiSelect"]; });

/* harmony import */ var _components_navbar_navbar__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./components/navbar/navbar */ "./src/components/navbar/navbar.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseNavbar", function() { return _components_navbar_navbar__WEBPACK_IMPORTED_MODULE_55__["BaseNavbar"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MNavbarSkin", function() { return _components_navbar_navbar__WEBPACK_IMPORTED_MODULE_55__["MNavbarSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MNavbarMaxWidth", function() { return _components_navbar_navbar__WEBPACK_IMPORTED_MODULE_55__["MNavbarMaxWidth"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MNavbar", function() { return _components_navbar_navbar__WEBPACK_IMPORTED_MODULE_55__["MNavbar"]; });

/* harmony import */ var _components_navbar_navbar_item_navbar_item__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./components/navbar/navbar-item/navbar-item */ "./src/components/navbar/navbar-item/navbar-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MNavbarItem", function() { return _components_navbar_navbar_item_navbar_item__WEBPACK_IMPORTED_MODULE_56__["MNavbarItem"]; });

/* harmony import */ var _components_option_option__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./components/option/option */ "./src/components/option/option.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseOption", function() { return _components_option_option__WEBPACK_IMPORTED_MODULE_57__["BaseOption"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionsSkin", function() { return _components_option_option__WEBPACK_IMPORTED_MODULE_57__["MOptionsSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOption", function() { return _components_option_option__WEBPACK_IMPORTED_MODULE_57__["MOption"]; });

/* harmony import */ var _components_option_option_item_option_item__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./components/option/option-item/option-item */ "./src/components/option/option-item/option-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItem", function() { return _components_option_option_item_option_item__WEBPACK_IMPORTED_MODULE_58__["MOptionItem"]; });

/* harmony import */ var _components_option_option_item_option_item_add__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./components/option/option-item/option-item-add */ "./src/components/option/option-item/option-item-add.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItemAdd", function() { return _components_option_option_item_option_item_add__WEBPACK_IMPORTED_MODULE_59__["MOptionItemAdd"]; });

/* harmony import */ var _components_option_option_item_option_item_archive__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./components/option/option-item/option-item-archive */ "./src/components/option/option-item/option-item-archive.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItemArchive", function() { return _components_option_option_item_option_item_archive__WEBPACK_IMPORTED_MODULE_60__["MOptionItemArchive"]; });

/* harmony import */ var _components_option_option_item_option_item_delete__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./components/option/option-item/option-item-delete */ "./src/components/option/option-item/option-item-delete.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItemDelete", function() { return _components_option_option_item_option_item_delete__WEBPACK_IMPORTED_MODULE_61__["MOptionItemDelete"]; });

/* harmony import */ var _components_option_option_item_option_item_edit__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./components/option/option-item/option-item-edit */ "./src/components/option/option-item/option-item-edit.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItemEdit", function() { return _components_option_option_item_option_item_edit__WEBPACK_IMPORTED_MODULE_62__["MOptionItemEdit"]; });

/* harmony import */ var _components_option_option_item_option_item_predefined__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./components/option/option-item/option-item-predefined */ "./src/components/option/option-item/option-item-predefined.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionItemPredefined", function() { return _components_option_option_item_option_item_predefined__WEBPACK_IMPORTED_MODULE_63__["MOptionItemPredefined"]; });

/* harmony import */ var _components_option_option_separator_option_separator__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ./components/option/option-separator/option-separator */ "./src/components/option/option-separator/option-separator.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionSeparator", function() { return _components_option_option_separator_option_separator__WEBPACK_IMPORTED_MODULE_64__["MOptionSeparator"]; });

/* harmony import */ var _components_option_option_title_option_title__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ./components/option/option-title/option-title */ "./src/components/option/option-title/option-title.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOptionTitle", function() { return _components_option_option_title_option_title__WEBPACK_IMPORTED_MODULE_65__["MOptionTitle"]; });

/* harmony import */ var _components_organize_table_columns_modal_organize_table_columns_modal__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ./components/organize-table-columns-modal/organize-table-columns-modal */ "./src/components/organize-table-columns-modal/organize-table-columns-modal.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOrganizeTableColumnsModal", function() { return _components_organize_table_columns_modal_organize_table_columns_modal__WEBPACK_IMPORTED_MODULE_66__["MOrganizeTableColumnsModal"]; });

/* harmony import */ var _components_overlay_overlay__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ./components/overlay/overlay */ "./src/components/overlay/overlay.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOverlay", function() { return _components_overlay_overlay__WEBPACK_IMPORTED_MODULE_67__["MOverlay"]; });

/* harmony import */ var _components_pagination_pagination__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ./components/pagination/pagination */ "./src/components/pagination/pagination.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPagination", function() { return _components_pagination_pagination__WEBPACK_IMPORTED_MODULE_68__["MPagination"]; });

/* harmony import */ var _components_panel_panel__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ./components/panel/panel */ "./src/components/panel/panel.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPanelSkin", function() { return _components_panel_panel__WEBPACK_IMPORTED_MODULE_69__["MPanelSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPanel", function() { return _components_panel_panel__WEBPACK_IMPORTED_MODULE_69__["MPanel"]; });

/* harmony import */ var _components_periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ./components/periodpicker/periodpicker */ "./src/components/periodpicker/periodpicker.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MDateRange", function() { return _components_periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_70__["MDateRange"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPeriodpicker", function() { return _components_periodpicker_periodpicker__WEBPACK_IMPORTED_MODULE_70__["MPeriodpicker"]; });

/* harmony import */ var _components_popup_popup__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ./components/popup/popup */ "./src/components/popup/popup.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPopup", function() { return _components_popup_popup__WEBPACK_IMPORTED_MODULE_71__["MPopup"]; });

/* harmony import */ var _components_postalcodefield_postalcodefield__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ./components/postalcodefield/postalcodefield */ "./src/components/postalcodefield/postalcodefield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPostalCodeCountry", function() { return _components_postalcodefield_postalcodefield__WEBPACK_IMPORTED_MODULE_72__["MPostalCodeCountry"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPostalcodefield", function() { return _components_postalcodefield_postalcodefield__WEBPACK_IMPORTED_MODULE_72__["MPostalcodefield"]; });

/* harmony import */ var _components_progress_progress__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ./components/progress/progress */ "./src/components/progress/progress.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MProgressState", function() { return _components_progress_progress__WEBPACK_IMPORTED_MODULE_73__["MProgressState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MProgressSkin", function() { return _components_progress_progress__WEBPACK_IMPORTED_MODULE_73__["MProgressSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MProgress", function() { return _components_progress_progress__WEBPACK_IMPORTED_MODULE_73__["MProgress"]; });

/* harmony import */ var _components_radio_group_radio_group__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ./components/radio-group/radio-group */ "./src/components/radio-group/radio-group.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MRadioGroup", function() { return _components_radio_group_radio_group__WEBPACK_IMPORTED_MODULE_74__["MRadioGroup"]; });

/* harmony import */ var _components_radio_radio__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ./components/radio/radio */ "./src/components/radio/radio.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MRadioPosition", function() { return _components_radio_radio__WEBPACK_IMPORTED_MODULE_75__["MRadioPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MRadioVerticalAlignement", function() { return _components_radio_radio__WEBPACK_IMPORTED_MODULE_75__["MRadioVerticalAlignement"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseRadioGroup", function() { return _components_radio_radio__WEBPACK_IMPORTED_MODULE_75__["BaseRadioGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MRadio", function() { return _components_radio_radio__WEBPACK_IMPORTED_MODULE_75__["MRadio"]; });

/* harmony import */ var _components_rich_text_editor_rich_text_license_plugin__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ./components/rich-text-editor/rich-text-license-plugin */ "./src/components/rich-text-editor/rich-text-license-plugin.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RichTextLicensePlugin", function() { return _components_rich_text_editor_rich_text_license_plugin__WEBPACK_IMPORTED_MODULE_76__["default"]; });

/* harmony import */ var _components_rich_text_rich_text__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ./components/rich-text/rich-text */ "./src/components/rich-text/rich-text.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MRichText", function() { return _components_rich_text_rich_text__WEBPACK_IMPORTED_MODULE_77__["MRichText"]; });

/* harmony import */ var _components_scroll_top_scroll_top__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ./components/scroll-top/scroll-top */ "./src/components/scroll-top/scroll-top.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MScrollTopPosition", function() { return _components_scroll_top_scroll_top__WEBPACK_IMPORTED_MODULE_78__["MScrollTopPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MScrollTop", function() { return _components_scroll_top_scroll_top__WEBPACK_IMPORTED_MODULE_78__["MScrollTop"]; });

/* harmony import */ var _components_searchfield_searchfield__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ./components/searchfield/searchfield */ "./src/components/searchfield/searchfield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSearchfield", function() { return _components_searchfield_searchfield__WEBPACK_IMPORTED_MODULE_79__["MSearchfield"]; });

/* harmony import */ var _components_show_more_show_more__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ./components/show-more/show-more */ "./src/components/show-more/show-more.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MShowMore", function() { return _components_show_more_show_more__WEBPACK_IMPORTED_MODULE_80__["MShowMore"]; });

/* harmony import */ var _components_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ./components/sidebar/sidebar */ "./src/components/sidebar/sidebar.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSidebarOrigin", function() { return _components_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_81__["MSidebarOrigin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSidebarCloseButtonPosition", function() { return _components_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_81__["MSidebarCloseButtonPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSidebar", function() { return _components_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_81__["MSidebar"]; });

/* harmony import */ var _components_spinner_spinner__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ./components/spinner/spinner */ "./src/components/spinner/spinner.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSpinnerStyle", function() { return _components_spinner_spinner__WEBPACK_IMPORTED_MODULE_82__["MSpinnerStyle"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSpinnerSize", function() { return _components_spinner_spinner__WEBPACK_IMPORTED_MODULE_82__["MSpinnerSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PROCESSING_WARN", function() { return _components_spinner_spinner__WEBPACK_IMPORTED_MODULE_82__["PROCESSING_WARN"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSpinner", function() { return _components_spinner_spinner__WEBPACK_IMPORTED_MODULE_82__["MSpinner"]; });

/* harmony import */ var _components_steppers_steppers__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ./components/steppers/steppers */ "./src/components/steppers/steppers.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSteppers", function() { return _components_steppers_steppers__WEBPACK_IMPORTED_MODULE_83__["MSteppers"]; });

/* harmony import */ var _components_steppers_steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ./components/steppers/steppers-item/steppers-item */ "./src/components/steppers/steppers-item/steppers-item.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSteppersItemState", function() { return _components_steppers_steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_84__["MSteppersItemState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseSteppers", function() { return _components_steppers_steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_84__["BaseSteppers"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSteppersItem", function() { return _components_steppers_steppers_item_steppers_item__WEBPACK_IMPORTED_MODULE_84__["MSteppersItem"]; });

/* harmony import */ var _components_switch_switch__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ./components/switch/switch */ "./src/components/switch/switch.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSwitchPosition", function() { return _components_switch_switch__WEBPACK_IMPORTED_MODULE_85__["MSwitchPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSwitch", function() { return _components_switch_switch__WEBPACK_IMPORTED_MODULE_85__["MSwitch"]; });

/* harmony import */ var _components_table_header_table_header__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ./components/table-header/table-header */ "./src/components/table-header/table-header.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTableHeader", function() { return _components_table_header_table_header__WEBPACK_IMPORTED_MODULE_86__["MTableHeader"]; });

/* harmony import */ var _components_table_table__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ./components/table/table */ "./src/components/table/table.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTableSkin", function() { return _components_table_table__WEBPACK_IMPORTED_MODULE_87__["MTableSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MColumnSortDirection", function() { return _components_table_table__WEBPACK_IMPORTED_MODULE_87__["MColumnSortDirection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MColumnTextAlign", function() { return _components_table_table__WEBPACK_IMPORTED_MODULE_87__["MColumnTextAlign"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTable", function() { return _components_table_table__WEBPACK_IMPORTED_MODULE_87__["MTable"]; });

/* harmony import */ var _components_textarea_textarea__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ./components/textarea/textarea */ "./src/components/textarea/textarea.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTextarea", function() { return _components_textarea_textarea__WEBPACK_IMPORTED_MODULE_88__["MTextarea"]; });

/* harmony import */ var _components_textfield_textfield__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ./components/textfield/textfield */ "./src/components/textfield/textfield.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTextfieldType", function() { return _components_textfield_textfield__WEBPACK_IMPORTED_MODULE_89__["MTextfieldType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTextfield", function() { return _components_textfield_textfield__WEBPACK_IMPORTED_MODULE_89__["MTextfield"]; });

/* harmony import */ var _components_timepicker_timepicker__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ./components/timepicker/timepicker */ "./src/components/timepicker/timepicker.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTimepicker", function() { return _components_timepicker_timepicker__WEBPACK_IMPORTED_MODULE_90__["MTimepicker"]; });

/* harmony import */ var _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ./components/toast/toast */ "./src/components/toast/toast.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToastTimeout", function() { return _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__["MToastTimeout"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToastPosition", function() { return _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__["MToastPosition"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToastState", function() { return _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__["MToastState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToastDuration", function() { return _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__["MToastDuration"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToast", function() { return _components_toast_toast__WEBPACK_IMPORTED_MODULE_91__["MToast"]; });

/* harmony import */ var _components_toggle_buttons_toggle_buttons__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ./components/toggle-buttons/toggle-buttons */ "./src/components/toggle-buttons/toggle-buttons.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToggleButtonSkin", function() { return _components_toggle_buttons_toggle_buttons__WEBPACK_IMPORTED_MODULE_92__["MToggleButtonSkin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MToggleButtons", function() { return _components_toggle_buttons_toggle_buttons__WEBPACK_IMPORTED_MODULE_92__["MToggleButtons"]; });

/* harmony import */ var _components_tooltip_tooltip__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ./components/tooltip/tooltip */ "./src/components/tooltip/tooltip.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTooltipMode", function() { return _components_tooltip_tooltip__WEBPACK_IMPORTED_MODULE_93__["MTooltipMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTooltipSize", function() { return _components_tooltip_tooltip__WEBPACK_IMPORTED_MODULE_93__["MTooltipSize"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTooltip", function() { return _components_tooltip_tooltip__WEBPACK_IMPORTED_MODULE_93__["MTooltip"]; });

/* harmony import */ var _components_transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ./components/transitions/accordion-transition/accordion-transition */ "./src/components/transitions/accordion-transition/accordion-transition.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MAccordionTransition", function() { return _components_transitions_accordion_transition_accordion_transition__WEBPACK_IMPORTED_MODULE_94__["MAccordionTransition"]; });

/* harmony import */ var _components_transitions_opacity_transition_opacity_transition__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ./components/transitions/opacity-transition/opacity-transition */ "./src/components/transitions/opacity-transition/opacity-transition.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MOpacityTransition", function() { return _components_transitions_opacity_transition_opacity_transition__WEBPACK_IMPORTED_MODULE_95__["MOpacityTransition"]; });

/* harmony import */ var _components_transitions_slide_transition_slide_transition__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ./components/transitions/slide-transition/slide-transition */ "./src/components/transitions/slide-transition/slide-transition.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSlideTransitionDirection", function() { return _components_transitions_slide_transition_slide_transition__WEBPACK_IMPORTED_MODULE_96__["MSlideTransitionDirection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSlideTransition", function() { return _components_transitions_slide_transition_slide_transition__WEBPACK_IMPORTED_MODULE_96__["MSlideTransition"]; });

/* harmony import */ var _components_tree_tree__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ./components/tree/tree */ "./src/components/tree/tree.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MSelectionMode", function() { return _components_tree_tree__WEBPACK_IMPORTED_MODULE_97__["MSelectionMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MCheckboxes", function() { return _components_tree_tree__WEBPACK_IMPORTED_MODULE_97__["MCheckboxes"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTree", function() { return _components_tree_tree__WEBPACK_IMPORTED_MODULE_97__["MTree"]; });

/* harmony import */ var _components_typeahead_typeahead__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ./components/typeahead/typeahead */ "./src/components/typeahead/typeahead.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTypeahead", function() { return _components_typeahead_typeahead__WEBPACK_IMPORTED_MODULE_98__["MTypeahead"]; });

/* harmony import */ var _components_validation_message_validation_message__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ./components/validation-message/validation-message */ "./src/components/validation-message/validation-message.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MValidationMessage", function() { return _components_validation_message_validation_message__WEBPACK_IMPORTED_MODULE_99__["MValidationMessage"]; });

/* harmony import */ var _directives_badge_badge__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ./directives/badge/badge */ "./src/directives/badge/badge.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MBadgeState", function() { return _directives_badge_badge__WEBPACK_IMPORTED_MODULE_100__["MBadgeState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MBadgeDirective", function() { return _directives_badge_badge__WEBPACK_IMPORTED_MODULE_100__["MBadgeDirective"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DirectivesPlugin", function() { return _directives_directives_plugin__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _directives_i18n_i18n__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ./directives/i18n/i18n */ "./src/directives/i18n/i18n.ts");
/* empty/unused harmony star reexport *//* harmony import */ var _directives_popup_popup__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ./directives/popup/popup */ "./src/directives/popup/popup.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MPopupDirective", function() { return _directives_popup_popup__WEBPACK_IMPORTED_MODULE_102__["MPopupDirective"]; });

/* harmony import */ var _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(/*! ./directives/textarea-auto-height/textarea-auto-height */ "./src/directives/textarea-auto-height/textarea-auto-height.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MTextareaAutoHeight", function() { return _directives_textarea_auto_height_textarea_auto_height__WEBPACK_IMPORTED_MODULE_103__["MTextareaAutoHeight"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FiltersPlugin", function() { return _filters_filters_plugin__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(/*! ./filters/i18n/i18n */ "./src/filters/i18n/i18n.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i18nFilter", function() { return _filters_i18n_i18n__WEBPACK_IMPORTED_MODULE_104__["i18nFilter"]; });

/* harmony import */ var _utils_dialog_dialog_service_plugin__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(/*! ./utils/dialog/dialog-service.plugin */ "./src/utils/dialog/dialog-service.plugin.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DialogServicePlugin", function() { return _utils_dialog_dialog_service_plugin__WEBPACK_IMPORTED_MODULE_105__["default"]; });

/* harmony import */ var _utils_file_file__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(/*! ./utils/file/file */ "./src/utils/file/file.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileService", function() { return _utils_file_file__WEBPACK_IMPORTED_MODULE_106__["FileService"]; });

/* harmony import */ var _utils_form__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(/*! ./utils/form */ "./src/utils/form/index.ts");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _utils_form__WEBPACK_IMPORTED_MODULE_107__) if(["ComponentsPlugin","RichTextLicensePlugin","DirectivesPlugin","FiltersPlugin","DialogServicePlugin","FileService","HttpPlugin","HttpPluginOptions","DebugMode","I18nPlugin","ENGLISH","FRENCH","I18nPluginOptions","L10nPlugin","L10nPluginOptions","ConsoleOptions","LoggerPlugin","SpritesService","ToastServicePlugin","UtilsPlugin","UtilsPluginOptions","ModulComponentPlugin","MAccordionGroup","default","MAccordionSkin","MAccordionIconPosition","MAccordionIconSize","ACCORDION_CLOSEST_ELEMENTS","MAccordion","MAdd","MAutocomplete","MAvatarSize","MAvatar","MButtonType","MButtonSkin","MButtonIconPosition","MButton","CalendarMode","MCalendarType","MCalendar","MCarousel","MCharacterCount","MCheckboxPosition","MCheckboxVerticalAlignement","MCheckbox","MChipMode","MChipSize","MChip","MDatepickerDefaultView","MDatepicker","MDaterangepicker","MDecimalfield","MDialogWidth","MDialogState","MDialog","MDropdown","BaseDropdown","BaseDropdownGroup","MDropdownItem","MErrorAccessDenied","MErrorBrowserNotSupported","MErrorConfigNotSupported","MErrorOperationFailed","MErrorCookiesNotSupported","MErrorPageNotFound","MErrorResourceUnavailable","MErrorSessionExpired","MErrorTechnicalDifficulty","MExpandableLayoutPanelScrollMode","MExpandableLayoutPanelPosition","MExpandableLayout","MFileSelect","MFileUpload","MForm","FormPlugin","MI18n","MIconButtonSkin","MIconButton","MIconFile","MIcon","MInplaceEdit","MMInputGroupValidationMessagePosition","MInputGroup","MIntegerfield","MLimitText","MLinkMode","MLinkIconPosition","MLinkSkin","MLink","MListItem","BaseMenu","MMenuSkin","MMenu","BaseMenuItem","MMenuItem","Link","MMessagePageSkin","MMessagePageImageSize","MMessagePageState","MMessagePage","MMessageState","MMessageSkin","MMessage","MModalSize","MModal","MMoneyfield","MMultiSelect","BaseNavbar","MNavbarSkin","MNavbarMaxWidth","MNavbar","MNavbarItem","BaseOption","MOptionsSkin","MOption","MOptionItem","MOptionItemAdd","MOptionItemArchive","MOptionItemDelete","MOptionItemEdit","MOptionItemPredefined","MOptionSeparator","MOptionTitle","MOrganizeTableColumnsModal","MOverlay","MPagination","MPanelSkin","MPanel","MDateRange","MPeriodpicker","MPopup","MPostalCodeCountry","MPostalcodefield","MProgressState","MProgressSkin","MProgress","MRadioGroup","MRadioPosition","MRadioVerticalAlignement","BaseRadioGroup","MRadio","MRichText","MScrollTopPosition","MScrollTop","MSearchfield","MShowMore","MSidebarOrigin","MSidebarCloseButtonPosition","MSidebar","MSpinnerStyle","MSpinnerSize","PROCESSING_WARN","MSpinner","MSteppers","MSteppersItemState","BaseSteppers","MSteppersItem","MSwitchPosition","MSwitch","MTableHeader","MTableSkin","MColumnSortDirection","MColumnTextAlign","MTable","MTextarea","MTextfieldType","MTextfield","MTimepicker","MToastTimeout","MToastPosition","MToastState","MToastDuration","MToast","MToggleButtonSkin","MToggleButtons","MTooltipMode","MTooltipSize","MTooltip","MAccordionTransition","MOpacityTransition","MSlideTransitionDirection","MSlideTransition","MSelectionMode","MCheckboxes","MTree","MTypeahead","MValidationMessage","MBadgeState","MBadgeDirective","MPopupDirective","MTextareaAutoHeight","i18nFilter","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _utils_form__WEBPACK_IMPORTED_MODULE_107__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _utils_http_http__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(/*! ./utils/http/http */ "./src/utils/http/http.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpPlugin", function() { return _utils_http_http__WEBPACK_IMPORTED_MODULE_108__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HttpPluginOptions", function() { return _utils_http_http__WEBPACK_IMPORTED_MODULE_108__["HttpPluginOptions"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DebugMode", function() { return _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["DebugMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "I18nPlugin", function() { return _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ENGLISH", function() { return _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["ENGLISH"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FRENCH", function() { return _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["FRENCH"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "I18nPluginOptions", function() { return _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["I18nPluginOptions"]; });

/* harmony import */ var _utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(/*! ./utils/l10n/l10n */ "./src/utils/l10n/l10n.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "L10nPlugin", function() { return _utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_109__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "L10nPluginOptions", function() { return _utils_l10n_l10n__WEBPACK_IMPORTED_MODULE_109__["L10nPluginOptions"]; });

/* harmony import */ var _utils_logger_logger__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(/*! ./utils/logger/logger */ "./src/utils/logger/logger.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConsoleOptions", function() { return _utils_logger_logger__WEBPACK_IMPORTED_MODULE_110__["ConsoleOptions"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoggerPlugin", function() { return _utils_logger_logger__WEBPACK_IMPORTED_MODULE_110__["default"]; });

/* harmony import */ var _utils_svg_sprites__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(/*! ./utils/svg/sprites */ "./src/utils/svg/sprites.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SpritesService", function() { return _utils_svg_sprites__WEBPACK_IMPORTED_MODULE_111__["SpritesService"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ToastServicePlugin", function() { return _utils_toast_toast_service_plugin__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UtilsPlugin", function() { return _utils_utils_plugin__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UtilsPluginOptions", function() { return _utils_utils_plugin__WEBPACK_IMPORTED_MODULE_6__["UtilsPluginOptions"]; });








/**
 * we re-export components plugins, enums, props and others types here..
 * Everything listed here will be included in the packaged library
 */
/**
 * Components
 */































































































/**
 * directives
 */




/**
 * filters
 */


/**
 * Services and utils
 */










/**
 * @deprecated
 */
// tslint:disable-next-line: deprecation
var ModulComponentPlugin = {
    // tslint:disable-next-line: deprecation
    install: function (v, options) {
        if (options === void 0) { options = { curLang: _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["FRENCH"] }; }
        // tslint:disable-next-line: no-console
        console.warn('@deprecated ModulComponentPlugin will be removed in v2 , please use individual plugins instead');
        var utilsPluginOptions = {
            i18PluginOptions: {
                curLang: options.curLang
            },
            propagateVueParserErrors: false
        };
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_utils_plugin__WEBPACK_IMPORTED_MODULE_6__["default"], utilsPluginOptions);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_components_components_plugin__WEBPACK_IMPORTED_MODULE_1__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_directives_directives_plugin__WEBPACK_IMPORTED_MODULE_2__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_filters_filters_plugin__WEBPACK_IMPORTED_MODULE_3__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_utils_toast_toast_service_plugin__WEBPACK_IMPORTED_MODULE_5__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ModulComponentPlugin);


/***/ }),

/***/ "./src/mixins/element-queries/element-queries.ts":
/*!*******************************************************!*\
  !*** ./src/mixins/element-queries/element-queries.ts ***!
  \*******************************************************/
/*! exports provided: ElementQueriesBpMin, ElementQueriesBpMax, ElementQueries */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementQueriesBpMin", function() { return ElementQueriesBpMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementQueriesBpMax", function() { return ElementQueriesBpMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementQueries", function() { return ElementQueries; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var css_element_queries_src_ResizeSensor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! css-element-queries/src/ResizeSensor */ "css-element-queries/src/ResizeSensor");
/* harmony import */ var css_element_queries_src_ResizeSensor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(css_element_queries_src_ResizeSensor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");




var ElementQueriesBpMin;
(function (ElementQueriesBpMin) {
    ElementQueriesBpMin[ElementQueriesBpMin["XL"] = 1600] = "XL";
    ElementQueriesBpMin[ElementQueriesBpMin["L"] = 1200] = "L";
    ElementQueriesBpMin[ElementQueriesBpMin["M"] = 1024] = "M";
    ElementQueriesBpMin[ElementQueriesBpMin["S"] = 768] = "S";
    ElementQueriesBpMin[ElementQueriesBpMin["XS"] = 480] = "XS";
})(ElementQueriesBpMin || (ElementQueriesBpMin = {}));
var ElementQueriesBpMax;
(function (ElementQueriesBpMax) {
    ElementQueriesBpMax[ElementQueriesBpMax["XL"] = 1599] = "XL";
    ElementQueriesBpMax[ElementQueriesBpMax["L"] = 1199] = "L";
    ElementQueriesBpMax[ElementQueriesBpMax["M"] = 1023] = "M";
    ElementQueriesBpMax[ElementQueriesBpMax["S"] = 767] = "S";
    ElementQueriesBpMax[ElementQueriesBpMax["XS"] = 479] = "XS";
})(ElementQueriesBpMax || (ElementQueriesBpMax = {}));
var ElementQueries = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ElementQueries, _super);
    function ElementQueries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEqMinXL = false;
        _this.isEqMinL = false;
        _this.isEqMinM = false;
        _this.isEqMinS = false;
        _this.isEqMinXS = false;
        _this.isEqMaxXL = false;
        _this.isEqMaxL = false;
        _this.isEqMaxM = false;
        _this.isEqMaxS = false;
        _this.isEqMaxXS = false;
        _this.isEqS = false;
        _this.isEqM = false;
        _this.isEqL = false;
        _this.eqActive = true;
        return _this;
    }
    ElementQueries.prototype.mounted = function () {
        var _this = this;
        this.resizeElement(this.$el);
        this.resizeSensor = new css_element_queries_src_ResizeSensor__WEBPACK_IMPORTED_MODULE_1___default.a(this.$el, function () { return _this.resizeElement(_this.$el); });
    };
    ElementQueries.prototype.beforeDestroy = function () {
        if (this.resizeSensor !== undefined) {
            this.resizeSensor.detach();
            this.resizeSensor = undefined;
            delete this.resizeSensor;
        }
        this.$off('resize');
        this.$off('resizeDone');
    };
    ElementQueries.prototype.resizeElement = function (el) {
        var _this = this;
        if (this.eqActive) {
            var elWidth_1 = el.clientWidth;
            requestAnimationFrame(function () {
                _this.setEqMin(elWidth_1);
                _this.setEqMax(elWidth_1);
                _this.setEq(elWidth_1);
            });
            this.$emit('resize');
            clearTimeout(this.doneResizeEvent);
            this.doneResizeEvent = setTimeout(function () {
                _this.$emit('resizeDone');
            }, 200);
        }
        else {
            this.isEqMinXL = false;
            this.isEqMinL = false;
            this.isEqMinM = false;
            this.isEqMinS = false;
            this.isEqMinXS = false;
            this.isEqMaxXL = false;
            this.isEqMaxL = false;
            this.isEqMaxM = false;
            this.isEqMaxS = false;
            this.isEqMaxXS = false;
            this.isEqS = false;
            this.isEqM = false;
            this.isEqL = false;
        }
    };
    ElementQueries.prototype.setEqMin = function (elWidth) {
        // width >= XL
        if (elWidth >= ElementQueriesBpMin.XL) {
            if (!this.isEqMinXL) {
                this.isEqMinXL = true;
                this.$emit('isEqMinXL', true);
            }
        }
        else {
            if (this.isEqMinXL) {
                this.isEqMinXL = false;
                this.$emit('isEqMinXL', false);
            }
        }
        // width >= L
        if (elWidth >= ElementQueriesBpMin.L) {
            if (!this.isEqMinL) {
                this.isEqMinL = true;
                this.$emit('isEqMinL', true);
            }
        }
        else {
            if (this.isEqMinL) {
                this.isEqMinL = false;
                this.$emit('isEqMinL', false);
            }
        }
        // width >= M
        if (elWidth >= ElementQueriesBpMin.M) {
            if (!this.isEqMinM) {
                this.isEqMinM = true;
                this.$emit('isEqMinM', true);
            }
        }
        else {
            if (this.isEqMinM) {
                this.isEqMinM = false;
                this.$emit('isEqMinM', false);
            }
        }
        // width >= S
        if (elWidth >= ElementQueriesBpMin.S) {
            if (!this.isEqMinS) {
                this.isEqMinS = true;
                this.$emit('isEqMinS', true);
            }
        }
        else {
            if (this.isEqMinS) {
                this.isEqMinS = false;
                this.$emit('isEqMinS', false);
            }
        }
        // width >= XS
        if (elWidth >= ElementQueriesBpMin.XS) {
            if (!this.isEqMinXS) {
                this.isEqMinXS = true;
                this.$emit('isEqMinXS', true);
            }
        }
        else {
            if (this.isEqMinXS) {
                this.isEqMinXS = false;
                this.$emit('isEqMinXS', false);
            }
        }
    };
    ElementQueries.prototype.setEqMax = function (elWidth) {
        // width <= XL
        if (elWidth <= ElementQueriesBpMax.XL) {
            if (!this.isEqMaxXL) {
                this.isEqMaxXL = true;
                this.$emit('isEqMaxXL', true);
            }
        }
        else {
            if (this.isEqMaxXL) {
                this.isEqMaxXL = false;
                this.$emit('isEqMaxXL', false);
            }
        }
        // width <= L
        if (elWidth <= ElementQueriesBpMax.L) {
            if (!this.isEqMaxL) {
                this.isEqMaxL = true;
                this.$emit('isEqMaxL', true);
            }
        }
        else {
            if (this.isEqMaxL) {
                this.isEqMaxL = false;
                this.$emit('isEqMaxL', false);
            }
        }
        // width <= M
        if (elWidth <= ElementQueriesBpMax.M) {
            if (!this.isEqMaxM) {
                this.isEqMaxM = true;
                this.$emit('isEqMaxM', true);
            }
        }
        else {
            if (this.isEqMaxM) {
                this.isEqMaxM = false;
                this.$emit('isEqMaxM', false);
            }
        }
        // width <= S
        if (elWidth <= ElementQueriesBpMax.S) {
            if (!this.isEqMaxS) {
                this.isEqMaxS = true;
                this.$emit('isEqMaxS', true);
            }
        }
        else {
            if (this.isEqMaxS) {
                this.isEqMaxS = false;
                this.$emit('isEqMaxS', false);
            }
        }
        // width <= XS
        if (elWidth <= ElementQueriesBpMax.XS) {
            if (!this.isEqMaxXS) {
                this.isEqMaxXS = true;
                this.$emit('isEqMaxXS', true);
            }
        }
        else {
            if (this.isEqMaxXS) {
                this.isEqMaxXS = false;
                this.$emit('isEqMaxXS', false);
            }
        }
    };
    ElementQueries.prototype.setEq = function (elWidth) {
        // width >= minM && width <= maxL
        if (elWidth >= ElementQueriesBpMin.M && elWidth <= ElementQueriesBpMax.L) {
            if (!this.isEqL) {
                this.isEqL = true;
                this.$emit('isEqL', true);
            }
        }
        else {
            if (this.isEqL) {
                this.isEqL = false;
                this.$emit('isEqL', false);
            }
        }
        // width >= minS && width <= maxM
        if (elWidth >= ElementQueriesBpMin.S && elWidth <= ElementQueriesBpMax.M) {
            if (!this.isEqM) {
                this.isEqM = true;
                this.$emit('isEqM', true);
            }
        }
        else {
            if (this.isEqM) {
                this.isEqM = false;
                this.$emit('isEqM', false);
            }
        }
        // width >= minXS && width <= maxS
        if (elWidth >= ElementQueriesBpMin.XS && elWidth <= ElementQueriesBpMax.S) {
            if (!this.isEqS) {
                this.isEqS = true;
                this.$emit('isEqS', true);
            }
        }
        else {
            if (this.isEqS) {
                this.isEqS = false;
                this.$emit('isEqS', false);
            }
        }
    };
    ElementQueries = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], ElementQueries);
    return ElementQueries;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/input-label/input-label.ts":
/*!***********************************************!*\
  !*** ./src/mixins/input-label/input-label.ts ***!
  \***********************************************/
/*! exports provided: InputLabel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return InputLabel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");




var InputLabel = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InputLabel, _super);
    function InputLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputLabel.prototype, "hasLabel", {
        get: function () {
            return !!this.label;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputLabel.prototype, "label", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputLabel.prototype, "labelUp", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputLabel.prototype, "requiredMarker", void 0);
    InputLabel = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], InputLabel);
    return InputLabel;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/input-management/input-management.ts":
/*!*********************************************************!*\
  !*** ./src/mixins/input-management/input-management.ts ***!
  \*********************************************************/
/*! exports provided: InputManagement */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputManagement", function() { return InputManagement; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");




var InputManagement = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InputManagement, _super);
    function InputManagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trimWordWrap = false;
        _this.internalValue = '';
        _this.internalIsFocus = false;
        return _this;
    }
    InputManagement.prototype.emitClick = function (event) { };
    InputManagement.prototype.emitInput = function (internalValue) { };
    InputManagement.prototype.emitFocus = function (event) { };
    InputManagement.prototype.emitBlur = function (event) { };
    InputManagement.prototype.emitKeyup = function (event, model) { };
    InputManagement.prototype.emitKeydown = function (event) { };
    InputManagement.prototype.emitChange = function (model) { };
    InputManagement.prototype.emitPaste = function (event) { };
    InputManagement.prototype.mounted = function () {
        if (this.focus) {
            this.focusChanged(this.focus);
        }
    };
    InputManagement.prototype.focusInput = function () {
        var inputEl = this.as().getInput();
        if (inputEl) {
            inputEl.focus();
        }
    };
    Object.defineProperty(InputManagement.prototype, "hasValue", {
        get: function () {
            return !!(this.model || '').toString().trim();
        },
        enumerable: true,
        configurable: true
    });
    InputManagement.prototype.onClick = function (event) {
        this.internalIsFocus = this.as().active;
        var inputEl = this.as().getInput();
        if (this.internalIsFocus && inputEl) {
            inputEl.focus();
        }
        this.emitClick(event);
    };
    InputManagement.prototype.onFocus = function (event) {
        this.internalIsFocus = this.as().active;
        if (this.internalIsFocus) {
            this.emitFocus(event);
        }
    };
    InputManagement.prototype.onBlur = function (event) {
        this.internalIsFocus = false;
        this.emitBlur(event);
    };
    InputManagement.prototype.onKeyup = function (event) {
        if (this.as().active) {
            this.emitKeyup(event, this.model);
        }
    };
    InputManagement.prototype.onKeydown = function (event) {
        if (this.as().active) {
            this.emitKeydown(event);
        }
    };
    InputManagement.prototype.onChange = function (event) {
        this.emitChange(this.model);
    };
    InputManagement.prototype.onPaste = function (event) {
        this.emitPaste(event);
    };
    InputManagement.prototype.getTrimValue = function (value) {
        return /\n/g.test(value) && this.trimWordWrap ? value.replace(/\n/g, '') : value;
    };
    Object.defineProperty(InputManagement.prototype, "model", {
        get: function () {
            return this.internalValue;
        },
        set: function (value) {
            this.internalValue = this.getTrimValue(value);
            this.emitInput(this.internalValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputManagement.prototype, "isEmpty", {
        get: function () {
            return this.isFocus || this.hasValue ? false : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputManagement.prototype, "isFocus", {
        get: function () {
            return this.internalIsFocus;
        },
        enumerable: true,
        configurable: true
    });
    InputManagement.prototype.onValueChange = function (value) {
        this.internalValue = this.getTrimValue(this.value || '');
    };
    InputManagement.prototype.focusChanged = function (focus) {
        this.internalIsFocus = focus && this.as().active;
        var inputEl = this.as().getInput();
        if (inputEl) {
            if (this.internalIsFocus) {
                inputEl.focus();
            }
            else {
                inputEl.blur();
            }
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])(),
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Model"])('input')
    ], InputManagement.prototype, "value", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputManagement.prototype, "placeholder", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputManagement.prototype, "autocomplete", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputManagement.prototype, "focus", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], InputManagement.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('input')
    ], InputManagement.prototype, "emitInput", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('focus')
    ], InputManagement.prototype, "emitFocus", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('blur')
    ], InputManagement.prototype, "emitBlur", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('keyup')
    ], InputManagement.prototype, "emitKeyup", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('keydown')
    ], InputManagement.prototype, "emitKeydown", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('change')
    ], InputManagement.prototype, "emitChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('paste')
    ], InputManagement.prototype, "emitPaste", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('value', { immediate: true })
    ], InputManagement.prototype, "onValueChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('focus')
    ], InputManagement.prototype, "focusChanged", null);
    InputManagement = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], InputManagement);
    return InputManagement;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/input-popup/input-popup.ts":
/*!***********************************************!*\
  !*** ./src/mixins/input-popup/input-popup.ts ***!
  \***********************************************/
/*! exports provided: InputPopup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputPopup", function() { return InputPopup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/keycode/keycode */ "./src/utils/keycode/keycode.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _input_state_input_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../input-state/input-state */ "./src/mixins/input-state/input-state.ts");
/* harmony import */ var _media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");






var InputPopup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InputPopup, _super);
    function InputPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.internalValue = '';
        return _this;
    }
    InputPopup.prototype.inputOnKeydownEnter = function ($event) {
        if (!this.open) {
            this.open = true;
        }
        $event.preventDefault();
    };
    InputPopup.prototype.inputOnKeydownTab = function ($event) {
        if (this.as().isMqMinS) {
            this.open = false;
        }
    };
    InputPopup.prototype.inputOnKeydownDelete = function () {
        this.internalValue = '';
    };
    InputPopup.prototype.inputOnKeydown = function ($event) {
        // tslint:disable: deprecation
        if ($event.keyCode !== _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__["KeyCode"].M_RETURN &&
            $event.keyCode !== _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__["KeyCode"].M_ENTER &&
            $event.keyCode !== _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__["KeyCode"].M_TAB &&
            $event.keyCode !== _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__["KeyCode"].M_SHIFT &&
            $event.keyCode !== _utils_keycode_keycode__WEBPACK_IMPORTED_MODULE_2__["KeyCode"].M_ESCAPE && !this.open) {
            this.open = true;
        }
        // tslint:enable: deprecation
    };
    InputPopup.prototype.inputOnFocus = function () {
        if (!this.open && !this.as().isDisabled && this.as().isMqMinS) {
            this.open = true;
        }
    };
    Object.defineProperty(InputPopup.prototype, "isEmpty", {
        get: function () {
            return this.as().hasValue || (this.hasPlaceholder() && this.open) ? false : true;
        },
        enumerable: true,
        configurable: true
    });
    InputPopup.prototype.hasPlaceholder = function () {
        return this.placeholder !== undefined && this.placeholder !== '';
    };
    InputPopup = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [
                _input_state_input_state__WEBPACK_IMPORTED_MODULE_4__["InputState"],
                _media_queries_media_queries__WEBPACK_IMPORTED_MODULE_5__["MediaQueries"]
            ]
        })
    ], InputPopup);
    return InputPopup;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/input-state/input-state.ts":
/*!***********************************************!*\
  !*** ./src/mixins/input-state/input-state.ts ***!
  \***********************************************/
/*! exports provided: InputStateValue, InputStateTagStyle, InputState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputStateValue", function() { return InputStateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputStateTagStyle", function() { return InputStateTagStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputState", function() { return InputState; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");




var InputStateValue;
(function (InputStateValue) {
    InputStateValue["Default"] = "default";
    InputStateValue["Disabled"] = "disabled";
    InputStateValue["Readonly"] = "readonly";
    InputStateValue["Waiting"] = "waiting";
    InputStateValue["Error"] = "error";
    InputStateValue["Valid"] = "valid";
})(InputStateValue || (InputStateValue = {}));
var InputStateTagStyle;
(function (InputStateTagStyle) {
    InputStateTagStyle["Default"] = "default";
    InputStateTagStyle["H1"] = "h1";
    InputStateTagStyle["H2"] = "h2";
    InputStateTagStyle["H3"] = "h3";
    InputStateTagStyle["H4"] = "h4";
    InputStateTagStyle["H5"] = "h5";
    InputStateTagStyle["H6"] = "h6";
    InputStateTagStyle["P"] = "p";
})(InputStateTagStyle || (InputStateTagStyle = {}));
var InputState = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InputState, _super);
    function InputState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputState.prototype, "active", {
        get: function () {
            return !this.isDisabled && !this.isWaiting && !this.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isDisabled", {
        get: function () {
            return this.state === InputStateValue.Disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isReadonly", {
        get: function () {
            return this.state === InputStateValue.Readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isWaiting", {
        get: function () {
            return this.state === InputStateValue.Waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "hasError", {
        get: function () {
            return this.state === InputStateValue.Error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "isValid", {
        get: function () {
            return this.state === InputStateValue.Valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "state", {
        get: function () {
            if (this.waiting) {
                return InputStateValue.Waiting;
            }
            if (this.readonly) {
                return InputStateValue.Readonly;
            }
            if (this.disabled) {
                return InputStateValue.Disabled;
            }
            if (this.hasErrorMessage || this.error) {
                return InputStateValue.Error;
            }
            if (this.hasValidMessage || this.valid) {
                return InputStateValue.Valid;
            }
            return InputStateValue.Default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "hasErrorMessage", {
        get: function () {
            return (!!this.errorMessage || this.errorMessage === ' ') && !this.disabled && !this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "hasValidMessage", {
        get: function () {
            return (!!this.validMessage || this.validMessage === ' ') && !this.disabled && !this.waiting && !this.hasErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "hasHelperMessage", {
        get: function () {
            return (!!this.helperMessage || this.helperMessage === ' ') && !this.disabled && !this.waiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputState.prototype, "hasValidationMessage", {
        get: function () {
            return (this.hasErrorMessage || this.hasValidMessage || this.hasHelperMessage) && this.active;
        },
        enumerable: true,
        configurable: true
    });
    InputState.prototype.getInput = function () {
        var selector = this.as().selector || 'input, textarea, [contenteditable=true]';
        var elements = this.$el.querySelectorAll(selector);
        if (elements.length > 1) {
            throw new Error("Input state can manage 1 and only 1 nested editable element (" + selector + ")");
        }
        return elements[0];
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "waiting", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "error", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "valid", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "errorMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "validMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "helperMessage", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: InputStateTagStyle.Default,
            validator: function (value) {
                return value === InputStateTagStyle.Default ||
                    value === InputStateTagStyle.H1 ||
                    value === InputStateTagStyle.H2 ||
                    value === InputStateTagStyle.H3 ||
                    value === InputStateTagStyle.H4 ||
                    value === InputStateTagStyle.H5 ||
                    value === InputStateTagStyle.H6 ||
                    value === InputStateTagStyle.P;
            }
        })
    ], InputState.prototype, "tagStyle", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], InputState.prototype, "readonly", void 0);
    InputState = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], InputState);
    return InputState;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/input-width/input-width.ts":
/*!***********************************************!*\
  !*** ./src/mixins/input-width/input-width.ts ***!
  \***********************************************/
/*! exports provided: InputMaxWidth, InputMaxWidthValues, InputWidth */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaxWidth", function() { return InputMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaxWidthValues", function() { return InputMaxWidthValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputWidth", function() { return InputWidth; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");




var InputMaxWidth;
(function (InputMaxWidth) {
    InputMaxWidth["None"] = "none";
    InputMaxWidth["XSmall"] = "x-small";
    InputMaxWidth["Small"] = "small";
    InputMaxWidth["Regular"] = "regular";
    InputMaxWidth["Medium"] = "medium";
    InputMaxWidth["Large"] = "large";
})(InputMaxWidth || (InputMaxWidth = {}));
// input reference is minimum mobile width (320px), minus base padding (16px) from both sides.
// $m-min-width - $m-spacing * 2 = regular input width
var InputMaxWidthValues;
(function (InputMaxWidthValues) {
    InputMaxWidthValues["XSmall"] = "60px";
    InputMaxWidthValues["Small"] = "136px";
    InputMaxWidthValues["Regular"] = "288px";
    InputMaxWidthValues["Medium"] = "592px";
    InputMaxWidthValues["Large"] = "896px";
})(InputMaxWidthValues || (InputMaxWidthValues = {}));
var InputWidth = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InputWidth, _super);
    function InputWidth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputWidth.prototype, "inputMaxWidth", {
        get: function () {
            var maxWidth;
            switch (this.maxWidth) {
                case InputMaxWidth.None:
                    maxWidth = undefined;
                    break;
                case InputMaxWidth.XSmall:
                    maxWidth = InputMaxWidthValues.XSmall;
                    break;
                case InputMaxWidth.Small:
                    maxWidth = InputMaxWidthValues.Small;
                    break;
                case InputMaxWidth.Regular:
                    maxWidth = InputMaxWidthValues.Regular;
                    break;
                case InputMaxWidth.Medium:
                    maxWidth = InputMaxWidthValues.Medium;
                    break;
                case InputMaxWidth.Large:
                    maxWidth = InputMaxWidthValues.Large;
                    break;
                default:
                    maxWidth = this.maxWidth;
            }
            return maxWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputWidth.prototype, "inputWidth", {
        get: function () {
            return this.width === 'none' ? undefined : this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: '100%' })
    ], InputWidth.prototype, "width", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: InputMaxWidth.Regular })
    ], InputWidth.prototype, "maxWidth", void 0);
    InputWidth = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], InputWidth);
    return InputWidth;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/media-queries/media-queries.ts":
/*!***************************************************!*\
  !*** ./src/mixins/media-queries/media-queries.ts ***!
  \***************************************************/
/*! exports provided: MediaQueries */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaQueries", function() { return MediaQueries; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");



var MediaQueries = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MediaQueries, _super);
    function MediaQueries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mqState = _this.$mq ? _this.$mq.state : undefined;
        return _this;
    }
    Object.defineProperty(MediaQueries.prototype, "isMqMinXL", {
        get: function () {
            return this.$mq.state.isMqMinXL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqFromDesktop", {
        get: function () {
            return this.isMqMinXL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMinL", {
        get: function () {
            return this.$mq.state.isMqMinL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqFromLaptop", {
        get: function () {
            return this.isMqMinL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMinM", {
        get: function () {
            return this.$mq.state.isMqMinM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqFromTabletLandscape", {
        get: function () {
            return this.isMqMinM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMinS", {
        get: function () {
            return this.$mq.state.isMqMinS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqFromTabletPortrait", {
        get: function () {
            return this.isMqMinS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMinXS", {
        get: function () {
            return this.$mq.state.isMqMinXS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqFromPhonePortrait", {
        get: function () {
            return this.isMqMinXS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMaxXL", {
        get: function () {
            return this.$mq.state.isMqMaxXL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqLessThanDesktop", {
        get: function () {
            return this.isMqMaxXL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMaxL", {
        get: function () {
            return this.$mq.state.isMqMaxL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqLessThanLaptop", {
        get: function () {
            return this.isMqMaxL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMaxM", {
        get: function () {
            return this.$mq.state.isMqMaxM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqLessThanTabletLandscape", {
        get: function () {
            return this.isMqMaxM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMaxS", {
        get: function () {
            return this.$mq.state.isMqMaxS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqLessThanTabletPortrait", {
        get: function () {
            return this.isMqMaxS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqMaxXS", {
        get: function () {
            return this.$mq.state.isMqMaxXS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqLessThanPhonePortrait", {
        get: function () {
            return this.isMqMaxXS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqS", {
        get: function () {
            return this.$mq.state.isMqS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqM", {
        get: function () {
            return this.$mq.state.isMqM;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaQueries.prototype, "isMqL", {
        get: function () {
            return this.$mq.state.isMqL;
        },
        enumerable: true,
        configurable: true
    });
    MediaQueries = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default.a
    ], MediaQueries);
    return MediaQueries;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_2__["ModulVue"]));



/***/ }),

/***/ "./src/mixins/open-trigger/open-trigger.ts":
/*!*************************************************!*\
  !*** ./src/mixins/open-trigger/open-trigger.ts ***!
  \*************************************************/
/*! exports provided: MOpenTrigger, OpenTrigger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOpenTrigger", function() { return MOpenTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpenTrigger", function() { return OpenTrigger; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);



var MOpenTrigger;
(function (MOpenTrigger) {
    MOpenTrigger["Hover"] = "hover";
    MOpenTrigger["Click"] = "click";
    MOpenTrigger["Manual"] = "manual";
    MOpenTrigger["MouseDown"] = "mousedown";
})(MOpenTrigger || (MOpenTrigger = {}));
var OpenTrigger = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(OpenTrigger, _super);
    function OpenTrigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // should be initialized for reactivity (use of null instead of dummy class)
        // tslint:disable-next-line:no-null-keyword
        _this.internalTriggerHook = null;
        return _this;
    }
    Object.defineProperty(OpenTrigger.prototype, "triggerHook", {
        get: function () {
            return this.internalTriggerHook === null ? undefined : this.internalTriggerHook;
        },
        set: function (value) {
            this.internalTriggerHook = value;
        },
        enumerable: true,
        configurable: true
    });
    OpenTrigger = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], OpenTrigger);
    return OpenTrigger;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));



/***/ }),

/***/ "./src/mixins/portal/portal.ts":
/*!*************************************!*\
  !*** ./src/mixins/portal/portal.ts ***!
  \*************************************/
/*! exports provided: BackdropMode, PortalTransitionDuration, Portal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BackdropMode", function() { return BackdropMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortalTransitionDuration", function() { return PortalTransitionDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return Portal; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/mouse/mouse */ "./src/utils/mouse/mouse.ts");
/* harmony import */ var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/uuid/uuid */ "./src/utils/uuid/uuid.ts");
/* harmony import */ var _utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _media_queries_media_queries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../media-queries/media-queries */ "./src/mixins/media-queries/media-queries.ts");
/* harmony import */ var _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../open-trigger/open-trigger */ "./src/mixins/open-trigger/open-trigger.ts");








var BackdropMode;
(function (BackdropMode) {
    BackdropMode[BackdropMode["None"] = 0] = "None";
    BackdropMode[BackdropMode["ScrollOnly"] = 1] = "ScrollOnly";
    BackdropMode[BackdropMode["BackdropFast"] = 2] = "BackdropFast";
    BackdropMode[BackdropMode["BackdropSlow"] = 3] = "BackdropSlow";
})(BackdropMode || (BackdropMode = {}));
var PortalTransitionDuration;
(function (PortalTransitionDuration) {
    PortalTransitionDuration[PortalTransitionDuration["Fast"] = 200] = "Fast";
    PortalTransitionDuration[PortalTransitionDuration["Regular"] = 300] = "Regular";
    PortalTransitionDuration[PortalTransitionDuration["Slow"] = 450] = "Slow";
    PortalTransitionDuration[PortalTransitionDuration["XSlow"] = 600] = "XSlow";
})(PortalTransitionDuration || (PortalTransitionDuration = {}));
var Portal = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.internalTrigger = undefined;
        _this.propId = '';
        _this.internalOpen = false;
        _this.internalTransitionDuration = PortalTransitionDuration.Regular;
        _this.opening = false;
        _this.portalTargetCreated = false;
        _this.portalTargetMounted = false;
        return _this;
    }
    Portal.prototype.emitUpdateOpen = function (open) { };
    Portal.prototype.emitOpen = function () { };
    Portal.prototype.emitClose = function () { };
    Portal.prototype.emitPortalMounted = function () { };
    Portal.prototype.emitPortalAfterOpen = function () { };
    Portal.prototype.emitPortalAfterClose = function () { };
    Portal.prototype.emitClick = function (event) { };
    Portal.prototype.onOpenChange = function (open) {
        if (this.disabled || open === this.internalOpen) {
            return;
        }
        this.internalOpen = open;
        this.manageOpeningAndClosing(open);
    };
    Portal.prototype.setFocusToPortal = function () {
        if (this.as().handlesFocus()) {
            var el = this.as().getPortalElement();
            if (el) {
                var x = window.pageXOffset; // AEL-53
                var y = window.pageYOffset; // AEL-53
                el.setAttribute('tabindex', '0');
                el.focus();
                window.scrollTo(x, y); // AEL-53
                el.blur();
                el.removeAttribute('tabindex');
            }
        }
    };
    Portal.prototype.setFocusToTrigger = function () {
        if (this.as().handlesFocus() && this.internalTrigger) {
            this.internalTrigger.setAttribute('tabindex', '0');
            this.internalTrigger.focus();
            this.internalTrigger.blur();
            this.internalTrigger.removeAttribute('tabindex');
        }
    };
    Portal.prototype.getPortalElement = function () {
        return this.portalTargetEl;
    };
    Portal.prototype.getTrigger = function () {
        return this.internalTrigger;
    };
    Portal.prototype.tryClose = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$toast) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$toast.clear()];
                    case 1:
                        _a.sent(); // @todo Portal should not know toast
                        _a.label = 2;
                    case 2:
                        if (this.$modul.peekElement() === this.stackId) {
                            if (this.$listeners && this.$listeners.beforeClose) {
                                this.$emit('portal-before-close', function (close) {
                                    _this.propOpen = !close;
                                });
                            }
                            else {
                                this.propOpen = false;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Portal.prototype.created = function () {
        if (!this.$modul) {
            throw new Error('Portal mixin -> this.$modul is undefined, you must install the Modul plugin.');
        }
    };
    Portal.prototype.mounted = function () {
        this.portalTargetEl = document.getElementById(this.propId);
        this.handleTrigger();
        if (!this.lazy) {
            this.ensurePortalTargetEl();
        }
    };
    Portal.prototype.beforeDestroy = function () {
        this.propOpen = false;
        if (this.internalTrigger) {
            if (this.clickEventListener) {
                this.internalTrigger.removeEventListener('click', this.clickEventListener);
            }
            if (this.mouseenterEventListener) {
                this.internalTrigger.removeEventListener('mouseenter', this.mouseenterEventListener);
            }
            if (this.mousedownEventListener) {
                this.internalTrigger.removeEventListener('mousedown', this.mousedownEventListener);
            }
        }
        if (this.portalTargetEl && this.portalTargetEl.parentNode) {
            this.portalTargetEl.parentNode.removeChild(this.portalTargetEl);
            this.portalTargetCreated = false;
            this.portalTargetMounted = false;
        }
    };
    Object.defineProperty(Portal.prototype, "propOpen", {
        get: function () {
            if (this.internalOpen) {
                this.loaded = true;
            }
            return this.internalOpen;
        },
        set: function (open) {
            if (open !== this.internalOpen && !this.disabled) {
                this.manageOpeningAndClosing(open);
                this.internalOpen = open;
                this.emitUpdateOpen(open);
            }
        },
        enumerable: true,
        configurable: true
    });
    Portal.prototype.manageOpeningAndClosing = function (open) {
        var _this = this;
        if (open) {
            this.ensurePortalTargetEl(function () {
                if (_this.portalTargetEl) {
                    _this.stackId = _this.$modul.pushElement(_this.portalTargetEl, _this.as().getBackdropMode(), _this.as().isMqMaxS);
                    if (!_this.as().doCustomPropOpen(open, _this.portalTargetEl)) {
                        _this.portalTargetEl.style.position = 'absolute';
                        _this.portalTargetEl.style.top = '0';
                        _this.portalTargetEl.style.left = '0';
                        // this.opening is important since it's fix a race condition where the portal
                        // could appear behind the content of the page if it was toggled too quickly.
                        _this.opening = true;
                        setTimeout(function () {
                            _this.emitPortalAfterOpen();
                            _this.setFocusToPortal();
                            _this.opening = false;
                        }, _this.transitionDuration);
                    }
                    else {
                        _this.emitPortalAfterOpen();
                    }
                }
            });
            this.emitOpen();
        }
        else {
            if (this.portalTargetEl) {
                this.$modul.popElement(this.stackId);
                if (!this.as().doCustomPropOpen(open, this.portalTargetEl)) {
                    this.setFocusToTrigger();
                    setTimeout(function () {
                        // $emit update:open has been launched, animation already occurs
                        if (!_this.opening) {
                            _this.portalTargetEl.style.position = '';
                            _this.emitPortalAfterClose();
                        }
                    }, this.transitionDuration);
                }
                else {
                    this.emitPortalAfterClose();
                }
            }
            this.emitClose();
        }
    };
    Object.defineProperty(Portal.prototype, "transitionDuration", {
        get: function () {
            return this.internalTransitionDuration;
        },
        set: function (speed) {
            this.internalTransitionDuration = speed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Portal.prototype, "portalTargetSelector", {
        get: function () {
            return this.propId ? "#" + this.propId : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Portal.prototype, "portalCreated", {
        get: function () {
            return this.portalTargetCreated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Portal.prototype, "portalMounted", {
        get: function () {
            return (this.propOpen || this.preload || this.loaded) && (this.portalTargetMounted || !this.lazy);
        },
        enumerable: true,
        configurable: true
    });
    Portal.prototype.onTriggerChange = function () {
        this.handleTrigger();
    };
    Portal.prototype.onTriggerHookChange = function () {
        this.handleTrigger();
    };
    Portal.prototype.handleTrigger = function () {
        if (this.trigger) {
            this.internalTrigger = this.trigger;
        }
        else if (this.$slots.trigger && this.$slots.trigger[0]) {
            this.internalTrigger = this.$slots.trigger[0].elm;
        }
        else if (this.as().triggerHook) {
            this.internalTrigger = this.as().triggerHook;
        }
        if (this.internalTrigger) {
            switch (this.openTrigger) {
                case _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Click:
                    this.clickEventListener = this.toggle.bind(this);
                    this.internalTrigger.addEventListener('click', this.clickEventListener);
                    break;
                case _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].MouseDown:
                    this.mousedownEventListener = this.toggle.bind(this);
                    this.internalTrigger.addEventListener('mousedown', this.mousedownEventListener);
                    break;
                case _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Hover:
                    this.mouseenterEventListener = this.handleMouseEnter.bind(this);
                    this.internalTrigger.addEventListener('mouseenter', this.mouseenterEventListener);
                    // Closing not supported for the moment, check source code history for how was handled mouse leave
                    break;
            }
        }
    };
    Portal.prototype.toggle = function (event) {
        if (!this.disabled && event.button !== undefined && event.button === _utils_mouse_mouse__WEBPACK_IMPORTED_MODULE_3__["MouseButtons"].LEFT) {
            this.propOpen = !this.propOpen;
            this.emitClick(event);
        }
    };
    Portal.prototype.handleMouseEnter = function () {
        this.propOpen = true;
    };
    Portal.prototype.ensurePortalTargetEl = function (onPortalReady) {
        var _this = this;
        if (onPortalReady === void 0) { onPortalReady = function () { }; }
        if (!this.portalTargetEl) {
            this.propId = this.id === undefined ? 'mPortal-' + _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_4__["default"].generate() : this.id;
            this.portalTargetEl = document.createElement('div');
            this.portalTargetEl.setAttribute('id', this.propId);
            this.portalTargetEl.classList.add('m-u--app-body');
            document.body.appendChild(this.portalTargetEl);
            this.portalTargetCreated = true;
            // We wait for the portal creation / mounting.
            this.$nextTick(function () {
                _this.portalTargetMounted = true;
                _this.portalTargetEl = document.querySelector(_this.portalTargetSelector);
                _this.emitPortalMounted();
                onPortalReady();
            });
        }
        else {
            onPortalReady();
        }
    };
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({
            default: _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Click,
            validator: function (value) {
                return value === _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Click ||
                    value === _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Hover ||
                    value === _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].Manual ||
                    value === _open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["MOpenTrigger"].MouseDown;
            }
        })
    ], Portal.prototype, "openTrigger", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "open", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "id", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "disabled", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "trigger", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "className", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])()
    ], Portal.prototype, "preload", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Prop"])({ default: true })
    ], Portal.prototype, "lazy", void 0);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('update:open')
    ], Portal.prototype, "emitUpdateOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('open')
    ], Portal.prototype, "emitOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('close')
    ], Portal.prototype, "emitClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('portal-mounted')
    ], Portal.prototype, "emitPortalMounted", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('portal-after-open')
    ], Portal.prototype, "emitPortalAfterOpen", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('portal-after-close')
    ], Portal.prototype, "emitPortalAfterClose", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Emit"])('click')
    ], Portal.prototype, "emitClick", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('open', { immediate: true })
    ], Portal.prototype, "onOpenChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('trigger')
    ], Portal.prototype, "onTriggerChange", null);
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        Object(vue_property_decorator__WEBPACK_IMPORTED_MODULE_2__["Watch"])('internalTriggerHook')
    ], Portal.prototype, "onTriggerHookChange", null);
    Portal = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_1___default()({
            mixins: [_open_trigger_open_trigger__WEBPACK_IMPORTED_MODULE_7__["OpenTrigger"], _media_queries_media_queries__WEBPACK_IMPORTED_MODULE_6__["MediaQueries"]]
        })
    ], Portal);
    return Portal;
}(_utils_vue_vue__WEBPACK_IMPORTED_MODULE_5__["ModulVue"]));



/***/ }),

/***/ "./src/utils/clean/htmlClean.ts":
/*!**************************************!*\
  !*** ./src/utils/clean/htmlClean.ts ***!
  \**************************************/
/*! exports provided: eraseNewLines, filterByTag, filterByTags, replaceTag, replaceTags, eraseTag, eraseTags, eraseTagAndAllIsContent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eraseNewLines", function() { return eraseNewLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterByTag", function() { return filterByTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterByTags", function() { return filterByTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceTag", function() { return replaceTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceTags", function() { return replaceTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eraseTag", function() { return eraseTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eraseTags", function() { return eraseTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eraseTagAndAllIsContent", function() { return eraseTagAndAllIsContent; });
function createMultiTagsRegexString(tags) {
    // create a string for a multi tags regexp
    return "(" + tags.join('|') + ")";
}
function eraseNewLines(html) {
    if (typeof html === 'string') {
        return html.replace(/\n|\r/g, '');
    }
    return '';
}
function filterByTag(tag, html) {
    var regex = new RegExp("<" + tag + "([^>]*)>([^]*)</" + tag + ">", 'gmi');
    if (typeof html === 'string') {
        return html.replace(regex, '');
    }
    return '';
}
function filterByTags(tags, html) {
    return filterByTag(createMultiTagsRegexString(tags), html);
}
function replaceTag(tag, replace, html) {
    var openingTag = new RegExp("<" + tag + "([^>]*)>", 'gmi');
    if (typeof html === 'string') {
        return html.replace(openingTag, "<" + replace + ">").replace(tag + ">", replace + ">");
    }
    return '';
}
function replaceTags(tags, replace, html) {
    return replaceTag(createMultiTagsRegexString(tags), replace, html);
}
function eraseTag(tag, html) {
    var regex = new RegExp("(<" + tag + "([^>]*)>)|(</" + tag + ">)", 'gmi');
    if (typeof html === 'string') {
        return html.replace(regex, '');
    }
    return '';
}
function eraseTags(tags, html) {
    return eraseTag(createMultiTagsRegexString(tags), html);
}
function eraseTagAndAllIsContent(tag, html) {
    var regex = new RegExp("(<" + tag + "([^>]*)>)[^>]*(</" + tag + ">)", 'gmi');
    if (typeof html === 'string') {
        return html.replace(regex, '');
    }
    return '';
}


/***/ }),

/***/ "./src/utils/component/component-mixin.ts":
/*!************************************************!*\
  !*** ./src/utils/component/component-mixin.ts ***!
  \************************************************/
/*! exports provided: MComponentMixin, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MComponentMixin", function() { return MComponentMixin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../i18n/i18n */ "./src/utils/i18n/i18n.ts");




var MComponentMixin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MComponentMixin, _super);
    function MComponentMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MComponentMixin.prototype.beforeCreate = function () {
        var _this = this;
        if (this.$options.modul) {
            if (this.$options.modul.i18n) {
                if (!this.$i18n) {
                    throw new Error('You must install I18nPlugin to use the i18n option');
                }
                var i18nComponentOptions = this.$options.modul.i18n;
                var _loop_1 = function (key) {
                    if ([_i18n_i18n__WEBPACK_IMPORTED_MODULE_3__["FRENCH"], _i18n_i18n__WEBPACK_IMPORTED_MODULE_3__["ENGLISH"]].includes(key)) {
                        var msgs = i18nComponentOptions[key];
                        if (Array.isArray(msgs)) {
                            msgs.forEach(function (msg) {
                                _this.$i18n.addMessages(key, msg);
                            });
                        }
                        else {
                            this_1.$i18n.addMessages(key, msgs);
                        }
                    }
                    else {
                        throw new Error("Unknown lang " + key);
                    }
                };
                var this_1 = this;
                for (var key in i18nComponentOptions) {
                    _loop_1(key);
                }
            }
            if (this.$options.modul.sprites) {
                if (!this.$svg) {
                    throw new Error('You must install SpritesPlugin to use the sprites option');
                }
                var svgComponentOptions = this.$options.modul.sprites;
                if (svgComponentOptions.internalSprites) {
                    this.componentMixinsInternalSpriteIds = [];
                    if (Array.isArray(svgComponentOptions.internalSprites)) {
                        svgComponentOptions.internalSprites.forEach(function (sprite) {
                            _this.componentMixinsInternalSpriteIds.push(_this.$svg.addInternalSprites(sprite));
                        });
                    }
                    else {
                        this.componentMixinsInternalSpriteIds.push(this.$svg.addInternalSprites(svgComponentOptions.internalSprites));
                    }
                }
                else {
                    throw new Error("You must provide an internalSprites option");
                }
            }
        }
    };
    MComponentMixin.prototype.destroyed = function () {
        var _this = this;
        if (this.componentMixinsInternalSpriteIds && this.componentMixinsInternalSpriteIds.length > 0) {
            this.componentMixinsInternalSpriteIds.forEach(function (componentMixinsInternalSpriteId) {
                _this.$svg.removeInternalSprite(componentMixinsInternalSpriteId);
            });
        }
    };
    MComponentMixin = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], MComponentMixin);
    return MComponentMixin;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));

var ComponentMixinPlugin = {
    install: function (v, options) {
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.mixin(MComponentMixin);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ComponentMixinPlugin);


/***/ }),

/***/ "./src/utils/dialog/dialog-service.plugin.ts":
/*!***************************************************!*\
  !*** ./src/utils/dialog/dialog-service.plugin.ts ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _dialog_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dialog-service */ "./src/utils/dialog/dialog-service.ts");

var DialogServicePlugin = {
    install: function (v) {
        var dialog = new _dialog_service__WEBPACK_IMPORTED_MODULE_0__["DialogService"]();
        (v.prototype).$dialog = dialog;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (DialogServicePlugin);


/***/ }),

/***/ "./src/utils/dialog/dialog-service.ts":
/*!********************************************!*\
  !*** ./src/utils/dialog/dialog-service.ts ***!
  \********************************************/
/*! exports provided: DialogService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogService", function() { return DialogService; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../components/dialog/dialog */ "./src/components/dialog/dialog.ts");


var DialogService = /** @class */ (function () {
    function DialogService() {
    }
    /**
     *
     * @param message the message of the confirmation dialog
     * @param title a title label if any
     * @param okLabel a cancel label if any
     */
    DialogService.prototype.alert = function (message, title, okLabel) {
        var alertInstance = new _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialog"]({
            el: document.createElement('div')
        });
        document.body.appendChild(alertInstance.$el);
        alertInstance.message = message;
        alertInstance.okLabel = okLabel ? okLabel : undefined;
        alertInstance.title = title ? title : '';
        alertInstance.negativeLink = false;
        return this.show(alertInstance).then(function (result) {
            alertInstance.$destroy();
            return result;
        });
    };
    /**
     *
     * @param message the message of the confirmation dialog
     * @param title a title label if any
     * @param okLabel a ok label if any
     * @param cancelLabel a cancel label if any
     */
    DialogService.prototype.confirm = function (message, title, okLabel, cancelLabel) {
        var confirmInstance = new _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialog"]({
            el: document.createElement('div')
        });
        document.body.appendChild(confirmInstance.$el);
        confirmInstance.message = message;
        confirmInstance.state = _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialogState"].Confirmation;
        confirmInstance.title = title ? title : '';
        confirmInstance.okLabel = okLabel ? okLabel : undefined;
        confirmInstance.cancelLabel = cancelLabel ? cancelLabel : undefined;
        return this.show(confirmInstance).then(function (result) {
            confirmInstance.$destroy();
            return result;
        });
    };
    /**
     *
     * @param message the message of the confirmation dialog
     * @param state the dialog state
     * @param title a title label if any
     * @param okLabel a ok label if any
     * @param secBtn secBtn if any
     * @param secBtnLabel a secBtnLabel label if any
     * @param btnWidth a btnWidth if any
     * @param negativeLink negativeLink if any
     * @param cancelLabel a cancel label if any
     * @param width the width of the dialog if any
     */
    DialogService.prototype.generic = function (message, state, title, okLabel, secBtn, secBtnLabel, btnWidth, negativeLink, cancelLabel, width) {
        var genericInstance = new _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialog"]({
            el: document.createElement('div')
        });
        document.body.appendChild(genericInstance.$el);
        genericInstance.message = message;
        genericInstance.state = state ? state : _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialogState"].Default;
        genericInstance.title = title ? title : '';
        genericInstance.okLabel = okLabel ? okLabel : undefined;
        genericInstance.secBtn = secBtn ? secBtn : false;
        genericInstance.secBtnLabel = secBtnLabel ? secBtnLabel : undefined;
        genericInstance.btnWidth = btnWidth ? btnWidth : '100%';
        genericInstance.negativeLink = negativeLink ? negativeLink : true;
        genericInstance.cancelLabel = cancelLabel ? cancelLabel : undefined;
        genericInstance.width = width ? width : _components_dialog_dialog__WEBPACK_IMPORTED_MODULE_1__["MDialogWidth"].Default;
        return this.show(genericInstance).then(function (result) {
            genericInstance.$destroy();
            return result;
        });
    };
    /**
     *
     * @param mDialogInstance the MDialog instance
     * @param rejectOnCancel if true, the promise will be rejected on cancel
     */
    DialogService.prototype.show = function (mDialogInstance, rejectOnCancel) {
        return new Promise(function (resolve, reject) {
            var onOk = function () {
                if (mDialogInstance) {
                    unhook();
                }
                vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(function () {
                    resolve(true);
                });
            };
            var onCancel = function () {
                if (mDialogInstance) {
                    unhook();
                }
                vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(function () {
                    resolve(false);
                });
            };
            var onSecondaryBtn = function () {
                if (mDialogInstance) {
                    unhook();
                }
                vue__WEBPACK_IMPORTED_MODULE_0___default.a.nextTick(function () {
                    resolve(false);
                });
            };
            var hook = function () {
                if (mDialogInstance) {
                    mDialogInstance.$on('ok', onOk);
                    mDialogInstance.$on('cancel', onCancel);
                    mDialogInstance.$on('secondaryBtn', onSecondaryBtn);
                    mDialogInstance.openDialog();
                }
            };
            var unhook = function () {
                if (mDialogInstance) {
                    mDialogInstance.$off('ok', onOk);
                    mDialogInstance.$off('cancel', onCancel);
                    mDialogInstance.$off('secondaryBtn', onSecondaryBtn);
                }
            };
            if (mDialogInstance) {
                mDialogInstance.$nextTick(function () {
                    hook();
                });
            }
            else {
                console.error('No instance of dialog');
                reject();
            }
        });
    };
    return DialogService;
}());



/***/ }),

/***/ "./src/utils/enums/enums.ts":
/*!**********************************!*\
  !*** ./src/utils/enums/enums.ts ***!
  \**********************************/
/*! exports provided: Enums */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Enums", function() { return Enums; });
var Enums = /** @class */ (function () {
    function Enums() {
    }
    Enums.toValueArray = function (enumType) {
        return Object.keys(enumType).map(function (key) { return enumType[key]; });
    };
    Enums.toKeyValueArray = function (enumType) {
        return Object.keys(enumType).map(function (key) { return ({ key: key, value: enumType[key] }); });
    };
    return Enums;
}());



/***/ }),

/***/ "./src/utils/errors/window-error-handler.ts":
/*!**************************************************!*\
  !*** ./src/utils/errors/window-error-handler.ts ***!
  \**************************************************/
/*! exports provided: WindowErrorHandler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WindowErrorHandler", function() { return WindowErrorHandler; });
var WindowErrorHandler = /** @class */ (function () {
    function WindowErrorHandler() {
    }
    /**
     * Calls the window.onerror function. Use this method for errors that cannot be handled by the window.onerror standard handler.
     * Mostly, this method will be used to provide retroaction on Promise errors.
     * @param error The unhandled error.
     * @param defer True will delay the execution of the call to the next cyle, allowing, for example, stopping the propagation of the error in the promise chain. Default is false.
     */
    WindowErrorHandler.onError = function (error, defer) {
        if (defer === void 0) { defer = false; }
        var call = function () {
            if (!error.cancelBubble) {
                window.dispatchEvent(error);
            }
        };
        defer ? setTimeout(function () { return call(); }, 0) : call();
    };
    return WindowErrorHandler;
}());



/***/ }),

/***/ "./src/utils/event/event.ts":
/*!**********************************!*\
  !*** ./src/utils/event/event.ts ***!
  \**********************************/
/*! exports provided: targetIsInput */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "targetIsInput", function() { return targetIsInput; });
var targetIsInput = function (element, event) {
    var recursiveElement = event.target;
    while (recursiveElement && recursiveElement !== element) {
        if (['INPUT', 'TEXTAREA'].find(function (elem) { return elem === recursiveElement.tagName; }) || recursiveElement.contentEditable === 'true') {
            return true;
        }
        recursiveElement = recursiveElement.parentElement;
    }
    return false;
};


/***/ }),

/***/ "./src/utils/file/file.ts":
/*!********************************!*\
  !*** ./src/utils/file/file.ts ***!
  \********************************/
/*! exports provided: DEFAULT_STORE_NAME, MFileRejectionCause, MFileStatus, FileService, extractExtension, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_STORE_NAME", function() { return DEFAULT_STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFileRejectionCause", function() { return MFileRejectionCause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFileStatus", function() { return MFileStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileService", function() { return FileService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extractExtension", function() { return extractExtension; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../uuid/uuid */ "./src/utils/uuid/uuid.ts");




var DEFAULT_STORE_NAME = 'DEFAULT';
var MFileRejectionCause;
(function (MFileRejectionCause) {
    MFileRejectionCause["FILE_SIZE"] = "file-size";
    MFileRejectionCause["FILE_TYPE"] = "file-type";
    MFileRejectionCause["MAX_FILES"] = "max-files";
    MFileRejectionCause["CUSTOM_VALIDATION"] = "custom-validation";
})(MFileRejectionCause || (MFileRejectionCause = {}));
var MFileStatus;
(function (MFileStatus) {
    MFileStatus["READY"] = "ready";
    MFileStatus["UPLOADING"] = "uploading";
    MFileStatus["COMPLETED"] = "completed";
    MFileStatus["FAILED"] = "failed";
    MFileStatus["REJECTED"] = "rejected";
    MFileStatus["CANCELED"] = "canceled";
})(MFileStatus || (MFileStatus = {}));
var FileService = /** @class */ (function () {
    function FileService() {
        this.stores = {};
    }
    FileService.prototype.files = function (storeName) {
        return this.getStore(storeName).files;
    };
    FileService.prototype.setValidationOptions = function (options, storeName) {
        this.getStore(storeName).validationOptions = options;
    };
    FileService.prototype.add = function (files, storeName) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStore(storeName).add(files)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileService.prototype.addSingleFile = function (file, storeName) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStore(storeName).addSingleFile(file)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileService.prototype.remove = function (fileuid, storeName) {
        this.getStore(storeName).remove(fileuid);
    };
    FileService.prototype.clear = function (storeName) {
        this.getStore(storeName).clear();
    };
    FileService.prototype.destroy = function (storeName) {
        this.getStore(storeName).destroy();
        delete this.stores[this.getStoreName(storeName)];
    };
    FileService.prototype.upload = function (fileuid, options, storeName) {
        return this.getStore(storeName).upload(fileuid, options);
    };
    FileService.prototype.uploadTemp = function (files, storeName) {
        this.getStore(storeName).uploadTemp(files);
    };
    FileService.prototype.cancelUpload = function (fileuid, storeName) {
        this.getStore(storeName).cancelUpload(fileuid);
    };
    FileService.prototype.getStoreName = function (name) {
        return name ? name : DEFAULT_STORE_NAME;
    };
    FileService.prototype.getStore = function (name) {
        var storeName = this.getStoreName(name);
        var store = this.stores[storeName];
        if (!store) {
            store = this.stores[storeName] = new FileStore();
        }
        return store;
    };
    return FileService;
}());

function extractExtension(filename) {
    if (filename) {
        var match = filename.match(/\.([a-zA-Z0-9]{2,4})$/);
        return match ? match[1].toLowerCase() : '';
    }
    return '';
}
var FileStore = /** @class */ (function () {
    function FileStore() {
        this.filesmap = {};
        this.cancelTokens = {};
        this.rx = new vue__WEBPACK_IMPORTED_MODULE_2___default.a({
            data: {
                files: []
            }
        });
    }
    Object.defineProperty(FileStore.prototype, "validationOptions", {
        set: function (options) {
            this.options = options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileStore.prototype, "files", {
        get: function () {
            return this.rx.files;
        },
        enumerable: true,
        configurable: true
    });
    FileStore.prototype.getFile = function (uid) {
        return this.filesmap[uid];
    };
    FileStore.prototype.add = function (files) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var i;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < files.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.addSingleFile(files[i])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        ++i;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FileStore.prototype.addSingleFile = function (file) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createFile(file)];
                    case 1:
                        _a.sent();
                        this.refreshRx();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileStore.prototype.remove = function (uid) {
        delete this.filesmap[uid];
        this.refreshRx();
    };
    FileStore.prototype.clear = function () {
        this.filesmap = {};
        this.rx.files = [];
    };
    FileStore.prototype.destroy = function () {
        this.rx.$destroy();
    };
    FileStore.prototype.upload = function (fileuid, options) {
        var _this = this;
        var file = this.getFile(fileuid);
        var onUploadProgress = function (e) {
            file.progress = e.loaded / e.total * 100;
            if (options.onUploadProgress) {
                options.onUploadProgress(e);
            }
        };
        var httpService = vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$http;
        var cfg = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ method: 'POST', rawUrl: options.url, data: file.file, headers: {
                'Content-Type': file.file.type
            } }, options.config);
        var cancelToken = axios__WEBPACK_IMPORTED_MODULE_1___default.a.CancelToken.source();
        this.cancelTokens[fileuid] = cancelToken;
        var axiosOptions = {
            onUploadProgress: onUploadProgress,
            cancelToken: cancelToken.token
        };
        file.status = MFileStatus.UPLOADING;
        return httpService.execute(cfg, axiosOptions)
            .then(function (value) {
            file.status = MFileStatus.COMPLETED;
            file.progress = 100;
            return value;
        }, function (ex) {
            file.status = axios__WEBPACK_IMPORTED_MODULE_1___default.a.isCancel(ex)
                ? MFileStatus.CANCELED
                : MFileStatus.FAILED;
            if (file.status === MFileStatus.FAILED) {
                return Promise.reject(ex);
            }
        })
            .then(function (value) {
            delete _this.cancelTokens[fileuid];
            return value;
        });
    };
    FileStore.prototype.uploadTemp = function (files) {
        var _this = this;
        files.forEach(function (file) {
            var storeFile = _this.getFile(file.uid);
            storeFile.url = URL.createObjectURL(file.file);
            storeFile.status = MFileStatus.COMPLETED;
            storeFile.progress = 100;
        });
    };
    FileStore.prototype.cancelUpload = function (fileuid) {
        this.cancelTokens[fileuid].cancel();
        delete this.cancelTokens[fileuid];
    };
    FileStore.prototype.createFile = function (file) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var mfile;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mfile = {
                            uid: _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate(),
                            name: file.name,
                            file: file,
                            status: MFileStatus.READY,
                            progress: 0,
                            get extension() {
                                return extractExtension(file.name);
                            }
                        };
                        return [4 /*yield*/, this.validate(mfile)];
                    case 1:
                        _a.sent();
                        Object.freeze(mfile.file); // disable vuejs reactivity
                        this.filesmap[mfile.uid] = mfile;
                        return [2 /*return*/];
                }
            });
        });
    };
    FileStore.prototype.validate = function (file) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateExtension(file);
                        if (!this.options) {
                            return [2 /*return*/];
                        }
                        if (this.options.maxSizeKb) {
                            this.validateSize(file);
                        }
                        if (this.options.maxFiles) {
                            this.validateMaxFiles(file);
                        }
                        if (!(this.isExtensionSupported(file) && this.options.customValidationFunction)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.executeCustomValidation(file)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If the extension is not specified, it'll be rejected.
     * If the extension is a part of acceptedExtensions or if acceptedExtensions is empty or undefined, we accept all extensions.
     * If the extension is a part of rejectedExtensions, it'll be rejected.
     * If the extension is a part of the accepted and rejected extensions, it'll be rejected.
     */
    FileStore.prototype.validateExtension = function (file) {
        if (!this.isExtensionSupported(file)) {
            file.status = MFileStatus.REJECTED;
            file.rejection = MFileRejectionCause.FILE_TYPE;
        }
    };
    FileStore.prototype.isExtensionSupported = function (file) {
        var ext = extractExtension(file.file.name);
        return ext !== '' && !this.extensionInRejectedExtensions(ext) && this.extensionInAcceptedExtensions(ext);
    };
    FileStore.prototype.extensionInAcceptedExtensions = function (extension) {
        return this.options === undefined || this.options.allowedExtensions === undefined || this.options.allowedExtensions.length === 0 || this.options.allowedExtensions.indexOf(extension) !== -1;
    };
    FileStore.prototype.extensionInRejectedExtensions = function (extension) {
        return this.options !== undefined && this.options.rejectedExtensions !== undefined && this.options.rejectedExtensions.length > 0 && this.options.rejectedExtensions.indexOf(extension) !== -1;
    };
    FileStore.prototype.validateSize = function (file) {
        if (file.file.size / 1024 > this.options.maxSizeKb) {
            file.status = MFileStatus.REJECTED;
            file.rejection = MFileRejectionCause.FILE_SIZE;
        }
    };
    FileStore.prototype.validateMaxFiles = function (file) {
        var _this = this;
        var nbValidFiles = Object.keys(this.filesmap).reduce(function (t, uid) {
            var f = _this.filesmap[uid];
            return (t =
                f.status === MFileStatus.COMPLETED ||
                    f.status === MFileStatus.READY ||
                    f.status === MFileStatus.UPLOADING
                    ? t + 1
                    : t);
        }, 0);
        if (nbValidFiles >= this.options.maxFiles) {
            file.status = MFileStatus.REJECTED;
            file.rejection = MFileRejectionCause.MAX_FILES;
        }
    };
    FileStore.prototype.executeCustomValidation = function (file) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.options.customValidationFunction(file)];
                    case 1:
                        if (!(_a.sent())) {
                            file.status = MFileStatus.REJECTED;
                            file.rejection = MFileRejectionCause.CUSTOM_VALIDATION;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FileStore.prototype.refreshRx = function () {
        var files = [];
        for (var f in this.filesmap) {
            files.push(this.filesmap[f]);
        }
        this.rx.files = files;
    };
    return FileStore;
}());
var FilePlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('$file', 'plugin.install');
        var file = new FileService();
        (v.prototype).$file = file;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FilePlugin);


/***/ }),

/***/ "./src/utils/form/abstract-control.ts":
/*!********************************************!*\
  !*** ./src/utils/form/abstract-control.ts ***!
  \********************************************/
/*! exports provided: AbstractControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return AbstractControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _str_str__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../str/str */ "./src/utils/str/str.ts");
/* harmony import */ var _control_edition_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./control-edition-context */ "./src/utils/form/control-edition-context.ts");
/* harmony import */ var _validation_guard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./validation-guard */ "./src/utils/form/validation-guard.ts");




/**
 * This is the base class for `FormControl`, `FormGroup`, and `FormArray`.
 *
 */
var AbstractControl = /** @class */ (function () {
    function AbstractControl(validators, options) {
        if (validators === void 0) { validators = []; }
        this.validators = validators;
        this.htmlElementAccessor = function () { return undefined; };
        this._validationGuard = _validation_guard__WEBPACK_IMPORTED_MODULE_3__["DefaultValidationGuard"];
        this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].None;
        this._errors = [];
        this._waiting = false;
        this._enabled = true;
        this._readonly = false;
        this._pristine = true;
        this._touched = false;
        if (options) {
            if (options.validationGuard) {
                this._validationGuard = options.validationGuard;
            }
        }
    }
    Object.defineProperty(AbstractControl.prototype, "htmlElement", {
        get: function () {
            return this.htmlElementAccessor();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        get: function () {
            return this._pristine;
        },
        enumerable: true,
        configurable: true
    });
    AbstractControl.prototype.hasError = function () {
        return this.errors.length > 0;
    };
    AbstractControl.prototype.hasErrorDeep = function () {
        return this.errorsDeep.length > 0;
    };
    Object.defineProperty(AbstractControl.prototype, "errorMessage", {
        /**
         * Gets the first error message, if any, of the current control errors.
         * Children errors are excluded.
         */
        get: function () {
            if (this.hasError()) {
                return Object(_str_str__WEBPACK_IMPORTED_MODULE_1__["getString"])(this.errors[0].message);
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errorMessageDeep", {
        /**
         * Gets the first error message, if any, of one of the current control and children control errors.
         */
        get: function () {
            if (this.hasErrorDeep()) {
                return Object(_str_str__WEBPACK_IMPORTED_MODULE_1__["getString"])(this.errorsDeep[0].message);
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (parent) {
            this._parent = parent;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The submit method reset the edition context and runs all validations in
     * a downward manner from parents (FormGroup and FormArray) to childs (FormControl).
     */
    AbstractControl.prototype.submit = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].None;
                return [2 /*return*/];
            });
        });
    };
    AbstractControl.prototype.reset = function () {
        this._pristine = true;
        this.validators.forEach(function (v) { return v.lastCheck = undefined; });
        this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].None;
        this.errors = [];
    };
    AbstractControl.prototype.upwardValueChanged = function () {
        this._pristine = false;
        if (!this._hasAnyControlsInError() && this.enabled && !this.readonly) {
            this.validate();
        }
        if (this._parent) {
            this._parent.upwardValueChanged();
        }
    };
    AbstractControl.prototype.validate = function () {
        var _this = this;
        this.validators.map(function (v) {
            if (v.async
                ||
                    _this._validationGuard(_this._editionContext, v.validationType)) {
                return;
            }
            var validationResult = v.validationFunction(_this);
            if (!(validationResult instanceof Promise)) {
                v.lastCheck = validationResult;
            }
            else {
                throw new Error('if you are using a async validation function  you must set the async flag to true');
            }
        });
        this._updateErrors();
    };
    AbstractControl.prototype.validateAsync = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.validators
                            .map(function (v) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                            var validationResult, _a;
                            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!v.async
                                            ||
                                                this._validationGuard(this._editionContext, v.validationType)) {
                                            return [2 /*return*/];
                                        }
                                        validationResult = v.validationFunction(this);
                                        if (!(validationResult instanceof Promise)) return [3 /*break*/, 2];
                                        this._waiting = true;
                                        _a = v;
                                        return [4 /*yield*/, validationResult];
                                    case 1:
                                        _a.lastCheck = _b.sent();
                                        this._waiting = false;
                                        return [3 /*break*/, 3];
                                    case 2: throw new Error('Async validation function should return a Promise<boolan>');
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 1:
                        _a.sent();
                        this._updateErrors();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbstractControl.prototype.initEdition = function () {
        if (!this.enabled || this.readonly) {
            return;
        }
        if (this.errors.length > 0) {
            this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].HasErrors;
        }
        else if (this.pristine) {
            this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].Pristine;
        }
        else {
            this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].Dirty;
        }
        if (this._parent) {
            this._parent.initEdition();
        }
    };
    AbstractControl.prototype.endEdition = function () {
        if (!this.enabled || this.readonly) {
            return;
        }
        this._editionContext = _control_edition_context__WEBPACK_IMPORTED_MODULE_2__["ControlEditionContext"].None;
        this._updateErrors();
        if (!this.pristine && !this._hasAnyControlsInError()) {
            this.validate();
            this.validateAsync();
        }
        if (this._parent) {
            this._parent.endEdition();
        }
    };
    AbstractControl.prototype._updateErrors = function () {
        this.errors = this.validators.filter(function (v) { return v.lastCheck === false; }).map(function (v) { return v.error; });
    };
    AbstractControl.prototype._hasAnyControlsInError = function () {
        return false;
    };
    return AbstractControl;
}());



/***/ }),

/***/ "./src/utils/form/control-edition-context.ts":
/*!***************************************************!*\
  !*** ./src/utils/form/control-edition-context.ts ***!
  \***************************************************/
/*! exports provided: ControlEditionContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlEditionContext", function() { return ControlEditionContext; });
var ControlEditionContext;
(function (ControlEditionContext) {
    ControlEditionContext["None"] = "none";
    ControlEditionContext["Dirty"] = "dirty";
    ControlEditionContext["HasErrors"] = "has-errors";
    ControlEditionContext["Pristine"] = "pristine";
})(ControlEditionContext || (ControlEditionContext = {}));


/***/ }),

/***/ "./src/utils/form/control-error.ts":
/*!*****************************************!*\
  !*** ./src/utils/form/control-error.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {



/***/ }),

/***/ "./src/utils/form/control-options.ts":
/*!*******************************************!*\
  !*** ./src/utils/form/control-options.ts ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {



/***/ }),

/***/ "./src/utils/form/control-validator-validation-type.ts":
/*!*************************************************************!*\
  !*** ./src/utils/form/control-validator-validation-type.ts ***!
  \*************************************************************/
/*! exports provided: ControlValidatorValidationType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlValidatorValidationType", function() { return ControlValidatorValidationType; });
/**
 * @see https://wiki.dti.ulaval.ca/pages/viewpage.action?spaceKey=MODUL&title=Gestion+des+erreurs
 */
var ControlValidatorValidationType;
(function (ControlValidatorValidationType) {
    ControlValidatorValidationType["None"] = "none";
    ControlValidatorValidationType["AtExit"] = "at-exit";
    ControlValidatorValidationType["Correction"] = "correction";
    ControlValidatorValidationType["Modification"] = "modification";
    ControlValidatorValidationType["OnGoing"] = "on-going";
})(ControlValidatorValidationType || (ControlValidatorValidationType = {}));


/***/ }),

/***/ "./src/utils/form/form-array.ts":
/*!**************************************!*\
  !*** ./src/utils/form/form-array.ts ***!
  \**************************************/
/*! exports provided: FormArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return FormArray; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _abstract_control__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./abstract-control */ "./src/utils/form/abstract-control.ts");


var FormArray = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FormArray, _super);
    function FormArray(_controls, validators, options) {
        if (_controls === void 0) { _controls = []; }
        if (validators === void 0) { validators = []; }
        var _this = _super.call(this, validators, options) || this;
        _this._controls = _controls;
        _this.validators = validators;
        _this.setupControlsParent();
        return _this;
    }
    FormArray.prototype.setupControlsParent = function () {
        var _this = this;
        this.controls.forEach(function (c) { return c.parent = _this; });
    };
    Object.defineProperty(FormArray.prototype, "value", {
        /**
         * Return an agregate values of all enabled controls.
         */
        get: function () {
            return this._controls.filter(function (c) { return c.enabled; }).map(function (c) { return c.value; });
        },
        set: function (value) {
            throw Error('Assigning a value to a FormArray is not yet implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "valid", {
        get: function () {
            if (!this.enabled || this.readonly) {
                return true;
            }
            else {
                return (this.validators.every(function (v) { return !!v.lastCheck; })
                    &&
                        this._controls.every(function (c) { return c.valid; }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (isEnabled) {
            this._enabled = isEnabled;
            this._controls.forEach(function (c) { return c.enabled = isEnabled; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "waiting", {
        get: function () {
            return this._waiting;
        },
        set: function (isWaiting) {
            this._waiting = isWaiting;
            this._controls.forEach(function (c) { return c.waiting = isWaiting; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "readonly", {
        get: function () {
            return this._readonly;
        },
        set: function (isReadonly) {
            this._readonly = isReadonly;
            this._controls.forEach(function (c) { return c.readonly = isReadonly; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "touched", {
        get: function () {
            return this.controls.every(function (c) { return c.touched; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "errors", {
        get: function () {
            return (this.enabled && !this.readonly) ? this._errors : [];
        },
        set: function (errors) {
            this._errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArray.prototype, "errorsDeep", {
        get: function () {
            if (!this.enabled || this.readonly) {
                return [];
            }
            var errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.errors);
            this.controls.forEach(function (control) {
                errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(errors, control.errorsDeep);
            });
            return errors;
        },
        enumerable: true,
        configurable: true
    });
    FormArray.prototype.getControl = function (name) {
        throw Error('Getting a control from a FormArray is not yet implemented');
    };
    FormArray.prototype.submit = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.submit.call(this);
                        return [4 /*yield*/, Promise.all(this.controls.map(function (c) { return c.submit(); }))];
                    case 1:
                        _a.sent();
                        if (!!this._hasAnyControlsInError()) return [3 /*break*/, 3];
                        this.validate();
                        return [4 /*yield*/, this.validateAsync()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FormArray.prototype.reset = function () {
        _super.prototype.reset.call(this);
        this._controls.forEach(function (c) { return c.reset(); });
    };
    FormArray.prototype.initEdition = function () {
        _super.prototype.initEdition.call(this);
    };
    FormArray.prototype.endEdition = function () {
        if (!this.touched) {
            return;
        }
        _super.prototype.endEdition.call(this);
    };
    Object.defineProperty(FormArray.prototype, "controls", {
        get: function () {
            return this._controls;
        },
        enumerable: true,
        configurable: true
    });
    FormArray.prototype.addControl = function (control, indexInsertion) {
        if (indexInsertion === void 0) { indexInsertion = undefined; }
        control.parent = this;
        if (indexInsertion === undefined) {
            this._controls = this._controls.concat(control);
        }
        else {
            this._controls.splice(indexInsertion, 0, control);
        }
    };
    FormArray.prototype.removeControl = function (index) {
        if (this._controls[index] !== undefined) {
            var removedControl = this._controls.splice(index, 1)[0];
            return removedControl;
        }
        else {
            throw Error("There is no control with index= " + index + " in this array");
        }
    };
    FormArray.prototype._hasAnyControlsInError = function () {
        return this.controls.some(function (c) { return c.hasError(); });
    };
    return FormArray;
}(_abstract_control__WEBPACK_IMPORTED_MODULE_1__["AbstractControl"]));



/***/ }),

/***/ "./src/utils/form/form-control.ts":
/*!****************************************!*\
  !*** ./src/utils/form/form-control.ts ***!
  \****************************************/
/*! exports provided: FormControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return FormControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _abstract_control__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./abstract-control */ "./src/utils/form/abstract-control.ts");


var FormControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FormControl, _super);
    function FormControl(validators, options) {
        if (validators === void 0) { validators = []; }
        var _this = _super.call(this, validators, options) || this;
        _this.validators = validators;
        if (options) {
            if (options.initialValue !== undefined) {
                _this.initialValue = options.initialValue;
            }
        }
        else {
            // ensure reactivity
            _this._value = undefined;
        }
        return _this;
    }
    FormControl.prototype.clone = function (oldObject) {
        var newObject = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, oldObject);
        Object.setPrototypeOf(newObject, Object.getPrototypeOf(oldObject));
        return newObject;
    };
    Object.defineProperty(FormControl.prototype, "initialValue", {
        set: function (initialValue) {
            if (Array.isArray(initialValue)) {
                this._initialValue = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(initialValue);
                this._value = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(initialValue);
                this._oldValue = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(initialValue);
            }
            else if (initialValue instanceof Object) {
                this._initialValue = this.clone(initialValue);
                this._value = this.clone(initialValue);
                this._oldValue = this.clone(initialValue);
            }
            else {
                this._initialValue = initialValue;
                this._value = initialValue;
                this._oldValue = initialValue;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "touched", {
        get: function () {
            return this._touched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "controls", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    FormControl.prototype.getControl = function (name) {
        return undefined;
    };
    Object.defineProperty(FormControl.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (value === this.value && typeof value !== 'object') {
                return;
            }
            this._oldValue = this._value;
            this._value = value;
            this.upwardValueChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "valid", {
        get: function () {
            if (!this.enabled || this.readonly) {
                return true;
            }
            else {
                return this.validators.every(function (v) { return !!v.lastCheck; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (isEnabled) {
            this._enabled = isEnabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "waiting", {
        get: function () {
            return this._waiting;
        },
        set: function (isWaiting) {
            this._waiting = isWaiting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "readonly", {
        get: function () {
            return this._readonly;
        },
        set: function (isReadonly) {
            this._readonly = isReadonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "errors", {
        get: function () {
            return (this.enabled && !this.readonly) ? this._errors : [];
        },
        set: function (errors) {
            this._errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControl.prototype, "errorsDeep", {
        get: function () {
            return this.errors;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This specify the ennd of a edition context.
     */
    FormControl.prototype.endEdition = function () {
        this._touched = true;
        _super.prototype.endEdition.call(this);
    };
    /**
     * Reset the field to it's orginal pristine state.
     *
     * @param {T} [initialValue]  a new initial value for the field
     */
    FormControl.prototype.reset = function (initialValue) {
        _super.prototype.reset.call(this);
        this._touched = false;
        if (typeof initialValue === 'undefined') {
            this._value = this._initialValue;
            this._oldValue = this._initialValue;
        }
        else {
            this.initialValue = initialValue;
        }
    };
    /**
     * Run all validators
     *
     */
    FormControl.prototype.submit = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.submit.call(this);
                        this.validate();
                        return [4 /*yield*/, this.validateAsync()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return FormControl;
}(_abstract_control__WEBPACK_IMPORTED_MODULE_1__["AbstractControl"]));



/***/ }),

/***/ "./src/utils/form/form-group.ts":
/*!**************************************!*\
  !*** ./src/utils/form/form-group.ts ***!
  \**************************************/
/*! exports provided: FormGroup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _abstract_control__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./abstract-control */ "./src/utils/form/abstract-control.ts");



var FormGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FormGroup, _super);
    function FormGroup(_controls, validators, options) {
        if (validators === void 0) { validators = []; }
        var _this = _super.call(this, validators, options) || this;
        _this._controls = _controls;
        _this.validators = validators;
        _this.setupControlsParent();
        return _this;
    }
    Object.defineProperty(FormGroup.prototype, "value", {
        /**
         * Return an agregate values of all enabled controls.
         */
        get: function () {
            var _this = this;
            var values = {};
            var enabledControls = Object.keys(this._controls)
                .filter(function (c) { return _this._controls[c].enabled; })
                .reduce(function (obj, key) {
                obj[key] = _this._controls[key];
                return obj;
            }, {});
            Object.keys(enabledControls).map(function (c) { return values[c] = enabledControls[c].value; });
            return values;
        },
        set: function (value) {
            throw Error('Assigning a value to a FormGroup is not yet implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "valid", {
        get: function () {
            if (!this.enabled || this.readonly) {
                return true;
            }
            else {
                return (this.validators.every(function (v) { return !!v.lastCheck; })
                    &&
                        this.controls.every(function (c) { return c.valid; }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (isEnabled) {
            this._enabled = isEnabled;
            this.controls.forEach(function (c) { return c.enabled = isEnabled; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "waiting", {
        get: function () {
            return this._waiting;
        },
        set: function (isWaiting) {
            this._waiting = isWaiting;
            this.controls.forEach(function (c) { return c.waiting = isWaiting; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "readonly", {
        get: function () {
            return this._readonly;
        },
        set: function (isReadonly) {
            this._readonly = isReadonly;
            this.controls.forEach(function (c) { return c.readonly = isReadonly; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "errors", {
        get: function () {
            return (this.enabled && !this.readonly) ? this._errors : [];
        },
        set: function (errors) {
            this._errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "errorsDeep", {
        get: function () {
            if (!this.enabled || this.readonly) {
                return [];
            }
            var errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.errors);
            this.controls.forEach(function (control) {
                errors = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(errors, control.errorsDeep);
            });
            return errors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroup.prototype, "touched", {
        get: function () {
            return this.controls.every(function (c) { return c.touched; });
        },
        enumerable: true,
        configurable: true
    });
    FormGroup.prototype.submit = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.submit.call(this);
                        return [4 /*yield*/, Promise.all(this.controls.map(function (c) { return c.submit(); }))];
                    case 1:
                        _a.sent();
                        if (!!this._hasAnyControlsInError()) return [3 /*break*/, 3];
                        this.validate();
                        return [4 /*yield*/, this.validateAsync()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FormGroup.prototype.reset = function () {
        _super.prototype.reset.call(this);
        this.controls.forEach(function (c) { return c.reset(); });
    };
    FormGroup.prototype.endEdition = function () {
        if (!this.touched) {
            return;
        }
        _super.prototype.endEdition.call(this);
    };
    Object.defineProperty(FormGroup.prototype, "controls", {
        get: function () {
            return Object.values(this._controls);
        },
        enumerable: true,
        configurable: true
    });
    FormGroup.prototype.containsControl = function (name) {
        return typeof this._controls[name] !== 'undefined';
    };
    FormGroup.prototype.getControl = function (name) {
        if (this._controls[name] !== undefined) {
            return this._controls[name];
        }
        else {
            throw Error("There is no control with the name " + name + " in this group");
        }
    };
    FormGroup.prototype.addControl = function (name, control) {
        if (this._controls[name] !== undefined) {
            throw Error("There is already a control with name " + name + " in this group");
        }
        control.parent = this;
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$set(this._controls, name, control);
    };
    FormGroup.prototype.setControl = function (name, control) {
        control.parent = this;
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$set(this._controls, name, control);
    };
    FormGroup.prototype.removeControl = function (name) {
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$delete(this._controls, name);
    };
    FormGroup.prototype.setupControlsParent = function () {
        var _this = this;
        this.controls.forEach(function (c) { return c.parent = _this; });
    };
    FormGroup.prototype._hasAnyControlsInError = function () {
        return this.controls.some(function (c) { return c.hasError(); });
    };
    return FormGroup;
}(_abstract_control__WEBPACK_IMPORTED_MODULE_2__["AbstractControl"]));



/***/ }),

/***/ "./src/utils/form/index.ts":
/*!*********************************!*\
  !*** ./src/utils/form/index.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _abstract_control__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./abstract-control */ "./src/utils/form/abstract-control.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return _abstract_control__WEBPACK_IMPORTED_MODULE_0__["AbstractControl"]; });

/* harmony import */ var _control_edition_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./control-edition-context */ "./src/utils/form/control-edition-context.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ControlEditionContext", function() { return _control_edition_context__WEBPACK_IMPORTED_MODULE_1__["ControlEditionContext"]; });

/* harmony import */ var _control_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./control-error */ "./src/utils/form/control-error.ts");
/* harmony import */ var _control_error__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_control_error__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _control_error__WEBPACK_IMPORTED_MODULE_2__) if(["AbstractControl","ControlEditionContext","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _control_error__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _control_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./control-options */ "./src/utils/form/control-options.ts");
/* harmony import */ var _control_options__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_control_options__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _control_options__WEBPACK_IMPORTED_MODULE_3__) if(["AbstractControl","ControlEditionContext","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _control_options__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ControlValidatorValidationType", function() { return _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_4__["ControlValidatorValidationType"]; });

/* harmony import */ var _form_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./form-array */ "./src/utils/form/form-array.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return _form_array__WEBPACK_IMPORTED_MODULE_5__["FormArray"]; });

/* harmony import */ var _form_control__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./form-control */ "./src/utils/form/form-control.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return _form_control__WEBPACK_IMPORTED_MODULE_6__["FormControl"]; });

/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./form-group */ "./src/utils/form/form-group.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return _form_group__WEBPACK_IMPORTED_MODULE_7__["FormGroup"]; });

/* harmony import */ var _validators__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./validators */ "./src/utils/form/validators/index.ts");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _validators__WEBPACK_IMPORTED_MODULE_8__) if(["AbstractControl","ControlEditionContext","ControlValidatorValidationType","FormArray","FormControl","FormGroup","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _validators__WEBPACK_IMPORTED_MODULE_8__[key]; }) }(__WEBPACK_IMPORT_KEY__));











/***/ }),

/***/ "./src/utils/form/validation-guard.ts":
/*!********************************************!*\
  !*** ./src/utils/form/validation-guard.ts ***!
  \********************************************/
/*! exports provided: DefaultValidationGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValidationGuard", function() { return DefaultValidationGuard; });
/* harmony import */ var _control_edition_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./control-edition-context */ "./src/utils/form/control-edition-context.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");


var DefaultValidationGuard = function (editionContext, validationType) {
    var guard = new Map([
        [
            _control_edition_context__WEBPACK_IMPORTED_MODULE_0__["ControlEditionContext"].Pristine, [
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].None,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].AtExit,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].Correction,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].Modification
            ]
        ],
        [
            _control_edition_context__WEBPACK_IMPORTED_MODULE_0__["ControlEditionContext"].Dirty, [
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].None,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].AtExit,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].Correction
            ]
        ],
        [
            _control_edition_context__WEBPACK_IMPORTED_MODULE_0__["ControlEditionContext"].HasErrors, [
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].None,
                _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_1__["ControlValidatorValidationType"].AtExit
            ]
        ],
        [
            _control_edition_context__WEBPACK_IMPORTED_MODULE_0__["ControlEditionContext"].None, []
        ]
    ]);
    return guard.get(editionContext).includes(validationType);
};


/***/ }),

/***/ "./src/utils/form/validators/between/between.ts":
/*!******************************************************!*\
  !*** ./src/utils/form/validators/between/between.ts ***!
  \******************************************************/
/*! exports provided: BetweenValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BetweenValidator", function() { return BetweenValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param lowerBound Minimum value of the range within which the value must be to be valid. Inclusive.
 * @param upperBound Maximum value of the range within which the value must be to be valid. Inclusive.
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var BetweenValidator = function (lowerBound, upperBound, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Between,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the between validator should not be attached to a form group');
            }
            var isBetween;
            if (!control.value && control.value !== 0) {
                isBetween = true;
            }
            else {
                var value = control.value;
                isBetween = value >= lowerBound && value <= upperBound;
            }
            return isBetween;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:betweenValidatorErrorMessage', {
                lowerBound: lowerBound,
                upperBound: upperBound
            }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:betweenValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    lowerBound: lowerBound,
                    upperBound: upperBound
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/compare/compare.ts":
/*!******************************************************!*\
  !*** ./src/utils/form/validators/compare/compare.ts ***!
  \******************************************************/
/*! exports provided: CompareValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompareValidator", function() { return CompareValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-control */ "./src/utils/form/form-control.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param controlNames
 * @param controlLabels
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var CompareValidator = function (controlNames, controlLabels, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Compare,
        validationFunction: function (control) {
            if (control instanceof _form_control__WEBPACK_IMPORTED_MODULE_3__["FormControl"]) {
                throw Error('the compare controls validator should not be attached to a form control');
            }
            return controlNames
                .map(function (cn) { return control.getControl(cn); })
                .every(function (fc) {
                var source = (fc.value !== undefined ? fc.value : '');
                var target = (control.controls[0].value !== undefined ? control.controls[0].value : '');
                return source === target;
            });
        },
        error: options && options.error ?
            options.error : {
            message: options && controlLabels ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:compareValidatorErrorMessage', { controlNames: controlLabels.join(', ') }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf) :
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:compareValidatorErrorMessageNoName', undefined, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && controlLabels ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:compareValidatorErrorMessage', { controlNames: controlLabels.join(', ') }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/control-validator.ts":
/*!********************************************************!*\
  !*** ./src/utils/form/validators/control-validator.ts ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {



/***/ }),

/***/ "./src/utils/form/validators/date-between/date-between.ts":
/*!****************************************************************!*\
  !*** ./src/utils/form/validators/date-between/date-between.ts ***!
  \****************************************************************/
/*! exports provided: DateBetweenValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateBetweenValidator", function() { return DateBetweenValidator; });
/* harmony import */ var _filters_date_date_date__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../filters/date/date/date */ "./src/filters/date/date/date.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../modul-date/modul-date */ "./src/utils/modul-date/modul-date.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");







/**
 *
 * @param start Start of the period during witch the date must be to be valid. Inclusive.
 * @param end End of the period during witch the date must be to be valid. Inclusive.
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var DateBetweenValidator = function (start, end, options) {
    var startFormatted = Object(_filters_date_date_date__WEBPACK_IMPORTED_MODULE_0__["dateFilter"])(new _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__["default"](start).toDate());
    var endFormatted = Object(_filters_date_date_date__WEBPACK_IMPORTED_MODULE_0__["dateFilter"])(new _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__["default"](end).toDate());
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_6__["ValidatorKeys"].Date,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_5__["FormGroup"]) {
                throw Error('the DateBetweenValidator should not be attached to a form group');
            }
            if (!control.value || (control.value.length < 10) || isNaN(Date.parse(control.value))) {
                return true;
            }
            else {
                var formControlDate = new _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__["default"](control.value);
                return formControlDate.isBetween(new _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__["default"](start), new _modul_date_modul_date__WEBPACK_IMPORTED_MODULE_2__["default"](end));
            }
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"].prototype.$i18n).translate('m-form:dateBetweenValidatorErrorMessage', {
                start: startFormatted,
                end: endFormatted
            }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_1__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_3__["ModulVue"].prototype.$i18n).translate('m-form:dateBetweenValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    start: startFormatted,
                    end: endFormatted
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_1__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_4__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/date-format/date-format.ts":
/*!**************************************************************!*\
  !*** ./src/utils/form/validators/date-format/date-format.ts ***!
  \**************************************************************/
/*! exports provided: DateFormatValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateFormatValidator", function() { return DateFormatValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var DateFormatValidator = function (options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Date,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the DateValidator should not be attached to a form group');
            }
            if (!control.value) {
                return true;
            }
            else {
                if (control.value.length < 10) {
                    return true;
                }
                else {
                    return !isNaN(Date.parse(control.value));
                }
            }
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:dateFormatValidatorErrorMessage', undefined, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:dateFormValidatorErrorSummaryMessage', { controlLabel: options.controlLabel }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].OnGoing
    };
};


/***/ }),

/***/ "./src/utils/form/validators/email/email.ts":
/*!**************************************************!*\
  !*** ./src/utils/form/validators/email/email.ts ***!
  \**************************************************/
/*! exports provided: EmailValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return EmailValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var EmailValidator = function (options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Email,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the email validator should not be attached to a form group');
            }
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return control.value ? re.test(String(control.value).toLowerCase()) : true;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:emailValidatorErrorMessage'),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:emailValidatorErrorSummaryMessage', { controlLabel: options.controlLabel }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/index.ts":
/*!********************************************!*\
  !*** ./src/utils/form/validators/index.ts ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _between_between__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./between/between */ "./src/utils/form/validators/between/between.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BetweenValidator", function() { return _between_between__WEBPACK_IMPORTED_MODULE_0__["BetweenValidator"]; });

/* harmony import */ var _compare_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./compare/compare */ "./src/utils/form/validators/compare/compare.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CompareValidator", function() { return _compare_compare__WEBPACK_IMPORTED_MODULE_1__["CompareValidator"]; });

/* harmony import */ var _control_validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./control-validator */ "./src/utils/form/validators/control-validator.ts");
/* harmony import */ var _control_validator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_control_validator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _control_validator__WEBPACK_IMPORTED_MODULE_2__) if(["BetweenValidator","CompareValidator","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _control_validator__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _date_between_date_between__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./date-between/date-between */ "./src/utils/form/validators/date-between/date-between.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateBetweenValidator", function() { return _date_between_date_between__WEBPACK_IMPORTED_MODULE_3__["DateBetweenValidator"]; });

/* harmony import */ var _date_format_date_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./date-format/date-format */ "./src/utils/form/validators/date-format/date-format.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateFormatValidator", function() { return _date_format_date_format__WEBPACK_IMPORTED_MODULE_4__["DateFormatValidator"]; });

/* harmony import */ var _email_email__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./email/email */ "./src/utils/form/validators/email/email.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return _email_email__WEBPACK_IMPORTED_MODULE_5__["EmailValidator"]; });

/* harmony import */ var _max_length_max_length__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./max-length/max-length */ "./src/utils/form/validators/max-length/max-length.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return _max_length_max_length__WEBPACK_IMPORTED_MODULE_6__["MaxLengthValidator"]; });

/* harmony import */ var _max_max__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./max/max */ "./src/utils/form/validators/max/max.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MaxValidator", function() { return _max_max__WEBPACK_IMPORTED_MODULE_7__["MaxValidator"]; });

/* harmony import */ var _min_length_min_length__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./min-length/min-length */ "./src/utils/form/validators/min-length/min-length.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return _min_length_min_length__WEBPACK_IMPORTED_MODULE_8__["MinLengthValidator"]; });

/* harmony import */ var _min_min__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./min/min */ "./src/utils/form/validators/min/min.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MinValidator", function() { return _min_min__WEBPACK_IMPORTED_MODULE_9__["MinValidator"]; });

/* harmony import */ var _required_required__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./required/required */ "./src/utils/form/validators/required/required.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return _required_required__WEBPACK_IMPORTED_MODULE_10__["RequiredValidator"]; });

/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorKeys", function() { return _validator_error_keys__WEBPACK_IMPORTED_MODULE_11__["ValidatorKeys"]; });















/***/ }),

/***/ "./src/utils/form/validators/max-length/max-length.ts":
/*!************************************************************!*\
  !*** ./src/utils/form/validators/max-length/max-length.ts ***!
  \************************************************************/
/*! exports provided: MaxLengthValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param maxLength Max length (inclusive)
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var MaxLengthValidator = function (maxLength, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].MaxLength,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the max length validator should not be attached to a form group');
            }
            var isMaxLength;
            if (!control.value) {
                isMaxLength = true;
            }
            else if (!isNaN(control.value)) {
                isMaxLength = control.value.toString().length <= maxLength;
            }
            else {
                isMaxLength = control.value.length <= maxLength;
            }
            return isMaxLength;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:maxLengthValidatorErrorMessage', { maxLength: maxLength }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:maxLengthValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    maxLength: maxLength
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].OnGoing
    };
};


/***/ }),

/***/ "./src/utils/form/validators/max/max.ts":
/*!**********************************************!*\
  !*** ./src/utils/form/validators/max/max.ts ***!
  \**********************************************/
/*! exports provided: MaxValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxValidator", function() { return MaxValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param min The maximum value required to be valid. Bound included.
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var MaxValidator = function (max, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Max,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the max validator should not be attached to a form group');
            }
            var isMax;
            if (!control.value && control.value !== 0) {
                isMax = true;
            }
            else {
                var value = control.value;
                isMax = value <= max;
            }
            return isMax;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:maxValidatorErrorMessage', { max: max }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:maxValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    max: max
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/min-length/min-length.ts":
/*!************************************************************!*\
  !*** ./src/utils/form/validators/min-length/min-length.ts ***!
  \************************************************************/
/*! exports provided: MinLengthValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param minLength The minimum length required to be valid. Bound included.
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var MinLengthValidator = function (minLength, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].MaxLength,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the min length validator should not be attached to a form group');
            }
            var isMinLength;
            if (!control.value) {
                isMinLength = true;
            }
            else if (!isNaN(control.value)) {
                isMinLength = control.value.toString().length >= minLength;
            }
            else {
                isMinLength = control.value.length >= minLength;
            }
            return isMinLength;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:minLengthValidatorErrorMessage', { minLength: minLength }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:minLengthValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    minLength: minLength
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/min/min.ts":
/*!**********************************************!*\
  !*** ./src/utils/form/validators/min/min.ts ***!
  \**********************************************/
/*! exports provided: MinValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinValidator", function() { return MinValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");





/**
 *
 * @param min The minimum value required to be valid. Bound included.
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var MinValidator = function (min, options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_4__["ValidatorKeys"].Min,
        validationFunction: function (control) {
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_3__["FormGroup"]) {
                throw Error('the min validator should not be attached to a form group');
            }
            var isMin;
            if (!control.value && control.value !== 0) {
                isMin = true;
            }
            else {
                var value = control.value;
                isMin = value >= min;
            }
            return isMin;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:minValidatorErrorMessage', { min: min }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:minValidatorErrorSummaryMessage', {
                    controlLabel: options.controlLabel,
                    min: min
                }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].Correction
    };
};


/***/ }),

/***/ "./src/utils/form/validators/required/required.ts":
/*!********************************************************!*\
  !*** ./src/utils/form/validators/required/required.ts ***!
  \********************************************************/
/*! exports provided: RequiredValidator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return RequiredValidator; });
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _vue_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../vue/vue */ "./src/utils/vue/vue.ts");
/* harmony import */ var _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../control-validator-validation-type */ "./src/utils/form/control-validator-validation-type.ts");
/* harmony import */ var _form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../form-control */ "./src/utils/form/form-control.ts");
/* harmony import */ var _form_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../form-group */ "./src/utils/form/form-group.ts");
/* harmony import */ var _validator_error_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../validator-error-keys */ "./src/utils/form/validators/validator-error-keys.ts");






/**
 *
 * @param options options required to personnalise the validator, like the timing of the validation or the error messages to display.
 */
var RequiredValidator = function (options) {
    return {
        key: _validator_error_keys__WEBPACK_IMPORTED_MODULE_5__["ValidatorKeys"].Required,
        validationFunction: function (control) {
            var isPopulate = false;
            var assertPopulate = function (value) {
                if (!isNaN(value) && value === 0) {
                    return true;
                }
                else if (Array.isArray(value)) {
                    return value.length > 0;
                }
                return !!value;
            };
            if (control instanceof _form_group__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]) {
                isPopulate = control.controls
                    .filter(function (c) { return c instanceof _form_control__WEBPACK_IMPORTED_MODULE_3__["FormControl"]; })
                    .every(function (fc) {
                    return assertPopulate(fc.value);
                });
            }
            else {
                isPopulate = assertPopulate(control.value);
            }
            return isPopulate;
        },
        error: options && options.error ?
            options.error : {
            message: (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:requiredValidatorErrorMessage', undefined, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf),
            groupMessage: options && options.controlLabel ?
                (_vue_vue__WEBPACK_IMPORTED_MODULE_1__["ModulVue"].prototype.$i18n).translate('m-form:requiredValidatorErrorSummaryMessage', { controlLabel: options.controlLabel }, undefined, undefined, undefined, _i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FormatMode"].Sprintf)
                : undefined
        },
        validationType: options && options.validationType ?
            options.validationType : _control_validator_validation_type__WEBPACK_IMPORTED_MODULE_2__["ControlValidatorValidationType"].OnGoing
    };
};


/***/ }),

/***/ "./src/utils/form/validators/validator-error-keys.ts":
/*!***********************************************************!*\
  !*** ./src/utils/form/validators/validator-error-keys.ts ***!
  \***********************************************************/
/*! exports provided: ValidatorKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidatorKeys", function() { return ValidatorKeys; });
var ValidatorKeys;
(function (ValidatorKeys) {
    ValidatorKeys["Required"] = "required";
    ValidatorKeys["MinLength"] = "min-length";
    ValidatorKeys["MaxLength"] = "max-length";
    ValidatorKeys["Min"] = "min";
    ValidatorKeys["Max"] = "max";
    ValidatorKeys["Between"] = "between";
    ValidatorKeys["Email"] = "email";
    ValidatorKeys["Compare"] = "compare";
    ValidatorKeys["Date"] = "date";
    ValidatorKeys["Phone"] = "phone";
})(ValidatorKeys || (ValidatorKeys = {}));


/***/ }),

/***/ "./src/utils/http/http-param-serializer.ts":
/*!*************************************************!*\
  !*** ./src/utils/http/http-param-serializer.ts ***!
  \*************************************************/
/*! exports provided: serializeParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeParams", function() { return serializeParams; });
function serializeParams(params) {
    var options = [];
    var _loop_1 = function (key) {
        if (typeof params[key] === 'object' && params[key] !== undefined && params[key].length !== undefined) {
            // array
            if (params[key].length > 0) {
                params[key].forEach(function (el) { return options.push(key + "=" + serializeValue(el)); }); // array not empty
            }
        }
        else if (params[key] !== undefined) {
            options.push(key + "=" + serializeValue(params[key]));
        }
    };
    for (var key in params) {
        _loop_1(key);
    }
    return options.join('&');
}
function serializeValue(value) {
    return typeof value !== 'object'
        ? encodeURIComponent(value)
        : toString.call(value) === '[object Date]'
            ? value.toISOString()
            : JSON.stringify(value);
}


/***/ }),

/***/ "./src/utils/http/http.ts":
/*!********************************!*\
  !*** ./src/utils/http/http.ts ***!
  \********************************/
/*! exports provided: NO_TIMEOUT, HttpService, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_TIMEOUT", function() { return NO_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpService", function() { return HttpService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _errors_window_error_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../errors/window-error-handler */ "./src/utils/errors/window-error-handler.ts");
/* harmony import */ var _str_str__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../str/str */ "./src/utils/str/str.ts");
/* harmony import */ var _http_param_serializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./http-param-serializer */ "./src/utils/http/http-param-serializer.ts");





var AUTHORIZATION_HEADER = 'Authorization';
var NO_TIMEOUT = 0;
var HttpService = /** @class */ (function () {
    function HttpService(options) {
        this.options = options;
        this.instance = axios__WEBPACK_IMPORTED_MODULE_1___default.a.create();
        if (this.options) {
            // timeout
            if (!this.options.timeout) {
                this.instance.defaults.timeout = 30000;
            }
            else if (this.options.timeout === NO_TIMEOUT) {
                this.instance.defaults.timeout = undefined;
            }
            else {
                this.instance.defaults.timeout = this.options.timeout;
            }
            // request interceptor for authorization header
            if (this.options.protectedUrls && this.options.authorizationFn) {
                var protectedUrls_1 = this.options.protectedUrls;
                var authFn_1 = this.options.authorizationFn;
                this.instance.interceptors.request.use(function (config) {
                    var result = Promise.resolve(config);
                    var tokenAsync;
                    protectedUrls_1.every(function (url) {
                        if (_str_str__WEBPACK_IMPORTED_MODULE_3__["startsWith"](config.url, url)) {
                            tokenAsync = Promise.resolve(authFn_1());
                            return false; // break
                        }
                        return true;
                    });
                    if (tokenAsync) {
                        result = tokenAsync.then(function (token) {
                            var _a;
                            config.headers = Object.assign(config.headers || {}, (_a = {}, _a[AUTHORIZATION_HEADER] = token, _a));
                            return config;
                        });
                    }
                    return result;
                });
            }
            // response interceptor to progagate PromiseError
            if (this.options.useEventOnPromiseError === undefined || this.options.useEventOnPromiseError) {
                this.instance.interceptors.response.use(function (response) { return response; }, function (err) {
                    // wrap to a PromiseError, so that propagation can be stopped
                    var promiseErrorEvent = new ErrorEvent('error', {
                        error: err,
                        cancelable: true
                    });
                    // delay onError
                    _errors_window_error_handler__WEBPACK_IMPORTED_MODULE_2__["WindowErrorHandler"].onError(promiseErrorEvent, true);
                    return Promise.reject(promiseErrorEvent);
                });
            }
        }
    }
    HttpService.prototype.execute = function (config, axiosOptions) {
        var mergedConfig = this.buildConfig(config);
        mergedConfig = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, mergedConfig), axiosOptions);
        return this.instance.request(mergedConfig);
    };
    HttpService.prototype.buildConfig = function (config) {
        var _a;
        var axiosConfig = {};
        axiosConfig.url = this.resolveUrl(config);
        axiosConfig.method = config.method;
        axiosConfig.params = config.params;
        axiosConfig.headers = config.headers;
        axiosConfig.timeout = config.timeout;
        if (config.formParams) {
            var CONTENT_TYPE = 'Content-Type';
            var FORM_URLENCODED = 'application/x-www-form-urlencoded';
            if (axiosConfig.headers) {
                axiosConfig.headers[CONTENT_TYPE] = FORM_URLENCODED;
            }
            else {
                axiosConfig.headers = (_a = {},
                    _a[CONTENT_TYPE] = FORM_URLENCODED,
                    _a);
            }
            axiosConfig.data = Object(_http_param_serializer__WEBPACK_IMPORTED_MODULE_4__["serializeParams"])(config.formParams);
        }
        else {
            axiosConfig.data = config.data;
        }
        axiosConfig.paramsSerializer = function (params) { return Object(_http_param_serializer__WEBPACK_IMPORTED_MODULE_4__["serializeParams"])(params); };
        return axiosConfig;
    };
    HttpService.prototype.resolveUrl = function (config) {
        var result = config.rawUrl;
        if (result && config.pathParams) {
            for (var key in config.pathParams) {
                result = result.replace('{' + key + '}', encodeURIComponent(config.pathParams[key]));
            }
        }
        return result;
    };
    return HttpService;
}());

var HttpPlugin = {
    install: function (v, options) {
        var http = new HttpService(options);
        (v.prototype).$http = http;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (HttpPlugin);


/***/ }),

/***/ "./src/utils/i18n/i18n.ts":
/*!********************************!*\
  !*** ./src/utils/i18n/i18n.ts ***!
  \********************************/
/*! exports provided: FRENCH, ENGLISH, SpecialCharacter, DebugMode, FormatMode, Messages, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FRENCH", function() { return FRENCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENGLISH", function() { return ENGLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpecialCharacter", function() { return SpecialCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugMode", function() { return DebugMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatMode", function() { return FormatMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Messages", function() { return Messages; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! sprintf-js */ "sprintf-js");
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sprintf_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);



/**
 * This package provides language and locales utilities.
 */
/**
 * French language code.
 */
var FRENCH = 'fr';
/**
 * English language code.
 */
var ENGLISH = 'en';
/**
 * Regex to parse and format messages.
 */
var FORMAT_REGEX = /{\d+}/g;
/**
 * String used as a special characters wrapper
 */
var SPECIAL_CHARACTER_PREFIXE = '_';
var SPECIAL_CHARACTER_SUFIXE = '_';
/**
 * Special characters must be represented as their unicode equivalent \u00xxxx
 */
var SpecialCharacter;
(function (SpecialCharacter) {
    SpecialCharacter["NBSP"] = "160";
    SpecialCharacter["NBHYPHEN"] = "8209";
    SpecialCharacter["EMDASH"] = "8212";
    SpecialCharacter["ENDASH"] = "8211"; // en dash equivalent to unicode :\u002013, HTML entity : &#ndash; => (–)
})(SpecialCharacter || (SpecialCharacter = {}));
var DebugMode;
(function (DebugMode) {
    DebugMode[DebugMode["Throw"] = 0] = "Throw";
    DebugMode[DebugMode["Warn"] = 1] = "Warn";
    DebugMode[DebugMode["Prod"] = 2] = "Prod";
})(DebugMode || (DebugMode = {}));
var FormatMode;
(function (FormatMode) {
    FormatMode["Default"] = "";
    FormatMode["Vsprintf"] = "vsprintf";
    FormatMode["Sprintf"] = "sprintf";
})(FormatMode || (FormatMode = {}));
var Messages = /** @class */ (function () {
    function Messages(options) {
        this.options = options;
        this.curLang = ENGLISH;
        this.messages = {};
        this.specialCharacterDict = {};
        if (options) {
            if (options.curLang) {
                this.currentLang(options.curLang);
            }
            if (options.formatMode) {
                this.formatMode = options.formatMode;
            }
        }
        this.initSpecialCharactersDict();
    }
    /**
     * Set the application language globally
     *
     * @param lang The language, for example: 'en'
     */
    Messages.prototype.currentLang = function (lang) {
        if (lang) {
            this.curLang = lang;
            this.curLocale = this.getCurrentLocale();
        }
        return this.curLang;
    };
    /**
     * Get current locale
     */
    Messages.prototype.getCurrentLocale = function () {
        var locale;
        switch (this.curLang) {
            case FRENCH:
                locale = 'fr-CA';
                break;
            case ENGLISH:
            default:
                locale = 'en-CA';
                break;
        }
        return locale;
    };
    Object.defineProperty(Messages.prototype, "currentLocale", {
        get: function () {
            return this.curLocale;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds the messages so that they can be resolved.
     *
     * @param lang The language, for example: 'en'
     * @param messages The messages
     */
    Messages.prototype.addMessages = function (lang, bundle) {
        var languageBundles = this.messages[lang];
        this.messages[lang] = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, languageBundles), bundle);
    };
    /**
     * Allows to translate a key into the specified language.
     *
     * The resolution is made in this order:
     *
     * key.nb.modifier
     * key.p.modifier
     * key.nb
     * key.p
     * key.modifier
     * key
     */
    Messages.prototype.translate = function (key, params, nb, modifier, htmlEncodeParams, formatMode) {
        if (params === void 0) { params = []; }
        if (htmlEncodeParams === void 0) { htmlEncodeParams = true; }
        if (formatMode === void 0) { formatMode = this.formatMode; }
        if (!key) {
            throw new Error('The key is empty.');
        }
        var val = this.resolveKey(this.curLang, key, nb, modifier);
        if (htmlEncodeParams && params.length) {
            Object.keys(params).forEach(function (key) { params[key] = htmlEncode(params[key].toString()); });
        }
        if (formatMode === FormatMode.Sprintf || formatMode === FormatMode.Vsprintf) {
            params = Object.assign(this.specialCharacterDict, params);
        }
        val = this.format(val, params, formatMode);
        return val;
    };
    /**
     * format a string with depending on the option formatMode
     * @param {string} val the string to format
     * @param {any[]} params the values to insert in string
     */
    Messages.prototype.format = function (val, params, formatMode) {
        switch (formatMode) {
            case FormatMode.Vsprintf:
                return Object(sprintf_js__WEBPACK_IMPORTED_MODULE_1__["vsprintf"])(val, params);
            case FormatMode.Sprintf:
                return Object(sprintf_js__WEBPACK_IMPORTED_MODULE_1__["sprintf"])(val, params);
            default:
                return formatRegexp(val, params);
        }
    };
    Messages.prototype.resolveKey = function (lang, key, nb, modifier, encodeParams) {
        var val = undefined;
        if (nb !== undefined && modifier) {
            // key.nb.modifier
            val = this.findKey(lang, key + "." + nb + "." + modifier);
            if (val) {
                return val;
            }
            // key.p.modifier
            if (nb < -1 || nb > 1) {
                val = this.findKey(lang, key + ".p." + modifier);
                if (val) {
                    return val;
                }
            }
        }
        if (nb !== undefined) {
            // key.nb
            val = this.findKey(lang, key + "." + nb);
            if (val) {
                return val;
            }
            // key.p
            if (nb < -1 || nb > 1) {
                val = this.findKey(lang, key + ".p");
                if (val) {
                    return val;
                }
            }
        }
        if (modifier) {
            // key.modifier
            val = this.findKey(lang, key + "." + modifier);
            if (val) {
                return val;
            }
        }
        // key
        val = this.findKey(lang, key);
        if (val) {
            return val;
        }
        var error = "The key " + key + " does not exist. Current lang: " + this.curLang;
        if (this.options && this.options.debug === DebugMode.Throw) {
            throw new Error(error);
        }
        else {
            if (!this.options || this.options.debug === DebugMode.Warn) {
                vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn(error);
            }
            else {
                vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.debug(error);
            }
            return key;
        }
    };
    /**
     * Build the list of special characters that are automatically replaced to the desired pattern
     *
     * Example with '_' as PREFIXE and SUFIXE
     * NBSP => _NBSP_ : '\xOA'
     */
    Messages.prototype.initSpecialCharactersDict = function () {
        var _this = this;
        Object.keys(SpecialCharacter).forEach(function (key) {
            _this.specialCharacterDict["" + SPECIAL_CHARACTER_PREFIXE + key + SPECIAL_CHARACTER_SUFIXE] = String.fromCharCode(SpecialCharacter[key]);
        });
    };
    /**
     * Finds a key in the available messages or returns null.
     *
     * @param lang The language to use
     * @param key The key to find
     */
    Messages.prototype.findKey = function (lang, key) {
        var parts = key.split(':');
        if (parts.length !== 2) {
            var error = "The key " + key + " is invalid. The key needs to be in the format <bundle>:<id>";
            if (this.options && this.options.debug === DebugMode.Throw) {
                throw new Error(error);
            }
            else {
                if (!this.options || this.options.debug === DebugMode.Warn) {
                    vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn(error);
                }
                else {
                    vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.debug(error);
                }
                return undefined;
            }
        }
        var bundleName = parts[0];
        var id = parts[1];
        var langMsgs = this.messages[lang];
        var bundleMsgs = langMsgs && langMsgs[bundleName];
        return bundleMsgs && bundleMsgs[id];
    };
    return Messages;
}());

/**
 * Formats a value containing parameters.
 *
 * The format is 'This is a {0} containing {1}...'
 */
function formatRegexp(val, params) {
    return val.replace(FORMAT_REGEX, function (match) {
        // TODO: should use the regex variable notation instead of parsing the regex match
        var index = parseInt(match.substring(1, match.length - 1), 10);
        if (index >= params.length) {
            vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn("The parameter " + index + " doesn't exist while translating: '" + val + "'");
        }
        return params[index];
    });
}
/**
 * Encodes a value so that it can be inserted in an html string.
 * @param val The value to encode
 */
function htmlEncode(val) {
    return val
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
var MessagePlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('$i18n', 'plugin.install');
        var msg = new Messages(options);
        (v.prototype).$i18n = msg;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MessagePlugin);


/***/ }),

/***/ "./src/utils/input/input.ts":
/*!**********************************!*\
  !*** ./src/utils/input/input.ts ***!
  \**********************************/
/*! exports provided: changeSelection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeSelection", function() { return changeSelection; });
function changeSelection(input, selection) {
    var indexSelection = input.value.indexOf(selection || '');
    if (input && selection && indexSelection >= 0) {
        input.focus();
        input.setSelectionRange(indexSelection, indexSelection + selection.length);
    }
}


/***/ }),

/***/ "./src/utils/keycode/keycode.ts":
/*!**************************************!*\
  !*** ./src/utils/keycode/keycode.ts ***!
  \**************************************/
/*! exports provided: KeyCode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return KeyCode; });
var KeyCode = /** @class */ (function () {
    function KeyCode() {
    }
    KeyCode.M_CANCEL = 3;
    KeyCode.M_HELP = 6;
    KeyCode.M_BACK_SPACE = 8;
    KeyCode.M_TAB = 9;
    KeyCode.M_CLEAR = 12;
    KeyCode.M_RETURN = 13;
    KeyCode.M_ENTER = 14;
    KeyCode.M_SHIFT = 16;
    KeyCode.M_CONTROL = 17;
    KeyCode.M_ALT = 18;
    KeyCode.M_PAUSE = 19;
    KeyCode.M_CAPS_LOCK = 20;
    KeyCode.M_ESCAPE = 27;
    KeyCode.M_SPACE = 32;
    KeyCode.M_PAGE_UP = 33;
    KeyCode.M_PAGE_DOWN = 34;
    KeyCode.M_END = 35;
    KeyCode.M_HOME = 36;
    KeyCode.M_LEFT = 37;
    KeyCode.M_UP = 38;
    KeyCode.M_RIGHT = 39;
    KeyCode.M_DOWN = 40;
    KeyCode.M_PRINTSCREEN = 44;
    KeyCode.M_INSERT = 45;
    KeyCode.M_DELETE = 46;
    KeyCode.M_0 = 48;
    KeyCode.M_1 = 49;
    KeyCode.M_2 = 50;
    KeyCode.M_3 = 51;
    KeyCode.M_4 = 52;
    KeyCode.M_5 = 53;
    KeyCode.M_6 = 54;
    KeyCode.M_7 = 55;
    KeyCode.M_8 = 56;
    KeyCode.M_9 = 57;
    KeyCode.M_SEMICOLON = 59;
    KeyCode.M_EQUALS = 61;
    KeyCode.M_A = 65;
    KeyCode.M_B = 66;
    KeyCode.M_C = 67;
    KeyCode.M_D = 68;
    KeyCode.M_E = 69;
    KeyCode.M_F = 70;
    KeyCode.M_G = 71;
    KeyCode.M_H = 72;
    KeyCode.M_I = 73;
    KeyCode.M_J = 74;
    KeyCode.M_K = 75;
    KeyCode.M_L = 76;
    KeyCode.M_M = 77;
    KeyCode.M_N = 78;
    KeyCode.M_O = 79;
    KeyCode.M_P = 80;
    KeyCode.M_Q = 81;
    KeyCode.M_R = 82;
    KeyCode.M_S = 83;
    KeyCode.M_T = 84;
    KeyCode.M_U = 85;
    KeyCode.M_V = 86;
    KeyCode.M_W = 87;
    KeyCode.M_X = 88;
    KeyCode.M_Y = 89;
    KeyCode.M_Z = 90;
    KeyCode.M_CONTEXT_MENU = 93;
    KeyCode.M_NUMPAD0 = 96;
    KeyCode.M_NUMPAD1 = 97;
    KeyCode.M_NUMPAD2 = 98;
    KeyCode.M_NUMPAD3 = 99;
    KeyCode.M_NUMPAD4 = 100;
    KeyCode.M_NUMPAD5 = 101;
    KeyCode.M_NUMPAD6 = 102;
    KeyCode.M_NUMPAD7 = 103;
    KeyCode.M_NUMPAD8 = 104;
    KeyCode.M_NUMPAD9 = 105;
    KeyCode.M_MULTIPLY = 106;
    KeyCode.M_ADD = 107;
    KeyCode.M_SEPARATOR = 108;
    KeyCode.M_SUBTRACT = 109;
    KeyCode.M_DECIMAL = 110;
    KeyCode.M_DIVIDE = 111;
    KeyCode.M_F1 = 112;
    KeyCode.M_F2 = 113;
    KeyCode.M_F3 = 114;
    KeyCode.M_F4 = 115;
    KeyCode.M_F5 = 116;
    KeyCode.M_F6 = 117;
    KeyCode.M_F7 = 118;
    KeyCode.M_F8 = 119;
    KeyCode.M_F9 = 120;
    KeyCode.M_F10 = 121;
    KeyCode.M_F11 = 122;
    KeyCode.M_F12 = 123;
    KeyCode.M_F13 = 124;
    KeyCode.M_F14 = 125;
    KeyCode.M_F15 = 126;
    KeyCode.M_F16 = 127;
    KeyCode.M_F17 = 128;
    KeyCode.M_F18 = 129;
    KeyCode.M_F19 = 130;
    KeyCode.M_F20 = 131;
    KeyCode.M_F21 = 132;
    KeyCode.M_F22 = 133;
    KeyCode.M_F23 = 134;
    KeyCode.M_F24 = 135;
    KeyCode.M_NUM_LOCK = 144;
    KeyCode.M_SCROLL_LOCK = 145;
    KeyCode.M_COMMA = 188;
    KeyCode.M_PERIOD = 190;
    KeyCode.M_SLASH = 191;
    KeyCode.M_BACK_QUOTE = 192;
    KeyCode.M_OPEN_BRACKET = 219;
    KeyCode.M_BACK_SLASH = 220;
    KeyCode.M_CLOSE_BRACKET = 221;
    KeyCode.M_QUOTE = 222;
    KeyCode.M_META = 224;
    return KeyCode;
}());



/***/ }),

/***/ "./src/utils/l10n/l10n.ts":
/*!********************************!*\
  !*** ./src/utils/l10n/l10n.ts ***!
  \********************************/
/*! exports provided: MCurrencySymbolPosition, MCurrency, MDecimalFormat, L10n, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCurrencySymbolPosition", function() { return MCurrencySymbolPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCurrency", function() { return MCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MDecimalFormat", function() { return MDecimalFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L10n", function() { return L10n; });
/* harmony import */ var _money_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../money/money */ "./src/utils/money/money.ts");

var MCurrencySymbolPosition;
(function (MCurrencySymbolPosition) {
    MCurrencySymbolPosition["Before"] = "before";
    MCurrencySymbolPosition["After"] = "after";
})(MCurrencySymbolPosition || (MCurrencySymbolPosition = {}));
var MCurrency = /** @class */ (function () {
    function MCurrency(type, localizedSymbol, symbolPosition) {
        this.type = type;
        this.localizedSymbol = localizedSymbol;
        this.symbolPosition = symbolPosition;
    }
    return MCurrency;
}());

var MDecimalFormat = /** @class */ (function () {
    function MDecimalFormat(thousandSeparator, decimalMark) {
        this.thousandSeparator = thousandSeparator;
        this.decimalMark = decimalMark;
    }
    return MDecimalFormat;
}());

var L10n = /** @class */ (function () {
    function L10n(options) {
        this.currency = (options || {}).curCurrency || _money_money__WEBPACK_IMPORTED_MODULE_0__["MCurrencyType"].CAD;
    }
    Object.defineProperty(L10n.prototype, "currentCurrency", {
        get: function () {
            return this.currency;
        },
        set: function (value) {
            this.currency = value;
        },
        enumerable: true,
        configurable: true
    });
    L10n.prototype.getCurrencyDetail = function (locale) {
        var currency = this.currentCurrency;
        var currencyTemplate = new Intl.NumberFormat(locale, { maximumSignificantDigits: 1, style: 'currency', currency: _money_money__WEBPACK_IMPORTED_MODULE_0__["MCurrencyType"][currency] }).format(0);
        var localizedSymbol = currencyTemplate.replace('0', '').trim();
        return new MCurrency(currency, localizedSymbol, currencyTemplate.split(localizedSymbol)[0] === '' ? MCurrencySymbolPosition.Before : MCurrencySymbolPosition.After);
    };
    L10n.prototype.getDecimalFormat = function (locale) {
        // TODO : Make this code more generic when the need arise.
        switch (locale) {
            case 'en-CA':
                return new MDecimalFormat(',', '.');
            case 'fr-CA':
                return new MDecimalFormat(' ', ',');
            default:
                throw new Error('l10n: Unhandled locale type.  Please specify a decimal format for this locale.');
        }
    };
    return L10n;
}());

var L10nPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('$l10n', 'plugin.install');
        (v.prototype).$l10n = new L10n(options);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (L10nPlugin);


/***/ }),

/***/ "./src/utils/license/license.ts":
/*!**************************************!*\
  !*** ./src/utils/license/license.ts ***!
  \**************************************/
/*! exports provided: Licenses, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Licenses", function() { return Licenses; });
var Licenses = /** @class */ (function () {
    function Licenses() {
    }
    Licenses.prototype.addLicense = function (id, value) {
        Licenses.licenses[id] = value;
    };
    Licenses.prototype.getLicense = function (id) {
        return Licenses.licenses[id];
    };
    Licenses.licenses = {};
    return Licenses;
}());

var LicensePlugin = {
    install: function (v) {
        (v.prototype).$license = new Licenses();
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LicensePlugin);


/***/ }),

/***/ "./src/utils/logger/logger.ts":
/*!************************************!*\
  !*** ./src/utils/logger/logger.ts ***!
  \************************************/
/*! exports provided: Logger, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);

var Logger = /** @class */ (function () {
    function Logger(options) {
        this.displayLogs = true;
        this.displayWarnings = true;
        this.displayDebugs = true;
        this.displayInfos = true;
        this.hideAll = false;
        this.setConsoleOptions(options);
    }
    Logger.prototype.setConsoleOptions = function (options) {
        if (options) {
            if (typeof (options.displayLogs) === 'boolean') {
                this.displayLogs = options.displayLogs;
            }
            if (typeof (options.displayWarnings) === 'boolean') {
                this.displayWarnings = options.displayWarnings;
            }
            if (typeof (options.displayDebugs) === 'boolean') {
                this.displayDebugs = options.displayDebugs;
            }
            if (typeof (options.displayInfos) === 'boolean') {
                this.displayInfos = options.displayInfos;
            }
            if (typeof (options.hideAll) === 'boolean') {
                this.hideAll = options.hideAll;
            }
        }
    };
    Logger.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.hideAll && this.displayLogs) {
            console.log.apply(console, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([message], optionalParams));
        }
    };
    Logger.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.hideAll && this.displayWarnings) {
            console.warn.apply(console, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([message], optionalParams));
        }
    };
    Logger.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.hideAll && this.displayDebugs) {
            console.debug.apply(console, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([message], optionalParams));
        }
    };
    Logger.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.hideAll && this.displayInfos) {
            console.info.apply(console, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([message], optionalParams));
        }
    };
    Logger.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.hideAll) {
            console.error.apply(console, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([message], optionalParams));
        }
    };
    return Logger;
}());

var LoggerPlugin = {
    install: function (v, options) {
        var logger = new Logger(options);
        logger.debug('$logger', 'plugin.install');
        (v.prototype).$log = logger;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (LoggerPlugin);


/***/ }),

/***/ "./src/utils/media-queries/media-queries.ts":
/*!**************************************************!*\
  !*** ./src/utils/media-queries/media-queries.ts ***!
  \**************************************************/
/*! exports provided: MediaQueriesBpMin, MediaQueriesBpMax, MediaQueriesBp, MediaQueries, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaQueriesBpMin", function() { return MediaQueriesBpMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaQueriesBpMax", function() { return MediaQueriesBpMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaQueriesBp", function() { return MediaQueriesBp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaQueries", function() { return MediaQueries; });
/* harmony import */ var enquire_js_dist_enquire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! enquire.js/dist/enquire */ "enquire.js/dist/enquire");
/* harmony import */ var enquire_js_dist_enquire__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(enquire_js_dist_enquire__WEBPACK_IMPORTED_MODULE_0__);

var MediaQueriesBpMin;
(function (MediaQueriesBpMin) {
    MediaQueriesBpMin["XL"] = "(min-width: 1600px)";
    MediaQueriesBpMin["L"] = "(min-width: 1200px)";
    MediaQueriesBpMin["M"] = "(min-width: 1024px)";
    MediaQueriesBpMin["S"] = "(min-width: 768px)";
    MediaQueriesBpMin["XS"] = "(min-width: 480px)";
    MediaQueriesBpMin["FROM_DESKTOP"] = "(min-width: 1600px)";
    MediaQueriesBpMin["FROM_LAPTOP"] = "(min-width: 1200px)";
    MediaQueriesBpMin["FROM_TABLET_LANDSCAPE"] = "(min-width: 1024px)";
    MediaQueriesBpMin["FROM_TABLET_PORTRAIT"] = "(min-width: 768px)";
    MediaQueriesBpMin["FROM_PHONE_PORTRAIT"] = "(min-width: 480px)";
})(MediaQueriesBpMin || (MediaQueriesBpMin = {}));
var MediaQueriesBpMax;
(function (MediaQueriesBpMax) {
    MediaQueriesBpMax["XL"] = "(max-width: 1599px)";
    MediaQueriesBpMax["L"] = "(max-width: 1199px)";
    MediaQueriesBpMax["M"] = "(max-width: 1023px)";
    MediaQueriesBpMax["S"] = "(max-width: 767px)";
    MediaQueriesBpMax["XS"] = "(max-width: 479px)";
    MediaQueriesBpMax["LESS_THAN_DESKTOP"] = "(max-width: 1599px)";
    MediaQueriesBpMax["LESS_THAN_LAPTOP"] = "(max-width: 1199px)";
    MediaQueriesBpMax["LESS_THAN_TABLET_LANDSCAPE"] = "(max-width: 1023px)";
    MediaQueriesBpMax["LESS_THAN_TABLET_PORTRAIT"] = "(max-width: 767px)";
    MediaQueriesBpMax["LESS_THAN_PHONE_PORTRAIT"] = "(max-width: 479px)";
})(MediaQueriesBpMax || (MediaQueriesBpMax = {}));
var MediaQueriesBp;
(function (MediaQueriesBp) {
    MediaQueriesBp["L"] = "(min-width: 1024px) and (max-width:1599px)";
    MediaQueriesBp["M"] = "(min-width: 768px) and (max-width: 1023px)";
    MediaQueriesBp["S"] = "(min-width: 480px) and (max-width: 767px)";
})(MediaQueriesBp || (MediaQueriesBp = {}));
var MediaQueries = /** @class */ (function () {
    function MediaQueries() {
        var _this = this;
        this.state = {
            isMqMinXL: false,
            isMqMinL: false,
            isMqMinM: false,
            isMqMinS: false,
            isMqMinXS: false,
            isMqMaxXL: false,
            isMqMaxL: false,
            isMqMaxM: false,
            isMqMaxS: false,
            isMqMaxXS: false,
            isMqS: false,
            isMqM: false,
            isMqL: false
        };
        this.register(MediaQueriesBpMin.XL, function () { return _this.state.isMqMinXL = true; }, function () { return _this.state.isMqMinXL = false; });
        this.register(MediaQueriesBpMin.L, function () { return _this.state.isMqMinL = true; }, function () { return _this.state.isMqMinL = false; });
        this.register(MediaQueriesBpMin.M, function () { return _this.state.isMqMinM = true; }, function () { return _this.state.isMqMinM = false; });
        this.register(MediaQueriesBpMin.S, function () { return _this.state.isMqMinS = true; }, function () { return _this.state.isMqMinS = false; });
        this.register(MediaQueriesBpMin.XS, function () { return _this.state.isMqMinXS = true; }, function () { return _this.state.isMqMinXS = false; });
        this.register(MediaQueriesBpMax.XL, function () { return _this.state.isMqMaxXL = true; }, function () { return _this.state.isMqMaxXL = false; });
        this.register(MediaQueriesBpMax.L, function () { return _this.state.isMqMaxL = true; }, function () { return _this.state.isMqMaxL = false; });
        this.register(MediaQueriesBpMax.M, function () { return _this.state.isMqMaxM = true; }, function () { return _this.state.isMqMaxM = false; });
        this.register(MediaQueriesBpMax.S, function () { return _this.state.isMqMaxS = true; }, function () { return _this.state.isMqMaxS = false; });
        this.register(MediaQueriesBpMax.XS, function () { return _this.state.isMqMaxXS = true; }, function () { return _this.state.isMqMaxXS = false; });
        this.register(MediaQueriesBp.S, function () { return _this.state.isMqS = true; }, function () { return _this.state.isMqS = false; });
        this.register(MediaQueriesBp.M, function () { return _this.state.isMqM = true; }, function () { return _this.state.isMqM = false; });
        this.register(MediaQueriesBp.L, function () { return _this.state.isMqL = true; }, function () { return _this.state.isMqL = false; });
    }
    MediaQueries.prototype.register = function (breakingPoint, match, unmatch) {
        var obj = {
            match: function () { return match(); },
            unmatch: function () { return unmatch(); }
        };
        enquire_js_dist_enquire__WEBPACK_IMPORTED_MODULE_0___default.a.register(breakingPoint, obj);
    };
    return MediaQueries;
}());

var MediaQueriesPlugin = {
    install: function (v) {
        var mediaQueries = new MediaQueries();
        (v.prototype).$mq = mediaQueries;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MediaQueriesPlugin);


/***/ }),

/***/ "./src/utils/modul-date/modul-date.ts":
/*!********************************************!*\
  !*** ./src/utils/modul-date/modul-date.ts ***!
  \********************************************/
/*! exports provided: DatePrecision, DateComparison, DATE_FORMAT_REGEX, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePrecision", function() { return DatePrecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateComparison", function() { return DateComparison; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_FORMAT_REGEX", function() { return DATE_FORMAT_REGEX; });
/**
 * Level of precision required when comparing two dates
 * Day: yyyy-mm-dd
 * Month: yyyy-mm
 * Year: yyyy
 */
var DatePrecision;
(function (DatePrecision) {
    DatePrecision["DAY"] = "day";
    DatePrecision["MONTH"] = "month";
    DatePrecision["YEAR"] = "year";
})(DatePrecision || (DatePrecision = {}));
var DateComparison;
(function (DateComparison) {
    DateComparison[DateComparison["IS_BEFORE"] = -1] = "IS_BEFORE";
    DateComparison[DateComparison["IS_EQUAL"] = 0] = "IS_EQUAL";
    DateComparison[DateComparison["IS_AFTER"] = 1] = "IS_AFTER";
})(DateComparison || (DateComparison = {}));
var DATE_FORMAT_REGEX = /(^(\d{1,4})[\.|\\\/|-](\d{1,2})(([\.|\\\/|-])(\d{1,4}))?)$/;
var ModulDate = /** @class */ (function () {
    function ModulDate(year, month, day) {
        switch (arguments.length) {
            case 1:
                var value = arguments[0];
                if (value instanceof ModulDate) {
                    this.innerDate = new Date(value.fullYear(), value.month(), value.day());
                }
                else if (value instanceof Date) {
                    this.innerDate = new Date(value);
                }
                else if (typeof (value) === 'string') {
                    this.dateFromString(value);
                }
                else {
                    var date_1 = new Date();
                    this.innerDate = new Date(date_1.getFullYear(), date_1.getMonth(), date_1.getDate());
                }
                break;
            case 3:
                this.innerDate = new Date(year, month, day);
                break;
            default:
                var date = new Date();
                this.innerDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }
    }
    /**
     * Check if the current date is before or equal to the received date.
     *
     * @param otherDate date to be compared with
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isSameOrBefore = function (otherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(otherDate.innerDate, precision) >= this.toTime(this.innerDate, precision);
    };
    /**
     * Check if the current date is strictly before to the received date.
     *
     * @param otherDate date to be compared with
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isBefore = function (otherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(otherDate.innerDate, precision) > this.toTime(this.innerDate, precision);
    };
    /**
     * Check if the current date is equal to the received date.
     *
     * @param otherDate date to be compared with
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isSame = function (otherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(otherDate.innerDate, precision) === this.toTime(this.innerDate, precision);
    };
    /**
     * Check if the current date is equal or after to the received date.
     *
     * @param otherDate date to be compared with
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isSameOrAfter = function (otherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(otherDate.innerDate, precision) <= this.toTime(this.innerDate, precision);
    };
    /**
     * Check if the current date or after to the received date.
     *
     * @param otherDate date to be compared with
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isAfter = function (otherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(otherDate.innerDate, precision) < this.toTime(this.innerDate, precision);
    };
    /**
     * Check if the current date is equal to one of the bounds or between them.
     *
     * @param lowerDate lower bound
     * @param higherDate higher bound
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isBetween = function (lowerDate, higherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(lowerDate.innerDate, precision) <= this.toTime(this.innerDate, precision)
            && this.toTime(this.innerDate, precision) <= this.toTime(higherDate.innerDate, precision);
    };
    /**
     * Check if the current date is strictly between bounds them.
     *
     * @param lowerDate lower bound
     * @param higherDate higher bound
     * @param precision level of precision for comparison @see DatePrecision
     */
    ModulDate.prototype.isBetweenStrict = function (lowerDate, higherDate, precision) {
        if (precision === void 0) { precision = DatePrecision.DAY; }
        return this.toTime(lowerDate.innerDate, precision) < this.toTime(this.innerDate, precision)
            && this.toTime(this.innerDate, precision) < this.toTime(higherDate.innerDate, precision);
    };
    /**
     * Compare the current date with the received date to determine if the current date is before, equal or after the
     * received date
     *
     * @param date date to be compared with
     * @returns @see DateComparison
     */
    ModulDate.prototype.compare = function (date) {
        var current = this.toTime(this.innerDate, DatePrecision.DAY);
        var other = this.toTime(date.innerDate, DatePrecision.DAY);
        if (current < other) {
            return DateComparison.IS_BEFORE;
        }
        else if (current > other) {
            return DateComparison.IS_AFTER;
        }
        return DateComparison.IS_EQUAL;
    };
    /**
     * format date string as YYYY-MM-DD
     */
    ModulDate.prototype.toString = function () {
        var month = this.padString((this.innerDate.getMonth() + 1).toString());
        var day = this.padString(this.innerDate.getDate().toString());
        return this.fullYear() + "-" + month + "-" + day;
    };
    /**
     * format date following the date part of the standard ISO-8601
     */
    ModulDate.prototype.toISOString = function () {
        return this.innerDate.toISOString();
    };
    /**
     * format date following the locale representation of a date
     */
    ModulDate.prototype.toLocaleDateString = function () {
        return this.innerDate.toLocaleDateString();
    };
    /**
     * Getter for the year value
     */
    ModulDate.prototype.fullYear = function () {
        return this.innerDate.getFullYear();
    };
    /**
     * Getter for the month value
     */
    ModulDate.prototype.month = function () {
        return this.innerDate.getMonth();
    };
    /**
     * Getter for the day of the month value
     */
    ModulDate.prototype.day = function () {
        return this.innerDate.getDate();
    };
    /**
     * Getter for the day of the week value
     */
    ModulDate.prototype.dayOfWeek = function () {
        return this.innerDate.getDay();
    };
    /**
     * Compares if two dates are equals
     *
     * @param otherDate date to compare with
     */
    ModulDate.prototype.equals = function (otherDate) {
        if (otherDate instanceof Date) {
            return this.toTime(otherDate, DatePrecision.DAY) === this.toTime(this.innerDate, DatePrecision.DAY);
        }
        else if (otherDate instanceof ModulDate) {
            return this.toTime(otherDate.innerDate, DatePrecision.DAY) === this.toTime(this.innerDate, DatePrecision.DAY);
        }
        return false;
    };
    /**
     * Calculates the number of days between the current date and the received date.
     *
     * @param other
     * @return Number of days in absolute format
     */
    ModulDate.prototype.deltaInDays = function (other) {
        return Math.round(Math.abs(other.innerDate.getTime() - this.innerDate.getTime()) / (1000 * 3600 * 24));
    };
    /**
     * Add an unit of time to a copy of the current date and return it.
     *
     * @param valueToAdd The value to add to the time unit.
     * @param unitOfTime The kind of time unit to be added.
     * @return A new Date
     */
    ModulDate.prototype.add = function (valueToAdd, unitOfTime) {
        return this.subtract(-valueToAdd, unitOfTime);
    };
    /**
     * subtract an unit of time to a copy of the current date and return it.
     *
     * @param valueToSubtract The value to add to the time unit.
     * @param unitOfTime The kind of time unit to be added.
     * @return A new Date
     */
    ModulDate.prototype.subtract = function (valueToSubtract, unitOfTime) {
        if (unitOfTime === void 0) { unitOfTime = DatePrecision.YEAR; }
        var newDate = new Date(this.innerDate);
        switch (unitOfTime) {
            case DatePrecision.YEAR:
                newDate.setFullYear(newDate.getFullYear() - valueToSubtract);
                break;
            case DatePrecision.MONTH:
                newDate.setMonth(newDate.getMonth() - valueToSubtract);
                break;
            case DatePrecision.DAY:
                var dateOffset = (24 * 60 * 60 * 1000) * valueToSubtract;
                newDate.setTime(newDate.getTime() - dateOffset);
                break;
            default: throw new Error("modul-date: Unknown substract unitOfTime: " + unitOfTime);
        }
        return newDate;
    };
    /**
     * Return a date representing the end of the day of a given date (23:59:59).
     *
     * @return A new Date
     */
    ModulDate.prototype.beginOfDay = function () {
        return new Date(this.innerDate.getFullYear(), this.innerDate.getMonth(), this.innerDate.getDate(), 0, 0, 0, 0);
    };
    /**
     * Return a date representing the end of the day of a given date (23:59:59).
     *
     * @return A new Date
     */
    ModulDate.prototype.endOfDay = function () {
        return new Date(this.innerDate.getFullYear(), this.innerDate.getMonth(), this.innerDate.getDate(), 23, 59, 59, 999);
    };
    ModulDate.prototype.toDate = function () {
        return this.innerDate;
    };
    ModulDate.prototype.dateFromString = function (value) {
        if (value === '') {
            this.innerDate = new Date();
        }
        else {
            this.innerDate = this.convertStringToDate(value);
        }
    };
    ModulDate.prototype.convertStringToDate = function (value) {
        // If the string is an iso string, we use it directly.
        if (value.split('T')[1]) {
            return new Date(value);
        }
        // Otherwise we try to build the date from a partial date string (2010-12-01 or 2010/12/01)
        if (!DATE_FORMAT_REGEX.test(value)) {
            throw Error("Impossible to find date parts in date");
        }
        else {
            var stringToDelete = /[\.|\\/|-]/g;
            var parts = value.split(stringToDelete);
            var first = parts[0];
            var second = parts[1];
            var third = parts[2] || '1';
            if (parseInt(first, 10) > 12 && parseInt(second, 10) > 12 && parseInt(third, 10) > 12) {
                throw Error("No suitable month value");
            }
            else if (parseInt(first, 10) > 31 && parseInt(third, 10) > 31) {
                throw Error("No suitable day of month value");
            }
            if (third.length === 4 || third.length > first.length) {
                third = [first, first = third][0];
            }
            var year = (first.length === 2) ? '20' + first : first;
            if (parseInt(second, 10) > 12) {
                third = [second, second = third][0];
            }
            var month = this.padString(second);
            var day = this.padString(third);
            var date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
            return date;
        }
    };
    ModulDate.prototype.padString = function (input) {
        return ('000' + input).slice(-2);
    };
    ModulDate.prototype.toTime = function (date, precision) {
        var toTimeDate;
        switch (precision) {
            case DatePrecision.YEAR:
                toTimeDate = new Date(date.getFullYear(), 1, 1);
                break;
            case DatePrecision.MONTH:
                toTimeDate = new Date(date.getFullYear(), date.getMonth(), 1);
                break;
            default: // DatePrecision.DAY:
                toTimeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }
        return toTimeDate.getTime();
    };
    return ModulDate;
}());
/* harmony default export */ __webpack_exports__["default"] = (ModulDate);


/***/ }),

/***/ "./src/utils/modul-icons/modul-icons.ts":
/*!**********************************************!*\
  !*** ./src/utils/modul-icons/modul-icons.ts ***!
  \**********************************************/
/*! exports provided: ModulIconsCategory, ModulIconName, ModulIcons */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModulIconsCategory", function() { return ModulIconsCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModulIconName", function() { return ModulIconName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModulIcons", function() { return ModulIcons; });
var ModulIconsCategory;
(function (ModulIconsCategory) {
    ModulIconsCategory["Arrow"] = "arrow";
    ModulIconsCategory["Audio"] = "audio";
    ModulIconsCategory["Control"] = "control";
    ModulIconsCategory["Document"] = "document";
    ModulIconsCategory["File"] = "file";
    ModulIconsCategory["Form"] = "form";
    ModulIconsCategory["Image"] = "image";
    ModulIconsCategory["Message"] = "message";
    ModulIconsCategory["State"] = "state";
    ModulIconsCategory["Text"] = "text";
    ModulIconsCategory["Video"] = "video";
})(ModulIconsCategory || (ModulIconsCategory = {}));
var ModulIconName;
(function (ModulIconName) {
    ModulIconName["AddCircleFilled"] = "add-circle-filled";
    ModulIconName["AddCircle"] = "add-circle";
    ModulIconName["ArrowDown"] = "arrow--down";
    ModulIconName["ArrowLeft"] = "arrow--left";
    ModulIconName["ArrowRight"] = "arrow--right";
    ModulIconName["ArrowUp"] = "arrow--up";
    ModulIconName["ArrowButtonDown"] = "arrow-button--down";
    ModulIconName["ArrowButtonLeft"] = "arrow-button--left";
    ModulIconName["ArrowButtonRight"] = "arrow-button--right";
    ModulIconName["ArrowButtonUp"] = "arrow-button--up";
    ModulIconName["ArrowHeadCircleRight"] = "arrow-head-circle--right";
    ModulIconName["ArrowHeadFilledDown"] = "arrow-head-filled--down";
    ModulIconName["ArrowHeadFilledLeft"] = "arrow-head-filled--left";
    ModulIconName["ArrowHeadFilledRight"] = "arrow-head-filled--right";
    ModulIconName["ArrowHeadFilledUp"] = "arrow-head-filled--up";
    ModulIconName["ArrowReturn"] = "arrow-return";
    ModulIconName["ArrowThinDown"] = "arrow-thin--down";
    ModulIconName["ArrowThinLeft"] = "arrow-thin--left";
    ModulIconName["ArrowThinRight"] = "arrow-thin--right";
    ModulIconName["ArrowThinUp"] = "arrow-thin--up";
    ModulIconName["Attachment"] = "attachment";
    ModulIconName["Avatar"] = "avatar";
    ModulIconName["Calendar"] = "calendar";
    ModulIconName["ChevronDown"] = "chevron--down";
    ModulIconName["ChevronLeft"] = "chevron--left";
    ModulIconName["ChevronRight"] = "chevron--right";
    ModulIconName["ChevronUp"] = "chevron--up";
    ModulIconName["Clock"] = "clock";
    ModulIconName["CloseClear"] = "close-clear";
    ModulIconName["CodeTag"] = "code-tag";
    ModulIconName["Compare"] = "compare";
    ModulIconName["CompletedFilled"] = "completed-filled";
    ModulIconName["ConfirmationWhiteFilled"] = "confirmation-white-filled";
    ModulIconName["Confirmation"] = "confirmation";
    ModulIconName["Delete"] = "delete";
    ModulIconName["Download"] = "download";
    ModulIconName["DragVertical"] = "drag-vertical";
    ModulIconName["Dragndrop"] = "dragndrop";
    ModulIconName["Edit"] = "edit";
    ModulIconName["EmailSend"] = "email-send";
    ModulIconName["Email"] = "email";
    ModulIconName["ErrorFilled"] = "error-filled";
    ModulIconName["ErrorWhiteFilled"] = "error-white-filled";
    ModulIconName["Error"] = "error";
    ModulIconName["Evaluation"] = "evaluation";
    ModulIconName["FileAccess"] = "file-access";
    ModulIconName["FileAudio"] = "file-audio";
    ModulIconName["FileCode"] = "file-code";
    ModulIconName["FileDefault"] = "file-default";
    ModulIconName["FileDwg"] = "file-dwg";
    ModulIconName["FileExcel"] = "file-excel";
    ModulIconName["FileFlash"] = "file-flash";
    ModulIconName["FileImage"] = "file-image";
    ModulIconName["FileMarkup"] = "file-markup";
    ModulIconName["FileMediaplayer"] = "file-mediaplayer";
    ModulIconName["FileOpenofficeBase"] = "file-openoffice-base";
    ModulIconName["FileOpenofficeCalc"] = "file-openoffice-calc";
    ModulIconName["FileOpenofficeDefault"] = "file-openoffice-default";
    ModulIconName["FileOpenofficeDraw"] = "file-openoffice-draw";
    ModulIconName["FileOpenofficeImpress"] = "file-openoffice-impress";
    ModulIconName["FileOpenofficeMath"] = "file-openoffice-math";
    ModulIconName["FileOpenofficeWritter"] = "file-openoffice-writter";
    ModulIconName["FilePdf"] = "file-pdf";
    ModulIconName["FilePowerpoint"] = "file-powerpoint";
    ModulIconName["FileQuicktime"] = "file-quicktime";
    ModulIconName["FileRealplayer"] = "file-realplayer";
    ModulIconName["FileText"] = "file-text";
    ModulIconName["FileVideo"] = "file-video";
    ModulIconName["FileVisio"] = "file-visio";
    ModulIconName["FileWord"] = "file-word";
    ModulIconName["FileZip"] = "file-zip";
    ModulIconName["FolderOpen"] = "folder-open";
    ModulIconName["Folder"] = "folder";
    ModulIconName["FullScreen"] = "full-screen";
    ModulIconName["GridFilled"] = "grid-filled";
    ModulIconName["Grid"] = "grid";
    ModulIconName["Grouping"] = "grouping";
    ModulIconName["HelpCircle"] = "help-circle";
    ModulIconName["Heraldry"] = "heraldry";
    ModulIconName["Hide"] = "hide";
    ModulIconName["Hint"] = "hint";
    ModulIconName["Home"] = "Home";
    ModulIconName["ImageSlideshow"] = "image-slideshow";
    ModulIconName["ImageSquare"] = "image-square";
    ModulIconName["Image1Filled"] = "image1-filled";
    ModulIconName["Image2Filled"] = "image2-filled";
    ModulIconName["InformationFilled"] = "information-filled";
    ModulIconName["InformationWhiteFilled"] = "information-white-filled";
    ModulIconName["Information"] = "information";
    ModulIconName["LeaveFullScreen"] = "leave-full-screen";
    ModulIconName["ListFilled"] = "list-filled";
    ModulIconName["List"] = "list";
    ModulIconName["Lock"] = "lock";
    ModulIconName["Logout"] = "logout";
    ModulIconName["MultimediaExternal"] = "multimedia-external";
    ModulIconName["MultimediaFilled"] = "multimedia-filled";
    ModulIconName["Multimedia"] = "multimedia";
    ModulIconName["NotAllowed"] = "not-allowed";
    ModulIconName["Notification"] = "notification";
    ModulIconName["Options"] = "options";
    ModulIconName["Panel"] = "panel";
    ModulIconName["Profile"] = "profile";
    ModulIconName["RemoveAssignation"] = "remove-assignation";
    ModulIconName["RemoveCircleFilled"] = "remove-circle-filled";
    ModulIconName["RemoveCircle"] = "remove-circle";
    ModulIconName["Replace"] = "replace";
    ModulIconName["RightAnswer"] = "right-answer";
    ModulIconName["RoleAssignation"] = "role-assignation";
    ModulIconName["Search"] = "search";
    ModulIconName["Show"] = "show";
    ModulIconName["Subtitle"] = "subtitle";
    ModulIconName["Text1"] = "text1";
    ModulIconName["Text2"] = "text2";
    ModulIconName["VideoFilled"] = "video-filled";
    ModulIconName["VideoSlideshow"] = "video-slideshow";
    ModulIconName["Video"] = "video";
    ModulIconName["WarningFilled"] = "warning-filled";
    ModulIconName["WarningWhiteFilled"] = "warning-white-filled";
    ModulIconName["Warning"] = "warning";
    ModulIconName["WrongAnswer"] = "wrong-answer";
})(ModulIconName || (ModulIconName = {}));
var ModulIcons = [
    {
        name: ModulIconName.AddCircleFilled,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.AddCircle,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowDown,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowLeft,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowUp,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowButtonDown,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowButtonLeft,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowButtonRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowButtonUp,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowHeadCircleRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowHeadFilledDown,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowHeadFilledLeft,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowHeadFilledRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowHeadFilledUp,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowReturn,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowThinDown,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowThinLeft,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowThinRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ArrowThinUp,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Attachment,
        category: [
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.Avatar
    },
    {
        name: ModulIconName.Calendar,
        category: [
            ModulIconsCategory.Form
        ]
    },
    {
        name: ModulIconName.ChevronDown,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ChevronLeft,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ChevronRight,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ChevronUp,
        category: [
            ModulIconsCategory.Arrow,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Clock,
        category: [
            ModulIconsCategory.Form
        ]
    },
    {
        name: ModulIconName.CloseClear,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.CodeTag,
        category: [
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.Compare,
        category: [
            ModulIconsCategory.Control,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.CompletedFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.ConfirmationWhiteFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Confirmation,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Delete,
        category: [
            ModulIconsCategory.Form,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Download,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.DragVertical,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Dragndrop,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Edit,
        category: [
            ModulIconsCategory.Form,
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.EmailSend,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Email
    },
    {
        name: ModulIconName.ErrorFilled,
        category: [
            ModulIconsCategory.Form,
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.ErrorWhiteFilled,
        category: [
            ModulIconsCategory.Form,
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Error,
        category: [
            ModulIconsCategory.Form,
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Evaluation
    },
    {
        name: ModulIconName.FileAccess,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileAudio,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileCode,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FileDefault,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileDwg,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileExcel,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileFlash,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Video,
            ModulIconsCategory.Image,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileImage,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Image
        ]
    },
    {
        name: ModulIconName.FileMarkup,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FileMediaplayer,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Video,
            ModulIconsCategory.Image,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileOpenofficeBase,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeCalc,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeDefault,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeDraw,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeImpress,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeMath,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileOpenofficeWritter,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FilePdf,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Image,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FilePowerpoint,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Image,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileQuicktime,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileRealplayer,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileText,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FileVideo,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.FileVisio,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FileWord,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document,
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.FileZip,
        category: [
            ModulIconsCategory.File,
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FolderOpen,
        category: [
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.Folder,
        category: [
            ModulIconsCategory.Document
        ]
    },
    {
        name: ModulIconName.FullScreen,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.GridFilled
    },
    {
        name: ModulIconName.Grid
    },
    {
        name: ModulIconName.Grouping,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.HelpCircle
    },
    {
        name: ModulIconName.Heraldry
    },
    {
        name: ModulIconName.Hide,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Hint
    },
    {
        name: ModulIconName.Home,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ImageSlideshow,
        category: [
            ModulIconsCategory.Image
        ]
    },
    {
        name: ModulIconName.ImageSquare,
        category: [
            ModulIconsCategory.Image
        ]
    },
    {
        name: ModulIconName.Image1Filled,
        category: [
            ModulIconsCategory.Image
        ]
    },
    {
        name: ModulIconName.Image2Filled,
        category: [
            ModulIconsCategory.Image
        ]
    },
    {
        name: ModulIconName.InformationFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.InformationWhiteFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Information,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.LeaveFullScreen,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.ListFilled
    },
    {
        name: ModulIconName.List
    },
    {
        name: ModulIconName.Lock
    },
    {
        name: ModulIconName.Logout,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.MultimediaExternal,
        category: [
            ModulIconsCategory.Image,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.MultimediaFilled,
        category: [
            ModulIconsCategory.Image,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.Multimedia,
        category: [
            ModulIconsCategory.Image,
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.NotAllowed,
        category: [
            ModulIconsCategory.Control,
            ModulIconsCategory.Form
        ]
    },
    {
        name: ModulIconName.Notification
    },
    {
        name: ModulIconName.Options,
        category: [
            ModulIconsCategory.Control,
            ModulIconsCategory.Form
        ]
    },
    {
        name: ModulIconName.Panel,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Profile
    },
    {
        name: ModulIconName.RemoveAssignation,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.RemoveCircleFilled,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.RemoveCircle,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Replace,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.RightAnswer,
        category: [
            ModulIconsCategory.State
        ]
    },
    {
        name: ModulIconName.RoleAssignation,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Search,
        category: [
            ModulIconsCategory.Control,
            ModulIconsCategory.Form
        ]
    },
    {
        name: ModulIconName.Show,
        category: [
            ModulIconsCategory.Control
        ]
    },
    {
        name: ModulIconName.Subtitle,
        category: [
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.Text1,
        category: [
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.Text2,
        category: [
            ModulIconsCategory.Text
        ]
    },
    {
        name: ModulIconName.VideoFilled,
        category: [
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.VideoSlideshow,
        category: [
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.Video,
        category: [
            ModulIconsCategory.Video,
            ModulIconsCategory.Audio
        ]
    },
    {
        name: ModulIconName.WarningFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.WarningWhiteFilled,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.Warning,
        category: [
            ModulIconsCategory.State,
            ModulIconsCategory.Message
        ]
    },
    {
        name: ModulIconName.WrongAnswer,
        category: [
            ModulIconsCategory.State
        ]
    }
];


/***/ }),

/***/ "./src/utils/modul/modul.ts":
/*!**********************************!*\
  !*** ./src/utils/modul/modul.ts ***!
  \**********************************/
/*! exports provided: Modul, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modul", function() { return Modul; });
/* harmony import */ var portal_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! portal-vue */ "portal-vue");
/* harmony import */ var portal_vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(portal_vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/portal/portal */ "./src/mixins/portal/portal.ts");
/* harmony import */ var _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../uuid/uuid */ "./src/utils/uuid/uuid.ts");




var BACKDROP_ID = 'mBackdropID';
var BACKDROP_CLASS_NAME = 'm-backdrop';
var BACKDROP_STYLE_TRANSITION = 'opacity ease';
var BACKDROP_STYLE_TRANSITION_SLOW_DURATION = 600;
var BACKDROP_STYLE_TRANSITION_FAST_DURATION = 300;
var BACKDROP_STYLE_POSITION = 'fixed';
var BACKDROP_STYLE_POSITION_VALUE = '0';
var BACKDROP_STYLE_BACKGROUND = '#000';
var BACKDROP_STYLE_OPACITY = '0';
var BACKDROP_STYLE_OPACITY_VISIBLE = '0.7';
var BACKDROP_STYLE_OPACITY_NOT_VISIBLE = '0';
var Z_INDEZ_DEFAULT = 100;
var DONE_EVENT_DURATION = 100;
var Modul = /** @class */ (function () {
    function Modul(options) {
        var _this = this;
        this.options = options;
        this.htmlEl = document.querySelector('html');
        this.bodyEl = document.querySelector('body');
        this.event = new vue__WEBPACK_IMPORTED_MODULE_1___default.a();
        this.scrollPosition = 0;
        this.stopScrollPosition = 0;
        this.scrollDown = false;
        this.scrollUp = true;
        this.windowZIndex = Z_INDEZ_DEFAULT;
        this.windowStack = [];
        this.windowStackMap = {};
        this.lastScrollPosition = 0;
        this.internalScrollActive = true;
        this.scrollPosition = window.pageYOffset;
        window.addEventListener('click', function (e) { return _this.onClick(e); });
        window.addEventListener('scroll', function (e) { return _this.onScroll(e); });
        window.addEventListener('resize', function (e) { return _this.onResize(e); });
    }
    /**
     * @deprecated Don't use this function to emit events between two components
     */
    Modul.prototype.updateAfterResize = function () {
        this.event.$emit('updateAfterResize');
    };
    Modul.prototype.pushElement = function (element, backdropMode, viewportIsSmall) {
        var stackId = _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate();
        var backdropIndex = undefined;
        var scrollId = undefined;
        if (backdropMode !== _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_2__["BackdropMode"].None) {
            this.scrollActive = false;
            scrollId = _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate();
        }
        if (backdropMode === _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_2__["BackdropMode"].BackdropFast || backdropMode === _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_2__["BackdropMode"].BackdropSlow) {
            backdropIndex = this.ensureBackdrop(viewportIsSmall);
        }
        var index = this.windowStack.push(stackId) - 1;
        this.windowStackMap[stackId] = {
            stackIndex: index,
            backdropIndex: backdropIndex,
            backdropIsFast: backdropMode === _mixins_portal_portal__WEBPACK_IMPORTED_MODULE_2__["BackdropMode"].BackdropFast,
            scrollId: scrollId
        };
        this.windowZIndex++;
        element.style.zIndex = String(this.windowZIndex);
        return stackId;
    };
    Modul.prototype.popElement = function (stackId) {
        if (stackId && this.windowStack) {
            if (this.peekElement() === stackId) {
                this.windowZIndex--;
                this.windowStack.pop();
            }
            else {
                var stackElement_1 = this.windowStackMap[stackId];
                if (stackElement_1 && stackElement_1.stackIndex !== undefined) {
                    this.windowStack[stackElement_1.stackIndex] = undefined;
                }
            }
            while (this.windowStack.length > 0 && this.windowStack[this.windowStack.length - 1] === undefined) {
                this.windowZIndex--;
                this.windowStack.pop();
            }
            var stackElement = this.windowStackMap[stackId];
            if (stackElement && (stackElement.backdropIndex || stackElement.scrollId)) {
                this.removeBackdrop(!stackElement.backdropIsFast);
            }
            if (this.windowZIndex < Z_INDEZ_DEFAULT) {
                vue__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.$log.warn('$modul: Invalid window ref count');
                this.windowZIndex = Z_INDEZ_DEFAULT;
            }
            delete this.windowStackMap[stackId];
        }
    };
    Modul.prototype.peekElement = function () {
        return this.windowStack.length > 0 ? this.windowStack[this.windowStack.length - 1] : undefined;
    };
    Modul.prototype.onClick = function (event) {
        this.event.$emit('click', event);
    };
    Modul.prototype.onScroll = function (event) {
        var _this = this;
        if (this.scrollActive) {
            this.scrollPosition = window.pageYOffset;
            if (this.lastScrollPosition > this.scrollPosition) {
                this.scrollUp = true;
                this.scrollDown = false;
            }
            else {
                this.scrollUp = false;
                this.scrollDown = true;
            }
            this.lastScrollPosition = this.scrollPosition;
            this.event.$emit('scroll', event);
            clearTimeout(this.doneScrollEvent);
            this.doneScrollEvent = setTimeout(function () {
                _this.event.$emit('scrollDone', event);
            }, DONE_EVENT_DURATION);
        }
    };
    Modul.prototype.onResize = function (event) {
        var _this = this;
        this.event.$emit('resize', event);
        clearTimeout(this.doneResizeEvent);
        this.doneResizeEvent = setTimeout(function () {
            _this.event.$emit('resizeDone', event);
        }, DONE_EVENT_DURATION);
    };
    Modul.prototype.ensureBackdrop = function (viewportIsSmall) {
        var _this = this;
        if (!this.backdropElement) {
            var element = document.createElement('div');
            var id = BACKDROP_ID + '-' + _uuid_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].generate();
            element.setAttribute('id', id);
            element.setAttribute('class', BACKDROP_CLASS_NAME);
            element.setAttribute('aria-hidden', 'true');
            // tslint:disable-next-line: deprecation
            element.style.webkitTransition = BACKDROP_STYLE_TRANSITION;
            element.style.transition = BACKDROP_STYLE_TRANSITION;
            element.style.position = BACKDROP_STYLE_POSITION;
            element.style.top = BACKDROP_STYLE_POSITION_VALUE;
            element.style.right = BACKDROP_STYLE_POSITION_VALUE;
            element.style.bottom = BACKDROP_STYLE_POSITION_VALUE;
            element.style.left = BACKDROP_STYLE_POSITION_VALUE;
            element.style.zIndex = String(this.windowZIndex);
            element.style.background = BACKDROP_STYLE_BACKGROUND;
            element.style.opacity = BACKDROP_STYLE_OPACITY;
            this.bodyEl.appendChild(element);
            this.backdropElement = document.querySelector('#' + id);
            var duration = String(BACKDROP_STYLE_TRANSITION_FAST_DURATION / 1000) + 's';
            // tslint:disable-next-line: deprecation
            this.backdropElement.style.webkitTransitionDuration = duration;
            this.backdropElement.style.transitionDuration = duration;
            setTimeout(function () {
                if (_this.backdropElement) {
                    _this.backdropElement.style.opacity = BACKDROP_STYLE_OPACITY_VISIBLE;
                }
            }, 5);
        }
        else {
            this.backdropElement.style.zIndex = String(this.windowZIndex);
        }
        return this.windowZIndex;
    };
    Modul.prototype.removeBackdrop = function (slow) {
        var lastBackdropIndex = undefined;
        var lastScrollId = undefined;
        for (var i = this.windowStack.length - 1; i >= 0; i--) {
            var stackId = this.windowStack[i];
            if (stackId) {
                if (!lastBackdropIndex && this.windowStackMap[stackId].backdropIndex) {
                    lastBackdropIndex = this.windowStackMap[stackId].backdropIndex;
                }
                if (!lastScrollId && this.windowStackMap[stackId].scrollId) {
                    lastScrollId = this.windowStackMap[stackId].scrollId;
                }
                if (lastBackdropIndex && lastScrollId) {
                    break;
                }
            }
        }
        if (!lastScrollId && lastBackdropIndex) {
            throw new Error('Backdrop should always hide scroll bar');
        }
        if (!lastScrollId && !this.backdropElement) {
            this.scrollActive = true;
        }
        else if (!lastBackdropIndex) {
            var speed = slow ? BACKDROP_STYLE_TRANSITION_SLOW_DURATION : BACKDROP_STYLE_TRANSITION_FAST_DURATION;
            if (this.backdropElement) {
                var duration = String(speed / 1000) + 's';
                // tslint:disable-next-line: deprecation
                this.backdropElement.style.webkitTransitionDuration = duration;
                this.backdropElement.style.transitionDuration = duration;
                this.backdropElement.style.opacity = BACKDROP_STYLE_OPACITY_NOT_VISIBLE;
                var b_1 = this.backdropElement;
                this.backdropElement = undefined;
                if (!lastScrollId) {
                    this.scrollActive = true;
                }
                setTimeout(function () {
                    if (b_1 && b_1.parentNode) {
                        b_1.parentNode.removeChild(b_1);
                    }
                }, speed);
            }
        }
        else if (this.backdropElement) {
            this.backdropElement.style.zIndex = String(lastBackdropIndex);
        }
        else {
            throw new Error('backdropElement cannot be null');
        }
    };
    Object.defineProperty(Modul.prototype, "scrollActive", {
        get: function () {
            return this.internalScrollActive;
        },
        set: function (scrollActive) {
            if (scrollActive) {
                this.htmlEl.style.removeProperty('position');
                this.htmlEl.style.removeProperty('top');
                this.htmlEl.style.removeProperty('right');
                this.htmlEl.style.removeProperty('left');
                this.htmlEl.style.removeProperty('bottom');
                this.htmlEl.style.removeProperty('height');
                this.bodyEl.style.removeProperty('margin-top');
                window.scrollTo(0, this.stopScrollPosition);
                if (this.htmlEl.style.length === 0) {
                    this.htmlEl.removeAttribute('style');
                }
                if (this.bodyEl.style.length === 0) {
                    this.bodyEl.removeAttribute('style');
                }
            }
            else {
                this.stopScrollPosition = this.scrollPosition;
                this.htmlEl.style.position = 'fixed';
                this.htmlEl.style.top = '0';
                this.htmlEl.style.right = '0';
                this.htmlEl.style.left = '0';
                this.htmlEl.style.bottom = '0';
                this.htmlEl.style.height = '100%';
                this.bodyEl.style.marginTop = "-" + this.stopScrollPosition + "px";
            }
            this.internalScrollActive = scrollActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modul.prototype, "CSPNonce", {
        get: function () {
            return this.options !== undefined ? this.options.CSPNonce : undefined;
        },
        enumerable: true,
        configurable: true
    });
    return Modul;
}());

var ModulPlugin = {
    install: function (v, options) {
        vue__WEBPACK_IMPORTED_MODULE_1___default.a.use(portal_vue__WEBPACK_IMPORTED_MODULE_0___default.a);
        var modul = new Modul(options);
        (v.prototype).$modul = modul;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ModulPlugin);


/***/ }),

/***/ "./src/utils/money/money.ts":
/*!**********************************!*\
  !*** ./src/utils/money/money.ts ***!
  \**********************************/
/*! exports provided: MCurrencyType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MCurrencyType", function() { return MCurrencyType; });
var MCurrencyType;
(function (MCurrencyType) {
    MCurrencyType["NONE"] = "";
    MCurrencyType["CAD"] = "CAD";
    MCurrencyType["USD"] = "USD";
    MCurrencyType["EUR"] = "EUR";
})(MCurrencyType || (MCurrencyType = {}));


/***/ }),

/***/ "./src/utils/mouse/mouse.ts":
/*!**********************************!*\
  !*** ./src/utils/mouse/mouse.ts ***!
  \**********************************/
/*! exports provided: mousePositionElement, isInElement, MouseButtons */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mousePositionElement", function() { return mousePositionElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInElement", function() { return isInElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MouseButtons", function() { return MouseButtons; });
// Inspiration => https://acko.net/blog/mouse-handling-and-absolute-positions-in-javascript/.
var getRelativeMousePos = function (event, reference) {
    var x = 0;
    var y = 0;
    var mouseEvent = event;
    var pos;
    var el = undefined;
    if (mouseEvent && mouseEvent.offsetX !== undefined && mouseEvent.offsetY !== undefined) {
        pos = { x: mouseEvent.offsetX, y: mouseEvent.offsetY };
        el = mouseEvent.target;
    }
    var customEvent = event;
    if (customEvent && customEvent.detail && customEvent.detail.offsetX !== undefined && customEvent.detail.offsetY !== undefined) {
        pos = { x: customEvent.detail.offsetX, y: customEvent.detail.offsetY };
        el = customEvent.detail.target;
    }
    if (el === reference) {
        return { x: pos.x, y: pos.y };
    }
    if (!pos || !el) {
        return { x: 0, y: 0 };
    }
    // Fix for firefox.
    var recursiveElement = el;
    while (recursiveElement.nodeType === Node.TEXT_NODE) {
        recursiveElement = recursiveElement.parentElement;
    }
    // Send the coordinates upwards through the offsetParent chain.
    while (recursiveElement) {
        recursiveElement.mouseX = pos.x || 0;
        recursiveElement.mouseY = pos.y || 0;
        pos.x += (recursiveElement).offsetLeft || 0;
        pos.y += (recursiveElement).offsetTop || 0;
        recursiveElement = (recursiveElement).offsetParent;
    }
    // Look for the coordinates starting from the reference element.
    var recursiveReference = reference;
    var offset = { x: 0, y: 0 };
    while (recursiveReference) {
        if (typeof recursiveReference.mouseX !== 'undefined') {
            x = recursiveReference.mouseX - offset.x;
            y = recursiveReference.mouseY - offset.y;
            break;
        }
        offset.x += recursiveReference.offsetLeft || 0;
        offset.y += recursiveReference.offsetTop || 0;
        recursiveReference = recursiveReference.offsetParent;
    }
    // Reset stored coordinates
    var recursiveCleanup = el;
    while (recursiveCleanup) {
        recursiveCleanup.mouseX = undefined;
        recursiveCleanup.mouseY = undefined;
        recursiveCleanup = recursiveCleanup.offsetParent;
    }
    // Subtract distance to middle
    return { x: x, y: y };
};
var mousePositionElement = function (e, relativeToEl) {
    return getRelativeMousePos(e, relativeToEl);
};
var isInElement = function (e, relativeToEl, threshold) {
    if (threshold === void 0) { threshold = 3; }
    var mousePosition = mousePositionElement(e, relativeToEl);
    return mousePosition.x > 0 && mousePosition.y > 0
        && mousePosition.x + threshold <= relativeToEl.offsetWidth
        && mousePosition.y + threshold <= relativeToEl.offsetHeight;
};
var MouseButtons = /** @class */ (function () {
    function MouseButtons() {
    }
    MouseButtons.LEFT = 0;
    MouseButtons.WHEEL = 1;
    MouseButtons.RIGHT = 2;
    MouseButtons.BROWSER_BACK = 3;
    MouseButtons.BROWSER_FORWARD = 4;
    return MouseButtons;
}());



/***/ }),

/***/ "./src/utils/polyfills/drag-and-drop.polyfill.ts":
/*!*******************************************************!*\
  !*** ./src/utils/polyfills/drag-and-drop.polyfill.ts ***!
  \*******************************************************/
/*! exports provided: dragDropDelay, polyFillActive */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dragDropDelay", function() { return dragDropDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyFillActive", function() { return polyFillActive; });
/* harmony import */ var mobile_drag_drop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobile-drag-drop */ "mobile-drag-drop");
/* harmony import */ var mobile_drag_drop__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mobile_drag_drop__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mobile_drag_drop_scroll_behaviour__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mobile-drag-drop/scroll-behaviour */ "mobile-drag-drop/scroll-behaviour");
/* harmony import */ var mobile_drag_drop_scroll_behaviour__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mobile_drag_drop_scroll_behaviour__WEBPACK_IMPORTED_MODULE_1__);


var dragDropDelay = 500;
var polyFillActive = {
    dragDrop: false
};
// Polyfill for drag and drop on mobile.
polyFillActive.dragDrop = Object(mobile_drag_drop__WEBPACK_IMPORTED_MODULE_0__["polyfill"])({
    holdToDrag: dragDropDelay,
    dragImageTranslateOverride: mobile_drag_drop_scroll_behaviour__WEBPACK_IMPORTED_MODULE_1__["scrollBehaviourDragImageTranslateOverride"],
    iterationInterval: 50,
    dragImageCenterOnTouch: true
});


/***/ }),

/***/ "./src/utils/props-validation/props-validation.ts":
/*!********************************************************!*\
  !*** ./src/utils/props-validation/props-validation.ts ***!
  \********************************************************/
/*! exports provided: REGEX_CSS_NUMBER_VALUE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGEX_CSS_NUMBER_VALUE", function() { return REGEX_CSS_NUMBER_VALUE; });
var REGEX_CSS_NUMBER_VALUE = /^\d+(\.[0-9]{1,4})?(px|em|rem|vw|vh|%)$/;


/***/ }),

/***/ "./src/utils/scroll-to/scroll-to.ts":
/*!******************************************!*\
  !*** ./src/utils/scroll-to/scroll-to.ts ***!
  \******************************************/
/*! exports provided: ScrollToDuration, ScrollTo, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollToDuration", function() { return ScrollToDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollTo", function() { return ScrollTo; });
var ScrollToDuration;
(function (ScrollToDuration) {
    ScrollToDuration["Long"] = "long";
    ScrollToDuration["Regular"] = "regular";
    ScrollToDuration["Fast"] = "fast";
    ScrollToDuration["Instant"] = "instant";
})(ScrollToDuration || (ScrollToDuration = {}));
var linear = function (t) { return t; };
// accelerating from zero velocity
var easeInQuad = function (t) { return t * t; };
// decelerating to zero velocity
var easeOutQuad = function (t) { return t * (2 - t); };
// accelerating from zero velocity
var easeInCubic = function (t) { return t * t * t; };
// decelerating to zero velocity
var easeOutCubic = function (t) { return --t * t * t + 1; };
// accelerating from zero velocity
var easeInQuint = function (t) { return t * t * t * t * t; };
// decelerating to zero velocity
var easeOutQuint = function (t) { return 1 + --t * t * t * t * t; };
var defaultEasingFunction = easeOutQuint;
var ScrollTo = /** @class */ (function () {
    function ScrollTo() {
    }
    /**
     * Scroll to top of the current windows
     *
     * @param duration duration of the scroll
     */
    ScrollTo.prototype.goToTop = function (duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        return this.internalScroll(undefined, 0, duration, defaultEasingFunction);
    };
    /**
     * Scroll to top of an specified container
     *
     * @param container the HTML container containing the scroll
     * @param duration duration of the scroll
     */
    ScrollTo.prototype.goToTopInside = function (container, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        return this.internalScroll(container, 0, duration, defaultEasingFunction);
    };
    /**
     * Scroll to the bottom of an specified container
     *
     * @param container the HTML container containing the scroll
     * @param duration duration of the scroll
     */
    ScrollTo.prototype.goToBottomInside = function (container, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        var targetLocation = this.maxContainerScroll(container);
        return this.internalScroll(container, targetLocation, duration, defaultEasingFunction);
    };
    /**
     * Scroll to the bottom of the windows
     *
     * @param duration duration of the scroll
     */
    ScrollTo.prototype.goToBottom = function (duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        var targetLocation = this.maxWindowScroll();
        return this.internalScroll(undefined, targetLocation, duration, defaultEasingFunction);
    };
    /**
     * Scroll to a specific element or position of the windows
     *
     * @param target the HTML container containing the scroll
     * @param offset the offset to add (in case of a sticky header)
     * @param duration duration of the scroll
     */
    ScrollTo.prototype.goTo = function (target, offset, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        var targetLocation = 0;
        // get element relative position from window
        if (target instanceof HTMLElement) {
            var elementLocation = target.getBoundingClientRect().top + window.pageYOffset;
            targetLocation = Math.max(Math.round(elementLocation) + offset, 0);
        }
        else {
            targetLocation = +target;
        }
        // get scroll location if its less than maxscroll
        var scrollLocation = Math.min(targetLocation, this.maxWindowScroll());
        return this.internalScroll(undefined, scrollLocation, duration, defaultEasingFunction);
    };
    /**
     * Scroll to a specific element of an specified container
     *
     * @param container the HTML container containing the scroll
     * @param target the target HtmlElement
     * @param offset the offset to add (in case of a sticky header)
     * @param duration duration of the scroll
     * @param easing easing function to use
     */
    ScrollTo.prototype.goToInside = function (container, target, offset, duration) {
        if (duration === void 0) { duration = ScrollToDuration.Regular; }
        var targetLocation = 0;
        // get element relative position from container
        if (target instanceof HTMLElement) {
            var scrollTop = (container.getBoundingClientRect().top * -1) + container.scrollTop;
            targetLocation = (target.getBoundingClientRect().top + scrollTop) - container.clientTop;
            targetLocation = targetLocation + offset;
        }
        else {
            targetLocation = +target;
        }
        // get scroll location if its less than maxscroll
        var scrollLocation = Math.min(targetLocation, this.maxContainerScroll(container));
        return this.internalScroll(container, scrollLocation, duration, defaultEasingFunction);
    };
    ScrollTo.prototype.internalScroll = function (container, targetLocation, duration, easing) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var startTime = performance.now();
            var startLocation = 0;
            if (container) {
                _this.disableScrollEvent(container);
                startLocation = container.scrollTop;
            }
            else {
                _this.disableScrollEvent(document.body);
                startLocation = window.pageYOffset;
            }
            var distanceToScroll = targetLocation - startLocation;
            var _duration = _this.getDuration(duration);
            var step = function (currentTime) {
                var progressPercentage = _duration ? Math.min(1, ((currentTime - startTime) / _duration)) : 100;
                var targetPosition = _duration ? Math.floor(startLocation + distanceToScroll * easing(progressPercentage)) : targetLocation;
                if (container) {
                    container.scrollTop = targetPosition;
                    if (targetPosition === targetLocation || progressPercentage === 1) {
                        _this.enableScrollEvent(container);
                        return resolve(targetLocation);
                    }
                }
                else {
                    window.scrollTo(0, targetPosition);
                    if (Math.round(window.pageYOffset) === targetLocation || progressPercentage === 1) {
                        _this.enableScrollEvent(document.body);
                        return resolve(targetLocation);
                    }
                }
                window.requestAnimationFrame(step);
            };
            window.requestAnimationFrame(step);
        });
    };
    ScrollTo.prototype.disableScrollEvent = function (container) {
        container.addEventListener('touchmove', this.preventDefault, { passive: false });
        container.addEventListener('wheel', this.preventDefault, { passive: false });
        container.addEventListener('touchstart ', this.preventDefault, { passive: false });
    };
    ScrollTo.prototype.enableScrollEvent = function (container) {
        container.removeEventListener('touchmove', this.preventDefault);
        container.removeEventListener('wheel', this.preventDefault);
        container.removeEventListener('touchstart', this.preventDefault);
    };
    ScrollTo.prototype.preventDefault = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    ScrollTo.prototype.maxContainerScroll = function (container) {
        return Math.max(Math.round(container.scrollHeight - container.offsetHeight), 0);
    };
    ScrollTo.prototype.maxWindowScroll = function () {
        return this.getDocumentHeight() - this.getWindowHeight();
    };
    ScrollTo.prototype.getDocumentHeight = function () {
        return Math.max(document.body.scrollHeight, document.documentElement ? document.documentElement.scrollHeight : 0, document.body.offsetHeight, document.documentElement ? document.documentElement.offsetHeight : 0, document.body.clientHeight, document.documentElement ? document.documentElement.clientHeight : 0);
    };
    ScrollTo.prototype.getWindowHeight = function () {
        return window.innerHeight ||
            (document.documentElement || document.body).clientHeight;
    };
    ScrollTo.prototype.getDuration = function (speed) {
        switch (speed) {
            case ScrollToDuration.Long:
                return 1000;
            case ScrollToDuration.Regular:
                return 600;
            case ScrollToDuration.Fast:
                return 400;
            case ScrollToDuration.Instant:
                return 0;
            default: throw Error('scrollToUtil: Unknown scroll duration.');
        }
    };
    return ScrollTo;
}());

var ScrollToPlugin = {
    install: function (v) {
        var scrollTo = new ScrollTo();
        (v.prototype).$scrollTo = scrollTo;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ScrollToPlugin);


/***/ }),

/***/ "./src/utils/selection/selection.ts":
/*!******************************************!*\
  !*** ./src/utils/selection/selection.ts ***!
  \******************************************/
/*! exports provided: clearUserSelection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearUserSelection", function() { return clearUserSelection; });
var clearUserSelection = function () {
    // Source: https://jsfiddle.net/mkrivan/hohx4nes/
    if (document.getSelection) { // for all new browsers (IE9+, Chrome, Firefox)
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(document.createRange());
    }
    else if (window.getSelection) { // equals with the document.getSelection (MSDN info)
        if (window.getSelection().removeAllRanges) { // for all new browsers (IE9+, Chrome, Firefox)
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(document.createRange());
        }
        else if (window.getSelection().empty) { // Chrome supports this as well
            window.getSelection().empty();
        }
    }
    else if (document.selection) { // IE8-
        document.selection.empty();
    }
};


/***/ }),

/***/ "./src/utils/str/str.ts":
/*!******************************!*\
  !*** ./src/utils/str/str.ts ***!
  \******************************/
/*! exports provided: getString, startsWith, normalizeString, NBSP */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getString", function() { return getString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startsWith", function() { return startsWith; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeString", function() { return normalizeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NBSP", function() { return NBSP; });
/**
 * Obtains the string value from different source types.
 * @param text The value from witch the string must be extracted.
 */
function getString(text) {
    if (!text) {
        return '';
    }
    return typeof text === 'string' ? text : text();
}
function startsWith(text, startsWith) {
    var undef = undefined;
    return (text === undef && startsWith === undef) // both undef
        || (text !== undef && startsWith !== undef && !text && !startsWith) // both empty
        || (!!text && startsWith !== undef && !startsWith) // startsWith empty
        || (!!text && !!startsWith && text.slice(0, startsWith.length) === startsWith);
}
var diacriticsMap = {};
diacriticsMap[0x0061] = 'a';
diacriticsMap[0x24D0] = 'a';
diacriticsMap[0xFF41] = 'a';
diacriticsMap[0x1E9A] = 'a';
diacriticsMap[0x00E0] = 'a';
diacriticsMap[0x00E1] = 'a';
diacriticsMap[0x00E2] = 'a';
diacriticsMap[0x1EA7] = 'a';
diacriticsMap[0x1EA5] = 'a';
diacriticsMap[0x1EAB] = 'a';
diacriticsMap[0x1EA9] = 'a';
diacriticsMap[0x00E3] = 'a';
diacriticsMap[0x0101] = 'a';
diacriticsMap[0x0103] = 'a';
diacriticsMap[0x1EB1] = 'a';
diacriticsMap[0x1EAF] = 'a';
diacriticsMap[0x1EB5] = 'a';
diacriticsMap[0x1EB3] = 'a';
diacriticsMap[0x0227] = 'a';
diacriticsMap[0x01E1] = 'a';
diacriticsMap[0x00E4] = 'a';
diacriticsMap[0x01DF] = 'a';
diacriticsMap[0x1EA3] = 'a';
diacriticsMap[0x00E5] = 'a';
diacriticsMap[0x01FB] = 'a';
diacriticsMap[0x01CE] = 'a';
diacriticsMap[0x0201] = 'a';
diacriticsMap[0x0203] = 'a';
diacriticsMap[0x1EA1] = 'a';
diacriticsMap[0x1EAD] = 'a';
diacriticsMap[0x1EB7] = 'a';
diacriticsMap[0x1E01] = 'a';
diacriticsMap[0x0105] = 'a';
diacriticsMap[0x2C65] = 'a';
diacriticsMap[0x0250] = 'a';
diacriticsMap[0xA733] = 'aa';
diacriticsMap[0x00E6] = 'ae';
diacriticsMap[0x01FD] = 'ae';
diacriticsMap[0x01E3] = 'ae';
diacriticsMap[0xA735] = 'ao';
diacriticsMap[0xA737] = 'au';
diacriticsMap[0xA739] = 'av';
diacriticsMap[0xA73B] = 'av';
diacriticsMap[0xA73D] = 'ay';
diacriticsMap[0x0062] = 'b';
diacriticsMap[0x24D1] = 'b';
diacriticsMap[0xFF42] = 'b';
diacriticsMap[0x1E03] = 'b';
diacriticsMap[0x1E05] = 'b';
diacriticsMap[0x1E07] = 'b';
diacriticsMap[0x0180] = 'b';
diacriticsMap[0x0183] = 'b';
diacriticsMap[0x0253] = 'b';
diacriticsMap[0x0063] = 'c';
diacriticsMap[0x24D2] = 'c';
diacriticsMap[0xFF43] = 'c';
diacriticsMap[0x0107] = 'c';
diacriticsMap[0x0109] = 'c';
diacriticsMap[0x010B] = 'c';
diacriticsMap[0x010D] = 'c';
diacriticsMap[0x00E7] = 'c';
diacriticsMap[0x1E09] = 'c';
diacriticsMap[0x0188] = 'c';
diacriticsMap[0x023C] = 'c';
diacriticsMap[0xA73F] = 'c';
diacriticsMap[0x2184] = 'c';
diacriticsMap[0x0064] = 'd';
diacriticsMap[0x24D3] = 'd';
diacriticsMap[0xFF44] = 'd';
diacriticsMap[0x1E0B] = 'd';
diacriticsMap[0x010F] = 'd';
diacriticsMap[0x1E0D] = 'd';
diacriticsMap[0x1E11] = 'd';
diacriticsMap[0x1E13] = 'd';
diacriticsMap[0x1E0F] = 'd';
diacriticsMap[0x0111] = 'd';
diacriticsMap[0x018C] = 'd';
diacriticsMap[0x0256] = 'd';
diacriticsMap[0x0257] = 'd';
diacriticsMap[0xA77A] = 'd';
diacriticsMap[0x01F3] = 'dz';
diacriticsMap[0x01C6] = 'dz';
diacriticsMap[0x0065] = 'e';
diacriticsMap[0x24D4] = 'e';
diacriticsMap[0xFF45] = 'e';
diacriticsMap[0x00E8] = 'e';
diacriticsMap[0x00E9] = 'e';
diacriticsMap[0x00EA] = 'e';
diacriticsMap[0x1EC1] = 'e';
diacriticsMap[0x1EBF] = 'e';
diacriticsMap[0x1EC5] = 'e';
diacriticsMap[0x1EC3] = 'e';
diacriticsMap[0x1EBD] = 'e';
diacriticsMap[0x0113] = 'e';
diacriticsMap[0x1E15] = 'e';
diacriticsMap[0x1E17] = 'e';
diacriticsMap[0x0115] = 'e';
diacriticsMap[0x0117] = 'e';
diacriticsMap[0x00EB] = 'e';
diacriticsMap[0x1EBB] = 'e';
diacriticsMap[0x011B] = 'e';
diacriticsMap[0x0205] = 'e';
diacriticsMap[0x0207] = 'e';
diacriticsMap[0x1EB9] = 'e';
diacriticsMap[0x1EC7] = 'e';
diacriticsMap[0x0229] = 'e';
diacriticsMap[0x1E1D] = 'e';
diacriticsMap[0x0119] = 'e';
diacriticsMap[0x1E19] = 'e';
diacriticsMap[0x1E1B] = 'e';
diacriticsMap[0x0247] = 'e';
diacriticsMap[0x025B] = 'e';
diacriticsMap[0x01DD] = 'e';
diacriticsMap[0x0066] = 'f';
diacriticsMap[0x24D5] = 'f';
diacriticsMap[0xFF46] = 'f';
diacriticsMap[0x1E1F] = 'f';
diacriticsMap[0x0192] = 'f';
diacriticsMap[0xA77C] = 'f';
diacriticsMap[0x0067] = 'g';
diacriticsMap[0x24D6] = 'g';
diacriticsMap[0xFF47] = 'g';
diacriticsMap[0x01F5] = 'g';
diacriticsMap[0x011D] = 'g';
diacriticsMap[0x1E21] = 'g';
diacriticsMap[0x011F] = 'g';
diacriticsMap[0x0121] = 'g';
diacriticsMap[0x01E7] = 'g';
diacriticsMap[0x0123] = 'g';
diacriticsMap[0x01E5] = 'g';
diacriticsMap[0x0260] = 'g';
diacriticsMap[0xA7A1] = 'g';
diacriticsMap[0x1D79] = 'g';
diacriticsMap[0xA77F] = 'g';
diacriticsMap[0x0068] = 'h';
diacriticsMap[0x24D7] = 'h';
diacriticsMap[0xFF48] = 'h';
diacriticsMap[0x0125] = 'h';
diacriticsMap[0x1E23] = 'h';
diacriticsMap[0x1E27] = 'h';
diacriticsMap[0x021F] = 'h';
diacriticsMap[0x1E25] = 'h';
diacriticsMap[0x1E29] = 'h';
diacriticsMap[0x1E2B] = 'h';
diacriticsMap[0x1E96] = 'h';
diacriticsMap[0x0127] = 'h';
diacriticsMap[0x2C68] = 'h';
diacriticsMap[0x2C76] = 'h';
diacriticsMap[0x0265] = 'h';
diacriticsMap[0x0195] = 'hv';
diacriticsMap[0x0069] = 'i';
diacriticsMap[0x24D8] = 'i';
diacriticsMap[0xFF49] = 'i';
diacriticsMap[0x00EC] = 'i';
diacriticsMap[0x00ED] = 'i';
diacriticsMap[0x00EE] = 'i';
diacriticsMap[0x0129] = 'i';
diacriticsMap[0x012B] = 'i';
diacriticsMap[0x012D] = 'i';
diacriticsMap[0x00EF] = 'i';
diacriticsMap[0x1E2F] = 'i';
diacriticsMap[0x1EC9] = 'i';
diacriticsMap[0x01D0] = 'i';
diacriticsMap[0x0209] = 'i';
diacriticsMap[0x020B] = 'i';
diacriticsMap[0x1ECB] = 'i';
diacriticsMap[0x012F] = 'i';
diacriticsMap[0x1E2D] = 'i';
diacriticsMap[0x0268] = 'i';
diacriticsMap[0x0131] = 'i';
diacriticsMap[0x006A] = 'j';
diacriticsMap[0x24D9] = 'j';
diacriticsMap[0xFF4A] = 'j';
diacriticsMap[0x0135] = 'j';
diacriticsMap[0x01F0] = 'j';
diacriticsMap[0x0249] = 'j';
diacriticsMap[0x006B] = 'k';
diacriticsMap[0x24DA] = 'k';
diacriticsMap[0xFF4B] = 'k';
diacriticsMap[0x1E31] = 'k';
diacriticsMap[0x01E9] = 'k';
diacriticsMap[0x1E33] = 'k';
diacriticsMap[0x0137] = 'k';
diacriticsMap[0x1E35] = 'k';
diacriticsMap[0x0199] = 'k';
diacriticsMap[0x2C6A] = 'k';
diacriticsMap[0xA741] = 'k';
diacriticsMap[0xA743] = 'k';
diacriticsMap[0xA745] = 'k';
diacriticsMap[0xA7A3] = 'k';
diacriticsMap[0x006C] = 'l';
diacriticsMap[0x24DB] = 'l';
diacriticsMap[0xFF4C] = 'l';
diacriticsMap[0x0140] = 'l';
diacriticsMap[0x013A] = 'l';
diacriticsMap[0x013E] = 'l';
diacriticsMap[0x1E37] = 'l';
diacriticsMap[0x1E39] = 'l';
diacriticsMap[0x013C] = 'l';
diacriticsMap[0x1E3D] = 'l';
diacriticsMap[0x1E3B] = 'l';
diacriticsMap[0x017F] = 'l';
diacriticsMap[0x0142] = 'l';
diacriticsMap[0x019A] = 'l';
diacriticsMap[0x026B] = 'l';
diacriticsMap[0x2C61] = 'l';
diacriticsMap[0xA749] = 'l';
diacriticsMap[0xA781] = 'l';
diacriticsMap[0xA747] = 'l';
diacriticsMap[0x01C9] = 'lj';
diacriticsMap[0x006D] = 'm';
diacriticsMap[0x24DC] = 'm';
diacriticsMap[0xFF4D] = 'm';
diacriticsMap[0x1E3F] = 'm';
diacriticsMap[0x1E41] = 'm';
diacriticsMap[0x1E43] = 'm';
diacriticsMap[0x0271] = 'm';
diacriticsMap[0x026F] = 'm';
diacriticsMap[0x006E] = 'n';
diacriticsMap[0x24DD] = 'n';
diacriticsMap[0xFF4E] = 'n';
diacriticsMap[0x01F9] = 'n';
diacriticsMap[0x0144] = 'n';
diacriticsMap[0x00F1] = 'n';
diacriticsMap[0x1E45] = 'n';
diacriticsMap[0x0148] = 'n';
diacriticsMap[0x1E47] = 'n';
diacriticsMap[0x0146] = 'n';
diacriticsMap[0x1E4B] = 'n';
diacriticsMap[0x1E49] = 'n';
diacriticsMap[0x019E] = 'n';
diacriticsMap[0x0272] = 'n';
diacriticsMap[0x0149] = 'n';
diacriticsMap[0xA791] = 'n';
diacriticsMap[0xA7A5] = 'n';
diacriticsMap[0x01CC] = 'nj';
diacriticsMap[0x006F] = 'o';
diacriticsMap[0x24DE] = 'o';
diacriticsMap[0xFF4F] = 'o';
diacriticsMap[0x00F2] = 'o';
diacriticsMap[0x00F3] = 'o';
diacriticsMap[0x00F4] = 'o';
diacriticsMap[0x1ED3] = 'o';
diacriticsMap[0x1ED1] = 'o';
diacriticsMap[0x1ED7] = 'o';
diacriticsMap[0x1ED5] = 'o';
diacriticsMap[0x00F5] = 'o';
diacriticsMap[0x1E4D] = 'o';
diacriticsMap[0x022D] = 'o';
diacriticsMap[0x1E4F] = 'o';
diacriticsMap[0x014D] = 'o';
diacriticsMap[0x1E51] = 'o';
diacriticsMap[0x1E53] = 'o';
diacriticsMap[0x014F] = 'o';
diacriticsMap[0x022F] = 'o';
diacriticsMap[0x0231] = 'o';
diacriticsMap[0x00F6] = 'o';
diacriticsMap[0x022B] = 'o';
diacriticsMap[0x1ECF] = 'o';
diacriticsMap[0x0151] = 'o';
diacriticsMap[0x01D2] = 'o';
diacriticsMap[0x020D] = 'o';
diacriticsMap[0x020F] = 'o';
diacriticsMap[0x01A1] = 'o';
diacriticsMap[0x1EDD] = 'o';
diacriticsMap[0x1EDB] = 'o';
diacriticsMap[0x1EE1] = 'o';
diacriticsMap[0x1EDF] = 'o';
diacriticsMap[0x1EE3] = 'o';
diacriticsMap[0x1ECD] = 'o';
diacriticsMap[0x1ED9] = 'o';
diacriticsMap[0x01EB] = 'o';
diacriticsMap[0x01ED] = 'o';
diacriticsMap[0x00F8] = 'o';
diacriticsMap[0x01FF] = 'o';
diacriticsMap[0x0254] = 'o';
diacriticsMap[0xA74B] = 'o';
diacriticsMap[0xA74D] = 'o';
diacriticsMap[0x0275] = 'o';
diacriticsMap[0x01A3] = 'oi';
diacriticsMap[0x0223] = 'ou';
diacriticsMap[0xA74F] = 'oo';
diacriticsMap[0x0070] = 'p';
diacriticsMap[0x24DF] = 'p';
diacriticsMap[0xFF50] = 'p';
diacriticsMap[0x1E55] = 'p';
diacriticsMap[0x1E57] = 'p';
diacriticsMap[0x01A5] = 'p';
diacriticsMap[0x1D7D] = 'p';
diacriticsMap[0xA751] = 'p';
diacriticsMap[0xA753] = 'p';
diacriticsMap[0xA755] = 'p';
diacriticsMap[0x0071] = 'q';
diacriticsMap[0x24E0] = 'q';
diacriticsMap[0xFF51] = 'q';
diacriticsMap[0x024B] = 'q';
diacriticsMap[0xA757] = 'q';
diacriticsMap[0xA759] = 'q';
diacriticsMap[0x0072] = 'r';
diacriticsMap[0x24E1] = 'r';
diacriticsMap[0xFF52] = 'r';
diacriticsMap[0x0155] = 'r';
diacriticsMap[0x1E59] = 'r';
diacriticsMap[0x0159] = 'r';
diacriticsMap[0x0211] = 'r';
diacriticsMap[0x0213] = 'r';
diacriticsMap[0x1E5B] = 'r';
diacriticsMap[0x1E5D] = 'r';
diacriticsMap[0x0157] = 'r';
diacriticsMap[0x1E5F] = 'r';
diacriticsMap[0x024D] = 'r';
diacriticsMap[0x027D] = 'r';
diacriticsMap[0xA75B] = 'r';
diacriticsMap[0xA7A7] = 'r';
diacriticsMap[0xA783] = 'r';
diacriticsMap[0x0073] = 's';
diacriticsMap[0x24E2] = 's';
diacriticsMap[0xFF53] = 's';
diacriticsMap[0x015B] = 's';
diacriticsMap[0x1E65] = 's';
diacriticsMap[0x015D] = 's';
diacriticsMap[0x1E61] = 's';
diacriticsMap[0x0161] = 's';
diacriticsMap[0x1E67] = 's';
diacriticsMap[0x1E63] = 's';
diacriticsMap[0x1E69] = 's';
diacriticsMap[0x0219] = 's';
diacriticsMap[0x015F] = 's';
diacriticsMap[0x023F] = 's';
diacriticsMap[0xA7A9] = 's';
diacriticsMap[0xA785] = 's';
diacriticsMap[0x1E9B] = 's';
diacriticsMap[0x00DF] = 'ss';
diacriticsMap[0x0074] = 't';
diacriticsMap[0x24E3] = 't';
diacriticsMap[0xFF54] = 't';
diacriticsMap[0x1E6B] = 't';
diacriticsMap[0x1E97] = 't';
diacriticsMap[0x0165] = 't';
diacriticsMap[0x1E6D] = 't';
diacriticsMap[0x021B] = 't';
diacriticsMap[0x0163] = 't';
diacriticsMap[0x1E71] = 't';
diacriticsMap[0x1E6F] = 't';
diacriticsMap[0x0167] = 't';
diacriticsMap[0x01AD] = 't';
diacriticsMap[0x0288] = 't';
diacriticsMap[0x2C66] = 't';
diacriticsMap[0xA787] = 't';
diacriticsMap[0xA729] = 'tz';
diacriticsMap[0x0075] = 'u';
diacriticsMap[0x24E4] = 'u';
diacriticsMap[0xFF55] = 'u';
diacriticsMap[0x00F9] = 'u';
diacriticsMap[0x00FA] = 'u';
diacriticsMap[0x00FB] = 'u';
diacriticsMap[0x0169] = 'u';
diacriticsMap[0x1E79] = 'u';
diacriticsMap[0x016B] = 'u';
diacriticsMap[0x1E7B] = 'u';
diacriticsMap[0x016D] = 'u';
diacriticsMap[0x00FC] = 'u';
diacriticsMap[0x01DC] = 'u';
diacriticsMap[0x01D8] = 'u';
diacriticsMap[0x01D6] = 'u';
diacriticsMap[0x01DA] = 'u';
diacriticsMap[0x1EE7] = 'u';
diacriticsMap[0x016F] = 'u';
diacriticsMap[0x0171] = 'u';
diacriticsMap[0x01D4] = 'u';
diacriticsMap[0x0215] = 'u';
diacriticsMap[0x0217] = 'u';
diacriticsMap[0x01B0] = 'u';
diacriticsMap[0x1EEB] = 'u';
diacriticsMap[0x1EE9] = 'u';
diacriticsMap[0x1EEF] = 'u';
diacriticsMap[0x1EED] = 'u';
diacriticsMap[0x1EF1] = 'u';
diacriticsMap[0x1EE5] = 'u';
diacriticsMap[0x1E73] = 'u';
diacriticsMap[0x0173] = 'u';
diacriticsMap[0x1E77] = 'u';
diacriticsMap[0x1E75] = 'u';
diacriticsMap[0x0289] = 'u';
diacriticsMap[0x0076] = 'v';
diacriticsMap[0x24E5] = 'v';
diacriticsMap[0xFF56] = 'v';
diacriticsMap[0x1E7D] = 'v';
diacriticsMap[0x1E7F] = 'v';
diacriticsMap[0x028B] = 'v';
diacriticsMap[0xA75F] = 'v';
diacriticsMap[0x028C] = 'v';
diacriticsMap[0xA761] = 'vy';
diacriticsMap[0x0077] = 'w';
diacriticsMap[0x24E6] = 'w';
diacriticsMap[0xFF57] = 'w';
diacriticsMap[0x1E81] = 'w';
diacriticsMap[0x1E83] = 'w';
diacriticsMap[0x0175] = 'w';
diacriticsMap[0x1E87] = 'w';
diacriticsMap[0x1E85] = 'w';
diacriticsMap[0x1E98] = 'w';
diacriticsMap[0x1E89] = 'w';
diacriticsMap[0x2C73] = 'w';
diacriticsMap[0x0078] = 'x';
diacriticsMap[0x24E7] = 'x';
diacriticsMap[0xFF58] = 'x';
diacriticsMap[0x1E8B] = 'x';
diacriticsMap[0x1E8D] = 'x';
diacriticsMap[0x0079] = 'y';
diacriticsMap[0x24E8] = 'y';
diacriticsMap[0xFF59] = 'y';
diacriticsMap[0x1EF3] = 'y';
diacriticsMap[0x00FD] = 'y';
diacriticsMap[0x0177] = 'y';
diacriticsMap[0x1EF9] = 'y';
diacriticsMap[0x0233] = 'y';
diacriticsMap[0x1E8F] = 'y';
diacriticsMap[0x00FF] = 'y';
diacriticsMap[0x1EF7] = 'y';
diacriticsMap[0x1E99] = 'y';
diacriticsMap[0x1EF5] = 'y';
diacriticsMap[0x01B4] = 'y';
diacriticsMap[0x024F] = 'y';
diacriticsMap[0x1EFF] = 'y';
diacriticsMap[0x007A] = 'z';
diacriticsMap[0x24E9] = 'z';
diacriticsMap[0xFF5A] = 'z';
diacriticsMap[0x017A] = 'z';
diacriticsMap[0x1E91] = 'z';
diacriticsMap[0x017C] = 'z';
diacriticsMap[0x017E] = 'z';
diacriticsMap[0x1E93] = 'z';
diacriticsMap[0x1E95] = 'z';
diacriticsMap[0x01B6] = 'z';
diacriticsMap[0x0225] = 'z';
diacriticsMap[0x0240] = 'z';
diacriticsMap[0x2C6C] = 'z';
diacriticsMap[0xA763] = 'z';
/**
 * Normalize a string to remove accents. Then, the normalize version will be used to make the comparison.
 * function convert to lowercase. *
 * @param {string} texte The string to normalize
 * @return {string} The string in lowercase with accent characters replace by non-accent one.
 */
function normalizeString(str) {
    var result = '';
    var val = str.toString(); // In case 'str' is a numeric value
    for (var i = 0; i < val.length; ++i) {
        // Passer chaque cles et remplacer dans la chaine
        var converted = diacriticsMap[val.charAt(i).toLowerCase().charCodeAt(0)];
        result += converted ? converted : val.charAt(i);
    }
    return result;
}
var NBSP = '\xa0';


/***/ }),

/***/ "./src/utils/svg/sprites.ts":
/*!**********************************!*\
  !*** ./src/utils/svg/sprites.ts ***!
  \**********************************/
/*! exports provided: SpritesService, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpritesService", function() { return SpritesService; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuid_uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../uuid/uuid */ "./src/utils/uuid/uuid.ts");


var SpritesService = /** @class */ (function () {
    function SpritesService() {
        this.externalSpriteIdPrefixes = new Map();
    }
    /** @deprecated Use addInternalSprites or addExternalSprites instead */
    SpritesService.prototype.addSprites = function (sprites) {
        return this.addInternalSprites(sprites);
    };
    SpritesService.prototype.addInternalSprites = function (sprites) {
        var div = document.createElement('div');
        var id = _uuid_uuid__WEBPACK_IMPORTED_MODULE_1__["default"].generate();
        div.id = id;
        div.setAttribute('aria-hidden', 'true');
        div.style.display = 'none';
        div.innerHTML = sprites;
        document.body.insertBefore(div, document.body.childNodes[0]);
        return id;
    };
    SpritesService.prototype.removeInternalSprite = function (id) {
        if (document.getElementById(id) !== null) {
            document.getElementById(id).remove();
        }
        else {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$log.warn("unable to remove internal sprite with id=" + id);
        }
    };
    SpritesService.prototype.addExternalSprites = function (sprites, externalSpriteIdPrefix) {
        if (this.isInExternalSprites(externalSpriteIdPrefix)) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$log.warn('"' + externalSpriteIdPrefix + '" already exists in the externalSpriteIdPrefixes. You are overwriting a sprites collection.');
        }
        this.externalSpriteIdPrefixes.set(externalSpriteIdPrefix, sprites);
    };
    SpritesService.prototype.getExternalSpritesFromSpriteId = function (spriteId) {
        if (spriteId && this.isInExternalSprites(this.getExternalSpriteIdPrefixFromSpriteId(spriteId))) {
            return this.getExternalSprites(this.getExternalSpriteIdPrefixFromSpriteId(spriteId)) + '#' + spriteId;
        }
    };
    SpritesService.prototype.isInExternalSprites = function (externalSpriteIdPrefix) {
        return externalSpriteIdPrefix !== undefined && this.externalSpriteIdPrefixes.has(externalSpriteIdPrefix);
    };
    SpritesService.prototype.getExternalSpriteIdPrefixFromSpriteId = function (spriteId) {
        if (spriteId.indexOf(SpritesService.externalSpriteIdPrefixSeparator) !== -1) {
            return spriteId.split(SpritesService.externalSpriteIdPrefixSeparator)[0];
        }
    };
    SpritesService.prototype.getExternalSprites = function (externalSpriteIdPrefix) {
        return this.externalSpriteIdPrefixes.get(externalSpriteIdPrefix);
    };
    SpritesService.externalSpriteIdPrefixSeparator = '-';
    return SpritesService;
}());

var SpritesPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('$svg', 'plugin.install');
        var svg = new SpritesService();
        (v.prototype).$svg = svg;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SpritesPlugin);


/***/ }),

/***/ "./src/utils/svg/svg-sprite.ts":
/*!*************************************!*\
  !*** ./src/utils/svg/svg-sprite.ts ***!
  \*************************************/
/*! exports provided: SvgSpriteService, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgSpriteService", function() { return SvgSpriteService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);

var SvgSpriteService = /** @class */ (function () {
    function SvgSpriteService() {
        this.svgList = {};
    }
    SvgSpriteService.prototype.addSvg = function (svgName, svgString) {
        if (this.svgList[svgName]) {
            if (this.svgList[svgName] !== svgString) {
                // tslint:disable-next-line: no-console
                console.warn("The '" + svgName + "' SVG name is already used to display another SVG. Choose a new name to save the SVG in this sprite.");
            }
            return;
        }
        this.svgList[svgName] = svgString;
    };
    SvgSpriteService.prototype.removeSvg = function (svgNames) {
        var _this = this;
        this.svgList = Object.keys(this.svgList).reduce(function (acc, value) {
            var _a;
            return (svgNames.some(function (sn) { return value === sn; }) ? acc : Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, acc), (_a = {}, _a[value] = _this.svgList[value], _a)));
        }, {});
    };
    SvgSpriteService.prototype.getSvgString = function (svgName) {
        if (!this.svgList[svgName]) {
            // tslint:disable-next-line: no-console
            console.warn(this.getErrorMessage(svgName));
            return;
        }
        return this.svgList[svgName];
    };
    SvgSpriteService.prototype.getSvg = function (svgName) {
        if (!this.svgList[svgName]) {
            // tslint:disable-next-line: no-console
            console.warn(this.getErrorMessage(svgName));
            return;
        }
        var domParser = new DOMParser().parseFromString(this.svgList[svgName], 'text/html');
        return domParser && domParser.querySelector('svg') ? domParser.querySelector('svg') : undefined;
    };
    SvgSpriteService.prototype.getSvgList = function () {
        return this.svgList;
    };
    SvgSpriteService.prototype.getErrorMessage = function (svgName) {
        return "SVG " + svgName + " hasn't added to the sprite yet. Use the 'addSvg(svgName: string, svgString: string)' method to add the SVG to the sprite";
    };
    return SvgSpriteService;
}());

var SvgSpritesPlugin = {
    install: function (v) {
        v.prototype.$log.debug('$svgSprite', 'plugin.install');
        var svgSprite = new SvgSpriteService();
        (v.prototype).$svgSprite = svgSprite;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (SvgSpritesPlugin);


/***/ }),

/***/ "./src/utils/toast/toast-service.plugin.ts":
/*!*************************************************!*\
  !*** ./src/utils/toast/toast-service.plugin.ts ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _toast_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toast-service */ "./src/utils/toast/toast-service.ts");

var ToastServicePlugin = {
    install: function (v) {
        var toast = new _toast_service__WEBPACK_IMPORTED_MODULE_0__["default"]();
        v.prototype.$toast = toast;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ToastServicePlugin);


/***/ }),

/***/ "./src/utils/toast/toast-service.ts":
/*!******************************************!*\
  !*** ./src/utils/toast/toast-service.ts ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_toast_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../components/toast/toast */ "./src/components/toast/toast.ts");



var TIME_BEFORE_ANIMATION_IS_OVER = 300;
var ToastService = /** @class */ (function () {
    function ToastService() {
        this.toasts = [];
        this.baseTopPosition = '0';
    }
    ToastService.prototype.show = function (params) {
        var toast = this.createToast(params);
        this.toasts.push(toast);
        if (this.activeToast) {
            this.activeToast.open = false;
            this.activeToast = this.toasts[1];
            this.toasts.splice(0, 1);
        }
        else {
            this.activeToast = this.toasts[0];
        }
    };
    ToastService.prototype.clear = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, Promise, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (this.activeToast) {
                    this.activeToast.open = false;
                }
                this.toasts = [];
                this.activeToast = undefined;
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(function () { return resolve(); }, TIME_BEFORE_ANIMATION_IS_OVER);
                    })];
            });
        });
    };
    ToastService.prototype.createToast = function (params) {
        var _a;
        var toast = new _components_toast_toast__WEBPACK_IMPORTED_MODULE_2__["MToast"]({
            el: document.createElement('div'),
            propsData: (_a = {},
                _a['open.sync'] = true,
                _a.state = params.state,
                _a.position = params.position,
                _a.timeout = params.timeout,
                _a.actionLabel = params.actionLabel,
                _a.icon = params.icon,
                _a.closeButton = params.closeButton,
                _a)
        });
        toast.$on('close', function () { return setTimeout(function () { return toast.$destroy(); }, TIME_BEFORE_ANIMATION_IS_OVER); });
        if (params.action) {
            toast.$on('action-button', function (event) {
                params.action(event);
            });
        }
        toast.offset = toast.isTop ? this.baseTopPosition : '0';
        // Si c'est déjà du HTML, laisser tel quel, sinon, encapsuler dans un p
        params.text = /^<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>$/.test(params.text) ? params.text : "<p>" + params.text + "</p>";
        if (vue__WEBPACK_IMPORTED_MODULE_1___default.a.compile !== undefined) {
            toast.$slots.default = [toast.$createElement(vue__WEBPACK_IMPORTED_MODULE_1___default.a.compile(params.text))];
        }
        else {
            toast.$slots.default = [toast.$createElement('div', { domProps: { innerHTML: params.text } })];
        }
        return toast;
    };
    return ToastService;
}());
/* harmony default export */ __webpack_exports__["default"] = (ToastService);


/***/ }),

/***/ "./src/utils/user-agent/user-agent.ts":
/*!********************************************!*\
  !*** ./src/utils/user-agent/user-agent.ts ***!
  \********************************************/
/*! exports provided: UserAgent, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return UserAgent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);

var ENGINE_EDGE = { expected: ['Edge'] };
var ENGINE_GECKO = { expected: ['Gecko'] };
var ENGINE_KHTML = { expected: ['KHTML'] };
var ENGINE_WEBKIT = { expected: ['AppleWebKit'] };
var ENGINE_BLINK = { expected: ['Chrome', 'Chromium'], not: ENGINE_EDGE.expected };
var ENGINE_PRESTO = { expected: ['Opera'] };
var ENGINE_TRIDENT = { expected: ['Trident', 'MSIE'] };
var OS_ANDROID = { expected: ['Android'] };
var OS_IOS = { expected: ['iPad', 'iPhone'] };
var OS_WINDOWS_PHONE = { expected: ['Windows Phone', 'XBLWP7', 'ZuneWP7', 'WP7'] };
var OS_WINDOWS = { expected: ['Windows NT'], not: OS_WINDOWS_PHONE.expected };
var OS_MACOS = { expected: ['Mac OS X', 'Mac Os X'] };
var OS_UNIX = { expected: ['X11'] };
var OS_LINUX = { expected: ['Linux'] };
var OS_MOBILE_GENERIC = { expected: ['Mobi'] };
var OS_MOBILE = { expected: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(OS_MOBILE_GENERIC.expected, OS_ANDROID.expected, OS_IOS.expected, OS_WINDOWS_PHONE.expected) };
var OS_DESKTOP = { expected: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(OS_WINDOWS.expected, OS_MACOS.expected, OS_UNIX.expected, OS_LINUX.expected) };
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        this.state = {
            isEdge: false,
            isGecko: false,
            isKHTML: false,
            isWebKit: false,
            isBlink: false,
            isPresto: false,
            isTrident: false,
            isWindows: false,
            isMacOs: false,
            isUnix: false,
            isLinux: false,
            isAndroid: false,
            isIOs: false,
            isWindowsPhone: false,
            isMobile: false,
            isDesktop: false
        };
        this.initUserAgentEngines();
        this.initUserAgentOS();
        this.initHardware();
    }
    UserAgent.prototype.isMobile = function () {
        return this.state.isMobile;
    };
    UserAgent.prototype.isDesktop = function () {
        return this.state.isDesktop;
    };
    UserAgent.prototype.isEdge = function () {
        return this.state.isEdge;
    };
    UserAgent.prototype.isGecko = function () {
        return this.state.isGecko;
    };
    UserAgent.prototype.isKHTML = function () {
        return this.state.isKHTML;
    };
    UserAgent.prototype.isWebKit = function () {
        return this.state.isWebKit;
    };
    UserAgent.prototype.isBlink = function () {
        return this.state.isBlink;
    };
    UserAgent.prototype.isPresto = function () {
        return this.state.isPresto;
    };
    UserAgent.prototype.isTrident = function () {
        return this.state.isTrident;
    };
    UserAgent.prototype.isWindows = function () {
        return this.state.isWindows;
    };
    UserAgent.prototype.isMacOs = function () {
        return this.state.isMacOs;
    };
    UserAgent.prototype.isUnix = function () {
        return this.state.isUnix;
    };
    UserAgent.prototype.isLinux = function () {
        return this.state.isLinux;
    };
    UserAgent.prototype.isAndroid = function () {
        return this.state.isAndroid;
    };
    UserAgent.prototype.isIOs = function () {
        return this.state.isIOs;
    };
    UserAgent.prototype.isWindowsPhone = function () {
        return this.state.isWindowsPhone;
    };
    UserAgent.prototype.initHardware = function () {
        this.state.isMobile = this.userAgentIs(OS_MOBILE);
        this.state.isDesktop = !this.state.isMobile;
    };
    UserAgent.prototype.initUserAgentOS = function () {
        this.state.isWindows = this.userAgentIs(OS_WINDOWS);
        this.state.isMacOs = this.userAgentIs(OS_MACOS);
        this.state.isUnix = this.userAgentIs(OS_UNIX);
        this.state.isLinux = this.userAgentIs(OS_LINUX);
        this.state.isAndroid = this.userAgentIs(OS_ANDROID);
        this.state.isIOs = this.userAgentIs(OS_IOS);
        this.state.isWindowsPhone = this.userAgentIs(OS_WINDOWS_PHONE);
    };
    UserAgent.prototype.initUserAgentEngines = function () {
        this.state.isEdge = this.userAgentIs(ENGINE_EDGE);
        this.state.isGecko = this.userAgentIs(ENGINE_GECKO);
        this.state.isKHTML = this.userAgentIs(ENGINE_KHTML);
        this.state.isWebKit = this.userAgentIs(ENGINE_WEBKIT);
        this.state.isBlink = this.userAgentIs(ENGINE_BLINK);
        this.state.isPresto = this.userAgentIs(ENGINE_PRESTO);
        this.state.isTrident = this.userAgentIs(ENGINE_TRIDENT);
    };
    UserAgent.prototype.userAgentIs = function (specification) {
        var containsExpected = specification.expected.reduce(function (previous, value) {
            return previous || navigator.userAgent.indexOf(value) !== -1;
        }, false);
        if (!specification.not) {
            return containsExpected;
        }
        var containsNotExpected = specification.not.reduce(function (previous, value) {
            return previous || navigator.userAgent.indexOf(value) !== -1;
        }, false);
        return containsExpected && !containsNotExpected;
    };
    return UserAgent;
}());

var UserAgentUtil = new UserAgent();
/* harmony default export */ __webpack_exports__["default"] = (UserAgentUtil);


/***/ }),

/***/ "./src/utils/utils-plugin.ts":
/*!***********************************!*\
  !*** ./src/utils/utils-plugin.ts ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _component_component_mixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./component/component-mixin */ "./src/utils/component/component-mixin.ts");
/* harmony import */ var _errors_window_error_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./errors/window-error-handler */ "./src/utils/errors/window-error-handler.ts");
/* harmony import */ var _http_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./http/http */ "./src/utils/http/http.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./i18n/i18n */ "./src/utils/i18n/i18n.ts");
/* harmony import */ var _l10n_l10n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./l10n/l10n */ "./src/utils/l10n/l10n.ts");
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./logger/logger */ "./src/utils/logger/logger.ts");
/* harmony import */ var _media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./media-queries/media-queries */ "./src/utils/media-queries/media-queries.ts");
/* harmony import */ var _modul_modul__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modul/modul */ "./src/utils/modul/modul.ts");
/* harmony import */ var _scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scroll-to/scroll-to */ "./src/utils/scroll-to/scroll-to.ts");
/* harmony import */ var _svg_sprites__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./svg/sprites */ "./src/utils/svg/sprites.ts");
/* harmony import */ var _svg_svg_sprite__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./svg/svg-sprite */ "./src/utils/svg/svg-sprite.ts");












var UtilsPlugin = {
    install: function (v, options) {
        if (!options || options.propagateVueParserErrors === undefined || options.propagateVueParserErrors) {
            // Vue parser errors do not propagate to window.onError by default
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.config.errorHandler = function (err, vm, info) {
                _errors_window_error_handler__WEBPACK_IMPORTED_MODULE_2__["WindowErrorHandler"].onError(new ErrorEvent('error', { error: err }));
            };
        }
        if (!v.prototype.$log) {
            vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_logger_logger__WEBPACK_IMPORTED_MODULE_6__["default"], options ? options.consoleOptions : undefined);
        }
        else if (options) {
            v.prototype.$log.setConsoleOptions(options.consoleOptions);
        }
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_i18n_i18n__WEBPACK_IMPORTED_MODULE_4__["default"], options.i18PluginOptions);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_l10n_l10n__WEBPACK_IMPORTED_MODULE_5__["default"], options.l10nPluginOptions);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_http_http__WEBPACK_IMPORTED_MODULE_3__["default"], options.httpPluginOptions);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_media_queries_media_queries__WEBPACK_IMPORTED_MODULE_7__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_svg_sprites__WEBPACK_IMPORTED_MODULE_10__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_modul_modul__WEBPACK_IMPORTED_MODULE_8__["default"], options.modulPluginOptions);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_svg_svg_sprite__WEBPACK_IMPORTED_MODULE_11__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_scroll_to_scroll_to__WEBPACK_IMPORTED_MODULE_9__["default"]);
        vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(_component_component_mixin__WEBPACK_IMPORTED_MODULE_1__["default"]);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (UtilsPlugin);


/***/ }),

/***/ "./src/utils/uuid/uuid.ts":
/*!********************************!*\
  !*** ./src/utils/uuid/uuid.ts ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    generate: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
});


/***/ }),

/***/ "./src/utils/vue/directive.ts":
/*!************************************!*\
  !*** ./src/utils/vue/directive.ts ***!
  \************************************/
/*! exports provided: getVNodeAttributeValue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVNodeAttributeValue", function() { return getVNodeAttributeValue; });
var getVNodeAttributeValue = function (node, attributeName) {
    if (!node.data || !node.data.attrs) {
        return undefined;
    }
    return node.data.attrs[attributeName];
};


/***/ }),

/***/ "./src/utils/vue/events.ts":
/*!*********************************!*\
  !*** ./src/utils/vue/events.ts ***!
  \*********************************/
/*! exports provided: dispatchEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatchEvent", function() { return dispatchEvent; });
var dispatchEvent = function (element, eventName, eventData) {
    var vueElement = element;
    if (vueElement.__vue__) {
        if (vueElement.__vue__.$listeners[eventName]) {
            return vueElement.__vue__.$emit(eventName, eventData);
        }
        else if (vueElement.__vue__.$children.length > 0 && vueElement.__vue__.$children[0].$el === vueElement && vueElement.__vue__.$children[0].$listeners[eventName]) {
            return vueElement.__vue__.$children[0].$emit(eventName, eventData);
        }
    }
    return element.dispatchEvent(eventData);
};


/***/ }),

/***/ "./src/utils/vue/vue.ts":
/*!******************************!*\
  !*** ./src/utils/vue/vue.ts ***!
  \******************************/
/*! exports provided: ModulVue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModulVue", function() { return ModulVue; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-class-component */ "vue-class-component");
/* harmony import */ var vue_class_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_class_component__WEBPACK_IMPORTED_MODULE_2__);



var ModulVue = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ModulVue, _super);
    function ModulVue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModulVue.prototype.getParent = function (test) {
        var p = this.$parent;
        while (p && !test(p)) {
            p = p.$parent;
        }
        return p;
    };
    ModulVue.prototype.as = function () {
        var result = this;
        return result;
    };
    ModulVue = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"])([
        vue_class_component__WEBPACK_IMPORTED_MODULE_2___default.a
    ], ModulVue);
    return ModulVue;
}(vue__WEBPACK_IMPORTED_MODULE_1___default.a));



/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "cleave.js":
/*!****************************!*\
  !*** external "cleave.js" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("cleave.js");

/***/ }),

/***/ "css-element-queries/src/ResizeSensor":
/*!*******************************************************!*\
  !*** external "css-element-queries/src/ResizeSensor" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("css-element-queries/src/ResizeSensor");

/***/ }),

/***/ "enquire.js/dist/enquire":
/*!******************************************!*\
  !*** external "enquire.js/dist/enquire" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("enquire.js/dist/enquire");

/***/ }),

/***/ "filesize":
/*!***************************!*\
  !*** external "filesize" ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("filesize");

/***/ }),

/***/ "mobile-drag-drop":
/*!***********************************!*\
  !*** external "mobile-drag-drop" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("mobile-drag-drop");

/***/ }),

/***/ "mobile-drag-drop/scroll-behaviour":
/*!****************************************************!*\
  !*** external "mobile-drag-drop/scroll-behaviour" ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("mobile-drag-drop/scroll-behaviour");

/***/ }),

/***/ "moment":
/*!*************************!*\
  !*** external "moment" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "popper.js":
/*!****************************!*\
  !*** external "popper.js" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("popper.js");

/***/ }),

/***/ "portal-vue":
/*!*****************************!*\
  !*** external "portal-vue" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("portal-vue");

/***/ }),

/***/ "sprintf-js":
/*!*****************************!*\
  !*** external "sprintf-js" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("sprintf-js");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),

/***/ "vue":
/*!**********************!*\
  !*** external "vue" ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "vue-class-component":
/*!**************************************!*\
  !*** external "vue-class-component" ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("vue-class-component");

/***/ }),

/***/ "vue-property-decorator":
/*!*****************************************!*\
  !*** external "vue-property-decorator" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("vue-property-decorator");

/***/ }),

/***/ "zingtouch":
/*!****************************!*\
  !*** external "zingtouch" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("zingtouch");

/***/ })

/******/ });
//# sourceMappingURL=modul.js.map